// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.14 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Geograph, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
  body {
  min-height: 100vh;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
    min-height: -webkit-fill-available;
    padding-bottom: env(safe-area-inset-bottom);
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 992px) {

  .container {
    max-width: 992px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1380px) {

  .container {
    max-width: 1380px;
  }
}
@media (min-width: 1920px) {

  .container {
    max-width: 1920px;
  }
}
.backface-hidden {
    backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    -ms-backface-visibility: hidden;
  }
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.\\!visible {
  visibility: visible !important;
}
.visible {
  visibility: visible;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.\\!absolute {
  position: absolute !important;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.\\!sticky {
  position: sticky !important;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-x-3 {
  left: 0.75rem;
  right: 0.75rem;
}
.inset-x-4 {
  left: 1rem;
  right: 1rem;
}
.\\!-left-6 {
  left: -1.5rem !important;
}
.\\!left-4 {
  left: 1rem !important;
}
.\\!left-6 {
  left: 1.5rem !important;
}
.\\!right-4 {
  right: 1rem !important;
}
.\\!right-6 {
  right: 1.5rem !important;
}
.\\!right-auto {
  right: auto !important;
}
.\\!top-4 {
  top: 1rem !important;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-10 {
  bottom: 2.5rem;
}
.bottom-3 {
  bottom: 0.75rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-6 {
  bottom: 1.5rem;
}
.left-0 {
  left: 0px;
}
.left-1\\/2 {
  left: 50%;
}
.left-10 {
  left: 2.5rem;
}
.left-2\\/4 {
  left: 50%;
}
.left-4 {
  left: 1rem;
}
.right-0 {
  right: 0px;
}
.right-1\\/2 {
  right: 50%;
}
.right-10 {
  right: 2.5rem;
}
.right-6 {
  right: 1.5rem;
}
.top-0 {
  top: 0px;
}
.top-24 {
  top: 6rem;
}
.top-4 {
  top: 1rem;
}
.top-\\[60px\\] {
  top: 60px;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[99\\] {
  z-index: 99;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.col-span-3 {
  grid-column: span 3 / span 3;
}
.col-span-6 {
  grid-column: span 6 / span 6;
}
.col-span-7 {
  grid-column: span 7 / span 7;
}
.col-span-full {
  grid-column: 1 / -1;
}
.row-span-2 {
  grid-row: span 2 / span 2;
}
.\\!m-0 {
  margin: 0px !important;
}
.m-0 {
  margin: 0px;
}
.-mx-6 {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}
.mx-6 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-10 {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.-ml-6 {
  margin-left: -1.5rem;
}
.-mt-4 {
  margin-top: -1rem;
}
.-mt-6 {
  margin-top: -1.5rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mb-auto {
  margin-bottom: auto;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.mr-0 {
  margin-right: 0px;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-8 {
  margin-right: 2rem;
}
.mt-0 {
  margin-top: 0px;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-auto {
  margin-top: auto;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.list-item {
  display: list-item;
}
.\\!hidden {
  display: none !important;
}
.hidden {
  display: none;
}
.aspect-4\\/5 {
  aspect-ratio: 4 / 5;
}
.aspect-6\\/7 {
  aspect-ratio: 6 / 7;
}
.aspect-\\[4\\/3\\] {
  aspect-ratio: 4/3;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.aspect-video {
  aspect-ratio: 16 / 9;
}
.\\!h-12 {
  height: 3rem !important;
}
.\\!h-full {
  height: 100% !important;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-2 {
  height: 0.5rem;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[60px\\] {
  height: 60px;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.max-h-\\[30rem\\] {
  max-height: 30rem;
}
.min-h-\\[40px\\] {
  min-height: 40px;
}
.\\!w-full {
  width: 100% !important;
}
.w-0 {
  width: 0px;
}
.w-12 {
  width: 3rem;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-3 {
  width: 0.75rem;
}
.w-36 {
  width: 9rem;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[40px\\] {
  width: 40px;
}
.w-auto {
  width: auto;
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.min-w-40 {
  min-width: 10rem;
}
.min-w-\\[40px\\] {
  min-width: 40px;
}
.min-w-\\[55\\%\\] {
  min-width: 55%;
}
.min-w-full {
  min-width: 100%;
}
.\\!max-w-\\[600px\\] {
  max-width: 600px !important;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-\\[1380px\\] {
  max-width: 1380px;
}
.max-w-\\[40ch\\] {
  max-width: 40ch;
}
.max-w-\\[90\\%\\] {
  max-width: 90%;
}
.max-w-fit {
  max-width: -moz-fit-content;
  max-width: fit-content;
}
.max-w-full {
  max-width: 100%;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-screen-2xl {
  max-width: 1380px;
}
.max-w-xl {
  max-width: 36rem;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-shrink {
  flex-shrink: 1;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.-translate-x-2\\/4 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-8 {
  --tw-translate-y: -2rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-90 {
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-pointer {
  cursor: pointer;
}
.resize {
  resize: both;
}
.grid-flow-row {
  grid-auto-flow: row;
}
.grid-flow-col {
  grid-auto-flow: column;
}
.auto-rows-min {
  grid-auto-rows: min-content;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-8 {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}
.grid-cols-\\[1fr\\2c auto\\] {
  grid-template-columns: 1fr auto;
}
.grid-cols-\\[25\\%_75\\%\\] {
  grid-template-columns: 25% 75%;
}
.grid-rows-6 {
  grid-template-rows: repeat(6, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.content-center {
  align-content: center;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-16 {
  gap: 4rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-8 {
  column-gap: 2rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-8 {
  row-gap: 2rem;
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.self-start {
  align-self: flex-start;
}
.self-end {
  align-self: flex-end;
}
.self-center {
  align-self: center;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-visible {
  overflow: visible;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-x-visible {
  overflow-x: visible;
}
.overflow-x-scroll {
  overflow-x: scroll;
}
.scroll-smooth {
  scroll-behavior: smooth;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre {
  white-space: pre;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.text-wrap {
  text-wrap: wrap;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.\\!border-b {
  border-bottom-width: 1px !important;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-0 {
  border-top-width: 0px;
}
.border-solid {
  border-style: solid;
}
.border-none {
  border-style: none;
}
.\\!border-white {
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 255 255 / var(--tw-border-opacity)) !important;
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
}
.border-black\\/20 {
  border-color: rgb(33 33 33 / 0.2);
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity));
}
.border-neutral-600 {
  --tw-border-opacity: 1;
  border-color: rgb(224 223 221 / var(--tw-border-opacity));
}
.border-transparent {
  border-color: transparent;
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.\\!bg-black {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity)) !important;
}
.\\!bg-grey-dark {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(77 85 89 / var(--tw-bg-opacity)) !important;
}
.\\!bg-white {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity));
}
.bg-black\\/20 {
  background-color: rgb(33 33 33 / 0.2);
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}
.bg-grey {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}
.bg-neutral-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 247 245 / var(--tw-bg-opacity));
}
.bg-neutral-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(200 199 197 / var(--tw-bg-opacity));
}
.bg-shop-pay {
  --tw-bg-opacity: 1;
  background-color: rgb(90 49 244 / var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.fill-black {
  fill: #212121;
}
.fill-yellow {
  fill: #FBB333;
}
.object-cover {
  object-fit: cover;
}
.object-center {
  object-position: center;
}
.\\!p-0 {
  padding: 0px !important;
}
.p-0 {
  padding: 0px;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-12 {
  padding: 3rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-3\\.5 {
  padding: 0.875rem;
}
.p-4 {
  padding: 1rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.\\!px-6 {
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}
.\\!py-3 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pl-0 {
  padding-left: 0px;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pr-0 {
  padding-right: 0px;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-14 {
  padding-top: 3.5rem;
}
.pt-20 {
  padding-top: 5rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.font-sans {
  font-family: Geograph, sans-serif;
}
.font-serif {
  font-family: Self Modern, serif;
}
.\\!text-xs {
  font-size: 0.75rem !important;
  line-height: 1rem !important;
}
.text-1xl {
  font-size: 1.375rem;
}
.text-1xl\\/none {
  font-size: 1.375rem;
  line-height: 1;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-base\\/tight {
  font-size: 1rem;
  line-height: 1.25;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-lg\\/6 {
  font-size: 1.125rem;
  line-height: 1.5rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-sm\\/none {
  font-size: 0.875rem;
  line-height: 1;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.text-xs\\/none {
  font-size: 0.75rem;
  line-height: 1;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-7 {
  line-height: 1.75rem;
}
.leading-none {
  line-height: 1;
}
.leading-normal {
  line-height: 1.5;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[2px\\] {
  letter-spacing: 2px;
}
.tracking-normal {
  letter-spacing: 0em;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(33 33 33 / var(--tw-text-opacity));
}
.text-black-400 {
  --tw-text-opacity: 1;
  color: rgb(163 163 163 / var(--tw-text-opacity));
}
.text-black\\/80 {
  color: rgb(33 33 33 / 0.8);
}
.text-discount-grey {
  --tw-text-opacity: 1;
  color: rgb(118 118 118 / var(--tw-text-opacity));
}
.text-discount-red {
  --tw-text-opacity: 1;
  color: rgb(173 31 0 / var(--tw-text-opacity));
}
.text-error {
  --tw-text-opacity: 1;
  color: rgb(182 81 81 / var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.line-through {
  text-decoration-line: line-through;
}
.no-underline {
  text-decoration-line: none;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inputError {
  --tw-shadow: 0 2px 0 0 rgb(182, 81, 81), 2px 0 0 0 rgb(182, 81, 81), 0 0 0 2px rgb(182, 81, 81);
  --tw-shadow-colored: 0 2px 0 0 var(--tw-shadow-color), 2px 0 0 0 var(--tw-shadow-color), 0 0 0 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline {
  outline-style: solid;
}
.outline-1 {
  outline-width: 1px;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert {
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-in-out-expo {
  transition-timing-function: cubic-bezier(.025,.115,.085,.99);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.will-change-transform {
  will-change: transform;
}
.font-sans.text-xs.leading-3.capsize::before, .font-sans .text-xs.leading-3.capsize::before, .font-sans .text-xs .leading-3.capsize::before, .text-xs .font-sans.leading-3.capsize::before, .text-xs .font-sans .leading-3.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.\\!text-xs.leading-3.capsize::before, .font-sans .\\!text-xs.leading-3.capsize::before, .font-sans .\\!text-xs .leading-3.capsize::before, .\\!text-xs .font-sans.leading-3.capsize::before, .\\!text-xs .font-sans .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.font-sans.text-xs.leading-3.capsize::after, .font-sans .text-xs.leading-3.capsize::after, .font-sans .text-xs .leading-3.capsize::after, .text-xs .font-sans.leading-3.capsize::after, .text-xs .font-sans .leading-3.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.\\!text-xs.leading-3.capsize::after, .font-sans .\\!text-xs.leading-3.capsize::after, .font-sans .\\!text-xs .leading-3.capsize::after, .\\!text-xs .font-sans.leading-3.capsize::after, .\\!text-xs .font-sans .leading-3.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.font-sans.text-xs.leading-4.capsize::before, .font-sans .text-xs.leading-4.capsize::before, .font-sans .text-xs .leading-4.capsize::before, .text-xs .font-sans.leading-4.capsize::before, .text-xs .font-sans .leading-4.capsize::before {
  content: '';
  margin-bottom: -0.3237em;
  display: table;
}
.font-sans.\\!text-xs.leading-4.capsize::before, .font-sans .\\!text-xs.leading-4.capsize::before, .font-sans .\\!text-xs .leading-4.capsize::before, .\\!text-xs .font-sans.leading-4.capsize::before, .\\!text-xs .font-sans .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.3237em !important;
  display: table !important;
}
.font-sans.text-xs.leading-4.capsize::after, .font-sans .text-xs.leading-4.capsize::after, .font-sans .text-xs .leading-4.capsize::after, .text-xs .font-sans.leading-4.capsize::after, .text-xs .font-sans .leading-4.capsize::after {
  content: '';
  margin-top: -0.2797em;
  display: table;
}
.font-sans.\\!text-xs.leading-4.capsize::after, .font-sans .\\!text-xs.leading-4.capsize::after, .font-sans .\\!text-xs .leading-4.capsize::after, .\\!text-xs .font-sans.leading-4.capsize::after, .\\!text-xs .font-sans .leading-4.capsize::after {
  content: '' !important;
  margin-top: -0.2797em !important;
  display: table !important;
}
.font-sans.text-xs.leading-5.capsize::before, .font-sans .text-xs.leading-5.capsize::before, .font-sans .text-xs .leading-5.capsize::before, .text-xs .font-sans.leading-5.capsize::before, .text-xs .font-sans .leading-5.capsize::before {
  content: '';
  margin-bottom: -0.4903em;
  display: table;
}
.font-sans.\\!text-xs.leading-5.capsize::before, .font-sans .\\!text-xs.leading-5.capsize::before, .font-sans .\\!text-xs .leading-5.capsize::before, .\\!text-xs .font-sans.leading-5.capsize::before, .\\!text-xs .font-sans .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.4903em !important;
  display: table !important;
}
.font-sans.text-xs.leading-5.capsize::after, .font-sans .text-xs.leading-5.capsize::after, .font-sans .text-xs .leading-5.capsize::after, .text-xs .font-sans.leading-5.capsize::after, .text-xs .font-sans .leading-5.capsize::after {
  content: '';
  margin-top: -0.4463em;
  display: table;
}
.font-sans.\\!text-xs.leading-5.capsize::after, .font-sans .\\!text-xs.leading-5.capsize::after, .font-sans .\\!text-xs .leading-5.capsize::after, .\\!text-xs .font-sans.leading-5.capsize::after, .\\!text-xs .font-sans .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.4463em !important;
  display: table !important;
}
.font-sans.text-xs.leading-6.capsize::before, .font-sans .text-xs.leading-6.capsize::before, .font-sans .text-xs .leading-6.capsize::before, .text-xs .font-sans.leading-6.capsize::before, .text-xs .font-sans .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans.\\!text-xs.leading-6.capsize::before, .font-sans .\\!text-xs.leading-6.capsize::before, .font-sans .\\!text-xs .leading-6.capsize::before, .\\!text-xs .font-sans.leading-6.capsize::before, .\\!text-xs .font-sans .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.font-sans.text-xs.leading-6.capsize::after, .font-sans .text-xs.leading-6.capsize::after, .font-sans .text-xs .leading-6.capsize::after, .text-xs .font-sans.leading-6.capsize::after, .text-xs .font-sans .leading-6.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-sans.\\!text-xs.leading-6.capsize::after, .font-sans .\\!text-xs.leading-6.capsize::after, .font-sans .\\!text-xs .leading-6.capsize::after, .\\!text-xs .font-sans.leading-6.capsize::after, .\\!text-xs .font-sans .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.font-sans.text-xs.leading-7.capsize::before, .font-sans .text-xs.leading-7.capsize::before, .font-sans .text-xs .leading-7.capsize::before, .text-xs .font-sans.leading-7.capsize::before, .text-xs .font-sans .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.8237em;
  display: table;
}
.font-sans.\\!text-xs.leading-7.capsize::before, .font-sans .\\!text-xs.leading-7.capsize::before, .font-sans .\\!text-xs .leading-7.capsize::before, .\\!text-xs .font-sans.leading-7.capsize::before, .\\!text-xs .font-sans .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.8237em !important;
  display: table !important;
}
.font-sans.text-xs.leading-7.capsize::after, .font-sans .text-xs.leading-7.capsize::after, .font-sans .text-xs .leading-7.capsize::after, .text-xs .font-sans.leading-7.capsize::after, .text-xs .font-sans .leading-7.capsize::after {
  content: '';
  margin-top: -0.7797em;
  display: table;
}
.font-sans.\\!text-xs.leading-7.capsize::after, .font-sans .\\!text-xs.leading-7.capsize::after, .font-sans .\\!text-xs .leading-7.capsize::after, .\\!text-xs .font-sans.leading-7.capsize::after, .\\!text-xs .font-sans .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.7797em !important;
  display: table !important;
}
.font-sans.text-xs.leading-8.capsize::before, .font-sans .text-xs.leading-8.capsize::before, .font-sans .text-xs .leading-8.capsize::before, .text-xs .font-sans.leading-8.capsize::before, .text-xs .font-sans .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.9903em;
  display: table;
}
.font-sans.\\!text-xs.leading-8.capsize::before, .font-sans .\\!text-xs.leading-8.capsize::before, .font-sans .\\!text-xs .leading-8.capsize::before, .\\!text-xs .font-sans.leading-8.capsize::before, .\\!text-xs .font-sans .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.9903em !important;
  display: table !important;
}
.font-sans.text-xs.leading-8.capsize::after, .font-sans .text-xs.leading-8.capsize::after, .font-sans .text-xs .leading-8.capsize::after, .text-xs .font-sans.leading-8.capsize::after, .text-xs .font-sans .leading-8.capsize::after {
  content: '';
  margin-top: -0.9463em;
  display: table;
}
.font-sans.\\!text-xs.leading-8.capsize::after, .font-sans .\\!text-xs.leading-8.capsize::after, .font-sans .\\!text-xs .leading-8.capsize::after, .\\!text-xs .font-sans.leading-8.capsize::after, .\\!text-xs .font-sans .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.9463em !important;
  display: table !important;
}
.font-sans.text-xs.leading-9.capsize::before, .font-sans .text-xs.leading-9.capsize::before, .font-sans .text-xs .leading-9.capsize::before, .text-xs .font-sans.leading-9.capsize::before, .text-xs .font-sans .leading-9.capsize::before {
  content: '';
  margin-bottom: -1.157em;
  display: table;
}
.font-sans.\\!text-xs.leading-9.capsize::before, .font-sans .\\!text-xs.leading-9.capsize::before, .font-sans .\\!text-xs .leading-9.capsize::before, .\\!text-xs .font-sans.leading-9.capsize::before, .\\!text-xs .font-sans .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -1.157em !important;
  display: table !important;
}
.font-sans.text-xs.leading-9.capsize::after, .font-sans .text-xs.leading-9.capsize::after, .font-sans .text-xs .leading-9.capsize::after, .text-xs .font-sans.leading-9.capsize::after, .text-xs .font-sans .leading-9.capsize::after {
  content: '';
  margin-top: -1.113em;
  display: table;
}
.font-sans.\\!text-xs.leading-9.capsize::after, .font-sans .\\!text-xs.leading-9.capsize::after, .font-sans .\\!text-xs .leading-9.capsize::after, .\\!text-xs .font-sans.leading-9.capsize::after, .\\!text-xs .font-sans .leading-9.capsize::after {
  content: '' !important;
  margin-top: -1.113em !important;
  display: table !important;
}
.font-sans.text-xs.leading-10.capsize::before, .font-sans .text-xs.leading-10.capsize::before, .font-sans .text-xs .leading-10.capsize::before, .text-xs .font-sans.leading-10.capsize::before, .text-xs .font-sans .leading-10.capsize::before {
  content: '';
  margin-bottom: -1.3237em;
  display: table;
}
.font-sans.\\!text-xs.leading-10.capsize::before, .font-sans .\\!text-xs.leading-10.capsize::before, .font-sans .\\!text-xs .leading-10.capsize::before, .\\!text-xs .font-sans.leading-10.capsize::before, .\\!text-xs .font-sans .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -1.3237em !important;
  display: table !important;
}
.font-sans.text-xs.leading-10.capsize::after, .font-sans .text-xs.leading-10.capsize::after, .font-sans .text-xs .leading-10.capsize::after, .text-xs .font-sans.leading-10.capsize::after, .text-xs .font-sans .leading-10.capsize::after {
  content: '';
  margin-top: -1.2797em;
  display: table;
}
.font-sans.\\!text-xs.leading-10.capsize::after, .font-sans .\\!text-xs.leading-10.capsize::after, .font-sans .\\!text-xs .leading-10.capsize::after, .\\!text-xs .font-sans.leading-10.capsize::after, .\\!text-xs .font-sans .leading-10.capsize::after {
  content: '' !important;
  margin-top: -1.2797em !important;
  display: table !important;
}
.font-sans.text-xs.leading-none.capsize::before, .font-sans .text-xs.leading-none.capsize::before, .font-sans .text-xs .leading-none.capsize::before, .text-xs .font-sans.leading-none.capsize::before, .text-xs .font-sans .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.\\!text-xs.leading-none.capsize::before, .font-sans .\\!text-xs.leading-none.capsize::before, .font-sans .\\!text-xs .leading-none.capsize::before, .\\!text-xs .font-sans.leading-none.capsize::before, .\\!text-xs .font-sans .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.font-sans.text-xs.leading-none.capsize::after, .font-sans .text-xs.leading-none.capsize::after, .font-sans .text-xs .leading-none.capsize::after, .text-xs .font-sans.leading-none.capsize::after, .text-xs .font-sans .leading-none.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.\\!text-xs.leading-none.capsize::after, .font-sans .\\!text-xs.leading-none.capsize::after, .font-sans .\\!text-xs .leading-none.capsize::after, .\\!text-xs .font-sans.leading-none.capsize::after, .\\!text-xs .font-sans .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.font-sans.text-xs.leading-tight.capsize::before, .font-sans .text-xs.leading-tight.capsize::before, .font-sans .text-xs .leading-tight.capsize::before, .text-xs .font-sans.leading-tight.capsize::before, .text-xs .font-sans .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.282em;
  display: table;
}
.font-sans.\\!text-xs.leading-tight.capsize::before, .font-sans .\\!text-xs.leading-tight.capsize::before, .font-sans .\\!text-xs .leading-tight.capsize::before, .\\!text-xs .font-sans.leading-tight.capsize::before, .\\!text-xs .font-sans .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
.font-sans.text-xs.leading-tight.capsize::after, .font-sans .text-xs.leading-tight.capsize::after, .font-sans .text-xs .leading-tight.capsize::after, .text-xs .font-sans.leading-tight.capsize::after, .text-xs .font-sans .leading-tight.capsize::after {
  content: '';
  margin-top: -0.238em;
  display: table;
}
.font-sans.\\!text-xs.leading-tight.capsize::after, .font-sans .\\!text-xs.leading-tight.capsize::after, .font-sans .\\!text-xs .leading-tight.capsize::after, .\\!text-xs .font-sans.leading-tight.capsize::after, .\\!text-xs .font-sans .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
.font-sans.text-xs.leading-snug.capsize::before, .font-sans .text-xs.leading-snug.capsize::before, .font-sans .text-xs .leading-snug.capsize::before, .text-xs .font-sans.leading-snug.capsize::before, .text-xs .font-sans .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3445em;
  display: table;
}
.font-sans.\\!text-xs.leading-snug.capsize::before, .font-sans .\\!text-xs.leading-snug.capsize::before, .font-sans .\\!text-xs .leading-snug.capsize::before, .\\!text-xs .font-sans.leading-snug.capsize::before, .\\!text-xs .font-sans .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
.font-sans.text-xs.leading-snug.capsize::after, .font-sans .text-xs.leading-snug.capsize::after, .font-sans .text-xs .leading-snug.capsize::after, .text-xs .font-sans.leading-snug.capsize::after, .text-xs .font-sans .leading-snug.capsize::after {
  content: '';
  margin-top: -0.3005em;
  display: table;
}
.font-sans.\\!text-xs.leading-snug.capsize::after, .font-sans .\\!text-xs.leading-snug.capsize::after, .font-sans .\\!text-xs .leading-snug.capsize::after, .\\!text-xs .font-sans.leading-snug.capsize::after, .\\!text-xs .font-sans .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
.font-sans.text-xs.leading-normal.capsize::before, .font-sans .text-xs.leading-normal.capsize::before, .font-sans .text-xs .leading-normal.capsize::before, .text-xs .font-sans.leading-normal.capsize::before, .text-xs .font-sans .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.407em;
  display: table;
}
.font-sans.\\!text-xs.leading-normal.capsize::before, .font-sans .\\!text-xs.leading-normal.capsize::before, .font-sans .\\!text-xs .leading-normal.capsize::before, .\\!text-xs .font-sans.leading-normal.capsize::before, .\\!text-xs .font-sans .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
.font-sans.text-xs.leading-normal.capsize::after, .font-sans .text-xs.leading-normal.capsize::after, .font-sans .text-xs .leading-normal.capsize::after, .text-xs .font-sans.leading-normal.capsize::after, .text-xs .font-sans .leading-normal.capsize::after {
  content: '';
  margin-top: -0.363em;
  display: table;
}
.font-sans.\\!text-xs.leading-normal.capsize::after, .font-sans .\\!text-xs.leading-normal.capsize::after, .font-sans .\\!text-xs .leading-normal.capsize::after, .\\!text-xs .font-sans.leading-normal.capsize::after, .\\!text-xs .font-sans .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
.font-sans.text-xs.leading-relaxed.capsize::before, .font-sans .text-xs.leading-relaxed.capsize::before, .font-sans .text-xs .leading-relaxed.capsize::before, .text-xs .font-sans.leading-relaxed.capsize::before, .text-xs .font-sans .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4695em;
  display: table;
}
.font-sans.\\!text-xs.leading-relaxed.capsize::before, .font-sans .\\!text-xs.leading-relaxed.capsize::before, .font-sans .\\!text-xs .leading-relaxed.capsize::before, .\\!text-xs .font-sans.leading-relaxed.capsize::before, .\\!text-xs .font-sans .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
.font-sans.text-xs.leading-relaxed.capsize::after, .font-sans .text-xs.leading-relaxed.capsize::after, .font-sans .text-xs .leading-relaxed.capsize::after, .text-xs .font-sans.leading-relaxed.capsize::after, .text-xs .font-sans .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4255em;
  display: table;
}
.font-sans.\\!text-xs.leading-relaxed.capsize::after, .font-sans .\\!text-xs.leading-relaxed.capsize::after, .font-sans .\\!text-xs .leading-relaxed.capsize::after, .\\!text-xs .font-sans.leading-relaxed.capsize::after, .\\!text-xs .font-sans .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
.font-sans.text-xs.leading-loose.capsize::before, .font-sans .text-xs.leading-loose.capsize::before, .font-sans .text-xs .leading-loose.capsize::before, .text-xs .font-sans.leading-loose.capsize::before, .text-xs .font-sans .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans.\\!text-xs.leading-loose.capsize::before, .font-sans .\\!text-xs.leading-loose.capsize::before, .font-sans .\\!text-xs .leading-loose.capsize::before, .\\!text-xs .font-sans.leading-loose.capsize::before, .\\!text-xs .font-sans .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.font-sans.text-xs.leading-loose.capsize::after, .font-sans .text-xs.leading-loose.capsize::after, .font-sans .text-xs .leading-loose.capsize::after, .text-xs .font-sans.leading-loose.capsize::after, .text-xs .font-sans .leading-loose.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-sans.\\!text-xs.leading-loose.capsize::after, .font-sans .\\!text-xs.leading-loose.capsize::after, .font-sans .\\!text-xs .leading-loose.capsize::after, .\\!text-xs .font-sans.leading-loose.capsize::after, .\\!text-xs .font-sans .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.font-sans.text-sm.leading-3.capsize::before, .font-sans .text-sm.leading-3.capsize::before, .font-sans .text-sm .leading-3.capsize::before, .text-sm .font-sans.leading-3.capsize::before, .text-sm .font-sans .leading-3.capsize::before {
  content: '';
  margin-bottom: -0.0856em;
  display: table;
}
.font-sans.text-sm.leading-3.capsize::after, .font-sans .text-sm.leading-3.capsize::after, .font-sans .text-sm .leading-3.capsize::after, .text-sm .font-sans.leading-3.capsize::after, .text-sm .font-sans .leading-3.capsize::after {
  content: '';
  margin-top: -0.0416em;
  display: table;
}
.font-sans.text-sm.leading-4.capsize::before, .font-sans .text-sm.leading-4.capsize::before, .font-sans .text-sm .leading-4.capsize::before, .text-sm .font-sans.leading-4.capsize::before, .text-sm .font-sans .leading-4.capsize::before {
  content: '';
  margin-bottom: -0.2284em;
  display: table;
}
.font-sans.text-sm.leading-4.capsize::after, .font-sans .text-sm.leading-4.capsize::after, .font-sans .text-sm .leading-4.capsize::after, .text-sm .font-sans.leading-4.capsize::after, .text-sm .font-sans .leading-4.capsize::after {
  content: '';
  margin-top: -0.1844em;
  display: table;
}
.font-sans.text-sm.leading-5.capsize::before, .font-sans .text-sm.leading-5.capsize::before, .font-sans .text-sm .leading-5.capsize::before, .text-sm .font-sans.leading-5.capsize::before, .text-sm .font-sans .leading-5.capsize::before {
  content: '';
  margin-bottom: -0.3713em;
  display: table;
}
.font-sans.text-sm.leading-5.capsize::after, .font-sans .text-sm.leading-5.capsize::after, .font-sans .text-sm .leading-5.capsize::after, .text-sm .font-sans.leading-5.capsize::after, .text-sm .font-sans .leading-5.capsize::after {
  content: '';
  margin-top: -0.3273em;
  display: table;
}
.font-sans.text-sm.leading-6.capsize::before, .font-sans .text-sm.leading-6.capsize::before, .font-sans .text-sm .leading-6.capsize::before, .text-sm .font-sans.leading-6.capsize::before, .text-sm .font-sans .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.5141em;
  display: table;
}
.font-sans.text-sm.leading-6.capsize::after, .font-sans .text-sm.leading-6.capsize::after, .font-sans .text-sm .leading-6.capsize::after, .text-sm .font-sans.leading-6.capsize::after, .text-sm .font-sans .leading-6.capsize::after {
  content: '';
  margin-top: -0.4701em;
  display: table;
}
.font-sans.text-sm.leading-7.capsize::before, .font-sans .text-sm.leading-7.capsize::before, .font-sans .text-sm .leading-7.capsize::before, .text-sm .font-sans.leading-7.capsize::before, .text-sm .font-sans .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans.text-sm.leading-7.capsize::after, .font-sans .text-sm.leading-7.capsize::after, .font-sans .text-sm .leading-7.capsize::after, .text-sm .font-sans.leading-7.capsize::after, .text-sm .font-sans .leading-7.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-sans.text-sm.leading-8.capsize::before, .font-sans .text-sm.leading-8.capsize::before, .font-sans .text-sm .leading-8.capsize::before, .text-sm .font-sans.leading-8.capsize::before, .text-sm .font-sans .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.7999em;
  display: table;
}
.font-sans.text-sm.leading-8.capsize::after, .font-sans .text-sm.leading-8.capsize::after, .font-sans .text-sm .leading-8.capsize::after, .text-sm .font-sans.leading-8.capsize::after, .text-sm .font-sans .leading-8.capsize::after {
  content: '';
  margin-top: -0.7559em;
  display: table;
}
.font-sans.text-sm.leading-9.capsize::before, .font-sans .text-sm.leading-9.capsize::before, .font-sans .text-sm .leading-9.capsize::before, .text-sm .font-sans.leading-9.capsize::before, .text-sm .font-sans .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.9427em;
  display: table;
}
.font-sans.text-sm.leading-9.capsize::after, .font-sans .text-sm.leading-9.capsize::after, .font-sans .text-sm .leading-9.capsize::after, .text-sm .font-sans.leading-9.capsize::after, .text-sm .font-sans .leading-9.capsize::after {
  content: '';
  margin-top: -0.8987em;
  display: table;
}
.font-sans.text-sm.leading-10.capsize::before, .font-sans .text-sm.leading-10.capsize::before, .font-sans .text-sm .leading-10.capsize::before, .text-sm .font-sans.leading-10.capsize::before, .text-sm .font-sans .leading-10.capsize::before {
  content: '';
  margin-bottom: -1.0856em;
  display: table;
}
.font-sans.text-sm.leading-10.capsize::after, .font-sans .text-sm.leading-10.capsize::after, .font-sans .text-sm .leading-10.capsize::after, .text-sm .font-sans.leading-10.capsize::after, .text-sm .font-sans .leading-10.capsize::after {
  content: '';
  margin-top: -1.0416em;
  display: table;
}
.font-sans.text-sm.leading-none.capsize::before, .font-sans .text-sm.leading-none.capsize::before, .font-sans .text-sm .leading-none.capsize::before, .text-sm .font-sans.leading-none.capsize::before, .text-sm .font-sans .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-sm.leading-none.capsize::after, .font-sans .text-sm.leading-none.capsize::after, .font-sans .text-sm .leading-none.capsize::after, .text-sm .font-sans.leading-none.capsize::after, .text-sm .font-sans .leading-none.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-sm.leading-tight.capsize::before, .font-sans .text-sm.leading-tight.capsize::before, .font-sans .text-sm .leading-tight.capsize::before, .text-sm .font-sans.leading-tight.capsize::before, .text-sm .font-sans .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.282em;
  display: table;
}
.font-sans.text-sm.leading-tight.capsize::after, .font-sans .text-sm.leading-tight.capsize::after, .font-sans .text-sm .leading-tight.capsize::after, .text-sm .font-sans.leading-tight.capsize::after, .text-sm .font-sans .leading-tight.capsize::after {
  content: '';
  margin-top: -0.238em;
  display: table;
}
.font-sans.text-sm.leading-snug.capsize::before, .font-sans .text-sm.leading-snug.capsize::before, .font-sans .text-sm .leading-snug.capsize::before, .text-sm .font-sans.leading-snug.capsize::before, .text-sm .font-sans .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3445em;
  display: table;
}
.font-sans.text-sm.leading-snug.capsize::after, .font-sans .text-sm.leading-snug.capsize::after, .font-sans .text-sm .leading-snug.capsize::after, .text-sm .font-sans.leading-snug.capsize::after, .text-sm .font-sans .leading-snug.capsize::after {
  content: '';
  margin-top: -0.3005em;
  display: table;
}
.font-sans.text-sm.leading-normal.capsize::before, .font-sans .text-sm.leading-normal.capsize::before, .font-sans .text-sm .leading-normal.capsize::before, .text-sm .font-sans.leading-normal.capsize::before, .text-sm .font-sans .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.407em;
  display: table;
}
.font-sans.text-sm.leading-normal.capsize::after, .font-sans .text-sm.leading-normal.capsize::after, .font-sans .text-sm .leading-normal.capsize::after, .text-sm .font-sans.leading-normal.capsize::after, .text-sm .font-sans .leading-normal.capsize::after {
  content: '';
  margin-top: -0.363em;
  display: table;
}
.font-sans.text-sm.leading-relaxed.capsize::before, .font-sans .text-sm.leading-relaxed.capsize::before, .font-sans .text-sm .leading-relaxed.capsize::before, .text-sm .font-sans.leading-relaxed.capsize::before, .text-sm .font-sans .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4695em;
  display: table;
}
.font-sans.text-sm.leading-relaxed.capsize::after, .font-sans .text-sm.leading-relaxed.capsize::after, .font-sans .text-sm .leading-relaxed.capsize::after, .text-sm .font-sans.leading-relaxed.capsize::after, .text-sm .font-sans .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4255em;
  display: table;
}
.font-sans.text-sm.leading-loose.capsize::before, .font-sans .text-sm.leading-loose.capsize::before, .font-sans .text-sm .leading-loose.capsize::before, .text-sm .font-sans.leading-loose.capsize::before, .text-sm .font-sans .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans.text-sm.leading-loose.capsize::after, .font-sans .text-sm.leading-loose.capsize::after, .font-sans .text-sm .leading-loose.capsize::after, .text-sm .font-sans.leading-loose.capsize::after, .text-sm .font-sans .leading-loose.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-sans.text-base.leading-3.capsize::before, .font-sans .text-base.leading-3.capsize::before, .font-sans .text-base .leading-3.capsize::before, .text-base .font-sans.leading-3.capsize::before, .text-base .font-sans .leading-3.capsize::before {
  content: '';
  margin-bottom: -0.032em;
  display: table;
}
.font-sans.text-base.leading-3.capsize::after, .font-sans .text-base.leading-3.capsize::after, .font-sans .text-base .leading-3.capsize::after, .text-base .font-sans.leading-3.capsize::after, .text-base .font-sans .leading-3.capsize::after {
  content: '';
  margin-top: 0.012em;
  display: table;
}
.font-sans.text-base.leading-4.capsize::before, .font-sans .text-base.leading-4.capsize::before, .font-sans .text-base .leading-4.capsize::before, .text-base .font-sans.leading-4.capsize::before, .text-base .font-sans .leading-4.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-base.leading-4.capsize::after, .font-sans .text-base.leading-4.capsize::after, .font-sans .text-base .leading-4.capsize::after, .text-base .font-sans.leading-4.capsize::after, .text-base .font-sans .leading-4.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-base.leading-5.capsize::before, .font-sans .text-base.leading-5.capsize::before, .font-sans .text-base .leading-5.capsize::before, .text-base .font-sans.leading-5.capsize::before, .text-base .font-sans .leading-5.capsize::before {
  content: '';
  margin-bottom: -0.282em;
  display: table;
}
.font-sans.text-base.leading-5.capsize::after, .font-sans .text-base.leading-5.capsize::after, .font-sans .text-base .leading-5.capsize::after, .text-base .font-sans.leading-5.capsize::after, .text-base .font-sans .leading-5.capsize::after {
  content: '';
  margin-top: -0.238em;
  display: table;
}
.font-sans.text-base.leading-6.capsize::before, .font-sans .text-base.leading-6.capsize::before, .font-sans .text-base .leading-6.capsize::before, .text-base .font-sans.leading-6.capsize::before, .text-base .font-sans .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.407em;
  display: table;
}
.font-sans.text-base.leading-6.capsize::after, .font-sans .text-base.leading-6.capsize::after, .font-sans .text-base .leading-6.capsize::after, .text-base .font-sans.leading-6.capsize::after, .text-base .font-sans .leading-6.capsize::after {
  content: '';
  margin-top: -0.363em;
  display: table;
}
.font-sans.text-base.leading-7.capsize::before, .font-sans .text-base.leading-7.capsize::before, .font-sans .text-base .leading-7.capsize::before, .text-base .font-sans.leading-7.capsize::before, .text-base .font-sans .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.532em;
  display: table;
}
.font-sans.text-base.leading-7.capsize::after, .font-sans .text-base.leading-7.capsize::after, .font-sans .text-base .leading-7.capsize::after, .text-base .font-sans.leading-7.capsize::after, .text-base .font-sans .leading-7.capsize::after {
  content: '';
  margin-top: -0.488em;
  display: table;
}
.font-sans.text-base.leading-8.capsize::before, .font-sans .text-base.leading-8.capsize::before, .font-sans .text-base .leading-8.capsize::before, .text-base .font-sans.leading-8.capsize::before, .text-base .font-sans .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans.text-base.leading-8.capsize::after, .font-sans .text-base.leading-8.capsize::after, .font-sans .text-base .leading-8.capsize::after, .text-base .font-sans.leading-8.capsize::after, .text-base .font-sans .leading-8.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-sans.text-base.leading-9.capsize::before, .font-sans .text-base.leading-9.capsize::before, .font-sans .text-base .leading-9.capsize::before, .text-base .font-sans.leading-9.capsize::before, .text-base .font-sans .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.782em;
  display: table;
}
.font-sans.text-base.leading-9.capsize::after, .font-sans .text-base.leading-9.capsize::after, .font-sans .text-base .leading-9.capsize::after, .text-base .font-sans.leading-9.capsize::after, .text-base .font-sans .leading-9.capsize::after {
  content: '';
  margin-top: -0.738em;
  display: table;
}
.font-sans.text-base.leading-10.capsize::before, .font-sans .text-base.leading-10.capsize::before, .font-sans .text-base .leading-10.capsize::before, .text-base .font-sans.leading-10.capsize::before, .text-base .font-sans .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.907em;
  display: table;
}
.font-sans.text-base.leading-10.capsize::after, .font-sans .text-base.leading-10.capsize::after, .font-sans .text-base .leading-10.capsize::after, .text-base .font-sans.leading-10.capsize::after, .text-base .font-sans .leading-10.capsize::after {
  content: '';
  margin-top: -0.863em;
  display: table;
}
.font-sans.text-base.leading-none.capsize::before, .font-sans .text-base.leading-none.capsize::before, .font-sans .text-base .leading-none.capsize::before, .text-base .font-sans.leading-none.capsize::before, .text-base .font-sans .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-base.leading-none.capsize::after, .font-sans .text-base.leading-none.capsize::after, .font-sans .text-base .leading-none.capsize::after, .text-base .font-sans.leading-none.capsize::after, .text-base .font-sans .leading-none.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-base.leading-tight.capsize::before, .font-sans .text-base.leading-tight.capsize::before, .font-sans .text-base .leading-tight.capsize::before, .text-base .font-sans.leading-tight.capsize::before, .text-base .font-sans .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.282em;
  display: table;
}
.font-sans.text-base.leading-tight.capsize::after, .font-sans .text-base.leading-tight.capsize::after, .font-sans .text-base .leading-tight.capsize::after, .text-base .font-sans.leading-tight.capsize::after, .text-base .font-sans .leading-tight.capsize::after {
  content: '';
  margin-top: -0.238em;
  display: table;
}
.font-sans.text-base.leading-snug.capsize::before, .font-sans .text-base.leading-snug.capsize::before, .font-sans .text-base .leading-snug.capsize::before, .text-base .font-sans.leading-snug.capsize::before, .text-base .font-sans .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3445em;
  display: table;
}
.font-sans.text-base.leading-snug.capsize::after, .font-sans .text-base.leading-snug.capsize::after, .font-sans .text-base .leading-snug.capsize::after, .text-base .font-sans.leading-snug.capsize::after, .text-base .font-sans .leading-snug.capsize::after {
  content: '';
  margin-top: -0.3005em;
  display: table;
}
.font-sans.text-base.leading-normal.capsize::before, .font-sans .text-base.leading-normal.capsize::before, .font-sans .text-base .leading-normal.capsize::before, .text-base .font-sans.leading-normal.capsize::before, .text-base .font-sans .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.407em;
  display: table;
}
.font-sans.text-base.leading-normal.capsize::after, .font-sans .text-base.leading-normal.capsize::after, .font-sans .text-base .leading-normal.capsize::after, .text-base .font-sans.leading-normal.capsize::after, .text-base .font-sans .leading-normal.capsize::after {
  content: '';
  margin-top: -0.363em;
  display: table;
}
.font-sans.text-base.leading-relaxed.capsize::before, .font-sans .text-base.leading-relaxed.capsize::before, .font-sans .text-base .leading-relaxed.capsize::before, .text-base .font-sans.leading-relaxed.capsize::before, .text-base .font-sans .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4695em;
  display: table;
}
.font-sans.text-base.leading-relaxed.capsize::after, .font-sans .text-base.leading-relaxed.capsize::after, .font-sans .text-base .leading-relaxed.capsize::after, .text-base .font-sans.leading-relaxed.capsize::after, .text-base .font-sans .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4255em;
  display: table;
}
.font-sans.text-base.leading-loose.capsize::before, .font-sans .text-base.leading-loose.capsize::before, .font-sans .text-base .leading-loose.capsize::before, .text-base .font-sans.leading-loose.capsize::before, .text-base .font-sans .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans.text-base.leading-loose.capsize::after, .font-sans .text-base.leading-loose.capsize::after, .font-sans .text-base .leading-loose.capsize::after, .text-base .font-sans.leading-loose.capsize::after, .text-base .font-sans .leading-loose.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-sans.text-lg.leading-3.capsize::before, .font-sans .text-lg.leading-3.capsize::before, .font-sans .text-lg .leading-3.capsize::before, .text-lg .font-sans.leading-3.capsize::before, .text-lg .font-sans .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.0097em;
  display: table;
}
.font-sans.text-lg.leading-3.capsize::after, .font-sans .text-lg.leading-3.capsize::after, .font-sans .text-lg .leading-3.capsize::after, .text-lg .font-sans.leading-3.capsize::after, .text-lg .font-sans .leading-3.capsize::after {
  content: '';
  margin-top: 0.0537em;
  display: table;
}
.font-sans.text-lg.leading-4.capsize::before, .font-sans .text-lg.leading-4.capsize::before, .font-sans .text-lg .leading-4.capsize::before, .text-lg .font-sans.leading-4.capsize::before, .text-lg .font-sans .leading-4.capsize::before {
  content: '';
  margin-bottom: -0.1014em;
  display: table;
}
.font-sans.text-lg.leading-4.capsize::after, .font-sans .text-lg.leading-4.capsize::after, .font-sans .text-lg .leading-4.capsize::after, .text-lg .font-sans.leading-4.capsize::after, .text-lg .font-sans .leading-4.capsize::after {
  content: '';
  margin-top: -0.0574em;
  display: table;
}
.font-sans.text-lg.leading-5.capsize::before, .font-sans .text-lg.leading-5.capsize::before, .font-sans .text-lg .leading-5.capsize::before, .text-lg .font-sans.leading-5.capsize::before, .text-lg .font-sans .leading-5.capsize::before {
  content: '';
  margin-bottom: -0.2126em;
  display: table;
}
.font-sans.text-lg.leading-5.capsize::after, .font-sans .text-lg.leading-5.capsize::after, .font-sans .text-lg .leading-5.capsize::after, .text-lg .font-sans.leading-5.capsize::after, .text-lg .font-sans .leading-5.capsize::after {
  content: '';
  margin-top: -0.1686em;
  display: table;
}
.font-sans.text-lg.leading-6.capsize::before, .font-sans .text-lg.leading-6.capsize::before, .font-sans .text-lg .leading-6.capsize::before, .text-lg .font-sans.leading-6.capsize::before, .text-lg .font-sans .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.3237em;
  display: table;
}
.font-sans.text-lg.leading-6.capsize::after, .font-sans .text-lg.leading-6.capsize::after, .font-sans .text-lg .leading-6.capsize::after, .text-lg .font-sans.leading-6.capsize::after, .text-lg .font-sans .leading-6.capsize::after {
  content: '';
  margin-top: -0.2797em;
  display: table;
}
.font-sans.text-lg.leading-7.capsize::before, .font-sans .text-lg.leading-7.capsize::before, .font-sans .text-lg .leading-7.capsize::before, .text-lg .font-sans.leading-7.capsize::before, .text-lg .font-sans .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.4348em;
  display: table;
}
.font-sans.text-lg.leading-7.capsize::after, .font-sans .text-lg.leading-7.capsize::after, .font-sans .text-lg .leading-7.capsize::after, .text-lg .font-sans.leading-7.capsize::after, .text-lg .font-sans .leading-7.capsize::after {
  content: '';
  margin-top: -0.3908em;
  display: table;
}
.font-sans.text-lg.leading-8.capsize::before, .font-sans .text-lg.leading-8.capsize::before, .font-sans .text-lg .leading-8.capsize::before, .text-lg .font-sans.leading-8.capsize::before, .text-lg .font-sans .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.5459em;
  display: table;
}
.font-sans.text-lg.leading-8.capsize::after, .font-sans .text-lg.leading-8.capsize::after, .font-sans .text-lg .leading-8.capsize::after, .text-lg .font-sans.leading-8.capsize::after, .text-lg .font-sans .leading-8.capsize::after {
  content: '';
  margin-top: -0.5019em;
  display: table;
}
.font-sans.text-lg.leading-9.capsize::before, .font-sans .text-lg.leading-9.capsize::before, .font-sans .text-lg .leading-9.capsize::before, .text-lg .font-sans.leading-9.capsize::before, .text-lg .font-sans .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans.text-lg.leading-9.capsize::after, .font-sans .text-lg.leading-9.capsize::after, .font-sans .text-lg .leading-9.capsize::after, .text-lg .font-sans.leading-9.capsize::after, .text-lg .font-sans .leading-9.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-sans.text-lg.leading-10.capsize::before, .font-sans .text-lg.leading-10.capsize::before, .font-sans .text-lg .leading-10.capsize::before, .text-lg .font-sans.leading-10.capsize::before, .text-lg .font-sans .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.7681em;
  display: table;
}
.font-sans.text-lg.leading-10.capsize::after, .font-sans .text-lg.leading-10.capsize::after, .font-sans .text-lg .leading-10.capsize::after, .text-lg .font-sans.leading-10.capsize::after, .text-lg .font-sans .leading-10.capsize::after {
  content: '';
  margin-top: -0.7241em;
  display: table;
}
.font-sans.text-lg.leading-none.capsize::before, .font-sans .text-lg.leading-none.capsize::before, .font-sans .text-lg .leading-none.capsize::before, .text-lg .font-sans.leading-none.capsize::before, .text-lg .font-sans .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-lg.leading-none.capsize::after, .font-sans .text-lg.leading-none.capsize::after, .font-sans .text-lg .leading-none.capsize::after, .text-lg .font-sans.leading-none.capsize::after, .text-lg .font-sans .leading-none.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-lg.leading-tight.capsize::before, .font-sans .text-lg.leading-tight.capsize::before, .font-sans .text-lg .leading-tight.capsize::before, .text-lg .font-sans.leading-tight.capsize::before, .text-lg .font-sans .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.282em;
  display: table;
}
.font-sans.text-lg.leading-tight.capsize::after, .font-sans .text-lg.leading-tight.capsize::after, .font-sans .text-lg .leading-tight.capsize::after, .text-lg .font-sans.leading-tight.capsize::after, .text-lg .font-sans .leading-tight.capsize::after {
  content: '';
  margin-top: -0.238em;
  display: table;
}
.font-sans.text-lg.leading-snug.capsize::before, .font-sans .text-lg.leading-snug.capsize::before, .font-sans .text-lg .leading-snug.capsize::before, .text-lg .font-sans.leading-snug.capsize::before, .text-lg .font-sans .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3445em;
  display: table;
}
.font-sans.text-lg.leading-snug.capsize::after, .font-sans .text-lg.leading-snug.capsize::after, .font-sans .text-lg .leading-snug.capsize::after, .text-lg .font-sans.leading-snug.capsize::after, .text-lg .font-sans .leading-snug.capsize::after {
  content: '';
  margin-top: -0.3005em;
  display: table;
}
.font-sans.text-lg.leading-normal.capsize::before, .font-sans .text-lg.leading-normal.capsize::before, .font-sans .text-lg .leading-normal.capsize::before, .text-lg .font-sans.leading-normal.capsize::before, .text-lg .font-sans .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.407em;
  display: table;
}
.font-sans.text-lg.leading-normal.capsize::after, .font-sans .text-lg.leading-normal.capsize::after, .font-sans .text-lg .leading-normal.capsize::after, .text-lg .font-sans.leading-normal.capsize::after, .text-lg .font-sans .leading-normal.capsize::after {
  content: '';
  margin-top: -0.363em;
  display: table;
}
.font-sans.text-lg.leading-relaxed.capsize::before, .font-sans .text-lg.leading-relaxed.capsize::before, .font-sans .text-lg .leading-relaxed.capsize::before, .text-lg .font-sans.leading-relaxed.capsize::before, .text-lg .font-sans .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4695em;
  display: table;
}
.font-sans.text-lg.leading-relaxed.capsize::after, .font-sans .text-lg.leading-relaxed.capsize::after, .font-sans .text-lg .leading-relaxed.capsize::after, .text-lg .font-sans.leading-relaxed.capsize::after, .text-lg .font-sans .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4255em;
  display: table;
}
.font-sans.text-lg.leading-loose.capsize::before, .font-sans .text-lg.leading-loose.capsize::before, .font-sans .text-lg .leading-loose.capsize::before, .text-lg .font-sans.leading-loose.capsize::before, .text-lg .font-sans .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans.text-lg.leading-loose.capsize::after, .font-sans .text-lg.leading-loose.capsize::after, .font-sans .text-lg .leading-loose.capsize::after, .text-lg .font-sans.leading-loose.capsize::after, .text-lg .font-sans .leading-loose.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-sans.text-xl.leading-3.capsize::before, .font-sans .text-xl.leading-3.capsize::before, .font-sans .text-xl .leading-3.capsize::before, .text-xl .font-sans.leading-3.capsize::before, .text-xl .font-sans .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.043em;
  display: table;
}
.font-sans.text-xl.leading-3.capsize::after, .font-sans .text-xl.leading-3.capsize::after, .font-sans .text-xl .leading-3.capsize::after, .text-xl .font-sans.leading-3.capsize::after, .text-xl .font-sans .leading-3.capsize::after {
  content: '';
  margin-top: 0.087em;
  display: table;
}
.font-sans.text-xl.leading-4.capsize::before, .font-sans .text-xl.leading-4.capsize::before, .font-sans .text-xl .leading-4.capsize::before, .text-xl .font-sans.leading-4.capsize::before, .text-xl .font-sans .leading-4.capsize::before {
  content: '';
  margin-bottom: -0.057em;
  display: table;
}
.font-sans.text-xl.leading-4.capsize::after, .font-sans .text-xl.leading-4.capsize::after, .font-sans .text-xl .leading-4.capsize::after, .text-xl .font-sans.leading-4.capsize::after, .text-xl .font-sans .leading-4.capsize::after {
  content: '';
  margin-top: -0.013em;
  display: table;
}
.font-sans.text-xl.leading-5.capsize::before, .font-sans .text-xl.leading-5.capsize::before, .font-sans .text-xl .leading-5.capsize::before, .text-xl .font-sans.leading-5.capsize::before, .text-xl .font-sans .leading-5.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-xl.leading-5.capsize::after, .font-sans .text-xl.leading-5.capsize::after, .font-sans .text-xl .leading-5.capsize::after, .text-xl .font-sans.leading-5.capsize::after, .text-xl .font-sans .leading-5.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-xl.leading-6.capsize::before, .font-sans .text-xl.leading-6.capsize::before, .font-sans .text-xl .leading-6.capsize::before, .text-xl .font-sans.leading-6.capsize::before, .text-xl .font-sans .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.257em;
  display: table;
}
.font-sans.text-xl.leading-6.capsize::after, .font-sans .text-xl.leading-6.capsize::after, .font-sans .text-xl .leading-6.capsize::after, .text-xl .font-sans.leading-6.capsize::after, .text-xl .font-sans .leading-6.capsize::after {
  content: '';
  margin-top: -0.213em;
  display: table;
}
.font-sans.text-xl.leading-7.capsize::before, .font-sans .text-xl.leading-7.capsize::before, .font-sans .text-xl .leading-7.capsize::before, .text-xl .font-sans.leading-7.capsize::before, .text-xl .font-sans .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.357em;
  display: table;
}
.font-sans.text-xl.leading-7.capsize::after, .font-sans .text-xl.leading-7.capsize::after, .font-sans .text-xl .leading-7.capsize::after, .text-xl .font-sans.leading-7.capsize::after, .text-xl .font-sans .leading-7.capsize::after {
  content: '';
  margin-top: -0.313em;
  display: table;
}
.font-sans.text-xl.leading-8.capsize::before, .font-sans .text-xl.leading-8.capsize::before, .font-sans .text-xl .leading-8.capsize::before, .text-xl .font-sans.leading-8.capsize::before, .text-xl .font-sans .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.457em;
  display: table;
}
.font-sans.text-xl.leading-8.capsize::after, .font-sans .text-xl.leading-8.capsize::after, .font-sans .text-xl .leading-8.capsize::after, .text-xl .font-sans.leading-8.capsize::after, .text-xl .font-sans .leading-8.capsize::after {
  content: '';
  margin-top: -0.413em;
  display: table;
}
.font-sans.text-xl.leading-9.capsize::before, .font-sans .text-xl.leading-9.capsize::before, .font-sans .text-xl .leading-9.capsize::before, .text-xl .font-sans.leading-9.capsize::before, .text-xl .font-sans .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.557em;
  display: table;
}
.font-sans.text-xl.leading-9.capsize::after, .font-sans .text-xl.leading-9.capsize::after, .font-sans .text-xl .leading-9.capsize::after, .text-xl .font-sans.leading-9.capsize::after, .text-xl .font-sans .leading-9.capsize::after {
  content: '';
  margin-top: -0.513em;
  display: table;
}
.font-sans.text-xl.leading-10.capsize::before, .font-sans .text-xl.leading-10.capsize::before, .font-sans .text-xl .leading-10.capsize::before, .text-xl .font-sans.leading-10.capsize::before, .text-xl .font-sans .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans.text-xl.leading-10.capsize::after, .font-sans .text-xl.leading-10.capsize::after, .font-sans .text-xl .leading-10.capsize::after, .text-xl .font-sans.leading-10.capsize::after, .text-xl .font-sans .leading-10.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-sans.text-xl.leading-none.capsize::before, .font-sans .text-xl.leading-none.capsize::before, .font-sans .text-xl .leading-none.capsize::before, .text-xl .font-sans.leading-none.capsize::before, .text-xl .font-sans .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-xl.leading-none.capsize::after, .font-sans .text-xl.leading-none.capsize::after, .font-sans .text-xl .leading-none.capsize::after, .text-xl .font-sans.leading-none.capsize::after, .text-xl .font-sans .leading-none.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-xl.leading-tight.capsize::before, .font-sans .text-xl.leading-tight.capsize::before, .font-sans .text-xl .leading-tight.capsize::before, .text-xl .font-sans.leading-tight.capsize::before, .text-xl .font-sans .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.282em;
  display: table;
}
.font-sans.text-xl.leading-tight.capsize::after, .font-sans .text-xl.leading-tight.capsize::after, .font-sans .text-xl .leading-tight.capsize::after, .text-xl .font-sans.leading-tight.capsize::after, .text-xl .font-sans .leading-tight.capsize::after {
  content: '';
  margin-top: -0.238em;
  display: table;
}
.font-sans.text-xl.leading-snug.capsize::before, .font-sans .text-xl.leading-snug.capsize::before, .font-sans .text-xl .leading-snug.capsize::before, .text-xl .font-sans.leading-snug.capsize::before, .text-xl .font-sans .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3445em;
  display: table;
}
.font-sans.text-xl.leading-snug.capsize::after, .font-sans .text-xl.leading-snug.capsize::after, .font-sans .text-xl .leading-snug.capsize::after, .text-xl .font-sans.leading-snug.capsize::after, .text-xl .font-sans .leading-snug.capsize::after {
  content: '';
  margin-top: -0.3005em;
  display: table;
}
.font-sans.text-xl.leading-normal.capsize::before, .font-sans .text-xl.leading-normal.capsize::before, .font-sans .text-xl .leading-normal.capsize::before, .text-xl .font-sans.leading-normal.capsize::before, .text-xl .font-sans .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.407em;
  display: table;
}
.font-sans.text-xl.leading-normal.capsize::after, .font-sans .text-xl.leading-normal.capsize::after, .font-sans .text-xl .leading-normal.capsize::after, .text-xl .font-sans.leading-normal.capsize::after, .text-xl .font-sans .leading-normal.capsize::after {
  content: '';
  margin-top: -0.363em;
  display: table;
}
.font-sans.text-xl.leading-relaxed.capsize::before, .font-sans .text-xl.leading-relaxed.capsize::before, .font-sans .text-xl .leading-relaxed.capsize::before, .text-xl .font-sans.leading-relaxed.capsize::before, .text-xl .font-sans .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4695em;
  display: table;
}
.font-sans.text-xl.leading-relaxed.capsize::after, .font-sans .text-xl.leading-relaxed.capsize::after, .font-sans .text-xl .leading-relaxed.capsize::after, .text-xl .font-sans.leading-relaxed.capsize::after, .text-xl .font-sans .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4255em;
  display: table;
}
.font-sans.text-xl.leading-loose.capsize::before, .font-sans .text-xl.leading-loose.capsize::before, .font-sans .text-xl .leading-loose.capsize::before, .text-xl .font-sans.leading-loose.capsize::before, .text-xl .font-sans .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans.text-xl.leading-loose.capsize::after, .font-sans .text-xl.leading-loose.capsize::after, .font-sans .text-xl .leading-loose.capsize::after, .text-xl .font-sans.leading-loose.capsize::after, .text-xl .font-sans .leading-loose.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-sans.text-2xl.leading-3.capsize::before, .font-sans .text-2xl.leading-3.capsize::before, .font-sans .text-2xl .leading-3.capsize::before, .text-2xl .font-sans.leading-3.capsize::before, .text-2xl .font-sans .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.093em;
  display: table;
}
.font-sans.text-2xl.leading-3.capsize::after, .font-sans .text-2xl.leading-3.capsize::after, .font-sans .text-2xl .leading-3.capsize::after, .text-2xl .font-sans.leading-3.capsize::after, .text-2xl .font-sans .leading-3.capsize::after {
  content: '';
  margin-top: 0.137em;
  display: table;
}
.font-sans.text-2xl.leading-4.capsize::before, .font-sans .text-2xl.leading-4.capsize::before, .font-sans .text-2xl .leading-4.capsize::before, .text-2xl .font-sans.leading-4.capsize::before, .text-2xl .font-sans .leading-4.capsize::before {
  content: '';
  margin-bottom: 0.0097em;
  display: table;
}
.font-sans.text-2xl.leading-4.capsize::after, .font-sans .text-2xl.leading-4.capsize::after, .font-sans .text-2xl .leading-4.capsize::after, .text-2xl .font-sans.leading-4.capsize::after, .text-2xl .font-sans .leading-4.capsize::after {
  content: '';
  margin-top: 0.0537em;
  display: table;
}
.font-sans.text-2xl.leading-5.capsize::before, .font-sans .text-2xl.leading-5.capsize::before, .font-sans .text-2xl .leading-5.capsize::before, .text-2xl .font-sans.leading-5.capsize::before, .text-2xl .font-sans .leading-5.capsize::before {
  content: '';
  margin-bottom: -0.0737em;
  display: table;
}
.font-sans.text-2xl.leading-5.capsize::after, .font-sans .text-2xl.leading-5.capsize::after, .font-sans .text-2xl .leading-5.capsize::after, .text-2xl .font-sans.leading-5.capsize::after, .text-2xl .font-sans .leading-5.capsize::after {
  content: '';
  margin-top: -0.0297em;
  display: table;
}
.font-sans.text-2xl.leading-6.capsize::before, .font-sans .text-2xl.leading-6.capsize::before, .font-sans .text-2xl .leading-6.capsize::before, .text-2xl .font-sans.leading-6.capsize::before, .text-2xl .font-sans .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-2xl.leading-6.capsize::after, .font-sans .text-2xl.leading-6.capsize::after, .font-sans .text-2xl .leading-6.capsize::after, .text-2xl .font-sans.leading-6.capsize::after, .text-2xl .font-sans .leading-6.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-2xl.leading-7.capsize::before, .font-sans .text-2xl.leading-7.capsize::before, .font-sans .text-2xl .leading-7.capsize::before, .text-2xl .font-sans.leading-7.capsize::before, .text-2xl .font-sans .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.2403em;
  display: table;
}
.font-sans.text-2xl.leading-7.capsize::after, .font-sans .text-2xl.leading-7.capsize::after, .font-sans .text-2xl .leading-7.capsize::after, .text-2xl .font-sans.leading-7.capsize::after, .text-2xl .font-sans .leading-7.capsize::after {
  content: '';
  margin-top: -0.1963em;
  display: table;
}
.font-sans.text-2xl.leading-8.capsize::before, .font-sans .text-2xl.leading-8.capsize::before, .font-sans .text-2xl .leading-8.capsize::before, .text-2xl .font-sans.leading-8.capsize::before, .text-2xl .font-sans .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.3237em;
  display: table;
}
.font-sans.text-2xl.leading-8.capsize::after, .font-sans .text-2xl.leading-8.capsize::after, .font-sans .text-2xl .leading-8.capsize::after, .text-2xl .font-sans.leading-8.capsize::after, .text-2xl .font-sans .leading-8.capsize::after {
  content: '';
  margin-top: -0.2797em;
  display: table;
}
.font-sans.text-2xl.leading-9.capsize::before, .font-sans .text-2xl.leading-9.capsize::before, .font-sans .text-2xl .leading-9.capsize::before, .text-2xl .font-sans.leading-9.capsize::before, .text-2xl .font-sans .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.407em;
  display: table;
}
.font-sans.text-2xl.leading-9.capsize::after, .font-sans .text-2xl.leading-9.capsize::after, .font-sans .text-2xl .leading-9.capsize::after, .text-2xl .font-sans.leading-9.capsize::after, .text-2xl .font-sans .leading-9.capsize::after {
  content: '';
  margin-top: -0.363em;
  display: table;
}
.font-sans.text-2xl.leading-10.capsize::before, .font-sans .text-2xl.leading-10.capsize::before, .font-sans .text-2xl .leading-10.capsize::before, .text-2xl .font-sans.leading-10.capsize::before, .text-2xl .font-sans .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.4903em;
  display: table;
}
.font-sans.text-2xl.leading-10.capsize::after, .font-sans .text-2xl.leading-10.capsize::after, .font-sans .text-2xl .leading-10.capsize::after, .text-2xl .font-sans.leading-10.capsize::after, .text-2xl .font-sans .leading-10.capsize::after {
  content: '';
  margin-top: -0.4463em;
  display: table;
}
.font-sans.text-2xl.leading-none.capsize::before, .font-sans .text-2xl.leading-none.capsize::before, .font-sans .text-2xl .leading-none.capsize::before, .text-2xl .font-sans.leading-none.capsize::before, .text-2xl .font-sans .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-2xl.leading-none.capsize::after, .font-sans .text-2xl.leading-none.capsize::after, .font-sans .text-2xl .leading-none.capsize::after, .text-2xl .font-sans.leading-none.capsize::after, .text-2xl .font-sans .leading-none.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-2xl.leading-tight.capsize::before, .font-sans .text-2xl.leading-tight.capsize::before, .font-sans .text-2xl .leading-tight.capsize::before, .text-2xl .font-sans.leading-tight.capsize::before, .text-2xl .font-sans .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.282em;
  display: table;
}
.font-sans.text-2xl.leading-tight.capsize::after, .font-sans .text-2xl.leading-tight.capsize::after, .font-sans .text-2xl .leading-tight.capsize::after, .text-2xl .font-sans.leading-tight.capsize::after, .text-2xl .font-sans .leading-tight.capsize::after {
  content: '';
  margin-top: -0.238em;
  display: table;
}
.font-sans.text-2xl.leading-snug.capsize::before, .font-sans .text-2xl.leading-snug.capsize::before, .font-sans .text-2xl .leading-snug.capsize::before, .text-2xl .font-sans.leading-snug.capsize::before, .text-2xl .font-sans .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3445em;
  display: table;
}
.font-sans.text-2xl.leading-snug.capsize::after, .font-sans .text-2xl.leading-snug.capsize::after, .font-sans .text-2xl .leading-snug.capsize::after, .text-2xl .font-sans.leading-snug.capsize::after, .text-2xl .font-sans .leading-snug.capsize::after {
  content: '';
  margin-top: -0.3005em;
  display: table;
}
.font-sans.text-2xl.leading-normal.capsize::before, .font-sans .text-2xl.leading-normal.capsize::before, .font-sans .text-2xl .leading-normal.capsize::before, .text-2xl .font-sans.leading-normal.capsize::before, .text-2xl .font-sans .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.407em;
  display: table;
}
.font-sans.text-2xl.leading-normal.capsize::after, .font-sans .text-2xl.leading-normal.capsize::after, .font-sans .text-2xl .leading-normal.capsize::after, .text-2xl .font-sans.leading-normal.capsize::after, .text-2xl .font-sans .leading-normal.capsize::after {
  content: '';
  margin-top: -0.363em;
  display: table;
}
.font-sans.text-2xl.leading-relaxed.capsize::before, .font-sans .text-2xl.leading-relaxed.capsize::before, .font-sans .text-2xl .leading-relaxed.capsize::before, .text-2xl .font-sans.leading-relaxed.capsize::before, .text-2xl .font-sans .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4695em;
  display: table;
}
.font-sans.text-2xl.leading-relaxed.capsize::after, .font-sans .text-2xl.leading-relaxed.capsize::after, .font-sans .text-2xl .leading-relaxed.capsize::after, .text-2xl .font-sans.leading-relaxed.capsize::after, .text-2xl .font-sans .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4255em;
  display: table;
}
.font-sans.text-2xl.leading-loose.capsize::before, .font-sans .text-2xl.leading-loose.capsize::before, .font-sans .text-2xl .leading-loose.capsize::before, .text-2xl .font-sans.leading-loose.capsize::before, .text-2xl .font-sans .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans.text-2xl.leading-loose.capsize::after, .font-sans .text-2xl.leading-loose.capsize::after, .font-sans .text-2xl .leading-loose.capsize::after, .text-2xl .font-sans.leading-loose.capsize::after, .text-2xl .font-sans .leading-loose.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-sans.text-3xl.leading-3.capsize::before, .font-sans .text-3xl.leading-3.capsize::before, .font-sans .text-3xl .leading-3.capsize::before, .text-3xl .font-sans.leading-3.capsize::before, .text-3xl .font-sans .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.143em;
  display: table;
}
.font-sans.text-3xl.leading-3.capsize::after, .font-sans .text-3xl.leading-3.capsize::after, .font-sans .text-3xl .leading-3.capsize::after, .text-3xl .font-sans.leading-3.capsize::after, .text-3xl .font-sans .leading-3.capsize::after {
  content: '';
  margin-top: 0.187em;
  display: table;
}
.font-sans.text-3xl.leading-4.capsize::before, .font-sans .text-3xl.leading-4.capsize::before, .font-sans .text-3xl .leading-4.capsize::before, .text-3xl .font-sans.leading-4.capsize::before, .text-3xl .font-sans .leading-4.capsize::before {
  content: '';
  margin-bottom: 0.0763em;
  display: table;
}
.font-sans.text-3xl.leading-4.capsize::after, .font-sans .text-3xl.leading-4.capsize::after, .font-sans .text-3xl .leading-4.capsize::after, .text-3xl .font-sans.leading-4.capsize::after, .text-3xl .font-sans .leading-4.capsize::after {
  content: '';
  margin-top: 0.1203em;
  display: table;
}
.font-sans.text-3xl.leading-5.capsize::before, .font-sans .text-3xl.leading-5.capsize::before, .font-sans .text-3xl .leading-5.capsize::before, .text-3xl .font-sans.leading-5.capsize::before, .text-3xl .font-sans .leading-5.capsize::before {
  content: '';
  margin-bottom: 0.0097em;
  display: table;
}
.font-sans.text-3xl.leading-5.capsize::after, .font-sans .text-3xl.leading-5.capsize::after, .font-sans .text-3xl .leading-5.capsize::after, .text-3xl .font-sans.leading-5.capsize::after, .text-3xl .font-sans .leading-5.capsize::after {
  content: '';
  margin-top: 0.0537em;
  display: table;
}
.font-sans.text-3xl.leading-6.capsize::before, .font-sans .text-3xl.leading-6.capsize::before, .font-sans .text-3xl .leading-6.capsize::before, .text-3xl .font-sans.leading-6.capsize::before, .text-3xl .font-sans .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.057em;
  display: table;
}
.font-sans.text-3xl.leading-6.capsize::after, .font-sans .text-3xl.leading-6.capsize::after, .font-sans .text-3xl .leading-6.capsize::after, .text-3xl .font-sans.leading-6.capsize::after, .text-3xl .font-sans .leading-6.capsize::after {
  content: '';
  margin-top: -0.013em;
  display: table;
}
.font-sans.text-3xl.leading-7.capsize::before, .font-sans .text-3xl.leading-7.capsize::before, .font-sans .text-3xl .leading-7.capsize::before, .text-3xl .font-sans.leading-7.capsize::before, .text-3xl .font-sans .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.1237em;
  display: table;
}
.font-sans.text-3xl.leading-7.capsize::after, .font-sans .text-3xl.leading-7.capsize::after, .font-sans .text-3xl .leading-7.capsize::after, .text-3xl .font-sans.leading-7.capsize::after, .text-3xl .font-sans .leading-7.capsize::after {
  content: '';
  margin-top: -0.0797em;
  display: table;
}
.font-sans.text-3xl.leading-8.capsize::before, .font-sans .text-3xl.leading-8.capsize::before, .font-sans .text-3xl .leading-8.capsize::before, .text-3xl .font-sans.leading-8.capsize::before, .text-3xl .font-sans .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.1903em;
  display: table;
}
.font-sans.text-3xl.leading-8.capsize::after, .font-sans .text-3xl.leading-8.capsize::after, .font-sans .text-3xl .leading-8.capsize::after, .text-3xl .font-sans.leading-8.capsize::after, .text-3xl .font-sans .leading-8.capsize::after {
  content: '';
  margin-top: -0.1463em;
  display: table;
}
.font-sans.text-3xl.leading-9.capsize::before, .font-sans .text-3xl.leading-9.capsize::before, .font-sans .text-3xl .leading-9.capsize::before, .text-3xl .font-sans.leading-9.capsize::before, .text-3xl .font-sans .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.257em;
  display: table;
}
.font-sans.text-3xl.leading-9.capsize::after, .font-sans .text-3xl.leading-9.capsize::after, .font-sans .text-3xl .leading-9.capsize::after, .text-3xl .font-sans.leading-9.capsize::after, .text-3xl .font-sans .leading-9.capsize::after {
  content: '';
  margin-top: -0.213em;
  display: table;
}
.font-sans.text-3xl.leading-10.capsize::before, .font-sans .text-3xl.leading-10.capsize::before, .font-sans .text-3xl .leading-10.capsize::before, .text-3xl .font-sans.leading-10.capsize::before, .text-3xl .font-sans .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.3237em;
  display: table;
}
.font-sans.text-3xl.leading-10.capsize::after, .font-sans .text-3xl.leading-10.capsize::after, .font-sans .text-3xl .leading-10.capsize::after, .text-3xl .font-sans.leading-10.capsize::after, .text-3xl .font-sans .leading-10.capsize::after {
  content: '';
  margin-top: -0.2797em;
  display: table;
}
.font-sans.text-3xl.leading-none.capsize::before, .font-sans .text-3xl.leading-none.capsize::before, .font-sans .text-3xl .leading-none.capsize::before, .text-3xl .font-sans.leading-none.capsize::before, .text-3xl .font-sans .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-3xl.leading-none.capsize::after, .font-sans .text-3xl.leading-none.capsize::after, .font-sans .text-3xl .leading-none.capsize::after, .text-3xl .font-sans.leading-none.capsize::after, .text-3xl .font-sans .leading-none.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-3xl.leading-tight.capsize::before, .font-sans .text-3xl.leading-tight.capsize::before, .font-sans .text-3xl .leading-tight.capsize::before, .text-3xl .font-sans.leading-tight.capsize::before, .text-3xl .font-sans .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.282em;
  display: table;
}
.font-sans.text-3xl.leading-tight.capsize::after, .font-sans .text-3xl.leading-tight.capsize::after, .font-sans .text-3xl .leading-tight.capsize::after, .text-3xl .font-sans.leading-tight.capsize::after, .text-3xl .font-sans .leading-tight.capsize::after {
  content: '';
  margin-top: -0.238em;
  display: table;
}
.font-sans.text-3xl.leading-snug.capsize::before, .font-sans .text-3xl.leading-snug.capsize::before, .font-sans .text-3xl .leading-snug.capsize::before, .text-3xl .font-sans.leading-snug.capsize::before, .text-3xl .font-sans .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3445em;
  display: table;
}
.font-sans.text-3xl.leading-snug.capsize::after, .font-sans .text-3xl.leading-snug.capsize::after, .font-sans .text-3xl .leading-snug.capsize::after, .text-3xl .font-sans.leading-snug.capsize::after, .text-3xl .font-sans .leading-snug.capsize::after {
  content: '';
  margin-top: -0.3005em;
  display: table;
}
.font-sans.text-3xl.leading-normal.capsize::before, .font-sans .text-3xl.leading-normal.capsize::before, .font-sans .text-3xl .leading-normal.capsize::before, .text-3xl .font-sans.leading-normal.capsize::before, .text-3xl .font-sans .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.407em;
  display: table;
}
.font-sans.text-3xl.leading-normal.capsize::after, .font-sans .text-3xl.leading-normal.capsize::after, .font-sans .text-3xl .leading-normal.capsize::after, .text-3xl .font-sans.leading-normal.capsize::after, .text-3xl .font-sans .leading-normal.capsize::after {
  content: '';
  margin-top: -0.363em;
  display: table;
}
.font-sans.text-3xl.leading-relaxed.capsize::before, .font-sans .text-3xl.leading-relaxed.capsize::before, .font-sans .text-3xl .leading-relaxed.capsize::before, .text-3xl .font-sans.leading-relaxed.capsize::before, .text-3xl .font-sans .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4695em;
  display: table;
}
.font-sans.text-3xl.leading-relaxed.capsize::after, .font-sans .text-3xl.leading-relaxed.capsize::after, .font-sans .text-3xl .leading-relaxed.capsize::after, .text-3xl .font-sans.leading-relaxed.capsize::after, .text-3xl .font-sans .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4255em;
  display: table;
}
.font-sans.text-3xl.leading-loose.capsize::before, .font-sans .text-3xl.leading-loose.capsize::before, .font-sans .text-3xl .leading-loose.capsize::before, .text-3xl .font-sans.leading-loose.capsize::before, .text-3xl .font-sans .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans.text-3xl.leading-loose.capsize::after, .font-sans .text-3xl.leading-loose.capsize::after, .font-sans .text-3xl .leading-loose.capsize::after, .text-3xl .font-sans.leading-loose.capsize::after, .text-3xl .font-sans .leading-loose.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-sans.text-4xl.leading-3.capsize::before, .font-sans .text-4xl.leading-3.capsize::before, .font-sans .text-4xl .leading-3.capsize::before, .text-4xl .font-sans.leading-3.capsize::before, .text-4xl .font-sans .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.1763em;
  display: table;
}
.font-sans.text-4xl.leading-3.capsize::after, .font-sans .text-4xl.leading-3.capsize::after, .font-sans .text-4xl .leading-3.capsize::after, .text-4xl .font-sans.leading-3.capsize::after, .text-4xl .font-sans .leading-3.capsize::after {
  content: '';
  margin-top: 0.2203em;
  display: table;
}
.font-sans.text-4xl.leading-4.capsize::before, .font-sans .text-4xl.leading-4.capsize::before, .font-sans .text-4xl .leading-4.capsize::before, .text-4xl .font-sans.leading-4.capsize::before, .text-4xl .font-sans .leading-4.capsize::before {
  content: '';
  margin-bottom: 0.1208em;
  display: table;
}
.font-sans.text-4xl.leading-4.capsize::after, .font-sans .text-4xl.leading-4.capsize::after, .font-sans .text-4xl .leading-4.capsize::after, .text-4xl .font-sans.leading-4.capsize::after, .text-4xl .font-sans .leading-4.capsize::after {
  content: '';
  margin-top: 0.1648em;
  display: table;
}
.font-sans.text-4xl.leading-5.capsize::before, .font-sans .text-4xl.leading-5.capsize::before, .font-sans .text-4xl .leading-5.capsize::before, .text-4xl .font-sans.leading-5.capsize::before, .text-4xl .font-sans .leading-5.capsize::before {
  content: '';
  margin-bottom: 0.0652em;
  display: table;
}
.font-sans.text-4xl.leading-5.capsize::after, .font-sans .text-4xl.leading-5.capsize::after, .font-sans .text-4xl .leading-5.capsize::after, .text-4xl .font-sans.leading-5.capsize::after, .text-4xl .font-sans .leading-5.capsize::after {
  content: '';
  margin-top: 0.1092em;
  display: table;
}
.font-sans.text-4xl.leading-6.capsize::before, .font-sans .text-4xl.leading-6.capsize::before, .font-sans .text-4xl .leading-6.capsize::before, .text-4xl .font-sans.leading-6.capsize::before, .text-4xl .font-sans .leading-6.capsize::before {
  content: '';
  margin-bottom: 0.0097em;
  display: table;
}
.font-sans.text-4xl.leading-6.capsize::after, .font-sans .text-4xl.leading-6.capsize::after, .font-sans .text-4xl .leading-6.capsize::after, .text-4xl .font-sans.leading-6.capsize::after, .text-4xl .font-sans .leading-6.capsize::after {
  content: '';
  margin-top: 0.0537em;
  display: table;
}
.font-sans.text-4xl.leading-7.capsize::before, .font-sans .text-4xl.leading-7.capsize::before, .font-sans .text-4xl .leading-7.capsize::before, .text-4xl .font-sans.leading-7.capsize::before, .text-4xl .font-sans .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.0459em;
  display: table;
}
.font-sans.text-4xl.leading-7.capsize::after, .font-sans .text-4xl.leading-7.capsize::after, .font-sans .text-4xl .leading-7.capsize::after, .text-4xl .font-sans.leading-7.capsize::after, .text-4xl .font-sans .leading-7.capsize::after {
  content: '';
  margin-top: -0.0019em;
  display: table;
}
.font-sans.text-4xl.leading-8.capsize::before, .font-sans .text-4xl.leading-8.capsize::before, .font-sans .text-4xl .leading-8.capsize::before, .text-4xl .font-sans.leading-8.capsize::before, .text-4xl .font-sans .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.1014em;
  display: table;
}
.font-sans.text-4xl.leading-8.capsize::after, .font-sans .text-4xl.leading-8.capsize::after, .font-sans .text-4xl .leading-8.capsize::after, .text-4xl .font-sans.leading-8.capsize::after, .text-4xl .font-sans .leading-8.capsize::after {
  content: '';
  margin-top: -0.0574em;
  display: table;
}
.font-sans.text-4xl.leading-9.capsize::before, .font-sans .text-4xl.leading-9.capsize::before, .font-sans .text-4xl .leading-9.capsize::before, .text-4xl .font-sans.leading-9.capsize::before, .text-4xl .font-sans .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-4xl.leading-9.capsize::after, .font-sans .text-4xl.leading-9.capsize::after, .font-sans .text-4xl .leading-9.capsize::after, .text-4xl .font-sans.leading-9.capsize::after, .text-4xl .font-sans .leading-9.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-4xl.leading-10.capsize::before, .font-sans .text-4xl.leading-10.capsize::before, .font-sans .text-4xl .leading-10.capsize::before, .text-4xl .font-sans.leading-10.capsize::before, .text-4xl .font-sans .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.2126em;
  display: table;
}
.font-sans.text-4xl.leading-10.capsize::after, .font-sans .text-4xl.leading-10.capsize::after, .font-sans .text-4xl .leading-10.capsize::after, .text-4xl .font-sans.leading-10.capsize::after, .text-4xl .font-sans .leading-10.capsize::after {
  content: '';
  margin-top: -0.1686em;
  display: table;
}
.font-sans.text-4xl.leading-none.capsize::before, .font-sans .text-4xl.leading-none.capsize::before, .font-sans .text-4xl .leading-none.capsize::before, .text-4xl .font-sans.leading-none.capsize::before, .text-4xl .font-sans .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-4xl.leading-none.capsize::after, .font-sans .text-4xl.leading-none.capsize::after, .font-sans .text-4xl .leading-none.capsize::after, .text-4xl .font-sans.leading-none.capsize::after, .text-4xl .font-sans .leading-none.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-4xl.leading-tight.capsize::before, .font-sans .text-4xl.leading-tight.capsize::before, .font-sans .text-4xl .leading-tight.capsize::before, .text-4xl .font-sans.leading-tight.capsize::before, .text-4xl .font-sans .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.282em;
  display: table;
}
.font-sans.text-4xl.leading-tight.capsize::after, .font-sans .text-4xl.leading-tight.capsize::after, .font-sans .text-4xl .leading-tight.capsize::after, .text-4xl .font-sans.leading-tight.capsize::after, .text-4xl .font-sans .leading-tight.capsize::after {
  content: '';
  margin-top: -0.238em;
  display: table;
}
.font-sans.text-4xl.leading-snug.capsize::before, .font-sans .text-4xl.leading-snug.capsize::before, .font-sans .text-4xl .leading-snug.capsize::before, .text-4xl .font-sans.leading-snug.capsize::before, .text-4xl .font-sans .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3445em;
  display: table;
}
.font-sans.text-4xl.leading-snug.capsize::after, .font-sans .text-4xl.leading-snug.capsize::after, .font-sans .text-4xl .leading-snug.capsize::after, .text-4xl .font-sans.leading-snug.capsize::after, .text-4xl .font-sans .leading-snug.capsize::after {
  content: '';
  margin-top: -0.3005em;
  display: table;
}
.font-sans.text-4xl.leading-normal.capsize::before, .font-sans .text-4xl.leading-normal.capsize::before, .font-sans .text-4xl .leading-normal.capsize::before, .text-4xl .font-sans.leading-normal.capsize::before, .text-4xl .font-sans .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.407em;
  display: table;
}
.font-sans.text-4xl.leading-normal.capsize::after, .font-sans .text-4xl.leading-normal.capsize::after, .font-sans .text-4xl .leading-normal.capsize::after, .text-4xl .font-sans.leading-normal.capsize::after, .text-4xl .font-sans .leading-normal.capsize::after {
  content: '';
  margin-top: -0.363em;
  display: table;
}
.font-sans.text-4xl.leading-relaxed.capsize::before, .font-sans .text-4xl.leading-relaxed.capsize::before, .font-sans .text-4xl .leading-relaxed.capsize::before, .text-4xl .font-sans.leading-relaxed.capsize::before, .text-4xl .font-sans .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4695em;
  display: table;
}
.font-sans.text-4xl.leading-relaxed.capsize::after, .font-sans .text-4xl.leading-relaxed.capsize::after, .font-sans .text-4xl .leading-relaxed.capsize::after, .text-4xl .font-sans.leading-relaxed.capsize::after, .text-4xl .font-sans .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4255em;
  display: table;
}
.font-sans.text-4xl.leading-loose.capsize::before, .font-sans .text-4xl.leading-loose.capsize::before, .font-sans .text-4xl .leading-loose.capsize::before, .text-4xl .font-sans.leading-loose.capsize::before, .text-4xl .font-sans .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans.text-4xl.leading-loose.capsize::after, .font-sans .text-4xl.leading-loose.capsize::after, .font-sans .text-4xl .leading-loose.capsize::after, .text-4xl .font-sans.leading-loose.capsize::after, .text-4xl .font-sans .leading-loose.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-sans.text-5xl.leading-3.capsize::before, .font-sans .text-5xl.leading-3.capsize::before, .font-sans .text-5xl .leading-3.capsize::before, .text-5xl .font-sans.leading-3.capsize::before, .text-5xl .font-sans .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.218em;
  display: table;
}
.font-sans.text-5xl.leading-3.capsize::after, .font-sans .text-5xl.leading-3.capsize::after, .font-sans .text-5xl .leading-3.capsize::after, .text-5xl .font-sans.leading-3.capsize::after, .text-5xl .font-sans .leading-3.capsize::after {
  content: '';
  margin-top: 0.262em;
  display: table;
}
.font-sans.text-5xl.leading-4.capsize::before, .font-sans .text-5xl.leading-4.capsize::before, .font-sans .text-5xl .leading-4.capsize::before, .text-5xl .font-sans.leading-4.capsize::before, .text-5xl .font-sans .leading-4.capsize::before {
  content: '';
  margin-bottom: 0.1763em;
  display: table;
}
.font-sans.text-5xl.leading-4.capsize::after, .font-sans .text-5xl.leading-4.capsize::after, .font-sans .text-5xl .leading-4.capsize::after, .text-5xl .font-sans.leading-4.capsize::after, .text-5xl .font-sans .leading-4.capsize::after {
  content: '';
  margin-top: 0.2203em;
  display: table;
}
.font-sans.text-5xl.leading-5.capsize::before, .font-sans .text-5xl.leading-5.capsize::before, .font-sans .text-5xl .leading-5.capsize::before, .text-5xl .font-sans.leading-5.capsize::before, .text-5xl .font-sans .leading-5.capsize::before {
  content: '';
  margin-bottom: 0.1347em;
  display: table;
}
.font-sans.text-5xl.leading-5.capsize::after, .font-sans .text-5xl.leading-5.capsize::after, .font-sans .text-5xl .leading-5.capsize::after, .text-5xl .font-sans.leading-5.capsize::after, .text-5xl .font-sans .leading-5.capsize::after {
  content: '';
  margin-top: 0.1787em;
  display: table;
}
.font-sans.text-5xl.leading-6.capsize::before, .font-sans .text-5xl.leading-6.capsize::before, .font-sans .text-5xl .leading-6.capsize::before, .text-5xl .font-sans.leading-6.capsize::before, .text-5xl .font-sans .leading-6.capsize::before {
  content: '';
  margin-bottom: 0.093em;
  display: table;
}
.font-sans.text-5xl.leading-6.capsize::after, .font-sans .text-5xl.leading-6.capsize::after, .font-sans .text-5xl .leading-6.capsize::after, .text-5xl .font-sans.leading-6.capsize::after, .text-5xl .font-sans .leading-6.capsize::after {
  content: '';
  margin-top: 0.137em;
  display: table;
}
.font-sans.text-5xl.leading-7.capsize::before, .font-sans .text-5xl.leading-7.capsize::before, .font-sans .text-5xl .leading-7.capsize::before, .text-5xl .font-sans.leading-7.capsize::before, .text-5xl .font-sans .leading-7.capsize::before {
  content: '';
  margin-bottom: 0.0513em;
  display: table;
}
.font-sans.text-5xl.leading-7.capsize::after, .font-sans .text-5xl.leading-7.capsize::after, .font-sans .text-5xl .leading-7.capsize::after, .text-5xl .font-sans.leading-7.capsize::after, .text-5xl .font-sans .leading-7.capsize::after {
  content: '';
  margin-top: 0.0953em;
  display: table;
}
.font-sans.text-5xl.leading-8.capsize::before, .font-sans .text-5xl.leading-8.capsize::before, .font-sans .text-5xl .leading-8.capsize::before, .text-5xl .font-sans.leading-8.capsize::before, .text-5xl .font-sans .leading-8.capsize::before {
  content: '';
  margin-bottom: 0.0097em;
  display: table;
}
.font-sans.text-5xl.leading-8.capsize::after, .font-sans .text-5xl.leading-8.capsize::after, .font-sans .text-5xl .leading-8.capsize::after, .text-5xl .font-sans.leading-8.capsize::after, .text-5xl .font-sans .leading-8.capsize::after {
  content: '';
  margin-top: 0.0537em;
  display: table;
}
.font-sans.text-5xl.leading-9.capsize::before, .font-sans .text-5xl.leading-9.capsize::before, .font-sans .text-5xl .leading-9.capsize::before, .text-5xl .font-sans.leading-9.capsize::before, .text-5xl .font-sans .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.032em;
  display: table;
}
.font-sans.text-5xl.leading-9.capsize::after, .font-sans .text-5xl.leading-9.capsize::after, .font-sans .text-5xl .leading-9.capsize::after, .text-5xl .font-sans.leading-9.capsize::after, .text-5xl .font-sans .leading-9.capsize::after {
  content: '';
  margin-top: 0.012em;
  display: table;
}
.font-sans.text-5xl.leading-10.capsize::before, .font-sans .text-5xl.leading-10.capsize::before, .font-sans .text-5xl .leading-10.capsize::before, .text-5xl .font-sans.leading-10.capsize::before, .text-5xl .font-sans .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.0737em;
  display: table;
}
.font-sans.text-5xl.leading-10.capsize::after, .font-sans .text-5xl.leading-10.capsize::after, .font-sans .text-5xl .leading-10.capsize::after, .text-5xl .font-sans.leading-10.capsize::after, .text-5xl .font-sans .leading-10.capsize::after {
  content: '';
  margin-top: -0.0297em;
  display: table;
}
.font-sans.text-5xl.leading-none.capsize::before, .font-sans .text-5xl.leading-none.capsize::before, .font-sans .text-5xl .leading-none.capsize::before, .text-5xl .font-sans.leading-none.capsize::before, .text-5xl .font-sans .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-5xl.leading-none.capsize::after, .font-sans .text-5xl.leading-none.capsize::after, .font-sans .text-5xl .leading-none.capsize::after, .text-5xl .font-sans.leading-none.capsize::after, .text-5xl .font-sans .leading-none.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-5xl.leading-tight.capsize::before, .font-sans .text-5xl.leading-tight.capsize::before, .font-sans .text-5xl .leading-tight.capsize::before, .text-5xl .font-sans.leading-tight.capsize::before, .text-5xl .font-sans .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.282em;
  display: table;
}
.font-sans.text-5xl.leading-tight.capsize::after, .font-sans .text-5xl.leading-tight.capsize::after, .font-sans .text-5xl .leading-tight.capsize::after, .text-5xl .font-sans.leading-tight.capsize::after, .text-5xl .font-sans .leading-tight.capsize::after {
  content: '';
  margin-top: -0.238em;
  display: table;
}
.font-sans.text-5xl.leading-snug.capsize::before, .font-sans .text-5xl.leading-snug.capsize::before, .font-sans .text-5xl .leading-snug.capsize::before, .text-5xl .font-sans.leading-snug.capsize::before, .text-5xl .font-sans .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3445em;
  display: table;
}
.font-sans.text-5xl.leading-snug.capsize::after, .font-sans .text-5xl.leading-snug.capsize::after, .font-sans .text-5xl .leading-snug.capsize::after, .text-5xl .font-sans.leading-snug.capsize::after, .text-5xl .font-sans .leading-snug.capsize::after {
  content: '';
  margin-top: -0.3005em;
  display: table;
}
.font-sans.text-5xl.leading-normal.capsize::before, .font-sans .text-5xl.leading-normal.capsize::before, .font-sans .text-5xl .leading-normal.capsize::before, .text-5xl .font-sans.leading-normal.capsize::before, .text-5xl .font-sans .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.407em;
  display: table;
}
.font-sans.text-5xl.leading-normal.capsize::after, .font-sans .text-5xl.leading-normal.capsize::after, .font-sans .text-5xl .leading-normal.capsize::after, .text-5xl .font-sans.leading-normal.capsize::after, .text-5xl .font-sans .leading-normal.capsize::after {
  content: '';
  margin-top: -0.363em;
  display: table;
}
.font-sans.text-5xl.leading-relaxed.capsize::before, .font-sans .text-5xl.leading-relaxed.capsize::before, .font-sans .text-5xl .leading-relaxed.capsize::before, .text-5xl .font-sans.leading-relaxed.capsize::before, .text-5xl .font-sans .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4695em;
  display: table;
}
.font-sans.text-5xl.leading-relaxed.capsize::after, .font-sans .text-5xl.leading-relaxed.capsize::after, .font-sans .text-5xl .leading-relaxed.capsize::after, .text-5xl .font-sans.leading-relaxed.capsize::after, .text-5xl .font-sans .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4255em;
  display: table;
}
.font-sans.text-5xl.leading-loose.capsize::before, .font-sans .text-5xl.leading-loose.capsize::before, .font-sans .text-5xl .leading-loose.capsize::before, .text-5xl .font-sans.leading-loose.capsize::before, .text-5xl .font-sans .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans.text-5xl.leading-loose.capsize::after, .font-sans .text-5xl.leading-loose.capsize::after, .font-sans .text-5xl .leading-loose.capsize::after, .text-5xl .font-sans.leading-loose.capsize::after, .text-5xl .font-sans .leading-loose.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-sans.text-6xl.leading-3.capsize::before, .font-sans .text-6xl.leading-3.capsize::before, .font-sans .text-6xl .leading-3.capsize::before, .text-6xl .font-sans.leading-3.capsize::before, .text-6xl .font-sans .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.243em;
  display: table;
}
.font-sans.text-6xl.leading-3.capsize::after, .font-sans .text-6xl.leading-3.capsize::after, .font-sans .text-6xl .leading-3.capsize::after, .text-6xl .font-sans.leading-3.capsize::after, .text-6xl .font-sans .leading-3.capsize::after {
  content: '';
  margin-top: 0.287em;
  display: table;
}
.font-sans.text-6xl.leading-4.capsize::before, .font-sans .text-6xl.leading-4.capsize::before, .font-sans .text-6xl .leading-4.capsize::before, .text-6xl .font-sans.leading-4.capsize::before, .text-6xl .font-sans .leading-4.capsize::before {
  content: '';
  margin-bottom: 0.2097em;
  display: table;
}
.font-sans.text-6xl.leading-4.capsize::after, .font-sans .text-6xl.leading-4.capsize::after, .font-sans .text-6xl .leading-4.capsize::after, .text-6xl .font-sans.leading-4.capsize::after, .text-6xl .font-sans .leading-4.capsize::after {
  content: '';
  margin-top: 0.2537em;
  display: table;
}
.font-sans.text-6xl.leading-5.capsize::before, .font-sans .text-6xl.leading-5.capsize::before, .font-sans .text-6xl .leading-5.capsize::before, .text-6xl .font-sans.leading-5.capsize::before, .text-6xl .font-sans .leading-5.capsize::before {
  content: '';
  margin-bottom: 0.1763em;
  display: table;
}
.font-sans.text-6xl.leading-5.capsize::after, .font-sans .text-6xl.leading-5.capsize::after, .font-sans .text-6xl .leading-5.capsize::after, .text-6xl .font-sans.leading-5.capsize::after, .text-6xl .font-sans .leading-5.capsize::after {
  content: '';
  margin-top: 0.2203em;
  display: table;
}
.font-sans.text-6xl.leading-6.capsize::before, .font-sans .text-6xl.leading-6.capsize::before, .font-sans .text-6xl .leading-6.capsize::before, .text-6xl .font-sans.leading-6.capsize::before, .text-6xl .font-sans .leading-6.capsize::before {
  content: '';
  margin-bottom: 0.143em;
  display: table;
}
.font-sans.text-6xl.leading-6.capsize::after, .font-sans .text-6xl.leading-6.capsize::after, .font-sans .text-6xl .leading-6.capsize::after, .text-6xl .font-sans.leading-6.capsize::after, .text-6xl .font-sans .leading-6.capsize::after {
  content: '';
  margin-top: 0.187em;
  display: table;
}
.font-sans.text-6xl.leading-7.capsize::before, .font-sans .text-6xl.leading-7.capsize::before, .font-sans .text-6xl .leading-7.capsize::before, .text-6xl .font-sans.leading-7.capsize::before, .text-6xl .font-sans .leading-7.capsize::before {
  content: '';
  margin-bottom: 0.1097em;
  display: table;
}
.font-sans.text-6xl.leading-7.capsize::after, .font-sans .text-6xl.leading-7.capsize::after, .font-sans .text-6xl .leading-7.capsize::after, .text-6xl .font-sans.leading-7.capsize::after, .text-6xl .font-sans .leading-7.capsize::after {
  content: '';
  margin-top: 0.1537em;
  display: table;
}
.font-sans.text-6xl.leading-8.capsize::before, .font-sans .text-6xl.leading-8.capsize::before, .font-sans .text-6xl .leading-8.capsize::before, .text-6xl .font-sans.leading-8.capsize::before, .text-6xl .font-sans .leading-8.capsize::before {
  content: '';
  margin-bottom: 0.0763em;
  display: table;
}
.font-sans.text-6xl.leading-8.capsize::after, .font-sans .text-6xl.leading-8.capsize::after, .font-sans .text-6xl .leading-8.capsize::after, .text-6xl .font-sans.leading-8.capsize::after, .text-6xl .font-sans .leading-8.capsize::after {
  content: '';
  margin-top: 0.1203em;
  display: table;
}
.font-sans.text-6xl.leading-9.capsize::before, .font-sans .text-6xl.leading-9.capsize::before, .font-sans .text-6xl .leading-9.capsize::before, .text-6xl .font-sans.leading-9.capsize::before, .text-6xl .font-sans .leading-9.capsize::before {
  content: '';
  margin-bottom: 0.043em;
  display: table;
}
.font-sans.text-6xl.leading-9.capsize::after, .font-sans .text-6xl.leading-9.capsize::after, .font-sans .text-6xl .leading-9.capsize::after, .text-6xl .font-sans.leading-9.capsize::after, .text-6xl .font-sans .leading-9.capsize::after {
  content: '';
  margin-top: 0.087em;
  display: table;
}
.font-sans.text-6xl.leading-10.capsize::before, .font-sans .text-6xl.leading-10.capsize::before, .font-sans .text-6xl .leading-10.capsize::before, .text-6xl .font-sans.leading-10.capsize::before, .text-6xl .font-sans .leading-10.capsize::before {
  content: '';
  margin-bottom: 0.0097em;
  display: table;
}
.font-sans.text-6xl.leading-10.capsize::after, .font-sans .text-6xl.leading-10.capsize::after, .font-sans .text-6xl .leading-10.capsize::after, .text-6xl .font-sans.leading-10.capsize::after, .text-6xl .font-sans .leading-10.capsize::after {
  content: '';
  margin-top: 0.0537em;
  display: table;
}
.font-sans.text-6xl.leading-none.capsize::before, .font-sans .text-6xl.leading-none.capsize::before, .font-sans .text-6xl .leading-none.capsize::before, .text-6xl .font-sans.leading-none.capsize::before, .text-6xl .font-sans .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-6xl.leading-none.capsize::after, .font-sans .text-6xl.leading-none.capsize::after, .font-sans .text-6xl .leading-none.capsize::after, .text-6xl .font-sans.leading-none.capsize::after, .text-6xl .font-sans .leading-none.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-6xl.leading-tight.capsize::before, .font-sans .text-6xl.leading-tight.capsize::before, .font-sans .text-6xl .leading-tight.capsize::before, .text-6xl .font-sans.leading-tight.capsize::before, .text-6xl .font-sans .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.282em;
  display: table;
}
.font-sans.text-6xl.leading-tight.capsize::after, .font-sans .text-6xl.leading-tight.capsize::after, .font-sans .text-6xl .leading-tight.capsize::after, .text-6xl .font-sans.leading-tight.capsize::after, .text-6xl .font-sans .leading-tight.capsize::after {
  content: '';
  margin-top: -0.238em;
  display: table;
}
.font-sans.text-6xl.leading-snug.capsize::before, .font-sans .text-6xl.leading-snug.capsize::before, .font-sans .text-6xl .leading-snug.capsize::before, .text-6xl .font-sans.leading-snug.capsize::before, .text-6xl .font-sans .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3445em;
  display: table;
}
.font-sans.text-6xl.leading-snug.capsize::after, .font-sans .text-6xl.leading-snug.capsize::after, .font-sans .text-6xl .leading-snug.capsize::after, .text-6xl .font-sans.leading-snug.capsize::after, .text-6xl .font-sans .leading-snug.capsize::after {
  content: '';
  margin-top: -0.3005em;
  display: table;
}
.font-sans.text-6xl.leading-normal.capsize::before, .font-sans .text-6xl.leading-normal.capsize::before, .font-sans .text-6xl .leading-normal.capsize::before, .text-6xl .font-sans.leading-normal.capsize::before, .text-6xl .font-sans .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.407em;
  display: table;
}
.font-sans.text-6xl.leading-normal.capsize::after, .font-sans .text-6xl.leading-normal.capsize::after, .font-sans .text-6xl .leading-normal.capsize::after, .text-6xl .font-sans.leading-normal.capsize::after, .text-6xl .font-sans .leading-normal.capsize::after {
  content: '';
  margin-top: -0.363em;
  display: table;
}
.font-sans.text-6xl.leading-relaxed.capsize::before, .font-sans .text-6xl.leading-relaxed.capsize::before, .font-sans .text-6xl .leading-relaxed.capsize::before, .text-6xl .font-sans.leading-relaxed.capsize::before, .text-6xl .font-sans .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4695em;
  display: table;
}
.font-sans.text-6xl.leading-relaxed.capsize::after, .font-sans .text-6xl.leading-relaxed.capsize::after, .font-sans .text-6xl .leading-relaxed.capsize::after, .text-6xl .font-sans.leading-relaxed.capsize::after, .text-6xl .font-sans .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4255em;
  display: table;
}
.font-sans.text-6xl.leading-loose.capsize::before, .font-sans .text-6xl.leading-loose.capsize::before, .font-sans .text-6xl .leading-loose.capsize::before, .text-6xl .font-sans.leading-loose.capsize::before, .text-6xl .font-sans .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans.text-6xl.leading-loose.capsize::after, .font-sans .text-6xl.leading-loose.capsize::after, .font-sans .text-6xl .leading-loose.capsize::after, .text-6xl .font-sans.leading-loose.capsize::after, .text-6xl .font-sans .leading-loose.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-sans.text-7xl.leading-3.capsize::before, .font-sans .text-7xl.leading-3.capsize::before, .font-sans .text-7xl .leading-3.capsize::before, .text-7xl .font-sans.leading-3.capsize::before, .text-7xl .font-sans .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.2597em;
  display: table;
}
.font-sans.text-7xl.leading-3.capsize::after, .font-sans .text-7xl.leading-3.capsize::after, .font-sans .text-7xl .leading-3.capsize::after, .text-7xl .font-sans.leading-3.capsize::after, .text-7xl .font-sans .leading-3.capsize::after {
  content: '';
  margin-top: 0.3037em;
  display: table;
}
.font-sans.text-7xl.leading-4.capsize::before, .font-sans .text-7xl.leading-4.capsize::before, .font-sans .text-7xl .leading-4.capsize::before, .text-7xl .font-sans.leading-4.capsize::before, .text-7xl .font-sans .leading-4.capsize::before {
  content: '';
  margin-bottom: 0.2319em;
  display: table;
}
.font-sans.text-7xl.leading-4.capsize::after, .font-sans .text-7xl.leading-4.capsize::after, .font-sans .text-7xl .leading-4.capsize::after, .text-7xl .font-sans.leading-4.capsize::after, .text-7xl .font-sans .leading-4.capsize::after {
  content: '';
  margin-top: 0.2759em;
  display: table;
}
.font-sans.text-7xl.leading-5.capsize::before, .font-sans .text-7xl.leading-5.capsize::before, .font-sans .text-7xl .leading-5.capsize::before, .text-7xl .font-sans.leading-5.capsize::before, .text-7xl .font-sans .leading-5.capsize::before {
  content: '';
  margin-bottom: 0.2041em;
  display: table;
}
.font-sans.text-7xl.leading-5.capsize::after, .font-sans .text-7xl.leading-5.capsize::after, .font-sans .text-7xl .leading-5.capsize::after, .text-7xl .font-sans.leading-5.capsize::after, .text-7xl .font-sans .leading-5.capsize::after {
  content: '';
  margin-top: 0.2481em;
  display: table;
}
.font-sans.text-7xl.leading-6.capsize::before, .font-sans .text-7xl.leading-6.capsize::before, .font-sans .text-7xl .leading-6.capsize::before, .text-7xl .font-sans.leading-6.capsize::before, .text-7xl .font-sans .leading-6.capsize::before {
  content: '';
  margin-bottom: 0.1763em;
  display: table;
}
.font-sans.text-7xl.leading-6.capsize::after, .font-sans .text-7xl.leading-6.capsize::after, .font-sans .text-7xl .leading-6.capsize::after, .text-7xl .font-sans.leading-6.capsize::after, .text-7xl .font-sans .leading-6.capsize::after {
  content: '';
  margin-top: 0.2203em;
  display: table;
}
.font-sans.text-7xl.leading-7.capsize::before, .font-sans .text-7xl.leading-7.capsize::before, .font-sans .text-7xl .leading-7.capsize::before, .text-7xl .font-sans.leading-7.capsize::before, .text-7xl .font-sans .leading-7.capsize::before {
  content: '';
  margin-bottom: 0.1486em;
  display: table;
}
.font-sans.text-7xl.leading-7.capsize::after, .font-sans .text-7xl.leading-7.capsize::after, .font-sans .text-7xl .leading-7.capsize::after, .text-7xl .font-sans.leading-7.capsize::after, .text-7xl .font-sans .leading-7.capsize::after {
  content: '';
  margin-top: 0.1926em;
  display: table;
}
.font-sans.text-7xl.leading-8.capsize::before, .font-sans .text-7xl.leading-8.capsize::before, .font-sans .text-7xl .leading-8.capsize::before, .text-7xl .font-sans.leading-8.capsize::before, .text-7xl .font-sans .leading-8.capsize::before {
  content: '';
  margin-bottom: 0.1208em;
  display: table;
}
.font-sans.text-7xl.leading-8.capsize::after, .font-sans .text-7xl.leading-8.capsize::after, .font-sans .text-7xl .leading-8.capsize::after, .text-7xl .font-sans.leading-8.capsize::after, .text-7xl .font-sans .leading-8.capsize::after {
  content: '';
  margin-top: 0.1648em;
  display: table;
}
.font-sans.text-7xl.leading-9.capsize::before, .font-sans .text-7xl.leading-9.capsize::before, .font-sans .text-7xl .leading-9.capsize::before, .text-7xl .font-sans.leading-9.capsize::before, .text-7xl .font-sans .leading-9.capsize::before {
  content: '';
  margin-bottom: 0.093em;
  display: table;
}
.font-sans.text-7xl.leading-9.capsize::after, .font-sans .text-7xl.leading-9.capsize::after, .font-sans .text-7xl .leading-9.capsize::after, .text-7xl .font-sans.leading-9.capsize::after, .text-7xl .font-sans .leading-9.capsize::after {
  content: '';
  margin-top: 0.137em;
  display: table;
}
.font-sans.text-7xl.leading-10.capsize::before, .font-sans .text-7xl.leading-10.capsize::before, .font-sans .text-7xl .leading-10.capsize::before, .text-7xl .font-sans.leading-10.capsize::before, .text-7xl .font-sans .leading-10.capsize::before {
  content: '';
  margin-bottom: 0.0652em;
  display: table;
}
.font-sans.text-7xl.leading-10.capsize::after, .font-sans .text-7xl.leading-10.capsize::after, .font-sans .text-7xl .leading-10.capsize::after, .text-7xl .font-sans.leading-10.capsize::after, .text-7xl .font-sans .leading-10.capsize::after {
  content: '';
  margin-top: 0.1092em;
  display: table;
}
.font-sans.text-7xl.leading-none.capsize::before, .font-sans .text-7xl.leading-none.capsize::before, .font-sans .text-7xl .leading-none.capsize::before, .text-7xl .font-sans.leading-none.capsize::before, .text-7xl .font-sans .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-7xl.leading-none.capsize::after, .font-sans .text-7xl.leading-none.capsize::after, .font-sans .text-7xl .leading-none.capsize::after, .text-7xl .font-sans.leading-none.capsize::after, .text-7xl .font-sans .leading-none.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-7xl.leading-tight.capsize::before, .font-sans .text-7xl.leading-tight.capsize::before, .font-sans .text-7xl .leading-tight.capsize::before, .text-7xl .font-sans.leading-tight.capsize::before, .text-7xl .font-sans .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.282em;
  display: table;
}
.font-sans.text-7xl.leading-tight.capsize::after, .font-sans .text-7xl.leading-tight.capsize::after, .font-sans .text-7xl .leading-tight.capsize::after, .text-7xl .font-sans.leading-tight.capsize::after, .text-7xl .font-sans .leading-tight.capsize::after {
  content: '';
  margin-top: -0.238em;
  display: table;
}
.font-sans.text-7xl.leading-snug.capsize::before, .font-sans .text-7xl.leading-snug.capsize::before, .font-sans .text-7xl .leading-snug.capsize::before, .text-7xl .font-sans.leading-snug.capsize::before, .text-7xl .font-sans .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3445em;
  display: table;
}
.font-sans.text-7xl.leading-snug.capsize::after, .font-sans .text-7xl.leading-snug.capsize::after, .font-sans .text-7xl .leading-snug.capsize::after, .text-7xl .font-sans.leading-snug.capsize::after, .text-7xl .font-sans .leading-snug.capsize::after {
  content: '';
  margin-top: -0.3005em;
  display: table;
}
.font-sans.text-7xl.leading-normal.capsize::before, .font-sans .text-7xl.leading-normal.capsize::before, .font-sans .text-7xl .leading-normal.capsize::before, .text-7xl .font-sans.leading-normal.capsize::before, .text-7xl .font-sans .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.407em;
  display: table;
}
.font-sans.text-7xl.leading-normal.capsize::after, .font-sans .text-7xl.leading-normal.capsize::after, .font-sans .text-7xl .leading-normal.capsize::after, .text-7xl .font-sans.leading-normal.capsize::after, .text-7xl .font-sans .leading-normal.capsize::after {
  content: '';
  margin-top: -0.363em;
  display: table;
}
.font-sans.text-7xl.leading-relaxed.capsize::before, .font-sans .text-7xl.leading-relaxed.capsize::before, .font-sans .text-7xl .leading-relaxed.capsize::before, .text-7xl .font-sans.leading-relaxed.capsize::before, .text-7xl .font-sans .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4695em;
  display: table;
}
.font-sans.text-7xl.leading-relaxed.capsize::after, .font-sans .text-7xl.leading-relaxed.capsize::after, .font-sans .text-7xl .leading-relaxed.capsize::after, .text-7xl .font-sans.leading-relaxed.capsize::after, .text-7xl .font-sans .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4255em;
  display: table;
}
.font-sans.text-7xl.leading-loose.capsize::before, .font-sans .text-7xl.leading-loose.capsize::before, .font-sans .text-7xl .leading-loose.capsize::before, .text-7xl .font-sans.leading-loose.capsize::before, .text-7xl .font-sans .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans.text-7xl.leading-loose.capsize::after, .font-sans .text-7xl.leading-loose.capsize::after, .font-sans .text-7xl .leading-loose.capsize::after, .text-7xl .font-sans.leading-loose.capsize::after, .text-7xl .font-sans .leading-loose.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-sans.text-8xl.leading-3.capsize::before, .font-sans .text-8xl.leading-3.capsize::before, .font-sans .text-8xl .leading-3.capsize::before, .text-8xl .font-sans.leading-3.capsize::before, .text-8xl .font-sans .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.2805em;
  display: table;
}
.font-sans.text-8xl.leading-3.capsize::after, .font-sans .text-8xl.leading-3.capsize::after, .font-sans .text-8xl .leading-3.capsize::after, .text-8xl .font-sans.leading-3.capsize::after, .text-8xl .font-sans .leading-3.capsize::after {
  content: '';
  margin-top: 0.3245em;
  display: table;
}
.font-sans.text-8xl.leading-4.capsize::before, .font-sans .text-8xl.leading-4.capsize::before, .font-sans .text-8xl .leading-4.capsize::before, .text-8xl .font-sans.leading-4.capsize::before, .text-8xl .font-sans .leading-4.capsize::before {
  content: '';
  margin-bottom: 0.2597em;
  display: table;
}
.font-sans.text-8xl.leading-4.capsize::after, .font-sans .text-8xl.leading-4.capsize::after, .font-sans .text-8xl .leading-4.capsize::after, .text-8xl .font-sans.leading-4.capsize::after, .text-8xl .font-sans .leading-4.capsize::after {
  content: '';
  margin-top: 0.3037em;
  display: table;
}
.font-sans.text-8xl.leading-5.capsize::before, .font-sans .text-8xl.leading-5.capsize::before, .font-sans .text-8xl .leading-5.capsize::before, .text-8xl .font-sans.leading-5.capsize::before, .text-8xl .font-sans .leading-5.capsize::before {
  content: '';
  margin-bottom: 0.2388em;
  display: table;
}
.font-sans.text-8xl.leading-5.capsize::after, .font-sans .text-8xl.leading-5.capsize::after, .font-sans .text-8xl .leading-5.capsize::after, .text-8xl .font-sans.leading-5.capsize::after, .text-8xl .font-sans .leading-5.capsize::after {
  content: '';
  margin-top: 0.2828em;
  display: table;
}
.font-sans.text-8xl.leading-6.capsize::before, .font-sans .text-8xl.leading-6.capsize::before, .font-sans .text-8xl .leading-6.capsize::before, .text-8xl .font-sans.leading-6.capsize::before, .text-8xl .font-sans .leading-6.capsize::before {
  content: '';
  margin-bottom: 0.218em;
  display: table;
}
.font-sans.text-8xl.leading-6.capsize::after, .font-sans .text-8xl.leading-6.capsize::after, .font-sans .text-8xl .leading-6.capsize::after, .text-8xl .font-sans.leading-6.capsize::after, .text-8xl .font-sans .leading-6.capsize::after {
  content: '';
  margin-top: 0.262em;
  display: table;
}
.font-sans.text-8xl.leading-7.capsize::before, .font-sans .text-8xl.leading-7.capsize::before, .font-sans .text-8xl .leading-7.capsize::before, .text-8xl .font-sans.leading-7.capsize::before, .text-8xl .font-sans .leading-7.capsize::before {
  content: '';
  margin-bottom: 0.1972em;
  display: table;
}
.font-sans.text-8xl.leading-7.capsize::after, .font-sans .text-8xl.leading-7.capsize::after, .font-sans .text-8xl .leading-7.capsize::after, .text-8xl .font-sans.leading-7.capsize::after, .text-8xl .font-sans .leading-7.capsize::after {
  content: '';
  margin-top: 0.2412em;
  display: table;
}
.font-sans.text-8xl.leading-8.capsize::before, .font-sans .text-8xl.leading-8.capsize::before, .font-sans .text-8xl .leading-8.capsize::before, .text-8xl .font-sans.leading-8.capsize::before, .text-8xl .font-sans .leading-8.capsize::before {
  content: '';
  margin-bottom: 0.1763em;
  display: table;
}
.font-sans.text-8xl.leading-8.capsize::after, .font-sans .text-8xl.leading-8.capsize::after, .font-sans .text-8xl .leading-8.capsize::after, .text-8xl .font-sans.leading-8.capsize::after, .text-8xl .font-sans .leading-8.capsize::after {
  content: '';
  margin-top: 0.2203em;
  display: table;
}
.font-sans.text-8xl.leading-9.capsize::before, .font-sans .text-8xl.leading-9.capsize::before, .font-sans .text-8xl .leading-9.capsize::before, .text-8xl .font-sans.leading-9.capsize::before, .text-8xl .font-sans .leading-9.capsize::before {
  content: '';
  margin-bottom: 0.1555em;
  display: table;
}
.font-sans.text-8xl.leading-9.capsize::after, .font-sans .text-8xl.leading-9.capsize::after, .font-sans .text-8xl .leading-9.capsize::after, .text-8xl .font-sans.leading-9.capsize::after, .text-8xl .font-sans .leading-9.capsize::after {
  content: '';
  margin-top: 0.1995em;
  display: table;
}
.font-sans.text-8xl.leading-10.capsize::before, .font-sans .text-8xl.leading-10.capsize::before, .font-sans .text-8xl .leading-10.capsize::before, .text-8xl .font-sans.leading-10.capsize::before, .text-8xl .font-sans .leading-10.capsize::before {
  content: '';
  margin-bottom: 0.1347em;
  display: table;
}
.font-sans.text-8xl.leading-10.capsize::after, .font-sans .text-8xl.leading-10.capsize::after, .font-sans .text-8xl .leading-10.capsize::after, .text-8xl .font-sans.leading-10.capsize::after, .text-8xl .font-sans .leading-10.capsize::after {
  content: '';
  margin-top: 0.1787em;
  display: table;
}
.font-sans.text-8xl.leading-none.capsize::before, .font-sans .text-8xl.leading-none.capsize::before, .font-sans .text-8xl .leading-none.capsize::before, .text-8xl .font-sans.leading-none.capsize::before, .text-8xl .font-sans .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-8xl.leading-none.capsize::after, .font-sans .text-8xl.leading-none.capsize::after, .font-sans .text-8xl .leading-none.capsize::after, .text-8xl .font-sans.leading-none.capsize::after, .text-8xl .font-sans .leading-none.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-8xl.leading-tight.capsize::before, .font-sans .text-8xl.leading-tight.capsize::before, .font-sans .text-8xl .leading-tight.capsize::before, .text-8xl .font-sans.leading-tight.capsize::before, .text-8xl .font-sans .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.282em;
  display: table;
}
.font-sans.text-8xl.leading-tight.capsize::after, .font-sans .text-8xl.leading-tight.capsize::after, .font-sans .text-8xl .leading-tight.capsize::after, .text-8xl .font-sans.leading-tight.capsize::after, .text-8xl .font-sans .leading-tight.capsize::after {
  content: '';
  margin-top: -0.238em;
  display: table;
}
.font-sans.text-8xl.leading-snug.capsize::before, .font-sans .text-8xl.leading-snug.capsize::before, .font-sans .text-8xl .leading-snug.capsize::before, .text-8xl .font-sans.leading-snug.capsize::before, .text-8xl .font-sans .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3445em;
  display: table;
}
.font-sans.text-8xl.leading-snug.capsize::after, .font-sans .text-8xl.leading-snug.capsize::after, .font-sans .text-8xl .leading-snug.capsize::after, .text-8xl .font-sans.leading-snug.capsize::after, .text-8xl .font-sans .leading-snug.capsize::after {
  content: '';
  margin-top: -0.3005em;
  display: table;
}
.font-sans.text-8xl.leading-normal.capsize::before, .font-sans .text-8xl.leading-normal.capsize::before, .font-sans .text-8xl .leading-normal.capsize::before, .text-8xl .font-sans.leading-normal.capsize::before, .text-8xl .font-sans .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.407em;
  display: table;
}
.font-sans.text-8xl.leading-normal.capsize::after, .font-sans .text-8xl.leading-normal.capsize::after, .font-sans .text-8xl .leading-normal.capsize::after, .text-8xl .font-sans.leading-normal.capsize::after, .text-8xl .font-sans .leading-normal.capsize::after {
  content: '';
  margin-top: -0.363em;
  display: table;
}
.font-sans.text-8xl.leading-relaxed.capsize::before, .font-sans .text-8xl.leading-relaxed.capsize::before, .font-sans .text-8xl .leading-relaxed.capsize::before, .text-8xl .font-sans.leading-relaxed.capsize::before, .text-8xl .font-sans .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4695em;
  display: table;
}
.font-sans.text-8xl.leading-relaxed.capsize::after, .font-sans .text-8xl.leading-relaxed.capsize::after, .font-sans .text-8xl .leading-relaxed.capsize::after, .text-8xl .font-sans.leading-relaxed.capsize::after, .text-8xl .font-sans .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4255em;
  display: table;
}
.font-sans.text-8xl.leading-loose.capsize::before, .font-sans .text-8xl.leading-loose.capsize::before, .font-sans .text-8xl .leading-loose.capsize::before, .text-8xl .font-sans.leading-loose.capsize::before, .text-8xl .font-sans .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans.text-8xl.leading-loose.capsize::after, .font-sans .text-8xl.leading-loose.capsize::after, .font-sans .text-8xl .leading-loose.capsize::after, .text-8xl .font-sans.leading-loose.capsize::after, .text-8xl .font-sans .leading-loose.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-sans.text-9xl.leading-3.capsize::before, .font-sans .text-9xl.leading-3.capsize::before, .font-sans .text-9xl .leading-3.capsize::before, .text-9xl .font-sans.leading-3.capsize::before, .text-9xl .font-sans .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.2961em;
  display: table;
}
.font-sans.text-9xl.leading-3.capsize::after, .font-sans .text-9xl.leading-3.capsize::after, .font-sans .text-9xl .leading-3.capsize::after, .text-9xl .font-sans.leading-3.capsize::after, .text-9xl .font-sans .leading-3.capsize::after {
  content: '';
  margin-top: 0.3401em;
  display: table;
}
.font-sans.text-9xl.leading-4.capsize::before, .font-sans .text-9xl.leading-4.capsize::before, .font-sans .text-9xl .leading-4.capsize::before, .text-9xl .font-sans.leading-4.capsize::before, .text-9xl .font-sans .leading-4.capsize::before {
  content: '';
  margin-bottom: 0.2805em;
  display: table;
}
.font-sans.text-9xl.leading-4.capsize::after, .font-sans .text-9xl.leading-4.capsize::after, .font-sans .text-9xl .leading-4.capsize::after, .text-9xl .font-sans.leading-4.capsize::after, .text-9xl .font-sans .leading-4.capsize::after {
  content: '';
  margin-top: 0.3245em;
  display: table;
}
.font-sans.text-9xl.leading-5.capsize::before, .font-sans .text-9xl.leading-5.capsize::before, .font-sans .text-9xl .leading-5.capsize::before, .text-9xl .font-sans.leading-5.capsize::before, .text-9xl .font-sans .leading-5.capsize::before {
  content: '';
  margin-bottom: 0.2649em;
  display: table;
}
.font-sans.text-9xl.leading-5.capsize::after, .font-sans .text-9xl.leading-5.capsize::after, .font-sans .text-9xl .leading-5.capsize::after, .text-9xl .font-sans.leading-5.capsize::after, .text-9xl .font-sans .leading-5.capsize::after {
  content: '';
  margin-top: 0.3089em;
  display: table;
}
.font-sans.text-9xl.leading-6.capsize::before, .font-sans .text-9xl.leading-6.capsize::before, .font-sans .text-9xl .leading-6.capsize::before, .text-9xl .font-sans.leading-6.capsize::before, .text-9xl .font-sans .leading-6.capsize::before {
  content: '';
  margin-bottom: 0.2493em;
  display: table;
}
.font-sans.text-9xl.leading-6.capsize::after, .font-sans .text-9xl.leading-6.capsize::after, .font-sans .text-9xl .leading-6.capsize::after, .text-9xl .font-sans.leading-6.capsize::after, .text-9xl .font-sans .leading-6.capsize::after {
  content: '';
  margin-top: 0.2933em;
  display: table;
}
.font-sans.text-9xl.leading-7.capsize::before, .font-sans .text-9xl.leading-7.capsize::before, .font-sans .text-9xl .leading-7.capsize::before, .text-9xl .font-sans.leading-7.capsize::before, .text-9xl .font-sans .leading-7.capsize::before {
  content: '';
  margin-bottom: 0.2336em;
  display: table;
}
.font-sans.text-9xl.leading-7.capsize::after, .font-sans .text-9xl.leading-7.capsize::after, .font-sans .text-9xl .leading-7.capsize::after, .text-9xl .font-sans.leading-7.capsize::after, .text-9xl .font-sans .leading-7.capsize::after {
  content: '';
  margin-top: 0.2776em;
  display: table;
}
.font-sans.text-9xl.leading-8.capsize::before, .font-sans .text-9xl.leading-8.capsize::before, .font-sans .text-9xl .leading-8.capsize::before, .text-9xl .font-sans.leading-8.capsize::before, .text-9xl .font-sans .leading-8.capsize::before {
  content: '';
  margin-bottom: 0.218em;
  display: table;
}
.font-sans.text-9xl.leading-8.capsize::after, .font-sans .text-9xl.leading-8.capsize::after, .font-sans .text-9xl .leading-8.capsize::after, .text-9xl .font-sans.leading-8.capsize::after, .text-9xl .font-sans .leading-8.capsize::after {
  content: '';
  margin-top: 0.262em;
  display: table;
}
.font-sans.text-9xl.leading-9.capsize::before, .font-sans .text-9xl.leading-9.capsize::before, .font-sans .text-9xl .leading-9.capsize::before, .text-9xl .font-sans.leading-9.capsize::before, .text-9xl .font-sans .leading-9.capsize::before {
  content: '';
  margin-bottom: 0.2024em;
  display: table;
}
.font-sans.text-9xl.leading-9.capsize::after, .font-sans .text-9xl.leading-9.capsize::after, .font-sans .text-9xl .leading-9.capsize::after, .text-9xl .font-sans.leading-9.capsize::after, .text-9xl .font-sans .leading-9.capsize::after {
  content: '';
  margin-top: 0.2464em;
  display: table;
}
.font-sans.text-9xl.leading-10.capsize::before, .font-sans .text-9xl.leading-10.capsize::before, .font-sans .text-9xl .leading-10.capsize::before, .text-9xl .font-sans.leading-10.capsize::before, .text-9xl .font-sans .leading-10.capsize::before {
  content: '';
  margin-bottom: 0.1868em;
  display: table;
}
.font-sans.text-9xl.leading-10.capsize::after, .font-sans .text-9xl.leading-10.capsize::after, .font-sans .text-9xl .leading-10.capsize::after, .text-9xl .font-sans.leading-10.capsize::after, .text-9xl .font-sans .leading-10.capsize::after {
  content: '';
  margin-top: 0.2308em;
  display: table;
}
.font-sans.text-9xl.leading-none.capsize::before, .font-sans .text-9xl.leading-none.capsize::before, .font-sans .text-9xl .leading-none.capsize::before, .text-9xl .font-sans.leading-none.capsize::before, .text-9xl .font-sans .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-9xl.leading-none.capsize::after, .font-sans .text-9xl.leading-none.capsize::after, .font-sans .text-9xl .leading-none.capsize::after, .text-9xl .font-sans.leading-none.capsize::after, .text-9xl .font-sans .leading-none.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-9xl.leading-tight.capsize::before, .font-sans .text-9xl.leading-tight.capsize::before, .font-sans .text-9xl .leading-tight.capsize::before, .text-9xl .font-sans.leading-tight.capsize::before, .text-9xl .font-sans .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.282em;
  display: table;
}
.font-sans.text-9xl.leading-tight.capsize::after, .font-sans .text-9xl.leading-tight.capsize::after, .font-sans .text-9xl .leading-tight.capsize::after, .text-9xl .font-sans.leading-tight.capsize::after, .text-9xl .font-sans .leading-tight.capsize::after {
  content: '';
  margin-top: -0.238em;
  display: table;
}
.font-sans.text-9xl.leading-snug.capsize::before, .font-sans .text-9xl.leading-snug.capsize::before, .font-sans .text-9xl .leading-snug.capsize::before, .text-9xl .font-sans.leading-snug.capsize::before, .text-9xl .font-sans .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3445em;
  display: table;
}
.font-sans.text-9xl.leading-snug.capsize::after, .font-sans .text-9xl.leading-snug.capsize::after, .font-sans .text-9xl .leading-snug.capsize::after, .text-9xl .font-sans.leading-snug.capsize::after, .text-9xl .font-sans .leading-snug.capsize::after {
  content: '';
  margin-top: -0.3005em;
  display: table;
}
.font-sans.text-9xl.leading-normal.capsize::before, .font-sans .text-9xl.leading-normal.capsize::before, .font-sans .text-9xl .leading-normal.capsize::before, .text-9xl .font-sans.leading-normal.capsize::before, .text-9xl .font-sans .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.407em;
  display: table;
}
.font-sans.text-9xl.leading-normal.capsize::after, .font-sans .text-9xl.leading-normal.capsize::after, .font-sans .text-9xl .leading-normal.capsize::after, .text-9xl .font-sans.leading-normal.capsize::after, .text-9xl .font-sans .leading-normal.capsize::after {
  content: '';
  margin-top: -0.363em;
  display: table;
}
.font-sans.text-9xl.leading-relaxed.capsize::before, .font-sans .text-9xl.leading-relaxed.capsize::before, .font-sans .text-9xl .leading-relaxed.capsize::before, .text-9xl .font-sans.leading-relaxed.capsize::before, .text-9xl .font-sans .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4695em;
  display: table;
}
.font-sans.text-9xl.leading-relaxed.capsize::after, .font-sans .text-9xl.leading-relaxed.capsize::after, .font-sans .text-9xl .leading-relaxed.capsize::after, .text-9xl .font-sans.leading-relaxed.capsize::after, .text-9xl .font-sans .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4255em;
  display: table;
}
.font-sans.text-9xl.leading-loose.capsize::before, .font-sans .text-9xl.leading-loose.capsize::before, .font-sans .text-9xl .leading-loose.capsize::before, .text-9xl .font-sans.leading-loose.capsize::before, .text-9xl .font-sans .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans.text-9xl.leading-loose.capsize::after, .font-sans .text-9xl.leading-loose.capsize::after, .font-sans .text-9xl .leading-loose.capsize::after, .text-9xl .font-sans.leading-loose.capsize::after, .text-9xl .font-sans .leading-loose.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-sans.text-1xl.leading-3.capsize::before, .font-sans .text-1xl.leading-3.capsize::before, .font-sans .text-1xl .leading-3.capsize::before, .text-1xl .font-sans.leading-3.capsize::before, .text-1xl .font-sans .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.0703em;
  display: table;
}
.font-sans.text-1xl.leading-3.capsize::after, .font-sans .text-1xl.leading-3.capsize::after, .font-sans .text-1xl .leading-3.capsize::after, .text-1xl .font-sans.leading-3.capsize::after, .text-1xl .font-sans .leading-3.capsize::after {
  content: '';
  margin-top: 0.1143em;
  display: table;
}
.font-sans.text-1xl.leading-4.capsize::before, .font-sans .text-1xl.leading-4.capsize::before, .font-sans .text-1xl .leading-4.capsize::before, .text-1xl .font-sans.leading-4.capsize::before, .text-1xl .font-sans .leading-4.capsize::before {
  content: '';
  margin-bottom: -0.0206em;
  display: table;
}
.font-sans.text-1xl.leading-4.capsize::after, .font-sans .text-1xl.leading-4.capsize::after, .font-sans .text-1xl .leading-4.capsize::after, .text-1xl .font-sans.leading-4.capsize::after, .text-1xl .font-sans .leading-4.capsize::after {
  content: '';
  margin-top: 0.0234em;
  display: table;
}
.font-sans.text-1xl.leading-5.capsize::before, .font-sans .text-1xl.leading-5.capsize::before, .font-sans .text-1xl .leading-5.capsize::before, .text-1xl .font-sans.leading-5.capsize::before, .text-1xl .font-sans .leading-5.capsize::before {
  content: '';
  margin-bottom: -0.1115em;
  display: table;
}
.font-sans.text-1xl.leading-5.capsize::after, .font-sans .text-1xl.leading-5.capsize::after, .font-sans .text-1xl .leading-5.capsize::after, .text-1xl .font-sans.leading-5.capsize::after, .text-1xl .font-sans .leading-5.capsize::after {
  content: '';
  margin-top: -0.0675em;
  display: table;
}
.font-sans.text-1xl.leading-6.capsize::before, .font-sans .text-1xl.leading-6.capsize::before, .font-sans .text-1xl .leading-6.capsize::before, .text-1xl .font-sans.leading-6.capsize::before, .text-1xl .font-sans .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.2025em;
  display: table;
}
.font-sans.text-1xl.leading-6.capsize::after, .font-sans .text-1xl.leading-6.capsize::after, .font-sans .text-1xl .leading-6.capsize::after, .text-1xl .font-sans.leading-6.capsize::after, .text-1xl .font-sans .leading-6.capsize::after {
  content: '';
  margin-top: -0.1585em;
  display: table;
}
.font-sans.text-1xl.leading-7.capsize::before, .font-sans .text-1xl.leading-7.capsize::before, .font-sans .text-1xl .leading-7.capsize::before, .text-1xl .font-sans.leading-7.capsize::before, .text-1xl .font-sans .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.2934em;
  display: table;
}
.font-sans.text-1xl.leading-7.capsize::after, .font-sans .text-1xl.leading-7.capsize::after, .font-sans .text-1xl .leading-7.capsize::after, .text-1xl .font-sans.leading-7.capsize::after, .text-1xl .font-sans .leading-7.capsize::after {
  content: '';
  margin-top: -0.2494em;
  display: table;
}
.font-sans.text-1xl.leading-8.capsize::before, .font-sans .text-1xl.leading-8.capsize::before, .font-sans .text-1xl .leading-8.capsize::before, .text-1xl .font-sans.leading-8.capsize::before, .text-1xl .font-sans .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.3843em;
  display: table;
}
.font-sans.text-1xl.leading-8.capsize::after, .font-sans .text-1xl.leading-8.capsize::after, .font-sans .text-1xl .leading-8.capsize::after, .text-1xl .font-sans.leading-8.capsize::after, .text-1xl .font-sans .leading-8.capsize::after {
  content: '';
  margin-top: -0.3403em;
  display: table;
}
.font-sans.text-1xl.leading-9.capsize::before, .font-sans .text-1xl.leading-9.capsize::before, .font-sans .text-1xl .leading-9.capsize::before, .text-1xl .font-sans.leading-9.capsize::before, .text-1xl .font-sans .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.4752em;
  display: table;
}
.font-sans.text-1xl.leading-9.capsize::after, .font-sans .text-1xl.leading-9.capsize::after, .font-sans .text-1xl .leading-9.capsize::after, .text-1xl .font-sans.leading-9.capsize::after, .text-1xl .font-sans .leading-9.capsize::after {
  content: '';
  margin-top: -0.4312em;
  display: table;
}
.font-sans.text-1xl.leading-10.capsize::before, .font-sans .text-1xl.leading-10.capsize::before, .font-sans .text-1xl .leading-10.capsize::before, .text-1xl .font-sans.leading-10.capsize::before, .text-1xl .font-sans .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.5661em;
  display: table;
}
.font-sans.text-1xl.leading-10.capsize::after, .font-sans .text-1xl.leading-10.capsize::after, .font-sans .text-1xl .leading-10.capsize::after, .text-1xl .font-sans.leading-10.capsize::after, .text-1xl .font-sans .leading-10.capsize::after {
  content: '';
  margin-top: -0.5221em;
  display: table;
}
.font-sans.text-1xl.leading-none.capsize::before, .font-sans .text-1xl.leading-none.capsize::before, .font-sans .text-1xl .leading-none.capsize::before, .text-1xl .font-sans.leading-none.capsize::before, .text-1xl .font-sans .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-1xl.leading-none.capsize::after, .font-sans .text-1xl.leading-none.capsize::after, .font-sans .text-1xl .leading-none.capsize::after, .text-1xl .font-sans.leading-none.capsize::after, .text-1xl .font-sans .leading-none.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-1xl.leading-tight.capsize::before, .font-sans .text-1xl.leading-tight.capsize::before, .font-sans .text-1xl .leading-tight.capsize::before, .text-1xl .font-sans.leading-tight.capsize::before, .text-1xl .font-sans .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.282em;
  display: table;
}
.font-sans.text-1xl.leading-tight.capsize::after, .font-sans .text-1xl.leading-tight.capsize::after, .font-sans .text-1xl .leading-tight.capsize::after, .text-1xl .font-sans.leading-tight.capsize::after, .text-1xl .font-sans .leading-tight.capsize::after {
  content: '';
  margin-top: -0.238em;
  display: table;
}
.font-sans.text-1xl.leading-snug.capsize::before, .font-sans .text-1xl.leading-snug.capsize::before, .font-sans .text-1xl .leading-snug.capsize::before, .text-1xl .font-sans.leading-snug.capsize::before, .text-1xl .font-sans .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3445em;
  display: table;
}
.font-sans.text-1xl.leading-snug.capsize::after, .font-sans .text-1xl.leading-snug.capsize::after, .font-sans .text-1xl .leading-snug.capsize::after, .text-1xl .font-sans.leading-snug.capsize::after, .text-1xl .font-sans .leading-snug.capsize::after {
  content: '';
  margin-top: -0.3005em;
  display: table;
}
.font-sans.text-1xl.leading-normal.capsize::before, .font-sans .text-1xl.leading-normal.capsize::before, .font-sans .text-1xl .leading-normal.capsize::before, .text-1xl .font-sans.leading-normal.capsize::before, .text-1xl .font-sans .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.407em;
  display: table;
}
.font-sans.text-1xl.leading-normal.capsize::after, .font-sans .text-1xl.leading-normal.capsize::after, .font-sans .text-1xl .leading-normal.capsize::after, .text-1xl .font-sans.leading-normal.capsize::after, .text-1xl .font-sans .leading-normal.capsize::after {
  content: '';
  margin-top: -0.363em;
  display: table;
}
.font-sans.text-1xl.leading-relaxed.capsize::before, .font-sans .text-1xl.leading-relaxed.capsize::before, .font-sans .text-1xl .leading-relaxed.capsize::before, .text-1xl .font-sans.leading-relaxed.capsize::before, .text-1xl .font-sans .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4695em;
  display: table;
}
.font-sans.text-1xl.leading-relaxed.capsize::after, .font-sans .text-1xl.leading-relaxed.capsize::after, .font-sans .text-1xl .leading-relaxed.capsize::after, .text-1xl .font-sans.leading-relaxed.capsize::after, .text-1xl .font-sans .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4255em;
  display: table;
}
.font-sans.text-1xl.leading-loose.capsize::before, .font-sans .text-1xl.leading-loose.capsize::before, .font-sans .text-1xl .leading-loose.capsize::before, .text-1xl .font-sans.leading-loose.capsize::before, .text-1xl .font-sans .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans.text-1xl.leading-loose.capsize::after, .font-sans .text-1xl.leading-loose.capsize::after, .font-sans .text-1xl .leading-loose.capsize::after, .text-1xl .font-sans.leading-loose.capsize::after, .text-1xl .font-sans .leading-loose.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-sans.text-3.3xl.leading-3.capsize::before, .font-sans .text-3.3xl.leading-3.capsize::before, .font-sans .text-3.3xl .leading-3.capsize::before, .text-3.3xl .font-sans.leading-3.capsize::before, .text-3.3xl .font-sans .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.1555em;
  display: table;
}
.font-sans.text-3.3xl.leading-3.capsize::after, .font-sans .text-3.3xl.leading-3.capsize::after, .font-sans .text-3.3xl .leading-3.capsize::after, .text-3.3xl .font-sans.leading-3.capsize::after, .text-3.3xl .font-sans .leading-3.capsize::after {
  content: '';
  margin-top: 0.1995em;
  display: table;
}
.font-sans.text-3.3xl.leading-4.capsize::before, .font-sans .text-3.3xl.leading-4.capsize::before, .font-sans .text-3.3xl .leading-4.capsize::before, .text-3.3xl .font-sans.leading-4.capsize::before, .text-3.3xl .font-sans .leading-4.capsize::before {
  content: '';
  margin-bottom: 0.093em;
  display: table;
}
.font-sans.text-3.3xl.leading-4.capsize::after, .font-sans .text-3.3xl.leading-4.capsize::after, .font-sans .text-3.3xl .leading-4.capsize::after, .text-3.3xl .font-sans.leading-4.capsize::after, .text-3.3xl .font-sans .leading-4.capsize::after {
  content: '';
  margin-top: 0.137em;
  display: table;
}
.font-sans.text-3.3xl.leading-5.capsize::before, .font-sans .text-3.3xl.leading-5.capsize::before, .font-sans .text-3.3xl .leading-5.capsize::before, .text-3.3xl .font-sans.leading-5.capsize::before, .text-3.3xl .font-sans .leading-5.capsize::before {
  content: '';
  margin-bottom: 0.0305em;
  display: table;
}
.font-sans.text-3.3xl.leading-5.capsize::after, .font-sans .text-3.3xl.leading-5.capsize::after, .font-sans .text-3.3xl .leading-5.capsize::after, .text-3.3xl .font-sans.leading-5.capsize::after, .text-3.3xl .font-sans .leading-5.capsize::after {
  content: '';
  margin-top: 0.0745em;
  display: table;
}
.font-sans.text-3.3xl.leading-6.capsize::before, .font-sans .text-3.3xl.leading-6.capsize::before, .font-sans .text-3.3xl .leading-6.capsize::before, .text-3.3xl .font-sans.leading-6.capsize::before, .text-3.3xl .font-sans .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.032em;
  display: table;
}
.font-sans.text-3.3xl.leading-6.capsize::after, .font-sans .text-3.3xl.leading-6.capsize::after, .font-sans .text-3.3xl .leading-6.capsize::after, .text-3.3xl .font-sans.leading-6.capsize::after, .text-3.3xl .font-sans .leading-6.capsize::after {
  content: '';
  margin-top: 0.012em;
  display: table;
}
.font-sans.text-3.3xl.leading-7.capsize::before, .font-sans .text-3.3xl.leading-7.capsize::before, .font-sans .text-3.3xl .leading-7.capsize::before, .text-3.3xl .font-sans.leading-7.capsize::before, .text-3.3xl .font-sans .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.0945em;
  display: table;
}
.font-sans.text-3.3xl.leading-7.capsize::after, .font-sans .text-3.3xl.leading-7.capsize::after, .font-sans .text-3.3xl .leading-7.capsize::after, .text-3.3xl .font-sans.leading-7.capsize::after, .text-3.3xl .font-sans .leading-7.capsize::after {
  content: '';
  margin-top: -0.0505em;
  display: table;
}
.font-sans.text-3.3xl.leading-8.capsize::before, .font-sans .text-3.3xl.leading-8.capsize::before, .font-sans .text-3.3xl .leading-8.capsize::before, .text-3.3xl .font-sans.leading-8.capsize::before, .text-3.3xl .font-sans .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-3.3xl.leading-8.capsize::after, .font-sans .text-3.3xl.leading-8.capsize::after, .font-sans .text-3.3xl .leading-8.capsize::after, .text-3.3xl .font-sans.leading-8.capsize::after, .text-3.3xl .font-sans .leading-8.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-3.3xl.leading-9.capsize::before, .font-sans .text-3.3xl.leading-9.capsize::before, .font-sans .text-3.3xl .leading-9.capsize::before, .text-3.3xl .font-sans.leading-9.capsize::before, .text-3.3xl .font-sans .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.2195em;
  display: table;
}
.font-sans.text-3.3xl.leading-9.capsize::after, .font-sans .text-3.3xl.leading-9.capsize::after, .font-sans .text-3.3xl .leading-9.capsize::after, .text-3.3xl .font-sans.leading-9.capsize::after, .text-3.3xl .font-sans .leading-9.capsize::after {
  content: '';
  margin-top: -0.1755em;
  display: table;
}
.font-sans.text-3.3xl.leading-10.capsize::before, .font-sans .text-3.3xl.leading-10.capsize::before, .font-sans .text-3.3xl .leading-10.capsize::before, .text-3.3xl .font-sans.leading-10.capsize::before, .text-3.3xl .font-sans .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.282em;
  display: table;
}
.font-sans.text-3.3xl.leading-10.capsize::after, .font-sans .text-3.3xl.leading-10.capsize::after, .font-sans .text-3.3xl .leading-10.capsize::after, .text-3.3xl .font-sans.leading-10.capsize::after, .text-3.3xl .font-sans .leading-10.capsize::after {
  content: '';
  margin-top: -0.238em;
  display: table;
}
.font-sans.text-3.3xl.leading-none.capsize::before, .font-sans .text-3.3xl.leading-none.capsize::before, .font-sans .text-3.3xl .leading-none.capsize::before, .text-3.3xl .font-sans.leading-none.capsize::before, .text-3.3xl .font-sans .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-3.3xl.leading-none.capsize::after, .font-sans .text-3.3xl.leading-none.capsize::after, .font-sans .text-3.3xl .leading-none.capsize::after, .text-3.3xl .font-sans.leading-none.capsize::after, .text-3.3xl .font-sans .leading-none.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-3.3xl.leading-tight.capsize::before, .font-sans .text-3.3xl.leading-tight.capsize::before, .font-sans .text-3.3xl .leading-tight.capsize::before, .text-3.3xl .font-sans.leading-tight.capsize::before, .text-3.3xl .font-sans .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.282em;
  display: table;
}
.font-sans.text-3.3xl.leading-tight.capsize::after, .font-sans .text-3.3xl.leading-tight.capsize::after, .font-sans .text-3.3xl .leading-tight.capsize::after, .text-3.3xl .font-sans.leading-tight.capsize::after, .text-3.3xl .font-sans .leading-tight.capsize::after {
  content: '';
  margin-top: -0.238em;
  display: table;
}
.font-sans.text-3.3xl.leading-snug.capsize::before, .font-sans .text-3.3xl.leading-snug.capsize::before, .font-sans .text-3.3xl .leading-snug.capsize::before, .text-3.3xl .font-sans.leading-snug.capsize::before, .text-3.3xl .font-sans .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3445em;
  display: table;
}
.font-sans.text-3.3xl.leading-snug.capsize::after, .font-sans .text-3.3xl.leading-snug.capsize::after, .font-sans .text-3.3xl .leading-snug.capsize::after, .text-3.3xl .font-sans.leading-snug.capsize::after, .text-3.3xl .font-sans .leading-snug.capsize::after {
  content: '';
  margin-top: -0.3005em;
  display: table;
}
.font-sans.text-3.3xl.leading-normal.capsize::before, .font-sans .text-3.3xl.leading-normal.capsize::before, .font-sans .text-3.3xl .leading-normal.capsize::before, .text-3.3xl .font-sans.leading-normal.capsize::before, .text-3.3xl .font-sans .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.407em;
  display: table;
}
.font-sans.text-3.3xl.leading-normal.capsize::after, .font-sans .text-3.3xl.leading-normal.capsize::after, .font-sans .text-3.3xl .leading-normal.capsize::after, .text-3.3xl .font-sans.leading-normal.capsize::after, .text-3.3xl .font-sans .leading-normal.capsize::after {
  content: '';
  margin-top: -0.363em;
  display: table;
}
.font-sans.text-3.3xl.leading-relaxed.capsize::before, .font-sans .text-3.3xl.leading-relaxed.capsize::before, .font-sans .text-3.3xl .leading-relaxed.capsize::before, .text-3.3xl .font-sans.leading-relaxed.capsize::before, .text-3.3xl .font-sans .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4695em;
  display: table;
}
.font-sans.text-3.3xl.leading-relaxed.capsize::after, .font-sans .text-3.3xl.leading-relaxed.capsize::after, .font-sans .text-3.3xl .leading-relaxed.capsize::after, .text-3.3xl .font-sans.leading-relaxed.capsize::after, .text-3.3xl .font-sans .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4255em;
  display: table;
}
.font-sans.text-3.3xl.leading-loose.capsize::before, .font-sans .text-3.3xl.leading-loose.capsize::before, .font-sans .text-3.3xl .leading-loose.capsize::before, .text-3.3xl .font-sans.leading-loose.capsize::before, .text-3.3xl .font-sans .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans.text-3.3xl.leading-loose.capsize::after, .font-sans .text-3.3xl.leading-loose.capsize::after, .font-sans .text-3.3xl .leading-loose.capsize::after, .text-3.3xl .font-sans.leading-loose.capsize::after, .text-3.3xl .font-sans .leading-loose.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-serif.text-xs.leading-3.capsize::before, .font-serif .text-xs.leading-3.capsize::before, .font-serif .text-xs .leading-3.capsize::before, .text-xs .font-serif.leading-3.capsize::before, .text-xs .font-serif .leading-3.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.\\!text-xs.leading-3.capsize::before, .font-serif .\\!text-xs.leading-3.capsize::before, .font-serif .\\!text-xs .leading-3.capsize::before, .\\!text-xs .font-serif.leading-3.capsize::before, .\\!text-xs .font-serif .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: -0.12em !important;
  display: table !important;
}
.font-serif.text-xs.leading-3.capsize::after, .font-serif .text-xs.leading-3.capsize::after, .font-serif .text-xs .leading-3.capsize::after, .text-xs .font-serif.leading-3.capsize::after, .text-xs .font-serif .leading-3.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.\\!text-xs.leading-3.capsize::after, .font-serif .\\!text-xs.leading-3.capsize::after, .font-serif .\\!text-xs .leading-3.capsize::after, .\\!text-xs .font-serif.leading-3.capsize::after, .\\!text-xs .font-serif .leading-3.capsize::after {
  content: '' !important;
  margin-top: -0.1em !important;
  display: table !important;
}
.font-serif.text-xs.leading-4.capsize::before, .font-serif .text-xs.leading-4.capsize::before, .font-serif .text-xs .leading-4.capsize::before, .text-xs .font-serif.leading-4.capsize::before, .text-xs .font-serif .leading-4.capsize::before {
  content: '';
  margin-bottom: -0.2867em;
  display: table;
}
.font-serif.\\!text-xs.leading-4.capsize::before, .font-serif .\\!text-xs.leading-4.capsize::before, .font-serif .\\!text-xs .leading-4.capsize::before, .\\!text-xs .font-serif.leading-4.capsize::before, .\\!text-xs .font-serif .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.2867em !important;
  display: table !important;
}
.font-serif.text-xs.leading-4.capsize::after, .font-serif .text-xs.leading-4.capsize::after, .font-serif .text-xs .leading-4.capsize::after, .text-xs .font-serif.leading-4.capsize::after, .text-xs .font-serif .leading-4.capsize::after {
  content: '';
  margin-top: -0.2667em;
  display: table;
}
.font-serif.\\!text-xs.leading-4.capsize::after, .font-serif .\\!text-xs.leading-4.capsize::after, .font-serif .\\!text-xs .leading-4.capsize::after, .\\!text-xs .font-serif.leading-4.capsize::after, .\\!text-xs .font-serif .leading-4.capsize::after {
  content: '' !important;
  margin-top: -0.2667em !important;
  display: table !important;
}
.font-serif.text-xs.leading-5.capsize::before, .font-serif .text-xs.leading-5.capsize::before, .font-serif .text-xs .leading-5.capsize::before, .text-xs .font-serif.leading-5.capsize::before, .text-xs .font-serif .leading-5.capsize::before {
  content: '';
  margin-bottom: -0.4533em;
  display: table;
}
.font-serif.\\!text-xs.leading-5.capsize::before, .font-serif .\\!text-xs.leading-5.capsize::before, .font-serif .\\!text-xs .leading-5.capsize::before, .\\!text-xs .font-serif.leading-5.capsize::before, .\\!text-xs .font-serif .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.4533em !important;
  display: table !important;
}
.font-serif.text-xs.leading-5.capsize::after, .font-serif .text-xs.leading-5.capsize::after, .font-serif .text-xs .leading-5.capsize::after, .text-xs .font-serif.leading-5.capsize::after, .text-xs .font-serif .leading-5.capsize::after {
  content: '';
  margin-top: -0.4333em;
  display: table;
}
.font-serif.\\!text-xs.leading-5.capsize::after, .font-serif .\\!text-xs.leading-5.capsize::after, .font-serif .\\!text-xs .leading-5.capsize::after, .\\!text-xs .font-serif.leading-5.capsize::after, .\\!text-xs .font-serif .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.4333em !important;
  display: table !important;
}
.font-serif.text-xs.leading-6.capsize::before, .font-serif .text-xs.leading-6.capsize::before, .font-serif .text-xs .leading-6.capsize::before, .text-xs .font-serif.leading-6.capsize::before, .text-xs .font-serif .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif.\\!text-xs.leading-6.capsize::before, .font-serif .\\!text-xs.leading-6.capsize::before, .font-serif .\\!text-xs .leading-6.capsize::before, .\\!text-xs .font-serif.leading-6.capsize::before, .\\!text-xs .font-serif .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.62em !important;
  display: table !important;
}
.font-serif.text-xs.leading-6.capsize::after, .font-serif .text-xs.leading-6.capsize::after, .font-serif .text-xs .leading-6.capsize::after, .text-xs .font-serif.leading-6.capsize::after, .text-xs .font-serif .leading-6.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
.font-serif.\\!text-xs.leading-6.capsize::after, .font-serif .\\!text-xs.leading-6.capsize::after, .font-serif .\\!text-xs .leading-6.capsize::after, .\\!text-xs .font-serif.leading-6.capsize::after, .\\!text-xs .font-serif .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.6em !important;
  display: table !important;
}
.font-serif.text-xs.leading-7.capsize::before, .font-serif .text-xs.leading-7.capsize::before, .font-serif .text-xs .leading-7.capsize::before, .text-xs .font-serif.leading-7.capsize::before, .text-xs .font-serif .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.7867em;
  display: table;
}
.font-serif.\\!text-xs.leading-7.capsize::before, .font-serif .\\!text-xs.leading-7.capsize::before, .font-serif .\\!text-xs .leading-7.capsize::before, .\\!text-xs .font-serif.leading-7.capsize::before, .\\!text-xs .font-serif .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.7867em !important;
  display: table !important;
}
.font-serif.text-xs.leading-7.capsize::after, .font-serif .text-xs.leading-7.capsize::after, .font-serif .text-xs .leading-7.capsize::after, .text-xs .font-serif.leading-7.capsize::after, .text-xs .font-serif .leading-7.capsize::after {
  content: '';
  margin-top: -0.7667em;
  display: table;
}
.font-serif.\\!text-xs.leading-7.capsize::after, .font-serif .\\!text-xs.leading-7.capsize::after, .font-serif .\\!text-xs .leading-7.capsize::after, .\\!text-xs .font-serif.leading-7.capsize::after, .\\!text-xs .font-serif .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.7667em !important;
  display: table !important;
}
.font-serif.text-xs.leading-8.capsize::before, .font-serif .text-xs.leading-8.capsize::before, .font-serif .text-xs .leading-8.capsize::before, .text-xs .font-serif.leading-8.capsize::before, .text-xs .font-serif .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.9533em;
  display: table;
}
.font-serif.\\!text-xs.leading-8.capsize::before, .font-serif .\\!text-xs.leading-8.capsize::before, .font-serif .\\!text-xs .leading-8.capsize::before, .\\!text-xs .font-serif.leading-8.capsize::before, .\\!text-xs .font-serif .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.9533em !important;
  display: table !important;
}
.font-serif.text-xs.leading-8.capsize::after, .font-serif .text-xs.leading-8.capsize::after, .font-serif .text-xs .leading-8.capsize::after, .text-xs .font-serif.leading-8.capsize::after, .text-xs .font-serif .leading-8.capsize::after {
  content: '';
  margin-top: -0.9333em;
  display: table;
}
.font-serif.\\!text-xs.leading-8.capsize::after, .font-serif .\\!text-xs.leading-8.capsize::after, .font-serif .\\!text-xs .leading-8.capsize::after, .\\!text-xs .font-serif.leading-8.capsize::after, .\\!text-xs .font-serif .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.9333em !important;
  display: table !important;
}
.font-serif.text-xs.leading-9.capsize::before, .font-serif .text-xs.leading-9.capsize::before, .font-serif .text-xs .leading-9.capsize::before, .text-xs .font-serif.leading-9.capsize::before, .text-xs .font-serif .leading-9.capsize::before {
  content: '';
  margin-bottom: -1.12em;
  display: table;
}
.font-serif.\\!text-xs.leading-9.capsize::before, .font-serif .\\!text-xs.leading-9.capsize::before, .font-serif .\\!text-xs .leading-9.capsize::before, .\\!text-xs .font-serif.leading-9.capsize::before, .\\!text-xs .font-serif .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -1.12em !important;
  display: table !important;
}
.font-serif.text-xs.leading-9.capsize::after, .font-serif .text-xs.leading-9.capsize::after, .font-serif .text-xs .leading-9.capsize::after, .text-xs .font-serif.leading-9.capsize::after, .text-xs .font-serif .leading-9.capsize::after {
  content: '';
  margin-top: -1.1em;
  display: table;
}
.font-serif.\\!text-xs.leading-9.capsize::after, .font-serif .\\!text-xs.leading-9.capsize::after, .font-serif .\\!text-xs .leading-9.capsize::after, .\\!text-xs .font-serif.leading-9.capsize::after, .\\!text-xs .font-serif .leading-9.capsize::after {
  content: '' !important;
  margin-top: -1.1em !important;
  display: table !important;
}
.font-serif.text-xs.leading-10.capsize::before, .font-serif .text-xs.leading-10.capsize::before, .font-serif .text-xs .leading-10.capsize::before, .text-xs .font-serif.leading-10.capsize::before, .text-xs .font-serif .leading-10.capsize::before {
  content: '';
  margin-bottom: -1.2867em;
  display: table;
}
.font-serif.\\!text-xs.leading-10.capsize::before, .font-serif .\\!text-xs.leading-10.capsize::before, .font-serif .\\!text-xs .leading-10.capsize::before, .\\!text-xs .font-serif.leading-10.capsize::before, .\\!text-xs .font-serif .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -1.2867em !important;
  display: table !important;
}
.font-serif.text-xs.leading-10.capsize::after, .font-serif .text-xs.leading-10.capsize::after, .font-serif .text-xs .leading-10.capsize::after, .text-xs .font-serif.leading-10.capsize::after, .text-xs .font-serif .leading-10.capsize::after {
  content: '';
  margin-top: -1.2667em;
  display: table;
}
.font-serif.\\!text-xs.leading-10.capsize::after, .font-serif .\\!text-xs.leading-10.capsize::after, .font-serif .\\!text-xs .leading-10.capsize::after, .\\!text-xs .font-serif.leading-10.capsize::after, .\\!text-xs .font-serif .leading-10.capsize::after {
  content: '' !important;
  margin-top: -1.2667em !important;
  display: table !important;
}
.font-serif.text-xs.leading-none.capsize::before, .font-serif .text-xs.leading-none.capsize::before, .font-serif .text-xs .leading-none.capsize::before, .text-xs .font-serif.leading-none.capsize::before, .text-xs .font-serif .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.\\!text-xs.leading-none.capsize::before, .font-serif .\\!text-xs.leading-none.capsize::before, .font-serif .\\!text-xs .leading-none.capsize::before, .\\!text-xs .font-serif.leading-none.capsize::before, .\\!text-xs .font-serif .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.12em !important;
  display: table !important;
}
.font-serif.text-xs.leading-none.capsize::after, .font-serif .text-xs.leading-none.capsize::after, .font-serif .text-xs .leading-none.capsize::after, .text-xs .font-serif.leading-none.capsize::after, .text-xs .font-serif .leading-none.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.\\!text-xs.leading-none.capsize::after, .font-serif .\\!text-xs.leading-none.capsize::after, .font-serif .\\!text-xs .leading-none.capsize::after, .\\!text-xs .font-serif.leading-none.capsize::after, .\\!text-xs .font-serif .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.1em !important;
  display: table !important;
}
.font-serif.text-xs.leading-tight.capsize::before, .font-serif .text-xs.leading-tight.capsize::before, .font-serif .text-xs .leading-tight.capsize::before, .text-xs .font-serif.leading-tight.capsize::before, .text-xs .font-serif .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.245em;
  display: table;
}
.font-serif.\\!text-xs.leading-tight.capsize::before, .font-serif .\\!text-xs.leading-tight.capsize::before, .font-serif .\\!text-xs .leading-tight.capsize::before, .\\!text-xs .font-serif.leading-tight.capsize::before, .\\!text-xs .font-serif .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.245em !important;
  display: table !important;
}
.font-serif.text-xs.leading-tight.capsize::after, .font-serif .text-xs.leading-tight.capsize::after, .font-serif .text-xs .leading-tight.capsize::after, .text-xs .font-serif.leading-tight.capsize::after, .text-xs .font-serif .leading-tight.capsize::after {
  content: '';
  margin-top: -0.225em;
  display: table;
}
.font-serif.\\!text-xs.leading-tight.capsize::after, .font-serif .\\!text-xs.leading-tight.capsize::after, .font-serif .\\!text-xs .leading-tight.capsize::after, .\\!text-xs .font-serif.leading-tight.capsize::after, .\\!text-xs .font-serif .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.225em !important;
  display: table !important;
}
.font-serif.text-xs.leading-snug.capsize::before, .font-serif .text-xs.leading-snug.capsize::before, .font-serif .text-xs .leading-snug.capsize::before, .text-xs .font-serif.leading-snug.capsize::before, .text-xs .font-serif .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3075em;
  display: table;
}
.font-serif.\\!text-xs.leading-snug.capsize::before, .font-serif .\\!text-xs.leading-snug.capsize::before, .font-serif .\\!text-xs .leading-snug.capsize::before, .\\!text-xs .font-serif.leading-snug.capsize::before, .\\!text-xs .font-serif .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3075em !important;
  display: table !important;
}
.font-serif.text-xs.leading-snug.capsize::after, .font-serif .text-xs.leading-snug.capsize::after, .font-serif .text-xs .leading-snug.capsize::after, .text-xs .font-serif.leading-snug.capsize::after, .text-xs .font-serif .leading-snug.capsize::after {
  content: '';
  margin-top: -0.2875em;
  display: table;
}
.font-serif.\\!text-xs.leading-snug.capsize::after, .font-serif .\\!text-xs.leading-snug.capsize::after, .font-serif .\\!text-xs .leading-snug.capsize::after, .\\!text-xs .font-serif.leading-snug.capsize::after, .\\!text-xs .font-serif .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.2875em !important;
  display: table !important;
}
.font-serif.text-xs.leading-normal.capsize::before, .font-serif .text-xs.leading-normal.capsize::before, .font-serif .text-xs .leading-normal.capsize::before, .text-xs .font-serif.leading-normal.capsize::before, .text-xs .font-serif .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.37em;
  display: table;
}
.font-serif.\\!text-xs.leading-normal.capsize::before, .font-serif .\\!text-xs.leading-normal.capsize::before, .font-serif .\\!text-xs .leading-normal.capsize::before, .\\!text-xs .font-serif.leading-normal.capsize::before, .\\!text-xs .font-serif .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.37em !important;
  display: table !important;
}
.font-serif.text-xs.leading-normal.capsize::after, .font-serif .text-xs.leading-normal.capsize::after, .font-serif .text-xs .leading-normal.capsize::after, .text-xs .font-serif.leading-normal.capsize::after, .text-xs .font-serif .leading-normal.capsize::after {
  content: '';
  margin-top: -0.35em;
  display: table;
}
.font-serif.\\!text-xs.leading-normal.capsize::after, .font-serif .\\!text-xs.leading-normal.capsize::after, .font-serif .\\!text-xs .leading-normal.capsize::after, .\\!text-xs .font-serif.leading-normal.capsize::after, .\\!text-xs .font-serif .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.35em !important;
  display: table !important;
}
.font-serif.text-xs.leading-relaxed.capsize::before, .font-serif .text-xs.leading-relaxed.capsize::before, .font-serif .text-xs .leading-relaxed.capsize::before, .text-xs .font-serif.leading-relaxed.capsize::before, .text-xs .font-serif .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4325em;
  display: table;
}
.font-serif.\\!text-xs.leading-relaxed.capsize::before, .font-serif .\\!text-xs.leading-relaxed.capsize::before, .font-serif .\\!text-xs .leading-relaxed.capsize::before, .\\!text-xs .font-serif.leading-relaxed.capsize::before, .\\!text-xs .font-serif .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4325em !important;
  display: table !important;
}
.font-serif.text-xs.leading-relaxed.capsize::after, .font-serif .text-xs.leading-relaxed.capsize::after, .font-serif .text-xs .leading-relaxed.capsize::after, .text-xs .font-serif.leading-relaxed.capsize::after, .text-xs .font-serif .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4125em;
  display: table;
}
.font-serif.\\!text-xs.leading-relaxed.capsize::after, .font-serif .\\!text-xs.leading-relaxed.capsize::after, .font-serif .\\!text-xs .leading-relaxed.capsize::after, .\\!text-xs .font-serif.leading-relaxed.capsize::after, .\\!text-xs .font-serif .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4125em !important;
  display: table !important;
}
.font-serif.text-xs.leading-loose.capsize::before, .font-serif .text-xs.leading-loose.capsize::before, .font-serif .text-xs .leading-loose.capsize::before, .text-xs .font-serif.leading-loose.capsize::before, .text-xs .font-serif .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif.\\!text-xs.leading-loose.capsize::before, .font-serif .\\!text-xs.leading-loose.capsize::before, .font-serif .\\!text-xs .leading-loose.capsize::before, .\\!text-xs .font-serif.leading-loose.capsize::before, .\\!text-xs .font-serif .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.62em !important;
  display: table !important;
}
.font-serif.text-xs.leading-loose.capsize::after, .font-serif .text-xs.leading-loose.capsize::after, .font-serif .text-xs .leading-loose.capsize::after, .text-xs .font-serif.leading-loose.capsize::after, .text-xs .font-serif .leading-loose.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
.font-serif.\\!text-xs.leading-loose.capsize::after, .font-serif .\\!text-xs.leading-loose.capsize::after, .font-serif .\\!text-xs .leading-loose.capsize::after, .\\!text-xs .font-serif.leading-loose.capsize::after, .\\!text-xs .font-serif .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.6em !important;
  display: table !important;
}
.font-serif.text-sm.leading-3.capsize::before, .font-serif .text-sm.leading-3.capsize::before, .font-serif .text-sm .leading-3.capsize::before, .text-sm .font-serif.leading-3.capsize::before, .text-sm .font-serif .leading-3.capsize::before {
  content: '';
  margin-bottom: -0.0486em;
  display: table;
}
.font-serif.text-sm.leading-3.capsize::after, .font-serif .text-sm.leading-3.capsize::after, .font-serif .text-sm .leading-3.capsize::after, .text-sm .font-serif.leading-3.capsize::after, .text-sm .font-serif .leading-3.capsize::after {
  content: '';
  margin-top: -0.0286em;
  display: table;
}
.font-serif.text-sm.leading-4.capsize::before, .font-serif .text-sm.leading-4.capsize::before, .font-serif .text-sm .leading-4.capsize::before, .text-sm .font-serif.leading-4.capsize::before, .text-sm .font-serif .leading-4.capsize::before {
  content: '';
  margin-bottom: -0.1914em;
  display: table;
}
.font-serif.text-sm.leading-4.capsize::after, .font-serif .text-sm.leading-4.capsize::after, .font-serif .text-sm .leading-4.capsize::after, .text-sm .font-serif.leading-4.capsize::after, .text-sm .font-serif .leading-4.capsize::after {
  content: '';
  margin-top: -0.1714em;
  display: table;
}
.font-serif.text-sm.leading-5.capsize::before, .font-serif .text-sm.leading-5.capsize::before, .font-serif .text-sm .leading-5.capsize::before, .text-sm .font-serif.leading-5.capsize::before, .text-sm .font-serif .leading-5.capsize::before {
  content: '';
  margin-bottom: -0.3343em;
  display: table;
}
.font-serif.text-sm.leading-5.capsize::after, .font-serif .text-sm.leading-5.capsize::after, .font-serif .text-sm .leading-5.capsize::after, .text-sm .font-serif.leading-5.capsize::after, .text-sm .font-serif .leading-5.capsize::after {
  content: '';
  margin-top: -0.3143em;
  display: table;
}
.font-serif.text-sm.leading-6.capsize::before, .font-serif .text-sm.leading-6.capsize::before, .font-serif .text-sm .leading-6.capsize::before, .text-sm .font-serif.leading-6.capsize::before, .text-sm .font-serif .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.4771em;
  display: table;
}
.font-serif.text-sm.leading-6.capsize::after, .font-serif .text-sm.leading-6.capsize::after, .font-serif .text-sm .leading-6.capsize::after, .text-sm .font-serif.leading-6.capsize::after, .text-sm .font-serif .leading-6.capsize::after {
  content: '';
  margin-top: -0.4571em;
  display: table;
}
.font-serif.text-sm.leading-7.capsize::before, .font-serif .text-sm.leading-7.capsize::before, .font-serif .text-sm .leading-7.capsize::before, .text-sm .font-serif.leading-7.capsize::before, .text-sm .font-serif .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif.text-sm.leading-7.capsize::after, .font-serif .text-sm.leading-7.capsize::after, .font-serif .text-sm .leading-7.capsize::after, .text-sm .font-serif.leading-7.capsize::after, .text-sm .font-serif .leading-7.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
.font-serif.text-sm.leading-8.capsize::before, .font-serif .text-sm.leading-8.capsize::before, .font-serif .text-sm .leading-8.capsize::before, .text-sm .font-serif.leading-8.capsize::before, .text-sm .font-serif .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.7629em;
  display: table;
}
.font-serif.text-sm.leading-8.capsize::after, .font-serif .text-sm.leading-8.capsize::after, .font-serif .text-sm .leading-8.capsize::after, .text-sm .font-serif.leading-8.capsize::after, .text-sm .font-serif .leading-8.capsize::after {
  content: '';
  margin-top: -0.7429em;
  display: table;
}
.font-serif.text-sm.leading-9.capsize::before, .font-serif .text-sm.leading-9.capsize::before, .font-serif .text-sm .leading-9.capsize::before, .text-sm .font-serif.leading-9.capsize::before, .text-sm .font-serif .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.9057em;
  display: table;
}
.font-serif.text-sm.leading-9.capsize::after, .font-serif .text-sm.leading-9.capsize::after, .font-serif .text-sm .leading-9.capsize::after, .text-sm .font-serif.leading-9.capsize::after, .text-sm .font-serif .leading-9.capsize::after {
  content: '';
  margin-top: -0.8857em;
  display: table;
}
.font-serif.text-sm.leading-10.capsize::before, .font-serif .text-sm.leading-10.capsize::before, .font-serif .text-sm .leading-10.capsize::before, .text-sm .font-serif.leading-10.capsize::before, .text-sm .font-serif .leading-10.capsize::before {
  content: '';
  margin-bottom: -1.0486em;
  display: table;
}
.font-serif.text-sm.leading-10.capsize::after, .font-serif .text-sm.leading-10.capsize::after, .font-serif .text-sm .leading-10.capsize::after, .text-sm .font-serif.leading-10.capsize::after, .text-sm .font-serif .leading-10.capsize::after {
  content: '';
  margin-top: -1.0286em;
  display: table;
}
.font-serif.text-sm.leading-none.capsize::before, .font-serif .text-sm.leading-none.capsize::before, .font-serif .text-sm .leading-none.capsize::before, .text-sm .font-serif.leading-none.capsize::before, .text-sm .font-serif .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-sm.leading-none.capsize::after, .font-serif .text-sm.leading-none.capsize::after, .font-serif .text-sm .leading-none.capsize::after, .text-sm .font-serif.leading-none.capsize::after, .text-sm .font-serif .leading-none.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-sm.leading-tight.capsize::before, .font-serif .text-sm.leading-tight.capsize::before, .font-serif .text-sm .leading-tight.capsize::before, .text-sm .font-serif.leading-tight.capsize::before, .text-sm .font-serif .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.245em;
  display: table;
}
.font-serif.text-sm.leading-tight.capsize::after, .font-serif .text-sm.leading-tight.capsize::after, .font-serif .text-sm .leading-tight.capsize::after, .text-sm .font-serif.leading-tight.capsize::after, .text-sm .font-serif .leading-tight.capsize::after {
  content: '';
  margin-top: -0.225em;
  display: table;
}
.font-serif.text-sm.leading-snug.capsize::before, .font-serif .text-sm.leading-snug.capsize::before, .font-serif .text-sm .leading-snug.capsize::before, .text-sm .font-serif.leading-snug.capsize::before, .text-sm .font-serif .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3075em;
  display: table;
}
.font-serif.text-sm.leading-snug.capsize::after, .font-serif .text-sm.leading-snug.capsize::after, .font-serif .text-sm .leading-snug.capsize::after, .text-sm .font-serif.leading-snug.capsize::after, .text-sm .font-serif .leading-snug.capsize::after {
  content: '';
  margin-top: -0.2875em;
  display: table;
}
.font-serif.text-sm.leading-normal.capsize::before, .font-serif .text-sm.leading-normal.capsize::before, .font-serif .text-sm .leading-normal.capsize::before, .text-sm .font-serif.leading-normal.capsize::before, .text-sm .font-serif .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.37em;
  display: table;
}
.font-serif.text-sm.leading-normal.capsize::after, .font-serif .text-sm.leading-normal.capsize::after, .font-serif .text-sm .leading-normal.capsize::after, .text-sm .font-serif.leading-normal.capsize::after, .text-sm .font-serif .leading-normal.capsize::after {
  content: '';
  margin-top: -0.35em;
  display: table;
}
.font-serif.text-sm.leading-relaxed.capsize::before, .font-serif .text-sm.leading-relaxed.capsize::before, .font-serif .text-sm .leading-relaxed.capsize::before, .text-sm .font-serif.leading-relaxed.capsize::before, .text-sm .font-serif .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4325em;
  display: table;
}
.font-serif.text-sm.leading-relaxed.capsize::after, .font-serif .text-sm.leading-relaxed.capsize::after, .font-serif .text-sm .leading-relaxed.capsize::after, .text-sm .font-serif.leading-relaxed.capsize::after, .text-sm .font-serif .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4125em;
  display: table;
}
.font-serif.text-sm.leading-loose.capsize::before, .font-serif .text-sm.leading-loose.capsize::before, .font-serif .text-sm .leading-loose.capsize::before, .text-sm .font-serif.leading-loose.capsize::before, .text-sm .font-serif .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif.text-sm.leading-loose.capsize::after, .font-serif .text-sm.leading-loose.capsize::after, .font-serif .text-sm .leading-loose.capsize::after, .text-sm .font-serif.leading-loose.capsize::after, .text-sm .font-serif .leading-loose.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
.font-serif.text-base.leading-3.capsize::before, .font-serif .text-base.leading-3.capsize::before, .font-serif .text-base .leading-3.capsize::before, .text-base .font-serif.leading-3.capsize::before, .text-base .font-serif .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.005em;
  display: table;
}
.font-serif.text-base.leading-3.capsize::after, .font-serif .text-base.leading-3.capsize::after, .font-serif .text-base .leading-3.capsize::after, .text-base .font-serif.leading-3.capsize::after, .text-base .font-serif .leading-3.capsize::after {
  content: '';
  margin-top: 0.025em;
  display: table;
}
.font-serif.text-base.leading-4.capsize::before, .font-serif .text-base.leading-4.capsize::before, .font-serif .text-base .leading-4.capsize::before, .text-base .font-serif.leading-4.capsize::before, .text-base .font-serif .leading-4.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-base.leading-4.capsize::after, .font-serif .text-base.leading-4.capsize::after, .font-serif .text-base .leading-4.capsize::after, .text-base .font-serif.leading-4.capsize::after, .text-base .font-serif .leading-4.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-base.leading-5.capsize::before, .font-serif .text-base.leading-5.capsize::before, .font-serif .text-base .leading-5.capsize::before, .text-base .font-serif.leading-5.capsize::before, .text-base .font-serif .leading-5.capsize::before {
  content: '';
  margin-bottom: -0.245em;
  display: table;
}
.font-serif.text-base.leading-5.capsize::after, .font-serif .text-base.leading-5.capsize::after, .font-serif .text-base .leading-5.capsize::after, .text-base .font-serif.leading-5.capsize::after, .text-base .font-serif .leading-5.capsize::after {
  content: '';
  margin-top: -0.225em;
  display: table;
}
.font-serif.text-base.leading-6.capsize::before, .font-serif .text-base.leading-6.capsize::before, .font-serif .text-base .leading-6.capsize::before, .text-base .font-serif.leading-6.capsize::before, .text-base .font-serif .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.37em;
  display: table;
}
.font-serif.text-base.leading-6.capsize::after, .font-serif .text-base.leading-6.capsize::after, .font-serif .text-base .leading-6.capsize::after, .text-base .font-serif.leading-6.capsize::after, .text-base .font-serif .leading-6.capsize::after {
  content: '';
  margin-top: -0.35em;
  display: table;
}
.font-serif.text-base.leading-7.capsize::before, .font-serif .text-base.leading-7.capsize::before, .font-serif .text-base .leading-7.capsize::before, .text-base .font-serif.leading-7.capsize::before, .text-base .font-serif .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.495em;
  display: table;
}
.font-serif.text-base.leading-7.capsize::after, .font-serif .text-base.leading-7.capsize::after, .font-serif .text-base .leading-7.capsize::after, .text-base .font-serif.leading-7.capsize::after, .text-base .font-serif .leading-7.capsize::after {
  content: '';
  margin-top: -0.475em;
  display: table;
}
.font-serif.text-base.leading-8.capsize::before, .font-serif .text-base.leading-8.capsize::before, .font-serif .text-base .leading-8.capsize::before, .text-base .font-serif.leading-8.capsize::before, .text-base .font-serif .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif.text-base.leading-8.capsize::after, .font-serif .text-base.leading-8.capsize::after, .font-serif .text-base .leading-8.capsize::after, .text-base .font-serif.leading-8.capsize::after, .text-base .font-serif .leading-8.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
.font-serif.text-base.leading-9.capsize::before, .font-serif .text-base.leading-9.capsize::before, .font-serif .text-base .leading-9.capsize::before, .text-base .font-serif.leading-9.capsize::before, .text-base .font-serif .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.745em;
  display: table;
}
.font-serif.text-base.leading-9.capsize::after, .font-serif .text-base.leading-9.capsize::after, .font-serif .text-base .leading-9.capsize::after, .text-base .font-serif.leading-9.capsize::after, .text-base .font-serif .leading-9.capsize::after {
  content: '';
  margin-top: -0.725em;
  display: table;
}
.font-serif.text-base.leading-10.capsize::before, .font-serif .text-base.leading-10.capsize::before, .font-serif .text-base .leading-10.capsize::before, .text-base .font-serif.leading-10.capsize::before, .text-base .font-serif .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.87em;
  display: table;
}
.font-serif.text-base.leading-10.capsize::after, .font-serif .text-base.leading-10.capsize::after, .font-serif .text-base .leading-10.capsize::after, .text-base .font-serif.leading-10.capsize::after, .text-base .font-serif .leading-10.capsize::after {
  content: '';
  margin-top: -0.85em;
  display: table;
}
.font-serif.text-base.leading-none.capsize::before, .font-serif .text-base.leading-none.capsize::before, .font-serif .text-base .leading-none.capsize::before, .text-base .font-serif.leading-none.capsize::before, .text-base .font-serif .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-base.leading-none.capsize::after, .font-serif .text-base.leading-none.capsize::after, .font-serif .text-base .leading-none.capsize::after, .text-base .font-serif.leading-none.capsize::after, .text-base .font-serif .leading-none.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-base.leading-tight.capsize::before, .font-serif .text-base.leading-tight.capsize::before, .font-serif .text-base .leading-tight.capsize::before, .text-base .font-serif.leading-tight.capsize::before, .text-base .font-serif .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.245em;
  display: table;
}
.font-serif.text-base.leading-tight.capsize::after, .font-serif .text-base.leading-tight.capsize::after, .font-serif .text-base .leading-tight.capsize::after, .text-base .font-serif.leading-tight.capsize::after, .text-base .font-serif .leading-tight.capsize::after {
  content: '';
  margin-top: -0.225em;
  display: table;
}
.font-serif.text-base.leading-snug.capsize::before, .font-serif .text-base.leading-snug.capsize::before, .font-serif .text-base .leading-snug.capsize::before, .text-base .font-serif.leading-snug.capsize::before, .text-base .font-serif .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3075em;
  display: table;
}
.font-serif.text-base.leading-snug.capsize::after, .font-serif .text-base.leading-snug.capsize::after, .font-serif .text-base .leading-snug.capsize::after, .text-base .font-serif.leading-snug.capsize::after, .text-base .font-serif .leading-snug.capsize::after {
  content: '';
  margin-top: -0.2875em;
  display: table;
}
.font-serif.text-base.leading-normal.capsize::before, .font-serif .text-base.leading-normal.capsize::before, .font-serif .text-base .leading-normal.capsize::before, .text-base .font-serif.leading-normal.capsize::before, .text-base .font-serif .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.37em;
  display: table;
}
.font-serif.text-base.leading-normal.capsize::after, .font-serif .text-base.leading-normal.capsize::after, .font-serif .text-base .leading-normal.capsize::after, .text-base .font-serif.leading-normal.capsize::after, .text-base .font-serif .leading-normal.capsize::after {
  content: '';
  margin-top: -0.35em;
  display: table;
}
.font-serif.text-base.leading-relaxed.capsize::before, .font-serif .text-base.leading-relaxed.capsize::before, .font-serif .text-base .leading-relaxed.capsize::before, .text-base .font-serif.leading-relaxed.capsize::before, .text-base .font-serif .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4325em;
  display: table;
}
.font-serif.text-base.leading-relaxed.capsize::after, .font-serif .text-base.leading-relaxed.capsize::after, .font-serif .text-base .leading-relaxed.capsize::after, .text-base .font-serif.leading-relaxed.capsize::after, .text-base .font-serif .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4125em;
  display: table;
}
.font-serif.text-base.leading-loose.capsize::before, .font-serif .text-base.leading-loose.capsize::before, .font-serif .text-base .leading-loose.capsize::before, .text-base .font-serif.leading-loose.capsize::before, .text-base .font-serif .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif.text-base.leading-loose.capsize::after, .font-serif .text-base.leading-loose.capsize::after, .font-serif .text-base .leading-loose.capsize::after, .text-base .font-serif.leading-loose.capsize::after, .text-base .font-serif .leading-loose.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
.font-serif.text-lg.leading-3.capsize::before, .font-serif .text-lg.leading-3.capsize::before, .font-serif .text-lg .leading-3.capsize::before, .text-lg .font-serif.leading-3.capsize::before, .text-lg .font-serif .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.0467em;
  display: table;
}
.font-serif.text-lg.leading-3.capsize::after, .font-serif .text-lg.leading-3.capsize::after, .font-serif .text-lg .leading-3.capsize::after, .text-lg .font-serif.leading-3.capsize::after, .text-lg .font-serif .leading-3.capsize::after {
  content: '';
  margin-top: 0.0667em;
  display: table;
}
.font-serif.text-lg.leading-4.capsize::before, .font-serif .text-lg.leading-4.capsize::before, .font-serif .text-lg .leading-4.capsize::before, .text-lg .font-serif.leading-4.capsize::before, .text-lg .font-serif .leading-4.capsize::before {
  content: '';
  margin-bottom: -0.0644em;
  display: table;
}
.font-serif.text-lg.leading-4.capsize::after, .font-serif .text-lg.leading-4.capsize::after, .font-serif .text-lg .leading-4.capsize::after, .text-lg .font-serif.leading-4.capsize::after, .text-lg .font-serif .leading-4.capsize::after {
  content: '';
  margin-top: -0.0444em;
  display: table;
}
.font-serif.text-lg.leading-5.capsize::before, .font-serif .text-lg.leading-5.capsize::before, .font-serif .text-lg .leading-5.capsize::before, .text-lg .font-serif.leading-5.capsize::before, .text-lg .font-serif .leading-5.capsize::before {
  content: '';
  margin-bottom: -0.1756em;
  display: table;
}
.font-serif.text-lg.leading-5.capsize::after, .font-serif .text-lg.leading-5.capsize::after, .font-serif .text-lg .leading-5.capsize::after, .text-lg .font-serif.leading-5.capsize::after, .text-lg .font-serif .leading-5.capsize::after {
  content: '';
  margin-top: -0.1556em;
  display: table;
}
.font-serif.text-lg.leading-6.capsize::before, .font-serif .text-lg.leading-6.capsize::before, .font-serif .text-lg .leading-6.capsize::before, .text-lg .font-serif.leading-6.capsize::before, .text-lg .font-serif .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.2867em;
  display: table;
}
.font-serif.text-lg.leading-6.capsize::after, .font-serif .text-lg.leading-6.capsize::after, .font-serif .text-lg .leading-6.capsize::after, .text-lg .font-serif.leading-6.capsize::after, .text-lg .font-serif .leading-6.capsize::after {
  content: '';
  margin-top: -0.2667em;
  display: table;
}
.font-serif.text-lg.leading-7.capsize::before, .font-serif .text-lg.leading-7.capsize::before, .font-serif .text-lg .leading-7.capsize::before, .text-lg .font-serif.leading-7.capsize::before, .text-lg .font-serif .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.3978em;
  display: table;
}
.font-serif.text-lg.leading-7.capsize::after, .font-serif .text-lg.leading-7.capsize::after, .font-serif .text-lg .leading-7.capsize::after, .text-lg .font-serif.leading-7.capsize::after, .text-lg .font-serif .leading-7.capsize::after {
  content: '';
  margin-top: -0.3778em;
  display: table;
}
.font-serif.text-lg.leading-8.capsize::before, .font-serif .text-lg.leading-8.capsize::before, .font-serif .text-lg .leading-8.capsize::before, .text-lg .font-serif.leading-8.capsize::before, .text-lg .font-serif .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.5089em;
  display: table;
}
.font-serif.text-lg.leading-8.capsize::after, .font-serif .text-lg.leading-8.capsize::after, .font-serif .text-lg .leading-8.capsize::after, .text-lg .font-serif.leading-8.capsize::after, .text-lg .font-serif .leading-8.capsize::after {
  content: '';
  margin-top: -0.4889em;
  display: table;
}
.font-serif.text-lg.leading-9.capsize::before, .font-serif .text-lg.leading-9.capsize::before, .font-serif .text-lg .leading-9.capsize::before, .text-lg .font-serif.leading-9.capsize::before, .text-lg .font-serif .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif.text-lg.leading-9.capsize::after, .font-serif .text-lg.leading-9.capsize::after, .font-serif .text-lg .leading-9.capsize::after, .text-lg .font-serif.leading-9.capsize::after, .text-lg .font-serif .leading-9.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
.font-serif.text-lg.leading-10.capsize::before, .font-serif .text-lg.leading-10.capsize::before, .font-serif .text-lg .leading-10.capsize::before, .text-lg .font-serif.leading-10.capsize::before, .text-lg .font-serif .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.7311em;
  display: table;
}
.font-serif.text-lg.leading-10.capsize::after, .font-serif .text-lg.leading-10.capsize::after, .font-serif .text-lg .leading-10.capsize::after, .text-lg .font-serif.leading-10.capsize::after, .text-lg .font-serif .leading-10.capsize::after {
  content: '';
  margin-top: -0.7111em;
  display: table;
}
.font-serif.text-lg.leading-none.capsize::before, .font-serif .text-lg.leading-none.capsize::before, .font-serif .text-lg .leading-none.capsize::before, .text-lg .font-serif.leading-none.capsize::before, .text-lg .font-serif .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-lg.leading-none.capsize::after, .font-serif .text-lg.leading-none.capsize::after, .font-serif .text-lg .leading-none.capsize::after, .text-lg .font-serif.leading-none.capsize::after, .text-lg .font-serif .leading-none.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-lg.leading-tight.capsize::before, .font-serif .text-lg.leading-tight.capsize::before, .font-serif .text-lg .leading-tight.capsize::before, .text-lg .font-serif.leading-tight.capsize::before, .text-lg .font-serif .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.245em;
  display: table;
}
.font-serif.text-lg.leading-tight.capsize::after, .font-serif .text-lg.leading-tight.capsize::after, .font-serif .text-lg .leading-tight.capsize::after, .text-lg .font-serif.leading-tight.capsize::after, .text-lg .font-serif .leading-tight.capsize::after {
  content: '';
  margin-top: -0.225em;
  display: table;
}
.font-serif.text-lg.leading-snug.capsize::before, .font-serif .text-lg.leading-snug.capsize::before, .font-serif .text-lg .leading-snug.capsize::before, .text-lg .font-serif.leading-snug.capsize::before, .text-lg .font-serif .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3075em;
  display: table;
}
.font-serif.text-lg.leading-snug.capsize::after, .font-serif .text-lg.leading-snug.capsize::after, .font-serif .text-lg .leading-snug.capsize::after, .text-lg .font-serif.leading-snug.capsize::after, .text-lg .font-serif .leading-snug.capsize::after {
  content: '';
  margin-top: -0.2875em;
  display: table;
}
.font-serif.text-lg.leading-normal.capsize::before, .font-serif .text-lg.leading-normal.capsize::before, .font-serif .text-lg .leading-normal.capsize::before, .text-lg .font-serif.leading-normal.capsize::before, .text-lg .font-serif .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.37em;
  display: table;
}
.font-serif.text-lg.leading-normal.capsize::after, .font-serif .text-lg.leading-normal.capsize::after, .font-serif .text-lg .leading-normal.capsize::after, .text-lg .font-serif.leading-normal.capsize::after, .text-lg .font-serif .leading-normal.capsize::after {
  content: '';
  margin-top: -0.35em;
  display: table;
}
.font-serif.text-lg.leading-relaxed.capsize::before, .font-serif .text-lg.leading-relaxed.capsize::before, .font-serif .text-lg .leading-relaxed.capsize::before, .text-lg .font-serif.leading-relaxed.capsize::before, .text-lg .font-serif .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4325em;
  display: table;
}
.font-serif.text-lg.leading-relaxed.capsize::after, .font-serif .text-lg.leading-relaxed.capsize::after, .font-serif .text-lg .leading-relaxed.capsize::after, .text-lg .font-serif.leading-relaxed.capsize::after, .text-lg .font-serif .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4125em;
  display: table;
}
.font-serif.text-lg.leading-loose.capsize::before, .font-serif .text-lg.leading-loose.capsize::before, .font-serif .text-lg .leading-loose.capsize::before, .text-lg .font-serif.leading-loose.capsize::before, .text-lg .font-serif .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif.text-lg.leading-loose.capsize::after, .font-serif .text-lg.leading-loose.capsize::after, .font-serif .text-lg .leading-loose.capsize::after, .text-lg .font-serif.leading-loose.capsize::after, .text-lg .font-serif .leading-loose.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
.font-serif.text-xl.leading-3.capsize::before, .font-serif .text-xl.leading-3.capsize::before, .font-serif .text-xl .leading-3.capsize::before, .text-xl .font-serif.leading-3.capsize::before, .text-xl .font-serif .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.08em;
  display: table;
}
.font-serif.text-xl.leading-3.capsize::after, .font-serif .text-xl.leading-3.capsize::after, .font-serif .text-xl .leading-3.capsize::after, .text-xl .font-serif.leading-3.capsize::after, .text-xl .font-serif .leading-3.capsize::after {
  content: '';
  margin-top: 0.1em;
  display: table;
}
.font-serif.text-xl.leading-4.capsize::before, .font-serif .text-xl.leading-4.capsize::before, .font-serif .text-xl .leading-4.capsize::before, .text-xl .font-serif.leading-4.capsize::before, .text-xl .font-serif .leading-4.capsize::before {
  content: '';
  margin-bottom: -0.02em;
  display: table;
}
.font-serif.text-xl.leading-4.capsize::after, .font-serif .text-xl.leading-4.capsize::after, .font-serif .text-xl .leading-4.capsize::after, .text-xl .font-serif.leading-4.capsize::after, .text-xl .font-serif .leading-4.capsize::after {
  content: '';
  margin-top: 0em;
  display: table;
}
.font-serif.text-xl.leading-5.capsize::before, .font-serif .text-xl.leading-5.capsize::before, .font-serif .text-xl .leading-5.capsize::before, .text-xl .font-serif.leading-5.capsize::before, .text-xl .font-serif .leading-5.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-xl.leading-5.capsize::after, .font-serif .text-xl.leading-5.capsize::after, .font-serif .text-xl .leading-5.capsize::after, .text-xl .font-serif.leading-5.capsize::after, .text-xl .font-serif .leading-5.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-xl.leading-6.capsize::before, .font-serif .text-xl.leading-6.capsize::before, .font-serif .text-xl .leading-6.capsize::before, .text-xl .font-serif.leading-6.capsize::before, .text-xl .font-serif .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.22em;
  display: table;
}
.font-serif.text-xl.leading-6.capsize::after, .font-serif .text-xl.leading-6.capsize::after, .font-serif .text-xl .leading-6.capsize::after, .text-xl .font-serif.leading-6.capsize::after, .text-xl .font-serif .leading-6.capsize::after {
  content: '';
  margin-top: -0.2em;
  display: table;
}
.font-serif.text-xl.leading-7.capsize::before, .font-serif .text-xl.leading-7.capsize::before, .font-serif .text-xl .leading-7.capsize::before, .text-xl .font-serif.leading-7.capsize::before, .text-xl .font-serif .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.32em;
  display: table;
}
.font-serif.text-xl.leading-7.capsize::after, .font-serif .text-xl.leading-7.capsize::after, .font-serif .text-xl .leading-7.capsize::after, .text-xl .font-serif.leading-7.capsize::after, .text-xl .font-serif .leading-7.capsize::after {
  content: '';
  margin-top: -0.3em;
  display: table;
}
.font-serif.text-xl.leading-8.capsize::before, .font-serif .text-xl.leading-8.capsize::before, .font-serif .text-xl .leading-8.capsize::before, .text-xl .font-serif.leading-8.capsize::before, .text-xl .font-serif .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.42em;
  display: table;
}
.font-serif.text-xl.leading-8.capsize::after, .font-serif .text-xl.leading-8.capsize::after, .font-serif .text-xl .leading-8.capsize::after, .text-xl .font-serif.leading-8.capsize::after, .text-xl .font-serif .leading-8.capsize::after {
  content: '';
  margin-top: -0.4em;
  display: table;
}
.font-serif.text-xl.leading-9.capsize::before, .font-serif .text-xl.leading-9.capsize::before, .font-serif .text-xl .leading-9.capsize::before, .text-xl .font-serif.leading-9.capsize::before, .text-xl .font-serif .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.52em;
  display: table;
}
.font-serif.text-xl.leading-9.capsize::after, .font-serif .text-xl.leading-9.capsize::after, .font-serif .text-xl .leading-9.capsize::after, .text-xl .font-serif.leading-9.capsize::after, .text-xl .font-serif .leading-9.capsize::after {
  content: '';
  margin-top: -0.5em;
  display: table;
}
.font-serif.text-xl.leading-10.capsize::before, .font-serif .text-xl.leading-10.capsize::before, .font-serif .text-xl .leading-10.capsize::before, .text-xl .font-serif.leading-10.capsize::before, .text-xl .font-serif .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif.text-xl.leading-10.capsize::after, .font-serif .text-xl.leading-10.capsize::after, .font-serif .text-xl .leading-10.capsize::after, .text-xl .font-serif.leading-10.capsize::after, .text-xl .font-serif .leading-10.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
.font-serif.text-xl.leading-none.capsize::before, .font-serif .text-xl.leading-none.capsize::before, .font-serif .text-xl .leading-none.capsize::before, .text-xl .font-serif.leading-none.capsize::before, .text-xl .font-serif .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-xl.leading-none.capsize::after, .font-serif .text-xl.leading-none.capsize::after, .font-serif .text-xl .leading-none.capsize::after, .text-xl .font-serif.leading-none.capsize::after, .text-xl .font-serif .leading-none.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-xl.leading-tight.capsize::before, .font-serif .text-xl.leading-tight.capsize::before, .font-serif .text-xl .leading-tight.capsize::before, .text-xl .font-serif.leading-tight.capsize::before, .text-xl .font-serif .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.245em;
  display: table;
}
.font-serif.text-xl.leading-tight.capsize::after, .font-serif .text-xl.leading-tight.capsize::after, .font-serif .text-xl .leading-tight.capsize::after, .text-xl .font-serif.leading-tight.capsize::after, .text-xl .font-serif .leading-tight.capsize::after {
  content: '';
  margin-top: -0.225em;
  display: table;
}
.font-serif.text-xl.leading-snug.capsize::before, .font-serif .text-xl.leading-snug.capsize::before, .font-serif .text-xl .leading-snug.capsize::before, .text-xl .font-serif.leading-snug.capsize::before, .text-xl .font-serif .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3075em;
  display: table;
}
.font-serif.text-xl.leading-snug.capsize::after, .font-serif .text-xl.leading-snug.capsize::after, .font-serif .text-xl .leading-snug.capsize::after, .text-xl .font-serif.leading-snug.capsize::after, .text-xl .font-serif .leading-snug.capsize::after {
  content: '';
  margin-top: -0.2875em;
  display: table;
}
.font-serif.text-xl.leading-normal.capsize::before, .font-serif .text-xl.leading-normal.capsize::before, .font-serif .text-xl .leading-normal.capsize::before, .text-xl .font-serif.leading-normal.capsize::before, .text-xl .font-serif .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.37em;
  display: table;
}
.font-serif.text-xl.leading-normal.capsize::after, .font-serif .text-xl.leading-normal.capsize::after, .font-serif .text-xl .leading-normal.capsize::after, .text-xl .font-serif.leading-normal.capsize::after, .text-xl .font-serif .leading-normal.capsize::after {
  content: '';
  margin-top: -0.35em;
  display: table;
}
.font-serif.text-xl.leading-relaxed.capsize::before, .font-serif .text-xl.leading-relaxed.capsize::before, .font-serif .text-xl .leading-relaxed.capsize::before, .text-xl .font-serif.leading-relaxed.capsize::before, .text-xl .font-serif .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4325em;
  display: table;
}
.font-serif.text-xl.leading-relaxed.capsize::after, .font-serif .text-xl.leading-relaxed.capsize::after, .font-serif .text-xl .leading-relaxed.capsize::after, .text-xl .font-serif.leading-relaxed.capsize::after, .text-xl .font-serif .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4125em;
  display: table;
}
.font-serif.text-xl.leading-loose.capsize::before, .font-serif .text-xl.leading-loose.capsize::before, .font-serif .text-xl .leading-loose.capsize::before, .text-xl .font-serif.leading-loose.capsize::before, .text-xl .font-serif .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif.text-xl.leading-loose.capsize::after, .font-serif .text-xl.leading-loose.capsize::after, .font-serif .text-xl .leading-loose.capsize::after, .text-xl .font-serif.leading-loose.capsize::after, .text-xl .font-serif .leading-loose.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
.font-serif.text-2xl.leading-3.capsize::before, .font-serif .text-2xl.leading-3.capsize::before, .font-serif .text-2xl .leading-3.capsize::before, .text-2xl .font-serif.leading-3.capsize::before, .text-2xl .font-serif .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.13em;
  display: table;
}
.font-serif.text-2xl.leading-3.capsize::after, .font-serif .text-2xl.leading-3.capsize::after, .font-serif .text-2xl .leading-3.capsize::after, .text-2xl .font-serif.leading-3.capsize::after, .text-2xl .font-serif .leading-3.capsize::after {
  content: '';
  margin-top: 0.15em;
  display: table;
}
.font-serif.text-2xl.leading-4.capsize::before, .font-serif .text-2xl.leading-4.capsize::before, .font-serif .text-2xl .leading-4.capsize::before, .text-2xl .font-serif.leading-4.capsize::before, .text-2xl .font-serif .leading-4.capsize::before {
  content: '';
  margin-bottom: 0.0467em;
  display: table;
}
.font-serif.text-2xl.leading-4.capsize::after, .font-serif .text-2xl.leading-4.capsize::after, .font-serif .text-2xl .leading-4.capsize::after, .text-2xl .font-serif.leading-4.capsize::after, .text-2xl .font-serif .leading-4.capsize::after {
  content: '';
  margin-top: 0.0667em;
  display: table;
}
.font-serif.text-2xl.leading-5.capsize::before, .font-serif .text-2xl.leading-5.capsize::before, .font-serif .text-2xl .leading-5.capsize::before, .text-2xl .font-serif.leading-5.capsize::before, .text-2xl .font-serif .leading-5.capsize::before {
  content: '';
  margin-bottom: -0.0367em;
  display: table;
}
.font-serif.text-2xl.leading-5.capsize::after, .font-serif .text-2xl.leading-5.capsize::after, .font-serif .text-2xl .leading-5.capsize::after, .text-2xl .font-serif.leading-5.capsize::after, .text-2xl .font-serif .leading-5.capsize::after {
  content: '';
  margin-top: -0.0167em;
  display: table;
}
.font-serif.text-2xl.leading-6.capsize::before, .font-serif .text-2xl.leading-6.capsize::before, .font-serif .text-2xl .leading-6.capsize::before, .text-2xl .font-serif.leading-6.capsize::before, .text-2xl .font-serif .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-2xl.leading-6.capsize::after, .font-serif .text-2xl.leading-6.capsize::after, .font-serif .text-2xl .leading-6.capsize::after, .text-2xl .font-serif.leading-6.capsize::after, .text-2xl .font-serif .leading-6.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-2xl.leading-7.capsize::before, .font-serif .text-2xl.leading-7.capsize::before, .font-serif .text-2xl .leading-7.capsize::before, .text-2xl .font-serif.leading-7.capsize::before, .text-2xl .font-serif .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.2033em;
  display: table;
}
.font-serif.text-2xl.leading-7.capsize::after, .font-serif .text-2xl.leading-7.capsize::after, .font-serif .text-2xl .leading-7.capsize::after, .text-2xl .font-serif.leading-7.capsize::after, .text-2xl .font-serif .leading-7.capsize::after {
  content: '';
  margin-top: -0.1833em;
  display: table;
}
.font-serif.text-2xl.leading-8.capsize::before, .font-serif .text-2xl.leading-8.capsize::before, .font-serif .text-2xl .leading-8.capsize::before, .text-2xl .font-serif.leading-8.capsize::before, .text-2xl .font-serif .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.2867em;
  display: table;
}
.font-serif.text-2xl.leading-8.capsize::after, .font-serif .text-2xl.leading-8.capsize::after, .font-serif .text-2xl .leading-8.capsize::after, .text-2xl .font-serif.leading-8.capsize::after, .text-2xl .font-serif .leading-8.capsize::after {
  content: '';
  margin-top: -0.2667em;
  display: table;
}
.font-serif.text-2xl.leading-9.capsize::before, .font-serif .text-2xl.leading-9.capsize::before, .font-serif .text-2xl .leading-9.capsize::before, .text-2xl .font-serif.leading-9.capsize::before, .text-2xl .font-serif .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.37em;
  display: table;
}
.font-serif.text-2xl.leading-9.capsize::after, .font-serif .text-2xl.leading-9.capsize::after, .font-serif .text-2xl .leading-9.capsize::after, .text-2xl .font-serif.leading-9.capsize::after, .text-2xl .font-serif .leading-9.capsize::after {
  content: '';
  margin-top: -0.35em;
  display: table;
}
.font-serif.text-2xl.leading-10.capsize::before, .font-serif .text-2xl.leading-10.capsize::before, .font-serif .text-2xl .leading-10.capsize::before, .text-2xl .font-serif.leading-10.capsize::before, .text-2xl .font-serif .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.4533em;
  display: table;
}
.font-serif.text-2xl.leading-10.capsize::after, .font-serif .text-2xl.leading-10.capsize::after, .font-serif .text-2xl .leading-10.capsize::after, .text-2xl .font-serif.leading-10.capsize::after, .text-2xl .font-serif .leading-10.capsize::after {
  content: '';
  margin-top: -0.4333em;
  display: table;
}
.font-serif.text-2xl.leading-none.capsize::before, .font-serif .text-2xl.leading-none.capsize::before, .font-serif .text-2xl .leading-none.capsize::before, .text-2xl .font-serif.leading-none.capsize::before, .text-2xl .font-serif .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-2xl.leading-none.capsize::after, .font-serif .text-2xl.leading-none.capsize::after, .font-serif .text-2xl .leading-none.capsize::after, .text-2xl .font-serif.leading-none.capsize::after, .text-2xl .font-serif .leading-none.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-2xl.leading-tight.capsize::before, .font-serif .text-2xl.leading-tight.capsize::before, .font-serif .text-2xl .leading-tight.capsize::before, .text-2xl .font-serif.leading-tight.capsize::before, .text-2xl .font-serif .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.245em;
  display: table;
}
.font-serif.text-2xl.leading-tight.capsize::after, .font-serif .text-2xl.leading-tight.capsize::after, .font-serif .text-2xl .leading-tight.capsize::after, .text-2xl .font-serif.leading-tight.capsize::after, .text-2xl .font-serif .leading-tight.capsize::after {
  content: '';
  margin-top: -0.225em;
  display: table;
}
.font-serif.text-2xl.leading-snug.capsize::before, .font-serif .text-2xl.leading-snug.capsize::before, .font-serif .text-2xl .leading-snug.capsize::before, .text-2xl .font-serif.leading-snug.capsize::before, .text-2xl .font-serif .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3075em;
  display: table;
}
.font-serif.text-2xl.leading-snug.capsize::after, .font-serif .text-2xl.leading-snug.capsize::after, .font-serif .text-2xl .leading-snug.capsize::after, .text-2xl .font-serif.leading-snug.capsize::after, .text-2xl .font-serif .leading-snug.capsize::after {
  content: '';
  margin-top: -0.2875em;
  display: table;
}
.font-serif.text-2xl.leading-normal.capsize::before, .font-serif .text-2xl.leading-normal.capsize::before, .font-serif .text-2xl .leading-normal.capsize::before, .text-2xl .font-serif.leading-normal.capsize::before, .text-2xl .font-serif .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.37em;
  display: table;
}
.font-serif.text-2xl.leading-normal.capsize::after, .font-serif .text-2xl.leading-normal.capsize::after, .font-serif .text-2xl .leading-normal.capsize::after, .text-2xl .font-serif.leading-normal.capsize::after, .text-2xl .font-serif .leading-normal.capsize::after {
  content: '';
  margin-top: -0.35em;
  display: table;
}
.font-serif.text-2xl.leading-relaxed.capsize::before, .font-serif .text-2xl.leading-relaxed.capsize::before, .font-serif .text-2xl .leading-relaxed.capsize::before, .text-2xl .font-serif.leading-relaxed.capsize::before, .text-2xl .font-serif .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4325em;
  display: table;
}
.font-serif.text-2xl.leading-relaxed.capsize::after, .font-serif .text-2xl.leading-relaxed.capsize::after, .font-serif .text-2xl .leading-relaxed.capsize::after, .text-2xl .font-serif.leading-relaxed.capsize::after, .text-2xl .font-serif .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4125em;
  display: table;
}
.font-serif.text-2xl.leading-loose.capsize::before, .font-serif .text-2xl.leading-loose.capsize::before, .font-serif .text-2xl .leading-loose.capsize::before, .text-2xl .font-serif.leading-loose.capsize::before, .text-2xl .font-serif .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif.text-2xl.leading-loose.capsize::after, .font-serif .text-2xl.leading-loose.capsize::after, .font-serif .text-2xl .leading-loose.capsize::after, .text-2xl .font-serif.leading-loose.capsize::after, .text-2xl .font-serif .leading-loose.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
.font-serif.text-3xl.leading-3.capsize::before, .font-serif .text-3xl.leading-3.capsize::before, .font-serif .text-3xl .leading-3.capsize::before, .text-3xl .font-serif.leading-3.capsize::before, .text-3xl .font-serif .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.18em;
  display: table;
}
.font-serif.text-3xl.leading-3.capsize::after, .font-serif .text-3xl.leading-3.capsize::after, .font-serif .text-3xl .leading-3.capsize::after, .text-3xl .font-serif.leading-3.capsize::after, .text-3xl .font-serif .leading-3.capsize::after {
  content: '';
  margin-top: 0.2em;
  display: table;
}
.font-serif.text-3xl.leading-4.capsize::before, .font-serif .text-3xl.leading-4.capsize::before, .font-serif .text-3xl .leading-4.capsize::before, .text-3xl .font-serif.leading-4.capsize::before, .text-3xl .font-serif .leading-4.capsize::before {
  content: '';
  margin-bottom: 0.1133em;
  display: table;
}
.font-serif.text-3xl.leading-4.capsize::after, .font-serif .text-3xl.leading-4.capsize::after, .font-serif .text-3xl .leading-4.capsize::after, .text-3xl .font-serif.leading-4.capsize::after, .text-3xl .font-serif .leading-4.capsize::after {
  content: '';
  margin-top: 0.1333em;
  display: table;
}
.font-serif.text-3xl.leading-5.capsize::before, .font-serif .text-3xl.leading-5.capsize::before, .font-serif .text-3xl .leading-5.capsize::before, .text-3xl .font-serif.leading-5.capsize::before, .text-3xl .font-serif .leading-5.capsize::before {
  content: '';
  margin-bottom: 0.0467em;
  display: table;
}
.font-serif.text-3xl.leading-5.capsize::after, .font-serif .text-3xl.leading-5.capsize::after, .font-serif .text-3xl .leading-5.capsize::after, .text-3xl .font-serif.leading-5.capsize::after, .text-3xl .font-serif .leading-5.capsize::after {
  content: '';
  margin-top: 0.0667em;
  display: table;
}
.font-serif.text-3xl.leading-6.capsize::before, .font-serif .text-3xl.leading-6.capsize::before, .font-serif .text-3xl .leading-6.capsize::before, .text-3xl .font-serif.leading-6.capsize::before, .text-3xl .font-serif .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.02em;
  display: table;
}
.font-serif.text-3xl.leading-6.capsize::after, .font-serif .text-3xl.leading-6.capsize::after, .font-serif .text-3xl .leading-6.capsize::after, .text-3xl .font-serif.leading-6.capsize::after, .text-3xl .font-serif .leading-6.capsize::after {
  content: '';
  margin-top: 0em;
  display: table;
}
.font-serif.text-3xl.leading-7.capsize::before, .font-serif .text-3xl.leading-7.capsize::before, .font-serif .text-3xl .leading-7.capsize::before, .text-3xl .font-serif.leading-7.capsize::before, .text-3xl .font-serif .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.0867em;
  display: table;
}
.font-serif.text-3xl.leading-7.capsize::after, .font-serif .text-3xl.leading-7.capsize::after, .font-serif .text-3xl .leading-7.capsize::after, .text-3xl .font-serif.leading-7.capsize::after, .text-3xl .font-serif .leading-7.capsize::after {
  content: '';
  margin-top: -0.0667em;
  display: table;
}
.font-serif.text-3xl.leading-8.capsize::before, .font-serif .text-3xl.leading-8.capsize::before, .font-serif .text-3xl .leading-8.capsize::before, .text-3xl .font-serif.leading-8.capsize::before, .text-3xl .font-serif .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.1533em;
  display: table;
}
.font-serif.text-3xl.leading-8.capsize::after, .font-serif .text-3xl.leading-8.capsize::after, .font-serif .text-3xl .leading-8.capsize::after, .text-3xl .font-serif.leading-8.capsize::after, .text-3xl .font-serif .leading-8.capsize::after {
  content: '';
  margin-top: -0.1333em;
  display: table;
}
.font-serif.text-3xl.leading-9.capsize::before, .font-serif .text-3xl.leading-9.capsize::before, .font-serif .text-3xl .leading-9.capsize::before, .text-3xl .font-serif.leading-9.capsize::before, .text-3xl .font-serif .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.22em;
  display: table;
}
.font-serif.text-3xl.leading-9.capsize::after, .font-serif .text-3xl.leading-9.capsize::after, .font-serif .text-3xl .leading-9.capsize::after, .text-3xl .font-serif.leading-9.capsize::after, .text-3xl .font-serif .leading-9.capsize::after {
  content: '';
  margin-top: -0.2em;
  display: table;
}
.font-serif.text-3xl.leading-10.capsize::before, .font-serif .text-3xl.leading-10.capsize::before, .font-serif .text-3xl .leading-10.capsize::before, .text-3xl .font-serif.leading-10.capsize::before, .text-3xl .font-serif .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.2867em;
  display: table;
}
.font-serif.text-3xl.leading-10.capsize::after, .font-serif .text-3xl.leading-10.capsize::after, .font-serif .text-3xl .leading-10.capsize::after, .text-3xl .font-serif.leading-10.capsize::after, .text-3xl .font-serif .leading-10.capsize::after {
  content: '';
  margin-top: -0.2667em;
  display: table;
}
.font-serif.text-3xl.leading-none.capsize::before, .font-serif .text-3xl.leading-none.capsize::before, .font-serif .text-3xl .leading-none.capsize::before, .text-3xl .font-serif.leading-none.capsize::before, .text-3xl .font-serif .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-3xl.leading-none.capsize::after, .font-serif .text-3xl.leading-none.capsize::after, .font-serif .text-3xl .leading-none.capsize::after, .text-3xl .font-serif.leading-none.capsize::after, .text-3xl .font-serif .leading-none.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-3xl.leading-tight.capsize::before, .font-serif .text-3xl.leading-tight.capsize::before, .font-serif .text-3xl .leading-tight.capsize::before, .text-3xl .font-serif.leading-tight.capsize::before, .text-3xl .font-serif .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.245em;
  display: table;
}
.font-serif.text-3xl.leading-tight.capsize::after, .font-serif .text-3xl.leading-tight.capsize::after, .font-serif .text-3xl .leading-tight.capsize::after, .text-3xl .font-serif.leading-tight.capsize::after, .text-3xl .font-serif .leading-tight.capsize::after {
  content: '';
  margin-top: -0.225em;
  display: table;
}
.font-serif.text-3xl.leading-snug.capsize::before, .font-serif .text-3xl.leading-snug.capsize::before, .font-serif .text-3xl .leading-snug.capsize::before, .text-3xl .font-serif.leading-snug.capsize::before, .text-3xl .font-serif .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3075em;
  display: table;
}
.font-serif.text-3xl.leading-snug.capsize::after, .font-serif .text-3xl.leading-snug.capsize::after, .font-serif .text-3xl .leading-snug.capsize::after, .text-3xl .font-serif.leading-snug.capsize::after, .text-3xl .font-serif .leading-snug.capsize::after {
  content: '';
  margin-top: -0.2875em;
  display: table;
}
.font-serif.text-3xl.leading-normal.capsize::before, .font-serif .text-3xl.leading-normal.capsize::before, .font-serif .text-3xl .leading-normal.capsize::before, .text-3xl .font-serif.leading-normal.capsize::before, .text-3xl .font-serif .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.37em;
  display: table;
}
.font-serif.text-3xl.leading-normal.capsize::after, .font-serif .text-3xl.leading-normal.capsize::after, .font-serif .text-3xl .leading-normal.capsize::after, .text-3xl .font-serif.leading-normal.capsize::after, .text-3xl .font-serif .leading-normal.capsize::after {
  content: '';
  margin-top: -0.35em;
  display: table;
}
.font-serif.text-3xl.leading-relaxed.capsize::before, .font-serif .text-3xl.leading-relaxed.capsize::before, .font-serif .text-3xl .leading-relaxed.capsize::before, .text-3xl .font-serif.leading-relaxed.capsize::before, .text-3xl .font-serif .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4325em;
  display: table;
}
.font-serif.text-3xl.leading-relaxed.capsize::after, .font-serif .text-3xl.leading-relaxed.capsize::after, .font-serif .text-3xl .leading-relaxed.capsize::after, .text-3xl .font-serif.leading-relaxed.capsize::after, .text-3xl .font-serif .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4125em;
  display: table;
}
.font-serif.text-3xl.leading-loose.capsize::before, .font-serif .text-3xl.leading-loose.capsize::before, .font-serif .text-3xl .leading-loose.capsize::before, .text-3xl .font-serif.leading-loose.capsize::before, .text-3xl .font-serif .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif.text-3xl.leading-loose.capsize::after, .font-serif .text-3xl.leading-loose.capsize::after, .font-serif .text-3xl .leading-loose.capsize::after, .text-3xl .font-serif.leading-loose.capsize::after, .text-3xl .font-serif .leading-loose.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
.font-serif.text-4xl.leading-3.capsize::before, .font-serif .text-4xl.leading-3.capsize::before, .font-serif .text-4xl .leading-3.capsize::before, .text-4xl .font-serif.leading-3.capsize::before, .text-4xl .font-serif .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.2133em;
  display: table;
}
.font-serif.text-4xl.leading-3.capsize::after, .font-serif .text-4xl.leading-3.capsize::after, .font-serif .text-4xl .leading-3.capsize::after, .text-4xl .font-serif.leading-3.capsize::after, .text-4xl .font-serif .leading-3.capsize::after {
  content: '';
  margin-top: 0.2333em;
  display: table;
}
.font-serif.text-4xl.leading-4.capsize::before, .font-serif .text-4xl.leading-4.capsize::before, .font-serif .text-4xl .leading-4.capsize::before, .text-4xl .font-serif.leading-4.capsize::before, .text-4xl .font-serif .leading-4.capsize::before {
  content: '';
  margin-bottom: 0.1578em;
  display: table;
}
.font-serif.text-4xl.leading-4.capsize::after, .font-serif .text-4xl.leading-4.capsize::after, .font-serif .text-4xl .leading-4.capsize::after, .text-4xl .font-serif.leading-4.capsize::after, .text-4xl .font-serif .leading-4.capsize::after {
  content: '';
  margin-top: 0.1778em;
  display: table;
}
.font-serif.text-4xl.leading-5.capsize::before, .font-serif .text-4xl.leading-5.capsize::before, .font-serif .text-4xl .leading-5.capsize::before, .text-4xl .font-serif.leading-5.capsize::before, .text-4xl .font-serif .leading-5.capsize::before {
  content: '';
  margin-bottom: 0.1022em;
  display: table;
}
.font-serif.text-4xl.leading-5.capsize::after, .font-serif .text-4xl.leading-5.capsize::after, .font-serif .text-4xl .leading-5.capsize::after, .text-4xl .font-serif.leading-5.capsize::after, .text-4xl .font-serif .leading-5.capsize::after {
  content: '';
  margin-top: 0.1222em;
  display: table;
}
.font-serif.text-4xl.leading-6.capsize::before, .font-serif .text-4xl.leading-6.capsize::before, .font-serif .text-4xl .leading-6.capsize::before, .text-4xl .font-serif.leading-6.capsize::before, .text-4xl .font-serif .leading-6.capsize::before {
  content: '';
  margin-bottom: 0.0467em;
  display: table;
}
.font-serif.text-4xl.leading-6.capsize::after, .font-serif .text-4xl.leading-6.capsize::after, .font-serif .text-4xl .leading-6.capsize::after, .text-4xl .font-serif.leading-6.capsize::after, .text-4xl .font-serif .leading-6.capsize::after {
  content: '';
  margin-top: 0.0667em;
  display: table;
}
.font-serif.text-4xl.leading-7.capsize::before, .font-serif .text-4xl.leading-7.capsize::before, .font-serif .text-4xl .leading-7.capsize::before, .text-4xl .font-serif.leading-7.capsize::before, .text-4xl .font-serif .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.0089em;
  display: table;
}
.font-serif.text-4xl.leading-7.capsize::after, .font-serif .text-4xl.leading-7.capsize::after, .font-serif .text-4xl .leading-7.capsize::after, .text-4xl .font-serif.leading-7.capsize::after, .text-4xl .font-serif .leading-7.capsize::after {
  content: '';
  margin-top: 0.0111em;
  display: table;
}
.font-serif.text-4xl.leading-8.capsize::before, .font-serif .text-4xl.leading-8.capsize::before, .font-serif .text-4xl .leading-8.capsize::before, .text-4xl .font-serif.leading-8.capsize::before, .text-4xl .font-serif .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.0644em;
  display: table;
}
.font-serif.text-4xl.leading-8.capsize::after, .font-serif .text-4xl.leading-8.capsize::after, .font-serif .text-4xl .leading-8.capsize::after, .text-4xl .font-serif.leading-8.capsize::after, .text-4xl .font-serif .leading-8.capsize::after {
  content: '';
  margin-top: -0.0444em;
  display: table;
}
.font-serif.text-4xl.leading-9.capsize::before, .font-serif .text-4xl.leading-9.capsize::before, .font-serif .text-4xl .leading-9.capsize::before, .text-4xl .font-serif.leading-9.capsize::before, .text-4xl .font-serif .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-4xl.leading-9.capsize::after, .font-serif .text-4xl.leading-9.capsize::after, .font-serif .text-4xl .leading-9.capsize::after, .text-4xl .font-serif.leading-9.capsize::after, .text-4xl .font-serif .leading-9.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-4xl.leading-10.capsize::before, .font-serif .text-4xl.leading-10.capsize::before, .font-serif .text-4xl .leading-10.capsize::before, .text-4xl .font-serif.leading-10.capsize::before, .text-4xl .font-serif .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.1756em;
  display: table;
}
.font-serif.text-4xl.leading-10.capsize::after, .font-serif .text-4xl.leading-10.capsize::after, .font-serif .text-4xl .leading-10.capsize::after, .text-4xl .font-serif.leading-10.capsize::after, .text-4xl .font-serif .leading-10.capsize::after {
  content: '';
  margin-top: -0.1556em;
  display: table;
}
.font-serif.text-4xl.leading-none.capsize::before, .font-serif .text-4xl.leading-none.capsize::before, .font-serif .text-4xl .leading-none.capsize::before, .text-4xl .font-serif.leading-none.capsize::before, .text-4xl .font-serif .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-4xl.leading-none.capsize::after, .font-serif .text-4xl.leading-none.capsize::after, .font-serif .text-4xl .leading-none.capsize::after, .text-4xl .font-serif.leading-none.capsize::after, .text-4xl .font-serif .leading-none.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-4xl.leading-tight.capsize::before, .font-serif .text-4xl.leading-tight.capsize::before, .font-serif .text-4xl .leading-tight.capsize::before, .text-4xl .font-serif.leading-tight.capsize::before, .text-4xl .font-serif .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.245em;
  display: table;
}
.font-serif.text-4xl.leading-tight.capsize::after, .font-serif .text-4xl.leading-tight.capsize::after, .font-serif .text-4xl .leading-tight.capsize::after, .text-4xl .font-serif.leading-tight.capsize::after, .text-4xl .font-serif .leading-tight.capsize::after {
  content: '';
  margin-top: -0.225em;
  display: table;
}
.font-serif.text-4xl.leading-snug.capsize::before, .font-serif .text-4xl.leading-snug.capsize::before, .font-serif .text-4xl .leading-snug.capsize::before, .text-4xl .font-serif.leading-snug.capsize::before, .text-4xl .font-serif .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3075em;
  display: table;
}
.font-serif.text-4xl.leading-snug.capsize::after, .font-serif .text-4xl.leading-snug.capsize::after, .font-serif .text-4xl .leading-snug.capsize::after, .text-4xl .font-serif.leading-snug.capsize::after, .text-4xl .font-serif .leading-snug.capsize::after {
  content: '';
  margin-top: -0.2875em;
  display: table;
}
.font-serif.text-4xl.leading-normal.capsize::before, .font-serif .text-4xl.leading-normal.capsize::before, .font-serif .text-4xl .leading-normal.capsize::before, .text-4xl .font-serif.leading-normal.capsize::before, .text-4xl .font-serif .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.37em;
  display: table;
}
.font-serif.text-4xl.leading-normal.capsize::after, .font-serif .text-4xl.leading-normal.capsize::after, .font-serif .text-4xl .leading-normal.capsize::after, .text-4xl .font-serif.leading-normal.capsize::after, .text-4xl .font-serif .leading-normal.capsize::after {
  content: '';
  margin-top: -0.35em;
  display: table;
}
.font-serif.text-4xl.leading-relaxed.capsize::before, .font-serif .text-4xl.leading-relaxed.capsize::before, .font-serif .text-4xl .leading-relaxed.capsize::before, .text-4xl .font-serif.leading-relaxed.capsize::before, .text-4xl .font-serif .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4325em;
  display: table;
}
.font-serif.text-4xl.leading-relaxed.capsize::after, .font-serif .text-4xl.leading-relaxed.capsize::after, .font-serif .text-4xl .leading-relaxed.capsize::after, .text-4xl .font-serif.leading-relaxed.capsize::after, .text-4xl .font-serif .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4125em;
  display: table;
}
.font-serif.text-4xl.leading-loose.capsize::before, .font-serif .text-4xl.leading-loose.capsize::before, .font-serif .text-4xl .leading-loose.capsize::before, .text-4xl .font-serif.leading-loose.capsize::before, .text-4xl .font-serif .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif.text-4xl.leading-loose.capsize::after, .font-serif .text-4xl.leading-loose.capsize::after, .font-serif .text-4xl .leading-loose.capsize::after, .text-4xl .font-serif.leading-loose.capsize::after, .text-4xl .font-serif .leading-loose.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
.font-serif.text-5xl.leading-3.capsize::before, .font-serif .text-5xl.leading-3.capsize::before, .font-serif .text-5xl .leading-3.capsize::before, .text-5xl .font-serif.leading-3.capsize::before, .text-5xl .font-serif .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.255em;
  display: table;
}
.font-serif.text-5xl.leading-3.capsize::after, .font-serif .text-5xl.leading-3.capsize::after, .font-serif .text-5xl .leading-3.capsize::after, .text-5xl .font-serif.leading-3.capsize::after, .text-5xl .font-serif .leading-3.capsize::after {
  content: '';
  margin-top: 0.275em;
  display: table;
}
.font-serif.text-5xl.leading-4.capsize::before, .font-serif .text-5xl.leading-4.capsize::before, .font-serif .text-5xl .leading-4.capsize::before, .text-5xl .font-serif.leading-4.capsize::before, .text-5xl .font-serif .leading-4.capsize::before {
  content: '';
  margin-bottom: 0.2133em;
  display: table;
}
.font-serif.text-5xl.leading-4.capsize::after, .font-serif .text-5xl.leading-4.capsize::after, .font-serif .text-5xl .leading-4.capsize::after, .text-5xl .font-serif.leading-4.capsize::after, .text-5xl .font-serif .leading-4.capsize::after {
  content: '';
  margin-top: 0.2333em;
  display: table;
}
.font-serif.text-5xl.leading-5.capsize::before, .font-serif .text-5xl.leading-5.capsize::before, .font-serif .text-5xl .leading-5.capsize::before, .text-5xl .font-serif.leading-5.capsize::before, .text-5xl .font-serif .leading-5.capsize::before {
  content: '';
  margin-bottom: 0.1717em;
  display: table;
}
.font-serif.text-5xl.leading-5.capsize::after, .font-serif .text-5xl.leading-5.capsize::after, .font-serif .text-5xl .leading-5.capsize::after, .text-5xl .font-serif.leading-5.capsize::after, .text-5xl .font-serif .leading-5.capsize::after {
  content: '';
  margin-top: 0.1917em;
  display: table;
}
.font-serif.text-5xl.leading-6.capsize::before, .font-serif .text-5xl.leading-6.capsize::before, .font-serif .text-5xl .leading-6.capsize::before, .text-5xl .font-serif.leading-6.capsize::before, .text-5xl .font-serif .leading-6.capsize::before {
  content: '';
  margin-bottom: 0.13em;
  display: table;
}
.font-serif.text-5xl.leading-6.capsize::after, .font-serif .text-5xl.leading-6.capsize::after, .font-serif .text-5xl .leading-6.capsize::after, .text-5xl .font-serif.leading-6.capsize::after, .text-5xl .font-serif .leading-6.capsize::after {
  content: '';
  margin-top: 0.15em;
  display: table;
}
.font-serif.text-5xl.leading-7.capsize::before, .font-serif .text-5xl.leading-7.capsize::before, .font-serif .text-5xl .leading-7.capsize::before, .text-5xl .font-serif.leading-7.capsize::before, .text-5xl .font-serif .leading-7.capsize::before {
  content: '';
  margin-bottom: 0.0883em;
  display: table;
}
.font-serif.text-5xl.leading-7.capsize::after, .font-serif .text-5xl.leading-7.capsize::after, .font-serif .text-5xl .leading-7.capsize::after, .text-5xl .font-serif.leading-7.capsize::after, .text-5xl .font-serif .leading-7.capsize::after {
  content: '';
  margin-top: 0.1083em;
  display: table;
}
.font-serif.text-5xl.leading-8.capsize::before, .font-serif .text-5xl.leading-8.capsize::before, .font-serif .text-5xl .leading-8.capsize::before, .text-5xl .font-serif.leading-8.capsize::before, .text-5xl .font-serif .leading-8.capsize::before {
  content: '';
  margin-bottom: 0.0467em;
  display: table;
}
.font-serif.text-5xl.leading-8.capsize::after, .font-serif .text-5xl.leading-8.capsize::after, .font-serif .text-5xl .leading-8.capsize::after, .text-5xl .font-serif.leading-8.capsize::after, .text-5xl .font-serif .leading-8.capsize::after {
  content: '';
  margin-top: 0.0667em;
  display: table;
}
.font-serif.text-5xl.leading-9.capsize::before, .font-serif .text-5xl.leading-9.capsize::before, .font-serif .text-5xl .leading-9.capsize::before, .text-5xl .font-serif.leading-9.capsize::before, .text-5xl .font-serif .leading-9.capsize::before {
  content: '';
  margin-bottom: 0.005em;
  display: table;
}
.font-serif.text-5xl.leading-9.capsize::after, .font-serif .text-5xl.leading-9.capsize::after, .font-serif .text-5xl .leading-9.capsize::after, .text-5xl .font-serif.leading-9.capsize::after, .text-5xl .font-serif .leading-9.capsize::after {
  content: '';
  margin-top: 0.025em;
  display: table;
}
.font-serif.text-5xl.leading-10.capsize::before, .font-serif .text-5xl.leading-10.capsize::before, .font-serif .text-5xl .leading-10.capsize::before, .text-5xl .font-serif.leading-10.capsize::before, .text-5xl .font-serif .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.0367em;
  display: table;
}
.font-serif.text-5xl.leading-10.capsize::after, .font-serif .text-5xl.leading-10.capsize::after, .font-serif .text-5xl .leading-10.capsize::after, .text-5xl .font-serif.leading-10.capsize::after, .text-5xl .font-serif .leading-10.capsize::after {
  content: '';
  margin-top: -0.0167em;
  display: table;
}
.font-serif.text-5xl.leading-none.capsize::before, .font-serif .text-5xl.leading-none.capsize::before, .font-serif .text-5xl .leading-none.capsize::before, .text-5xl .font-serif.leading-none.capsize::before, .text-5xl .font-serif .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-5xl.leading-none.capsize::after, .font-serif .text-5xl.leading-none.capsize::after, .font-serif .text-5xl .leading-none.capsize::after, .text-5xl .font-serif.leading-none.capsize::after, .text-5xl .font-serif .leading-none.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-5xl.leading-tight.capsize::before, .font-serif .text-5xl.leading-tight.capsize::before, .font-serif .text-5xl .leading-tight.capsize::before, .text-5xl .font-serif.leading-tight.capsize::before, .text-5xl .font-serif .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.245em;
  display: table;
}
.font-serif.text-5xl.leading-tight.capsize::after, .font-serif .text-5xl.leading-tight.capsize::after, .font-serif .text-5xl .leading-tight.capsize::after, .text-5xl .font-serif.leading-tight.capsize::after, .text-5xl .font-serif .leading-tight.capsize::after {
  content: '';
  margin-top: -0.225em;
  display: table;
}
.font-serif.text-5xl.leading-snug.capsize::before, .font-serif .text-5xl.leading-snug.capsize::before, .font-serif .text-5xl .leading-snug.capsize::before, .text-5xl .font-serif.leading-snug.capsize::before, .text-5xl .font-serif .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3075em;
  display: table;
}
.font-serif.text-5xl.leading-snug.capsize::after, .font-serif .text-5xl.leading-snug.capsize::after, .font-serif .text-5xl .leading-snug.capsize::after, .text-5xl .font-serif.leading-snug.capsize::after, .text-5xl .font-serif .leading-snug.capsize::after {
  content: '';
  margin-top: -0.2875em;
  display: table;
}
.font-serif.text-5xl.leading-normal.capsize::before, .font-serif .text-5xl.leading-normal.capsize::before, .font-serif .text-5xl .leading-normal.capsize::before, .text-5xl .font-serif.leading-normal.capsize::before, .text-5xl .font-serif .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.37em;
  display: table;
}
.font-serif.text-5xl.leading-normal.capsize::after, .font-serif .text-5xl.leading-normal.capsize::after, .font-serif .text-5xl .leading-normal.capsize::after, .text-5xl .font-serif.leading-normal.capsize::after, .text-5xl .font-serif .leading-normal.capsize::after {
  content: '';
  margin-top: -0.35em;
  display: table;
}
.font-serif.text-5xl.leading-relaxed.capsize::before, .font-serif .text-5xl.leading-relaxed.capsize::before, .font-serif .text-5xl .leading-relaxed.capsize::before, .text-5xl .font-serif.leading-relaxed.capsize::before, .text-5xl .font-serif .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4325em;
  display: table;
}
.font-serif.text-5xl.leading-relaxed.capsize::after, .font-serif .text-5xl.leading-relaxed.capsize::after, .font-serif .text-5xl .leading-relaxed.capsize::after, .text-5xl .font-serif.leading-relaxed.capsize::after, .text-5xl .font-serif .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4125em;
  display: table;
}
.font-serif.text-5xl.leading-loose.capsize::before, .font-serif .text-5xl.leading-loose.capsize::before, .font-serif .text-5xl .leading-loose.capsize::before, .text-5xl .font-serif.leading-loose.capsize::before, .text-5xl .font-serif .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif.text-5xl.leading-loose.capsize::after, .font-serif .text-5xl.leading-loose.capsize::after, .font-serif .text-5xl .leading-loose.capsize::after, .text-5xl .font-serif.leading-loose.capsize::after, .text-5xl .font-serif .leading-loose.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
.font-serif.text-6xl.leading-3.capsize::before, .font-serif .text-6xl.leading-3.capsize::before, .font-serif .text-6xl .leading-3.capsize::before, .text-6xl .font-serif.leading-3.capsize::before, .text-6xl .font-serif .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.28em;
  display: table;
}
.font-serif.text-6xl.leading-3.capsize::after, .font-serif .text-6xl.leading-3.capsize::after, .font-serif .text-6xl .leading-3.capsize::after, .text-6xl .font-serif.leading-3.capsize::after, .text-6xl .font-serif .leading-3.capsize::after {
  content: '';
  margin-top: 0.3em;
  display: table;
}
.font-serif.text-6xl.leading-4.capsize::before, .font-serif .text-6xl.leading-4.capsize::before, .font-serif .text-6xl .leading-4.capsize::before, .text-6xl .font-serif.leading-4.capsize::before, .text-6xl .font-serif .leading-4.capsize::before {
  content: '';
  margin-bottom: 0.2467em;
  display: table;
}
.font-serif.text-6xl.leading-4.capsize::after, .font-serif .text-6xl.leading-4.capsize::after, .font-serif .text-6xl .leading-4.capsize::after, .text-6xl .font-serif.leading-4.capsize::after, .text-6xl .font-serif .leading-4.capsize::after {
  content: '';
  margin-top: 0.2667em;
  display: table;
}
.font-serif.text-6xl.leading-5.capsize::before, .font-serif .text-6xl.leading-5.capsize::before, .font-serif .text-6xl .leading-5.capsize::before, .text-6xl .font-serif.leading-5.capsize::before, .text-6xl .font-serif .leading-5.capsize::before {
  content: '';
  margin-bottom: 0.2133em;
  display: table;
}
.font-serif.text-6xl.leading-5.capsize::after, .font-serif .text-6xl.leading-5.capsize::after, .font-serif .text-6xl .leading-5.capsize::after, .text-6xl .font-serif.leading-5.capsize::after, .text-6xl .font-serif .leading-5.capsize::after {
  content: '';
  margin-top: 0.2333em;
  display: table;
}
.font-serif.text-6xl.leading-6.capsize::before, .font-serif .text-6xl.leading-6.capsize::before, .font-serif .text-6xl .leading-6.capsize::before, .text-6xl .font-serif.leading-6.capsize::before, .text-6xl .font-serif .leading-6.capsize::before {
  content: '';
  margin-bottom: 0.18em;
  display: table;
}
.font-serif.text-6xl.leading-6.capsize::after, .font-serif .text-6xl.leading-6.capsize::after, .font-serif .text-6xl .leading-6.capsize::after, .text-6xl .font-serif.leading-6.capsize::after, .text-6xl .font-serif .leading-6.capsize::after {
  content: '';
  margin-top: 0.2em;
  display: table;
}
.font-serif.text-6xl.leading-7.capsize::before, .font-serif .text-6xl.leading-7.capsize::before, .font-serif .text-6xl .leading-7.capsize::before, .text-6xl .font-serif.leading-7.capsize::before, .text-6xl .font-serif .leading-7.capsize::before {
  content: '';
  margin-bottom: 0.1467em;
  display: table;
}
.font-serif.text-6xl.leading-7.capsize::after, .font-serif .text-6xl.leading-7.capsize::after, .font-serif .text-6xl .leading-7.capsize::after, .text-6xl .font-serif.leading-7.capsize::after, .text-6xl .font-serif .leading-7.capsize::after {
  content: '';
  margin-top: 0.1667em;
  display: table;
}
.font-serif.text-6xl.leading-8.capsize::before, .font-serif .text-6xl.leading-8.capsize::before, .font-serif .text-6xl .leading-8.capsize::before, .text-6xl .font-serif.leading-8.capsize::before, .text-6xl .font-serif .leading-8.capsize::before {
  content: '';
  margin-bottom: 0.1133em;
  display: table;
}
.font-serif.text-6xl.leading-8.capsize::after, .font-serif .text-6xl.leading-8.capsize::after, .font-serif .text-6xl .leading-8.capsize::after, .text-6xl .font-serif.leading-8.capsize::after, .text-6xl .font-serif .leading-8.capsize::after {
  content: '';
  margin-top: 0.1333em;
  display: table;
}
.font-serif.text-6xl.leading-9.capsize::before, .font-serif .text-6xl.leading-9.capsize::before, .font-serif .text-6xl .leading-9.capsize::before, .text-6xl .font-serif.leading-9.capsize::before, .text-6xl .font-serif .leading-9.capsize::before {
  content: '';
  margin-bottom: 0.08em;
  display: table;
}
.font-serif.text-6xl.leading-9.capsize::after, .font-serif .text-6xl.leading-9.capsize::after, .font-serif .text-6xl .leading-9.capsize::after, .text-6xl .font-serif.leading-9.capsize::after, .text-6xl .font-serif .leading-9.capsize::after {
  content: '';
  margin-top: 0.1em;
  display: table;
}
.font-serif.text-6xl.leading-10.capsize::before, .font-serif .text-6xl.leading-10.capsize::before, .font-serif .text-6xl .leading-10.capsize::before, .text-6xl .font-serif.leading-10.capsize::before, .text-6xl .font-serif .leading-10.capsize::before {
  content: '';
  margin-bottom: 0.0467em;
  display: table;
}
.font-serif.text-6xl.leading-10.capsize::after, .font-serif .text-6xl.leading-10.capsize::after, .font-serif .text-6xl .leading-10.capsize::after, .text-6xl .font-serif.leading-10.capsize::after, .text-6xl .font-serif .leading-10.capsize::after {
  content: '';
  margin-top: 0.0667em;
  display: table;
}
.font-serif.text-6xl.leading-none.capsize::before, .font-serif .text-6xl.leading-none.capsize::before, .font-serif .text-6xl .leading-none.capsize::before, .text-6xl .font-serif.leading-none.capsize::before, .text-6xl .font-serif .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-6xl.leading-none.capsize::after, .font-serif .text-6xl.leading-none.capsize::after, .font-serif .text-6xl .leading-none.capsize::after, .text-6xl .font-serif.leading-none.capsize::after, .text-6xl .font-serif .leading-none.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-6xl.leading-tight.capsize::before, .font-serif .text-6xl.leading-tight.capsize::before, .font-serif .text-6xl .leading-tight.capsize::before, .text-6xl .font-serif.leading-tight.capsize::before, .text-6xl .font-serif .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.245em;
  display: table;
}
.font-serif.text-6xl.leading-tight.capsize::after, .font-serif .text-6xl.leading-tight.capsize::after, .font-serif .text-6xl .leading-tight.capsize::after, .text-6xl .font-serif.leading-tight.capsize::after, .text-6xl .font-serif .leading-tight.capsize::after {
  content: '';
  margin-top: -0.225em;
  display: table;
}
.font-serif.text-6xl.leading-snug.capsize::before, .font-serif .text-6xl.leading-snug.capsize::before, .font-serif .text-6xl .leading-snug.capsize::before, .text-6xl .font-serif.leading-snug.capsize::before, .text-6xl .font-serif .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3075em;
  display: table;
}
.font-serif.text-6xl.leading-snug.capsize::after, .font-serif .text-6xl.leading-snug.capsize::after, .font-serif .text-6xl .leading-snug.capsize::after, .text-6xl .font-serif.leading-snug.capsize::after, .text-6xl .font-serif .leading-snug.capsize::after {
  content: '';
  margin-top: -0.2875em;
  display: table;
}
.font-serif.text-6xl.leading-normal.capsize::before, .font-serif .text-6xl.leading-normal.capsize::before, .font-serif .text-6xl .leading-normal.capsize::before, .text-6xl .font-serif.leading-normal.capsize::before, .text-6xl .font-serif .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.37em;
  display: table;
}
.font-serif.text-6xl.leading-normal.capsize::after, .font-serif .text-6xl.leading-normal.capsize::after, .font-serif .text-6xl .leading-normal.capsize::after, .text-6xl .font-serif.leading-normal.capsize::after, .text-6xl .font-serif .leading-normal.capsize::after {
  content: '';
  margin-top: -0.35em;
  display: table;
}
.font-serif.text-6xl.leading-relaxed.capsize::before, .font-serif .text-6xl.leading-relaxed.capsize::before, .font-serif .text-6xl .leading-relaxed.capsize::before, .text-6xl .font-serif.leading-relaxed.capsize::before, .text-6xl .font-serif .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4325em;
  display: table;
}
.font-serif.text-6xl.leading-relaxed.capsize::after, .font-serif .text-6xl.leading-relaxed.capsize::after, .font-serif .text-6xl .leading-relaxed.capsize::after, .text-6xl .font-serif.leading-relaxed.capsize::after, .text-6xl .font-serif .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4125em;
  display: table;
}
.font-serif.text-6xl.leading-loose.capsize::before, .font-serif .text-6xl.leading-loose.capsize::before, .font-serif .text-6xl .leading-loose.capsize::before, .text-6xl .font-serif.leading-loose.capsize::before, .text-6xl .font-serif .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif.text-6xl.leading-loose.capsize::after, .font-serif .text-6xl.leading-loose.capsize::after, .font-serif .text-6xl .leading-loose.capsize::after, .text-6xl .font-serif.leading-loose.capsize::after, .text-6xl .font-serif .leading-loose.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
.font-serif.text-7xl.leading-3.capsize::before, .font-serif .text-7xl.leading-3.capsize::before, .font-serif .text-7xl .leading-3.capsize::before, .text-7xl .font-serif.leading-3.capsize::before, .text-7xl .font-serif .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.2967em;
  display: table;
}
.font-serif.text-7xl.leading-3.capsize::after, .font-serif .text-7xl.leading-3.capsize::after, .font-serif .text-7xl .leading-3.capsize::after, .text-7xl .font-serif.leading-3.capsize::after, .text-7xl .font-serif .leading-3.capsize::after {
  content: '';
  margin-top: 0.3167em;
  display: table;
}
.font-serif.text-7xl.leading-4.capsize::before, .font-serif .text-7xl.leading-4.capsize::before, .font-serif .text-7xl .leading-4.capsize::before, .text-7xl .font-serif.leading-4.capsize::before, .text-7xl .font-serif .leading-4.capsize::before {
  content: '';
  margin-bottom: 0.2689em;
  display: table;
}
.font-serif.text-7xl.leading-4.capsize::after, .font-serif .text-7xl.leading-4.capsize::after, .font-serif .text-7xl .leading-4.capsize::after, .text-7xl .font-serif.leading-4.capsize::after, .text-7xl .font-serif .leading-4.capsize::after {
  content: '';
  margin-top: 0.2889em;
  display: table;
}
.font-serif.text-7xl.leading-5.capsize::before, .font-serif .text-7xl.leading-5.capsize::before, .font-serif .text-7xl .leading-5.capsize::before, .text-7xl .font-serif.leading-5.capsize::before, .text-7xl .font-serif .leading-5.capsize::before {
  content: '';
  margin-bottom: 0.2411em;
  display: table;
}
.font-serif.text-7xl.leading-5.capsize::after, .font-serif .text-7xl.leading-5.capsize::after, .font-serif .text-7xl .leading-5.capsize::after, .text-7xl .font-serif.leading-5.capsize::after, .text-7xl .font-serif .leading-5.capsize::after {
  content: '';
  margin-top: 0.2611em;
  display: table;
}
.font-serif.text-7xl.leading-6.capsize::before, .font-serif .text-7xl.leading-6.capsize::before, .font-serif .text-7xl .leading-6.capsize::before, .text-7xl .font-serif.leading-6.capsize::before, .text-7xl .font-serif .leading-6.capsize::before {
  content: '';
  margin-bottom: 0.2133em;
  display: table;
}
.font-serif.text-7xl.leading-6.capsize::after, .font-serif .text-7xl.leading-6.capsize::after, .font-serif .text-7xl .leading-6.capsize::after, .text-7xl .font-serif.leading-6.capsize::after, .text-7xl .font-serif .leading-6.capsize::after {
  content: '';
  margin-top: 0.2333em;
  display: table;
}
.font-serif.text-7xl.leading-7.capsize::before, .font-serif .text-7xl.leading-7.capsize::before, .font-serif .text-7xl .leading-7.capsize::before, .text-7xl .font-serif.leading-7.capsize::before, .text-7xl .font-serif .leading-7.capsize::before {
  content: '';
  margin-bottom: 0.1856em;
  display: table;
}
.font-serif.text-7xl.leading-7.capsize::after, .font-serif .text-7xl.leading-7.capsize::after, .font-serif .text-7xl .leading-7.capsize::after, .text-7xl .font-serif.leading-7.capsize::after, .text-7xl .font-serif .leading-7.capsize::after {
  content: '';
  margin-top: 0.2056em;
  display: table;
}
.font-serif.text-7xl.leading-8.capsize::before, .font-serif .text-7xl.leading-8.capsize::before, .font-serif .text-7xl .leading-8.capsize::before, .text-7xl .font-serif.leading-8.capsize::before, .text-7xl .font-serif .leading-8.capsize::before {
  content: '';
  margin-bottom: 0.1578em;
  display: table;
}
.font-serif.text-7xl.leading-8.capsize::after, .font-serif .text-7xl.leading-8.capsize::after, .font-serif .text-7xl .leading-8.capsize::after, .text-7xl .font-serif.leading-8.capsize::after, .text-7xl .font-serif .leading-8.capsize::after {
  content: '';
  margin-top: 0.1778em;
  display: table;
}
.font-serif.text-7xl.leading-9.capsize::before, .font-serif .text-7xl.leading-9.capsize::before, .font-serif .text-7xl .leading-9.capsize::before, .text-7xl .font-serif.leading-9.capsize::before, .text-7xl .font-serif .leading-9.capsize::before {
  content: '';
  margin-bottom: 0.13em;
  display: table;
}
.font-serif.text-7xl.leading-9.capsize::after, .font-serif .text-7xl.leading-9.capsize::after, .font-serif .text-7xl .leading-9.capsize::after, .text-7xl .font-serif.leading-9.capsize::after, .text-7xl .font-serif .leading-9.capsize::after {
  content: '';
  margin-top: 0.15em;
  display: table;
}
.font-serif.text-7xl.leading-10.capsize::before, .font-serif .text-7xl.leading-10.capsize::before, .font-serif .text-7xl .leading-10.capsize::before, .text-7xl .font-serif.leading-10.capsize::before, .text-7xl .font-serif .leading-10.capsize::before {
  content: '';
  margin-bottom: 0.1022em;
  display: table;
}
.font-serif.text-7xl.leading-10.capsize::after, .font-serif .text-7xl.leading-10.capsize::after, .font-serif .text-7xl .leading-10.capsize::after, .text-7xl .font-serif.leading-10.capsize::after, .text-7xl .font-serif .leading-10.capsize::after {
  content: '';
  margin-top: 0.1222em;
  display: table;
}
.font-serif.text-7xl.leading-none.capsize::before, .font-serif .text-7xl.leading-none.capsize::before, .font-serif .text-7xl .leading-none.capsize::before, .text-7xl .font-serif.leading-none.capsize::before, .text-7xl .font-serif .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-7xl.leading-none.capsize::after, .font-serif .text-7xl.leading-none.capsize::after, .font-serif .text-7xl .leading-none.capsize::after, .text-7xl .font-serif.leading-none.capsize::after, .text-7xl .font-serif .leading-none.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-7xl.leading-tight.capsize::before, .font-serif .text-7xl.leading-tight.capsize::before, .font-serif .text-7xl .leading-tight.capsize::before, .text-7xl .font-serif.leading-tight.capsize::before, .text-7xl .font-serif .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.245em;
  display: table;
}
.font-serif.text-7xl.leading-tight.capsize::after, .font-serif .text-7xl.leading-tight.capsize::after, .font-serif .text-7xl .leading-tight.capsize::after, .text-7xl .font-serif.leading-tight.capsize::after, .text-7xl .font-serif .leading-tight.capsize::after {
  content: '';
  margin-top: -0.225em;
  display: table;
}
.font-serif.text-7xl.leading-snug.capsize::before, .font-serif .text-7xl.leading-snug.capsize::before, .font-serif .text-7xl .leading-snug.capsize::before, .text-7xl .font-serif.leading-snug.capsize::before, .text-7xl .font-serif .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3075em;
  display: table;
}
.font-serif.text-7xl.leading-snug.capsize::after, .font-serif .text-7xl.leading-snug.capsize::after, .font-serif .text-7xl .leading-snug.capsize::after, .text-7xl .font-serif.leading-snug.capsize::after, .text-7xl .font-serif .leading-snug.capsize::after {
  content: '';
  margin-top: -0.2875em;
  display: table;
}
.font-serif.text-7xl.leading-normal.capsize::before, .font-serif .text-7xl.leading-normal.capsize::before, .font-serif .text-7xl .leading-normal.capsize::before, .text-7xl .font-serif.leading-normal.capsize::before, .text-7xl .font-serif .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.37em;
  display: table;
}
.font-serif.text-7xl.leading-normal.capsize::after, .font-serif .text-7xl.leading-normal.capsize::after, .font-serif .text-7xl .leading-normal.capsize::after, .text-7xl .font-serif.leading-normal.capsize::after, .text-7xl .font-serif .leading-normal.capsize::after {
  content: '';
  margin-top: -0.35em;
  display: table;
}
.font-serif.text-7xl.leading-relaxed.capsize::before, .font-serif .text-7xl.leading-relaxed.capsize::before, .font-serif .text-7xl .leading-relaxed.capsize::before, .text-7xl .font-serif.leading-relaxed.capsize::before, .text-7xl .font-serif .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4325em;
  display: table;
}
.font-serif.text-7xl.leading-relaxed.capsize::after, .font-serif .text-7xl.leading-relaxed.capsize::after, .font-serif .text-7xl .leading-relaxed.capsize::after, .text-7xl .font-serif.leading-relaxed.capsize::after, .text-7xl .font-serif .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4125em;
  display: table;
}
.font-serif.text-7xl.leading-loose.capsize::before, .font-serif .text-7xl.leading-loose.capsize::before, .font-serif .text-7xl .leading-loose.capsize::before, .text-7xl .font-serif.leading-loose.capsize::before, .text-7xl .font-serif .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif.text-7xl.leading-loose.capsize::after, .font-serif .text-7xl.leading-loose.capsize::after, .font-serif .text-7xl .leading-loose.capsize::after, .text-7xl .font-serif.leading-loose.capsize::after, .text-7xl .font-serif .leading-loose.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
.font-serif.text-8xl.leading-3.capsize::before, .font-serif .text-8xl.leading-3.capsize::before, .font-serif .text-8xl .leading-3.capsize::before, .text-8xl .font-serif.leading-3.capsize::before, .text-8xl .font-serif .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.3175em;
  display: table;
}
.font-serif.text-8xl.leading-3.capsize::after, .font-serif .text-8xl.leading-3.capsize::after, .font-serif .text-8xl .leading-3.capsize::after, .text-8xl .font-serif.leading-3.capsize::after, .text-8xl .font-serif .leading-3.capsize::after {
  content: '';
  margin-top: 0.3375em;
  display: table;
}
.font-serif.text-8xl.leading-4.capsize::before, .font-serif .text-8xl.leading-4.capsize::before, .font-serif .text-8xl .leading-4.capsize::before, .text-8xl .font-serif.leading-4.capsize::before, .text-8xl .font-serif .leading-4.capsize::before {
  content: '';
  margin-bottom: 0.2967em;
  display: table;
}
.font-serif.text-8xl.leading-4.capsize::after, .font-serif .text-8xl.leading-4.capsize::after, .font-serif .text-8xl .leading-4.capsize::after, .text-8xl .font-serif.leading-4.capsize::after, .text-8xl .font-serif .leading-4.capsize::after {
  content: '';
  margin-top: 0.3167em;
  display: table;
}
.font-serif.text-8xl.leading-5.capsize::before, .font-serif .text-8xl.leading-5.capsize::before, .font-serif .text-8xl .leading-5.capsize::before, .text-8xl .font-serif.leading-5.capsize::before, .text-8xl .font-serif .leading-5.capsize::before {
  content: '';
  margin-bottom: 0.2758em;
  display: table;
}
.font-serif.text-8xl.leading-5.capsize::after, .font-serif .text-8xl.leading-5.capsize::after, .font-serif .text-8xl .leading-5.capsize::after, .text-8xl .font-serif.leading-5.capsize::after, .text-8xl .font-serif .leading-5.capsize::after {
  content: '';
  margin-top: 0.2958em;
  display: table;
}
.font-serif.text-8xl.leading-6.capsize::before, .font-serif .text-8xl.leading-6.capsize::before, .font-serif .text-8xl .leading-6.capsize::before, .text-8xl .font-serif.leading-6.capsize::before, .text-8xl .font-serif .leading-6.capsize::before {
  content: '';
  margin-bottom: 0.255em;
  display: table;
}
.font-serif.text-8xl.leading-6.capsize::after, .font-serif .text-8xl.leading-6.capsize::after, .font-serif .text-8xl .leading-6.capsize::after, .text-8xl .font-serif.leading-6.capsize::after, .text-8xl .font-serif .leading-6.capsize::after {
  content: '';
  margin-top: 0.275em;
  display: table;
}
.font-serif.text-8xl.leading-7.capsize::before, .font-serif .text-8xl.leading-7.capsize::before, .font-serif .text-8xl .leading-7.capsize::before, .text-8xl .font-serif.leading-7.capsize::before, .text-8xl .font-serif .leading-7.capsize::before {
  content: '';
  margin-bottom: 0.2342em;
  display: table;
}
.font-serif.text-8xl.leading-7.capsize::after, .font-serif .text-8xl.leading-7.capsize::after, .font-serif .text-8xl .leading-7.capsize::after, .text-8xl .font-serif.leading-7.capsize::after, .text-8xl .font-serif .leading-7.capsize::after {
  content: '';
  margin-top: 0.2542em;
  display: table;
}
.font-serif.text-8xl.leading-8.capsize::before, .font-serif .text-8xl.leading-8.capsize::before, .font-serif .text-8xl .leading-8.capsize::before, .text-8xl .font-serif.leading-8.capsize::before, .text-8xl .font-serif .leading-8.capsize::before {
  content: '';
  margin-bottom: 0.2133em;
  display: table;
}
.font-serif.text-8xl.leading-8.capsize::after, .font-serif .text-8xl.leading-8.capsize::after, .font-serif .text-8xl .leading-8.capsize::after, .text-8xl .font-serif.leading-8.capsize::after, .text-8xl .font-serif .leading-8.capsize::after {
  content: '';
  margin-top: 0.2333em;
  display: table;
}
.font-serif.text-8xl.leading-9.capsize::before, .font-serif .text-8xl.leading-9.capsize::before, .font-serif .text-8xl .leading-9.capsize::before, .text-8xl .font-serif.leading-9.capsize::before, .text-8xl .font-serif .leading-9.capsize::before {
  content: '';
  margin-bottom: 0.1925em;
  display: table;
}
.font-serif.text-8xl.leading-9.capsize::after, .font-serif .text-8xl.leading-9.capsize::after, .font-serif .text-8xl .leading-9.capsize::after, .text-8xl .font-serif.leading-9.capsize::after, .text-8xl .font-serif .leading-9.capsize::after {
  content: '';
  margin-top: 0.2125em;
  display: table;
}
.font-serif.text-8xl.leading-10.capsize::before, .font-serif .text-8xl.leading-10.capsize::before, .font-serif .text-8xl .leading-10.capsize::before, .text-8xl .font-serif.leading-10.capsize::before, .text-8xl .font-serif .leading-10.capsize::before {
  content: '';
  margin-bottom: 0.1717em;
  display: table;
}
.font-serif.text-8xl.leading-10.capsize::after, .font-serif .text-8xl.leading-10.capsize::after, .font-serif .text-8xl .leading-10.capsize::after, .text-8xl .font-serif.leading-10.capsize::after, .text-8xl .font-serif .leading-10.capsize::after {
  content: '';
  margin-top: 0.1917em;
  display: table;
}
.font-serif.text-8xl.leading-none.capsize::before, .font-serif .text-8xl.leading-none.capsize::before, .font-serif .text-8xl .leading-none.capsize::before, .text-8xl .font-serif.leading-none.capsize::before, .text-8xl .font-serif .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-8xl.leading-none.capsize::after, .font-serif .text-8xl.leading-none.capsize::after, .font-serif .text-8xl .leading-none.capsize::after, .text-8xl .font-serif.leading-none.capsize::after, .text-8xl .font-serif .leading-none.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-8xl.leading-tight.capsize::before, .font-serif .text-8xl.leading-tight.capsize::before, .font-serif .text-8xl .leading-tight.capsize::before, .text-8xl .font-serif.leading-tight.capsize::before, .text-8xl .font-serif .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.245em;
  display: table;
}
.font-serif.text-8xl.leading-tight.capsize::after, .font-serif .text-8xl.leading-tight.capsize::after, .font-serif .text-8xl .leading-tight.capsize::after, .text-8xl .font-serif.leading-tight.capsize::after, .text-8xl .font-serif .leading-tight.capsize::after {
  content: '';
  margin-top: -0.225em;
  display: table;
}
.font-serif.text-8xl.leading-snug.capsize::before, .font-serif .text-8xl.leading-snug.capsize::before, .font-serif .text-8xl .leading-snug.capsize::before, .text-8xl .font-serif.leading-snug.capsize::before, .text-8xl .font-serif .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3075em;
  display: table;
}
.font-serif.text-8xl.leading-snug.capsize::after, .font-serif .text-8xl.leading-snug.capsize::after, .font-serif .text-8xl .leading-snug.capsize::after, .text-8xl .font-serif.leading-snug.capsize::after, .text-8xl .font-serif .leading-snug.capsize::after {
  content: '';
  margin-top: -0.2875em;
  display: table;
}
.font-serif.text-8xl.leading-normal.capsize::before, .font-serif .text-8xl.leading-normal.capsize::before, .font-serif .text-8xl .leading-normal.capsize::before, .text-8xl .font-serif.leading-normal.capsize::before, .text-8xl .font-serif .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.37em;
  display: table;
}
.font-serif.text-8xl.leading-normal.capsize::after, .font-serif .text-8xl.leading-normal.capsize::after, .font-serif .text-8xl .leading-normal.capsize::after, .text-8xl .font-serif.leading-normal.capsize::after, .text-8xl .font-serif .leading-normal.capsize::after {
  content: '';
  margin-top: -0.35em;
  display: table;
}
.font-serif.text-8xl.leading-relaxed.capsize::before, .font-serif .text-8xl.leading-relaxed.capsize::before, .font-serif .text-8xl .leading-relaxed.capsize::before, .text-8xl .font-serif.leading-relaxed.capsize::before, .text-8xl .font-serif .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4325em;
  display: table;
}
.font-serif.text-8xl.leading-relaxed.capsize::after, .font-serif .text-8xl.leading-relaxed.capsize::after, .font-serif .text-8xl .leading-relaxed.capsize::after, .text-8xl .font-serif.leading-relaxed.capsize::after, .text-8xl .font-serif .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4125em;
  display: table;
}
.font-serif.text-8xl.leading-loose.capsize::before, .font-serif .text-8xl.leading-loose.capsize::before, .font-serif .text-8xl .leading-loose.capsize::before, .text-8xl .font-serif.leading-loose.capsize::before, .text-8xl .font-serif .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif.text-8xl.leading-loose.capsize::after, .font-serif .text-8xl.leading-loose.capsize::after, .font-serif .text-8xl .leading-loose.capsize::after, .text-8xl .font-serif.leading-loose.capsize::after, .text-8xl .font-serif .leading-loose.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
.font-serif.text-9xl.leading-3.capsize::before, .font-serif .text-9xl.leading-3.capsize::before, .font-serif .text-9xl .leading-3.capsize::before, .text-9xl .font-serif.leading-3.capsize::before, .text-9xl .font-serif .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.3331em;
  display: table;
}
.font-serif.text-9xl.leading-3.capsize::after, .font-serif .text-9xl.leading-3.capsize::after, .font-serif .text-9xl .leading-3.capsize::after, .text-9xl .font-serif.leading-3.capsize::after, .text-9xl .font-serif .leading-3.capsize::after {
  content: '';
  margin-top: 0.3531em;
  display: table;
}
.font-serif.text-9xl.leading-4.capsize::before, .font-serif .text-9xl.leading-4.capsize::before, .font-serif .text-9xl .leading-4.capsize::before, .text-9xl .font-serif.leading-4.capsize::before, .text-9xl .font-serif .leading-4.capsize::before {
  content: '';
  margin-bottom: 0.3175em;
  display: table;
}
.font-serif.text-9xl.leading-4.capsize::after, .font-serif .text-9xl.leading-4.capsize::after, .font-serif .text-9xl .leading-4.capsize::after, .text-9xl .font-serif.leading-4.capsize::after, .text-9xl .font-serif .leading-4.capsize::after {
  content: '';
  margin-top: 0.3375em;
  display: table;
}
.font-serif.text-9xl.leading-5.capsize::before, .font-serif .text-9xl.leading-5.capsize::before, .font-serif .text-9xl .leading-5.capsize::before, .text-9xl .font-serif.leading-5.capsize::before, .text-9xl .font-serif .leading-5.capsize::before {
  content: '';
  margin-bottom: 0.3019em;
  display: table;
}
.font-serif.text-9xl.leading-5.capsize::after, .font-serif .text-9xl.leading-5.capsize::after, .font-serif .text-9xl .leading-5.capsize::after, .text-9xl .font-serif.leading-5.capsize::after, .text-9xl .font-serif .leading-5.capsize::after {
  content: '';
  margin-top: 0.3219em;
  display: table;
}
.font-serif.text-9xl.leading-6.capsize::before, .font-serif .text-9xl.leading-6.capsize::before, .font-serif .text-9xl .leading-6.capsize::before, .text-9xl .font-serif.leading-6.capsize::before, .text-9xl .font-serif .leading-6.capsize::before {
  content: '';
  margin-bottom: 0.2863em;
  display: table;
}
.font-serif.text-9xl.leading-6.capsize::after, .font-serif .text-9xl.leading-6.capsize::after, .font-serif .text-9xl .leading-6.capsize::after, .text-9xl .font-serif.leading-6.capsize::after, .text-9xl .font-serif .leading-6.capsize::after {
  content: '';
  margin-top: 0.3063em;
  display: table;
}
.font-serif.text-9xl.leading-7.capsize::before, .font-serif .text-9xl.leading-7.capsize::before, .font-serif .text-9xl .leading-7.capsize::before, .text-9xl .font-serif.leading-7.capsize::before, .text-9xl .font-serif .leading-7.capsize::before {
  content: '';
  margin-bottom: 0.2706em;
  display: table;
}
.font-serif.text-9xl.leading-7.capsize::after, .font-serif .text-9xl.leading-7.capsize::after, .font-serif .text-9xl .leading-7.capsize::after, .text-9xl .font-serif.leading-7.capsize::after, .text-9xl .font-serif .leading-7.capsize::after {
  content: '';
  margin-top: 0.2906em;
  display: table;
}
.font-serif.text-9xl.leading-8.capsize::before, .font-serif .text-9xl.leading-8.capsize::before, .font-serif .text-9xl .leading-8.capsize::before, .text-9xl .font-serif.leading-8.capsize::before, .text-9xl .font-serif .leading-8.capsize::before {
  content: '';
  margin-bottom: 0.255em;
  display: table;
}
.font-serif.text-9xl.leading-8.capsize::after, .font-serif .text-9xl.leading-8.capsize::after, .font-serif .text-9xl .leading-8.capsize::after, .text-9xl .font-serif.leading-8.capsize::after, .text-9xl .font-serif .leading-8.capsize::after {
  content: '';
  margin-top: 0.275em;
  display: table;
}
.font-serif.text-9xl.leading-9.capsize::before, .font-serif .text-9xl.leading-9.capsize::before, .font-serif .text-9xl .leading-9.capsize::before, .text-9xl .font-serif.leading-9.capsize::before, .text-9xl .font-serif .leading-9.capsize::before {
  content: '';
  margin-bottom: 0.2394em;
  display: table;
}
.font-serif.text-9xl.leading-9.capsize::after, .font-serif .text-9xl.leading-9.capsize::after, .font-serif .text-9xl .leading-9.capsize::after, .text-9xl .font-serif.leading-9.capsize::after, .text-9xl .font-serif .leading-9.capsize::after {
  content: '';
  margin-top: 0.2594em;
  display: table;
}
.font-serif.text-9xl.leading-10.capsize::before, .font-serif .text-9xl.leading-10.capsize::before, .font-serif .text-9xl .leading-10.capsize::before, .text-9xl .font-serif.leading-10.capsize::before, .text-9xl .font-serif .leading-10.capsize::before {
  content: '';
  margin-bottom: 0.2238em;
  display: table;
}
.font-serif.text-9xl.leading-10.capsize::after, .font-serif .text-9xl.leading-10.capsize::after, .font-serif .text-9xl .leading-10.capsize::after, .text-9xl .font-serif.leading-10.capsize::after, .text-9xl .font-serif .leading-10.capsize::after {
  content: '';
  margin-top: 0.2438em;
  display: table;
}
.font-serif.text-9xl.leading-none.capsize::before, .font-serif .text-9xl.leading-none.capsize::before, .font-serif .text-9xl .leading-none.capsize::before, .text-9xl .font-serif.leading-none.capsize::before, .text-9xl .font-serif .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-9xl.leading-none.capsize::after, .font-serif .text-9xl.leading-none.capsize::after, .font-serif .text-9xl .leading-none.capsize::after, .text-9xl .font-serif.leading-none.capsize::after, .text-9xl .font-serif .leading-none.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-9xl.leading-tight.capsize::before, .font-serif .text-9xl.leading-tight.capsize::before, .font-serif .text-9xl .leading-tight.capsize::before, .text-9xl .font-serif.leading-tight.capsize::before, .text-9xl .font-serif .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.245em;
  display: table;
}
.font-serif.text-9xl.leading-tight.capsize::after, .font-serif .text-9xl.leading-tight.capsize::after, .font-serif .text-9xl .leading-tight.capsize::after, .text-9xl .font-serif.leading-tight.capsize::after, .text-9xl .font-serif .leading-tight.capsize::after {
  content: '';
  margin-top: -0.225em;
  display: table;
}
.font-serif.text-9xl.leading-snug.capsize::before, .font-serif .text-9xl.leading-snug.capsize::before, .font-serif .text-9xl .leading-snug.capsize::before, .text-9xl .font-serif.leading-snug.capsize::before, .text-9xl .font-serif .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3075em;
  display: table;
}
.font-serif.text-9xl.leading-snug.capsize::after, .font-serif .text-9xl.leading-snug.capsize::after, .font-serif .text-9xl .leading-snug.capsize::after, .text-9xl .font-serif.leading-snug.capsize::after, .text-9xl .font-serif .leading-snug.capsize::after {
  content: '';
  margin-top: -0.2875em;
  display: table;
}
.font-serif.text-9xl.leading-normal.capsize::before, .font-serif .text-9xl.leading-normal.capsize::before, .font-serif .text-9xl .leading-normal.capsize::before, .text-9xl .font-serif.leading-normal.capsize::before, .text-9xl .font-serif .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.37em;
  display: table;
}
.font-serif.text-9xl.leading-normal.capsize::after, .font-serif .text-9xl.leading-normal.capsize::after, .font-serif .text-9xl .leading-normal.capsize::after, .text-9xl .font-serif.leading-normal.capsize::after, .text-9xl .font-serif .leading-normal.capsize::after {
  content: '';
  margin-top: -0.35em;
  display: table;
}
.font-serif.text-9xl.leading-relaxed.capsize::before, .font-serif .text-9xl.leading-relaxed.capsize::before, .font-serif .text-9xl .leading-relaxed.capsize::before, .text-9xl .font-serif.leading-relaxed.capsize::before, .text-9xl .font-serif .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4325em;
  display: table;
}
.font-serif.text-9xl.leading-relaxed.capsize::after, .font-serif .text-9xl.leading-relaxed.capsize::after, .font-serif .text-9xl .leading-relaxed.capsize::after, .text-9xl .font-serif.leading-relaxed.capsize::after, .text-9xl .font-serif .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4125em;
  display: table;
}
.font-serif.text-9xl.leading-loose.capsize::before, .font-serif .text-9xl.leading-loose.capsize::before, .font-serif .text-9xl .leading-loose.capsize::before, .text-9xl .font-serif.leading-loose.capsize::before, .text-9xl .font-serif .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif.text-9xl.leading-loose.capsize::after, .font-serif .text-9xl.leading-loose.capsize::after, .font-serif .text-9xl .leading-loose.capsize::after, .text-9xl .font-serif.leading-loose.capsize::after, .text-9xl .font-serif .leading-loose.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
.font-serif.text-1xl.leading-3.capsize::before, .font-serif .text-1xl.leading-3.capsize::before, .font-serif .text-1xl .leading-3.capsize::before, .text-1xl .font-serif.leading-3.capsize::before, .text-1xl .font-serif .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.1073em;
  display: table;
}
.font-serif.text-1xl.leading-3.capsize::after, .font-serif .text-1xl.leading-3.capsize::after, .font-serif .text-1xl .leading-3.capsize::after, .text-1xl .font-serif.leading-3.capsize::after, .text-1xl .font-serif .leading-3.capsize::after {
  content: '';
  margin-top: 0.1273em;
  display: table;
}
.font-serif.text-1xl.leading-4.capsize::before, .font-serif .text-1xl.leading-4.capsize::before, .font-serif .text-1xl .leading-4.capsize::before, .text-1xl .font-serif.leading-4.capsize::before, .text-1xl .font-serif .leading-4.capsize::before {
  content: '';
  margin-bottom: 0.0164em;
  display: table;
}
.font-serif.text-1xl.leading-4.capsize::after, .font-serif .text-1xl.leading-4.capsize::after, .font-serif .text-1xl .leading-4.capsize::after, .text-1xl .font-serif.leading-4.capsize::after, .text-1xl .font-serif .leading-4.capsize::after {
  content: '';
  margin-top: 0.0364em;
  display: table;
}
.font-serif.text-1xl.leading-5.capsize::before, .font-serif .text-1xl.leading-5.capsize::before, .font-serif .text-1xl .leading-5.capsize::before, .text-1xl .font-serif.leading-5.capsize::before, .text-1xl .font-serif .leading-5.capsize::before {
  content: '';
  margin-bottom: -0.0745em;
  display: table;
}
.font-serif.text-1xl.leading-5.capsize::after, .font-serif .text-1xl.leading-5.capsize::after, .font-serif .text-1xl .leading-5.capsize::after, .text-1xl .font-serif.leading-5.capsize::after, .text-1xl .font-serif .leading-5.capsize::after {
  content: '';
  margin-top: -0.0545em;
  display: table;
}
.font-serif.text-1xl.leading-6.capsize::before, .font-serif .text-1xl.leading-6.capsize::before, .font-serif .text-1xl .leading-6.capsize::before, .text-1xl .font-serif.leading-6.capsize::before, .text-1xl .font-serif .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.1655em;
  display: table;
}
.font-serif.text-1xl.leading-6.capsize::after, .font-serif .text-1xl.leading-6.capsize::after, .font-serif .text-1xl .leading-6.capsize::after, .text-1xl .font-serif.leading-6.capsize::after, .text-1xl .font-serif .leading-6.capsize::after {
  content: '';
  margin-top: -0.1455em;
  display: table;
}
.font-serif.text-1xl.leading-7.capsize::before, .font-serif .text-1xl.leading-7.capsize::before, .font-serif .text-1xl .leading-7.capsize::before, .text-1xl .font-serif.leading-7.capsize::before, .text-1xl .font-serif .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.2564em;
  display: table;
}
.font-serif.text-1xl.leading-7.capsize::after, .font-serif .text-1xl.leading-7.capsize::after, .font-serif .text-1xl .leading-7.capsize::after, .text-1xl .font-serif.leading-7.capsize::after, .text-1xl .font-serif .leading-7.capsize::after {
  content: '';
  margin-top: -0.2364em;
  display: table;
}
.font-serif.text-1xl.leading-8.capsize::before, .font-serif .text-1xl.leading-8.capsize::before, .font-serif .text-1xl .leading-8.capsize::before, .text-1xl .font-serif.leading-8.capsize::before, .text-1xl .font-serif .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.3473em;
  display: table;
}
.font-serif.text-1xl.leading-8.capsize::after, .font-serif .text-1xl.leading-8.capsize::after, .font-serif .text-1xl .leading-8.capsize::after, .text-1xl .font-serif.leading-8.capsize::after, .text-1xl .font-serif .leading-8.capsize::after {
  content: '';
  margin-top: -0.3273em;
  display: table;
}
.font-serif.text-1xl.leading-9.capsize::before, .font-serif .text-1xl.leading-9.capsize::before, .font-serif .text-1xl .leading-9.capsize::before, .text-1xl .font-serif.leading-9.capsize::before, .text-1xl .font-serif .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.4382em;
  display: table;
}
.font-serif.text-1xl.leading-9.capsize::after, .font-serif .text-1xl.leading-9.capsize::after, .font-serif .text-1xl .leading-9.capsize::after, .text-1xl .font-serif.leading-9.capsize::after, .text-1xl .font-serif .leading-9.capsize::after {
  content: '';
  margin-top: -0.4182em;
  display: table;
}
.font-serif.text-1xl.leading-10.capsize::before, .font-serif .text-1xl.leading-10.capsize::before, .font-serif .text-1xl .leading-10.capsize::before, .text-1xl .font-serif.leading-10.capsize::before, .text-1xl .font-serif .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.5291em;
  display: table;
}
.font-serif.text-1xl.leading-10.capsize::after, .font-serif .text-1xl.leading-10.capsize::after, .font-serif .text-1xl .leading-10.capsize::after, .text-1xl .font-serif.leading-10.capsize::after, .text-1xl .font-serif .leading-10.capsize::after {
  content: '';
  margin-top: -0.5091em;
  display: table;
}
.font-serif.text-1xl.leading-none.capsize::before, .font-serif .text-1xl.leading-none.capsize::before, .font-serif .text-1xl .leading-none.capsize::before, .text-1xl .font-serif.leading-none.capsize::before, .text-1xl .font-serif .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-1xl.leading-none.capsize::after, .font-serif .text-1xl.leading-none.capsize::after, .font-serif .text-1xl .leading-none.capsize::after, .text-1xl .font-serif.leading-none.capsize::after, .text-1xl .font-serif .leading-none.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-1xl.leading-tight.capsize::before, .font-serif .text-1xl.leading-tight.capsize::before, .font-serif .text-1xl .leading-tight.capsize::before, .text-1xl .font-serif.leading-tight.capsize::before, .text-1xl .font-serif .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.245em;
  display: table;
}
.font-serif.text-1xl.leading-tight.capsize::after, .font-serif .text-1xl.leading-tight.capsize::after, .font-serif .text-1xl .leading-tight.capsize::after, .text-1xl .font-serif.leading-tight.capsize::after, .text-1xl .font-serif .leading-tight.capsize::after {
  content: '';
  margin-top: -0.225em;
  display: table;
}
.font-serif.text-1xl.leading-snug.capsize::before, .font-serif .text-1xl.leading-snug.capsize::before, .font-serif .text-1xl .leading-snug.capsize::before, .text-1xl .font-serif.leading-snug.capsize::before, .text-1xl .font-serif .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3075em;
  display: table;
}
.font-serif.text-1xl.leading-snug.capsize::after, .font-serif .text-1xl.leading-snug.capsize::after, .font-serif .text-1xl .leading-snug.capsize::after, .text-1xl .font-serif.leading-snug.capsize::after, .text-1xl .font-serif .leading-snug.capsize::after {
  content: '';
  margin-top: -0.2875em;
  display: table;
}
.font-serif.text-1xl.leading-normal.capsize::before, .font-serif .text-1xl.leading-normal.capsize::before, .font-serif .text-1xl .leading-normal.capsize::before, .text-1xl .font-serif.leading-normal.capsize::before, .text-1xl .font-serif .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.37em;
  display: table;
}
.font-serif.text-1xl.leading-normal.capsize::after, .font-serif .text-1xl.leading-normal.capsize::after, .font-serif .text-1xl .leading-normal.capsize::after, .text-1xl .font-serif.leading-normal.capsize::after, .text-1xl .font-serif .leading-normal.capsize::after {
  content: '';
  margin-top: -0.35em;
  display: table;
}
.font-serif.text-1xl.leading-relaxed.capsize::before, .font-serif .text-1xl.leading-relaxed.capsize::before, .font-serif .text-1xl .leading-relaxed.capsize::before, .text-1xl .font-serif.leading-relaxed.capsize::before, .text-1xl .font-serif .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4325em;
  display: table;
}
.font-serif.text-1xl.leading-relaxed.capsize::after, .font-serif .text-1xl.leading-relaxed.capsize::after, .font-serif .text-1xl .leading-relaxed.capsize::after, .text-1xl .font-serif.leading-relaxed.capsize::after, .text-1xl .font-serif .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4125em;
  display: table;
}
.font-serif.text-1xl.leading-loose.capsize::before, .font-serif .text-1xl.leading-loose.capsize::before, .font-serif .text-1xl .leading-loose.capsize::before, .text-1xl .font-serif.leading-loose.capsize::before, .text-1xl .font-serif .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif.text-1xl.leading-loose.capsize::after, .font-serif .text-1xl.leading-loose.capsize::after, .font-serif .text-1xl .leading-loose.capsize::after, .text-1xl .font-serif.leading-loose.capsize::after, .text-1xl .font-serif .leading-loose.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
.font-serif.text-3.3xl.leading-3.capsize::before, .font-serif .text-3.3xl.leading-3.capsize::before, .font-serif .text-3.3xl .leading-3.capsize::before, .text-3.3xl .font-serif.leading-3.capsize::before, .text-3.3xl .font-serif .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.1925em;
  display: table;
}
.font-serif.text-3.3xl.leading-3.capsize::after, .font-serif .text-3.3xl.leading-3.capsize::after, .font-serif .text-3.3xl .leading-3.capsize::after, .text-3.3xl .font-serif.leading-3.capsize::after, .text-3.3xl .font-serif .leading-3.capsize::after {
  content: '';
  margin-top: 0.2125em;
  display: table;
}
.font-serif.text-3.3xl.leading-4.capsize::before, .font-serif .text-3.3xl.leading-4.capsize::before, .font-serif .text-3.3xl .leading-4.capsize::before, .text-3.3xl .font-serif.leading-4.capsize::before, .text-3.3xl .font-serif .leading-4.capsize::before {
  content: '';
  margin-bottom: 0.13em;
  display: table;
}
.font-serif.text-3.3xl.leading-4.capsize::after, .font-serif .text-3.3xl.leading-4.capsize::after, .font-serif .text-3.3xl .leading-4.capsize::after, .text-3.3xl .font-serif.leading-4.capsize::after, .text-3.3xl .font-serif .leading-4.capsize::after {
  content: '';
  margin-top: 0.15em;
  display: table;
}
.font-serif.text-3.3xl.leading-5.capsize::before, .font-serif .text-3.3xl.leading-5.capsize::before, .font-serif .text-3.3xl .leading-5.capsize::before, .text-3.3xl .font-serif.leading-5.capsize::before, .text-3.3xl .font-serif .leading-5.capsize::before {
  content: '';
  margin-bottom: 0.0675em;
  display: table;
}
.font-serif.text-3.3xl.leading-5.capsize::after, .font-serif .text-3.3xl.leading-5.capsize::after, .font-serif .text-3.3xl .leading-5.capsize::after, .text-3.3xl .font-serif.leading-5.capsize::after, .text-3.3xl .font-serif .leading-5.capsize::after {
  content: '';
  margin-top: 0.0875em;
  display: table;
}
.font-serif.text-3.3xl.leading-6.capsize::before, .font-serif .text-3.3xl.leading-6.capsize::before, .font-serif .text-3.3xl .leading-6.capsize::before, .text-3.3xl .font-serif.leading-6.capsize::before, .text-3.3xl .font-serif .leading-6.capsize::before {
  content: '';
  margin-bottom: 0.005em;
  display: table;
}
.font-serif.text-3.3xl.leading-6.capsize::after, .font-serif .text-3.3xl.leading-6.capsize::after, .font-serif .text-3.3xl .leading-6.capsize::after, .text-3.3xl .font-serif.leading-6.capsize::after, .text-3.3xl .font-serif .leading-6.capsize::after {
  content: '';
  margin-top: 0.025em;
  display: table;
}
.font-serif.text-3.3xl.leading-7.capsize::before, .font-serif .text-3.3xl.leading-7.capsize::before, .font-serif .text-3.3xl .leading-7.capsize::before, .text-3.3xl .font-serif.leading-7.capsize::before, .text-3.3xl .font-serif .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.0575em;
  display: table;
}
.font-serif.text-3.3xl.leading-7.capsize::after, .font-serif .text-3.3xl.leading-7.capsize::after, .font-serif .text-3.3xl .leading-7.capsize::after, .text-3.3xl .font-serif.leading-7.capsize::after, .text-3.3xl .font-serif .leading-7.capsize::after {
  content: '';
  margin-top: -0.0375em;
  display: table;
}
.font-serif.text-3.3xl.leading-8.capsize::before, .font-serif .text-3.3xl.leading-8.capsize::before, .font-serif .text-3.3xl .leading-8.capsize::before, .text-3.3xl .font-serif.leading-8.capsize::before, .text-3.3xl .font-serif .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-3.3xl.leading-8.capsize::after, .font-serif .text-3.3xl.leading-8.capsize::after, .font-serif .text-3.3xl .leading-8.capsize::after, .text-3.3xl .font-serif.leading-8.capsize::after, .text-3.3xl .font-serif .leading-8.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-3.3xl.leading-9.capsize::before, .font-serif .text-3.3xl.leading-9.capsize::before, .font-serif .text-3.3xl .leading-9.capsize::before, .text-3.3xl .font-serif.leading-9.capsize::before, .text-3.3xl .font-serif .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.1825em;
  display: table;
}
.font-serif.text-3.3xl.leading-9.capsize::after, .font-serif .text-3.3xl.leading-9.capsize::after, .font-serif .text-3.3xl .leading-9.capsize::after, .text-3.3xl .font-serif.leading-9.capsize::after, .text-3.3xl .font-serif .leading-9.capsize::after {
  content: '';
  margin-top: -0.1625em;
  display: table;
}
.font-serif.text-3.3xl.leading-10.capsize::before, .font-serif .text-3.3xl.leading-10.capsize::before, .font-serif .text-3.3xl .leading-10.capsize::before, .text-3.3xl .font-serif.leading-10.capsize::before, .text-3.3xl .font-serif .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.245em;
  display: table;
}
.font-serif.text-3.3xl.leading-10.capsize::after, .font-serif .text-3.3xl.leading-10.capsize::after, .font-serif .text-3.3xl .leading-10.capsize::after, .text-3.3xl .font-serif.leading-10.capsize::after, .text-3.3xl .font-serif .leading-10.capsize::after {
  content: '';
  margin-top: -0.225em;
  display: table;
}
.font-serif.text-3.3xl.leading-none.capsize::before, .font-serif .text-3.3xl.leading-none.capsize::before, .font-serif .text-3.3xl .leading-none.capsize::before, .text-3.3xl .font-serif.leading-none.capsize::before, .text-3.3xl .font-serif .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-3.3xl.leading-none.capsize::after, .font-serif .text-3.3xl.leading-none.capsize::after, .font-serif .text-3.3xl .leading-none.capsize::after, .text-3.3xl .font-serif.leading-none.capsize::after, .text-3.3xl .font-serif .leading-none.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-3.3xl.leading-tight.capsize::before, .font-serif .text-3.3xl.leading-tight.capsize::before, .font-serif .text-3.3xl .leading-tight.capsize::before, .text-3.3xl .font-serif.leading-tight.capsize::before, .text-3.3xl .font-serif .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.245em;
  display: table;
}
.font-serif.text-3.3xl.leading-tight.capsize::after, .font-serif .text-3.3xl.leading-tight.capsize::after, .font-serif .text-3.3xl .leading-tight.capsize::after, .text-3.3xl .font-serif.leading-tight.capsize::after, .text-3.3xl .font-serif .leading-tight.capsize::after {
  content: '';
  margin-top: -0.225em;
  display: table;
}
.font-serif.text-3.3xl.leading-snug.capsize::before, .font-serif .text-3.3xl.leading-snug.capsize::before, .font-serif .text-3.3xl .leading-snug.capsize::before, .text-3.3xl .font-serif.leading-snug.capsize::before, .text-3.3xl .font-serif .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3075em;
  display: table;
}
.font-serif.text-3.3xl.leading-snug.capsize::after, .font-serif .text-3.3xl.leading-snug.capsize::after, .font-serif .text-3.3xl .leading-snug.capsize::after, .text-3.3xl .font-serif.leading-snug.capsize::after, .text-3.3xl .font-serif .leading-snug.capsize::after {
  content: '';
  margin-top: -0.2875em;
  display: table;
}
.font-serif.text-3.3xl.leading-normal.capsize::before, .font-serif .text-3.3xl.leading-normal.capsize::before, .font-serif .text-3.3xl .leading-normal.capsize::before, .text-3.3xl .font-serif.leading-normal.capsize::before, .text-3.3xl .font-serif .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.37em;
  display: table;
}
.font-serif.text-3.3xl.leading-normal.capsize::after, .font-serif .text-3.3xl.leading-normal.capsize::after, .font-serif .text-3.3xl .leading-normal.capsize::after, .text-3.3xl .font-serif.leading-normal.capsize::after, .text-3.3xl .font-serif .leading-normal.capsize::after {
  content: '';
  margin-top: -0.35em;
  display: table;
}
.font-serif.text-3.3xl.leading-relaxed.capsize::before, .font-serif .text-3.3xl.leading-relaxed.capsize::before, .font-serif .text-3.3xl .leading-relaxed.capsize::before, .text-3.3xl .font-serif.leading-relaxed.capsize::before, .text-3.3xl .font-serif .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4325em;
  display: table;
}
.font-serif.text-3.3xl.leading-relaxed.capsize::after, .font-serif .text-3.3xl.leading-relaxed.capsize::after, .font-serif .text-3.3xl .leading-relaxed.capsize::after, .text-3.3xl .font-serif.leading-relaxed.capsize::after, .text-3.3xl .font-serif .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4125em;
  display: table;
}
.font-serif.text-3.3xl.leading-loose.capsize::before, .font-serif .text-3.3xl.leading-loose.capsize::before, .font-serif .text-3.3xl .leading-loose.capsize::before, .text-3.3xl .font-serif.leading-loose.capsize::before, .text-3.3xl .font-serif .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif.text-3.3xl.leading-loose.capsize::after, .font-serif .text-3.3xl.leading-loose.capsize::after, .font-serif .text-3.3xl .leading-loose.capsize::after, .text-3.3xl .font-serif.leading-loose.capsize::after, .text-3.3xl .font-serif .leading-loose.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
/* Hide scrollbar for Chrome, Safari and Opera */
.no-scrollbar::-webkit-scrollbar {
    display: none;
  }
/* Hide scrollbar for IE, Edge and Firefox */
.no-scrollbar {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
.ligatures-none {
    font-variant-ligatures: none;
  }
.\\[font-size\\:clamp\\(0\\.875rem\\2c \\.5vw\\+1rem\\2c 1\\.5rem\\)\\] {
  font-size: clamp(0.875rem,.5vw + 1rem,1.5rem);
}
.\\[scrollbar-width\\:none\\] {
  scrollbar-width: none;
}
/*
  The base layer is for things like reset rules or default styles applied to plain HTML elements.
  The components layer is for class-based styles that you want to be able to override with utilities.
  The utilities layer is for small, single-purpose classes that should always take precedence over any other styles.

  The @layer directive helps you control declaration order by automatically relocating your styles to the corresponding
  @tailwind directive, and also enables features like modifiers and tree-shaking for your own custom CSS.  
*/
/* add the code bellow */
/* Yotpo */
.yotpo-sr-bottom-line-text--right-panel {
  padding: 0px !important;
  font-family: Geograph, sans-serif !important;
  font-weight: 400 !important;
  line-height: 1.75rem !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-3.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-3.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-4.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.3237em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-4.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::after {
  content: '' !important;
  margin-top: -0.2797em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-5.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.4903em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-5.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.4463em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-6.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-6.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-7.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.8237em !important;
  display: table !important;
}
.font-sans.text-xs.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-xs.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-xs .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-xs .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-xs .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.8237em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-7.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.8237em !important;
  display: table !important;
}
.font-sans.text-xs.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-xs.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-xs .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-xs .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-xs .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.8237em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-7.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.8237em !important;
  display: table !important;
}
.font-sans.text-xs.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-xs.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-xs .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-xs .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-xs .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.8237em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-7.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.8237em !important;
  display: table !important;
}
.font-sans.text-xs.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-xs.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-xs .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-xs .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-xs .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.8237em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-7.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.8237em !important;
  display: table !important;
}
.font-sans.text-xs.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-xs.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-xs .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-xs .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-xs .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.8237em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-7.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.7797em !important;
  display: table !important;
}
.font-sans.text-xs.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-xs.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-xs .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-xs .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-xs .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.7797em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-7.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.7797em !important;
  display: table !important;
}
.font-sans.text-xs.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-xs.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-xs .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-xs .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-xs .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.7797em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-7.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.7797em !important;
  display: table !important;
}
.font-sans.text-xs.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-xs.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-xs .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-xs .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-xs .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.7797em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-7.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.7797em !important;
  display: table !important;
}
.font-sans.text-xs.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-xs.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-xs .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-xs .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-xs .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.7797em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-7.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.7797em !important;
  display: table !important;
}
.font-sans.text-xs.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-xs.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-xs .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-xs .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-xs .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.7797em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-8.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.9903em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-8.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.9463em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-9.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -1.157em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-9.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::after {
  content: '' !important;
  margin-top: -1.113em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-10.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -1.3237em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-10.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::after {
  content: '' !important;
  margin-top: -1.2797em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-none.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-none.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-tight.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-tight.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-snug.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-snug.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-normal.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-normal.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-relaxed.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-relaxed.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-loose.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::before, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xs.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xs .leading-loose.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::after, .text-xs .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-3.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: -0.0856em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-3.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::after {
  content: '' !important;
  margin-top: -0.0416em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-4.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.2284em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-4.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::after {
  content: '' !important;
  margin-top: -0.1844em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-5.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.3713em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-5.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.3273em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-6.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.5141em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-6.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.4701em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-7.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.font-sans.text-sm.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-sm.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-sm .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-sm .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-sm .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-7.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.font-sans.text-sm.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-sm.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-sm .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-sm .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-sm .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-7.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.font-sans.text-sm.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-sm.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-sm .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-sm .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-sm .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-7.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.font-sans.text-sm.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-sm.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-sm .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-sm .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-sm .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-7.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.font-sans.text-sm.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-sm.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-sm .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-sm .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-sm .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-7.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.font-sans.text-sm.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-sm.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-sm .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-sm .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-sm .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-7.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.font-sans.text-sm.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-sm.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-sm .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-sm .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-sm .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-7.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.font-sans.text-sm.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-sm.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-sm .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-sm .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-sm .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-7.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.font-sans.text-sm.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-sm.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-sm .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-sm .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-sm .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-7.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.font-sans.text-sm.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-sm.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-sm .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-sm .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-sm .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-8.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.7999em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-8.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.7559em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-9.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.9427em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-9.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.8987em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-10.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -1.0856em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-10.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::after {
  content: '' !important;
  margin-top: -1.0416em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-none.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-none.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-tight.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-tight.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-snug.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-snug.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-normal.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-normal.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-relaxed.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-relaxed.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-loose.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::before, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-sm.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-sm .leading-loose.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::after, .text-sm .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-3.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: -0.032em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-3.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.012em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-4.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-4.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-5.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-5.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-6.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-6.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-7.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.532em !important;
  display: table !important;
}
.font-sans.text-base.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-base.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-base .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-base .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-base .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.532em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-7.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.532em !important;
  display: table !important;
}
.font-sans.text-base.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-base.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-base .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-base .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-base .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.532em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-7.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.532em !important;
  display: table !important;
}
.font-sans.text-base.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-base.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-base .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-base .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-base .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.532em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-7.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.532em !important;
  display: table !important;
}
.font-sans.text-base.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-base.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-base .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-base .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-base .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.532em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-7.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.532em !important;
  display: table !important;
}
.font-sans.text-base.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-base.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-base .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-base .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-base .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.532em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-7.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.488em !important;
  display: table !important;
}
.font-sans.text-base.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-base.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-base .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-base .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-base .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.488em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-7.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.488em !important;
  display: table !important;
}
.font-sans.text-base.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-base.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-base .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-base .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-base .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.488em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-7.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.488em !important;
  display: table !important;
}
.font-sans.text-base.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-base.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-base .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-base .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-base .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.488em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-7.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.488em !important;
  display: table !important;
}
.font-sans.text-base.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-base.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-base .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-base .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-base .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.488em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-7.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.488em !important;
  display: table !important;
}
.font-sans.text-base.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-base.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-base .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-base .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-base .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.488em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-8.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-8.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-9.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.782em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-9.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.738em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-10.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -0.907em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-10.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::after {
  content: '' !important;
  margin-top: -0.863em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-none.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-none.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-tight.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-tight.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-snug.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-snug.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-normal.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-normal.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-relaxed.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-relaxed.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-loose.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::before, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-base.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-base .leading-loose.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::after, .text-base .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-3.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: 0.0097em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-3.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.0537em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-4.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.1014em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-4.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::after {
  content: '' !important;
  margin-top: -0.0574em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-5.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.2126em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-5.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.1686em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-6.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.3237em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-6.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.2797em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-7.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.4348em !important;
  display: table !important;
}
.font-sans.text-lg.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-lg.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-lg .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-lg .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-lg .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.4348em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-7.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.4348em !important;
  display: table !important;
}
.font-sans.text-lg.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-lg.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-lg .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-lg .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-lg .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.4348em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-7.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.4348em !important;
  display: table !important;
}
.font-sans.text-lg.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-lg.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-lg .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-lg .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-lg .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.4348em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-7.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.4348em !important;
  display: table !important;
}
.font-sans.text-lg.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-lg.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-lg .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-lg .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-lg .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.4348em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-7.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.4348em !important;
  display: table !important;
}
.font-sans.text-lg.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-lg.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-lg .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-lg .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-lg .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.4348em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-7.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.3908em !important;
  display: table !important;
}
.font-sans.text-lg.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-lg.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-lg .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-lg .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-lg .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.3908em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-7.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.3908em !important;
  display: table !important;
}
.font-sans.text-lg.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-lg.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-lg .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-lg .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-lg .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.3908em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-7.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.3908em !important;
  display: table !important;
}
.font-sans.text-lg.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-lg.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-lg .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-lg .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-lg .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.3908em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-7.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.3908em !important;
  display: table !important;
}
.font-sans.text-lg.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-lg.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-lg .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-lg .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-lg .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.3908em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-7.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.3908em !important;
  display: table !important;
}
.font-sans.text-lg.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-lg.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-lg .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-lg .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-lg .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.3908em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-8.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.5459em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-8.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.5019em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-9.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-9.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-10.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -0.7681em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-10.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::after {
  content: '' !important;
  margin-top: -0.7241em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-none.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-none.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-tight.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-tight.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-snug.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-snug.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-normal.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-normal.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-relaxed.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-relaxed.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-loose.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::before, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-lg.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-lg .leading-loose.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::after, .text-lg .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-3.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: 0.043em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-3.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.087em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-4.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.057em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-4.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::after {
  content: '' !important;
  margin-top: -0.013em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-5.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-5.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-6.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.257em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-6.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.213em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-7.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.357em !important;
  display: table !important;
}
.font-sans.text-xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.357em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-7.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.357em !important;
  display: table !important;
}
.font-sans.text-xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.357em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-7.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.357em !important;
  display: table !important;
}
.font-sans.text-xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.357em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-7.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.357em !important;
  display: table !important;
}
.font-sans.text-xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.357em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-7.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.357em !important;
  display: table !important;
}
.font-sans.text-xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.357em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-7.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.313em !important;
  display: table !important;
}
.font-sans.text-xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.313em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-7.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.313em !important;
  display: table !important;
}
.font-sans.text-xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.313em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-7.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.313em !important;
  display: table !important;
}
.font-sans.text-xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.313em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-7.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.313em !important;
  display: table !important;
}
.font-sans.text-xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.313em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-7.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.313em !important;
  display: table !important;
}
.font-sans.text-xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.313em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-8.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.457em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-8.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.413em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-9.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.557em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-9.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.513em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-10.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-10.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-none.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-none.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-tight.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-tight.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-snug.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-snug.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-normal.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-normal.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-relaxed.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-relaxed.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-loose.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::before, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-xl.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-xl .leading-loose.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::after, .text-xl .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-3.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: 0.093em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-3.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.137em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-4.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: 0.0097em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-4.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::after {
  content: '' !important;
  margin-top: 0.0537em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-5.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.0737em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-5.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.0297em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-6.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-6.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-7.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.2403em !important;
  display: table !important;
}
.font-sans.text-2xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-2xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-2xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-2xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-2xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.2403em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-7.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.2403em !important;
  display: table !important;
}
.font-sans.text-2xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-2xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-2xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-2xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-2xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.2403em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-7.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.2403em !important;
  display: table !important;
}
.font-sans.text-2xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-2xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-2xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-2xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-2xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.2403em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-7.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.2403em !important;
  display: table !important;
}
.font-sans.text-2xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-2xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-2xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-2xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-2xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.2403em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-7.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.2403em !important;
  display: table !important;
}
.font-sans.text-2xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-2xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-2xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-2xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-2xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.2403em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-7.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.1963em !important;
  display: table !important;
}
.font-sans.text-2xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-2xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-2xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-2xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-2xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.1963em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-7.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.1963em !important;
  display: table !important;
}
.font-sans.text-2xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-2xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-2xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-2xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-2xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.1963em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-7.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.1963em !important;
  display: table !important;
}
.font-sans.text-2xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-2xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-2xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-2xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-2xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.1963em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-7.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.1963em !important;
  display: table !important;
}
.font-sans.text-2xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-2xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-2xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-2xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-2xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.1963em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-7.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.1963em !important;
  display: table !important;
}
.font-sans.text-2xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-2xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-2xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-2xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-2xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.1963em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-8.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.3237em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-8.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.2797em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-9.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-9.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-10.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -0.4903em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-10.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::after {
  content: '' !important;
  margin-top: -0.4463em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-none.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-none.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-tight.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-tight.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-snug.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-snug.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-normal.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-normal.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-relaxed.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-relaxed.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-loose.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::before, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-2xl.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-2xl .leading-loose.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::after, .text-2xl .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-3.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: 0.143em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-3.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.187em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-4.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: 0.0763em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-4.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::after {
  content: '' !important;
  margin-top: 0.1203em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-5.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: 0.0097em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-5.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::after {
  content: '' !important;
  margin-top: 0.0537em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-6.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.057em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-6.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.013em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-7.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.1237em !important;
  display: table !important;
}
.font-sans.text-3xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-3xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-3xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-3xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-3xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.1237em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-7.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.1237em !important;
  display: table !important;
}
.font-sans.text-3xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-3xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-3xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-3xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-3xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.1237em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-7.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.1237em !important;
  display: table !important;
}
.font-sans.text-3xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-3xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-3xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-3xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-3xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.1237em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-7.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.1237em !important;
  display: table !important;
}
.font-sans.text-3xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-3xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-3xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-3xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-3xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.1237em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-7.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.1237em !important;
  display: table !important;
}
.font-sans.text-3xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-3xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-3xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-3xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-3xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.1237em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-7.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.0797em !important;
  display: table !important;
}
.font-sans.text-3xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-3xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-3xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-3xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-3xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.0797em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-7.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.0797em !important;
  display: table !important;
}
.font-sans.text-3xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-3xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-3xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-3xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-3xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.0797em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-7.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.0797em !important;
  display: table !important;
}
.font-sans.text-3xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-3xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-3xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-3xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-3xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.0797em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-7.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.0797em !important;
  display: table !important;
}
.font-sans.text-3xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-3xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-3xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-3xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-3xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.0797em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-7.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.0797em !important;
  display: table !important;
}
.font-sans.text-3xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-3xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-3xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-3xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-3xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.0797em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-8.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.1903em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-8.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.1463em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-9.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.257em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-9.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.213em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-10.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -0.3237em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-10.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::after {
  content: '' !important;
  margin-top: -0.2797em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-none.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-none.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-tight.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-tight.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-snug.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-snug.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-normal.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-normal.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-relaxed.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-relaxed.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-loose.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::before, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3xl.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3xl .leading-loose.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::after, .text-3xl .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-3.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: 0.1763em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-3.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.2203em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-4.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: 0.1208em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-4.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::after {
  content: '' !important;
  margin-top: 0.1648em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-5.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: 0.0652em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-5.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::after {
  content: '' !important;
  margin-top: 0.1092em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-6.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: 0.0097em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-6.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::after {
  content: '' !important;
  margin-top: 0.0537em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-7.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.0459em !important;
  display: table !important;
}
.font-sans.text-4xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-4xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-4xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-4xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-4xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.0459em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-7.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.0459em !important;
  display: table !important;
}
.font-sans.text-4xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-4xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-4xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-4xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-4xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.0459em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-7.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.0459em !important;
  display: table !important;
}
.font-sans.text-4xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-4xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-4xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-4xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-4xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.0459em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-7.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.0459em !important;
  display: table !important;
}
.font-sans.text-4xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-4xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-4xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-4xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-4xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.0459em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-7.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.0459em !important;
  display: table !important;
}
.font-sans.text-4xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-4xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-4xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-4xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-4xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.0459em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-7.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.0019em !important;
  display: table !important;
}
.font-sans.text-4xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-4xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-4xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-4xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-4xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.0019em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-7.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.0019em !important;
  display: table !important;
}
.font-sans.text-4xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-4xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-4xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-4xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-4xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.0019em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-7.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.0019em !important;
  display: table !important;
}
.font-sans.text-4xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-4xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-4xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-4xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-4xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.0019em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-7.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.0019em !important;
  display: table !important;
}
.font-sans.text-4xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-4xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-4xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-4xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-4xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.0019em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-7.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.0019em !important;
  display: table !important;
}
.font-sans.text-4xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-4xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-4xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-4xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-4xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.0019em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-8.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.1014em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-8.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.0574em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-9.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-9.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-10.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -0.2126em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-10.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::after {
  content: '' !important;
  margin-top: -0.1686em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-none.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-none.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-tight.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-tight.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-snug.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-snug.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-normal.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-normal.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-relaxed.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-relaxed.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-loose.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::before, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-4xl.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-4xl .leading-loose.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::after, .text-4xl .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-3.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: 0.218em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-3.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.262em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-4.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: 0.1763em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-4.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::after {
  content: '' !important;
  margin-top: 0.2203em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-5.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: 0.1347em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-5.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::after {
  content: '' !important;
  margin-top: 0.1787em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-6.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: 0.093em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-6.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::after {
  content: '' !important;
  margin-top: 0.137em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-7.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.0513em !important;
  display: table !important;
}
.font-sans.text-5xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-5xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-5xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-5xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-5xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.0513em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-7.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.0513em !important;
  display: table !important;
}
.font-sans.text-5xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-5xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-5xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-5xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-5xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.0513em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-7.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.0513em !important;
  display: table !important;
}
.font-sans.text-5xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-5xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-5xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-5xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-5xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.0513em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-7.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.0513em !important;
  display: table !important;
}
.font-sans.text-5xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-5xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-5xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-5xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-5xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.0513em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-7.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.0513em !important;
  display: table !important;
}
.font-sans.text-5xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-5xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-5xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-5xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-5xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.0513em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-7.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.0953em !important;
  display: table !important;
}
.font-sans.text-5xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-5xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-5xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-5xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-5xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.0953em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-7.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.0953em !important;
  display: table !important;
}
.font-sans.text-5xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-5xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-5xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-5xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-5xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.0953em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-7.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.0953em !important;
  display: table !important;
}
.font-sans.text-5xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-5xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-5xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-5xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-5xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.0953em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-7.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.0953em !important;
  display: table !important;
}
.font-sans.text-5xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-5xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-5xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-5xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-5xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.0953em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-7.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.0953em !important;
  display: table !important;
}
.font-sans.text-5xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-5xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-5xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-5xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-5xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.0953em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-8.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: 0.0097em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-8.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::after {
  content: '' !important;
  margin-top: 0.0537em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-9.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.032em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-9.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::after {
  content: '' !important;
  margin-top: 0.012em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-10.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -0.0737em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-10.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::after {
  content: '' !important;
  margin-top: -0.0297em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-none.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-none.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-tight.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-tight.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-snug.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-snug.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-normal.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-normal.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-relaxed.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-relaxed.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-loose.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::before, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-5xl.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-5xl .leading-loose.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::after, .text-5xl .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-3.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: 0.243em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-3.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.287em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-4.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: 0.2097em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-4.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::after {
  content: '' !important;
  margin-top: 0.2537em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-5.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: 0.1763em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-5.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::after {
  content: '' !important;
  margin-top: 0.2203em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-6.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: 0.143em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-6.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::after {
  content: '' !important;
  margin-top: 0.187em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-7.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.1097em !important;
  display: table !important;
}
.font-sans.text-6xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-6xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-6xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-6xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-6xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.1097em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-7.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.1097em !important;
  display: table !important;
}
.font-sans.text-6xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-6xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-6xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-6xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-6xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.1097em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-7.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.1097em !important;
  display: table !important;
}
.font-sans.text-6xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-6xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-6xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-6xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-6xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.1097em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-7.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.1097em !important;
  display: table !important;
}
.font-sans.text-6xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-6xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-6xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-6xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-6xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.1097em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-7.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.1097em !important;
  display: table !important;
}
.font-sans.text-6xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-6xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-6xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-6xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-6xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.1097em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-7.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.1537em !important;
  display: table !important;
}
.font-sans.text-6xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-6xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-6xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-6xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-6xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.1537em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-7.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.1537em !important;
  display: table !important;
}
.font-sans.text-6xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-6xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-6xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-6xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-6xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.1537em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-7.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.1537em !important;
  display: table !important;
}
.font-sans.text-6xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-6xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-6xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-6xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-6xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.1537em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-7.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.1537em !important;
  display: table !important;
}
.font-sans.text-6xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-6xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-6xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-6xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-6xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.1537em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-7.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.1537em !important;
  display: table !important;
}
.font-sans.text-6xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-6xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-6xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-6xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-6xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.1537em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-8.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: 0.0763em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-8.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::after {
  content: '' !important;
  margin-top: 0.1203em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-9.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: 0.043em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-9.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::after {
  content: '' !important;
  margin-top: 0.087em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-10.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: 0.0097em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-10.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::after {
  content: '' !important;
  margin-top: 0.0537em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-none.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-none.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-tight.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-tight.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-snug.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-snug.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-normal.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-normal.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-relaxed.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-relaxed.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-loose.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::before, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-6xl.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-6xl .leading-loose.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::after, .text-6xl .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-3.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: 0.2597em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-3.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.3037em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-4.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: 0.2319em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-4.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::after {
  content: '' !important;
  margin-top: 0.2759em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-5.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: 0.2041em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-5.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::after {
  content: '' !important;
  margin-top: 0.2481em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-6.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: 0.1763em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-6.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::after {
  content: '' !important;
  margin-top: 0.2203em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-7.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.1486em !important;
  display: table !important;
}
.font-sans.text-7xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-7xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-7xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-7xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-7xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.1486em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-7.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.1486em !important;
  display: table !important;
}
.font-sans.text-7xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-7xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-7xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-7xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-7xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.1486em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-7.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.1486em !important;
  display: table !important;
}
.font-sans.text-7xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-7xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-7xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-7xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-7xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.1486em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-7.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.1486em !important;
  display: table !important;
}
.font-sans.text-7xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-7xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-7xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-7xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-7xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.1486em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-7.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.1486em !important;
  display: table !important;
}
.font-sans.text-7xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-7xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-7xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-7xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-7xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.1486em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-7.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.1926em !important;
  display: table !important;
}
.font-sans.text-7xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-7xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-7xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-7xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-7xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.1926em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-7.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.1926em !important;
  display: table !important;
}
.font-sans.text-7xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-7xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-7xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-7xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-7xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.1926em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-7.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.1926em !important;
  display: table !important;
}
.font-sans.text-7xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-7xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-7xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-7xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-7xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.1926em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-7.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.1926em !important;
  display: table !important;
}
.font-sans.text-7xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-7xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-7xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-7xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-7xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.1926em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-7.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.1926em !important;
  display: table !important;
}
.font-sans.text-7xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-7xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-7xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-7xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-7xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.1926em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-8.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: 0.1208em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-8.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::after {
  content: '' !important;
  margin-top: 0.1648em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-9.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: 0.093em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-9.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::after {
  content: '' !important;
  margin-top: 0.137em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-10.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: 0.0652em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-10.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::after {
  content: '' !important;
  margin-top: 0.1092em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-none.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-none.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-tight.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-tight.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-snug.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-snug.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-normal.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-normal.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-relaxed.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-relaxed.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-loose.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::before, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-7xl.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-7xl .leading-loose.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::after, .text-7xl .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-3.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: 0.2805em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-3.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.3245em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-4.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: 0.2597em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-4.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::after {
  content: '' !important;
  margin-top: 0.3037em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-5.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: 0.2388em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-5.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::after {
  content: '' !important;
  margin-top: 0.2828em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-6.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: 0.218em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-6.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::after {
  content: '' !important;
  margin-top: 0.262em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-7.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.1972em !important;
  display: table !important;
}
.font-sans.text-8xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-8xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-8xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-8xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-8xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.1972em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-7.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.1972em !important;
  display: table !important;
}
.font-sans.text-8xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-8xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-8xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-8xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-8xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.1972em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-7.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.1972em !important;
  display: table !important;
}
.font-sans.text-8xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-8xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-8xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-8xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-8xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.1972em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-7.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.1972em !important;
  display: table !important;
}
.font-sans.text-8xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-8xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-8xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-8xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-8xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.1972em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-7.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.1972em !important;
  display: table !important;
}
.font-sans.text-8xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-8xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-8xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-8xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-8xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.1972em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-7.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.2412em !important;
  display: table !important;
}
.font-sans.text-8xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-8xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-8xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-8xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-8xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.2412em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-7.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.2412em !important;
  display: table !important;
}
.font-sans.text-8xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-8xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-8xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-8xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-8xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.2412em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-7.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.2412em !important;
  display: table !important;
}
.font-sans.text-8xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-8xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-8xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-8xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-8xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.2412em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-7.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.2412em !important;
  display: table !important;
}
.font-sans.text-8xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-8xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-8xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-8xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-8xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.2412em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-7.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.2412em !important;
  display: table !important;
}
.font-sans.text-8xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-8xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-8xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-8xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-8xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.2412em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-8.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: 0.1763em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-8.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::after {
  content: '' !important;
  margin-top: 0.2203em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-9.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: 0.1555em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-9.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::after {
  content: '' !important;
  margin-top: 0.1995em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-10.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: 0.1347em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-10.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::after {
  content: '' !important;
  margin-top: 0.1787em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-none.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-none.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-tight.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-tight.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-snug.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-snug.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-normal.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-normal.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-relaxed.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-relaxed.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-loose.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::before, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-8xl.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-8xl .leading-loose.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::after, .text-8xl .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-3.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: 0.2961em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-3.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.3401em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-4.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: 0.2805em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-4.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::after {
  content: '' !important;
  margin-top: 0.3245em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-5.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: 0.2649em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-5.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::after {
  content: '' !important;
  margin-top: 0.3089em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-6.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: 0.2493em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-6.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::after {
  content: '' !important;
  margin-top: 0.2933em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-7.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.2336em !important;
  display: table !important;
}
.font-sans.text-9xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-9xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-9xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-9xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-9xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.2336em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-7.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.2336em !important;
  display: table !important;
}
.font-sans.text-9xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-9xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-9xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-9xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-9xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.2336em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-7.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.2336em !important;
  display: table !important;
}
.font-sans.text-9xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-9xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-9xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-9xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-9xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.2336em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-7.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.2336em !important;
  display: table !important;
}
.font-sans.text-9xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-9xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-9xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-9xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-9xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.2336em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-7.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.2336em !important;
  display: table !important;
}
.font-sans.text-9xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-9xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-9xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-9xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-9xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.2336em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-7.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.2776em !important;
  display: table !important;
}
.font-sans.text-9xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-9xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-9xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-9xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-9xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.2776em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-7.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.2776em !important;
  display: table !important;
}
.font-sans.text-9xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-9xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-9xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-9xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-9xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.2776em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-7.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.2776em !important;
  display: table !important;
}
.font-sans.text-9xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-9xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-9xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-9xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-9xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.2776em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-7.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.2776em !important;
  display: table !important;
}
.font-sans.text-9xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-9xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-9xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-9xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-9xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.2776em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-7.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.2776em !important;
  display: table !important;
}
.font-sans.text-9xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-9xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-9xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-9xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-9xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.2776em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-8.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: 0.218em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-8.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::after {
  content: '' !important;
  margin-top: 0.262em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-9.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: 0.2024em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-9.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::after {
  content: '' !important;
  margin-top: 0.2464em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-10.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: 0.1868em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-10.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::after {
  content: '' !important;
  margin-top: 0.2308em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-none.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-none.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-tight.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-tight.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-snug.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-snug.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-normal.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-normal.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-relaxed.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-relaxed.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-loose.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::before, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-9xl.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-9xl .leading-loose.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::after, .text-9xl .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-3.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: 0.0703em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-3.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.1143em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-4.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.0206em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-4.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::after {
  content: '' !important;
  margin-top: 0.0234em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-5.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.1115em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-5.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.0675em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-6.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.2025em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-6.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.1585em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-7.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.2934em !important;
  display: table !important;
}
.font-sans.text-1xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-1xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-1xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-1xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-1xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.2934em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-7.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.2934em !important;
  display: table !important;
}
.font-sans.text-1xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-1xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-1xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-1xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-1xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.2934em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-7.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.2934em !important;
  display: table !important;
}
.font-sans.text-1xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-1xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-1xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-1xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-1xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.2934em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-7.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.2934em !important;
  display: table !important;
}
.font-sans.text-1xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-1xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-1xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-1xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-1xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.2934em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-7.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.2934em !important;
  display: table !important;
}
.font-sans.text-1xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-1xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-1xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-1xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-1xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.2934em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-7.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.2494em !important;
  display: table !important;
}
.font-sans.text-1xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-1xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-1xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-1xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-1xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.2494em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-7.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.2494em !important;
  display: table !important;
}
.font-sans.text-1xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-1xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-1xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-1xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-1xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.2494em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-7.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.2494em !important;
  display: table !important;
}
.font-sans.text-1xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-1xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-1xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-1xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-1xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.2494em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-7.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.2494em !important;
  display: table !important;
}
.font-sans.text-1xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-1xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-1xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-1xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-1xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.2494em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-7.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.2494em !important;
  display: table !important;
}
.font-sans.text-1xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-1xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-1xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-1xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-1xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.2494em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-8.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.3843em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-8.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.3403em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-9.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.4752em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-9.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.4312em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-10.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -0.5661em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-10.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::after {
  content: '' !important;
  margin-top: -0.5221em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-none.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-none.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-tight.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-tight.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-snug.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-snug.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-normal.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-normal.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-relaxed.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-relaxed.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-loose.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::before, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-1xl.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-1xl .leading-loose.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::after, .text-1xl .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-3.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-3.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: 0.1555em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-3.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-3.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-3.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.1995em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-4.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-4.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: 0.093em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-4.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-4.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-4.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-4.capsize::after {
  content: '' !important;
  margin-top: 0.137em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-5.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-5.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: 0.0305em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-5.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-5.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-5.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-5.capsize::after {
  content: '' !important;
  margin-top: 0.0745em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-6.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-6.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.032em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-6.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-6.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-6.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-6.capsize::after {
  content: '' !important;
  margin-top: 0.012em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-7.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.0945em !important;
  display: table !important;
}
.font-sans.text-3.\\33xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-3.\\33xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-3.\\33xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-3.\\33xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.0945em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-7.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.0945em !important;
  display: table !important;
}
.font-sans.text-3.\\33xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-3.\\33xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-3.\\33xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-3.\\33xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.0945em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-7.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.0945em !important;
  display: table !important;
}
.font-sans.text-3.\\33xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-3.\\33xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-3.\\33xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-3.\\33xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.0945em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-7.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.0945em !important;
  display: table !important;
}
.font-sans.text-3.\\33xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-3.\\33xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-3.\\33xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-3.\\33xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.0945em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-7.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-7.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.0945em !important;
  display: table !important;
}
.font-sans.text-3.\\33xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-3.\\33xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-sans .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-3.\\33xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-3.\\33xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.0945em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-7.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.0505em !important;
  display: table !important;
}
.font-sans.text-3.\\33xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-3.\\33xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-3.\\33xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-3.\\33xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.0505em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-7.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.0505em !important;
  display: table !important;
}
.font-sans.text-3.\\33xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-3.\\33xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-3.\\33xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-3.\\33xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.0505em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-7.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.0505em !important;
  display: table !important;
}
.font-sans.text-3.\\33xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-3.\\33xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-3.\\33xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-3.\\33xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.0505em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-7.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.0505em !important;
  display: table !important;
}
.font-sans.text-3.\\33xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-3.\\33xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-3.\\33xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-3.\\33xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.0505em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-7.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-7.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-7.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.0505em !important;
  display: table !important;
}
.font-sans.text-3.\\33xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-3.\\33xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-sans .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-3.\\33xl .font-sans.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-3.\\33xl .font-sans .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.0505em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-8.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-8.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-8.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-8.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-8.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-9.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-9.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.2195em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-9.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-9.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-9.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.1755em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-10.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-10.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-10.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-10.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-10.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-10.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-none.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-none.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-none.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-none.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-none.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-tight.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-tight.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-tight.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-tight.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-tight.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-snug.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-snug.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-snug.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-snug.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-snug.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-normal.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-normal.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-normal.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-normal.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-normal.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-relaxed.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-relaxed.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-relaxed.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-relaxed.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-relaxed.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-loose.capsize::before,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-loose.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::before, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.yotpo-sr-bottom-line-text--right-panel.text-3.\\33xl.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl.leading-loose.capsize::after,.yotpo-sr-bottom-line-text--right-panel .text-3.\\33xl .leading-loose.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.leading-loose.capsize::after, .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.font-serif.text-xs.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-xs.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-xs .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-xs .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-xs .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.7867em !important;
  display: table !important;
}
.font-serif.text-xs.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-xs.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-xs .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-xs .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-xs .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.7667em !important;
  display: table !important;
}
.font-serif.text-sm.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-sm.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-sm .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-sm .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-sm .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.62em !important;
  display: table !important;
}
.font-serif.text-sm.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-sm.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-sm .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-sm .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-sm .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.6em !important;
  display: table !important;
}
.font-serif.text-base.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-base.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-base .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-base .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-base .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.495em !important;
  display: table !important;
}
.font-serif.text-base.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-base.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-base .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-base .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-base .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.475em !important;
  display: table !important;
}
.font-serif.text-lg.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-lg.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-lg .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-lg .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-lg .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.3978em !important;
  display: table !important;
}
.font-serif.text-lg.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-lg.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-lg .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-lg .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-lg .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.3778em !important;
  display: table !important;
}
.font-serif.text-xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-xl .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-xl .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.32em !important;
  display: table !important;
}
.font-serif.text-xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-xl .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-xl .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.3em !important;
  display: table !important;
}
.font-serif.text-2xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-2xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-2xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-2xl .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-2xl .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.2033em !important;
  display: table !important;
}
.font-serif.text-2xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-2xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-2xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-2xl .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-2xl .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.1833em !important;
  display: table !important;
}
.font-serif.text-3xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-3xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-3xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-3xl .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-3xl .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.0867em !important;
  display: table !important;
}
.font-serif.text-3xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-3xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-3xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-3xl .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-3xl .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.0667em !important;
  display: table !important;
}
.font-serif.text-4xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-4xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-4xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-4xl .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-4xl .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.0089em !important;
  display: table !important;
}
.font-serif.text-4xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-4xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-4xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-4xl .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-4xl .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.0111em !important;
  display: table !important;
}
.font-serif.text-5xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-5xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-5xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-5xl .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-5xl .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.0883em !important;
  display: table !important;
}
.font-serif.text-5xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-5xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-5xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-5xl .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-5xl .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.1083em !important;
  display: table !important;
}
.font-serif.text-6xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-6xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-6xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-6xl .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-6xl .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.1467em !important;
  display: table !important;
}
.font-serif.text-6xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-6xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-6xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-6xl .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-6xl .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.1667em !important;
  display: table !important;
}
.font-serif.text-7xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-7xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-7xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-7xl .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-7xl .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.1856em !important;
  display: table !important;
}
.font-serif.text-7xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-7xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-7xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-7xl .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-7xl .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.2056em !important;
  display: table !important;
}
.font-serif.text-8xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-8xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-8xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-8xl .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-8xl .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.2342em !important;
  display: table !important;
}
.font-serif.text-8xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-8xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-8xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-8xl .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-8xl .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.2542em !important;
  display: table !important;
}
.font-serif.text-9xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-9xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-9xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-9xl .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-9xl .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: 0.2706em !important;
  display: table !important;
}
.font-serif.text-9xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-9xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-9xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-9xl .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-9xl .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: 0.2906em !important;
  display: table !important;
}
.font-serif.text-1xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-1xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-1xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-1xl .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-1xl .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.2564em !important;
  display: table !important;
}
.font-serif.text-1xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-1xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-1xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-1xl .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-1xl .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.2364em !important;
  display: table !important;
}
.font-serif.text-3.\\33xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-3.\\33xl.yotpo-sr-bottom-line-text--right-panel.capsize::before, .font-serif .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-3.\\33xl .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::before, .text-3.\\33xl .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::before {
  content: '' !important;
  margin-bottom: -0.0575em !important;
  display: table !important;
}
.font-serif.text-3.\\33xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-3.\\33xl.yotpo-sr-bottom-line-text--right-panel.capsize::after, .font-serif .text-3.\\33xl .yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-3.\\33xl .font-serif.yotpo-sr-bottom-line-text--right-panel.capsize::after, .text-3.\\33xl .font-serif .yotpo-sr-bottom-line-text--right-panel.capsize::after {
  content: '' !important;
  margin-top: -0.0375em !important;
  display: table !important;
}
#yotpo-reviews * {
  font-family: Geograph, sans-serif !important;
}
#yotpo-reviews *.text-xs.leading-3.capsize::before,#yotpo-reviews * .text-xs.leading-3.capsize::before,#yotpo-reviews * .text-xs .leading-3.capsize::before, .text-xs #yotpo-reviews *.leading-3.capsize::before, .text-xs #yotpo-reviews * .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-3.capsize::after,#yotpo-reviews * .text-xs.leading-3.capsize::after,#yotpo-reviews * .text-xs .leading-3.capsize::after, .text-xs #yotpo-reviews *.leading-3.capsize::after, .text-xs #yotpo-reviews * .leading-3.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-4.capsize::before,#yotpo-reviews * .text-xs.leading-4.capsize::before,#yotpo-reviews * .text-xs .leading-4.capsize::before, .text-xs #yotpo-reviews *.leading-4.capsize::before, .text-xs #yotpo-reviews * .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.3237em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-4.capsize::after,#yotpo-reviews * .text-xs.leading-4.capsize::after,#yotpo-reviews * .text-xs .leading-4.capsize::after, .text-xs #yotpo-reviews *.leading-4.capsize::after, .text-xs #yotpo-reviews * .leading-4.capsize::after {
  content: '' !important;
  margin-top: -0.2797em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-5.capsize::before,#yotpo-reviews * .text-xs.leading-5.capsize::before,#yotpo-reviews * .text-xs .leading-5.capsize::before, .text-xs #yotpo-reviews *.leading-5.capsize::before, .text-xs #yotpo-reviews * .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.4903em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-5.capsize::after,#yotpo-reviews * .text-xs.leading-5.capsize::after,#yotpo-reviews * .text-xs .leading-5.capsize::after, .text-xs #yotpo-reviews *.leading-5.capsize::after, .text-xs #yotpo-reviews * .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.4463em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-6.capsize::before,#yotpo-reviews * .text-xs.leading-6.capsize::before,#yotpo-reviews * .text-xs .leading-6.capsize::before, .text-xs #yotpo-reviews *.leading-6.capsize::before, .text-xs #yotpo-reviews * .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-6.capsize::after,#yotpo-reviews * .text-xs.leading-6.capsize::after,#yotpo-reviews * .text-xs .leading-6.capsize::after, .text-xs #yotpo-reviews *.leading-6.capsize::after, .text-xs #yotpo-reviews * .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-7.capsize::before,#yotpo-reviews * .text-xs.leading-7.capsize::before,#yotpo-reviews * .text-xs .leading-7.capsize::before, .text-xs #yotpo-reviews *.leading-7.capsize::before, .text-xs #yotpo-reviews * .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.8237em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-7.capsize::after,#yotpo-reviews * .text-xs.leading-7.capsize::after,#yotpo-reviews * .text-xs .leading-7.capsize::after, .text-xs #yotpo-reviews *.leading-7.capsize::after, .text-xs #yotpo-reviews * .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.7797em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-8.capsize::before,#yotpo-reviews * .text-xs.leading-8.capsize::before,#yotpo-reviews * .text-xs .leading-8.capsize::before, .text-xs #yotpo-reviews *.leading-8.capsize::before, .text-xs #yotpo-reviews * .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.9903em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-8.capsize::after,#yotpo-reviews * .text-xs.leading-8.capsize::after,#yotpo-reviews * .text-xs .leading-8.capsize::after, .text-xs #yotpo-reviews *.leading-8.capsize::after, .text-xs #yotpo-reviews * .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.9463em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-9.capsize::before,#yotpo-reviews * .text-xs.leading-9.capsize::before,#yotpo-reviews * .text-xs .leading-9.capsize::before, .text-xs #yotpo-reviews *.leading-9.capsize::before, .text-xs #yotpo-reviews * .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -1.157em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-9.capsize::after,#yotpo-reviews * .text-xs.leading-9.capsize::after,#yotpo-reviews * .text-xs .leading-9.capsize::after, .text-xs #yotpo-reviews *.leading-9.capsize::after, .text-xs #yotpo-reviews * .leading-9.capsize::after {
  content: '' !important;
  margin-top: -1.113em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-10.capsize::before,#yotpo-reviews * .text-xs.leading-10.capsize::before,#yotpo-reviews * .text-xs .leading-10.capsize::before, .text-xs #yotpo-reviews *.leading-10.capsize::before, .text-xs #yotpo-reviews * .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -1.3237em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-10.capsize::after,#yotpo-reviews * .text-xs.leading-10.capsize::after,#yotpo-reviews * .text-xs .leading-10.capsize::after, .text-xs #yotpo-reviews *.leading-10.capsize::after, .text-xs #yotpo-reviews * .leading-10.capsize::after {
  content: '' !important;
  margin-top: -1.2797em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-none.capsize::before,#yotpo-reviews * .text-xs.leading-none.capsize::before,#yotpo-reviews * .text-xs .leading-none.capsize::before, .text-xs #yotpo-reviews *.leading-none.capsize::before, .text-xs #yotpo-reviews * .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-none.capsize::after,#yotpo-reviews * .text-xs.leading-none.capsize::after,#yotpo-reviews * .text-xs .leading-none.capsize::after, .text-xs #yotpo-reviews *.leading-none.capsize::after, .text-xs #yotpo-reviews * .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-tight.capsize::before,#yotpo-reviews * .text-xs.leading-tight.capsize::before,#yotpo-reviews * .text-xs .leading-tight.capsize::before, .text-xs #yotpo-reviews *.leading-tight.capsize::before, .text-xs #yotpo-reviews * .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-tight.capsize::after,#yotpo-reviews * .text-xs.leading-tight.capsize::after,#yotpo-reviews * .text-xs .leading-tight.capsize::after, .text-xs #yotpo-reviews *.leading-tight.capsize::after, .text-xs #yotpo-reviews * .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-snug.capsize::before,#yotpo-reviews * .text-xs.leading-snug.capsize::before,#yotpo-reviews * .text-xs .leading-snug.capsize::before, .text-xs #yotpo-reviews *.leading-snug.capsize::before, .text-xs #yotpo-reviews * .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-snug.capsize::after,#yotpo-reviews * .text-xs.leading-snug.capsize::after,#yotpo-reviews * .text-xs .leading-snug.capsize::after, .text-xs #yotpo-reviews *.leading-snug.capsize::after, .text-xs #yotpo-reviews * .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-normal.capsize::before,#yotpo-reviews * .text-xs.leading-normal.capsize::before,#yotpo-reviews * .text-xs .leading-normal.capsize::before, .text-xs #yotpo-reviews *.leading-normal.capsize::before, .text-xs #yotpo-reviews * .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-normal.capsize::after,#yotpo-reviews * .text-xs.leading-normal.capsize::after,#yotpo-reviews * .text-xs .leading-normal.capsize::after, .text-xs #yotpo-reviews *.leading-normal.capsize::after, .text-xs #yotpo-reviews * .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-relaxed.capsize::before,#yotpo-reviews * .text-xs.leading-relaxed.capsize::before,#yotpo-reviews * .text-xs .leading-relaxed.capsize::before, .text-xs #yotpo-reviews *.leading-relaxed.capsize::before, .text-xs #yotpo-reviews * .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-relaxed.capsize::after,#yotpo-reviews * .text-xs.leading-relaxed.capsize::after,#yotpo-reviews * .text-xs .leading-relaxed.capsize::after, .text-xs #yotpo-reviews *.leading-relaxed.capsize::after, .text-xs #yotpo-reviews * .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-loose.capsize::before,#yotpo-reviews * .text-xs.leading-loose.capsize::before,#yotpo-reviews * .text-xs .leading-loose.capsize::before, .text-xs #yotpo-reviews *.leading-loose.capsize::before, .text-xs #yotpo-reviews * .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
#yotpo-reviews *.text-xs.leading-loose.capsize::after,#yotpo-reviews * .text-xs.leading-loose.capsize::after,#yotpo-reviews * .text-xs .leading-loose.capsize::after, .text-xs #yotpo-reviews *.leading-loose.capsize::after, .text-xs #yotpo-reviews * .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-3.capsize::before,#yotpo-reviews * .text-sm.leading-3.capsize::before,#yotpo-reviews * .text-sm .leading-3.capsize::before, .text-sm #yotpo-reviews *.leading-3.capsize::before, .text-sm #yotpo-reviews * .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: -0.0856em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-3.capsize::after,#yotpo-reviews * .text-sm.leading-3.capsize::after,#yotpo-reviews * .text-sm .leading-3.capsize::after, .text-sm #yotpo-reviews *.leading-3.capsize::after, .text-sm #yotpo-reviews * .leading-3.capsize::after {
  content: '' !important;
  margin-top: -0.0416em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-4.capsize::before,#yotpo-reviews * .text-sm.leading-4.capsize::before,#yotpo-reviews * .text-sm .leading-4.capsize::before, .text-sm #yotpo-reviews *.leading-4.capsize::before, .text-sm #yotpo-reviews * .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.2284em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-4.capsize::after,#yotpo-reviews * .text-sm.leading-4.capsize::after,#yotpo-reviews * .text-sm .leading-4.capsize::after, .text-sm #yotpo-reviews *.leading-4.capsize::after, .text-sm #yotpo-reviews * .leading-4.capsize::after {
  content: '' !important;
  margin-top: -0.1844em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-5.capsize::before,#yotpo-reviews * .text-sm.leading-5.capsize::before,#yotpo-reviews * .text-sm .leading-5.capsize::before, .text-sm #yotpo-reviews *.leading-5.capsize::before, .text-sm #yotpo-reviews * .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.3713em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-5.capsize::after,#yotpo-reviews * .text-sm.leading-5.capsize::after,#yotpo-reviews * .text-sm .leading-5.capsize::after, .text-sm #yotpo-reviews *.leading-5.capsize::after, .text-sm #yotpo-reviews * .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.3273em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-6.capsize::before,#yotpo-reviews * .text-sm.leading-6.capsize::before,#yotpo-reviews * .text-sm .leading-6.capsize::before, .text-sm #yotpo-reviews *.leading-6.capsize::before, .text-sm #yotpo-reviews * .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.5141em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-6.capsize::after,#yotpo-reviews * .text-sm.leading-6.capsize::after,#yotpo-reviews * .text-sm .leading-6.capsize::after, .text-sm #yotpo-reviews *.leading-6.capsize::after, .text-sm #yotpo-reviews * .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.4701em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-7.capsize::before,#yotpo-reviews * .text-sm.leading-7.capsize::before,#yotpo-reviews * .text-sm .leading-7.capsize::before, .text-sm #yotpo-reviews *.leading-7.capsize::before, .text-sm #yotpo-reviews * .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-7.capsize::after,#yotpo-reviews * .text-sm.leading-7.capsize::after,#yotpo-reviews * .text-sm .leading-7.capsize::after, .text-sm #yotpo-reviews *.leading-7.capsize::after, .text-sm #yotpo-reviews * .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-8.capsize::before,#yotpo-reviews * .text-sm.leading-8.capsize::before,#yotpo-reviews * .text-sm .leading-8.capsize::before, .text-sm #yotpo-reviews *.leading-8.capsize::before, .text-sm #yotpo-reviews * .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.7999em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-8.capsize::after,#yotpo-reviews * .text-sm.leading-8.capsize::after,#yotpo-reviews * .text-sm .leading-8.capsize::after, .text-sm #yotpo-reviews *.leading-8.capsize::after, .text-sm #yotpo-reviews * .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.7559em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-9.capsize::before,#yotpo-reviews * .text-sm.leading-9.capsize::before,#yotpo-reviews * .text-sm .leading-9.capsize::before, .text-sm #yotpo-reviews *.leading-9.capsize::before, .text-sm #yotpo-reviews * .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.9427em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-9.capsize::after,#yotpo-reviews * .text-sm.leading-9.capsize::after,#yotpo-reviews * .text-sm .leading-9.capsize::after, .text-sm #yotpo-reviews *.leading-9.capsize::after, .text-sm #yotpo-reviews * .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.8987em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-10.capsize::before,#yotpo-reviews * .text-sm.leading-10.capsize::before,#yotpo-reviews * .text-sm .leading-10.capsize::before, .text-sm #yotpo-reviews *.leading-10.capsize::before, .text-sm #yotpo-reviews * .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -1.0856em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-10.capsize::after,#yotpo-reviews * .text-sm.leading-10.capsize::after,#yotpo-reviews * .text-sm .leading-10.capsize::after, .text-sm #yotpo-reviews *.leading-10.capsize::after, .text-sm #yotpo-reviews * .leading-10.capsize::after {
  content: '' !important;
  margin-top: -1.0416em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-none.capsize::before,#yotpo-reviews * .text-sm.leading-none.capsize::before,#yotpo-reviews * .text-sm .leading-none.capsize::before, .text-sm #yotpo-reviews *.leading-none.capsize::before, .text-sm #yotpo-reviews * .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-none.capsize::after,#yotpo-reviews * .text-sm.leading-none.capsize::after,#yotpo-reviews * .text-sm .leading-none.capsize::after, .text-sm #yotpo-reviews *.leading-none.capsize::after, .text-sm #yotpo-reviews * .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-tight.capsize::before,#yotpo-reviews * .text-sm.leading-tight.capsize::before,#yotpo-reviews * .text-sm .leading-tight.capsize::before, .text-sm #yotpo-reviews *.leading-tight.capsize::before, .text-sm #yotpo-reviews * .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-tight.capsize::after,#yotpo-reviews * .text-sm.leading-tight.capsize::after,#yotpo-reviews * .text-sm .leading-tight.capsize::after, .text-sm #yotpo-reviews *.leading-tight.capsize::after, .text-sm #yotpo-reviews * .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-snug.capsize::before,#yotpo-reviews * .text-sm.leading-snug.capsize::before,#yotpo-reviews * .text-sm .leading-snug.capsize::before, .text-sm #yotpo-reviews *.leading-snug.capsize::before, .text-sm #yotpo-reviews * .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-snug.capsize::after,#yotpo-reviews * .text-sm.leading-snug.capsize::after,#yotpo-reviews * .text-sm .leading-snug.capsize::after, .text-sm #yotpo-reviews *.leading-snug.capsize::after, .text-sm #yotpo-reviews * .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-normal.capsize::before,#yotpo-reviews * .text-sm.leading-normal.capsize::before,#yotpo-reviews * .text-sm .leading-normal.capsize::before, .text-sm #yotpo-reviews *.leading-normal.capsize::before, .text-sm #yotpo-reviews * .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-normal.capsize::after,#yotpo-reviews * .text-sm.leading-normal.capsize::after,#yotpo-reviews * .text-sm .leading-normal.capsize::after, .text-sm #yotpo-reviews *.leading-normal.capsize::after, .text-sm #yotpo-reviews * .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-relaxed.capsize::before,#yotpo-reviews * .text-sm.leading-relaxed.capsize::before,#yotpo-reviews * .text-sm .leading-relaxed.capsize::before, .text-sm #yotpo-reviews *.leading-relaxed.capsize::before, .text-sm #yotpo-reviews * .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-relaxed.capsize::after,#yotpo-reviews * .text-sm.leading-relaxed.capsize::after,#yotpo-reviews * .text-sm .leading-relaxed.capsize::after, .text-sm #yotpo-reviews *.leading-relaxed.capsize::after, .text-sm #yotpo-reviews * .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-loose.capsize::before,#yotpo-reviews * .text-sm.leading-loose.capsize::before,#yotpo-reviews * .text-sm .leading-loose.capsize::before, .text-sm #yotpo-reviews *.leading-loose.capsize::before, .text-sm #yotpo-reviews * .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
#yotpo-reviews *.text-sm.leading-loose.capsize::after,#yotpo-reviews * .text-sm.leading-loose.capsize::after,#yotpo-reviews * .text-sm .leading-loose.capsize::after, .text-sm #yotpo-reviews *.leading-loose.capsize::after, .text-sm #yotpo-reviews * .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-3.capsize::before,#yotpo-reviews * .text-base.leading-3.capsize::before,#yotpo-reviews * .text-base .leading-3.capsize::before, .text-base #yotpo-reviews *.leading-3.capsize::before, .text-base #yotpo-reviews * .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: -0.032em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-3.capsize::after,#yotpo-reviews * .text-base.leading-3.capsize::after,#yotpo-reviews * .text-base .leading-3.capsize::after, .text-base #yotpo-reviews *.leading-3.capsize::after, .text-base #yotpo-reviews * .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.012em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-4.capsize::before,#yotpo-reviews * .text-base.leading-4.capsize::before,#yotpo-reviews * .text-base .leading-4.capsize::before, .text-base #yotpo-reviews *.leading-4.capsize::before, .text-base #yotpo-reviews * .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-4.capsize::after,#yotpo-reviews * .text-base.leading-4.capsize::after,#yotpo-reviews * .text-base .leading-4.capsize::after, .text-base #yotpo-reviews *.leading-4.capsize::after, .text-base #yotpo-reviews * .leading-4.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-5.capsize::before,#yotpo-reviews * .text-base.leading-5.capsize::before,#yotpo-reviews * .text-base .leading-5.capsize::before, .text-base #yotpo-reviews *.leading-5.capsize::before, .text-base #yotpo-reviews * .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-5.capsize::after,#yotpo-reviews * .text-base.leading-5.capsize::after,#yotpo-reviews * .text-base .leading-5.capsize::after, .text-base #yotpo-reviews *.leading-5.capsize::after, .text-base #yotpo-reviews * .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-6.capsize::before,#yotpo-reviews * .text-base.leading-6.capsize::before,#yotpo-reviews * .text-base .leading-6.capsize::before, .text-base #yotpo-reviews *.leading-6.capsize::before, .text-base #yotpo-reviews * .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-6.capsize::after,#yotpo-reviews * .text-base.leading-6.capsize::after,#yotpo-reviews * .text-base .leading-6.capsize::after, .text-base #yotpo-reviews *.leading-6.capsize::after, .text-base #yotpo-reviews * .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-7.capsize::before,#yotpo-reviews * .text-base.leading-7.capsize::before,#yotpo-reviews * .text-base .leading-7.capsize::before, .text-base #yotpo-reviews *.leading-7.capsize::before, .text-base #yotpo-reviews * .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.532em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-7.capsize::after,#yotpo-reviews * .text-base.leading-7.capsize::after,#yotpo-reviews * .text-base .leading-7.capsize::after, .text-base #yotpo-reviews *.leading-7.capsize::after, .text-base #yotpo-reviews * .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.488em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-8.capsize::before,#yotpo-reviews * .text-base.leading-8.capsize::before,#yotpo-reviews * .text-base .leading-8.capsize::before, .text-base #yotpo-reviews *.leading-8.capsize::before, .text-base #yotpo-reviews * .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-8.capsize::after,#yotpo-reviews * .text-base.leading-8.capsize::after,#yotpo-reviews * .text-base .leading-8.capsize::after, .text-base #yotpo-reviews *.leading-8.capsize::after, .text-base #yotpo-reviews * .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-9.capsize::before,#yotpo-reviews * .text-base.leading-9.capsize::before,#yotpo-reviews * .text-base .leading-9.capsize::before, .text-base #yotpo-reviews *.leading-9.capsize::before, .text-base #yotpo-reviews * .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.782em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-9.capsize::after,#yotpo-reviews * .text-base.leading-9.capsize::after,#yotpo-reviews * .text-base .leading-9.capsize::after, .text-base #yotpo-reviews *.leading-9.capsize::after, .text-base #yotpo-reviews * .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.738em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-10.capsize::before,#yotpo-reviews * .text-base.leading-10.capsize::before,#yotpo-reviews * .text-base .leading-10.capsize::before, .text-base #yotpo-reviews *.leading-10.capsize::before, .text-base #yotpo-reviews * .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -0.907em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-10.capsize::after,#yotpo-reviews * .text-base.leading-10.capsize::after,#yotpo-reviews * .text-base .leading-10.capsize::after, .text-base #yotpo-reviews *.leading-10.capsize::after, .text-base #yotpo-reviews * .leading-10.capsize::after {
  content: '' !important;
  margin-top: -0.863em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-none.capsize::before,#yotpo-reviews * .text-base.leading-none.capsize::before,#yotpo-reviews * .text-base .leading-none.capsize::before, .text-base #yotpo-reviews *.leading-none.capsize::before, .text-base #yotpo-reviews * .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-none.capsize::after,#yotpo-reviews * .text-base.leading-none.capsize::after,#yotpo-reviews * .text-base .leading-none.capsize::after, .text-base #yotpo-reviews *.leading-none.capsize::after, .text-base #yotpo-reviews * .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-tight.capsize::before,#yotpo-reviews * .text-base.leading-tight.capsize::before,#yotpo-reviews * .text-base .leading-tight.capsize::before, .text-base #yotpo-reviews *.leading-tight.capsize::before, .text-base #yotpo-reviews * .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-tight.capsize::after,#yotpo-reviews * .text-base.leading-tight.capsize::after,#yotpo-reviews * .text-base .leading-tight.capsize::after, .text-base #yotpo-reviews *.leading-tight.capsize::after, .text-base #yotpo-reviews * .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-snug.capsize::before,#yotpo-reviews * .text-base.leading-snug.capsize::before,#yotpo-reviews * .text-base .leading-snug.capsize::before, .text-base #yotpo-reviews *.leading-snug.capsize::before, .text-base #yotpo-reviews * .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-snug.capsize::after,#yotpo-reviews * .text-base.leading-snug.capsize::after,#yotpo-reviews * .text-base .leading-snug.capsize::after, .text-base #yotpo-reviews *.leading-snug.capsize::after, .text-base #yotpo-reviews * .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-normal.capsize::before,#yotpo-reviews * .text-base.leading-normal.capsize::before,#yotpo-reviews * .text-base .leading-normal.capsize::before, .text-base #yotpo-reviews *.leading-normal.capsize::before, .text-base #yotpo-reviews * .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-normal.capsize::after,#yotpo-reviews * .text-base.leading-normal.capsize::after,#yotpo-reviews * .text-base .leading-normal.capsize::after, .text-base #yotpo-reviews *.leading-normal.capsize::after, .text-base #yotpo-reviews * .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-relaxed.capsize::before,#yotpo-reviews * .text-base.leading-relaxed.capsize::before,#yotpo-reviews * .text-base .leading-relaxed.capsize::before, .text-base #yotpo-reviews *.leading-relaxed.capsize::before, .text-base #yotpo-reviews * .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-relaxed.capsize::after,#yotpo-reviews * .text-base.leading-relaxed.capsize::after,#yotpo-reviews * .text-base .leading-relaxed.capsize::after, .text-base #yotpo-reviews *.leading-relaxed.capsize::after, .text-base #yotpo-reviews * .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-loose.capsize::before,#yotpo-reviews * .text-base.leading-loose.capsize::before,#yotpo-reviews * .text-base .leading-loose.capsize::before, .text-base #yotpo-reviews *.leading-loose.capsize::before, .text-base #yotpo-reviews * .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
#yotpo-reviews *.text-base.leading-loose.capsize::after,#yotpo-reviews * .text-base.leading-loose.capsize::after,#yotpo-reviews * .text-base .leading-loose.capsize::after, .text-base #yotpo-reviews *.leading-loose.capsize::after, .text-base #yotpo-reviews * .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-3.capsize::before,#yotpo-reviews * .text-lg.leading-3.capsize::before,#yotpo-reviews * .text-lg .leading-3.capsize::before, .text-lg #yotpo-reviews *.leading-3.capsize::before, .text-lg #yotpo-reviews * .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: 0.0097em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-3.capsize::after,#yotpo-reviews * .text-lg.leading-3.capsize::after,#yotpo-reviews * .text-lg .leading-3.capsize::after, .text-lg #yotpo-reviews *.leading-3.capsize::after, .text-lg #yotpo-reviews * .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.0537em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-4.capsize::before,#yotpo-reviews * .text-lg.leading-4.capsize::before,#yotpo-reviews * .text-lg .leading-4.capsize::before, .text-lg #yotpo-reviews *.leading-4.capsize::before, .text-lg #yotpo-reviews * .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.1014em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-4.capsize::after,#yotpo-reviews * .text-lg.leading-4.capsize::after,#yotpo-reviews * .text-lg .leading-4.capsize::after, .text-lg #yotpo-reviews *.leading-4.capsize::after, .text-lg #yotpo-reviews * .leading-4.capsize::after {
  content: '' !important;
  margin-top: -0.0574em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-5.capsize::before,#yotpo-reviews * .text-lg.leading-5.capsize::before,#yotpo-reviews * .text-lg .leading-5.capsize::before, .text-lg #yotpo-reviews *.leading-5.capsize::before, .text-lg #yotpo-reviews * .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.2126em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-5.capsize::after,#yotpo-reviews * .text-lg.leading-5.capsize::after,#yotpo-reviews * .text-lg .leading-5.capsize::after, .text-lg #yotpo-reviews *.leading-5.capsize::after, .text-lg #yotpo-reviews * .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.1686em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-6.capsize::before,#yotpo-reviews * .text-lg.leading-6.capsize::before,#yotpo-reviews * .text-lg .leading-6.capsize::before, .text-lg #yotpo-reviews *.leading-6.capsize::before, .text-lg #yotpo-reviews * .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.3237em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-6.capsize::after,#yotpo-reviews * .text-lg.leading-6.capsize::after,#yotpo-reviews * .text-lg .leading-6.capsize::after, .text-lg #yotpo-reviews *.leading-6.capsize::after, .text-lg #yotpo-reviews * .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.2797em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-7.capsize::before,#yotpo-reviews * .text-lg.leading-7.capsize::before,#yotpo-reviews * .text-lg .leading-7.capsize::before, .text-lg #yotpo-reviews *.leading-7.capsize::before, .text-lg #yotpo-reviews * .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.4348em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-7.capsize::after,#yotpo-reviews * .text-lg.leading-7.capsize::after,#yotpo-reviews * .text-lg .leading-7.capsize::after, .text-lg #yotpo-reviews *.leading-7.capsize::after, .text-lg #yotpo-reviews * .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.3908em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-8.capsize::before,#yotpo-reviews * .text-lg.leading-8.capsize::before,#yotpo-reviews * .text-lg .leading-8.capsize::before, .text-lg #yotpo-reviews *.leading-8.capsize::before, .text-lg #yotpo-reviews * .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.5459em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-8.capsize::after,#yotpo-reviews * .text-lg.leading-8.capsize::after,#yotpo-reviews * .text-lg .leading-8.capsize::after, .text-lg #yotpo-reviews *.leading-8.capsize::after, .text-lg #yotpo-reviews * .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.5019em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-9.capsize::before,#yotpo-reviews * .text-lg.leading-9.capsize::before,#yotpo-reviews * .text-lg .leading-9.capsize::before, .text-lg #yotpo-reviews *.leading-9.capsize::before, .text-lg #yotpo-reviews * .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-9.capsize::after,#yotpo-reviews * .text-lg.leading-9.capsize::after,#yotpo-reviews * .text-lg .leading-9.capsize::after, .text-lg #yotpo-reviews *.leading-9.capsize::after, .text-lg #yotpo-reviews * .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-10.capsize::before,#yotpo-reviews * .text-lg.leading-10.capsize::before,#yotpo-reviews * .text-lg .leading-10.capsize::before, .text-lg #yotpo-reviews *.leading-10.capsize::before, .text-lg #yotpo-reviews * .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -0.7681em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-10.capsize::after,#yotpo-reviews * .text-lg.leading-10.capsize::after,#yotpo-reviews * .text-lg .leading-10.capsize::after, .text-lg #yotpo-reviews *.leading-10.capsize::after, .text-lg #yotpo-reviews * .leading-10.capsize::after {
  content: '' !important;
  margin-top: -0.7241em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-none.capsize::before,#yotpo-reviews * .text-lg.leading-none.capsize::before,#yotpo-reviews * .text-lg .leading-none.capsize::before, .text-lg #yotpo-reviews *.leading-none.capsize::before, .text-lg #yotpo-reviews * .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-none.capsize::after,#yotpo-reviews * .text-lg.leading-none.capsize::after,#yotpo-reviews * .text-lg .leading-none.capsize::after, .text-lg #yotpo-reviews *.leading-none.capsize::after, .text-lg #yotpo-reviews * .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-tight.capsize::before,#yotpo-reviews * .text-lg.leading-tight.capsize::before,#yotpo-reviews * .text-lg .leading-tight.capsize::before, .text-lg #yotpo-reviews *.leading-tight.capsize::before, .text-lg #yotpo-reviews * .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-tight.capsize::after,#yotpo-reviews * .text-lg.leading-tight.capsize::after,#yotpo-reviews * .text-lg .leading-tight.capsize::after, .text-lg #yotpo-reviews *.leading-tight.capsize::after, .text-lg #yotpo-reviews * .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-snug.capsize::before,#yotpo-reviews * .text-lg.leading-snug.capsize::before,#yotpo-reviews * .text-lg .leading-snug.capsize::before, .text-lg #yotpo-reviews *.leading-snug.capsize::before, .text-lg #yotpo-reviews * .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-snug.capsize::after,#yotpo-reviews * .text-lg.leading-snug.capsize::after,#yotpo-reviews * .text-lg .leading-snug.capsize::after, .text-lg #yotpo-reviews *.leading-snug.capsize::after, .text-lg #yotpo-reviews * .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-normal.capsize::before,#yotpo-reviews * .text-lg.leading-normal.capsize::before,#yotpo-reviews * .text-lg .leading-normal.capsize::before, .text-lg #yotpo-reviews *.leading-normal.capsize::before, .text-lg #yotpo-reviews * .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-normal.capsize::after,#yotpo-reviews * .text-lg.leading-normal.capsize::after,#yotpo-reviews * .text-lg .leading-normal.capsize::after, .text-lg #yotpo-reviews *.leading-normal.capsize::after, .text-lg #yotpo-reviews * .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-relaxed.capsize::before,#yotpo-reviews * .text-lg.leading-relaxed.capsize::before,#yotpo-reviews * .text-lg .leading-relaxed.capsize::before, .text-lg #yotpo-reviews *.leading-relaxed.capsize::before, .text-lg #yotpo-reviews * .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-relaxed.capsize::after,#yotpo-reviews * .text-lg.leading-relaxed.capsize::after,#yotpo-reviews * .text-lg .leading-relaxed.capsize::after, .text-lg #yotpo-reviews *.leading-relaxed.capsize::after, .text-lg #yotpo-reviews * .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-loose.capsize::before,#yotpo-reviews * .text-lg.leading-loose.capsize::before,#yotpo-reviews * .text-lg .leading-loose.capsize::before, .text-lg #yotpo-reviews *.leading-loose.capsize::before, .text-lg #yotpo-reviews * .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
#yotpo-reviews *.text-lg.leading-loose.capsize::after,#yotpo-reviews * .text-lg.leading-loose.capsize::after,#yotpo-reviews * .text-lg .leading-loose.capsize::after, .text-lg #yotpo-reviews *.leading-loose.capsize::after, .text-lg #yotpo-reviews * .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-3.capsize::before,#yotpo-reviews * .text-xl.leading-3.capsize::before,#yotpo-reviews * .text-xl .leading-3.capsize::before, .text-xl #yotpo-reviews *.leading-3.capsize::before, .text-xl #yotpo-reviews * .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: 0.043em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-3.capsize::after,#yotpo-reviews * .text-xl.leading-3.capsize::after,#yotpo-reviews * .text-xl .leading-3.capsize::after, .text-xl #yotpo-reviews *.leading-3.capsize::after, .text-xl #yotpo-reviews * .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.087em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-4.capsize::before,#yotpo-reviews * .text-xl.leading-4.capsize::before,#yotpo-reviews * .text-xl .leading-4.capsize::before, .text-xl #yotpo-reviews *.leading-4.capsize::before, .text-xl #yotpo-reviews * .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.057em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-4.capsize::after,#yotpo-reviews * .text-xl.leading-4.capsize::after,#yotpo-reviews * .text-xl .leading-4.capsize::after, .text-xl #yotpo-reviews *.leading-4.capsize::after, .text-xl #yotpo-reviews * .leading-4.capsize::after {
  content: '' !important;
  margin-top: -0.013em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-5.capsize::before,#yotpo-reviews * .text-xl.leading-5.capsize::before,#yotpo-reviews * .text-xl .leading-5.capsize::before, .text-xl #yotpo-reviews *.leading-5.capsize::before, .text-xl #yotpo-reviews * .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-5.capsize::after,#yotpo-reviews * .text-xl.leading-5.capsize::after,#yotpo-reviews * .text-xl .leading-5.capsize::after, .text-xl #yotpo-reviews *.leading-5.capsize::after, .text-xl #yotpo-reviews * .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-6.capsize::before,#yotpo-reviews * .text-xl.leading-6.capsize::before,#yotpo-reviews * .text-xl .leading-6.capsize::before, .text-xl #yotpo-reviews *.leading-6.capsize::before, .text-xl #yotpo-reviews * .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.257em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-6.capsize::after,#yotpo-reviews * .text-xl.leading-6.capsize::after,#yotpo-reviews * .text-xl .leading-6.capsize::after, .text-xl #yotpo-reviews *.leading-6.capsize::after, .text-xl #yotpo-reviews * .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.213em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-7.capsize::before,#yotpo-reviews * .text-xl.leading-7.capsize::before,#yotpo-reviews * .text-xl .leading-7.capsize::before, .text-xl #yotpo-reviews *.leading-7.capsize::before, .text-xl #yotpo-reviews * .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.357em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-7.capsize::after,#yotpo-reviews * .text-xl.leading-7.capsize::after,#yotpo-reviews * .text-xl .leading-7.capsize::after, .text-xl #yotpo-reviews *.leading-7.capsize::after, .text-xl #yotpo-reviews * .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.313em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-8.capsize::before,#yotpo-reviews * .text-xl.leading-8.capsize::before,#yotpo-reviews * .text-xl .leading-8.capsize::before, .text-xl #yotpo-reviews *.leading-8.capsize::before, .text-xl #yotpo-reviews * .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.457em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-8.capsize::after,#yotpo-reviews * .text-xl.leading-8.capsize::after,#yotpo-reviews * .text-xl .leading-8.capsize::after, .text-xl #yotpo-reviews *.leading-8.capsize::after, .text-xl #yotpo-reviews * .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.413em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-9.capsize::before,#yotpo-reviews * .text-xl.leading-9.capsize::before,#yotpo-reviews * .text-xl .leading-9.capsize::before, .text-xl #yotpo-reviews *.leading-9.capsize::before, .text-xl #yotpo-reviews * .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.557em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-9.capsize::after,#yotpo-reviews * .text-xl.leading-9.capsize::after,#yotpo-reviews * .text-xl .leading-9.capsize::after, .text-xl #yotpo-reviews *.leading-9.capsize::after, .text-xl #yotpo-reviews * .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.513em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-10.capsize::before,#yotpo-reviews * .text-xl.leading-10.capsize::before,#yotpo-reviews * .text-xl .leading-10.capsize::before, .text-xl #yotpo-reviews *.leading-10.capsize::before, .text-xl #yotpo-reviews * .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-10.capsize::after,#yotpo-reviews * .text-xl.leading-10.capsize::after,#yotpo-reviews * .text-xl .leading-10.capsize::after, .text-xl #yotpo-reviews *.leading-10.capsize::after, .text-xl #yotpo-reviews * .leading-10.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-none.capsize::before,#yotpo-reviews * .text-xl.leading-none.capsize::before,#yotpo-reviews * .text-xl .leading-none.capsize::before, .text-xl #yotpo-reviews *.leading-none.capsize::before, .text-xl #yotpo-reviews * .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-none.capsize::after,#yotpo-reviews * .text-xl.leading-none.capsize::after,#yotpo-reviews * .text-xl .leading-none.capsize::after, .text-xl #yotpo-reviews *.leading-none.capsize::after, .text-xl #yotpo-reviews * .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-tight.capsize::before,#yotpo-reviews * .text-xl.leading-tight.capsize::before,#yotpo-reviews * .text-xl .leading-tight.capsize::before, .text-xl #yotpo-reviews *.leading-tight.capsize::before, .text-xl #yotpo-reviews * .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-tight.capsize::after,#yotpo-reviews * .text-xl.leading-tight.capsize::after,#yotpo-reviews * .text-xl .leading-tight.capsize::after, .text-xl #yotpo-reviews *.leading-tight.capsize::after, .text-xl #yotpo-reviews * .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-snug.capsize::before,#yotpo-reviews * .text-xl.leading-snug.capsize::before,#yotpo-reviews * .text-xl .leading-snug.capsize::before, .text-xl #yotpo-reviews *.leading-snug.capsize::before, .text-xl #yotpo-reviews * .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-snug.capsize::after,#yotpo-reviews * .text-xl.leading-snug.capsize::after,#yotpo-reviews * .text-xl .leading-snug.capsize::after, .text-xl #yotpo-reviews *.leading-snug.capsize::after, .text-xl #yotpo-reviews * .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-normal.capsize::before,#yotpo-reviews * .text-xl.leading-normal.capsize::before,#yotpo-reviews * .text-xl .leading-normal.capsize::before, .text-xl #yotpo-reviews *.leading-normal.capsize::before, .text-xl #yotpo-reviews * .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-normal.capsize::after,#yotpo-reviews * .text-xl.leading-normal.capsize::after,#yotpo-reviews * .text-xl .leading-normal.capsize::after, .text-xl #yotpo-reviews *.leading-normal.capsize::after, .text-xl #yotpo-reviews * .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-relaxed.capsize::before,#yotpo-reviews * .text-xl.leading-relaxed.capsize::before,#yotpo-reviews * .text-xl .leading-relaxed.capsize::before, .text-xl #yotpo-reviews *.leading-relaxed.capsize::before, .text-xl #yotpo-reviews * .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-relaxed.capsize::after,#yotpo-reviews * .text-xl.leading-relaxed.capsize::after,#yotpo-reviews * .text-xl .leading-relaxed.capsize::after, .text-xl #yotpo-reviews *.leading-relaxed.capsize::after, .text-xl #yotpo-reviews * .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-loose.capsize::before,#yotpo-reviews * .text-xl.leading-loose.capsize::before,#yotpo-reviews * .text-xl .leading-loose.capsize::before, .text-xl #yotpo-reviews *.leading-loose.capsize::before, .text-xl #yotpo-reviews * .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
#yotpo-reviews *.text-xl.leading-loose.capsize::after,#yotpo-reviews * .text-xl.leading-loose.capsize::after,#yotpo-reviews * .text-xl .leading-loose.capsize::after, .text-xl #yotpo-reviews *.leading-loose.capsize::after, .text-xl #yotpo-reviews * .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-3.capsize::before,#yotpo-reviews * .text-2xl.leading-3.capsize::before,#yotpo-reviews * .text-2xl .leading-3.capsize::before, .text-2xl #yotpo-reviews *.leading-3.capsize::before, .text-2xl #yotpo-reviews * .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: 0.093em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-3.capsize::after,#yotpo-reviews * .text-2xl.leading-3.capsize::after,#yotpo-reviews * .text-2xl .leading-3.capsize::after, .text-2xl #yotpo-reviews *.leading-3.capsize::after, .text-2xl #yotpo-reviews * .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.137em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-4.capsize::before,#yotpo-reviews * .text-2xl.leading-4.capsize::before,#yotpo-reviews * .text-2xl .leading-4.capsize::before, .text-2xl #yotpo-reviews *.leading-4.capsize::before, .text-2xl #yotpo-reviews * .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: 0.0097em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-4.capsize::after,#yotpo-reviews * .text-2xl.leading-4.capsize::after,#yotpo-reviews * .text-2xl .leading-4.capsize::after, .text-2xl #yotpo-reviews *.leading-4.capsize::after, .text-2xl #yotpo-reviews * .leading-4.capsize::after {
  content: '' !important;
  margin-top: 0.0537em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-5.capsize::before,#yotpo-reviews * .text-2xl.leading-5.capsize::before,#yotpo-reviews * .text-2xl .leading-5.capsize::before, .text-2xl #yotpo-reviews *.leading-5.capsize::before, .text-2xl #yotpo-reviews * .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.0737em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-5.capsize::after,#yotpo-reviews * .text-2xl.leading-5.capsize::after,#yotpo-reviews * .text-2xl .leading-5.capsize::after, .text-2xl #yotpo-reviews *.leading-5.capsize::after, .text-2xl #yotpo-reviews * .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.0297em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-6.capsize::before,#yotpo-reviews * .text-2xl.leading-6.capsize::before,#yotpo-reviews * .text-2xl .leading-6.capsize::before, .text-2xl #yotpo-reviews *.leading-6.capsize::before, .text-2xl #yotpo-reviews * .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-6.capsize::after,#yotpo-reviews * .text-2xl.leading-6.capsize::after,#yotpo-reviews * .text-2xl .leading-6.capsize::after, .text-2xl #yotpo-reviews *.leading-6.capsize::after, .text-2xl #yotpo-reviews * .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-7.capsize::before,#yotpo-reviews * .text-2xl.leading-7.capsize::before,#yotpo-reviews * .text-2xl .leading-7.capsize::before, .text-2xl #yotpo-reviews *.leading-7.capsize::before, .text-2xl #yotpo-reviews * .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.2403em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-7.capsize::after,#yotpo-reviews * .text-2xl.leading-7.capsize::after,#yotpo-reviews * .text-2xl .leading-7.capsize::after, .text-2xl #yotpo-reviews *.leading-7.capsize::after, .text-2xl #yotpo-reviews * .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.1963em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-8.capsize::before,#yotpo-reviews * .text-2xl.leading-8.capsize::before,#yotpo-reviews * .text-2xl .leading-8.capsize::before, .text-2xl #yotpo-reviews *.leading-8.capsize::before, .text-2xl #yotpo-reviews * .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.3237em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-8.capsize::after,#yotpo-reviews * .text-2xl.leading-8.capsize::after,#yotpo-reviews * .text-2xl .leading-8.capsize::after, .text-2xl #yotpo-reviews *.leading-8.capsize::after, .text-2xl #yotpo-reviews * .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.2797em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-9.capsize::before,#yotpo-reviews * .text-2xl.leading-9.capsize::before,#yotpo-reviews * .text-2xl .leading-9.capsize::before, .text-2xl #yotpo-reviews *.leading-9.capsize::before, .text-2xl #yotpo-reviews * .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-9.capsize::after,#yotpo-reviews * .text-2xl.leading-9.capsize::after,#yotpo-reviews * .text-2xl .leading-9.capsize::after, .text-2xl #yotpo-reviews *.leading-9.capsize::after, .text-2xl #yotpo-reviews * .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-10.capsize::before,#yotpo-reviews * .text-2xl.leading-10.capsize::before,#yotpo-reviews * .text-2xl .leading-10.capsize::before, .text-2xl #yotpo-reviews *.leading-10.capsize::before, .text-2xl #yotpo-reviews * .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -0.4903em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-10.capsize::after,#yotpo-reviews * .text-2xl.leading-10.capsize::after,#yotpo-reviews * .text-2xl .leading-10.capsize::after, .text-2xl #yotpo-reviews *.leading-10.capsize::after, .text-2xl #yotpo-reviews * .leading-10.capsize::after {
  content: '' !important;
  margin-top: -0.4463em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-none.capsize::before,#yotpo-reviews * .text-2xl.leading-none.capsize::before,#yotpo-reviews * .text-2xl .leading-none.capsize::before, .text-2xl #yotpo-reviews *.leading-none.capsize::before, .text-2xl #yotpo-reviews * .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-none.capsize::after,#yotpo-reviews * .text-2xl.leading-none.capsize::after,#yotpo-reviews * .text-2xl .leading-none.capsize::after, .text-2xl #yotpo-reviews *.leading-none.capsize::after, .text-2xl #yotpo-reviews * .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-tight.capsize::before,#yotpo-reviews * .text-2xl.leading-tight.capsize::before,#yotpo-reviews * .text-2xl .leading-tight.capsize::before, .text-2xl #yotpo-reviews *.leading-tight.capsize::before, .text-2xl #yotpo-reviews * .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-tight.capsize::after,#yotpo-reviews * .text-2xl.leading-tight.capsize::after,#yotpo-reviews * .text-2xl .leading-tight.capsize::after, .text-2xl #yotpo-reviews *.leading-tight.capsize::after, .text-2xl #yotpo-reviews * .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-snug.capsize::before,#yotpo-reviews * .text-2xl.leading-snug.capsize::before,#yotpo-reviews * .text-2xl .leading-snug.capsize::before, .text-2xl #yotpo-reviews *.leading-snug.capsize::before, .text-2xl #yotpo-reviews * .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-snug.capsize::after,#yotpo-reviews * .text-2xl.leading-snug.capsize::after,#yotpo-reviews * .text-2xl .leading-snug.capsize::after, .text-2xl #yotpo-reviews *.leading-snug.capsize::after, .text-2xl #yotpo-reviews * .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-normal.capsize::before,#yotpo-reviews * .text-2xl.leading-normal.capsize::before,#yotpo-reviews * .text-2xl .leading-normal.capsize::before, .text-2xl #yotpo-reviews *.leading-normal.capsize::before, .text-2xl #yotpo-reviews * .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-normal.capsize::after,#yotpo-reviews * .text-2xl.leading-normal.capsize::after,#yotpo-reviews * .text-2xl .leading-normal.capsize::after, .text-2xl #yotpo-reviews *.leading-normal.capsize::after, .text-2xl #yotpo-reviews * .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-relaxed.capsize::before,#yotpo-reviews * .text-2xl.leading-relaxed.capsize::before,#yotpo-reviews * .text-2xl .leading-relaxed.capsize::before, .text-2xl #yotpo-reviews *.leading-relaxed.capsize::before, .text-2xl #yotpo-reviews * .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-relaxed.capsize::after,#yotpo-reviews * .text-2xl.leading-relaxed.capsize::after,#yotpo-reviews * .text-2xl .leading-relaxed.capsize::after, .text-2xl #yotpo-reviews *.leading-relaxed.capsize::after, .text-2xl #yotpo-reviews * .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-loose.capsize::before,#yotpo-reviews * .text-2xl.leading-loose.capsize::before,#yotpo-reviews * .text-2xl .leading-loose.capsize::before, .text-2xl #yotpo-reviews *.leading-loose.capsize::before, .text-2xl #yotpo-reviews * .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
#yotpo-reviews *.text-2xl.leading-loose.capsize::after,#yotpo-reviews * .text-2xl.leading-loose.capsize::after,#yotpo-reviews * .text-2xl .leading-loose.capsize::after, .text-2xl #yotpo-reviews *.leading-loose.capsize::after, .text-2xl #yotpo-reviews * .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-3.capsize::before,#yotpo-reviews * .text-3xl.leading-3.capsize::before,#yotpo-reviews * .text-3xl .leading-3.capsize::before, .text-3xl #yotpo-reviews *.leading-3.capsize::before, .text-3xl #yotpo-reviews * .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: 0.143em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-3.capsize::after,#yotpo-reviews * .text-3xl.leading-3.capsize::after,#yotpo-reviews * .text-3xl .leading-3.capsize::after, .text-3xl #yotpo-reviews *.leading-3.capsize::after, .text-3xl #yotpo-reviews * .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.187em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-4.capsize::before,#yotpo-reviews * .text-3xl.leading-4.capsize::before,#yotpo-reviews * .text-3xl .leading-4.capsize::before, .text-3xl #yotpo-reviews *.leading-4.capsize::before, .text-3xl #yotpo-reviews * .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: 0.0763em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-4.capsize::after,#yotpo-reviews * .text-3xl.leading-4.capsize::after,#yotpo-reviews * .text-3xl .leading-4.capsize::after, .text-3xl #yotpo-reviews *.leading-4.capsize::after, .text-3xl #yotpo-reviews * .leading-4.capsize::after {
  content: '' !important;
  margin-top: 0.1203em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-5.capsize::before,#yotpo-reviews * .text-3xl.leading-5.capsize::before,#yotpo-reviews * .text-3xl .leading-5.capsize::before, .text-3xl #yotpo-reviews *.leading-5.capsize::before, .text-3xl #yotpo-reviews * .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: 0.0097em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-5.capsize::after,#yotpo-reviews * .text-3xl.leading-5.capsize::after,#yotpo-reviews * .text-3xl .leading-5.capsize::after, .text-3xl #yotpo-reviews *.leading-5.capsize::after, .text-3xl #yotpo-reviews * .leading-5.capsize::after {
  content: '' !important;
  margin-top: 0.0537em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-6.capsize::before,#yotpo-reviews * .text-3xl.leading-6.capsize::before,#yotpo-reviews * .text-3xl .leading-6.capsize::before, .text-3xl #yotpo-reviews *.leading-6.capsize::before, .text-3xl #yotpo-reviews * .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.057em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-6.capsize::after,#yotpo-reviews * .text-3xl.leading-6.capsize::after,#yotpo-reviews * .text-3xl .leading-6.capsize::after, .text-3xl #yotpo-reviews *.leading-6.capsize::after, .text-3xl #yotpo-reviews * .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.013em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-7.capsize::before,#yotpo-reviews * .text-3xl.leading-7.capsize::before,#yotpo-reviews * .text-3xl .leading-7.capsize::before, .text-3xl #yotpo-reviews *.leading-7.capsize::before, .text-3xl #yotpo-reviews * .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.1237em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-7.capsize::after,#yotpo-reviews * .text-3xl.leading-7.capsize::after,#yotpo-reviews * .text-3xl .leading-7.capsize::after, .text-3xl #yotpo-reviews *.leading-7.capsize::after, .text-3xl #yotpo-reviews * .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.0797em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-8.capsize::before,#yotpo-reviews * .text-3xl.leading-8.capsize::before,#yotpo-reviews * .text-3xl .leading-8.capsize::before, .text-3xl #yotpo-reviews *.leading-8.capsize::before, .text-3xl #yotpo-reviews * .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.1903em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-8.capsize::after,#yotpo-reviews * .text-3xl.leading-8.capsize::after,#yotpo-reviews * .text-3xl .leading-8.capsize::after, .text-3xl #yotpo-reviews *.leading-8.capsize::after, .text-3xl #yotpo-reviews * .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.1463em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-9.capsize::before,#yotpo-reviews * .text-3xl.leading-9.capsize::before,#yotpo-reviews * .text-3xl .leading-9.capsize::before, .text-3xl #yotpo-reviews *.leading-9.capsize::before, .text-3xl #yotpo-reviews * .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.257em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-9.capsize::after,#yotpo-reviews * .text-3xl.leading-9.capsize::after,#yotpo-reviews * .text-3xl .leading-9.capsize::after, .text-3xl #yotpo-reviews *.leading-9.capsize::after, .text-3xl #yotpo-reviews * .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.213em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-10.capsize::before,#yotpo-reviews * .text-3xl.leading-10.capsize::before,#yotpo-reviews * .text-3xl .leading-10.capsize::before, .text-3xl #yotpo-reviews *.leading-10.capsize::before, .text-3xl #yotpo-reviews * .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -0.3237em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-10.capsize::after,#yotpo-reviews * .text-3xl.leading-10.capsize::after,#yotpo-reviews * .text-3xl .leading-10.capsize::after, .text-3xl #yotpo-reviews *.leading-10.capsize::after, .text-3xl #yotpo-reviews * .leading-10.capsize::after {
  content: '' !important;
  margin-top: -0.2797em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-none.capsize::before,#yotpo-reviews * .text-3xl.leading-none.capsize::before,#yotpo-reviews * .text-3xl .leading-none.capsize::before, .text-3xl #yotpo-reviews *.leading-none.capsize::before, .text-3xl #yotpo-reviews * .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-none.capsize::after,#yotpo-reviews * .text-3xl.leading-none.capsize::after,#yotpo-reviews * .text-3xl .leading-none.capsize::after, .text-3xl #yotpo-reviews *.leading-none.capsize::after, .text-3xl #yotpo-reviews * .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-tight.capsize::before,#yotpo-reviews * .text-3xl.leading-tight.capsize::before,#yotpo-reviews * .text-3xl .leading-tight.capsize::before, .text-3xl #yotpo-reviews *.leading-tight.capsize::before, .text-3xl #yotpo-reviews * .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-tight.capsize::after,#yotpo-reviews * .text-3xl.leading-tight.capsize::after,#yotpo-reviews * .text-3xl .leading-tight.capsize::after, .text-3xl #yotpo-reviews *.leading-tight.capsize::after, .text-3xl #yotpo-reviews * .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-snug.capsize::before,#yotpo-reviews * .text-3xl.leading-snug.capsize::before,#yotpo-reviews * .text-3xl .leading-snug.capsize::before, .text-3xl #yotpo-reviews *.leading-snug.capsize::before, .text-3xl #yotpo-reviews * .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-snug.capsize::after,#yotpo-reviews * .text-3xl.leading-snug.capsize::after,#yotpo-reviews * .text-3xl .leading-snug.capsize::after, .text-3xl #yotpo-reviews *.leading-snug.capsize::after, .text-3xl #yotpo-reviews * .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-normal.capsize::before,#yotpo-reviews * .text-3xl.leading-normal.capsize::before,#yotpo-reviews * .text-3xl .leading-normal.capsize::before, .text-3xl #yotpo-reviews *.leading-normal.capsize::before, .text-3xl #yotpo-reviews * .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-normal.capsize::after,#yotpo-reviews * .text-3xl.leading-normal.capsize::after,#yotpo-reviews * .text-3xl .leading-normal.capsize::after, .text-3xl #yotpo-reviews *.leading-normal.capsize::after, .text-3xl #yotpo-reviews * .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-relaxed.capsize::before,#yotpo-reviews * .text-3xl.leading-relaxed.capsize::before,#yotpo-reviews * .text-3xl .leading-relaxed.capsize::before, .text-3xl #yotpo-reviews *.leading-relaxed.capsize::before, .text-3xl #yotpo-reviews * .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-relaxed.capsize::after,#yotpo-reviews * .text-3xl.leading-relaxed.capsize::after,#yotpo-reviews * .text-3xl .leading-relaxed.capsize::after, .text-3xl #yotpo-reviews *.leading-relaxed.capsize::after, .text-3xl #yotpo-reviews * .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-loose.capsize::before,#yotpo-reviews * .text-3xl.leading-loose.capsize::before,#yotpo-reviews * .text-3xl .leading-loose.capsize::before, .text-3xl #yotpo-reviews *.leading-loose.capsize::before, .text-3xl #yotpo-reviews * .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
#yotpo-reviews *.text-3xl.leading-loose.capsize::after,#yotpo-reviews * .text-3xl.leading-loose.capsize::after,#yotpo-reviews * .text-3xl .leading-loose.capsize::after, .text-3xl #yotpo-reviews *.leading-loose.capsize::after, .text-3xl #yotpo-reviews * .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-3.capsize::before,#yotpo-reviews * .text-4xl.leading-3.capsize::before,#yotpo-reviews * .text-4xl .leading-3.capsize::before, .text-4xl #yotpo-reviews *.leading-3.capsize::before, .text-4xl #yotpo-reviews * .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: 0.1763em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-3.capsize::after,#yotpo-reviews * .text-4xl.leading-3.capsize::after,#yotpo-reviews * .text-4xl .leading-3.capsize::after, .text-4xl #yotpo-reviews *.leading-3.capsize::after, .text-4xl #yotpo-reviews * .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.2203em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-4.capsize::before,#yotpo-reviews * .text-4xl.leading-4.capsize::before,#yotpo-reviews * .text-4xl .leading-4.capsize::before, .text-4xl #yotpo-reviews *.leading-4.capsize::before, .text-4xl #yotpo-reviews * .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: 0.1208em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-4.capsize::after,#yotpo-reviews * .text-4xl.leading-4.capsize::after,#yotpo-reviews * .text-4xl .leading-4.capsize::after, .text-4xl #yotpo-reviews *.leading-4.capsize::after, .text-4xl #yotpo-reviews * .leading-4.capsize::after {
  content: '' !important;
  margin-top: 0.1648em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-5.capsize::before,#yotpo-reviews * .text-4xl.leading-5.capsize::before,#yotpo-reviews * .text-4xl .leading-5.capsize::before, .text-4xl #yotpo-reviews *.leading-5.capsize::before, .text-4xl #yotpo-reviews * .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: 0.0652em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-5.capsize::after,#yotpo-reviews * .text-4xl.leading-5.capsize::after,#yotpo-reviews * .text-4xl .leading-5.capsize::after, .text-4xl #yotpo-reviews *.leading-5.capsize::after, .text-4xl #yotpo-reviews * .leading-5.capsize::after {
  content: '' !important;
  margin-top: 0.1092em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-6.capsize::before,#yotpo-reviews * .text-4xl.leading-6.capsize::before,#yotpo-reviews * .text-4xl .leading-6.capsize::before, .text-4xl #yotpo-reviews *.leading-6.capsize::before, .text-4xl #yotpo-reviews * .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: 0.0097em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-6.capsize::after,#yotpo-reviews * .text-4xl.leading-6.capsize::after,#yotpo-reviews * .text-4xl .leading-6.capsize::after, .text-4xl #yotpo-reviews *.leading-6.capsize::after, .text-4xl #yotpo-reviews * .leading-6.capsize::after {
  content: '' !important;
  margin-top: 0.0537em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-7.capsize::before,#yotpo-reviews * .text-4xl.leading-7.capsize::before,#yotpo-reviews * .text-4xl .leading-7.capsize::before, .text-4xl #yotpo-reviews *.leading-7.capsize::before, .text-4xl #yotpo-reviews * .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.0459em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-7.capsize::after,#yotpo-reviews * .text-4xl.leading-7.capsize::after,#yotpo-reviews * .text-4xl .leading-7.capsize::after, .text-4xl #yotpo-reviews *.leading-7.capsize::after, .text-4xl #yotpo-reviews * .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.0019em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-8.capsize::before,#yotpo-reviews * .text-4xl.leading-8.capsize::before,#yotpo-reviews * .text-4xl .leading-8.capsize::before, .text-4xl #yotpo-reviews *.leading-8.capsize::before, .text-4xl #yotpo-reviews * .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.1014em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-8.capsize::after,#yotpo-reviews * .text-4xl.leading-8.capsize::after,#yotpo-reviews * .text-4xl .leading-8.capsize::after, .text-4xl #yotpo-reviews *.leading-8.capsize::after, .text-4xl #yotpo-reviews * .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.0574em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-9.capsize::before,#yotpo-reviews * .text-4xl.leading-9.capsize::before,#yotpo-reviews * .text-4xl .leading-9.capsize::before, .text-4xl #yotpo-reviews *.leading-9.capsize::before, .text-4xl #yotpo-reviews * .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-9.capsize::after,#yotpo-reviews * .text-4xl.leading-9.capsize::after,#yotpo-reviews * .text-4xl .leading-9.capsize::after, .text-4xl #yotpo-reviews *.leading-9.capsize::after, .text-4xl #yotpo-reviews * .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-10.capsize::before,#yotpo-reviews * .text-4xl.leading-10.capsize::before,#yotpo-reviews * .text-4xl .leading-10.capsize::before, .text-4xl #yotpo-reviews *.leading-10.capsize::before, .text-4xl #yotpo-reviews * .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -0.2126em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-10.capsize::after,#yotpo-reviews * .text-4xl.leading-10.capsize::after,#yotpo-reviews * .text-4xl .leading-10.capsize::after, .text-4xl #yotpo-reviews *.leading-10.capsize::after, .text-4xl #yotpo-reviews * .leading-10.capsize::after {
  content: '' !important;
  margin-top: -0.1686em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-none.capsize::before,#yotpo-reviews * .text-4xl.leading-none.capsize::before,#yotpo-reviews * .text-4xl .leading-none.capsize::before, .text-4xl #yotpo-reviews *.leading-none.capsize::before, .text-4xl #yotpo-reviews * .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-none.capsize::after,#yotpo-reviews * .text-4xl.leading-none.capsize::after,#yotpo-reviews * .text-4xl .leading-none.capsize::after, .text-4xl #yotpo-reviews *.leading-none.capsize::after, .text-4xl #yotpo-reviews * .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-tight.capsize::before,#yotpo-reviews * .text-4xl.leading-tight.capsize::before,#yotpo-reviews * .text-4xl .leading-tight.capsize::before, .text-4xl #yotpo-reviews *.leading-tight.capsize::before, .text-4xl #yotpo-reviews * .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-tight.capsize::after,#yotpo-reviews * .text-4xl.leading-tight.capsize::after,#yotpo-reviews * .text-4xl .leading-tight.capsize::after, .text-4xl #yotpo-reviews *.leading-tight.capsize::after, .text-4xl #yotpo-reviews * .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-snug.capsize::before,#yotpo-reviews * .text-4xl.leading-snug.capsize::before,#yotpo-reviews * .text-4xl .leading-snug.capsize::before, .text-4xl #yotpo-reviews *.leading-snug.capsize::before, .text-4xl #yotpo-reviews * .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-snug.capsize::after,#yotpo-reviews * .text-4xl.leading-snug.capsize::after,#yotpo-reviews * .text-4xl .leading-snug.capsize::after, .text-4xl #yotpo-reviews *.leading-snug.capsize::after, .text-4xl #yotpo-reviews * .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-normal.capsize::before,#yotpo-reviews * .text-4xl.leading-normal.capsize::before,#yotpo-reviews * .text-4xl .leading-normal.capsize::before, .text-4xl #yotpo-reviews *.leading-normal.capsize::before, .text-4xl #yotpo-reviews * .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-normal.capsize::after,#yotpo-reviews * .text-4xl.leading-normal.capsize::after,#yotpo-reviews * .text-4xl .leading-normal.capsize::after, .text-4xl #yotpo-reviews *.leading-normal.capsize::after, .text-4xl #yotpo-reviews * .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-relaxed.capsize::before,#yotpo-reviews * .text-4xl.leading-relaxed.capsize::before,#yotpo-reviews * .text-4xl .leading-relaxed.capsize::before, .text-4xl #yotpo-reviews *.leading-relaxed.capsize::before, .text-4xl #yotpo-reviews * .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-relaxed.capsize::after,#yotpo-reviews * .text-4xl.leading-relaxed.capsize::after,#yotpo-reviews * .text-4xl .leading-relaxed.capsize::after, .text-4xl #yotpo-reviews *.leading-relaxed.capsize::after, .text-4xl #yotpo-reviews * .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-loose.capsize::before,#yotpo-reviews * .text-4xl.leading-loose.capsize::before,#yotpo-reviews * .text-4xl .leading-loose.capsize::before, .text-4xl #yotpo-reviews *.leading-loose.capsize::before, .text-4xl #yotpo-reviews * .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
#yotpo-reviews *.text-4xl.leading-loose.capsize::after,#yotpo-reviews * .text-4xl.leading-loose.capsize::after,#yotpo-reviews * .text-4xl .leading-loose.capsize::after, .text-4xl #yotpo-reviews *.leading-loose.capsize::after, .text-4xl #yotpo-reviews * .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-3.capsize::before,#yotpo-reviews * .text-5xl.leading-3.capsize::before,#yotpo-reviews * .text-5xl .leading-3.capsize::before, .text-5xl #yotpo-reviews *.leading-3.capsize::before, .text-5xl #yotpo-reviews * .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: 0.218em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-3.capsize::after,#yotpo-reviews * .text-5xl.leading-3.capsize::after,#yotpo-reviews * .text-5xl .leading-3.capsize::after, .text-5xl #yotpo-reviews *.leading-3.capsize::after, .text-5xl #yotpo-reviews * .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.262em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-4.capsize::before,#yotpo-reviews * .text-5xl.leading-4.capsize::before,#yotpo-reviews * .text-5xl .leading-4.capsize::before, .text-5xl #yotpo-reviews *.leading-4.capsize::before, .text-5xl #yotpo-reviews * .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: 0.1763em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-4.capsize::after,#yotpo-reviews * .text-5xl.leading-4.capsize::after,#yotpo-reviews * .text-5xl .leading-4.capsize::after, .text-5xl #yotpo-reviews *.leading-4.capsize::after, .text-5xl #yotpo-reviews * .leading-4.capsize::after {
  content: '' !important;
  margin-top: 0.2203em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-5.capsize::before,#yotpo-reviews * .text-5xl.leading-5.capsize::before,#yotpo-reviews * .text-5xl .leading-5.capsize::before, .text-5xl #yotpo-reviews *.leading-5.capsize::before, .text-5xl #yotpo-reviews * .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: 0.1347em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-5.capsize::after,#yotpo-reviews * .text-5xl.leading-5.capsize::after,#yotpo-reviews * .text-5xl .leading-5.capsize::after, .text-5xl #yotpo-reviews *.leading-5.capsize::after, .text-5xl #yotpo-reviews * .leading-5.capsize::after {
  content: '' !important;
  margin-top: 0.1787em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-6.capsize::before,#yotpo-reviews * .text-5xl.leading-6.capsize::before,#yotpo-reviews * .text-5xl .leading-6.capsize::before, .text-5xl #yotpo-reviews *.leading-6.capsize::before, .text-5xl #yotpo-reviews * .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: 0.093em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-6.capsize::after,#yotpo-reviews * .text-5xl.leading-6.capsize::after,#yotpo-reviews * .text-5xl .leading-6.capsize::after, .text-5xl #yotpo-reviews *.leading-6.capsize::after, .text-5xl #yotpo-reviews * .leading-6.capsize::after {
  content: '' !important;
  margin-top: 0.137em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-7.capsize::before,#yotpo-reviews * .text-5xl.leading-7.capsize::before,#yotpo-reviews * .text-5xl .leading-7.capsize::before, .text-5xl #yotpo-reviews *.leading-7.capsize::before, .text-5xl #yotpo-reviews * .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.0513em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-7.capsize::after,#yotpo-reviews * .text-5xl.leading-7.capsize::after,#yotpo-reviews * .text-5xl .leading-7.capsize::after, .text-5xl #yotpo-reviews *.leading-7.capsize::after, .text-5xl #yotpo-reviews * .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.0953em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-8.capsize::before,#yotpo-reviews * .text-5xl.leading-8.capsize::before,#yotpo-reviews * .text-5xl .leading-8.capsize::before, .text-5xl #yotpo-reviews *.leading-8.capsize::before, .text-5xl #yotpo-reviews * .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: 0.0097em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-8.capsize::after,#yotpo-reviews * .text-5xl.leading-8.capsize::after,#yotpo-reviews * .text-5xl .leading-8.capsize::after, .text-5xl #yotpo-reviews *.leading-8.capsize::after, .text-5xl #yotpo-reviews * .leading-8.capsize::after {
  content: '' !important;
  margin-top: 0.0537em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-9.capsize::before,#yotpo-reviews * .text-5xl.leading-9.capsize::before,#yotpo-reviews * .text-5xl .leading-9.capsize::before, .text-5xl #yotpo-reviews *.leading-9.capsize::before, .text-5xl #yotpo-reviews * .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.032em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-9.capsize::after,#yotpo-reviews * .text-5xl.leading-9.capsize::after,#yotpo-reviews * .text-5xl .leading-9.capsize::after, .text-5xl #yotpo-reviews *.leading-9.capsize::after, .text-5xl #yotpo-reviews * .leading-9.capsize::after {
  content: '' !important;
  margin-top: 0.012em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-10.capsize::before,#yotpo-reviews * .text-5xl.leading-10.capsize::before,#yotpo-reviews * .text-5xl .leading-10.capsize::before, .text-5xl #yotpo-reviews *.leading-10.capsize::before, .text-5xl #yotpo-reviews * .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -0.0737em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-10.capsize::after,#yotpo-reviews * .text-5xl.leading-10.capsize::after,#yotpo-reviews * .text-5xl .leading-10.capsize::after, .text-5xl #yotpo-reviews *.leading-10.capsize::after, .text-5xl #yotpo-reviews * .leading-10.capsize::after {
  content: '' !important;
  margin-top: -0.0297em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-none.capsize::before,#yotpo-reviews * .text-5xl.leading-none.capsize::before,#yotpo-reviews * .text-5xl .leading-none.capsize::before, .text-5xl #yotpo-reviews *.leading-none.capsize::before, .text-5xl #yotpo-reviews * .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-none.capsize::after,#yotpo-reviews * .text-5xl.leading-none.capsize::after,#yotpo-reviews * .text-5xl .leading-none.capsize::after, .text-5xl #yotpo-reviews *.leading-none.capsize::after, .text-5xl #yotpo-reviews * .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-tight.capsize::before,#yotpo-reviews * .text-5xl.leading-tight.capsize::before,#yotpo-reviews * .text-5xl .leading-tight.capsize::before, .text-5xl #yotpo-reviews *.leading-tight.capsize::before, .text-5xl #yotpo-reviews * .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-tight.capsize::after,#yotpo-reviews * .text-5xl.leading-tight.capsize::after,#yotpo-reviews * .text-5xl .leading-tight.capsize::after, .text-5xl #yotpo-reviews *.leading-tight.capsize::after, .text-5xl #yotpo-reviews * .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-snug.capsize::before,#yotpo-reviews * .text-5xl.leading-snug.capsize::before,#yotpo-reviews * .text-5xl .leading-snug.capsize::before, .text-5xl #yotpo-reviews *.leading-snug.capsize::before, .text-5xl #yotpo-reviews * .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-snug.capsize::after,#yotpo-reviews * .text-5xl.leading-snug.capsize::after,#yotpo-reviews * .text-5xl .leading-snug.capsize::after, .text-5xl #yotpo-reviews *.leading-snug.capsize::after, .text-5xl #yotpo-reviews * .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-normal.capsize::before,#yotpo-reviews * .text-5xl.leading-normal.capsize::before,#yotpo-reviews * .text-5xl .leading-normal.capsize::before, .text-5xl #yotpo-reviews *.leading-normal.capsize::before, .text-5xl #yotpo-reviews * .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-normal.capsize::after,#yotpo-reviews * .text-5xl.leading-normal.capsize::after,#yotpo-reviews * .text-5xl .leading-normal.capsize::after, .text-5xl #yotpo-reviews *.leading-normal.capsize::after, .text-5xl #yotpo-reviews * .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-relaxed.capsize::before,#yotpo-reviews * .text-5xl.leading-relaxed.capsize::before,#yotpo-reviews * .text-5xl .leading-relaxed.capsize::before, .text-5xl #yotpo-reviews *.leading-relaxed.capsize::before, .text-5xl #yotpo-reviews * .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-relaxed.capsize::after,#yotpo-reviews * .text-5xl.leading-relaxed.capsize::after,#yotpo-reviews * .text-5xl .leading-relaxed.capsize::after, .text-5xl #yotpo-reviews *.leading-relaxed.capsize::after, .text-5xl #yotpo-reviews * .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-loose.capsize::before,#yotpo-reviews * .text-5xl.leading-loose.capsize::before,#yotpo-reviews * .text-5xl .leading-loose.capsize::before, .text-5xl #yotpo-reviews *.leading-loose.capsize::before, .text-5xl #yotpo-reviews * .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
#yotpo-reviews *.text-5xl.leading-loose.capsize::after,#yotpo-reviews * .text-5xl.leading-loose.capsize::after,#yotpo-reviews * .text-5xl .leading-loose.capsize::after, .text-5xl #yotpo-reviews *.leading-loose.capsize::after, .text-5xl #yotpo-reviews * .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-3.capsize::before,#yotpo-reviews * .text-6xl.leading-3.capsize::before,#yotpo-reviews * .text-6xl .leading-3.capsize::before, .text-6xl #yotpo-reviews *.leading-3.capsize::before, .text-6xl #yotpo-reviews * .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: 0.243em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-3.capsize::after,#yotpo-reviews * .text-6xl.leading-3.capsize::after,#yotpo-reviews * .text-6xl .leading-3.capsize::after, .text-6xl #yotpo-reviews *.leading-3.capsize::after, .text-6xl #yotpo-reviews * .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.287em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-4.capsize::before,#yotpo-reviews * .text-6xl.leading-4.capsize::before,#yotpo-reviews * .text-6xl .leading-4.capsize::before, .text-6xl #yotpo-reviews *.leading-4.capsize::before, .text-6xl #yotpo-reviews * .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: 0.2097em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-4.capsize::after,#yotpo-reviews * .text-6xl.leading-4.capsize::after,#yotpo-reviews * .text-6xl .leading-4.capsize::after, .text-6xl #yotpo-reviews *.leading-4.capsize::after, .text-6xl #yotpo-reviews * .leading-4.capsize::after {
  content: '' !important;
  margin-top: 0.2537em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-5.capsize::before,#yotpo-reviews * .text-6xl.leading-5.capsize::before,#yotpo-reviews * .text-6xl .leading-5.capsize::before, .text-6xl #yotpo-reviews *.leading-5.capsize::before, .text-6xl #yotpo-reviews * .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: 0.1763em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-5.capsize::after,#yotpo-reviews * .text-6xl.leading-5.capsize::after,#yotpo-reviews * .text-6xl .leading-5.capsize::after, .text-6xl #yotpo-reviews *.leading-5.capsize::after, .text-6xl #yotpo-reviews * .leading-5.capsize::after {
  content: '' !important;
  margin-top: 0.2203em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-6.capsize::before,#yotpo-reviews * .text-6xl.leading-6.capsize::before,#yotpo-reviews * .text-6xl .leading-6.capsize::before, .text-6xl #yotpo-reviews *.leading-6.capsize::before, .text-6xl #yotpo-reviews * .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: 0.143em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-6.capsize::after,#yotpo-reviews * .text-6xl.leading-6.capsize::after,#yotpo-reviews * .text-6xl .leading-6.capsize::after, .text-6xl #yotpo-reviews *.leading-6.capsize::after, .text-6xl #yotpo-reviews * .leading-6.capsize::after {
  content: '' !important;
  margin-top: 0.187em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-7.capsize::before,#yotpo-reviews * .text-6xl.leading-7.capsize::before,#yotpo-reviews * .text-6xl .leading-7.capsize::before, .text-6xl #yotpo-reviews *.leading-7.capsize::before, .text-6xl #yotpo-reviews * .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.1097em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-7.capsize::after,#yotpo-reviews * .text-6xl.leading-7.capsize::after,#yotpo-reviews * .text-6xl .leading-7.capsize::after, .text-6xl #yotpo-reviews *.leading-7.capsize::after, .text-6xl #yotpo-reviews * .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.1537em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-8.capsize::before,#yotpo-reviews * .text-6xl.leading-8.capsize::before,#yotpo-reviews * .text-6xl .leading-8.capsize::before, .text-6xl #yotpo-reviews *.leading-8.capsize::before, .text-6xl #yotpo-reviews * .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: 0.0763em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-8.capsize::after,#yotpo-reviews * .text-6xl.leading-8.capsize::after,#yotpo-reviews * .text-6xl .leading-8.capsize::after, .text-6xl #yotpo-reviews *.leading-8.capsize::after, .text-6xl #yotpo-reviews * .leading-8.capsize::after {
  content: '' !important;
  margin-top: 0.1203em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-9.capsize::before,#yotpo-reviews * .text-6xl.leading-9.capsize::before,#yotpo-reviews * .text-6xl .leading-9.capsize::before, .text-6xl #yotpo-reviews *.leading-9.capsize::before, .text-6xl #yotpo-reviews * .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: 0.043em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-9.capsize::after,#yotpo-reviews * .text-6xl.leading-9.capsize::after,#yotpo-reviews * .text-6xl .leading-9.capsize::after, .text-6xl #yotpo-reviews *.leading-9.capsize::after, .text-6xl #yotpo-reviews * .leading-9.capsize::after {
  content: '' !important;
  margin-top: 0.087em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-10.capsize::before,#yotpo-reviews * .text-6xl.leading-10.capsize::before,#yotpo-reviews * .text-6xl .leading-10.capsize::before, .text-6xl #yotpo-reviews *.leading-10.capsize::before, .text-6xl #yotpo-reviews * .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: 0.0097em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-10.capsize::after,#yotpo-reviews * .text-6xl.leading-10.capsize::after,#yotpo-reviews * .text-6xl .leading-10.capsize::after, .text-6xl #yotpo-reviews *.leading-10.capsize::after, .text-6xl #yotpo-reviews * .leading-10.capsize::after {
  content: '' !important;
  margin-top: 0.0537em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-none.capsize::before,#yotpo-reviews * .text-6xl.leading-none.capsize::before,#yotpo-reviews * .text-6xl .leading-none.capsize::before, .text-6xl #yotpo-reviews *.leading-none.capsize::before, .text-6xl #yotpo-reviews * .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-none.capsize::after,#yotpo-reviews * .text-6xl.leading-none.capsize::after,#yotpo-reviews * .text-6xl .leading-none.capsize::after, .text-6xl #yotpo-reviews *.leading-none.capsize::after, .text-6xl #yotpo-reviews * .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-tight.capsize::before,#yotpo-reviews * .text-6xl.leading-tight.capsize::before,#yotpo-reviews * .text-6xl .leading-tight.capsize::before, .text-6xl #yotpo-reviews *.leading-tight.capsize::before, .text-6xl #yotpo-reviews * .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-tight.capsize::after,#yotpo-reviews * .text-6xl.leading-tight.capsize::after,#yotpo-reviews * .text-6xl .leading-tight.capsize::after, .text-6xl #yotpo-reviews *.leading-tight.capsize::after, .text-6xl #yotpo-reviews * .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-snug.capsize::before,#yotpo-reviews * .text-6xl.leading-snug.capsize::before,#yotpo-reviews * .text-6xl .leading-snug.capsize::before, .text-6xl #yotpo-reviews *.leading-snug.capsize::before, .text-6xl #yotpo-reviews * .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-snug.capsize::after,#yotpo-reviews * .text-6xl.leading-snug.capsize::after,#yotpo-reviews * .text-6xl .leading-snug.capsize::after, .text-6xl #yotpo-reviews *.leading-snug.capsize::after, .text-6xl #yotpo-reviews * .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-normal.capsize::before,#yotpo-reviews * .text-6xl.leading-normal.capsize::before,#yotpo-reviews * .text-6xl .leading-normal.capsize::before, .text-6xl #yotpo-reviews *.leading-normal.capsize::before, .text-6xl #yotpo-reviews * .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-normal.capsize::after,#yotpo-reviews * .text-6xl.leading-normal.capsize::after,#yotpo-reviews * .text-6xl .leading-normal.capsize::after, .text-6xl #yotpo-reviews *.leading-normal.capsize::after, .text-6xl #yotpo-reviews * .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-relaxed.capsize::before,#yotpo-reviews * .text-6xl.leading-relaxed.capsize::before,#yotpo-reviews * .text-6xl .leading-relaxed.capsize::before, .text-6xl #yotpo-reviews *.leading-relaxed.capsize::before, .text-6xl #yotpo-reviews * .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-relaxed.capsize::after,#yotpo-reviews * .text-6xl.leading-relaxed.capsize::after,#yotpo-reviews * .text-6xl .leading-relaxed.capsize::after, .text-6xl #yotpo-reviews *.leading-relaxed.capsize::after, .text-6xl #yotpo-reviews * .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-loose.capsize::before,#yotpo-reviews * .text-6xl.leading-loose.capsize::before,#yotpo-reviews * .text-6xl .leading-loose.capsize::before, .text-6xl #yotpo-reviews *.leading-loose.capsize::before, .text-6xl #yotpo-reviews * .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
#yotpo-reviews *.text-6xl.leading-loose.capsize::after,#yotpo-reviews * .text-6xl.leading-loose.capsize::after,#yotpo-reviews * .text-6xl .leading-loose.capsize::after, .text-6xl #yotpo-reviews *.leading-loose.capsize::after, .text-6xl #yotpo-reviews * .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-3.capsize::before,#yotpo-reviews * .text-7xl.leading-3.capsize::before,#yotpo-reviews * .text-7xl .leading-3.capsize::before, .text-7xl #yotpo-reviews *.leading-3.capsize::before, .text-7xl #yotpo-reviews * .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: 0.2597em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-3.capsize::after,#yotpo-reviews * .text-7xl.leading-3.capsize::after,#yotpo-reviews * .text-7xl .leading-3.capsize::after, .text-7xl #yotpo-reviews *.leading-3.capsize::after, .text-7xl #yotpo-reviews * .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.3037em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-4.capsize::before,#yotpo-reviews * .text-7xl.leading-4.capsize::before,#yotpo-reviews * .text-7xl .leading-4.capsize::before, .text-7xl #yotpo-reviews *.leading-4.capsize::before, .text-7xl #yotpo-reviews * .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: 0.2319em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-4.capsize::after,#yotpo-reviews * .text-7xl.leading-4.capsize::after,#yotpo-reviews * .text-7xl .leading-4.capsize::after, .text-7xl #yotpo-reviews *.leading-4.capsize::after, .text-7xl #yotpo-reviews * .leading-4.capsize::after {
  content: '' !important;
  margin-top: 0.2759em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-5.capsize::before,#yotpo-reviews * .text-7xl.leading-5.capsize::before,#yotpo-reviews * .text-7xl .leading-5.capsize::before, .text-7xl #yotpo-reviews *.leading-5.capsize::before, .text-7xl #yotpo-reviews * .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: 0.2041em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-5.capsize::after,#yotpo-reviews * .text-7xl.leading-5.capsize::after,#yotpo-reviews * .text-7xl .leading-5.capsize::after, .text-7xl #yotpo-reviews *.leading-5.capsize::after, .text-7xl #yotpo-reviews * .leading-5.capsize::after {
  content: '' !important;
  margin-top: 0.2481em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-6.capsize::before,#yotpo-reviews * .text-7xl.leading-6.capsize::before,#yotpo-reviews * .text-7xl .leading-6.capsize::before, .text-7xl #yotpo-reviews *.leading-6.capsize::before, .text-7xl #yotpo-reviews * .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: 0.1763em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-6.capsize::after,#yotpo-reviews * .text-7xl.leading-6.capsize::after,#yotpo-reviews * .text-7xl .leading-6.capsize::after, .text-7xl #yotpo-reviews *.leading-6.capsize::after, .text-7xl #yotpo-reviews * .leading-6.capsize::after {
  content: '' !important;
  margin-top: 0.2203em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-7.capsize::before,#yotpo-reviews * .text-7xl.leading-7.capsize::before,#yotpo-reviews * .text-7xl .leading-7.capsize::before, .text-7xl #yotpo-reviews *.leading-7.capsize::before, .text-7xl #yotpo-reviews * .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.1486em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-7.capsize::after,#yotpo-reviews * .text-7xl.leading-7.capsize::after,#yotpo-reviews * .text-7xl .leading-7.capsize::after, .text-7xl #yotpo-reviews *.leading-7.capsize::after, .text-7xl #yotpo-reviews * .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.1926em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-8.capsize::before,#yotpo-reviews * .text-7xl.leading-8.capsize::before,#yotpo-reviews * .text-7xl .leading-8.capsize::before, .text-7xl #yotpo-reviews *.leading-8.capsize::before, .text-7xl #yotpo-reviews * .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: 0.1208em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-8.capsize::after,#yotpo-reviews * .text-7xl.leading-8.capsize::after,#yotpo-reviews * .text-7xl .leading-8.capsize::after, .text-7xl #yotpo-reviews *.leading-8.capsize::after, .text-7xl #yotpo-reviews * .leading-8.capsize::after {
  content: '' !important;
  margin-top: 0.1648em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-9.capsize::before,#yotpo-reviews * .text-7xl.leading-9.capsize::before,#yotpo-reviews * .text-7xl .leading-9.capsize::before, .text-7xl #yotpo-reviews *.leading-9.capsize::before, .text-7xl #yotpo-reviews * .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: 0.093em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-9.capsize::after,#yotpo-reviews * .text-7xl.leading-9.capsize::after,#yotpo-reviews * .text-7xl .leading-9.capsize::after, .text-7xl #yotpo-reviews *.leading-9.capsize::after, .text-7xl #yotpo-reviews * .leading-9.capsize::after {
  content: '' !important;
  margin-top: 0.137em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-10.capsize::before,#yotpo-reviews * .text-7xl.leading-10.capsize::before,#yotpo-reviews * .text-7xl .leading-10.capsize::before, .text-7xl #yotpo-reviews *.leading-10.capsize::before, .text-7xl #yotpo-reviews * .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: 0.0652em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-10.capsize::after,#yotpo-reviews * .text-7xl.leading-10.capsize::after,#yotpo-reviews * .text-7xl .leading-10.capsize::after, .text-7xl #yotpo-reviews *.leading-10.capsize::after, .text-7xl #yotpo-reviews * .leading-10.capsize::after {
  content: '' !important;
  margin-top: 0.1092em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-none.capsize::before,#yotpo-reviews * .text-7xl.leading-none.capsize::before,#yotpo-reviews * .text-7xl .leading-none.capsize::before, .text-7xl #yotpo-reviews *.leading-none.capsize::before, .text-7xl #yotpo-reviews * .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-none.capsize::after,#yotpo-reviews * .text-7xl.leading-none.capsize::after,#yotpo-reviews * .text-7xl .leading-none.capsize::after, .text-7xl #yotpo-reviews *.leading-none.capsize::after, .text-7xl #yotpo-reviews * .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-tight.capsize::before,#yotpo-reviews * .text-7xl.leading-tight.capsize::before,#yotpo-reviews * .text-7xl .leading-tight.capsize::before, .text-7xl #yotpo-reviews *.leading-tight.capsize::before, .text-7xl #yotpo-reviews * .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-tight.capsize::after,#yotpo-reviews * .text-7xl.leading-tight.capsize::after,#yotpo-reviews * .text-7xl .leading-tight.capsize::after, .text-7xl #yotpo-reviews *.leading-tight.capsize::after, .text-7xl #yotpo-reviews * .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-snug.capsize::before,#yotpo-reviews * .text-7xl.leading-snug.capsize::before,#yotpo-reviews * .text-7xl .leading-snug.capsize::before, .text-7xl #yotpo-reviews *.leading-snug.capsize::before, .text-7xl #yotpo-reviews * .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-snug.capsize::after,#yotpo-reviews * .text-7xl.leading-snug.capsize::after,#yotpo-reviews * .text-7xl .leading-snug.capsize::after, .text-7xl #yotpo-reviews *.leading-snug.capsize::after, .text-7xl #yotpo-reviews * .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-normal.capsize::before,#yotpo-reviews * .text-7xl.leading-normal.capsize::before,#yotpo-reviews * .text-7xl .leading-normal.capsize::before, .text-7xl #yotpo-reviews *.leading-normal.capsize::before, .text-7xl #yotpo-reviews * .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-normal.capsize::after,#yotpo-reviews * .text-7xl.leading-normal.capsize::after,#yotpo-reviews * .text-7xl .leading-normal.capsize::after, .text-7xl #yotpo-reviews *.leading-normal.capsize::after, .text-7xl #yotpo-reviews * .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-relaxed.capsize::before,#yotpo-reviews * .text-7xl.leading-relaxed.capsize::before,#yotpo-reviews * .text-7xl .leading-relaxed.capsize::before, .text-7xl #yotpo-reviews *.leading-relaxed.capsize::before, .text-7xl #yotpo-reviews * .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-relaxed.capsize::after,#yotpo-reviews * .text-7xl.leading-relaxed.capsize::after,#yotpo-reviews * .text-7xl .leading-relaxed.capsize::after, .text-7xl #yotpo-reviews *.leading-relaxed.capsize::after, .text-7xl #yotpo-reviews * .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-loose.capsize::before,#yotpo-reviews * .text-7xl.leading-loose.capsize::before,#yotpo-reviews * .text-7xl .leading-loose.capsize::before, .text-7xl #yotpo-reviews *.leading-loose.capsize::before, .text-7xl #yotpo-reviews * .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
#yotpo-reviews *.text-7xl.leading-loose.capsize::after,#yotpo-reviews * .text-7xl.leading-loose.capsize::after,#yotpo-reviews * .text-7xl .leading-loose.capsize::after, .text-7xl #yotpo-reviews *.leading-loose.capsize::after, .text-7xl #yotpo-reviews * .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-3.capsize::before,#yotpo-reviews * .text-8xl.leading-3.capsize::before,#yotpo-reviews * .text-8xl .leading-3.capsize::before, .text-8xl #yotpo-reviews *.leading-3.capsize::before, .text-8xl #yotpo-reviews * .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: 0.2805em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-3.capsize::after,#yotpo-reviews * .text-8xl.leading-3.capsize::after,#yotpo-reviews * .text-8xl .leading-3.capsize::after, .text-8xl #yotpo-reviews *.leading-3.capsize::after, .text-8xl #yotpo-reviews * .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.3245em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-4.capsize::before,#yotpo-reviews * .text-8xl.leading-4.capsize::before,#yotpo-reviews * .text-8xl .leading-4.capsize::before, .text-8xl #yotpo-reviews *.leading-4.capsize::before, .text-8xl #yotpo-reviews * .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: 0.2597em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-4.capsize::after,#yotpo-reviews * .text-8xl.leading-4.capsize::after,#yotpo-reviews * .text-8xl .leading-4.capsize::after, .text-8xl #yotpo-reviews *.leading-4.capsize::after, .text-8xl #yotpo-reviews * .leading-4.capsize::after {
  content: '' !important;
  margin-top: 0.3037em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-5.capsize::before,#yotpo-reviews * .text-8xl.leading-5.capsize::before,#yotpo-reviews * .text-8xl .leading-5.capsize::before, .text-8xl #yotpo-reviews *.leading-5.capsize::before, .text-8xl #yotpo-reviews * .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: 0.2388em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-5.capsize::after,#yotpo-reviews * .text-8xl.leading-5.capsize::after,#yotpo-reviews * .text-8xl .leading-5.capsize::after, .text-8xl #yotpo-reviews *.leading-5.capsize::after, .text-8xl #yotpo-reviews * .leading-5.capsize::after {
  content: '' !important;
  margin-top: 0.2828em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-6.capsize::before,#yotpo-reviews * .text-8xl.leading-6.capsize::before,#yotpo-reviews * .text-8xl .leading-6.capsize::before, .text-8xl #yotpo-reviews *.leading-6.capsize::before, .text-8xl #yotpo-reviews * .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: 0.218em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-6.capsize::after,#yotpo-reviews * .text-8xl.leading-6.capsize::after,#yotpo-reviews * .text-8xl .leading-6.capsize::after, .text-8xl #yotpo-reviews *.leading-6.capsize::after, .text-8xl #yotpo-reviews * .leading-6.capsize::after {
  content: '' !important;
  margin-top: 0.262em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-7.capsize::before,#yotpo-reviews * .text-8xl.leading-7.capsize::before,#yotpo-reviews * .text-8xl .leading-7.capsize::before, .text-8xl #yotpo-reviews *.leading-7.capsize::before, .text-8xl #yotpo-reviews * .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.1972em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-7.capsize::after,#yotpo-reviews * .text-8xl.leading-7.capsize::after,#yotpo-reviews * .text-8xl .leading-7.capsize::after, .text-8xl #yotpo-reviews *.leading-7.capsize::after, .text-8xl #yotpo-reviews * .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.2412em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-8.capsize::before,#yotpo-reviews * .text-8xl.leading-8.capsize::before,#yotpo-reviews * .text-8xl .leading-8.capsize::before, .text-8xl #yotpo-reviews *.leading-8.capsize::before, .text-8xl #yotpo-reviews * .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: 0.1763em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-8.capsize::after,#yotpo-reviews * .text-8xl.leading-8.capsize::after,#yotpo-reviews * .text-8xl .leading-8.capsize::after, .text-8xl #yotpo-reviews *.leading-8.capsize::after, .text-8xl #yotpo-reviews * .leading-8.capsize::after {
  content: '' !important;
  margin-top: 0.2203em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-9.capsize::before,#yotpo-reviews * .text-8xl.leading-9.capsize::before,#yotpo-reviews * .text-8xl .leading-9.capsize::before, .text-8xl #yotpo-reviews *.leading-9.capsize::before, .text-8xl #yotpo-reviews * .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: 0.1555em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-9.capsize::after,#yotpo-reviews * .text-8xl.leading-9.capsize::after,#yotpo-reviews * .text-8xl .leading-9.capsize::after, .text-8xl #yotpo-reviews *.leading-9.capsize::after, .text-8xl #yotpo-reviews * .leading-9.capsize::after {
  content: '' !important;
  margin-top: 0.1995em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-10.capsize::before,#yotpo-reviews * .text-8xl.leading-10.capsize::before,#yotpo-reviews * .text-8xl .leading-10.capsize::before, .text-8xl #yotpo-reviews *.leading-10.capsize::before, .text-8xl #yotpo-reviews * .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: 0.1347em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-10.capsize::after,#yotpo-reviews * .text-8xl.leading-10.capsize::after,#yotpo-reviews * .text-8xl .leading-10.capsize::after, .text-8xl #yotpo-reviews *.leading-10.capsize::after, .text-8xl #yotpo-reviews * .leading-10.capsize::after {
  content: '' !important;
  margin-top: 0.1787em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-none.capsize::before,#yotpo-reviews * .text-8xl.leading-none.capsize::before,#yotpo-reviews * .text-8xl .leading-none.capsize::before, .text-8xl #yotpo-reviews *.leading-none.capsize::before, .text-8xl #yotpo-reviews * .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-none.capsize::after,#yotpo-reviews * .text-8xl.leading-none.capsize::after,#yotpo-reviews * .text-8xl .leading-none.capsize::after, .text-8xl #yotpo-reviews *.leading-none.capsize::after, .text-8xl #yotpo-reviews * .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-tight.capsize::before,#yotpo-reviews * .text-8xl.leading-tight.capsize::before,#yotpo-reviews * .text-8xl .leading-tight.capsize::before, .text-8xl #yotpo-reviews *.leading-tight.capsize::before, .text-8xl #yotpo-reviews * .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-tight.capsize::after,#yotpo-reviews * .text-8xl.leading-tight.capsize::after,#yotpo-reviews * .text-8xl .leading-tight.capsize::after, .text-8xl #yotpo-reviews *.leading-tight.capsize::after, .text-8xl #yotpo-reviews * .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-snug.capsize::before,#yotpo-reviews * .text-8xl.leading-snug.capsize::before,#yotpo-reviews * .text-8xl .leading-snug.capsize::before, .text-8xl #yotpo-reviews *.leading-snug.capsize::before, .text-8xl #yotpo-reviews * .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-snug.capsize::after,#yotpo-reviews * .text-8xl.leading-snug.capsize::after,#yotpo-reviews * .text-8xl .leading-snug.capsize::after, .text-8xl #yotpo-reviews *.leading-snug.capsize::after, .text-8xl #yotpo-reviews * .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-normal.capsize::before,#yotpo-reviews * .text-8xl.leading-normal.capsize::before,#yotpo-reviews * .text-8xl .leading-normal.capsize::before, .text-8xl #yotpo-reviews *.leading-normal.capsize::before, .text-8xl #yotpo-reviews * .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-normal.capsize::after,#yotpo-reviews * .text-8xl.leading-normal.capsize::after,#yotpo-reviews * .text-8xl .leading-normal.capsize::after, .text-8xl #yotpo-reviews *.leading-normal.capsize::after, .text-8xl #yotpo-reviews * .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-relaxed.capsize::before,#yotpo-reviews * .text-8xl.leading-relaxed.capsize::before,#yotpo-reviews * .text-8xl .leading-relaxed.capsize::before, .text-8xl #yotpo-reviews *.leading-relaxed.capsize::before, .text-8xl #yotpo-reviews * .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-relaxed.capsize::after,#yotpo-reviews * .text-8xl.leading-relaxed.capsize::after,#yotpo-reviews * .text-8xl .leading-relaxed.capsize::after, .text-8xl #yotpo-reviews *.leading-relaxed.capsize::after, .text-8xl #yotpo-reviews * .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-loose.capsize::before,#yotpo-reviews * .text-8xl.leading-loose.capsize::before,#yotpo-reviews * .text-8xl .leading-loose.capsize::before, .text-8xl #yotpo-reviews *.leading-loose.capsize::before, .text-8xl #yotpo-reviews * .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
#yotpo-reviews *.text-8xl.leading-loose.capsize::after,#yotpo-reviews * .text-8xl.leading-loose.capsize::after,#yotpo-reviews * .text-8xl .leading-loose.capsize::after, .text-8xl #yotpo-reviews *.leading-loose.capsize::after, .text-8xl #yotpo-reviews * .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-3.capsize::before,#yotpo-reviews * .text-9xl.leading-3.capsize::before,#yotpo-reviews * .text-9xl .leading-3.capsize::before, .text-9xl #yotpo-reviews *.leading-3.capsize::before, .text-9xl #yotpo-reviews * .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: 0.2961em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-3.capsize::after,#yotpo-reviews * .text-9xl.leading-3.capsize::after,#yotpo-reviews * .text-9xl .leading-3.capsize::after, .text-9xl #yotpo-reviews *.leading-3.capsize::after, .text-9xl #yotpo-reviews * .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.3401em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-4.capsize::before,#yotpo-reviews * .text-9xl.leading-4.capsize::before,#yotpo-reviews * .text-9xl .leading-4.capsize::before, .text-9xl #yotpo-reviews *.leading-4.capsize::before, .text-9xl #yotpo-reviews * .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: 0.2805em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-4.capsize::after,#yotpo-reviews * .text-9xl.leading-4.capsize::after,#yotpo-reviews * .text-9xl .leading-4.capsize::after, .text-9xl #yotpo-reviews *.leading-4.capsize::after, .text-9xl #yotpo-reviews * .leading-4.capsize::after {
  content: '' !important;
  margin-top: 0.3245em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-5.capsize::before,#yotpo-reviews * .text-9xl.leading-5.capsize::before,#yotpo-reviews * .text-9xl .leading-5.capsize::before, .text-9xl #yotpo-reviews *.leading-5.capsize::before, .text-9xl #yotpo-reviews * .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: 0.2649em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-5.capsize::after,#yotpo-reviews * .text-9xl.leading-5.capsize::after,#yotpo-reviews * .text-9xl .leading-5.capsize::after, .text-9xl #yotpo-reviews *.leading-5.capsize::after, .text-9xl #yotpo-reviews * .leading-5.capsize::after {
  content: '' !important;
  margin-top: 0.3089em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-6.capsize::before,#yotpo-reviews * .text-9xl.leading-6.capsize::before,#yotpo-reviews * .text-9xl .leading-6.capsize::before, .text-9xl #yotpo-reviews *.leading-6.capsize::before, .text-9xl #yotpo-reviews * .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: 0.2493em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-6.capsize::after,#yotpo-reviews * .text-9xl.leading-6.capsize::after,#yotpo-reviews * .text-9xl .leading-6.capsize::after, .text-9xl #yotpo-reviews *.leading-6.capsize::after, .text-9xl #yotpo-reviews * .leading-6.capsize::after {
  content: '' !important;
  margin-top: 0.2933em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-7.capsize::before,#yotpo-reviews * .text-9xl.leading-7.capsize::before,#yotpo-reviews * .text-9xl .leading-7.capsize::before, .text-9xl #yotpo-reviews *.leading-7.capsize::before, .text-9xl #yotpo-reviews * .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: 0.2336em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-7.capsize::after,#yotpo-reviews * .text-9xl.leading-7.capsize::after,#yotpo-reviews * .text-9xl .leading-7.capsize::after, .text-9xl #yotpo-reviews *.leading-7.capsize::after, .text-9xl #yotpo-reviews * .leading-7.capsize::after {
  content: '' !important;
  margin-top: 0.2776em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-8.capsize::before,#yotpo-reviews * .text-9xl.leading-8.capsize::before,#yotpo-reviews * .text-9xl .leading-8.capsize::before, .text-9xl #yotpo-reviews *.leading-8.capsize::before, .text-9xl #yotpo-reviews * .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: 0.218em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-8.capsize::after,#yotpo-reviews * .text-9xl.leading-8.capsize::after,#yotpo-reviews * .text-9xl .leading-8.capsize::after, .text-9xl #yotpo-reviews *.leading-8.capsize::after, .text-9xl #yotpo-reviews * .leading-8.capsize::after {
  content: '' !important;
  margin-top: 0.262em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-9.capsize::before,#yotpo-reviews * .text-9xl.leading-9.capsize::before,#yotpo-reviews * .text-9xl .leading-9.capsize::before, .text-9xl #yotpo-reviews *.leading-9.capsize::before, .text-9xl #yotpo-reviews * .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: 0.2024em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-9.capsize::after,#yotpo-reviews * .text-9xl.leading-9.capsize::after,#yotpo-reviews * .text-9xl .leading-9.capsize::after, .text-9xl #yotpo-reviews *.leading-9.capsize::after, .text-9xl #yotpo-reviews * .leading-9.capsize::after {
  content: '' !important;
  margin-top: 0.2464em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-10.capsize::before,#yotpo-reviews * .text-9xl.leading-10.capsize::before,#yotpo-reviews * .text-9xl .leading-10.capsize::before, .text-9xl #yotpo-reviews *.leading-10.capsize::before, .text-9xl #yotpo-reviews * .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: 0.1868em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-10.capsize::after,#yotpo-reviews * .text-9xl.leading-10.capsize::after,#yotpo-reviews * .text-9xl .leading-10.capsize::after, .text-9xl #yotpo-reviews *.leading-10.capsize::after, .text-9xl #yotpo-reviews * .leading-10.capsize::after {
  content: '' !important;
  margin-top: 0.2308em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-none.capsize::before,#yotpo-reviews * .text-9xl.leading-none.capsize::before,#yotpo-reviews * .text-9xl .leading-none.capsize::before, .text-9xl #yotpo-reviews *.leading-none.capsize::before, .text-9xl #yotpo-reviews * .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-none.capsize::after,#yotpo-reviews * .text-9xl.leading-none.capsize::after,#yotpo-reviews * .text-9xl .leading-none.capsize::after, .text-9xl #yotpo-reviews *.leading-none.capsize::after, .text-9xl #yotpo-reviews * .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-tight.capsize::before,#yotpo-reviews * .text-9xl.leading-tight.capsize::before,#yotpo-reviews * .text-9xl .leading-tight.capsize::before, .text-9xl #yotpo-reviews *.leading-tight.capsize::before, .text-9xl #yotpo-reviews * .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-tight.capsize::after,#yotpo-reviews * .text-9xl.leading-tight.capsize::after,#yotpo-reviews * .text-9xl .leading-tight.capsize::after, .text-9xl #yotpo-reviews *.leading-tight.capsize::after, .text-9xl #yotpo-reviews * .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-snug.capsize::before,#yotpo-reviews * .text-9xl.leading-snug.capsize::before,#yotpo-reviews * .text-9xl .leading-snug.capsize::before, .text-9xl #yotpo-reviews *.leading-snug.capsize::before, .text-9xl #yotpo-reviews * .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-snug.capsize::after,#yotpo-reviews * .text-9xl.leading-snug.capsize::after,#yotpo-reviews * .text-9xl .leading-snug.capsize::after, .text-9xl #yotpo-reviews *.leading-snug.capsize::after, .text-9xl #yotpo-reviews * .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-normal.capsize::before,#yotpo-reviews * .text-9xl.leading-normal.capsize::before,#yotpo-reviews * .text-9xl .leading-normal.capsize::before, .text-9xl #yotpo-reviews *.leading-normal.capsize::before, .text-9xl #yotpo-reviews * .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-normal.capsize::after,#yotpo-reviews * .text-9xl.leading-normal.capsize::after,#yotpo-reviews * .text-9xl .leading-normal.capsize::after, .text-9xl #yotpo-reviews *.leading-normal.capsize::after, .text-9xl #yotpo-reviews * .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-relaxed.capsize::before,#yotpo-reviews * .text-9xl.leading-relaxed.capsize::before,#yotpo-reviews * .text-9xl .leading-relaxed.capsize::before, .text-9xl #yotpo-reviews *.leading-relaxed.capsize::before, .text-9xl #yotpo-reviews * .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-relaxed.capsize::after,#yotpo-reviews * .text-9xl.leading-relaxed.capsize::after,#yotpo-reviews * .text-9xl .leading-relaxed.capsize::after, .text-9xl #yotpo-reviews *.leading-relaxed.capsize::after, .text-9xl #yotpo-reviews * .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-loose.capsize::before,#yotpo-reviews * .text-9xl.leading-loose.capsize::before,#yotpo-reviews * .text-9xl .leading-loose.capsize::before, .text-9xl #yotpo-reviews *.leading-loose.capsize::before, .text-9xl #yotpo-reviews * .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
#yotpo-reviews *.text-9xl.leading-loose.capsize::after,#yotpo-reviews * .text-9xl.leading-loose.capsize::after,#yotpo-reviews * .text-9xl .leading-loose.capsize::after, .text-9xl #yotpo-reviews *.leading-loose.capsize::after, .text-9xl #yotpo-reviews * .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-3.capsize::before,#yotpo-reviews * .text-1xl.leading-3.capsize::before,#yotpo-reviews * .text-1xl .leading-3.capsize::before, .text-1xl #yotpo-reviews *.leading-3.capsize::before, .text-1xl #yotpo-reviews * .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: 0.0703em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-3.capsize::after,#yotpo-reviews * .text-1xl.leading-3.capsize::after,#yotpo-reviews * .text-1xl .leading-3.capsize::after, .text-1xl #yotpo-reviews *.leading-3.capsize::after, .text-1xl #yotpo-reviews * .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.1143em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-4.capsize::before,#yotpo-reviews * .text-1xl.leading-4.capsize::before,#yotpo-reviews * .text-1xl .leading-4.capsize::before, .text-1xl #yotpo-reviews *.leading-4.capsize::before, .text-1xl #yotpo-reviews * .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.0206em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-4.capsize::after,#yotpo-reviews * .text-1xl.leading-4.capsize::after,#yotpo-reviews * .text-1xl .leading-4.capsize::after, .text-1xl #yotpo-reviews *.leading-4.capsize::after, .text-1xl #yotpo-reviews * .leading-4.capsize::after {
  content: '' !important;
  margin-top: 0.0234em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-5.capsize::before,#yotpo-reviews * .text-1xl.leading-5.capsize::before,#yotpo-reviews * .text-1xl .leading-5.capsize::before, .text-1xl #yotpo-reviews *.leading-5.capsize::before, .text-1xl #yotpo-reviews * .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.1115em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-5.capsize::after,#yotpo-reviews * .text-1xl.leading-5.capsize::after,#yotpo-reviews * .text-1xl .leading-5.capsize::after, .text-1xl #yotpo-reviews *.leading-5.capsize::after, .text-1xl #yotpo-reviews * .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.0675em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-6.capsize::before,#yotpo-reviews * .text-1xl.leading-6.capsize::before,#yotpo-reviews * .text-1xl .leading-6.capsize::before, .text-1xl #yotpo-reviews *.leading-6.capsize::before, .text-1xl #yotpo-reviews * .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.2025em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-6.capsize::after,#yotpo-reviews * .text-1xl.leading-6.capsize::after,#yotpo-reviews * .text-1xl .leading-6.capsize::after, .text-1xl #yotpo-reviews *.leading-6.capsize::after, .text-1xl #yotpo-reviews * .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.1585em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-7.capsize::before,#yotpo-reviews * .text-1xl.leading-7.capsize::before,#yotpo-reviews * .text-1xl .leading-7.capsize::before, .text-1xl #yotpo-reviews *.leading-7.capsize::before, .text-1xl #yotpo-reviews * .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.2934em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-7.capsize::after,#yotpo-reviews * .text-1xl.leading-7.capsize::after,#yotpo-reviews * .text-1xl .leading-7.capsize::after, .text-1xl #yotpo-reviews *.leading-7.capsize::after, .text-1xl #yotpo-reviews * .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.2494em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-8.capsize::before,#yotpo-reviews * .text-1xl.leading-8.capsize::before,#yotpo-reviews * .text-1xl .leading-8.capsize::before, .text-1xl #yotpo-reviews *.leading-8.capsize::before, .text-1xl #yotpo-reviews * .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.3843em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-8.capsize::after,#yotpo-reviews * .text-1xl.leading-8.capsize::after,#yotpo-reviews * .text-1xl .leading-8.capsize::after, .text-1xl #yotpo-reviews *.leading-8.capsize::after, .text-1xl #yotpo-reviews * .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.3403em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-9.capsize::before,#yotpo-reviews * .text-1xl.leading-9.capsize::before,#yotpo-reviews * .text-1xl .leading-9.capsize::before, .text-1xl #yotpo-reviews *.leading-9.capsize::before, .text-1xl #yotpo-reviews * .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.4752em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-9.capsize::after,#yotpo-reviews * .text-1xl.leading-9.capsize::after,#yotpo-reviews * .text-1xl .leading-9.capsize::after, .text-1xl #yotpo-reviews *.leading-9.capsize::after, .text-1xl #yotpo-reviews * .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.4312em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-10.capsize::before,#yotpo-reviews * .text-1xl.leading-10.capsize::before,#yotpo-reviews * .text-1xl .leading-10.capsize::before, .text-1xl #yotpo-reviews *.leading-10.capsize::before, .text-1xl #yotpo-reviews * .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -0.5661em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-10.capsize::after,#yotpo-reviews * .text-1xl.leading-10.capsize::after,#yotpo-reviews * .text-1xl .leading-10.capsize::after, .text-1xl #yotpo-reviews *.leading-10.capsize::after, .text-1xl #yotpo-reviews * .leading-10.capsize::after {
  content: '' !important;
  margin-top: -0.5221em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-none.capsize::before,#yotpo-reviews * .text-1xl.leading-none.capsize::before,#yotpo-reviews * .text-1xl .leading-none.capsize::before, .text-1xl #yotpo-reviews *.leading-none.capsize::before, .text-1xl #yotpo-reviews * .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-none.capsize::after,#yotpo-reviews * .text-1xl.leading-none.capsize::after,#yotpo-reviews * .text-1xl .leading-none.capsize::after, .text-1xl #yotpo-reviews *.leading-none.capsize::after, .text-1xl #yotpo-reviews * .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-tight.capsize::before,#yotpo-reviews * .text-1xl.leading-tight.capsize::before,#yotpo-reviews * .text-1xl .leading-tight.capsize::before, .text-1xl #yotpo-reviews *.leading-tight.capsize::before, .text-1xl #yotpo-reviews * .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-tight.capsize::after,#yotpo-reviews * .text-1xl.leading-tight.capsize::after,#yotpo-reviews * .text-1xl .leading-tight.capsize::after, .text-1xl #yotpo-reviews *.leading-tight.capsize::after, .text-1xl #yotpo-reviews * .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-snug.capsize::before,#yotpo-reviews * .text-1xl.leading-snug.capsize::before,#yotpo-reviews * .text-1xl .leading-snug.capsize::before, .text-1xl #yotpo-reviews *.leading-snug.capsize::before, .text-1xl #yotpo-reviews * .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-snug.capsize::after,#yotpo-reviews * .text-1xl.leading-snug.capsize::after,#yotpo-reviews * .text-1xl .leading-snug.capsize::after, .text-1xl #yotpo-reviews *.leading-snug.capsize::after, .text-1xl #yotpo-reviews * .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-normal.capsize::before,#yotpo-reviews * .text-1xl.leading-normal.capsize::before,#yotpo-reviews * .text-1xl .leading-normal.capsize::before, .text-1xl #yotpo-reviews *.leading-normal.capsize::before, .text-1xl #yotpo-reviews * .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-normal.capsize::after,#yotpo-reviews * .text-1xl.leading-normal.capsize::after,#yotpo-reviews * .text-1xl .leading-normal.capsize::after, .text-1xl #yotpo-reviews *.leading-normal.capsize::after, .text-1xl #yotpo-reviews * .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-relaxed.capsize::before,#yotpo-reviews * .text-1xl.leading-relaxed.capsize::before,#yotpo-reviews * .text-1xl .leading-relaxed.capsize::before, .text-1xl #yotpo-reviews *.leading-relaxed.capsize::before, .text-1xl #yotpo-reviews * .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-relaxed.capsize::after,#yotpo-reviews * .text-1xl.leading-relaxed.capsize::after,#yotpo-reviews * .text-1xl .leading-relaxed.capsize::after, .text-1xl #yotpo-reviews *.leading-relaxed.capsize::after, .text-1xl #yotpo-reviews * .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-loose.capsize::before,#yotpo-reviews * .text-1xl.leading-loose.capsize::before,#yotpo-reviews * .text-1xl .leading-loose.capsize::before, .text-1xl #yotpo-reviews *.leading-loose.capsize::before, .text-1xl #yotpo-reviews * .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
#yotpo-reviews *.text-1xl.leading-loose.capsize::after,#yotpo-reviews * .text-1xl.leading-loose.capsize::after,#yotpo-reviews * .text-1xl .leading-loose.capsize::after, .text-1xl #yotpo-reviews *.leading-loose.capsize::after, .text-1xl #yotpo-reviews * .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-3.capsize::before,#yotpo-reviews * .text-3.\\33xl.leading-3.capsize::before,#yotpo-reviews * .text-3.\\33xl .leading-3.capsize::before, .text-3.\\33xl #yotpo-reviews *.leading-3.capsize::before, .text-3.\\33xl #yotpo-reviews * .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: 0.1555em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-3.capsize::after,#yotpo-reviews * .text-3.\\33xl.leading-3.capsize::after,#yotpo-reviews * .text-3.\\33xl .leading-3.capsize::after, .text-3.\\33xl #yotpo-reviews *.leading-3.capsize::after, .text-3.\\33xl #yotpo-reviews * .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.1995em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-4.capsize::before,#yotpo-reviews * .text-3.\\33xl.leading-4.capsize::before,#yotpo-reviews * .text-3.\\33xl .leading-4.capsize::before, .text-3.\\33xl #yotpo-reviews *.leading-4.capsize::before, .text-3.\\33xl #yotpo-reviews * .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: 0.093em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-4.capsize::after,#yotpo-reviews * .text-3.\\33xl.leading-4.capsize::after,#yotpo-reviews * .text-3.\\33xl .leading-4.capsize::after, .text-3.\\33xl #yotpo-reviews *.leading-4.capsize::after, .text-3.\\33xl #yotpo-reviews * .leading-4.capsize::after {
  content: '' !important;
  margin-top: 0.137em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-5.capsize::before,#yotpo-reviews * .text-3.\\33xl.leading-5.capsize::before,#yotpo-reviews * .text-3.\\33xl .leading-5.capsize::before, .text-3.\\33xl #yotpo-reviews *.leading-5.capsize::before, .text-3.\\33xl #yotpo-reviews * .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: 0.0305em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-5.capsize::after,#yotpo-reviews * .text-3.\\33xl.leading-5.capsize::after,#yotpo-reviews * .text-3.\\33xl .leading-5.capsize::after, .text-3.\\33xl #yotpo-reviews *.leading-5.capsize::after, .text-3.\\33xl #yotpo-reviews * .leading-5.capsize::after {
  content: '' !important;
  margin-top: 0.0745em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-6.capsize::before,#yotpo-reviews * .text-3.\\33xl.leading-6.capsize::before,#yotpo-reviews * .text-3.\\33xl .leading-6.capsize::before, .text-3.\\33xl #yotpo-reviews *.leading-6.capsize::before, .text-3.\\33xl #yotpo-reviews * .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.032em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-6.capsize::after,#yotpo-reviews * .text-3.\\33xl.leading-6.capsize::after,#yotpo-reviews * .text-3.\\33xl .leading-6.capsize::after, .text-3.\\33xl #yotpo-reviews *.leading-6.capsize::after, .text-3.\\33xl #yotpo-reviews * .leading-6.capsize::after {
  content: '' !important;
  margin-top: 0.012em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-7.capsize::before,#yotpo-reviews * .text-3.\\33xl.leading-7.capsize::before,#yotpo-reviews * .text-3.\\33xl .leading-7.capsize::before, .text-3.\\33xl #yotpo-reviews *.leading-7.capsize::before, .text-3.\\33xl #yotpo-reviews * .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.0945em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-7.capsize::after,#yotpo-reviews * .text-3.\\33xl.leading-7.capsize::after,#yotpo-reviews * .text-3.\\33xl .leading-7.capsize::after, .text-3.\\33xl #yotpo-reviews *.leading-7.capsize::after, .text-3.\\33xl #yotpo-reviews * .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.0505em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-8.capsize::before,#yotpo-reviews * .text-3.\\33xl.leading-8.capsize::before,#yotpo-reviews * .text-3.\\33xl .leading-8.capsize::before, .text-3.\\33xl #yotpo-reviews *.leading-8.capsize::before, .text-3.\\33xl #yotpo-reviews * .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-8.capsize::after,#yotpo-reviews * .text-3.\\33xl.leading-8.capsize::after,#yotpo-reviews * .text-3.\\33xl .leading-8.capsize::after, .text-3.\\33xl #yotpo-reviews *.leading-8.capsize::after, .text-3.\\33xl #yotpo-reviews * .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-9.capsize::before,#yotpo-reviews * .text-3.\\33xl.leading-9.capsize::before,#yotpo-reviews * .text-3.\\33xl .leading-9.capsize::before, .text-3.\\33xl #yotpo-reviews *.leading-9.capsize::before, .text-3.\\33xl #yotpo-reviews * .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.2195em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-9.capsize::after,#yotpo-reviews * .text-3.\\33xl.leading-9.capsize::after,#yotpo-reviews * .text-3.\\33xl .leading-9.capsize::after, .text-3.\\33xl #yotpo-reviews *.leading-9.capsize::after, .text-3.\\33xl #yotpo-reviews * .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.1755em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-10.capsize::before,#yotpo-reviews * .text-3.\\33xl.leading-10.capsize::before,#yotpo-reviews * .text-3.\\33xl .leading-10.capsize::before, .text-3.\\33xl #yotpo-reviews *.leading-10.capsize::before, .text-3.\\33xl #yotpo-reviews * .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-10.capsize::after,#yotpo-reviews * .text-3.\\33xl.leading-10.capsize::after,#yotpo-reviews * .text-3.\\33xl .leading-10.capsize::after, .text-3.\\33xl #yotpo-reviews *.leading-10.capsize::after, .text-3.\\33xl #yotpo-reviews * .leading-10.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-none.capsize::before,#yotpo-reviews * .text-3.\\33xl.leading-none.capsize::before,#yotpo-reviews * .text-3.\\33xl .leading-none.capsize::before, .text-3.\\33xl #yotpo-reviews *.leading-none.capsize::before, .text-3.\\33xl #yotpo-reviews * .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-none.capsize::after,#yotpo-reviews * .text-3.\\33xl.leading-none.capsize::after,#yotpo-reviews * .text-3.\\33xl .leading-none.capsize::after, .text-3.\\33xl #yotpo-reviews *.leading-none.capsize::after, .text-3.\\33xl #yotpo-reviews * .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-tight.capsize::before,#yotpo-reviews * .text-3.\\33xl.leading-tight.capsize::before,#yotpo-reviews * .text-3.\\33xl .leading-tight.capsize::before, .text-3.\\33xl #yotpo-reviews *.leading-tight.capsize::before, .text-3.\\33xl #yotpo-reviews * .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-tight.capsize::after,#yotpo-reviews * .text-3.\\33xl.leading-tight.capsize::after,#yotpo-reviews * .text-3.\\33xl .leading-tight.capsize::after, .text-3.\\33xl #yotpo-reviews *.leading-tight.capsize::after, .text-3.\\33xl #yotpo-reviews * .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-snug.capsize::before,#yotpo-reviews * .text-3.\\33xl.leading-snug.capsize::before,#yotpo-reviews * .text-3.\\33xl .leading-snug.capsize::before, .text-3.\\33xl #yotpo-reviews *.leading-snug.capsize::before, .text-3.\\33xl #yotpo-reviews * .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-snug.capsize::after,#yotpo-reviews * .text-3.\\33xl.leading-snug.capsize::after,#yotpo-reviews * .text-3.\\33xl .leading-snug.capsize::after, .text-3.\\33xl #yotpo-reviews *.leading-snug.capsize::after, .text-3.\\33xl #yotpo-reviews * .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-normal.capsize::before,#yotpo-reviews * .text-3.\\33xl.leading-normal.capsize::before,#yotpo-reviews * .text-3.\\33xl .leading-normal.capsize::before, .text-3.\\33xl #yotpo-reviews *.leading-normal.capsize::before, .text-3.\\33xl #yotpo-reviews * .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-normal.capsize::after,#yotpo-reviews * .text-3.\\33xl.leading-normal.capsize::after,#yotpo-reviews * .text-3.\\33xl .leading-normal.capsize::after, .text-3.\\33xl #yotpo-reviews *.leading-normal.capsize::after, .text-3.\\33xl #yotpo-reviews * .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-relaxed.capsize::before,#yotpo-reviews * .text-3.\\33xl.leading-relaxed.capsize::before,#yotpo-reviews * .text-3.\\33xl .leading-relaxed.capsize::before, .text-3.\\33xl #yotpo-reviews *.leading-relaxed.capsize::before, .text-3.\\33xl #yotpo-reviews * .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-relaxed.capsize::after,#yotpo-reviews * .text-3.\\33xl.leading-relaxed.capsize::after,#yotpo-reviews * .text-3.\\33xl .leading-relaxed.capsize::after, .text-3.\\33xl #yotpo-reviews *.leading-relaxed.capsize::after, .text-3.\\33xl #yotpo-reviews * .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-loose.capsize::before,#yotpo-reviews * .text-3.\\33xl.leading-loose.capsize::before,#yotpo-reviews * .text-3.\\33xl .leading-loose.capsize::before, .text-3.\\33xl #yotpo-reviews *.leading-loose.capsize::before, .text-3.\\33xl #yotpo-reviews * .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
#yotpo-reviews *.text-3.\\33xl.leading-loose.capsize::after,#yotpo-reviews * .text-3.\\33xl.leading-loose.capsize::after,#yotpo-reviews * .text-3.\\33xl .leading-loose.capsize::after, .text-3.\\33xl #yotpo-reviews *.leading-loose.capsize::after, .text-3.\\33xl #yotpo-reviews * .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.pdp-storytelling #yotpo-reviews .yotpo-base-layout {
  width: 100% !important;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
@media (min-width: 768px) {

  .pdp-storytelling #yotpo-reviews .yotpo-base-layout {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
}
.Pdp:not(.pdp-storytelling) #yotpo-reviews .yotpo-base-layout {
  width: 100% !important;
  padding: 1.5rem;
}
@media (min-width: 1280px) {

  .Pdp:not(.pdp-storytelling) #yotpo-reviews .yotpo-base-layout {
    max-width: 1380px !important;
  }
}
#yotpo-reviews .yotpo-head {
  display: none;
}
#yotpo-reviews .yotpo-headline {
  display: none;
  font-size: 1.875rem;
  line-height: 2.25rem;
  font-weight: 700;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-3.capsize::before, .font-sans #yotpo-reviews .yotpo-headline.leading-3.capsize::before, .font-sans #yotpo-reviews .yotpo-headline .leading-3.capsize::before,#yotpo-reviews .yotpo-headline .font-sans.leading-3.capsize::before,#yotpo-reviews .yotpo-headline .font-sans .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.143em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-3.capsize::after, .font-sans #yotpo-reviews .yotpo-headline.leading-3.capsize::after, .font-sans #yotpo-reviews .yotpo-headline .leading-3.capsize::after,#yotpo-reviews .yotpo-headline .font-sans.leading-3.capsize::after,#yotpo-reviews .yotpo-headline .font-sans .leading-3.capsize::after {
  content: '';
  margin-top: 0.187em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-4.capsize::before, .font-sans #yotpo-reviews .yotpo-headline.leading-4.capsize::before, .font-sans #yotpo-reviews .yotpo-headline .leading-4.capsize::before,#yotpo-reviews .yotpo-headline .font-sans.leading-4.capsize::before,#yotpo-reviews .yotpo-headline .font-sans .leading-4.capsize::before {
  content: '';
  margin-bottom: 0.0763em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-4.capsize::after, .font-sans #yotpo-reviews .yotpo-headline.leading-4.capsize::after, .font-sans #yotpo-reviews .yotpo-headline .leading-4.capsize::after,#yotpo-reviews .yotpo-headline .font-sans.leading-4.capsize::after,#yotpo-reviews .yotpo-headline .font-sans .leading-4.capsize::after {
  content: '';
  margin-top: 0.1203em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-5.capsize::before, .font-sans #yotpo-reviews .yotpo-headline.leading-5.capsize::before, .font-sans #yotpo-reviews .yotpo-headline .leading-5.capsize::before,#yotpo-reviews .yotpo-headline .font-sans.leading-5.capsize::before,#yotpo-reviews .yotpo-headline .font-sans .leading-5.capsize::before {
  content: '';
  margin-bottom: 0.0097em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-5.capsize::after, .font-sans #yotpo-reviews .yotpo-headline.leading-5.capsize::after, .font-sans #yotpo-reviews .yotpo-headline .leading-5.capsize::after,#yotpo-reviews .yotpo-headline .font-sans.leading-5.capsize::after,#yotpo-reviews .yotpo-headline .font-sans .leading-5.capsize::after {
  content: '';
  margin-top: 0.0537em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-6.capsize::before, .font-sans #yotpo-reviews .yotpo-headline.leading-6.capsize::before, .font-sans #yotpo-reviews .yotpo-headline .leading-6.capsize::before,#yotpo-reviews .yotpo-headline .font-sans.leading-6.capsize::before,#yotpo-reviews .yotpo-headline .font-sans .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.057em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-6.capsize::after, .font-sans #yotpo-reviews .yotpo-headline.leading-6.capsize::after, .font-sans #yotpo-reviews .yotpo-headline .leading-6.capsize::after,#yotpo-reviews .yotpo-headline .font-sans.leading-6.capsize::after,#yotpo-reviews .yotpo-headline .font-sans .leading-6.capsize::after {
  content: '';
  margin-top: -0.013em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-7.capsize::before, .font-sans #yotpo-reviews .yotpo-headline.leading-7.capsize::before, .font-sans #yotpo-reviews .yotpo-headline .leading-7.capsize::before,#yotpo-reviews .yotpo-headline .font-sans.leading-7.capsize::before,#yotpo-reviews .yotpo-headline .font-sans .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.1237em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-7.capsize::after, .font-sans #yotpo-reviews .yotpo-headline.leading-7.capsize::after, .font-sans #yotpo-reviews .yotpo-headline .leading-7.capsize::after,#yotpo-reviews .yotpo-headline .font-sans.leading-7.capsize::after,#yotpo-reviews .yotpo-headline .font-sans .leading-7.capsize::after {
  content: '';
  margin-top: -0.0797em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-8.capsize::before, .font-sans #yotpo-reviews .yotpo-headline.leading-8.capsize::before, .font-sans #yotpo-reviews .yotpo-headline .leading-8.capsize::before,#yotpo-reviews .yotpo-headline .font-sans.leading-8.capsize::before,#yotpo-reviews .yotpo-headline .font-sans .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.1903em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-8.capsize::after, .font-sans #yotpo-reviews .yotpo-headline.leading-8.capsize::after, .font-sans #yotpo-reviews .yotpo-headline .leading-8.capsize::after,#yotpo-reviews .yotpo-headline .font-sans.leading-8.capsize::after,#yotpo-reviews .yotpo-headline .font-sans .leading-8.capsize::after {
  content: '';
  margin-top: -0.1463em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-9.capsize::before, .font-sans #yotpo-reviews .yotpo-headline.leading-9.capsize::before, .font-sans #yotpo-reviews .yotpo-headline .leading-9.capsize::before,#yotpo-reviews .yotpo-headline .font-sans.leading-9.capsize::before,#yotpo-reviews .yotpo-headline .font-sans .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.257em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-9.capsize::after, .font-sans #yotpo-reviews .yotpo-headline.leading-9.capsize::after, .font-sans #yotpo-reviews .yotpo-headline .leading-9.capsize::after,#yotpo-reviews .yotpo-headline .font-sans.leading-9.capsize::after,#yotpo-reviews .yotpo-headline .font-sans .leading-9.capsize::after {
  content: '';
  margin-top: -0.213em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-10.capsize::before, .font-sans #yotpo-reviews .yotpo-headline.leading-10.capsize::before, .font-sans #yotpo-reviews .yotpo-headline .leading-10.capsize::before,#yotpo-reviews .yotpo-headline .font-sans.leading-10.capsize::before,#yotpo-reviews .yotpo-headline .font-sans .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.3237em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-10.capsize::after, .font-sans #yotpo-reviews .yotpo-headline.leading-10.capsize::after, .font-sans #yotpo-reviews .yotpo-headline .leading-10.capsize::after,#yotpo-reviews .yotpo-headline .font-sans.leading-10.capsize::after,#yotpo-reviews .yotpo-headline .font-sans .leading-10.capsize::after {
  content: '';
  margin-top: -0.2797em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-none.capsize::before, .font-sans #yotpo-reviews .yotpo-headline.leading-none.capsize::before, .font-sans #yotpo-reviews .yotpo-headline .leading-none.capsize::before,#yotpo-reviews .yotpo-headline .font-sans.leading-none.capsize::before,#yotpo-reviews .yotpo-headline .font-sans .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-none.capsize::after, .font-sans #yotpo-reviews .yotpo-headline.leading-none.capsize::after, .font-sans #yotpo-reviews .yotpo-headline .leading-none.capsize::after,#yotpo-reviews .yotpo-headline .font-sans.leading-none.capsize::after,#yotpo-reviews .yotpo-headline .font-sans .leading-none.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-tight.capsize::before, .font-sans #yotpo-reviews .yotpo-headline.leading-tight.capsize::before, .font-sans #yotpo-reviews .yotpo-headline .leading-tight.capsize::before,#yotpo-reviews .yotpo-headline .font-sans.leading-tight.capsize::before,#yotpo-reviews .yotpo-headline .font-sans .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.282em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-tight.capsize::after, .font-sans #yotpo-reviews .yotpo-headline.leading-tight.capsize::after, .font-sans #yotpo-reviews .yotpo-headline .leading-tight.capsize::after,#yotpo-reviews .yotpo-headline .font-sans.leading-tight.capsize::after,#yotpo-reviews .yotpo-headline .font-sans .leading-tight.capsize::after {
  content: '';
  margin-top: -0.238em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-snug.capsize::before, .font-sans #yotpo-reviews .yotpo-headline.leading-snug.capsize::before, .font-sans #yotpo-reviews .yotpo-headline .leading-snug.capsize::before,#yotpo-reviews .yotpo-headline .font-sans.leading-snug.capsize::before,#yotpo-reviews .yotpo-headline .font-sans .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3445em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-snug.capsize::after, .font-sans #yotpo-reviews .yotpo-headline.leading-snug.capsize::after, .font-sans #yotpo-reviews .yotpo-headline .leading-snug.capsize::after,#yotpo-reviews .yotpo-headline .font-sans.leading-snug.capsize::after,#yotpo-reviews .yotpo-headline .font-sans .leading-snug.capsize::after {
  content: '';
  margin-top: -0.3005em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-normal.capsize::before, .font-sans #yotpo-reviews .yotpo-headline.leading-normal.capsize::before, .font-sans #yotpo-reviews .yotpo-headline .leading-normal.capsize::before,#yotpo-reviews .yotpo-headline .font-sans.leading-normal.capsize::before,#yotpo-reviews .yotpo-headline .font-sans .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.407em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-normal.capsize::after, .font-sans #yotpo-reviews .yotpo-headline.leading-normal.capsize::after, .font-sans #yotpo-reviews .yotpo-headline .leading-normal.capsize::after,#yotpo-reviews .yotpo-headline .font-sans.leading-normal.capsize::after,#yotpo-reviews .yotpo-headline .font-sans .leading-normal.capsize::after {
  content: '';
  margin-top: -0.363em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-relaxed.capsize::before, .font-sans #yotpo-reviews .yotpo-headline.leading-relaxed.capsize::before, .font-sans #yotpo-reviews .yotpo-headline .leading-relaxed.capsize::before,#yotpo-reviews .yotpo-headline .font-sans.leading-relaxed.capsize::before,#yotpo-reviews .yotpo-headline .font-sans .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4695em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-relaxed.capsize::after, .font-sans #yotpo-reviews .yotpo-headline.leading-relaxed.capsize::after, .font-sans #yotpo-reviews .yotpo-headline .leading-relaxed.capsize::after,#yotpo-reviews .yotpo-headline .font-sans.leading-relaxed.capsize::after,#yotpo-reviews .yotpo-headline .font-sans .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4255em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-loose.capsize::before, .font-sans #yotpo-reviews .yotpo-headline.leading-loose.capsize::before, .font-sans #yotpo-reviews .yotpo-headline .leading-loose.capsize::before,#yotpo-reviews .yotpo-headline .font-sans.leading-loose.capsize::before,#yotpo-reviews .yotpo-headline .font-sans .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-headline.leading-loose.capsize::after, .font-sans #yotpo-reviews .yotpo-headline.leading-loose.capsize::after, .font-sans #yotpo-reviews .yotpo-headline .leading-loose.capsize::after,#yotpo-reviews .yotpo-headline .font-sans.leading-loose.capsize::after,#yotpo-reviews .yotpo-headline .font-sans .leading-loose.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-3.capsize::before, .font-serif #yotpo-reviews .yotpo-headline.leading-3.capsize::before, .font-serif #yotpo-reviews .yotpo-headline .leading-3.capsize::before,#yotpo-reviews .yotpo-headline .font-serif.leading-3.capsize::before,#yotpo-reviews .yotpo-headline .font-serif .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.18em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-3.capsize::after, .font-serif #yotpo-reviews .yotpo-headline.leading-3.capsize::after, .font-serif #yotpo-reviews .yotpo-headline .leading-3.capsize::after,#yotpo-reviews .yotpo-headline .font-serif.leading-3.capsize::after,#yotpo-reviews .yotpo-headline .font-serif .leading-3.capsize::after {
  content: '';
  margin-top: 0.2em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-4.capsize::before, .font-serif #yotpo-reviews .yotpo-headline.leading-4.capsize::before, .font-serif #yotpo-reviews .yotpo-headline .leading-4.capsize::before,#yotpo-reviews .yotpo-headline .font-serif.leading-4.capsize::before,#yotpo-reviews .yotpo-headline .font-serif .leading-4.capsize::before {
  content: '';
  margin-bottom: 0.1133em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-4.capsize::after, .font-serif #yotpo-reviews .yotpo-headline.leading-4.capsize::after, .font-serif #yotpo-reviews .yotpo-headline .leading-4.capsize::after,#yotpo-reviews .yotpo-headline .font-serif.leading-4.capsize::after,#yotpo-reviews .yotpo-headline .font-serif .leading-4.capsize::after {
  content: '';
  margin-top: 0.1333em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-5.capsize::before, .font-serif #yotpo-reviews .yotpo-headline.leading-5.capsize::before, .font-serif #yotpo-reviews .yotpo-headline .leading-5.capsize::before,#yotpo-reviews .yotpo-headline .font-serif.leading-5.capsize::before,#yotpo-reviews .yotpo-headline .font-serif .leading-5.capsize::before {
  content: '';
  margin-bottom: 0.0467em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-5.capsize::after, .font-serif #yotpo-reviews .yotpo-headline.leading-5.capsize::after, .font-serif #yotpo-reviews .yotpo-headline .leading-5.capsize::after,#yotpo-reviews .yotpo-headline .font-serif.leading-5.capsize::after,#yotpo-reviews .yotpo-headline .font-serif .leading-5.capsize::after {
  content: '';
  margin-top: 0.0667em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-6.capsize::before, .font-serif #yotpo-reviews .yotpo-headline.leading-6.capsize::before, .font-serif #yotpo-reviews .yotpo-headline .leading-6.capsize::before,#yotpo-reviews .yotpo-headline .font-serif.leading-6.capsize::before,#yotpo-reviews .yotpo-headline .font-serif .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.02em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-6.capsize::after, .font-serif #yotpo-reviews .yotpo-headline.leading-6.capsize::after, .font-serif #yotpo-reviews .yotpo-headline .leading-6.capsize::after,#yotpo-reviews .yotpo-headline .font-serif.leading-6.capsize::after,#yotpo-reviews .yotpo-headline .font-serif .leading-6.capsize::after {
  content: '';
  margin-top: 0em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-7.capsize::before, .font-serif #yotpo-reviews .yotpo-headline.leading-7.capsize::before, .font-serif #yotpo-reviews .yotpo-headline .leading-7.capsize::before,#yotpo-reviews .yotpo-headline .font-serif.leading-7.capsize::before,#yotpo-reviews .yotpo-headline .font-serif .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.0867em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-7.capsize::after, .font-serif #yotpo-reviews .yotpo-headline.leading-7.capsize::after, .font-serif #yotpo-reviews .yotpo-headline .leading-7.capsize::after,#yotpo-reviews .yotpo-headline .font-serif.leading-7.capsize::after,#yotpo-reviews .yotpo-headline .font-serif .leading-7.capsize::after {
  content: '';
  margin-top: -0.0667em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-8.capsize::before, .font-serif #yotpo-reviews .yotpo-headline.leading-8.capsize::before, .font-serif #yotpo-reviews .yotpo-headline .leading-8.capsize::before,#yotpo-reviews .yotpo-headline .font-serif.leading-8.capsize::before,#yotpo-reviews .yotpo-headline .font-serif .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.1533em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-8.capsize::after, .font-serif #yotpo-reviews .yotpo-headline.leading-8.capsize::after, .font-serif #yotpo-reviews .yotpo-headline .leading-8.capsize::after,#yotpo-reviews .yotpo-headline .font-serif.leading-8.capsize::after,#yotpo-reviews .yotpo-headline .font-serif .leading-8.capsize::after {
  content: '';
  margin-top: -0.1333em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-9.capsize::before, .font-serif #yotpo-reviews .yotpo-headline.leading-9.capsize::before, .font-serif #yotpo-reviews .yotpo-headline .leading-9.capsize::before,#yotpo-reviews .yotpo-headline .font-serif.leading-9.capsize::before,#yotpo-reviews .yotpo-headline .font-serif .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.22em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-9.capsize::after, .font-serif #yotpo-reviews .yotpo-headline.leading-9.capsize::after, .font-serif #yotpo-reviews .yotpo-headline .leading-9.capsize::after,#yotpo-reviews .yotpo-headline .font-serif.leading-9.capsize::after,#yotpo-reviews .yotpo-headline .font-serif .leading-9.capsize::after {
  content: '';
  margin-top: -0.2em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-10.capsize::before, .font-serif #yotpo-reviews .yotpo-headline.leading-10.capsize::before, .font-serif #yotpo-reviews .yotpo-headline .leading-10.capsize::before,#yotpo-reviews .yotpo-headline .font-serif.leading-10.capsize::before,#yotpo-reviews .yotpo-headline .font-serif .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.2867em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-10.capsize::after, .font-serif #yotpo-reviews .yotpo-headline.leading-10.capsize::after, .font-serif #yotpo-reviews .yotpo-headline .leading-10.capsize::after,#yotpo-reviews .yotpo-headline .font-serif.leading-10.capsize::after,#yotpo-reviews .yotpo-headline .font-serif .leading-10.capsize::after {
  content: '';
  margin-top: -0.2667em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-none.capsize::before, .font-serif #yotpo-reviews .yotpo-headline.leading-none.capsize::before, .font-serif #yotpo-reviews .yotpo-headline .leading-none.capsize::before,#yotpo-reviews .yotpo-headline .font-serif.leading-none.capsize::before,#yotpo-reviews .yotpo-headline .font-serif .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-none.capsize::after, .font-serif #yotpo-reviews .yotpo-headline.leading-none.capsize::after, .font-serif #yotpo-reviews .yotpo-headline .leading-none.capsize::after,#yotpo-reviews .yotpo-headline .font-serif.leading-none.capsize::after,#yotpo-reviews .yotpo-headline .font-serif .leading-none.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-tight.capsize::before, .font-serif #yotpo-reviews .yotpo-headline.leading-tight.capsize::before, .font-serif #yotpo-reviews .yotpo-headline .leading-tight.capsize::before,#yotpo-reviews .yotpo-headline .font-serif.leading-tight.capsize::before,#yotpo-reviews .yotpo-headline .font-serif .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.245em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-tight.capsize::after, .font-serif #yotpo-reviews .yotpo-headline.leading-tight.capsize::after, .font-serif #yotpo-reviews .yotpo-headline .leading-tight.capsize::after,#yotpo-reviews .yotpo-headline .font-serif.leading-tight.capsize::after,#yotpo-reviews .yotpo-headline .font-serif .leading-tight.capsize::after {
  content: '';
  margin-top: -0.225em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-snug.capsize::before, .font-serif #yotpo-reviews .yotpo-headline.leading-snug.capsize::before, .font-serif #yotpo-reviews .yotpo-headline .leading-snug.capsize::before,#yotpo-reviews .yotpo-headline .font-serif.leading-snug.capsize::before,#yotpo-reviews .yotpo-headline .font-serif .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3075em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-snug.capsize::after, .font-serif #yotpo-reviews .yotpo-headline.leading-snug.capsize::after, .font-serif #yotpo-reviews .yotpo-headline .leading-snug.capsize::after,#yotpo-reviews .yotpo-headline .font-serif.leading-snug.capsize::after,#yotpo-reviews .yotpo-headline .font-serif .leading-snug.capsize::after {
  content: '';
  margin-top: -0.2875em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-normal.capsize::before, .font-serif #yotpo-reviews .yotpo-headline.leading-normal.capsize::before, .font-serif #yotpo-reviews .yotpo-headline .leading-normal.capsize::before,#yotpo-reviews .yotpo-headline .font-serif.leading-normal.capsize::before,#yotpo-reviews .yotpo-headline .font-serif .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.37em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-normal.capsize::after, .font-serif #yotpo-reviews .yotpo-headline.leading-normal.capsize::after, .font-serif #yotpo-reviews .yotpo-headline .leading-normal.capsize::after,#yotpo-reviews .yotpo-headline .font-serif.leading-normal.capsize::after,#yotpo-reviews .yotpo-headline .font-serif .leading-normal.capsize::after {
  content: '';
  margin-top: -0.35em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-relaxed.capsize::before, .font-serif #yotpo-reviews .yotpo-headline.leading-relaxed.capsize::before, .font-serif #yotpo-reviews .yotpo-headline .leading-relaxed.capsize::before,#yotpo-reviews .yotpo-headline .font-serif.leading-relaxed.capsize::before,#yotpo-reviews .yotpo-headline .font-serif .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4325em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-relaxed.capsize::after, .font-serif #yotpo-reviews .yotpo-headline.leading-relaxed.capsize::after, .font-serif #yotpo-reviews .yotpo-headline .leading-relaxed.capsize::after,#yotpo-reviews .yotpo-headline .font-serif.leading-relaxed.capsize::after,#yotpo-reviews .yotpo-headline .font-serif .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4125em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-loose.capsize::before, .font-serif #yotpo-reviews .yotpo-headline.leading-loose.capsize::before, .font-serif #yotpo-reviews .yotpo-headline .leading-loose.capsize::before,#yotpo-reviews .yotpo-headline .font-serif.leading-loose.capsize::before,#yotpo-reviews .yotpo-headline .font-serif .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-headline.leading-loose.capsize::after, .font-serif #yotpo-reviews .yotpo-headline.leading-loose.capsize::after, .font-serif #yotpo-reviews .yotpo-headline .leading-loose.capsize::after,#yotpo-reviews .yotpo-headline .font-serif.leading-loose.capsize::after,#yotpo-reviews .yotpo-headline .font-serif .leading-loose.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
#yotpo-reviews .yotpo-bottom-line-summary {
  margin-top: 0px;
}
#yotpo-reviews .yotpo-bottom-line-score {
  font-size: 1.875rem;
  line-height: 2.25rem;
  font-weight: 700;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-3.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-3.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-3.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-3.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.143em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-3.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-3.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-3.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-3.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-3.capsize::after {
  content: '';
  margin-top: 0.187em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-4.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-4.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-4.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-4.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-4.capsize::before {
  content: '';
  margin-bottom: 0.0763em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-4.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-4.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-4.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-4.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-4.capsize::after {
  content: '';
  margin-top: 0.1203em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-5.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-5.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-5.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-5.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-5.capsize::before {
  content: '';
  margin-bottom: 0.0097em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-5.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-5.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-5.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-5.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-5.capsize::after {
  content: '';
  margin-top: 0.0537em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-6.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-6.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-6.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-6.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.057em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-6.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-6.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-6.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-6.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-6.capsize::after {
  content: '';
  margin-top: -0.013em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-7.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-7.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-7.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-7.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.1237em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-7.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-7.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-7.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-7.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-7.capsize::after {
  content: '';
  margin-top: -0.0797em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-8.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-8.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-8.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-8.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.1903em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-8.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-8.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-8.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-8.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-8.capsize::after {
  content: '';
  margin-top: -0.1463em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-9.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-9.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-9.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-9.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.257em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-9.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-9.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-9.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-9.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-9.capsize::after {
  content: '';
  margin-top: -0.213em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-10.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-10.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-10.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-10.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.3237em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-10.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-10.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-10.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-10.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-10.capsize::after {
  content: '';
  margin-top: -0.2797em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-none.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-none.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-none.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-none.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-none.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-none.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-none.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-none.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-none.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-tight.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-tight.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-tight.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-tight.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.282em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-tight.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-tight.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-tight.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-tight.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-tight.capsize::after {
  content: '';
  margin-top: -0.238em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-snug.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-snug.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-snug.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-snug.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3445em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-snug.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-snug.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-snug.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-snug.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-snug.capsize::after {
  content: '';
  margin-top: -0.3005em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-normal.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-normal.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-normal.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-normal.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.407em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-normal.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-normal.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-normal.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-normal.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-normal.capsize::after {
  content: '';
  margin-top: -0.363em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-relaxed.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-relaxed.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-relaxed.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-relaxed.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4695em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-relaxed.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-relaxed.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-relaxed.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-relaxed.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4255em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-loose.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-loose.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-loose.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-loose.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-bottom-line-score.leading-loose.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-loose.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-loose.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-loose.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-loose.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-3.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-3.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-3.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-3.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.18em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-3.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-3.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-3.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-3.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-3.capsize::after {
  content: '';
  margin-top: 0.2em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-4.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-4.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-4.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-4.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-4.capsize::before {
  content: '';
  margin-bottom: 0.1133em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-4.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-4.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-4.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-4.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-4.capsize::after {
  content: '';
  margin-top: 0.1333em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-5.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-5.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-5.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-5.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-5.capsize::before {
  content: '';
  margin-bottom: 0.0467em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-5.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-5.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-5.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-5.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-5.capsize::after {
  content: '';
  margin-top: 0.0667em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-6.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-6.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-6.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-6.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.02em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-6.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-6.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-6.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-6.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-6.capsize::after {
  content: '';
  margin-top: 0em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-7.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-7.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-7.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-7.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.0867em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-7.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-7.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-7.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-7.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-7.capsize::after {
  content: '';
  margin-top: -0.0667em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-8.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-8.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-8.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-8.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.1533em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-8.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-8.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-8.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-8.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-8.capsize::after {
  content: '';
  margin-top: -0.1333em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-9.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-9.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-9.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-9.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.22em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-9.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-9.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-9.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-9.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-9.capsize::after {
  content: '';
  margin-top: -0.2em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-10.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-10.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-10.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-10.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.2867em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-10.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-10.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-10.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-10.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-10.capsize::after {
  content: '';
  margin-top: -0.2667em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-none.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-none.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-none.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-none.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-none.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-none.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-none.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-none.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-none.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-tight.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-tight.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-tight.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-tight.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.245em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-tight.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-tight.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-tight.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-tight.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-tight.capsize::after {
  content: '';
  margin-top: -0.225em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-snug.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-snug.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-snug.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-snug.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3075em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-snug.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-snug.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-snug.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-snug.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-snug.capsize::after {
  content: '';
  margin-top: -0.2875em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-normal.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-normal.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-normal.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-normal.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.37em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-normal.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-normal.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-normal.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-normal.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-normal.capsize::after {
  content: '';
  margin-top: -0.35em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-relaxed.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-relaxed.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-relaxed.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-relaxed.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4325em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-relaxed.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-relaxed.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-relaxed.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-relaxed.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4125em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-loose.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-loose.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-loose.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-loose.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-bottom-line-score.leading-loose.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-loose.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-loose.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-loose.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-loose.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
@media (min-width: 768px) {

  #yotpo-reviews .yotpo-bottom-line-score {
    font-size: 3rem;
    line-height: 1;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-3.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-3.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-3.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-3.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.218em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-3.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-3.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-3.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-3.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-3.capsize::after {
    content: '';
    margin-top: 0.262em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-4.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-4.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-4.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-4.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.1763em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-4.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-4.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-4.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-4.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-4.capsize::after {
    content: '';
    margin-top: 0.2203em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-5.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-5.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-5.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-5.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-5.capsize::before {
    content: '';
    margin-bottom: 0.1347em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-5.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-5.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-5.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-5.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-5.capsize::after {
    content: '';
    margin-top: 0.1787em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-6.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-6.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-6.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-6.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-6.capsize::before {
    content: '';
    margin-bottom: 0.093em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-6.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-6.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-6.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-6.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-6.capsize::after {
    content: '';
    margin-top: 0.137em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-7.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-7.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-7.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-7.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-7.capsize::before {
    content: '';
    margin-bottom: 0.0513em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-7.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-7.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-7.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-7.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-7.capsize::after {
    content: '';
    margin-top: 0.0953em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-8.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-8.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-8.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-8.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.0097em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-8.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-8.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-8.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-8.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: 0.0537em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-9.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-9.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-9.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-9.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.032em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-9.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-9.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-9.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-9.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-9.capsize::after {
    content: '';
    margin-top: 0.012em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-10.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-10.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-10.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-10.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.0737em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-10.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-10.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-10.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-10.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-10.capsize::after {
    content: '';
    margin-top: -0.0297em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-none.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-none.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-none.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-none.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-none.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-none.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-none.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-none.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-tight.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-tight.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-tight.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-tight.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-tight.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-tight.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-tight.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-tight.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-snug.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-snug.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-snug.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-snug.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3445em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-snug.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-snug.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-snug.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-snug.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-snug.capsize::after {
    content: '';
    margin-top: -0.3005em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-normal.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-normal.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-normal.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-normal.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-normal.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-normal.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-normal.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-normal.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-normal.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-relaxed.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-relaxed.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-relaxed.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-relaxed.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4695em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-relaxed.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-relaxed.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-relaxed.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-relaxed.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4255em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-loose.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-loose.capsize::before, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-loose.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-loose.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-sans.leading-loose.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score.leading-loose.capsize::after, .font-sans #yotpo-reviews .yotpo-bottom-line-score .leading-loose.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans.leading-loose.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-sans .leading-loose.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-3.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-3.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-3.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-3.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.255em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-3.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-3.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-3.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-3.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-3.capsize::after {
    content: '';
    margin-top: 0.275em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-4.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-4.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-4.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-4.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.2133em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-4.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-4.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-4.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-4.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-4.capsize::after {
    content: '';
    margin-top: 0.2333em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-5.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-5.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-5.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-5.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-5.capsize::before {
    content: '';
    margin-bottom: 0.1717em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-5.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-5.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-5.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-5.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-5.capsize::after {
    content: '';
    margin-top: 0.1917em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-6.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-6.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-6.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-6.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-6.capsize::before {
    content: '';
    margin-bottom: 0.13em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-6.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-6.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-6.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-6.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-6.capsize::after {
    content: '';
    margin-top: 0.15em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-7.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-7.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-7.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-7.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-7.capsize::before {
    content: '';
    margin-bottom: 0.0883em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-7.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-7.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-7.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-7.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-7.capsize::after {
    content: '';
    margin-top: 0.1083em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-8.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-8.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-8.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-8.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.0467em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-8.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-8.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-8.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-8.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: 0.0667em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-9.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-9.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-9.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-9.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-9.capsize::before {
    content: '';
    margin-bottom: 0.005em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-9.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-9.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-9.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-9.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-9.capsize::after {
    content: '';
    margin-top: 0.025em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-10.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-10.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-10.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-10.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.0367em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-10.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-10.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-10.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-10.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-10.capsize::after {
    content: '';
    margin-top: -0.0167em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-none.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-none.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-none.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-none.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-none.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-none.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-none.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-none.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-tight.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-tight.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-tight.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-tight.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-tight.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-tight.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-tight.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-tight.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-snug.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-snug.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-snug.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-snug.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3075em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-snug.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-snug.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-snug.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-snug.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-snug.capsize::after {
    content: '';
    margin-top: -0.2875em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-normal.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-normal.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-normal.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-normal.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-normal.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-normal.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-normal.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-normal.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-normal.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-relaxed.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-relaxed.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-relaxed.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-relaxed.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4325em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-relaxed.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-relaxed.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-relaxed.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-relaxed.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4125em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-loose.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-loose.capsize::before, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-loose.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-loose.capsize::before,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  #yotpo-reviews .yotpo-bottom-line-score.font-serif.leading-loose.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score.leading-loose.capsize::after, .font-serif #yotpo-reviews .yotpo-bottom-line-score .leading-loose.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif.leading-loose.capsize::after,#yotpo-reviews .yotpo-bottom-line-score .font-serif .leading-loose.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }
}
#yotpo-reviews .yotpo-bottom-line .yotpo-bottom-line-right-panel {
  padding-right: 0px;
}
#yotpo-reviews .yotpo-reviews-pagination-item {
  display: grid;
  width: 100%;
  place-items: center;
}
#yotpo-reviews-main-widget.yotpo-display-s .yotpo-reviews-pagination-item {
  height: auto;
  border-radius: 0px;
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
#yotpo-reviews .yotpo-horizontal-pagination .selected,
#yotpo-reviews
  .yotpo-horizontal-pagination
  .yotpo-pagination-number-container
  .yotpo-pagination-number:hover {
  background-color: transparent;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(33 33 33 / var(--tw-text-opacity));
}
#yotpo-reviews .yotpo-bottom-line {
  margin-right: 0px;
}
#yotpo-reviews .yotpo-header-container + .yotpo-review-border-smooth {
  display: none;
}
#yotpo-reviews .yotpo-reviews-summary-button {
  margin-top: 1rem;
  align-self: center;
}
#yotpo-reviews .yotpo-reviews-summary-button button {
  margin: 0px;
  height: auto;
  gap: 0.25rem;
  border-radius: 0px;
  padding: 1rem;
  font-weight: 600;
  text-transform: uppercase;
  line-height: 1;
  letter-spacing: 0.05em;
}
.font-sans.text-xs#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-xs#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-xs #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-xs .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-xs .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-xs#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-xs#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-xs #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-xs .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-xs .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-sm#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-sm#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-sm #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-sm .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-sm .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-sm#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-sm#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-sm #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-sm .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-sm .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-base#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-base#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-base #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-base .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-base .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-base#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-base#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-base #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-base .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-base .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-lg#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-lg#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-lg #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-lg .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-lg .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-lg#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-lg#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-lg #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-lg .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-lg .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-xl .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-xl .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-xl .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-xl .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-2xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-2xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-2xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-2xl .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-2xl .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-2xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-2xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-2xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-2xl .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-2xl .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-3xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-3xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-3xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-3xl .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-3xl .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-3xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-3xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-3xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-3xl .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-3xl .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-4xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-4xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-4xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-4xl .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-4xl .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-4xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-4xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-4xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-4xl .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-4xl .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-5xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-5xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-5xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-5xl .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-5xl .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-5xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-5xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-5xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-5xl .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-5xl .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-6xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-6xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-6xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-6xl .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-6xl .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-6xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-6xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-6xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-6xl .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-6xl .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-7xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-7xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-7xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-7xl .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-7xl .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-7xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-7xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-7xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-7xl .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-7xl .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-8xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-8xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-8xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-8xl .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-8xl .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-8xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-8xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-8xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-8xl .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-8xl .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-9xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-9xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-9xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-9xl .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-9xl .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-9xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-9xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-9xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-9xl .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-9xl .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-1xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-1xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-1xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-1xl .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-1xl .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-1xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-1xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-1xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-1xl .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-1xl .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-3.3xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-3.3xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-sans .text-3.3xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-3.3xl .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-3.3xl .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-3.3xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-3.3xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-sans .text-3.3xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-3.3xl .font-sans#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-3.3xl .font-sans #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-serif.text-xs#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-xs#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-xs #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-xs .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-xs .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-xs#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-xs#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-xs #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-xs .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-xs .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-sm#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-sm#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-sm #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-sm .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-sm .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-sm#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-sm#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-sm #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-sm .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-sm .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-base#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-base#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-base #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-base .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-base .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-base#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-base#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-base #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-base .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-base .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-lg#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-lg#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-lg #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-lg .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-lg .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-lg#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-lg#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-lg #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-lg .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-lg .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-xl .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-xl .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-xl .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-xl .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-2xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-2xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-2xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-2xl .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-2xl .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-2xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-2xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-2xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-2xl .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-2xl .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-3xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-3xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-3xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-3xl .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-3xl .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-3xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-3xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-3xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-3xl .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-3xl .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-4xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-4xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-4xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-4xl .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-4xl .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-4xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-4xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-4xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-4xl .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-4xl .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-5xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-5xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-5xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-5xl .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-5xl .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-5xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-5xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-5xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-5xl .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-5xl .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-6xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-6xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-6xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-6xl .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-6xl .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-6xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-6xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-6xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-6xl .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-6xl .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-7xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-7xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-7xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-7xl .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-7xl .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-7xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-7xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-7xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-7xl .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-7xl .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-8xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-8xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-8xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-8xl .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-8xl .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-8xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-8xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-8xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-8xl .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-8xl .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-9xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-9xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-9xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-9xl .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-9xl .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-9xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-9xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-9xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-9xl .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-9xl .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-1xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-1xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-1xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-1xl .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-1xl .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-1xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-1xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-1xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-1xl .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-1xl .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-3.3xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-3.3xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .font-serif .text-3.3xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-3.3xl .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::before, .text-3.3xl .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-3.3xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-3.3xl#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .font-serif .text-3.3xl #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-3.3xl .font-serif#yotpo-reviews .yotpo-reviews-summary-button button.capsize::after, .text-3.3xl .font-serif #yotpo-reviews .yotpo-reviews-summary-button button.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
#yotpo-reviews .yotpo-display-s .yotpo-main-layout .yotpo-layout-header-wrapper {
  margin-bottom: 0px;
}
/* Filters */
#yotpo-reviews label input,
#yotpo-reviews label div,
#yotpo-reviews label button,
#yotpo-reviews .yotpo-media-filter-container button,
#yotpo-reviews .yotpo-score-filter-container .yotpo-selected-value {
  border-radius: 0px;
  border-style: none;
  font-weight: 600;
}
#yotpo-reviews-main-widget:not(.yotpo-display-s) .yotpo-filters-top-panel {
  display: grid;
  grid-auto-flow: row dense;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: repeat(5, minmax(0, 1fr));
  gap: 1rem;
}
@media (min-width: 640px) {

  #yotpo-reviews-main-widget:not(.yotpo-display-s) .yotpo-filters-top-panel {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (min-width: 992px) {

  #yotpo-reviews-main-widget:not(.yotpo-display-s) .yotpo-filters-top-panel {
    grid-template-columns: repeat(6, minmax(0, 1fr));
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
}
#yotpo-reviews .yotpo-custom-questions-filter,
#yotpo-reviews .yotpo-free-search-filter-container,
#yotpo-reviews .yotpo-score-filter-container {
  width: auto;
}
#yotpo-reviews .yotpo-mobile-filters-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity));
}
#yotpo-reviews .yotpo-mobile-filters-btn-text {
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
#yotpo-reviews .yotpo-mobile-filters-btn svg path {
  fill: #fff;
}
#yotpo-reviews .yotpo-media-select svg path {
  fill: #212121;
}
#yotpo-reviews .yotpo-mobile-filters-btn-badge-wrapper {
  display: none;
}
#yotpo-reviews-main-widget:not(.yotpo-display-s) .yotpo-search-filter {
  grid-column: span 2 / span 2;
}
@media (min-width: 640px) {

  #yotpo-reviews-main-widget:not(.yotpo-display-s) .yotpo-search-filter {
    grid-column: span 3 / span 3;
  }
}
@media (min-width: 992px) {

  #yotpo-reviews-main-widget:not(.yotpo-display-s) .yotpo-search-filter {
    grid-column: span 2 / span 2;
  }
}
#yotpo-reviews .yotpo-review {
  margin-bottom: 2rem;
  margin-top: 1.5rem;
}
#yotpo-reviews .yotpo-filters-top-panel,
#yotpo-reviews .yotpo-filters-right-panel {
  width: 100%;
  flex-basis: 0px;
}
/* #yotpo-reviews .yotpo-filters-top-panel :nth-child(2), */
@media (min-width: 992px) {

  #yotpo-reviews .yotpo-filters-top-panel :nth-child(3),
#yotpo-reviews .yotpo-filters-top-panel :nth-child(4),
#yotpo-reviews .yotpo-filters-top-panel :nth-child(5),
#yotpo-reviews .yotpo-filters-top-panel :nth-child(6),
#yotpo-reviews .yotpo-filters-top-panel :nth-child(7),
#yotpo-reviews .yotpo-filters-top-panel :nth-child(8),
#yotpo-reviews .yotpo-filters-top-panel :nth-child(9) {
    grid-row-start: 2;
  }
}
#yotpo-reviews .yotpo-filters-right-panel label,
#yotpo-reviews .yotpo-filters-right-panel .yotpo-dropdown-closable,
#yotpo-reviews .yotpo-filters-right-panel .yotpo-dropdown-placeholder {
  background-color: transparent;
}
#yotpo-reviews .yotpo-sorting-filter-container {
  height: 2.5rem;
}
#yotpo-reviews .yotpo-sorting-filter-container button {
  align-items: center;
}
#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder {
  height: 100%;
  line-height: 2.5rem;
}
.font-sans.text-xs#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-xs#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-xs #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-xs .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-xs .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: -1.3237em;
  display: table;
}
.font-sans.text-xs#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-xs#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-xs #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-xs .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-xs .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: -1.2797em;
  display: table;
}
.font-sans.text-sm#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-sm#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-sm #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-sm .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-sm .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: -1.0856em;
  display: table;
}
.font-sans.text-sm#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-sm#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-sm #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-sm .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-sm .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: -1.0416em;
  display: table;
}
.font-sans.text-base#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-base#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-base #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-base .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-base .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: -0.907em;
  display: table;
}
.font-sans.text-base#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-base#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-base #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-base .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-base .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: -0.863em;
  display: table;
}
.font-sans.text-lg#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-lg#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-lg #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-lg .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-lg .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: -0.7681em;
  display: table;
}
.font-sans.text-lg#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-lg#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-lg #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-lg .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-lg .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: -0.7241em;
  display: table;
}
.font-sans.text-xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-xl .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-xl .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans.text-xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-xl .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-xl .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-sans.text-2xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-2xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-2xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-2xl .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-2xl .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: -0.4903em;
  display: table;
}
.font-sans.text-2xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-2xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-2xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-2xl .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-2xl .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: -0.4463em;
  display: table;
}
.font-sans.text-3xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-3xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-3xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-3xl .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-3xl .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: -0.3237em;
  display: table;
}
.font-sans.text-3xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-3xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-3xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-3xl .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-3xl .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: -0.2797em;
  display: table;
}
.font-sans.text-4xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-4xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-4xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-4xl .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-4xl .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: -0.2126em;
  display: table;
}
.font-sans.text-4xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-4xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-4xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-4xl .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-4xl .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: -0.1686em;
  display: table;
}
.font-sans.text-5xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-5xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-5xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-5xl .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-5xl .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: -0.0737em;
  display: table;
}
.font-sans.text-5xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-5xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-5xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-5xl .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-5xl .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: -0.0297em;
  display: table;
}
.font-sans.text-6xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-6xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-6xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-6xl .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-6xl .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: 0.0097em;
  display: table;
}
.font-sans.text-6xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-6xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-6xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-6xl .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-6xl .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: 0.0537em;
  display: table;
}
.font-sans.text-7xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-7xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-7xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-7xl .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-7xl .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: 0.0652em;
  display: table;
}
.font-sans.text-7xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-7xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-7xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-7xl .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-7xl .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: 0.1092em;
  display: table;
}
.font-sans.text-8xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-8xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-8xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-8xl .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-8xl .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: 0.1347em;
  display: table;
}
.font-sans.text-8xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-8xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-8xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-8xl .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-8xl .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: 0.1787em;
  display: table;
}
.font-sans.text-9xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-9xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-9xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-9xl .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-9xl .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: 0.1868em;
  display: table;
}
.font-sans.text-9xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-9xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-9xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-9xl .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-9xl .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: 0.2308em;
  display: table;
}
.font-sans.text-1xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-1xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-1xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-1xl .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-1xl .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: -0.5661em;
  display: table;
}
.font-sans.text-1xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-1xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-1xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-1xl .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-1xl .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: -0.5221em;
  display: table;
}
.font-sans.text-3.3xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-3.3xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-sans .text-3.3xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-3.3xl .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-3.3xl .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: -0.282em;
  display: table;
}
.font-sans.text-3.3xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-3.3xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-sans .text-3.3xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-3.3xl .font-sans#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-3.3xl .font-sans #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: -0.238em;
  display: table;
}
.font-serif.text-xs#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-xs#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-xs #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-xs .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-xs .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: -1.2867em;
  display: table;
}
.font-serif.text-xs#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-xs#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-xs #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-xs .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-xs .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: -1.2667em;
  display: table;
}
.font-serif.text-sm#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-sm#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-sm #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-sm .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-sm .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: -1.0486em;
  display: table;
}
.font-serif.text-sm#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-sm#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-sm #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-sm .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-sm .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: -1.0286em;
  display: table;
}
.font-serif.text-base#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-base#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-base #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-base .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-base .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: -0.87em;
  display: table;
}
.font-serif.text-base#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-base#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-base #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-base .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-base .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: -0.85em;
  display: table;
}
.font-serif.text-lg#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-lg#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-lg #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-lg .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-lg .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: -0.7311em;
  display: table;
}
.font-serif.text-lg#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-lg#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-lg #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-lg .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-lg .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: -0.7111em;
  display: table;
}
.font-serif.text-xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-xl .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-xl .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif.text-xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-xl .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-xl .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
.font-serif.text-2xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-2xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-2xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-2xl .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-2xl .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: -0.4533em;
  display: table;
}
.font-serif.text-2xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-2xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-2xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-2xl .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-2xl .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: -0.4333em;
  display: table;
}
.font-serif.text-3xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-3xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-3xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-3xl .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-3xl .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: -0.2867em;
  display: table;
}
.font-serif.text-3xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-3xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-3xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-3xl .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-3xl .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: -0.2667em;
  display: table;
}
.font-serif.text-4xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-4xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-4xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-4xl .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-4xl .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: -0.1756em;
  display: table;
}
.font-serif.text-4xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-4xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-4xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-4xl .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-4xl .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: -0.1556em;
  display: table;
}
.font-serif.text-5xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-5xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-5xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-5xl .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-5xl .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: -0.0367em;
  display: table;
}
.font-serif.text-5xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-5xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-5xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-5xl .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-5xl .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: -0.0167em;
  display: table;
}
.font-serif.text-6xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-6xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-6xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-6xl .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-6xl .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: 0.0467em;
  display: table;
}
.font-serif.text-6xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-6xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-6xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-6xl .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-6xl .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: 0.0667em;
  display: table;
}
.font-serif.text-7xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-7xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-7xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-7xl .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-7xl .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: 0.1022em;
  display: table;
}
.font-serif.text-7xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-7xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-7xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-7xl .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-7xl .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: 0.1222em;
  display: table;
}
.font-serif.text-8xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-8xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-8xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-8xl .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-8xl .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: 0.1717em;
  display: table;
}
.font-serif.text-8xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-8xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-8xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-8xl .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-8xl .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: 0.1917em;
  display: table;
}
.font-serif.text-9xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-9xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-9xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-9xl .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-9xl .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: 0.2238em;
  display: table;
}
.font-serif.text-9xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-9xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-9xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-9xl .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-9xl .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: 0.2438em;
  display: table;
}
.font-serif.text-1xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-1xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-1xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-1xl .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-1xl .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: -0.5291em;
  display: table;
}
.font-serif.text-1xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-1xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-1xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-1xl .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-1xl .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: -0.5091em;
  display: table;
}
.font-serif.text-3.3xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-3.3xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .font-serif .text-3.3xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-3.3xl .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before, .text-3.3xl .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::before {
  content: '';
  margin-bottom: -0.245em;
  display: table;
}
.font-serif.text-3.3xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-3.3xl#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .font-serif .text-3.3xl #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-3.3xl .font-serif#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after, .text-3.3xl .font-serif #yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder.capsize::after {
  content: '';
  margin-top: -0.225em;
  display: table;
}
#yotpo-reviews .yotpo-filter-select,
#yotpo-reviews .yotpo-media-select,
#yotpo-reviews .yotpo-media-filter-container,
#yotpo-reviews .yotpo-free-search-filter-container input,
#yotpo-reviews .yotpo-dropdown-placeholder-input,
#yotpo-reviews button.yotpo-dropdown-closable,
#yotpo-reviews .yotpo-search-filter .yotpo-search-label {
  height: 100%;
  width: 100%;
  border-style: none;
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}
#yotpo-reviews .yotpo-search-filter label,
#yotpo-reviews .yotpo-dropdown-base {
  height: 100%;
  width: 100%;
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}
#yotpo-reviews .yotpo-dropdown-placeholder-input {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity)) !important;
}
#yotpo-reviews .yotpo-search-filter .yotpo-search-label .yotpo-search-input {
  padding-left: 2.5rem;
}
#yotpo-reviews .yotpo-search-filter,
#yotpo-reviews .yotpo-score-filter,
#yotpo-reviews .yotpo-media-filter-container,
#yotpo-reviews .yotpo-custom-questions-filter {
  border-bottom-width: 2px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
}
[class*='yotpo-display-'][class*='yotpo-device-'][style]
  .yotpo-filters-container
  .yotpo-filters-top-panel
  > [class\$='filter-container']
  input[placeholder],
[class*='yotpo-display-'][class*='yotpo-device-'].yotpo-device-mobile
  .yotpo-filters-container
  .yotpo-filters-top-panel
  .yotpo-mobile-filters-btn {
  height: auto;
  width: 100%;
  min-width: 100%;
  border-radius: 0px;
  border-bottom-width: 2px;
  border-style: none;
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
  padding: 1rem;
}
#yotpo-reviews .yotpo-dropdown-closable .yotpo-dropdown-content-wrapper {
  top: 50px;
}
#yotpo-mobile-filters-popup .yotpo-filter-select,
#yotpo-mobile-filters-popup .yotpo-dropdown-placeholder-input {
  height: 50px;
  border-radius: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 2px;
  border-top-width: 0px;
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
  --tw-bg-opacity: 1 !important;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity)) !important;
  padding: 1rem;
}
#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value {
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
  font-weight: 600 !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-3.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-3.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-3.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-3.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: -0.0856em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-3.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-3.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-3.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-3.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-3.capsize::after {
  content: '' !important;
  margin-top: -0.0416em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-4.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-4.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-4.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-4.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.2284em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-4.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-4.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-4.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-4.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-4.capsize::after {
  content: '' !important;
  margin-top: -0.1844em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-5.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-5.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-5.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-5.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.3713em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-5.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-5.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-5.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-5.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.3273em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-6.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-6.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-6.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-6.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.5141em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-6.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-6.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-6.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-6.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.4701em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-7.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-7.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-7.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-7.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-7.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-7.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-7.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-7.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-8.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-8.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-8.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-8.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.7999em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-8.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-8.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-8.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-8.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.7559em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-9.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-9.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-9.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-9.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.9427em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-9.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-9.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-9.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-9.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.8987em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-10.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-10.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-10.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-10.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -1.0856em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-10.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-10.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-10.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-10.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-10.capsize::after {
  content: '' !important;
  margin-top: -1.0416em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-none.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-none.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-none.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-none.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-none.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-none.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-none.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-none.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-tight.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-tight.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-tight.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-tight.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-tight.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-tight.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-tight.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-tight.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-snug.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-snug.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-snug.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-snug.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-snug.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-snug.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-snug.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-snug.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-normal.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-normal.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-normal.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-normal.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-normal.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-normal.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-normal.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-normal.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-relaxed.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-relaxed.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-relaxed.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-relaxed.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-relaxed.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-relaxed.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-relaxed.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-relaxed.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-loose.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-loose.capsize::before, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-loose.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-loose.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.font-sans#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-loose.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-loose.capsize::after, .font-sans #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-loose.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans.leading-loose.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-sans .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-3.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-3.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-3.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-3.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: -0.0486em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-3.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-3.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-3.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-3.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-3.capsize::after {
  content: '' !important;
  margin-top: -0.0286em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-4.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-4.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-4.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-4.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.1914em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-4.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-4.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-4.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-4.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-4.capsize::after {
  content: '' !important;
  margin-top: -0.1714em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-5.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-5.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-5.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-5.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.3343em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-5.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-5.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-5.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-5.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.3143em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-6.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-6.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-6.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-6.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.4771em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-6.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-6.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-6.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-6.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.4571em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-7.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-7.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-7.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-7.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.62em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-7.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-7.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-7.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-7.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.6em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-8.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-8.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-8.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-8.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.7629em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-8.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-8.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-8.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-8.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.7429em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-9.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-9.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-9.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-9.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.9057em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-9.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-9.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-9.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-9.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.8857em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-10.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-10.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-10.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-10.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -1.0486em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-10.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-10.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-10.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-10.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-10.capsize::after {
  content: '' !important;
  margin-top: -1.0286em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-none.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-none.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-none.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-none.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.12em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-none.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-none.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-none.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-none.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.1em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-tight.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-tight.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-tight.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-tight.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.245em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-tight.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-tight.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-tight.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-tight.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.225em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-snug.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-snug.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-snug.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-snug.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3075em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-snug.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-snug.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-snug.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-snug.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.2875em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-normal.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-normal.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-normal.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-normal.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.37em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-normal.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-normal.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-normal.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-normal.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.35em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-relaxed.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-relaxed.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-relaxed.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-relaxed.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4325em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-relaxed.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-relaxed.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-relaxed.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-relaxed.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4125em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-loose.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-loose.capsize::before, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-loose.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-loose.capsize::before,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.62em !important;
  display: table !important;
}
.font-serif#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-loose.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value.leading-loose.capsize::after, .font-serif #yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .leading-loose.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif.leading-loose.capsize::after,#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value .font-serif .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.6em !important;
  display: table !important;
}
#yotpo-reviews.yotpo-widget-instance .yotpo-review-border-smooth {
  margin-top: 0px;
  height: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(212 212 212 / var(--tw-border-opacity));
}
#yotpo-reviews .yotpo-reviewer-details-verified svg {
  display: none;
}
#yotpo-reviews .yotpo-dropdown-base .yotpo-dropdown-arrow-icon {
  margin-top: -0.125rem !important;
}
/* Reviews */
#yotpo-reviews .yotpo-review-left-panel {
  order: 3;
  width: 100%;
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
  padding: 1.5rem;
}
@media (min-width: 992px) {

  #yotpo-reviews .yotpo-review-left-panel {
    width: 20rem;
  }
}
#yotpo-reviews-main-widget:not(.yotpo-display-s) .yotpo-review-left-panel {
  align-self: flex-start;
}
@media not all and (min-width: 992px) {

  #yotpo-reviews-main-widget:not(.yotpo-display-s) .yotpo-review-left-panel {
    margin-top: 1rem;
  }
}
#yotpo-reviews .yotpo-review-center-panel {
  margin-top: 0px;
  margin-bottom: 0px;
  gap: 0.5rem;
  padding: 0px;
}
@media (min-width: 992px) {

  #yotpo-reviews .yotpo-review-center-panel {
    padding-right: 2.5rem;
  }
}
#yotpo-reviews .yotpo-review-right-panel {
  display: none;
}
#yotpo-reviews .yotpo-review-customer-questions-container {
  width: 100%;
}
#yotpo-reviews-main-widget .yotpo-review-questions-mobile-panel {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 1.5rem;
}
#yotpo-reviews .yotpo-custom-questions-see-more-label {
  font-size: 0.75rem !important;
  line-height: 1rem !important;
  text-decoration-line: underline;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-3.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-3.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-3.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-3.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-3.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-3.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-3.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-3.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-3.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-4.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-4.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-4.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-4.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.3237em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-4.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-4.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-4.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-4.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-4.capsize::after {
  content: '' !important;
  margin-top: -0.2797em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-5.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-5.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-5.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-5.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.4903em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-5.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-5.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-5.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-5.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.4463em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-6.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-6.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-6.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-6.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-6.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-6.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-6.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-6.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-7.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-7.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-7.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-7.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.8237em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-7.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-7.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-7.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-7.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.7797em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-8.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-8.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-8.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-8.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.9903em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-8.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-8.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-8.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-8.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.9463em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-9.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-9.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-9.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-9.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -1.157em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-9.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-9.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-9.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-9.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-9.capsize::after {
  content: '' !important;
  margin-top: -1.113em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-10.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-10.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-10.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-10.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -1.3237em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-10.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-10.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-10.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-10.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-10.capsize::after {
  content: '' !important;
  margin-top: -1.2797em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-none.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-none.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-none.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-none.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-none.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-none.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-none.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-none.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-tight.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-tight.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-tight.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-tight.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-tight.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-tight.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-tight.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-tight.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-snug.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-snug.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-snug.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-snug.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-snug.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-snug.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-snug.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-snug.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-normal.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-normal.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-normal.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-normal.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-normal.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-normal.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-normal.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-normal.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-relaxed.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-relaxed.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-relaxed.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-relaxed.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-relaxed.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-relaxed.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-relaxed.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-relaxed.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-loose.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-loose.capsize::before, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-loose.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-loose.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-loose.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-loose.capsize::after, .font-sans #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-loose.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans.leading-loose.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-sans .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-3.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-3.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-3.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-3.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: -0.12em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-3.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-3.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-3.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-3.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-3.capsize::after {
  content: '' !important;
  margin-top: -0.1em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-4.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-4.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-4.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-4.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.2867em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-4.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-4.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-4.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-4.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-4.capsize::after {
  content: '' !important;
  margin-top: -0.2667em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-5.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-5.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-5.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-5.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.4533em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-5.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-5.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-5.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-5.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.4333em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-6.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-6.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-6.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-6.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.62em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-6.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-6.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-6.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-6.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.6em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-7.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-7.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-7.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-7.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.7867em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-7.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-7.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-7.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-7.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.7667em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-8.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-8.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-8.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-8.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.9533em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-8.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-8.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-8.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-8.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.9333em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-9.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-9.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-9.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-9.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -1.12em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-9.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-9.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-9.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-9.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-9.capsize::after {
  content: '' !important;
  margin-top: -1.1em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-10.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-10.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-10.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-10.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -1.2867em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-10.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-10.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-10.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-10.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-10.capsize::after {
  content: '' !important;
  margin-top: -1.2667em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-none.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-none.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-none.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-none.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.12em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-none.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-none.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-none.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-none.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.1em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-tight.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-tight.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-tight.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-tight.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.245em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-tight.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-tight.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-tight.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-tight.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.225em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-snug.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-snug.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-snug.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-snug.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3075em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-snug.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-snug.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-snug.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-snug.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.2875em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-normal.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-normal.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-normal.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-normal.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.37em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-normal.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-normal.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-normal.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-normal.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.35em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-relaxed.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-relaxed.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-relaxed.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-relaxed.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4325em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-relaxed.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-relaxed.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-relaxed.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-relaxed.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4125em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-loose.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-loose.capsize::before, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-loose.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-loose.capsize::before,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.62em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-custom-questions-see-more-label.leading-loose.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label.leading-loose.capsize::after, .font-serif #yotpo-reviews .yotpo-custom-questions-see-more-label .leading-loose.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif.leading-loose.capsize::after,#yotpo-reviews .yotpo-custom-questions-see-more-label .font-serif .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.6em !important;
  display: table !important;
}
#yotpo-reviews-main-widget.yotpo-display-s .yotpo-review-key-value-question {
  margin-top: 0px;
  margin-bottom: 0px;
  gap: 0.25rem !important;
}
#yotpo-reviews-main-widget:not(.yotpo-display-s) .yotpo-review-key-value-question {
  margin-bottom: 0px;
}
#yotpo-reviews-main-widget.yotpo-display-s .yotpo-custom-questions-question-wrapper {
  width: 100%;
  flex-wrap: nowrap;
}
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value {
  flex-wrap: nowrap;
  font-size: 0.75rem !important;
  line-height: 1rem !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-3.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-3.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-3.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-3.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-3.capsize::before,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-3.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-3.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-3.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-3.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-3.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-3.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-3.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-3.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-3.capsize::after,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-3.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-3.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-3.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-3.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-3.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-4.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-4.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-4.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-4.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-4.capsize::before,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-4.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-4.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-4.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-4.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.3237em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-4.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-4.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-4.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-4.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-4.capsize::after,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-4.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-4.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-4.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-4.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-4.capsize::after {
  content: '' !important;
  margin-top: -0.2797em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-5.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-5.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-5.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-5.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-5.capsize::before,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-5.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-5.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-5.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-5.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.4903em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-5.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-5.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-5.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-5.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-5.capsize::after,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-5.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-5.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-5.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-5.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.4463em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-6.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-6.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-6.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-6.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-6.capsize::before,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-6.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-6.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-6.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-6.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-6.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-6.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-6.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-6.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-6.capsize::after,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-6.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-6.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-6.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-6.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-7.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-7.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-7.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-7.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-7.capsize::before,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-7.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-7.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-7.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-7.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.8237em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-7.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-7.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-7.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-7.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-7.capsize::after,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-7.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-7.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-7.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-7.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.7797em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-8.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-8.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-8.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-8.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-8.capsize::before,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-8.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-8.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-8.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-8.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.9903em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-8.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-8.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-8.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-8.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-8.capsize::after,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-8.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-8.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-8.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-8.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.9463em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-9.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-9.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-9.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-9.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-9.capsize::before,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-9.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-9.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-9.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-9.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -1.157em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-9.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-9.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-9.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-9.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-9.capsize::after,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-9.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-9.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-9.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-9.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-9.capsize::after {
  content: '' !important;
  margin-top: -1.113em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-10.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-10.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-10.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-10.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-10.capsize::before,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-10.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-10.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-10.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-10.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -1.3237em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-10.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-10.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-10.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-10.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-10.capsize::after,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-10.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-10.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-10.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-10.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-10.capsize::after {
  content: '' !important;
  margin-top: -1.2797em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-none.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-none.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-none.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-none.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-none.capsize::before,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-none.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-none.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-none.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-none.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-none.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-none.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-none.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-none.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-none.capsize::after,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-none.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-none.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-none.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-none.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-tight.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-tight.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-tight.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-tight.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-tight.capsize::before,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-tight.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-tight.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-tight.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-tight.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-tight.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-tight.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-tight.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-tight.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-tight.capsize::after,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-tight.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-tight.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-tight.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-tight.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-snug.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-snug.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-snug.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-snug.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-snug.capsize::before,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-snug.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-snug.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-snug.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-snug.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-snug.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-snug.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-snug.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-snug.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-snug.capsize::after,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-snug.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-snug.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-snug.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-snug.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-normal.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-normal.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-normal.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-normal.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-normal.capsize::before,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-normal.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-normal.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-normal.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-normal.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-normal.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-normal.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-normal.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-normal.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-normal.capsize::after,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-normal.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-normal.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-normal.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-normal.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-relaxed.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-relaxed.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-relaxed.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-relaxed.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-relaxed.capsize::before,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-relaxed.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-relaxed.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-relaxed.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-relaxed.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-relaxed.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-relaxed.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-relaxed.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-relaxed.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-relaxed.capsize::after,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-relaxed.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-relaxed.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-relaxed.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-relaxed.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-loose.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-loose.capsize::before, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-loose.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-loose.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-loose.capsize::before,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-loose.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-loose.capsize::before, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-loose.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-loose.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.font-sans#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-loose.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-loose.capsize::after, .font-sans #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-loose.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans.leading-loose.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-sans .leading-loose.capsize::after,.font-sans
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-loose.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-loose.capsize::after, .font-sans 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-loose.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans.leading-loose.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-sans .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-3.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-3.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-3.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-3.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-3.capsize::before,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-3.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-3.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-3.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-3.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: -0.12em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-3.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-3.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-3.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-3.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-3.capsize::after,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-3.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-3.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-3.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-3.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-3.capsize::after {
  content: '' !important;
  margin-top: -0.1em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-4.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-4.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-4.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-4.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-4.capsize::before,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-4.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-4.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-4.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-4.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.2867em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-4.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-4.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-4.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-4.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-4.capsize::after,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-4.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-4.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-4.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-4.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-4.capsize::after {
  content: '' !important;
  margin-top: -0.2667em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-5.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-5.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-5.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-5.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-5.capsize::before,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-5.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-5.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-5.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-5.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.4533em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-5.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-5.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-5.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-5.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-5.capsize::after,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-5.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-5.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-5.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-5.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.4333em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-6.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-6.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-6.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-6.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-6.capsize::before,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-6.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-6.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-6.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-6.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.62em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-6.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-6.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-6.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-6.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-6.capsize::after,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-6.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-6.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-6.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-6.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.6em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-7.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-7.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-7.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-7.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-7.capsize::before,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-7.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-7.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-7.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-7.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.7867em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-7.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-7.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-7.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-7.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-7.capsize::after,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-7.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-7.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-7.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-7.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.7667em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-8.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-8.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-8.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-8.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-8.capsize::before,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-8.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-8.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-8.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-8.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.9533em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-8.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-8.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-8.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-8.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-8.capsize::after,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-8.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-8.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-8.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-8.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.9333em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-9.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-9.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-9.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-9.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-9.capsize::before,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-9.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-9.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-9.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-9.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -1.12em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-9.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-9.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-9.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-9.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-9.capsize::after,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-9.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-9.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-9.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-9.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-9.capsize::after {
  content: '' !important;
  margin-top: -1.1em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-10.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-10.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-10.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-10.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-10.capsize::before,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-10.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-10.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-10.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-10.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -1.2867em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-10.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-10.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-10.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-10.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-10.capsize::after,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-10.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-10.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-10.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-10.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-10.capsize::after {
  content: '' !important;
  margin-top: -1.2667em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-none.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-none.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-none.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-none.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-none.capsize::before,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-none.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-none.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-none.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-none.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.12em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-none.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-none.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-none.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-none.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-none.capsize::after,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-none.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-none.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-none.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-none.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.1em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-tight.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-tight.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-tight.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-tight.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-tight.capsize::before,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-tight.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-tight.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-tight.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-tight.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.245em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-tight.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-tight.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-tight.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-tight.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-tight.capsize::after,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-tight.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-tight.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-tight.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-tight.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.225em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-snug.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-snug.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-snug.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-snug.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-snug.capsize::before,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-snug.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-snug.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-snug.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-snug.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3075em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-snug.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-snug.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-snug.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-snug.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-snug.capsize::after,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-snug.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-snug.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-snug.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-snug.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.2875em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-normal.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-normal.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-normal.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-normal.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-normal.capsize::before,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-normal.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-normal.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-normal.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-normal.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.37em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-normal.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-normal.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-normal.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-normal.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-normal.capsize::after,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-normal.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-normal.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-normal.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-normal.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.35em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-relaxed.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-relaxed.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-relaxed.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-relaxed.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-relaxed.capsize::before,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-relaxed.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-relaxed.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-relaxed.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-relaxed.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4325em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-relaxed.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-relaxed.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-relaxed.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-relaxed.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-relaxed.capsize::after,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-relaxed.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-relaxed.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-relaxed.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-relaxed.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4125em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-loose.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-loose.capsize::before, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-loose.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-loose.capsize::before,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-loose.capsize::before,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-loose.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-loose.capsize::before, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-loose.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-loose.capsize::before,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.62em !important;
  display: table !important;
}
.font-serif#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-loose.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title.leading-loose.capsize::after, .font-serif #yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .leading-loose.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif.leading-loose.capsize::after,#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-title .font-serif .leading-loose.capsize::after,.font-serif
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-loose.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value.leading-loose.capsize::after, .font-serif 
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .leading-loose.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif.leading-loose.capsize::after,
#yotpo-reviews-main-widget.yotpo-display-s
  .yotpo-custom-questions-wrapper
  .yotpo-custom-questions-value .font-serif .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.6em !important;
  display: table !important;
}
#yotpo-reviews-main-widget.yotpo-display-s .yotpo-custom-questions-wrapper-suffix-padding {
  display: none;
}
#yotpo-reviews-main-widget.yotpo-display-s .yotpo-review-content {
  margin-bottom: 1rem;
  margin-top: 0px;
}
#yotpo-reviews-main-widget.yotpo-display-s .yotpo-review-comment,
#yotpo-reviews-main-widget.yotpo-display-s .yotpo-review-customer-questions,
#yotpo-reviews-main-widget.yotpo-display-s .yotpo-review-question,
#yotpo-reviews-main-widget.yotpo-display-s .yotpo-review-questions-mobile-panel,
#yotpo-reviews-main-widget.yotpo-display-s .yotpo-review-title,
#yotpo-reviews-main-widget.yotpo-display-s .yotpo-review-rating-title {
  margin-top: 0px;
  margin-bottom: 0px;
}
#yotpo-reviews-main-widget:not(.yotpo-display-s) .yotpo-review-customer-questions-container {
  margin-top: 1rem;
  border-top-width: 1px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color: rgb(212 212 212 / var(--tw-border-opacity));
}
#yotpo-reviews .yotpo-reviewer-details-verified {
  flex-direction: row;
  gap: 0.5rem;
  padding-top: 0px;
}
#yotpo-reviews .yotpo-reviewer-details-verified > * {
  line-height: 1;
}
.font-sans.text-xs#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-xs#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-xs #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-xs .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-xs .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-xs#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-xs#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-xs #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-xs .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-xs .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-sm#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-sm#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-sm #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-sm .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-sm .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-sm#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-sm#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-sm #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-sm .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-sm .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-base#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-base#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-base #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-base .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-base .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-base#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-base#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-base #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-base .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-base .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-lg#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-lg#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-lg #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-lg .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-lg .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-lg#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-lg#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-lg #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-lg .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-lg .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-xl .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-xl .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-xl .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-xl .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-2xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-2xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-2xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-2xl .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-2xl .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-2xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-2xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-2xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-2xl .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-2xl .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-3xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-3xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-3xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-3xl .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-3xl .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-3xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-3xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-3xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-3xl .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-3xl .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-4xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-4xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-4xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-4xl .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-4xl .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-4xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-4xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-4xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-4xl .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-4xl .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-5xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-5xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-5xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-5xl .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-5xl .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-5xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-5xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-5xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-5xl .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-5xl .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-6xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-6xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-6xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-6xl .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-6xl .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-6xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-6xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-6xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-6xl .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-6xl .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-7xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-7xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-7xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-7xl .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-7xl .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-7xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-7xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-7xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-7xl .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-7xl .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-8xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-8xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-8xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-8xl .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-8xl .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-8xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-8xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-8xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-8xl .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-8xl .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-9xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-9xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-9xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-9xl .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-9xl .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-9xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-9xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-9xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-9xl .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-9xl .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-1xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-1xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-1xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-1xl .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-1xl .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-1xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-1xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-1xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-1xl .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-1xl .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.text-3.3xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-3.3xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-sans .text-3.3xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-3.3xl .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-3.3xl .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.text-3.3xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-3.3xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-sans .text-3.3xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-3.3xl .font-sans#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-3.3xl .font-sans #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-serif.text-xs#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-xs#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-xs #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-xs .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-xs .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-xs#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-xs#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-xs #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-xs .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-xs .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-sm#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-sm#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-sm #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-sm .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-sm .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-sm#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-sm#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-sm #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-sm .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-sm .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-base#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-base#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-base #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-base .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-base .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-base#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-base#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-base #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-base .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-base .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-lg#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-lg#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-lg #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-lg .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-lg .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-lg#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-lg#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-lg #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-lg .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-lg .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-xl .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-xl .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-xl .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-xl .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-2xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-2xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-2xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-2xl .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-2xl .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-2xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-2xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-2xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-2xl .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-2xl .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-3xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-3xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-3xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-3xl .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-3xl .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-3xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-3xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-3xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-3xl .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-3xl .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-4xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-4xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-4xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-4xl .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-4xl .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-4xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-4xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-4xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-4xl .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-4xl .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-5xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-5xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-5xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-5xl .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-5xl .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-5xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-5xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-5xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-5xl .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-5xl .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-6xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-6xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-6xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-6xl .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-6xl .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-6xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-6xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-6xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-6xl .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-6xl .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-7xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-7xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-7xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-7xl .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-7xl .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-7xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-7xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-7xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-7xl .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-7xl .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-8xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-8xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-8xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-8xl .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-8xl .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-8xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-8xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-8xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-8xl .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-8xl .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-9xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-9xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-9xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-9xl .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-9xl .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-9xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-9xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-9xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-9xl .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-9xl .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-1xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-1xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-1xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-1xl .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-1xl .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-1xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-1xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-1xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-1xl .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-1xl .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.text-3.3xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-3.3xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .font-serif .text-3.3xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-3.3xl .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before, .text-3.3xl .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.text-3.3xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-3.3xl#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .font-serif .text-3.3xl #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-3.3xl .font-serif#yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after, .text-3.3xl .font-serif #yotpo-reviews .yotpo-reviewer-details-verified > *.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
#yotpo-reviews .yotpo-reviewer-details-verified :first-child {
  font-weight: 600;
}
#yotpo-reviews .yotpo-reviewer-details-verified :last-child {
  align-items: flex-end;
  font-style: italic;
}
#yotpo-reviews .yotpo-review-rating-title {
  margin-bottom: 0.5rem;
  flex-direction: column;
  gap: 0.5rem;
}
#yotpo-reviews-main-widget.yotpo-display-s .yotpo-review-star-rating {
  margin-bottom: 0.5rem;
}
#yotpo-reviews .yotpo-review-title {
  margin-left: 0px;
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 600;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-3.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title.leading-3.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title .leading-3.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans.leading-3.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.043em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-3.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title.leading-3.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title .leading-3.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans.leading-3.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans .leading-3.capsize::after {
  content: '';
  margin-top: 0.087em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-4.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title.leading-4.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title .leading-4.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans.leading-4.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans .leading-4.capsize::before {
  content: '';
  margin-bottom: -0.057em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-4.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title.leading-4.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title .leading-4.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans.leading-4.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans .leading-4.capsize::after {
  content: '';
  margin-top: -0.013em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-5.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title.leading-5.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title .leading-5.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans.leading-5.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans .leading-5.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-5.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title.leading-5.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title .leading-5.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans.leading-5.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans .leading-5.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-6.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title.leading-6.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title .leading-6.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans.leading-6.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.257em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-6.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title.leading-6.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title .leading-6.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans.leading-6.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans .leading-6.capsize::after {
  content: '';
  margin-top: -0.213em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-7.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title.leading-7.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title .leading-7.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans.leading-7.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.357em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-7.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title.leading-7.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title .leading-7.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans.leading-7.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans .leading-7.capsize::after {
  content: '';
  margin-top: -0.313em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-8.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title.leading-8.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title .leading-8.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans.leading-8.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.457em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-8.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title.leading-8.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title .leading-8.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans.leading-8.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans .leading-8.capsize::after {
  content: '';
  margin-top: -0.413em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-9.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title.leading-9.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title .leading-9.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans.leading-9.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.557em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-9.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title.leading-9.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title .leading-9.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans.leading-9.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans .leading-9.capsize::after {
  content: '';
  margin-top: -0.513em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-10.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title.leading-10.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title .leading-10.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans.leading-10.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-10.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title.leading-10.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title .leading-10.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans.leading-10.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans .leading-10.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-none.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title.leading-none.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title .leading-none.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans.leading-none.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-none.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title.leading-none.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title .leading-none.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans.leading-none.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans .leading-none.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-tight.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title.leading-tight.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title .leading-tight.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans.leading-tight.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.282em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-tight.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title.leading-tight.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title .leading-tight.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans.leading-tight.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans .leading-tight.capsize::after {
  content: '';
  margin-top: -0.238em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-snug.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title.leading-snug.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title .leading-snug.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans.leading-snug.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3445em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-snug.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title.leading-snug.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title .leading-snug.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans.leading-snug.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans .leading-snug.capsize::after {
  content: '';
  margin-top: -0.3005em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-normal.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title.leading-normal.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title .leading-normal.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans.leading-normal.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.407em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-normal.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title.leading-normal.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title .leading-normal.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans.leading-normal.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans .leading-normal.capsize::after {
  content: '';
  margin-top: -0.363em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-relaxed.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title.leading-relaxed.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title .leading-relaxed.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans.leading-relaxed.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4695em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-relaxed.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title.leading-relaxed.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title .leading-relaxed.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans.leading-relaxed.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4255em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-loose.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title.leading-loose.capsize::before, .font-sans #yotpo-reviews .yotpo-review-title .leading-loose.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans.leading-loose.capsize::before,#yotpo-reviews .yotpo-review-title .font-sans .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-review-title.leading-loose.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title.leading-loose.capsize::after, .font-sans #yotpo-reviews .yotpo-review-title .leading-loose.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans.leading-loose.capsize::after,#yotpo-reviews .yotpo-review-title .font-sans .leading-loose.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-3.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title.leading-3.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title .leading-3.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif.leading-3.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.08em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-3.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title.leading-3.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title .leading-3.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif.leading-3.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif .leading-3.capsize::after {
  content: '';
  margin-top: 0.1em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-4.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title.leading-4.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title .leading-4.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif.leading-4.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif .leading-4.capsize::before {
  content: '';
  margin-bottom: -0.02em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-4.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title.leading-4.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title .leading-4.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif.leading-4.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif .leading-4.capsize::after {
  content: '';
  margin-top: 0em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-5.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title.leading-5.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title .leading-5.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif.leading-5.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif .leading-5.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-5.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title.leading-5.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title .leading-5.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif.leading-5.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif .leading-5.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-6.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title.leading-6.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title .leading-6.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif.leading-6.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.22em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-6.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title.leading-6.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title .leading-6.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif.leading-6.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif .leading-6.capsize::after {
  content: '';
  margin-top: -0.2em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-7.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title.leading-7.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title .leading-7.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif.leading-7.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.32em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-7.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title.leading-7.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title .leading-7.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif.leading-7.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif .leading-7.capsize::after {
  content: '';
  margin-top: -0.3em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-8.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title.leading-8.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title .leading-8.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif.leading-8.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.42em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-8.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title.leading-8.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title .leading-8.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif.leading-8.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif .leading-8.capsize::after {
  content: '';
  margin-top: -0.4em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-9.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title.leading-9.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title .leading-9.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif.leading-9.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.52em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-9.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title.leading-9.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title .leading-9.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif.leading-9.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif .leading-9.capsize::after {
  content: '';
  margin-top: -0.5em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-10.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title.leading-10.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title .leading-10.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif.leading-10.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-10.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title.leading-10.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title .leading-10.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif.leading-10.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif .leading-10.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-none.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title.leading-none.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title .leading-none.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif.leading-none.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-none.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title.leading-none.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title .leading-none.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif.leading-none.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif .leading-none.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-tight.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title.leading-tight.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title .leading-tight.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif.leading-tight.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.245em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-tight.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title.leading-tight.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title .leading-tight.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif.leading-tight.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif .leading-tight.capsize::after {
  content: '';
  margin-top: -0.225em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-snug.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title.leading-snug.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title .leading-snug.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif.leading-snug.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3075em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-snug.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title.leading-snug.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title .leading-snug.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif.leading-snug.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif .leading-snug.capsize::after {
  content: '';
  margin-top: -0.2875em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-normal.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title.leading-normal.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title .leading-normal.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif.leading-normal.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.37em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-normal.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title.leading-normal.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title .leading-normal.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif.leading-normal.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif .leading-normal.capsize::after {
  content: '';
  margin-top: -0.35em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-relaxed.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title.leading-relaxed.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title .leading-relaxed.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif.leading-relaxed.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4325em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-relaxed.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title.leading-relaxed.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title .leading-relaxed.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif.leading-relaxed.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4125em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-loose.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title.leading-loose.capsize::before, .font-serif #yotpo-reviews .yotpo-review-title .leading-loose.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif.leading-loose.capsize::before,#yotpo-reviews .yotpo-review-title .font-serif .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-review-title.leading-loose.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title.leading-loose.capsize::after, .font-serif #yotpo-reviews .yotpo-review-title .leading-loose.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif.leading-loose.capsize::after,#yotpo-reviews .yotpo-review-title .font-serif .leading-loose.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
#yotpo-reviews .yotpo-read-more {
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 600;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-3.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more.leading-3.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more .leading-3.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans.leading-3.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans .leading-3.capsize::before {
  content: '';
  margin-bottom: -0.032em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-3.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more.leading-3.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more .leading-3.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans.leading-3.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans .leading-3.capsize::after {
  content: '';
  margin-top: 0.012em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-4.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more.leading-4.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more .leading-4.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans.leading-4.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans .leading-4.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-4.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more.leading-4.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more .leading-4.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans.leading-4.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans .leading-4.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-5.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more.leading-5.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more .leading-5.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans.leading-5.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans .leading-5.capsize::before {
  content: '';
  margin-bottom: -0.282em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-5.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more.leading-5.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more .leading-5.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans.leading-5.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans .leading-5.capsize::after {
  content: '';
  margin-top: -0.238em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-6.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more.leading-6.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more .leading-6.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans.leading-6.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.407em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-6.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more.leading-6.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more .leading-6.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans.leading-6.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans .leading-6.capsize::after {
  content: '';
  margin-top: -0.363em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-7.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more.leading-7.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more .leading-7.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans.leading-7.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.532em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-7.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more.leading-7.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more .leading-7.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans.leading-7.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans .leading-7.capsize::after {
  content: '';
  margin-top: -0.488em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-8.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more.leading-8.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more .leading-8.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans.leading-8.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-8.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more.leading-8.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more .leading-8.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans.leading-8.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans .leading-8.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-9.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more.leading-9.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more .leading-9.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans.leading-9.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.782em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-9.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more.leading-9.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more .leading-9.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans.leading-9.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans .leading-9.capsize::after {
  content: '';
  margin-top: -0.738em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-10.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more.leading-10.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more .leading-10.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans.leading-10.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.907em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-10.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more.leading-10.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more .leading-10.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans.leading-10.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans .leading-10.capsize::after {
  content: '';
  margin-top: -0.863em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-none.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more.leading-none.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more .leading-none.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans.leading-none.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-none.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more.leading-none.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more .leading-none.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans.leading-none.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans .leading-none.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-tight.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more.leading-tight.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more .leading-tight.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans.leading-tight.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.282em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-tight.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more.leading-tight.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more .leading-tight.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans.leading-tight.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans .leading-tight.capsize::after {
  content: '';
  margin-top: -0.238em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-snug.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more.leading-snug.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more .leading-snug.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans.leading-snug.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3445em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-snug.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more.leading-snug.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more .leading-snug.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans.leading-snug.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans .leading-snug.capsize::after {
  content: '';
  margin-top: -0.3005em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-normal.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more.leading-normal.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more .leading-normal.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans.leading-normal.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.407em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-normal.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more.leading-normal.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more .leading-normal.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans.leading-normal.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans .leading-normal.capsize::after {
  content: '';
  margin-top: -0.363em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-relaxed.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more.leading-relaxed.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more .leading-relaxed.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans.leading-relaxed.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4695em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-relaxed.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more.leading-relaxed.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more .leading-relaxed.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans.leading-relaxed.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4255em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-loose.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more.leading-loose.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more .leading-loose.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans.leading-loose.capsize::before,#yotpo-reviews .yotpo-read-more .font-sans .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans#yotpo-reviews .yotpo-read-more.leading-loose.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more.leading-loose.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more .leading-loose.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans.leading-loose.capsize::after,#yotpo-reviews .yotpo-read-more .font-sans .leading-loose.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-3.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more.leading-3.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more .leading-3.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif.leading-3.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.005em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-3.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more.leading-3.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more .leading-3.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif.leading-3.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif .leading-3.capsize::after {
  content: '';
  margin-top: 0.025em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-4.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more.leading-4.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more .leading-4.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif.leading-4.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif .leading-4.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-4.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more.leading-4.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more .leading-4.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif.leading-4.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif .leading-4.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-5.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more.leading-5.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more .leading-5.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif.leading-5.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif .leading-5.capsize::before {
  content: '';
  margin-bottom: -0.245em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-5.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more.leading-5.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more .leading-5.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif.leading-5.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif .leading-5.capsize::after {
  content: '';
  margin-top: -0.225em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-6.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more.leading-6.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more .leading-6.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif.leading-6.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.37em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-6.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more.leading-6.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more .leading-6.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif.leading-6.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif .leading-6.capsize::after {
  content: '';
  margin-top: -0.35em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-7.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more.leading-7.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more .leading-7.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif.leading-7.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.495em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-7.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more.leading-7.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more .leading-7.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif.leading-7.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif .leading-7.capsize::after {
  content: '';
  margin-top: -0.475em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-8.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more.leading-8.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more .leading-8.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif.leading-8.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-8.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more.leading-8.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more .leading-8.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif.leading-8.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif .leading-8.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-9.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more.leading-9.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more .leading-9.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif.leading-9.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.745em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-9.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more.leading-9.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more .leading-9.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif.leading-9.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif .leading-9.capsize::after {
  content: '';
  margin-top: -0.725em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-10.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more.leading-10.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more .leading-10.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif.leading-10.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.87em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-10.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more.leading-10.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more .leading-10.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif.leading-10.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif .leading-10.capsize::after {
  content: '';
  margin-top: -0.85em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-none.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more.leading-none.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more .leading-none.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif.leading-none.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-none.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more.leading-none.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more .leading-none.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif.leading-none.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif .leading-none.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-tight.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more.leading-tight.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more .leading-tight.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif.leading-tight.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.245em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-tight.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more.leading-tight.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more .leading-tight.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif.leading-tight.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif .leading-tight.capsize::after {
  content: '';
  margin-top: -0.225em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-snug.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more.leading-snug.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more .leading-snug.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif.leading-snug.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3075em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-snug.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more.leading-snug.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more .leading-snug.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif.leading-snug.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif .leading-snug.capsize::after {
  content: '';
  margin-top: -0.2875em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-normal.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more.leading-normal.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more .leading-normal.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif.leading-normal.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.37em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-normal.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more.leading-normal.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more .leading-normal.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif.leading-normal.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif .leading-normal.capsize::after {
  content: '';
  margin-top: -0.35em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-relaxed.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more.leading-relaxed.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more .leading-relaxed.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif.leading-relaxed.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4325em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-relaxed.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more.leading-relaxed.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more .leading-relaxed.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif.leading-relaxed.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4125em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-loose.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more.leading-loose.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more .leading-loose.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif.leading-loose.capsize::before,#yotpo-reviews .yotpo-read-more .font-serif .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif#yotpo-reviews .yotpo-read-more.leading-loose.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more.leading-loose.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more .leading-loose.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif.leading-loose.capsize::after,#yotpo-reviews .yotpo-read-more .font-serif .leading-loose.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
#yotpo-reviews .yotpo-read-more-text {
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-3.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-3.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-3.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-3.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: -0.032em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-3.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-3.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-3.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-3.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.012em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-4.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-4.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-4.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-4.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-4.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-4.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-4.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-4.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-4.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-5.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-5.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-5.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-5.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-5.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-5.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-5.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-5.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-6.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-6.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-6.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-6.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-6.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-6.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-6.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-6.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-7.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-7.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-7.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-7.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.532em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-7.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-7.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-7.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-7.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.488em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-8.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-8.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-8.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-8.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-8.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-8.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-8.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-8.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-9.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-9.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-9.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-9.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.782em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-9.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-9.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-9.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-9.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.738em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-10.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-10.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-10.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-10.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -0.907em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-10.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-10.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-10.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-10.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-10.capsize::after {
  content: '' !important;
  margin-top: -0.863em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-none.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-none.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-none.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-none.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-none.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-none.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-none.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-none.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-tight.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-tight.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-tight.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-tight.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-tight.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-tight.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-tight.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-tight.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-snug.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-snug.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-snug.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-snug.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-snug.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-snug.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-snug.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-snug.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-normal.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-normal.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-normal.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-normal.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-normal.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-normal.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-normal.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-normal.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-relaxed.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-relaxed.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-relaxed.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-relaxed.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-relaxed.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-relaxed.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-relaxed.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-relaxed.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-loose.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-loose.capsize::before, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-loose.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-loose.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.font-sans#yotpo-reviews .yotpo-read-more-text.leading-loose.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text.leading-loose.capsize::after, .font-sans #yotpo-reviews .yotpo-read-more-text .leading-loose.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans.leading-loose.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-sans .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-3.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-3.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-3.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-3.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: 0.005em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-3.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-3.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-3.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-3.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-3.capsize::after {
  content: '' !important;
  margin-top: 0.025em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-4.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-4.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-4.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-4.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.12em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-4.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-4.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-4.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-4.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-4.capsize::after {
  content: '' !important;
  margin-top: -0.1em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-5.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-5.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-5.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-5.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.245em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-5.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-5.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-5.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-5.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.225em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-6.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-6.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-6.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-6.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.37em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-6.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-6.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-6.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-6.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.35em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-7.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-7.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-7.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-7.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.495em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-7.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-7.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-7.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-7.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.475em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-8.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-8.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-8.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-8.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.62em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-8.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-8.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-8.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-8.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.6em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-9.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-9.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-9.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-9.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.745em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-9.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-9.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-9.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-9.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.725em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-10.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-10.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-10.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-10.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -0.87em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-10.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-10.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-10.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-10.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-10.capsize::after {
  content: '' !important;
  margin-top: -0.85em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-none.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-none.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-none.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-none.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.12em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-none.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-none.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-none.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-none.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.1em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-tight.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-tight.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-tight.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-tight.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.245em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-tight.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-tight.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-tight.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-tight.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.225em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-snug.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-snug.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-snug.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-snug.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3075em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-snug.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-snug.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-snug.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-snug.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.2875em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-normal.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-normal.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-normal.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-normal.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.37em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-normal.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-normal.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-normal.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-normal.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.35em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-relaxed.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-relaxed.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-relaxed.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-relaxed.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4325em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-relaxed.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-relaxed.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-relaxed.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-relaxed.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4125em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-loose.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-loose.capsize::before, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-loose.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-loose.capsize::before,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.62em !important;
  display: table !important;
}
.font-serif#yotpo-reviews .yotpo-read-more-text.leading-loose.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text.leading-loose.capsize::after, .font-serif #yotpo-reviews .yotpo-read-more-text .leading-loose.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif.leading-loose.capsize::after,#yotpo-reviews .yotpo-read-more-text .font-serif .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.6em !important;
  display: table !important;
}
#yotpo-reviews-main-widget .yotpo-review-comment {
  position: relative;
  display: block;
  gap: 1rem;
}
#yotpo-reviews-main-widget.yotpo-display-s .yotpo-review-comment {
  margin-bottom: 1rem;
  margin-top: 0px;
}
@media not all and (min-width: 992px) {

  #yotpo-reviews-main-widget:not(.yotpo-display-s) .yotpo-review-comment {
    margin-bottom: 1rem;
  }
}
@media (min-width: 992px) {

  #yotpo-reviews-main-widget:not(.yotpo-display-s) .yotpo-review-comment {
    margin-top: 1rem;
  }
}
#yotpo-reviews .yotpo-comment-title {
  position: absolute;
  left: -0px;
  top: -0px;
  margin: 0px;
  width: 2rem;
  height: 2rem;
  overflow: hidden;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity));
  background-image: url('https://cdn.allbirds.com/image/upload/v1731638362/bird-icon.svg');
  background-size: 24px;
  background-position: center;
  background-repeat: no-repeat;
  text-indent: -24rem;
}
#yotpo-reviews .yotpo-comment-title::before {
  margin-right: 0.25rem;
  --tw-content: '-';
  content: var(--tw-content);
}
#yotpo-reviews .yotpo-comment-data {
  gap: 0.5rem;
}
#yotpo-reviews .yotpo-comment-content {
  margin-left: 2.5rem;
  max-width: 65ch;
  border-radius: 1rem;
  border-top-left-radius: 0px;
  --tw-bg-opacity: 1;
  background-color: rgb(219 232 237 / var(--tw-bg-opacity));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
/* Store Locator */
#store-locator {
  position: relative;
  height: calc(100svh - env(safe-area-inset-bottom) - 60px);
}
.mapboxgl-ctrl-top-left {
  left: 10px;
  top: 0.75rem;
  z-index: 40 !important;
  box-sizing: border-box;
  min-width: 250px;
}
@media (min-width: 768px) {

  .mapboxgl-ctrl-top-left {
    min-width: 370px;
  }
}
.mapboxgl-ctrl-top-left .mapboxgl-ctrl {
  margin: 0px;
  min-width: 100%;
  max-width: 100%;
  border-width: 2px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input {
  margin: 0px;
  height: 2rem;
  width: 100%;
  cursor: text;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background-color: transparent;
  padding-left: 1.75rem;
  padding-right: 1.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 1rem;
  line-height: 1.5rem;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-3.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-3.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-3.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-3.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-3.capsize::before {
  content: '';
  margin-bottom: -0.032em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-3.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-3.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-3.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-3.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-3.capsize::after {
  content: '';
  margin-top: 0.012em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-4.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-4.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-4.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-4.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-4.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-4.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-4.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-4.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-4.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-4.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-5.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-5.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-5.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-5.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-5.capsize::before {
  content: '';
  margin-bottom: -0.282em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-5.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-5.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-5.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-5.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-5.capsize::after {
  content: '';
  margin-top: -0.238em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-6.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-6.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-6.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-6.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.407em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-6.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-6.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-6.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-6.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-6.capsize::after {
  content: '';
  margin-top: -0.363em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-7.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-7.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-7.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-7.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.532em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-7.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-7.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-7.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-7.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-7.capsize::after {
  content: '';
  margin-top: -0.488em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-8.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-8.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-8.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-8.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-8.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-8.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-8.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-8.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-8.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-9.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-9.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-9.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-9.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.782em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-9.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-9.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-9.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-9.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-9.capsize::after {
  content: '';
  margin-top: -0.738em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-10.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-10.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-10.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-10.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.907em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-10.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-10.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-10.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-10.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-10.capsize::after {
  content: '';
  margin-top: -0.863em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-none.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-none.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-none.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-none.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.157em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-none.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-none.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-none.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-none.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-none.capsize::after {
  content: '';
  margin-top: -0.113em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-tight.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-tight.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-tight.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-tight.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.282em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-tight.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-tight.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-tight.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-tight.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-tight.capsize::after {
  content: '';
  margin-top: -0.238em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-snug.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-snug.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-snug.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-snug.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3445em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-snug.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-snug.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-snug.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-snug.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-snug.capsize::after {
  content: '';
  margin-top: -0.3005em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-normal.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-normal.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-normal.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-normal.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.407em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-normal.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-normal.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-normal.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-normal.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-normal.capsize::after {
  content: '';
  margin-top: -0.363em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-relaxed.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-relaxed.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-relaxed.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-relaxed.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4695em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-relaxed.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-relaxed.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-relaxed.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-relaxed.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4255em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-loose.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-loose.capsize::before, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-loose.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-loose.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.657em;
  display: table;
}
.font-sans.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-loose.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-loose.capsize::after, .font-sans .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-loose.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans.leading-loose.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-sans .leading-loose.capsize::after {
  content: '';
  margin-top: -0.613em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-3.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-3.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-3.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-3.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-3.capsize::before {
  content: '';
  margin-bottom: 0.005em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-3.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-3.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-3.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-3.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-3.capsize::after {
  content: '';
  margin-top: 0.025em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-4.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-4.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-4.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-4.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-4.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-4.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-4.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-4.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-4.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-4.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-5.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-5.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-5.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-5.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-5.capsize::before {
  content: '';
  margin-bottom: -0.245em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-5.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-5.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-5.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-5.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-5.capsize::after {
  content: '';
  margin-top: -0.225em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-6.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-6.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-6.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-6.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-6.capsize::before {
  content: '';
  margin-bottom: -0.37em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-6.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-6.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-6.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-6.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-6.capsize::after {
  content: '';
  margin-top: -0.35em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-7.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-7.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-7.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-7.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-7.capsize::before {
  content: '';
  margin-bottom: -0.495em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-7.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-7.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-7.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-7.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-7.capsize::after {
  content: '';
  margin-top: -0.475em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-8.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-8.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-8.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-8.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-8.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-8.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-8.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-8.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-8.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-8.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-9.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-9.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-9.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-9.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-9.capsize::before {
  content: '';
  margin-bottom: -0.745em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-9.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-9.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-9.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-9.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-9.capsize::after {
  content: '';
  margin-top: -0.725em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-10.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-10.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-10.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-10.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-10.capsize::before {
  content: '';
  margin-bottom: -0.87em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-10.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-10.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-10.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-10.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-10.capsize::after {
  content: '';
  margin-top: -0.85em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-none.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-none.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-none.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-none.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-none.capsize::before {
  content: '';
  margin-bottom: -0.12em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-none.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-none.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-none.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-none.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-none.capsize::after {
  content: '';
  margin-top: -0.1em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-tight.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-tight.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-tight.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-tight.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-tight.capsize::before {
  content: '';
  margin-bottom: -0.245em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-tight.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-tight.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-tight.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-tight.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-tight.capsize::after {
  content: '';
  margin-top: -0.225em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-snug.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-snug.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-snug.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-snug.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-snug.capsize::before {
  content: '';
  margin-bottom: -0.3075em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-snug.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-snug.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-snug.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-snug.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-snug.capsize::after {
  content: '';
  margin-top: -0.2875em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-normal.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-normal.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-normal.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-normal.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-normal.capsize::before {
  content: '';
  margin-bottom: -0.37em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-normal.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-normal.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-normal.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-normal.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-normal.capsize::after {
  content: '';
  margin-top: -0.35em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-relaxed.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-relaxed.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-relaxed.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-relaxed.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-relaxed.capsize::before {
  content: '';
  margin-bottom: -0.4325em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-relaxed.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-relaxed.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-relaxed.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-relaxed.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-relaxed.capsize::after {
  content: '';
  margin-top: -0.4125em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-loose.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-loose.capsize::before, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-loose.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-loose.capsize::before,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-loose.capsize::before {
  content: '';
  margin-bottom: -0.62em;
  display: table;
}
.font-serif.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-loose.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input.leading-loose.capsize::after, .font-serif .mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .leading-loose.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif.leading-loose.capsize::after,.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input .font-serif .leading-loose.capsize::after {
  content: '';
  margin-top: -0.6em;
  display: table;
}
.mapboxgl-ctrl-top-left .mapboxgl-ctrl-geocoder--icon-search {
  left: 5px;
  top: 7px;
  height: 1.25rem;
  width: 1.25rem;
}
.mapboxgl-ctrl-top-left .mapboxgl-ctrl-geocoder .mapboxgl-ctrl-geocoder--pin-right > * {
  right: 0.5rem;
  top: 7px;
}
.mapboxgl-ctrl-top-left .mapboxgl-ctrl-geocoder .mapboxgl-ctrl-geocoder--icon-close {
  margin: 0px;
}
.mapboxgl-ctrl-top-left .mapboxgl-ctrl-geocoder .suggestions {
  z-index: 40;
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.mapboxgl-ctrl-top-right {
  z-index: 20;
}
.mapboxgl-ctrl-bottom-left .mapboxgl-ctrl a.mapboxgl-ctrl-logo {
  display: none;
}
.splide__arrow {
  height: 2.5rem;
  width: 2.5rem;
  border-style: none !important;
  opacity: 1 !important;
}
.splide__arrow:disabled {
  display: none;
}
.splide.is-focus-in .splide__arrow:focus {
  outline-width: 1px;
  outline-offset: 1px;
  outline-color: #212121;
}
#store-locator .splide__slide {
  display: flex;
  min-height: max-content;
  flex-grow: 1;
  flex-direction: column;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
@media (min-width: 768px) {

  #store-locator .splide__slide {
    border-radius: 0px;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}
#store-locator .splide__slide.is-active {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
body.index #gladlyChat_container .minimizedChatButtonSelector {
  display: none !important;
}
@media (min-width: 992px) {

  .lg\\:container {
    width: 100%;
  }

  @media (min-width: 640px) {

    .lg\\:container {
      max-width: 640px;
    }
  }

  @media (min-width: 768px) {

    .lg\\:container {
      max-width: 768px;
    }
  }

  @media (min-width: 992px) {

    .lg\\:container {
      max-width: 992px;
    }
  }

  @media (min-width: 1280px) {

    .lg\\:container {
      max-width: 1280px;
    }
  }

  @media (min-width: 1380px) {

    .lg\\:container {
      max-width: 1380px;
    }
  }

  @media (min-width: 1920px) {

    .lg\\:container {
      max-width: 1920px;
    }
  }
}
.before\\:\\!bg-white::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\\:-bottom-8::after {
  content: var(--tw-content);
  bottom: -2rem;
}
.after\\:left-1\\/2::after {
  content: var(--tw-content);
  left: 50%;
}
.after\\:mx-1::after {
  content: var(--tw-content);
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.after\\:my-6::after {
  content: var(--tw-content);
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.after\\:block::after {
  content: var(--tw-content);
  display: block;
}
.after\\:hidden::after {
  content: var(--tw-content);
  display: none;
}
.after\\:h-0\\.5::after {
  content: var(--tw-content);
  height: 0.125rem;
}
.after\\:h-px::after {
  content: var(--tw-content);
  height: 1px;
}
.after\\:w-12::after {
  content: var(--tw-content);
  width: 3rem;
}
.after\\:w-36::after {
  content: var(--tw-content);
  width: 9rem;
}
.after\\:-translate-x-1\\/2::after {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\\:place-self-end::after {
  content: var(--tw-content);
  place-self: end;
}
.after\\:place-self-center::after {
  content: var(--tw-content);
  place-self: center;
}
.after\\:rounded-full::after {
  content: var(--tw-content);
  border-radius: 9999px;
}
.after\\:\\!bg-white::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.after\\:bg-black::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity));
}
.after\\:bg-current::after {
  content: var(--tw-content);
  background-color: currentColor;
}
.after\\:bg-white::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.after\\:opacity-20::after {
  content: var(--tw-content);
  opacity: 0.2;
}
.after\\:content-\\[\\"\\"\\]::after {
  --tw-content: "";
  content: var(--tw-content);
}
.after\\:content-\\[\\"_\\"\\]::after {
  --tw-content: " ";
  content: var(--tw-content);
}
.after\\:content-\\[\\'\\/\\'\\]::after {
  --tw-content: '/';
  content: var(--tw-content);
}
.focus-within\\:bg-black:focus-within {
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity));
}
.focus-within\\:bg-opacity-40:focus-within {
  --tw-bg-opacity: 0.4;
}
.focus-within\\:opacity-100:focus-within {
  opacity: 1;
}
.hover\\:cursor-pointer:hover {
  cursor: pointer;
}
.hover\\:border-black:hover {
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
}
.hover\\:\\!bg-white:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-black:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}
.hover\\:bg-shop-pay-hover:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(60 13 239 / var(--tw-bg-opacity));
}
.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.hover\\:text-black:hover {
  --tw-text-opacity: 1;
  color: rgb(33 33 33 / var(--tw-text-opacity));
}
.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.group\\/card:hover .group-hover\\/card\\:bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity));
}
.group\\/card:hover .group-hover\\/card\\:bg-opacity-40 {
  --tw-bg-opacity: 0.4;
}
.group\\/play-button:hover .group-hover\\/play-button\\:text-black {
  --tw-text-opacity: 1;
  color: rgb(33 33 33 / var(--tw-text-opacity));
}
.group\\/card:hover .group-hover\\/card\\:opacity-100 {
  opacity: 1;
}
.group\\/play-button:hover .group-hover\\/play-button\\:invert {
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
@media not all and (min-width: 992px) {

  .max-lg\\:mb-10 {
    margin-bottom: 2.5rem;
  }

  .max-lg\\:hidden {
    display: none;
  }
}
@media not all and (min-width: 768px) {

  .max-md\\:-mt-2 {
    margin-top: -0.5rem;
  }

  .max-md\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .max-md\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .max-md\\:pt-12 {
    padding-top: 3rem;
  }

  .max-md\\:font-medium {
    font-weight: 500;
  }
}
@media (min-width: 640px) {

  .sm\\:w-32 {
    width: 8rem;
  }

  .sm\\:w-40 {
    width: 10rem;
  }

  .sm\\:\\!min-w-\\[600px\\] {
    min-width: 600px !important;
  }

  .sm\\:min-w-32 {
    min-width: 8rem;
  }

  .sm\\:min-w-44 {
    min-width: 11rem;
  }

  .sm\\:min-w-80 {
    min-width: 20rem;
  }

  .sm\\:max-w-fit {
    max-width: -moz-fit-content;
    max-width: fit-content;
  }

  .sm\\:max-w-md {
    max-width: 28rem;
  }

  .sm\\:flex-auto {
    flex: 1 1 auto;
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:gap-6 {
    gap: 1.5rem;
  }

  .sm\\:p-12 {
    padding: 3rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:text-center {
    text-align: center;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-sm\\/none {
    font-size: 0.875rem;
    line-height: 1;
  }

  .sm\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .sm\\:text-xs.font-sans.leading-3.capsize::before, .font-sans .sm\\:text-xs.leading-3.capsize::before, .font-sans .sm\\:text-xs .leading-3.capsize::before,.sm\\:text-xs .font-sans.leading-3.capsize::before,.sm\\:text-xs .font-sans .leading-3.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-3.capsize::after, .font-sans .sm\\:text-xs.leading-3.capsize::after, .font-sans .sm\\:text-xs .leading-3.capsize::after,.sm\\:text-xs .font-sans.leading-3.capsize::after,.sm\\:text-xs .font-sans .leading-3.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-4.capsize::before, .font-sans .sm\\:text-xs.leading-4.capsize::before, .font-sans .sm\\:text-xs .leading-4.capsize::before,.sm\\:text-xs .font-sans.leading-4.capsize::before,.sm\\:text-xs .font-sans .leading-4.capsize::before {
    content: '';
    margin-bottom: -0.3237em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-4.capsize::after, .font-sans .sm\\:text-xs.leading-4.capsize::after, .font-sans .sm\\:text-xs .leading-4.capsize::after,.sm\\:text-xs .font-sans.leading-4.capsize::after,.sm\\:text-xs .font-sans .leading-4.capsize::after {
    content: '';
    margin-top: -0.2797em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-5.capsize::before, .font-sans .sm\\:text-xs.leading-5.capsize::before, .font-sans .sm\\:text-xs .leading-5.capsize::before,.sm\\:text-xs .font-sans.leading-5.capsize::before,.sm\\:text-xs .font-sans .leading-5.capsize::before {
    content: '';
    margin-bottom: -0.4903em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-5.capsize::after, .font-sans .sm\\:text-xs.leading-5.capsize::after, .font-sans .sm\\:text-xs .leading-5.capsize::after,.sm\\:text-xs .font-sans.leading-5.capsize::after,.sm\\:text-xs .font-sans .leading-5.capsize::after {
    content: '';
    margin-top: -0.4463em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-6.capsize::before, .font-sans .sm\\:text-xs.leading-6.capsize::before, .font-sans .sm\\:text-xs .leading-6.capsize::before,.sm\\:text-xs .font-sans.leading-6.capsize::before,.sm\\:text-xs .font-sans .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-6.capsize::after, .font-sans .sm\\:text-xs.leading-6.capsize::after, .font-sans .sm\\:text-xs .leading-6.capsize::after,.sm\\:text-xs .font-sans.leading-6.capsize::after,.sm\\:text-xs .font-sans .leading-6.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-7.capsize::before, .font-sans .sm\\:text-xs.leading-7.capsize::before, .font-sans .sm\\:text-xs .leading-7.capsize::before,.sm\\:text-xs .font-sans.leading-7.capsize::before,.sm\\:text-xs .font-sans .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.8237em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-7.capsize::after, .font-sans .sm\\:text-xs.leading-7.capsize::after, .font-sans .sm\\:text-xs .leading-7.capsize::after,.sm\\:text-xs .font-sans.leading-7.capsize::after,.sm\\:text-xs .font-sans .leading-7.capsize::after {
    content: '';
    margin-top: -0.7797em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-8.capsize::before, .font-sans .sm\\:text-xs.leading-8.capsize::before, .font-sans .sm\\:text-xs .leading-8.capsize::before,.sm\\:text-xs .font-sans.leading-8.capsize::before,.sm\\:text-xs .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.9903em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-8.capsize::after, .font-sans .sm\\:text-xs.leading-8.capsize::after, .font-sans .sm\\:text-xs .leading-8.capsize::after,.sm\\:text-xs .font-sans.leading-8.capsize::after,.sm\\:text-xs .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.9463em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-9.capsize::before, .font-sans .sm\\:text-xs.leading-9.capsize::before, .font-sans .sm\\:text-xs .leading-9.capsize::before,.sm\\:text-xs .font-sans.leading-9.capsize::before,.sm\\:text-xs .font-sans .leading-9.capsize::before {
    content: '';
    margin-bottom: -1.157em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-9.capsize::after, .font-sans .sm\\:text-xs.leading-9.capsize::after, .font-sans .sm\\:text-xs .leading-9.capsize::after,.sm\\:text-xs .font-sans.leading-9.capsize::after,.sm\\:text-xs .font-sans .leading-9.capsize::after {
    content: '';
    margin-top: -1.113em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-10.capsize::before, .font-sans .sm\\:text-xs.leading-10.capsize::before, .font-sans .sm\\:text-xs .leading-10.capsize::before,.sm\\:text-xs .font-sans.leading-10.capsize::before,.sm\\:text-xs .font-sans .leading-10.capsize::before {
    content: '';
    margin-bottom: -1.3237em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-10.capsize::after, .font-sans .sm\\:text-xs.leading-10.capsize::after, .font-sans .sm\\:text-xs .leading-10.capsize::after,.sm\\:text-xs .font-sans.leading-10.capsize::after,.sm\\:text-xs .font-sans .leading-10.capsize::after {
    content: '';
    margin-top: -1.2797em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-none.capsize::before, .font-sans .sm\\:text-xs.leading-none.capsize::before, .font-sans .sm\\:text-xs .leading-none.capsize::before,.sm\\:text-xs .font-sans.leading-none.capsize::before,.sm\\:text-xs .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-none.capsize::after, .font-sans .sm\\:text-xs.leading-none.capsize::after, .font-sans .sm\\:text-xs .leading-none.capsize::after,.sm\\:text-xs .font-sans.leading-none.capsize::after,.sm\\:text-xs .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-tight.capsize::before, .font-sans .sm\\:text-xs.leading-tight.capsize::before, .font-sans .sm\\:text-xs .leading-tight.capsize::before,.sm\\:text-xs .font-sans.leading-tight.capsize::before,.sm\\:text-xs .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-tight.capsize::after, .font-sans .sm\\:text-xs.leading-tight.capsize::after, .font-sans .sm\\:text-xs .leading-tight.capsize::after,.sm\\:text-xs .font-sans.leading-tight.capsize::after,.sm\\:text-xs .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-snug.capsize::before, .font-sans .sm\\:text-xs.leading-snug.capsize::before, .font-sans .sm\\:text-xs .leading-snug.capsize::before,.sm\\:text-xs .font-sans.leading-snug.capsize::before,.sm\\:text-xs .font-sans .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3445em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-snug.capsize::after, .font-sans .sm\\:text-xs.leading-snug.capsize::after, .font-sans .sm\\:text-xs .leading-snug.capsize::after,.sm\\:text-xs .font-sans.leading-snug.capsize::after,.sm\\:text-xs .font-sans .leading-snug.capsize::after {
    content: '';
    margin-top: -0.3005em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-normal.capsize::before, .font-sans .sm\\:text-xs.leading-normal.capsize::before, .font-sans .sm\\:text-xs .leading-normal.capsize::before,.sm\\:text-xs .font-sans.leading-normal.capsize::before,.sm\\:text-xs .font-sans .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-normal.capsize::after, .font-sans .sm\\:text-xs.leading-normal.capsize::after, .font-sans .sm\\:text-xs .leading-normal.capsize::after,.sm\\:text-xs .font-sans.leading-normal.capsize::after,.sm\\:text-xs .font-sans .leading-normal.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-relaxed.capsize::before, .font-sans .sm\\:text-xs.leading-relaxed.capsize::before, .font-sans .sm\\:text-xs .leading-relaxed.capsize::before,.sm\\:text-xs .font-sans.leading-relaxed.capsize::before,.sm\\:text-xs .font-sans .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4695em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-relaxed.capsize::after, .font-sans .sm\\:text-xs.leading-relaxed.capsize::after, .font-sans .sm\\:text-xs .leading-relaxed.capsize::after,.sm\\:text-xs .font-sans.leading-relaxed.capsize::after,.sm\\:text-xs .font-sans .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4255em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-loose.capsize::before, .font-sans .sm\\:text-xs.leading-loose.capsize::before, .font-sans .sm\\:text-xs .leading-loose.capsize::before,.sm\\:text-xs .font-sans.leading-loose.capsize::before,.sm\\:text-xs .font-sans .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .sm\\:text-xs.font-sans.leading-loose.capsize::after, .font-sans .sm\\:text-xs.leading-loose.capsize::after, .font-sans .sm\\:text-xs .leading-loose.capsize::after,.sm\\:text-xs .font-sans.leading-loose.capsize::after,.sm\\:text-xs .font-sans .leading-loose.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-3.capsize::before, .font-sans .sm\\:text-base.leading-3.capsize::before, .font-sans .sm\\:text-base .leading-3.capsize::before,.sm\\:text-base .font-sans.leading-3.capsize::before,.sm\\:text-base .font-sans .leading-3.capsize::before {
    content: '';
    margin-bottom: -0.032em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-3.capsize::after, .font-sans .sm\\:text-base.leading-3.capsize::after, .font-sans .sm\\:text-base .leading-3.capsize::after,.sm\\:text-base .font-sans.leading-3.capsize::after,.sm\\:text-base .font-sans .leading-3.capsize::after {
    content: '';
    margin-top: 0.012em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-4.capsize::before, .font-sans .sm\\:text-base.leading-4.capsize::before, .font-sans .sm\\:text-base .leading-4.capsize::before,.sm\\:text-base .font-sans.leading-4.capsize::before,.sm\\:text-base .font-sans .leading-4.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-4.capsize::after, .font-sans .sm\\:text-base.leading-4.capsize::after, .font-sans .sm\\:text-base .leading-4.capsize::after,.sm\\:text-base .font-sans.leading-4.capsize::after,.sm\\:text-base .font-sans .leading-4.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-5.capsize::before, .font-sans .sm\\:text-base.leading-5.capsize::before, .font-sans .sm\\:text-base .leading-5.capsize::before,.sm\\:text-base .font-sans.leading-5.capsize::before,.sm\\:text-base .font-sans .leading-5.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-5.capsize::after, .font-sans .sm\\:text-base.leading-5.capsize::after, .font-sans .sm\\:text-base .leading-5.capsize::after,.sm\\:text-base .font-sans.leading-5.capsize::after,.sm\\:text-base .font-sans .leading-5.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-6.capsize::before, .font-sans .sm\\:text-base.leading-6.capsize::before, .font-sans .sm\\:text-base .leading-6.capsize::before,.sm\\:text-base .font-sans.leading-6.capsize::before,.sm\\:text-base .font-sans .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-6.capsize::after, .font-sans .sm\\:text-base.leading-6.capsize::after, .font-sans .sm\\:text-base .leading-6.capsize::after,.sm\\:text-base .font-sans.leading-6.capsize::after,.sm\\:text-base .font-sans .leading-6.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-7.capsize::before, .font-sans .sm\\:text-base.leading-7.capsize::before, .font-sans .sm\\:text-base .leading-7.capsize::before,.sm\\:text-base .font-sans.leading-7.capsize::before,.sm\\:text-base .font-sans .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.532em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-7.capsize::after, .font-sans .sm\\:text-base.leading-7.capsize::after, .font-sans .sm\\:text-base .leading-7.capsize::after,.sm\\:text-base .font-sans.leading-7.capsize::after,.sm\\:text-base .font-sans .leading-7.capsize::after {
    content: '';
    margin-top: -0.488em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-8.capsize::before, .font-sans .sm\\:text-base.leading-8.capsize::before, .font-sans .sm\\:text-base .leading-8.capsize::before,.sm\\:text-base .font-sans.leading-8.capsize::before,.sm\\:text-base .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-8.capsize::after, .font-sans .sm\\:text-base.leading-8.capsize::after, .font-sans .sm\\:text-base .leading-8.capsize::after,.sm\\:text-base .font-sans.leading-8.capsize::after,.sm\\:text-base .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-9.capsize::before, .font-sans .sm\\:text-base.leading-9.capsize::before, .font-sans .sm\\:text-base .leading-9.capsize::before,.sm\\:text-base .font-sans.leading-9.capsize::before,.sm\\:text-base .font-sans .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.782em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-9.capsize::after, .font-sans .sm\\:text-base.leading-9.capsize::after, .font-sans .sm\\:text-base .leading-9.capsize::after,.sm\\:text-base .font-sans.leading-9.capsize::after,.sm\\:text-base .font-sans .leading-9.capsize::after {
    content: '';
    margin-top: -0.738em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-10.capsize::before, .font-sans .sm\\:text-base.leading-10.capsize::before, .font-sans .sm\\:text-base .leading-10.capsize::before,.sm\\:text-base .font-sans.leading-10.capsize::before,.sm\\:text-base .font-sans .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.907em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-10.capsize::after, .font-sans .sm\\:text-base.leading-10.capsize::after, .font-sans .sm\\:text-base .leading-10.capsize::after,.sm\\:text-base .font-sans.leading-10.capsize::after,.sm\\:text-base .font-sans .leading-10.capsize::after {
    content: '';
    margin-top: -0.863em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-none.capsize::before, .font-sans .sm\\:text-base.leading-none.capsize::before, .font-sans .sm\\:text-base .leading-none.capsize::before,.sm\\:text-base .font-sans.leading-none.capsize::before,.sm\\:text-base .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-none.capsize::after, .font-sans .sm\\:text-base.leading-none.capsize::after, .font-sans .sm\\:text-base .leading-none.capsize::after,.sm\\:text-base .font-sans.leading-none.capsize::after,.sm\\:text-base .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-tight.capsize::before, .font-sans .sm\\:text-base.leading-tight.capsize::before, .font-sans .sm\\:text-base .leading-tight.capsize::before,.sm\\:text-base .font-sans.leading-tight.capsize::before,.sm\\:text-base .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-tight.capsize::after, .font-sans .sm\\:text-base.leading-tight.capsize::after, .font-sans .sm\\:text-base .leading-tight.capsize::after,.sm\\:text-base .font-sans.leading-tight.capsize::after,.sm\\:text-base .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-snug.capsize::before, .font-sans .sm\\:text-base.leading-snug.capsize::before, .font-sans .sm\\:text-base .leading-snug.capsize::before,.sm\\:text-base .font-sans.leading-snug.capsize::before,.sm\\:text-base .font-sans .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3445em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-snug.capsize::after, .font-sans .sm\\:text-base.leading-snug.capsize::after, .font-sans .sm\\:text-base .leading-snug.capsize::after,.sm\\:text-base .font-sans.leading-snug.capsize::after,.sm\\:text-base .font-sans .leading-snug.capsize::after {
    content: '';
    margin-top: -0.3005em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-normal.capsize::before, .font-sans .sm\\:text-base.leading-normal.capsize::before, .font-sans .sm\\:text-base .leading-normal.capsize::before,.sm\\:text-base .font-sans.leading-normal.capsize::before,.sm\\:text-base .font-sans .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-normal.capsize::after, .font-sans .sm\\:text-base.leading-normal.capsize::after, .font-sans .sm\\:text-base .leading-normal.capsize::after,.sm\\:text-base .font-sans.leading-normal.capsize::after,.sm\\:text-base .font-sans .leading-normal.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-relaxed.capsize::before, .font-sans .sm\\:text-base.leading-relaxed.capsize::before, .font-sans .sm\\:text-base .leading-relaxed.capsize::before,.sm\\:text-base .font-sans.leading-relaxed.capsize::before,.sm\\:text-base .font-sans .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4695em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-relaxed.capsize::after, .font-sans .sm\\:text-base.leading-relaxed.capsize::after, .font-sans .sm\\:text-base .leading-relaxed.capsize::after,.sm\\:text-base .font-sans.leading-relaxed.capsize::after,.sm\\:text-base .font-sans .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4255em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-loose.capsize::before, .font-sans .sm\\:text-base.leading-loose.capsize::before, .font-sans .sm\\:text-base .leading-loose.capsize::before,.sm\\:text-base .font-sans.leading-loose.capsize::before,.sm\\:text-base .font-sans .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .sm\\:text-base.font-sans.leading-loose.capsize::after, .font-sans .sm\\:text-base.leading-loose.capsize::after, .font-sans .sm\\:text-base .leading-loose.capsize::after,.sm\\:text-base .font-sans.leading-loose.capsize::after,.sm\\:text-base .font-sans .leading-loose.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-3.capsize::before, .font-sans .sm\\:text-2xl.leading-3.capsize::before, .font-sans .sm\\:text-2xl .leading-3.capsize::before,.sm\\:text-2xl .font-sans.leading-3.capsize::before,.sm\\:text-2xl .font-sans .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.093em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-3.capsize::after, .font-sans .sm\\:text-2xl.leading-3.capsize::after, .font-sans .sm\\:text-2xl .leading-3.capsize::after,.sm\\:text-2xl .font-sans.leading-3.capsize::after,.sm\\:text-2xl .font-sans .leading-3.capsize::after {
    content: '';
    margin-top: 0.137em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-4.capsize::before, .font-sans .sm\\:text-2xl.leading-4.capsize::before, .font-sans .sm\\:text-2xl .leading-4.capsize::before,.sm\\:text-2xl .font-sans.leading-4.capsize::before,.sm\\:text-2xl .font-sans .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.0097em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-4.capsize::after, .font-sans .sm\\:text-2xl.leading-4.capsize::after, .font-sans .sm\\:text-2xl .leading-4.capsize::after,.sm\\:text-2xl .font-sans.leading-4.capsize::after,.sm\\:text-2xl .font-sans .leading-4.capsize::after {
    content: '';
    margin-top: 0.0537em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-5.capsize::before, .font-sans .sm\\:text-2xl.leading-5.capsize::before, .font-sans .sm\\:text-2xl .leading-5.capsize::before,.sm\\:text-2xl .font-sans.leading-5.capsize::before,.sm\\:text-2xl .font-sans .leading-5.capsize::before {
    content: '';
    margin-bottom: -0.0737em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-5.capsize::after, .font-sans .sm\\:text-2xl.leading-5.capsize::after, .font-sans .sm\\:text-2xl .leading-5.capsize::after,.sm\\:text-2xl .font-sans.leading-5.capsize::after,.sm\\:text-2xl .font-sans .leading-5.capsize::after {
    content: '';
    margin-top: -0.0297em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-6.capsize::before, .font-sans .sm\\:text-2xl.leading-6.capsize::before, .font-sans .sm\\:text-2xl .leading-6.capsize::before,.sm\\:text-2xl .font-sans.leading-6.capsize::before,.sm\\:text-2xl .font-sans .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-6.capsize::after, .font-sans .sm\\:text-2xl.leading-6.capsize::after, .font-sans .sm\\:text-2xl .leading-6.capsize::after,.sm\\:text-2xl .font-sans.leading-6.capsize::after,.sm\\:text-2xl .font-sans .leading-6.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-7.capsize::before, .font-sans .sm\\:text-2xl.leading-7.capsize::before, .font-sans .sm\\:text-2xl .leading-7.capsize::before,.sm\\:text-2xl .font-sans.leading-7.capsize::before,.sm\\:text-2xl .font-sans .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.2403em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-7.capsize::after, .font-sans .sm\\:text-2xl.leading-7.capsize::after, .font-sans .sm\\:text-2xl .leading-7.capsize::after,.sm\\:text-2xl .font-sans.leading-7.capsize::after,.sm\\:text-2xl .font-sans .leading-7.capsize::after {
    content: '';
    margin-top: -0.1963em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-8.capsize::before, .font-sans .sm\\:text-2xl.leading-8.capsize::before, .font-sans .sm\\:text-2xl .leading-8.capsize::before,.sm\\:text-2xl .font-sans.leading-8.capsize::before,.sm\\:text-2xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.3237em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-8.capsize::after, .font-sans .sm\\:text-2xl.leading-8.capsize::after, .font-sans .sm\\:text-2xl .leading-8.capsize::after,.sm\\:text-2xl .font-sans.leading-8.capsize::after,.sm\\:text-2xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.2797em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-9.capsize::before, .font-sans .sm\\:text-2xl.leading-9.capsize::before, .font-sans .sm\\:text-2xl .leading-9.capsize::before,.sm\\:text-2xl .font-sans.leading-9.capsize::before,.sm\\:text-2xl .font-sans .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-9.capsize::after, .font-sans .sm\\:text-2xl.leading-9.capsize::after, .font-sans .sm\\:text-2xl .leading-9.capsize::after,.sm\\:text-2xl .font-sans.leading-9.capsize::after,.sm\\:text-2xl .font-sans .leading-9.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-10.capsize::before, .font-sans .sm\\:text-2xl.leading-10.capsize::before, .font-sans .sm\\:text-2xl .leading-10.capsize::before,.sm\\:text-2xl .font-sans.leading-10.capsize::before,.sm\\:text-2xl .font-sans .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.4903em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-10.capsize::after, .font-sans .sm\\:text-2xl.leading-10.capsize::after, .font-sans .sm\\:text-2xl .leading-10.capsize::after,.sm\\:text-2xl .font-sans.leading-10.capsize::after,.sm\\:text-2xl .font-sans .leading-10.capsize::after {
    content: '';
    margin-top: -0.4463em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-none.capsize::before, .font-sans .sm\\:text-2xl.leading-none.capsize::before, .font-sans .sm\\:text-2xl .leading-none.capsize::before,.sm\\:text-2xl .font-sans.leading-none.capsize::before,.sm\\:text-2xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-none.capsize::after, .font-sans .sm\\:text-2xl.leading-none.capsize::after, .font-sans .sm\\:text-2xl .leading-none.capsize::after,.sm\\:text-2xl .font-sans.leading-none.capsize::after,.sm\\:text-2xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-tight.capsize::before, .font-sans .sm\\:text-2xl.leading-tight.capsize::before, .font-sans .sm\\:text-2xl .leading-tight.capsize::before,.sm\\:text-2xl .font-sans.leading-tight.capsize::before,.sm\\:text-2xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-tight.capsize::after, .font-sans .sm\\:text-2xl.leading-tight.capsize::after, .font-sans .sm\\:text-2xl .leading-tight.capsize::after,.sm\\:text-2xl .font-sans.leading-tight.capsize::after,.sm\\:text-2xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-snug.capsize::before, .font-sans .sm\\:text-2xl.leading-snug.capsize::before, .font-sans .sm\\:text-2xl .leading-snug.capsize::before,.sm\\:text-2xl .font-sans.leading-snug.capsize::before,.sm\\:text-2xl .font-sans .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3445em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-snug.capsize::after, .font-sans .sm\\:text-2xl.leading-snug.capsize::after, .font-sans .sm\\:text-2xl .leading-snug.capsize::after,.sm\\:text-2xl .font-sans.leading-snug.capsize::after,.sm\\:text-2xl .font-sans .leading-snug.capsize::after {
    content: '';
    margin-top: -0.3005em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-normal.capsize::before, .font-sans .sm\\:text-2xl.leading-normal.capsize::before, .font-sans .sm\\:text-2xl .leading-normal.capsize::before,.sm\\:text-2xl .font-sans.leading-normal.capsize::before,.sm\\:text-2xl .font-sans .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-normal.capsize::after, .font-sans .sm\\:text-2xl.leading-normal.capsize::after, .font-sans .sm\\:text-2xl .leading-normal.capsize::after,.sm\\:text-2xl .font-sans.leading-normal.capsize::after,.sm\\:text-2xl .font-sans .leading-normal.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-relaxed.capsize::before, .font-sans .sm\\:text-2xl.leading-relaxed.capsize::before, .font-sans .sm\\:text-2xl .leading-relaxed.capsize::before,.sm\\:text-2xl .font-sans.leading-relaxed.capsize::before,.sm\\:text-2xl .font-sans .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4695em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-relaxed.capsize::after, .font-sans .sm\\:text-2xl.leading-relaxed.capsize::after, .font-sans .sm\\:text-2xl .leading-relaxed.capsize::after,.sm\\:text-2xl .font-sans.leading-relaxed.capsize::after,.sm\\:text-2xl .font-sans .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4255em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-loose.capsize::before, .font-sans .sm\\:text-2xl.leading-loose.capsize::before, .font-sans .sm\\:text-2xl .leading-loose.capsize::before,.sm\\:text-2xl .font-sans.leading-loose.capsize::before,.sm\\:text-2xl .font-sans .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .sm\\:text-2xl.font-sans.leading-loose.capsize::after, .font-sans .sm\\:text-2xl.leading-loose.capsize::after, .font-sans .sm\\:text-2xl .leading-loose.capsize::after,.sm\\:text-2xl .font-sans.leading-loose.capsize::after,.sm\\:text-2xl .font-sans .leading-loose.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-3.capsize::before, .font-sans .sm\\:text-6xl.leading-3.capsize::before, .font-sans .sm\\:text-6xl .leading-3.capsize::before,.sm\\:text-6xl .font-sans.leading-3.capsize::before,.sm\\:text-6xl .font-sans .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.243em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-3.capsize::after, .font-sans .sm\\:text-6xl.leading-3.capsize::after, .font-sans .sm\\:text-6xl .leading-3.capsize::after,.sm\\:text-6xl .font-sans.leading-3.capsize::after,.sm\\:text-6xl .font-sans .leading-3.capsize::after {
    content: '';
    margin-top: 0.287em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-4.capsize::before, .font-sans .sm\\:text-6xl.leading-4.capsize::before, .font-sans .sm\\:text-6xl .leading-4.capsize::before,.sm\\:text-6xl .font-sans.leading-4.capsize::before,.sm\\:text-6xl .font-sans .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.2097em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-4.capsize::after, .font-sans .sm\\:text-6xl.leading-4.capsize::after, .font-sans .sm\\:text-6xl .leading-4.capsize::after,.sm\\:text-6xl .font-sans.leading-4.capsize::after,.sm\\:text-6xl .font-sans .leading-4.capsize::after {
    content: '';
    margin-top: 0.2537em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-5.capsize::before, .font-sans .sm\\:text-6xl.leading-5.capsize::before, .font-sans .sm\\:text-6xl .leading-5.capsize::before,.sm\\:text-6xl .font-sans.leading-5.capsize::before,.sm\\:text-6xl .font-sans .leading-5.capsize::before {
    content: '';
    margin-bottom: 0.1763em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-5.capsize::after, .font-sans .sm\\:text-6xl.leading-5.capsize::after, .font-sans .sm\\:text-6xl .leading-5.capsize::after,.sm\\:text-6xl .font-sans.leading-5.capsize::after,.sm\\:text-6xl .font-sans .leading-5.capsize::after {
    content: '';
    margin-top: 0.2203em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-6.capsize::before, .font-sans .sm\\:text-6xl.leading-6.capsize::before, .font-sans .sm\\:text-6xl .leading-6.capsize::before,.sm\\:text-6xl .font-sans.leading-6.capsize::before,.sm\\:text-6xl .font-sans .leading-6.capsize::before {
    content: '';
    margin-bottom: 0.143em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-6.capsize::after, .font-sans .sm\\:text-6xl.leading-6.capsize::after, .font-sans .sm\\:text-6xl .leading-6.capsize::after,.sm\\:text-6xl .font-sans.leading-6.capsize::after,.sm\\:text-6xl .font-sans .leading-6.capsize::after {
    content: '';
    margin-top: 0.187em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-7.capsize::before, .font-sans .sm\\:text-6xl.leading-7.capsize::before, .font-sans .sm\\:text-6xl .leading-7.capsize::before,.sm\\:text-6xl .font-sans.leading-7.capsize::before,.sm\\:text-6xl .font-sans .leading-7.capsize::before {
    content: '';
    margin-bottom: 0.1097em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-7.capsize::after, .font-sans .sm\\:text-6xl.leading-7.capsize::after, .font-sans .sm\\:text-6xl .leading-7.capsize::after,.sm\\:text-6xl .font-sans.leading-7.capsize::after,.sm\\:text-6xl .font-sans .leading-7.capsize::after {
    content: '';
    margin-top: 0.1537em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-8.capsize::before, .font-sans .sm\\:text-6xl.leading-8.capsize::before, .font-sans .sm\\:text-6xl .leading-8.capsize::before,.sm\\:text-6xl .font-sans.leading-8.capsize::before,.sm\\:text-6xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.0763em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-8.capsize::after, .font-sans .sm\\:text-6xl.leading-8.capsize::after, .font-sans .sm\\:text-6xl .leading-8.capsize::after,.sm\\:text-6xl .font-sans.leading-8.capsize::after,.sm\\:text-6xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: 0.1203em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-9.capsize::before, .font-sans .sm\\:text-6xl.leading-9.capsize::before, .font-sans .sm\\:text-6xl .leading-9.capsize::before,.sm\\:text-6xl .font-sans.leading-9.capsize::before,.sm\\:text-6xl .font-sans .leading-9.capsize::before {
    content: '';
    margin-bottom: 0.043em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-9.capsize::after, .font-sans .sm\\:text-6xl.leading-9.capsize::after, .font-sans .sm\\:text-6xl .leading-9.capsize::after,.sm\\:text-6xl .font-sans.leading-9.capsize::after,.sm\\:text-6xl .font-sans .leading-9.capsize::after {
    content: '';
    margin-top: 0.087em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-10.capsize::before, .font-sans .sm\\:text-6xl.leading-10.capsize::before, .font-sans .sm\\:text-6xl .leading-10.capsize::before,.sm\\:text-6xl .font-sans.leading-10.capsize::before,.sm\\:text-6xl .font-sans .leading-10.capsize::before {
    content: '';
    margin-bottom: 0.0097em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-10.capsize::after, .font-sans .sm\\:text-6xl.leading-10.capsize::after, .font-sans .sm\\:text-6xl .leading-10.capsize::after,.sm\\:text-6xl .font-sans.leading-10.capsize::after,.sm\\:text-6xl .font-sans .leading-10.capsize::after {
    content: '';
    margin-top: 0.0537em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-none.capsize::before, .font-sans .sm\\:text-6xl.leading-none.capsize::before, .font-sans .sm\\:text-6xl .leading-none.capsize::before,.sm\\:text-6xl .font-sans.leading-none.capsize::before,.sm\\:text-6xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-none.capsize::after, .font-sans .sm\\:text-6xl.leading-none.capsize::after, .font-sans .sm\\:text-6xl .leading-none.capsize::after,.sm\\:text-6xl .font-sans.leading-none.capsize::after,.sm\\:text-6xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-tight.capsize::before, .font-sans .sm\\:text-6xl.leading-tight.capsize::before, .font-sans .sm\\:text-6xl .leading-tight.capsize::before,.sm\\:text-6xl .font-sans.leading-tight.capsize::before,.sm\\:text-6xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-tight.capsize::after, .font-sans .sm\\:text-6xl.leading-tight.capsize::after, .font-sans .sm\\:text-6xl .leading-tight.capsize::after,.sm\\:text-6xl .font-sans.leading-tight.capsize::after,.sm\\:text-6xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-snug.capsize::before, .font-sans .sm\\:text-6xl.leading-snug.capsize::before, .font-sans .sm\\:text-6xl .leading-snug.capsize::before,.sm\\:text-6xl .font-sans.leading-snug.capsize::before,.sm\\:text-6xl .font-sans .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3445em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-snug.capsize::after, .font-sans .sm\\:text-6xl.leading-snug.capsize::after, .font-sans .sm\\:text-6xl .leading-snug.capsize::after,.sm\\:text-6xl .font-sans.leading-snug.capsize::after,.sm\\:text-6xl .font-sans .leading-snug.capsize::after {
    content: '';
    margin-top: -0.3005em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-normal.capsize::before, .font-sans .sm\\:text-6xl.leading-normal.capsize::before, .font-sans .sm\\:text-6xl .leading-normal.capsize::before,.sm\\:text-6xl .font-sans.leading-normal.capsize::before,.sm\\:text-6xl .font-sans .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-normal.capsize::after, .font-sans .sm\\:text-6xl.leading-normal.capsize::after, .font-sans .sm\\:text-6xl .leading-normal.capsize::after,.sm\\:text-6xl .font-sans.leading-normal.capsize::after,.sm\\:text-6xl .font-sans .leading-normal.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-relaxed.capsize::before, .font-sans .sm\\:text-6xl.leading-relaxed.capsize::before, .font-sans .sm\\:text-6xl .leading-relaxed.capsize::before,.sm\\:text-6xl .font-sans.leading-relaxed.capsize::before,.sm\\:text-6xl .font-sans .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4695em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-relaxed.capsize::after, .font-sans .sm\\:text-6xl.leading-relaxed.capsize::after, .font-sans .sm\\:text-6xl .leading-relaxed.capsize::after,.sm\\:text-6xl .font-sans.leading-relaxed.capsize::after,.sm\\:text-6xl .font-sans .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4255em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-loose.capsize::before, .font-sans .sm\\:text-6xl.leading-loose.capsize::before, .font-sans .sm\\:text-6xl .leading-loose.capsize::before,.sm\\:text-6xl .font-sans.leading-loose.capsize::before,.sm\\:text-6xl .font-sans .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .sm\\:text-6xl.font-sans.leading-loose.capsize::after, .font-sans .sm\\:text-6xl.leading-loose.capsize::after, .font-sans .sm\\:text-6xl .leading-loose.capsize::after,.sm\\:text-6xl .font-sans.leading-loose.capsize::after,.sm\\:text-6xl .font-sans .leading-loose.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-3.capsize::before, .font-serif .sm\\:text-xs.leading-3.capsize::before, .font-serif .sm\\:text-xs .leading-3.capsize::before,.sm\\:text-xs .font-serif.leading-3.capsize::before,.sm\\:text-xs .font-serif .leading-3.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-3.capsize::after, .font-serif .sm\\:text-xs.leading-3.capsize::after, .font-serif .sm\\:text-xs .leading-3.capsize::after,.sm\\:text-xs .font-serif.leading-3.capsize::after,.sm\\:text-xs .font-serif .leading-3.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-4.capsize::before, .font-serif .sm\\:text-xs.leading-4.capsize::before, .font-serif .sm\\:text-xs .leading-4.capsize::before,.sm\\:text-xs .font-serif.leading-4.capsize::before,.sm\\:text-xs .font-serif .leading-4.capsize::before {
    content: '';
    margin-bottom: -0.2867em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-4.capsize::after, .font-serif .sm\\:text-xs.leading-4.capsize::after, .font-serif .sm\\:text-xs .leading-4.capsize::after,.sm\\:text-xs .font-serif.leading-4.capsize::after,.sm\\:text-xs .font-serif .leading-4.capsize::after {
    content: '';
    margin-top: -0.2667em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-5.capsize::before, .font-serif .sm\\:text-xs.leading-5.capsize::before, .font-serif .sm\\:text-xs .leading-5.capsize::before,.sm\\:text-xs .font-serif.leading-5.capsize::before,.sm\\:text-xs .font-serif .leading-5.capsize::before {
    content: '';
    margin-bottom: -0.4533em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-5.capsize::after, .font-serif .sm\\:text-xs.leading-5.capsize::after, .font-serif .sm\\:text-xs .leading-5.capsize::after,.sm\\:text-xs .font-serif.leading-5.capsize::after,.sm\\:text-xs .font-serif .leading-5.capsize::after {
    content: '';
    margin-top: -0.4333em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-6.capsize::before, .font-serif .sm\\:text-xs.leading-6.capsize::before, .font-serif .sm\\:text-xs .leading-6.capsize::before,.sm\\:text-xs .font-serif.leading-6.capsize::before,.sm\\:text-xs .font-serif .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-6.capsize::after, .font-serif .sm\\:text-xs.leading-6.capsize::after, .font-serif .sm\\:text-xs .leading-6.capsize::after,.sm\\:text-xs .font-serif.leading-6.capsize::after,.sm\\:text-xs .font-serif .leading-6.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-7.capsize::before, .font-serif .sm\\:text-xs.leading-7.capsize::before, .font-serif .sm\\:text-xs .leading-7.capsize::before,.sm\\:text-xs .font-serif.leading-7.capsize::before,.sm\\:text-xs .font-serif .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.7867em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-7.capsize::after, .font-serif .sm\\:text-xs.leading-7.capsize::after, .font-serif .sm\\:text-xs .leading-7.capsize::after,.sm\\:text-xs .font-serif.leading-7.capsize::after,.sm\\:text-xs .font-serif .leading-7.capsize::after {
    content: '';
    margin-top: -0.7667em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-8.capsize::before, .font-serif .sm\\:text-xs.leading-8.capsize::before, .font-serif .sm\\:text-xs .leading-8.capsize::before,.sm\\:text-xs .font-serif.leading-8.capsize::before,.sm\\:text-xs .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.9533em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-8.capsize::after, .font-serif .sm\\:text-xs.leading-8.capsize::after, .font-serif .sm\\:text-xs .leading-8.capsize::after,.sm\\:text-xs .font-serif.leading-8.capsize::after,.sm\\:text-xs .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.9333em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-9.capsize::before, .font-serif .sm\\:text-xs.leading-9.capsize::before, .font-serif .sm\\:text-xs .leading-9.capsize::before,.sm\\:text-xs .font-serif.leading-9.capsize::before,.sm\\:text-xs .font-serif .leading-9.capsize::before {
    content: '';
    margin-bottom: -1.12em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-9.capsize::after, .font-serif .sm\\:text-xs.leading-9.capsize::after, .font-serif .sm\\:text-xs .leading-9.capsize::after,.sm\\:text-xs .font-serif.leading-9.capsize::after,.sm\\:text-xs .font-serif .leading-9.capsize::after {
    content: '';
    margin-top: -1.1em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-10.capsize::before, .font-serif .sm\\:text-xs.leading-10.capsize::before, .font-serif .sm\\:text-xs .leading-10.capsize::before,.sm\\:text-xs .font-serif.leading-10.capsize::before,.sm\\:text-xs .font-serif .leading-10.capsize::before {
    content: '';
    margin-bottom: -1.2867em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-10.capsize::after, .font-serif .sm\\:text-xs.leading-10.capsize::after, .font-serif .sm\\:text-xs .leading-10.capsize::after,.sm\\:text-xs .font-serif.leading-10.capsize::after,.sm\\:text-xs .font-serif .leading-10.capsize::after {
    content: '';
    margin-top: -1.2667em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-none.capsize::before, .font-serif .sm\\:text-xs.leading-none.capsize::before, .font-serif .sm\\:text-xs .leading-none.capsize::before,.sm\\:text-xs .font-serif.leading-none.capsize::before,.sm\\:text-xs .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-none.capsize::after, .font-serif .sm\\:text-xs.leading-none.capsize::after, .font-serif .sm\\:text-xs .leading-none.capsize::after,.sm\\:text-xs .font-serif.leading-none.capsize::after,.sm\\:text-xs .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-tight.capsize::before, .font-serif .sm\\:text-xs.leading-tight.capsize::before, .font-serif .sm\\:text-xs .leading-tight.capsize::before,.sm\\:text-xs .font-serif.leading-tight.capsize::before,.sm\\:text-xs .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-tight.capsize::after, .font-serif .sm\\:text-xs.leading-tight.capsize::after, .font-serif .sm\\:text-xs .leading-tight.capsize::after,.sm\\:text-xs .font-serif.leading-tight.capsize::after,.sm\\:text-xs .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-snug.capsize::before, .font-serif .sm\\:text-xs.leading-snug.capsize::before, .font-serif .sm\\:text-xs .leading-snug.capsize::before,.sm\\:text-xs .font-serif.leading-snug.capsize::before,.sm\\:text-xs .font-serif .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3075em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-snug.capsize::after, .font-serif .sm\\:text-xs.leading-snug.capsize::after, .font-serif .sm\\:text-xs .leading-snug.capsize::after,.sm\\:text-xs .font-serif.leading-snug.capsize::after,.sm\\:text-xs .font-serif .leading-snug.capsize::after {
    content: '';
    margin-top: -0.2875em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-normal.capsize::before, .font-serif .sm\\:text-xs.leading-normal.capsize::before, .font-serif .sm\\:text-xs .leading-normal.capsize::before,.sm\\:text-xs .font-serif.leading-normal.capsize::before,.sm\\:text-xs .font-serif .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-normal.capsize::after, .font-serif .sm\\:text-xs.leading-normal.capsize::after, .font-serif .sm\\:text-xs .leading-normal.capsize::after,.sm\\:text-xs .font-serif.leading-normal.capsize::after,.sm\\:text-xs .font-serif .leading-normal.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-relaxed.capsize::before, .font-serif .sm\\:text-xs.leading-relaxed.capsize::before, .font-serif .sm\\:text-xs .leading-relaxed.capsize::before,.sm\\:text-xs .font-serif.leading-relaxed.capsize::before,.sm\\:text-xs .font-serif .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4325em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-relaxed.capsize::after, .font-serif .sm\\:text-xs.leading-relaxed.capsize::after, .font-serif .sm\\:text-xs .leading-relaxed.capsize::after,.sm\\:text-xs .font-serif.leading-relaxed.capsize::after,.sm\\:text-xs .font-serif .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4125em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-loose.capsize::before, .font-serif .sm\\:text-xs.leading-loose.capsize::before, .font-serif .sm\\:text-xs .leading-loose.capsize::before,.sm\\:text-xs .font-serif.leading-loose.capsize::before,.sm\\:text-xs .font-serif .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .sm\\:text-xs.font-serif.leading-loose.capsize::after, .font-serif .sm\\:text-xs.leading-loose.capsize::after, .font-serif .sm\\:text-xs .leading-loose.capsize::after,.sm\\:text-xs .font-serif.leading-loose.capsize::after,.sm\\:text-xs .font-serif .leading-loose.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-3.capsize::before, .font-serif .sm\\:text-base.leading-3.capsize::before, .font-serif .sm\\:text-base .leading-3.capsize::before,.sm\\:text-base .font-serif.leading-3.capsize::before,.sm\\:text-base .font-serif .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.005em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-3.capsize::after, .font-serif .sm\\:text-base.leading-3.capsize::after, .font-serif .sm\\:text-base .leading-3.capsize::after,.sm\\:text-base .font-serif.leading-3.capsize::after,.sm\\:text-base .font-serif .leading-3.capsize::after {
    content: '';
    margin-top: 0.025em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-4.capsize::before, .font-serif .sm\\:text-base.leading-4.capsize::before, .font-serif .sm\\:text-base .leading-4.capsize::before,.sm\\:text-base .font-serif.leading-4.capsize::before,.sm\\:text-base .font-serif .leading-4.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-4.capsize::after, .font-serif .sm\\:text-base.leading-4.capsize::after, .font-serif .sm\\:text-base .leading-4.capsize::after,.sm\\:text-base .font-serif.leading-4.capsize::after,.sm\\:text-base .font-serif .leading-4.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-5.capsize::before, .font-serif .sm\\:text-base.leading-5.capsize::before, .font-serif .sm\\:text-base .leading-5.capsize::before,.sm\\:text-base .font-serif.leading-5.capsize::before,.sm\\:text-base .font-serif .leading-5.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-5.capsize::after, .font-serif .sm\\:text-base.leading-5.capsize::after, .font-serif .sm\\:text-base .leading-5.capsize::after,.sm\\:text-base .font-serif.leading-5.capsize::after,.sm\\:text-base .font-serif .leading-5.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-6.capsize::before, .font-serif .sm\\:text-base.leading-6.capsize::before, .font-serif .sm\\:text-base .leading-6.capsize::before,.sm\\:text-base .font-serif.leading-6.capsize::before,.sm\\:text-base .font-serif .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-6.capsize::after, .font-serif .sm\\:text-base.leading-6.capsize::after, .font-serif .sm\\:text-base .leading-6.capsize::after,.sm\\:text-base .font-serif.leading-6.capsize::after,.sm\\:text-base .font-serif .leading-6.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-7.capsize::before, .font-serif .sm\\:text-base.leading-7.capsize::before, .font-serif .sm\\:text-base .leading-7.capsize::before,.sm\\:text-base .font-serif.leading-7.capsize::before,.sm\\:text-base .font-serif .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.495em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-7.capsize::after, .font-serif .sm\\:text-base.leading-7.capsize::after, .font-serif .sm\\:text-base .leading-7.capsize::after,.sm\\:text-base .font-serif.leading-7.capsize::after,.sm\\:text-base .font-serif .leading-7.capsize::after {
    content: '';
    margin-top: -0.475em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-8.capsize::before, .font-serif .sm\\:text-base.leading-8.capsize::before, .font-serif .sm\\:text-base .leading-8.capsize::before,.sm\\:text-base .font-serif.leading-8.capsize::before,.sm\\:text-base .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-8.capsize::after, .font-serif .sm\\:text-base.leading-8.capsize::after, .font-serif .sm\\:text-base .leading-8.capsize::after,.sm\\:text-base .font-serif.leading-8.capsize::after,.sm\\:text-base .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-9.capsize::before, .font-serif .sm\\:text-base.leading-9.capsize::before, .font-serif .sm\\:text-base .leading-9.capsize::before,.sm\\:text-base .font-serif.leading-9.capsize::before,.sm\\:text-base .font-serif .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.745em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-9.capsize::after, .font-serif .sm\\:text-base.leading-9.capsize::after, .font-serif .sm\\:text-base .leading-9.capsize::after,.sm\\:text-base .font-serif.leading-9.capsize::after,.sm\\:text-base .font-serif .leading-9.capsize::after {
    content: '';
    margin-top: -0.725em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-10.capsize::before, .font-serif .sm\\:text-base.leading-10.capsize::before, .font-serif .sm\\:text-base .leading-10.capsize::before,.sm\\:text-base .font-serif.leading-10.capsize::before,.sm\\:text-base .font-serif .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.87em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-10.capsize::after, .font-serif .sm\\:text-base.leading-10.capsize::after, .font-serif .sm\\:text-base .leading-10.capsize::after,.sm\\:text-base .font-serif.leading-10.capsize::after,.sm\\:text-base .font-serif .leading-10.capsize::after {
    content: '';
    margin-top: -0.85em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-none.capsize::before, .font-serif .sm\\:text-base.leading-none.capsize::before, .font-serif .sm\\:text-base .leading-none.capsize::before,.sm\\:text-base .font-serif.leading-none.capsize::before,.sm\\:text-base .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-none.capsize::after, .font-serif .sm\\:text-base.leading-none.capsize::after, .font-serif .sm\\:text-base .leading-none.capsize::after,.sm\\:text-base .font-serif.leading-none.capsize::after,.sm\\:text-base .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-tight.capsize::before, .font-serif .sm\\:text-base.leading-tight.capsize::before, .font-serif .sm\\:text-base .leading-tight.capsize::before,.sm\\:text-base .font-serif.leading-tight.capsize::before,.sm\\:text-base .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-tight.capsize::after, .font-serif .sm\\:text-base.leading-tight.capsize::after, .font-serif .sm\\:text-base .leading-tight.capsize::after,.sm\\:text-base .font-serif.leading-tight.capsize::after,.sm\\:text-base .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-snug.capsize::before, .font-serif .sm\\:text-base.leading-snug.capsize::before, .font-serif .sm\\:text-base .leading-snug.capsize::before,.sm\\:text-base .font-serif.leading-snug.capsize::before,.sm\\:text-base .font-serif .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3075em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-snug.capsize::after, .font-serif .sm\\:text-base.leading-snug.capsize::after, .font-serif .sm\\:text-base .leading-snug.capsize::after,.sm\\:text-base .font-serif.leading-snug.capsize::after,.sm\\:text-base .font-serif .leading-snug.capsize::after {
    content: '';
    margin-top: -0.2875em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-normal.capsize::before, .font-serif .sm\\:text-base.leading-normal.capsize::before, .font-serif .sm\\:text-base .leading-normal.capsize::before,.sm\\:text-base .font-serif.leading-normal.capsize::before,.sm\\:text-base .font-serif .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-normal.capsize::after, .font-serif .sm\\:text-base.leading-normal.capsize::after, .font-serif .sm\\:text-base .leading-normal.capsize::after,.sm\\:text-base .font-serif.leading-normal.capsize::after,.sm\\:text-base .font-serif .leading-normal.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-relaxed.capsize::before, .font-serif .sm\\:text-base.leading-relaxed.capsize::before, .font-serif .sm\\:text-base .leading-relaxed.capsize::before,.sm\\:text-base .font-serif.leading-relaxed.capsize::before,.sm\\:text-base .font-serif .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4325em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-relaxed.capsize::after, .font-serif .sm\\:text-base.leading-relaxed.capsize::after, .font-serif .sm\\:text-base .leading-relaxed.capsize::after,.sm\\:text-base .font-serif.leading-relaxed.capsize::after,.sm\\:text-base .font-serif .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4125em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-loose.capsize::before, .font-serif .sm\\:text-base.leading-loose.capsize::before, .font-serif .sm\\:text-base .leading-loose.capsize::before,.sm\\:text-base .font-serif.leading-loose.capsize::before,.sm\\:text-base .font-serif .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .sm\\:text-base.font-serif.leading-loose.capsize::after, .font-serif .sm\\:text-base.leading-loose.capsize::after, .font-serif .sm\\:text-base .leading-loose.capsize::after,.sm\\:text-base .font-serif.leading-loose.capsize::after,.sm\\:text-base .font-serif .leading-loose.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-3.capsize::before, .font-serif .sm\\:text-2xl.leading-3.capsize::before, .font-serif .sm\\:text-2xl .leading-3.capsize::before,.sm\\:text-2xl .font-serif.leading-3.capsize::before,.sm\\:text-2xl .font-serif .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.13em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-3.capsize::after, .font-serif .sm\\:text-2xl.leading-3.capsize::after, .font-serif .sm\\:text-2xl .leading-3.capsize::after,.sm\\:text-2xl .font-serif.leading-3.capsize::after,.sm\\:text-2xl .font-serif .leading-3.capsize::after {
    content: '';
    margin-top: 0.15em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-4.capsize::before, .font-serif .sm\\:text-2xl.leading-4.capsize::before, .font-serif .sm\\:text-2xl .leading-4.capsize::before,.sm\\:text-2xl .font-serif.leading-4.capsize::before,.sm\\:text-2xl .font-serif .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.0467em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-4.capsize::after, .font-serif .sm\\:text-2xl.leading-4.capsize::after, .font-serif .sm\\:text-2xl .leading-4.capsize::after,.sm\\:text-2xl .font-serif.leading-4.capsize::after,.sm\\:text-2xl .font-serif .leading-4.capsize::after {
    content: '';
    margin-top: 0.0667em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-5.capsize::before, .font-serif .sm\\:text-2xl.leading-5.capsize::before, .font-serif .sm\\:text-2xl .leading-5.capsize::before,.sm\\:text-2xl .font-serif.leading-5.capsize::before,.sm\\:text-2xl .font-serif .leading-5.capsize::before {
    content: '';
    margin-bottom: -0.0367em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-5.capsize::after, .font-serif .sm\\:text-2xl.leading-5.capsize::after, .font-serif .sm\\:text-2xl .leading-5.capsize::after,.sm\\:text-2xl .font-serif.leading-5.capsize::after,.sm\\:text-2xl .font-serif .leading-5.capsize::after {
    content: '';
    margin-top: -0.0167em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-6.capsize::before, .font-serif .sm\\:text-2xl.leading-6.capsize::before, .font-serif .sm\\:text-2xl .leading-6.capsize::before,.sm\\:text-2xl .font-serif.leading-6.capsize::before,.sm\\:text-2xl .font-serif .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-6.capsize::after, .font-serif .sm\\:text-2xl.leading-6.capsize::after, .font-serif .sm\\:text-2xl .leading-6.capsize::after,.sm\\:text-2xl .font-serif.leading-6.capsize::after,.sm\\:text-2xl .font-serif .leading-6.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-7.capsize::before, .font-serif .sm\\:text-2xl.leading-7.capsize::before, .font-serif .sm\\:text-2xl .leading-7.capsize::before,.sm\\:text-2xl .font-serif.leading-7.capsize::before,.sm\\:text-2xl .font-serif .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.2033em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-7.capsize::after, .font-serif .sm\\:text-2xl.leading-7.capsize::after, .font-serif .sm\\:text-2xl .leading-7.capsize::after,.sm\\:text-2xl .font-serif.leading-7.capsize::after,.sm\\:text-2xl .font-serif .leading-7.capsize::after {
    content: '';
    margin-top: -0.1833em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-8.capsize::before, .font-serif .sm\\:text-2xl.leading-8.capsize::before, .font-serif .sm\\:text-2xl .leading-8.capsize::before,.sm\\:text-2xl .font-serif.leading-8.capsize::before,.sm\\:text-2xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.2867em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-8.capsize::after, .font-serif .sm\\:text-2xl.leading-8.capsize::after, .font-serif .sm\\:text-2xl .leading-8.capsize::after,.sm\\:text-2xl .font-serif.leading-8.capsize::after,.sm\\:text-2xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.2667em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-9.capsize::before, .font-serif .sm\\:text-2xl.leading-9.capsize::before, .font-serif .sm\\:text-2xl .leading-9.capsize::before,.sm\\:text-2xl .font-serif.leading-9.capsize::before,.sm\\:text-2xl .font-serif .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-9.capsize::after, .font-serif .sm\\:text-2xl.leading-9.capsize::after, .font-serif .sm\\:text-2xl .leading-9.capsize::after,.sm\\:text-2xl .font-serif.leading-9.capsize::after,.sm\\:text-2xl .font-serif .leading-9.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-10.capsize::before, .font-serif .sm\\:text-2xl.leading-10.capsize::before, .font-serif .sm\\:text-2xl .leading-10.capsize::before,.sm\\:text-2xl .font-serif.leading-10.capsize::before,.sm\\:text-2xl .font-serif .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.4533em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-10.capsize::after, .font-serif .sm\\:text-2xl.leading-10.capsize::after, .font-serif .sm\\:text-2xl .leading-10.capsize::after,.sm\\:text-2xl .font-serif.leading-10.capsize::after,.sm\\:text-2xl .font-serif .leading-10.capsize::after {
    content: '';
    margin-top: -0.4333em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-none.capsize::before, .font-serif .sm\\:text-2xl.leading-none.capsize::before, .font-serif .sm\\:text-2xl .leading-none.capsize::before,.sm\\:text-2xl .font-serif.leading-none.capsize::before,.sm\\:text-2xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-none.capsize::after, .font-serif .sm\\:text-2xl.leading-none.capsize::after, .font-serif .sm\\:text-2xl .leading-none.capsize::after,.sm\\:text-2xl .font-serif.leading-none.capsize::after,.sm\\:text-2xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-tight.capsize::before, .font-serif .sm\\:text-2xl.leading-tight.capsize::before, .font-serif .sm\\:text-2xl .leading-tight.capsize::before,.sm\\:text-2xl .font-serif.leading-tight.capsize::before,.sm\\:text-2xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-tight.capsize::after, .font-serif .sm\\:text-2xl.leading-tight.capsize::after, .font-serif .sm\\:text-2xl .leading-tight.capsize::after,.sm\\:text-2xl .font-serif.leading-tight.capsize::after,.sm\\:text-2xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-snug.capsize::before, .font-serif .sm\\:text-2xl.leading-snug.capsize::before, .font-serif .sm\\:text-2xl .leading-snug.capsize::before,.sm\\:text-2xl .font-serif.leading-snug.capsize::before,.sm\\:text-2xl .font-serif .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3075em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-snug.capsize::after, .font-serif .sm\\:text-2xl.leading-snug.capsize::after, .font-serif .sm\\:text-2xl .leading-snug.capsize::after,.sm\\:text-2xl .font-serif.leading-snug.capsize::after,.sm\\:text-2xl .font-serif .leading-snug.capsize::after {
    content: '';
    margin-top: -0.2875em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-normal.capsize::before, .font-serif .sm\\:text-2xl.leading-normal.capsize::before, .font-serif .sm\\:text-2xl .leading-normal.capsize::before,.sm\\:text-2xl .font-serif.leading-normal.capsize::before,.sm\\:text-2xl .font-serif .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-normal.capsize::after, .font-serif .sm\\:text-2xl.leading-normal.capsize::after, .font-serif .sm\\:text-2xl .leading-normal.capsize::after,.sm\\:text-2xl .font-serif.leading-normal.capsize::after,.sm\\:text-2xl .font-serif .leading-normal.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-relaxed.capsize::before, .font-serif .sm\\:text-2xl.leading-relaxed.capsize::before, .font-serif .sm\\:text-2xl .leading-relaxed.capsize::before,.sm\\:text-2xl .font-serif.leading-relaxed.capsize::before,.sm\\:text-2xl .font-serif .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4325em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-relaxed.capsize::after, .font-serif .sm\\:text-2xl.leading-relaxed.capsize::after, .font-serif .sm\\:text-2xl .leading-relaxed.capsize::after,.sm\\:text-2xl .font-serif.leading-relaxed.capsize::after,.sm\\:text-2xl .font-serif .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4125em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-loose.capsize::before, .font-serif .sm\\:text-2xl.leading-loose.capsize::before, .font-serif .sm\\:text-2xl .leading-loose.capsize::before,.sm\\:text-2xl .font-serif.leading-loose.capsize::before,.sm\\:text-2xl .font-serif .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .sm\\:text-2xl.font-serif.leading-loose.capsize::after, .font-serif .sm\\:text-2xl.leading-loose.capsize::after, .font-serif .sm\\:text-2xl .leading-loose.capsize::after,.sm\\:text-2xl .font-serif.leading-loose.capsize::after,.sm\\:text-2xl .font-serif .leading-loose.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-3.capsize::before, .font-serif .sm\\:text-6xl.leading-3.capsize::before, .font-serif .sm\\:text-6xl .leading-3.capsize::before,.sm\\:text-6xl .font-serif.leading-3.capsize::before,.sm\\:text-6xl .font-serif .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.28em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-3.capsize::after, .font-serif .sm\\:text-6xl.leading-3.capsize::after, .font-serif .sm\\:text-6xl .leading-3.capsize::after,.sm\\:text-6xl .font-serif.leading-3.capsize::after,.sm\\:text-6xl .font-serif .leading-3.capsize::after {
    content: '';
    margin-top: 0.3em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-4.capsize::before, .font-serif .sm\\:text-6xl.leading-4.capsize::before, .font-serif .sm\\:text-6xl .leading-4.capsize::before,.sm\\:text-6xl .font-serif.leading-4.capsize::before,.sm\\:text-6xl .font-serif .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.2467em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-4.capsize::after, .font-serif .sm\\:text-6xl.leading-4.capsize::after, .font-serif .sm\\:text-6xl .leading-4.capsize::after,.sm\\:text-6xl .font-serif.leading-4.capsize::after,.sm\\:text-6xl .font-serif .leading-4.capsize::after {
    content: '';
    margin-top: 0.2667em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-5.capsize::before, .font-serif .sm\\:text-6xl.leading-5.capsize::before, .font-serif .sm\\:text-6xl .leading-5.capsize::before,.sm\\:text-6xl .font-serif.leading-5.capsize::before,.sm\\:text-6xl .font-serif .leading-5.capsize::before {
    content: '';
    margin-bottom: 0.2133em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-5.capsize::after, .font-serif .sm\\:text-6xl.leading-5.capsize::after, .font-serif .sm\\:text-6xl .leading-5.capsize::after,.sm\\:text-6xl .font-serif.leading-5.capsize::after,.sm\\:text-6xl .font-serif .leading-5.capsize::after {
    content: '';
    margin-top: 0.2333em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-6.capsize::before, .font-serif .sm\\:text-6xl.leading-6.capsize::before, .font-serif .sm\\:text-6xl .leading-6.capsize::before,.sm\\:text-6xl .font-serif.leading-6.capsize::before,.sm\\:text-6xl .font-serif .leading-6.capsize::before {
    content: '';
    margin-bottom: 0.18em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-6.capsize::after, .font-serif .sm\\:text-6xl.leading-6.capsize::after, .font-serif .sm\\:text-6xl .leading-6.capsize::after,.sm\\:text-6xl .font-serif.leading-6.capsize::after,.sm\\:text-6xl .font-serif .leading-6.capsize::after {
    content: '';
    margin-top: 0.2em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-7.capsize::before, .font-serif .sm\\:text-6xl.leading-7.capsize::before, .font-serif .sm\\:text-6xl .leading-7.capsize::before,.sm\\:text-6xl .font-serif.leading-7.capsize::before,.sm\\:text-6xl .font-serif .leading-7.capsize::before {
    content: '';
    margin-bottom: 0.1467em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-7.capsize::after, .font-serif .sm\\:text-6xl.leading-7.capsize::after, .font-serif .sm\\:text-6xl .leading-7.capsize::after,.sm\\:text-6xl .font-serif.leading-7.capsize::after,.sm\\:text-6xl .font-serif .leading-7.capsize::after {
    content: '';
    margin-top: 0.1667em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-8.capsize::before, .font-serif .sm\\:text-6xl.leading-8.capsize::before, .font-serif .sm\\:text-6xl .leading-8.capsize::before,.sm\\:text-6xl .font-serif.leading-8.capsize::before,.sm\\:text-6xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1133em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-8.capsize::after, .font-serif .sm\\:text-6xl.leading-8.capsize::after, .font-serif .sm\\:text-6xl .leading-8.capsize::after,.sm\\:text-6xl .font-serif.leading-8.capsize::after,.sm\\:text-6xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: 0.1333em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-9.capsize::before, .font-serif .sm\\:text-6xl.leading-9.capsize::before, .font-serif .sm\\:text-6xl .leading-9.capsize::before,.sm\\:text-6xl .font-serif.leading-9.capsize::before,.sm\\:text-6xl .font-serif .leading-9.capsize::before {
    content: '';
    margin-bottom: 0.08em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-9.capsize::after, .font-serif .sm\\:text-6xl.leading-9.capsize::after, .font-serif .sm\\:text-6xl .leading-9.capsize::after,.sm\\:text-6xl .font-serif.leading-9.capsize::after,.sm\\:text-6xl .font-serif .leading-9.capsize::after {
    content: '';
    margin-top: 0.1em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-10.capsize::before, .font-serif .sm\\:text-6xl.leading-10.capsize::before, .font-serif .sm\\:text-6xl .leading-10.capsize::before,.sm\\:text-6xl .font-serif.leading-10.capsize::before,.sm\\:text-6xl .font-serif .leading-10.capsize::before {
    content: '';
    margin-bottom: 0.0467em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-10.capsize::after, .font-serif .sm\\:text-6xl.leading-10.capsize::after, .font-serif .sm\\:text-6xl .leading-10.capsize::after,.sm\\:text-6xl .font-serif.leading-10.capsize::after,.sm\\:text-6xl .font-serif .leading-10.capsize::after {
    content: '';
    margin-top: 0.0667em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-none.capsize::before, .font-serif .sm\\:text-6xl.leading-none.capsize::before, .font-serif .sm\\:text-6xl .leading-none.capsize::before,.sm\\:text-6xl .font-serif.leading-none.capsize::before,.sm\\:text-6xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-none.capsize::after, .font-serif .sm\\:text-6xl.leading-none.capsize::after, .font-serif .sm\\:text-6xl .leading-none.capsize::after,.sm\\:text-6xl .font-serif.leading-none.capsize::after,.sm\\:text-6xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-tight.capsize::before, .font-serif .sm\\:text-6xl.leading-tight.capsize::before, .font-serif .sm\\:text-6xl .leading-tight.capsize::before,.sm\\:text-6xl .font-serif.leading-tight.capsize::before,.sm\\:text-6xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-tight.capsize::after, .font-serif .sm\\:text-6xl.leading-tight.capsize::after, .font-serif .sm\\:text-6xl .leading-tight.capsize::after,.sm\\:text-6xl .font-serif.leading-tight.capsize::after,.sm\\:text-6xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-snug.capsize::before, .font-serif .sm\\:text-6xl.leading-snug.capsize::before, .font-serif .sm\\:text-6xl .leading-snug.capsize::before,.sm\\:text-6xl .font-serif.leading-snug.capsize::before,.sm\\:text-6xl .font-serif .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3075em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-snug.capsize::after, .font-serif .sm\\:text-6xl.leading-snug.capsize::after, .font-serif .sm\\:text-6xl .leading-snug.capsize::after,.sm\\:text-6xl .font-serif.leading-snug.capsize::after,.sm\\:text-6xl .font-serif .leading-snug.capsize::after {
    content: '';
    margin-top: -0.2875em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-normal.capsize::before, .font-serif .sm\\:text-6xl.leading-normal.capsize::before, .font-serif .sm\\:text-6xl .leading-normal.capsize::before,.sm\\:text-6xl .font-serif.leading-normal.capsize::before,.sm\\:text-6xl .font-serif .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-normal.capsize::after, .font-serif .sm\\:text-6xl.leading-normal.capsize::after, .font-serif .sm\\:text-6xl .leading-normal.capsize::after,.sm\\:text-6xl .font-serif.leading-normal.capsize::after,.sm\\:text-6xl .font-serif .leading-normal.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-relaxed.capsize::before, .font-serif .sm\\:text-6xl.leading-relaxed.capsize::before, .font-serif .sm\\:text-6xl .leading-relaxed.capsize::before,.sm\\:text-6xl .font-serif.leading-relaxed.capsize::before,.sm\\:text-6xl .font-serif .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4325em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-relaxed.capsize::after, .font-serif .sm\\:text-6xl.leading-relaxed.capsize::after, .font-serif .sm\\:text-6xl .leading-relaxed.capsize::after,.sm\\:text-6xl .font-serif.leading-relaxed.capsize::after,.sm\\:text-6xl .font-serif .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4125em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-loose.capsize::before, .font-serif .sm\\:text-6xl.leading-loose.capsize::before, .font-serif .sm\\:text-6xl .leading-loose.capsize::before,.sm\\:text-6xl .font-serif.leading-loose.capsize::before,.sm\\:text-6xl .font-serif .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .sm\\:text-6xl.font-serif.leading-loose.capsize::after, .font-serif .sm\\:text-6xl.leading-loose.capsize::after, .font-serif .sm\\:text-6xl .leading-loose.capsize::after,.sm\\:text-6xl .font-serif.leading-loose.capsize::after,.sm\\:text-6xl .font-serif .leading-loose.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }
}
@media (min-width: 768px) {

  .md\\:static {
    position: static;
  }

  .md\\:sticky {
    position: sticky;
  }

  .md\\:inset-x-4 {
    left: 1rem;
    right: 1rem;
  }

  .md\\:bottom-0 {
    bottom: 0px;
  }

  .md\\:bottom-10 {
    bottom: 2.5rem;
  }

  .md\\:bottom-4 {
    bottom: 1rem;
  }

  .md\\:left-10 {
    left: 2.5rem;
  }

  .md\\:left-3 {
    left: 0.75rem;
  }

  .md\\:right-3 {
    right: 0.75rem;
  }

  .md\\:right-6 {
    right: 1.5rem;
  }

  .md\\:top-10 {
    top: 2.5rem;
  }

  .md\\:top-\\[56px\\] {
    top: 56px;
  }

  .md\\:m-10 {
    margin: 2.5rem;
  }

  .md\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .md\\:my-10 {
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }

  .md\\:my-20 {
    margin-top: 5rem;
    margin-bottom: 5rem;
  }

  .md\\:my-6 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .md\\:-mt-1 {
    margin-top: -0.25rem;
  }

  .md\\:mb-10 {
    margin-bottom: 2.5rem;
  }

  .md\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .md\\:mb-8 {
    margin-bottom: 2rem;
  }

  .md\\:mr-12 {
    margin-right: 3rem;
  }

  .md\\:mt-1 {
    margin-top: 0.25rem;
  }

  .md\\:mt-12 {
    margin-top: 3rem;
  }

  .md\\:mt-16 {
    margin-top: 4rem;
  }

  .md\\:mt-2 {
    margin-top: 0.5rem;
  }

  .md\\:mt-3 {
    margin-top: 0.75rem;
  }

  .md\\:mt-8 {
    margin-top: 2rem;
  }

  .md\\:block {
    display: block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:grid {
    display: grid;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:aspect-\\[1\\/\\.43\\] {
    aspect-ratio: 1/.43;
  }

  .md\\:aspect-\\[1\\/\\.57\\] {
    aspect-ratio: 1/.57;
  }

  .md\\:aspect-square {
    aspect-ratio: 1 / 1;
  }

  .md\\:w-1\\/2 {
    width: 50%;
  }

  .md\\:w-2\\/5 {
    width: 40%;
  }

  .md\\:w-3\\/5 {
    width: 60%;
  }

  .md\\:w-\\[366px\\] {
    width: 366px;
  }

  .md\\:min-w-40 {
    min-width: 10rem;
  }

  .md\\:flex-initial {
    flex: 0 1 auto;
  }

  .md\\:flex-none {
    flex: none;
  }

  .md\\:-translate-y-4 {
    --tw-translate-y: -1rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .md\\:grid-cols-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-rows-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-col {
    flex-direction: column;
  }

  .md\\:items-start {
    align-items: flex-start;
  }

  .md\\:items-end {
    align-items: flex-end;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-start {
    justify-content: flex-start;
  }

  .md\\:justify-center {
    justify-content: center;
  }

  .md\\:gap-10 {
    gap: 2.5rem;
  }

  .md\\:gap-2 {
    gap: 0.5rem;
  }

  .md\\:gap-4 {
    gap: 1rem;
  }

  .md\\:self-start {
    align-self: flex-start;
  }

  .md\\:self-end {
    align-self: flex-end;
  }

  .md\\:self-center {
    align-self: center;
  }

  .md\\:overflow-x-hidden {
    overflow-x: hidden;
  }

  .md\\:p-10 {
    padding: 2.5rem;
  }

  .md\\:p-20 {
    padding: 5rem;
  }

  .md\\:p-4 {
    padding: 1rem;
  }

  .md\\:p-\\[calc\\(1vw\\+1rem\\)\\] {
    padding: calc(1vw + 1rem);
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .md\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .md\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .md\\:pl-10 {
    padding-left: 2.5rem;
  }

  .md\\:pr-0 {
    padding-right: 0px;
  }

  .md\\:text-left {
    text-align: left;
  }

  .md\\:text-center {
    text-align: center;
  }

  .md\\:text-right {
    text-align: right;
  }

  .md\\:text-1xl {
    font-size: 1.375rem;
  }

  .md\\:text-1xl\\/7 {
    font-size: 1.375rem;
    line-height: 1.75rem;
  }

  .md\\:text-1xl\\/none {
    font-size: 1.375rem;
    line-height: 1;
  }

  .md\\:text-2xl\\/7 {
    font-size: 1.5rem;
    line-height: 1.75rem;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .md\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .md\\:text-7xl {
    font-size: 4.5rem;
    line-height: 1;
  }

  .md\\:text-\\[28px\\] {
    font-size: 28px;
  }

  .md\\:text-\\[32px\\] {
    font-size: 32px;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-sm\\/none {
    font-size: 0.875rem;
    line-height: 1;
  }

  .md\\:text-xs\\/none {
    font-size: 0.75rem;
    line-height: 1;
  }

  .md\\:leading-8 {
    line-height: 2rem;
  }

  .md\\:leading-\\[1\\.36\\] {
    line-height: 1.36;
  }

  .md\\:leading-none {
    line-height: 1;
  }

  .md\\:leading-tight {
    line-height: 1.25;
  }

  .md\\:shadow-md {
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .md\\:leading-8.font-sans.text-xs.capsize::before, .font-sans .md\\:leading-8.text-xs.capsize::before, .font-sans .text-xs .md\\:leading-8.capsize::before, .text-xs .md\\:leading-8.font-sans.capsize::before, .text-xs .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.9903em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-xs.capsize::after, .font-sans .md\\:leading-8.text-xs.capsize::after, .font-sans .text-xs .md\\:leading-8.capsize::after, .text-xs .md\\:leading-8.font-sans.capsize::after, .text-xs .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.9463em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-xs.capsize::before, .font-sans .md\\:leading-none.text-xs.capsize::before, .font-sans .text-xs .md\\:leading-none.capsize::before, .text-xs .md\\:leading-none.font-sans.capsize::before, .text-xs .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-xs.capsize::after, .font-sans .md\\:leading-none.text-xs.capsize::after, .font-sans .text-xs .md\\:leading-none.capsize::after, .text-xs .md\\:leading-none.font-sans.capsize::after, .text-xs .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-xs.capsize::before, .font-sans .md\\:leading-tight.text-xs.capsize::before, .font-sans .text-xs .md\\:leading-tight.capsize::before, .text-xs .md\\:leading-tight.font-sans.capsize::before, .text-xs .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-xs.capsize::after, .font-sans .md\\:leading-tight.text-xs.capsize::after, .font-sans .text-xs .md\\:leading-tight.capsize::after, .text-xs .md\\:leading-tight.font-sans.capsize::after, .text-xs .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-sm.capsize::before, .font-sans .md\\:leading-8.text-sm.capsize::before, .font-sans .text-sm .md\\:leading-8.capsize::before, .text-sm .md\\:leading-8.font-sans.capsize::before, .text-sm .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.7999em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-sm.capsize::after, .font-sans .md\\:leading-8.text-sm.capsize::after, .font-sans .text-sm .md\\:leading-8.capsize::after, .text-sm .md\\:leading-8.font-sans.capsize::after, .text-sm .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.7559em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-sm.capsize::before, .font-sans .md\\:leading-none.text-sm.capsize::before, .font-sans .text-sm .md\\:leading-none.capsize::before, .text-sm .md\\:leading-none.font-sans.capsize::before, .text-sm .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-sm.capsize::after, .font-sans .md\\:leading-none.text-sm.capsize::after, .font-sans .text-sm .md\\:leading-none.capsize::after, .text-sm .md\\:leading-none.font-sans.capsize::after, .text-sm .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-sm.capsize::before, .font-sans .md\\:leading-tight.text-sm.capsize::before, .font-sans .text-sm .md\\:leading-tight.capsize::before, .text-sm .md\\:leading-tight.font-sans.capsize::before, .text-sm .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-sm.capsize::after, .font-sans .md\\:leading-tight.text-sm.capsize::after, .font-sans .text-sm .md\\:leading-tight.capsize::after, .text-sm .md\\:leading-tight.font-sans.capsize::after, .text-sm .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-3.capsize::before, .font-sans .md\\:text-base.leading-3.capsize::before, .font-sans .md\\:text-base .leading-3.capsize::before,.md\\:text-base .font-sans.leading-3.capsize::before,.md\\:text-base .font-sans .leading-3.capsize::before {
    content: '';
    margin-bottom: -0.032em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-3.capsize::after, .font-sans .md\\:text-base.leading-3.capsize::after, .font-sans .md\\:text-base .leading-3.capsize::after,.md\\:text-base .font-sans.leading-3.capsize::after,.md\\:text-base .font-sans .leading-3.capsize::after {
    content: '';
    margin-top: 0.012em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-4.capsize::before, .font-sans .md\\:text-base.leading-4.capsize::before, .font-sans .md\\:text-base .leading-4.capsize::before,.md\\:text-base .font-sans.leading-4.capsize::before,.md\\:text-base .font-sans .leading-4.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-4.capsize::after, .font-sans .md\\:text-base.leading-4.capsize::after, .font-sans .md\\:text-base .leading-4.capsize::after,.md\\:text-base .font-sans.leading-4.capsize::after,.md\\:text-base .font-sans .leading-4.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-5.capsize::before, .font-sans .md\\:text-base.leading-5.capsize::before, .font-sans .md\\:text-base .leading-5.capsize::before,.md\\:text-base .font-sans.leading-5.capsize::before,.md\\:text-base .font-sans .leading-5.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-5.capsize::after, .font-sans .md\\:text-base.leading-5.capsize::after, .font-sans .md\\:text-base .leading-5.capsize::after,.md\\:text-base .font-sans.leading-5.capsize::after,.md\\:text-base .font-sans .leading-5.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-6.capsize::before, .font-sans .md\\:text-base.leading-6.capsize::before, .font-sans .md\\:text-base .leading-6.capsize::before,.md\\:text-base .font-sans.leading-6.capsize::before,.md\\:text-base .font-sans .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-6.capsize::after, .font-sans .md\\:text-base.leading-6.capsize::after, .font-sans .md\\:text-base .leading-6.capsize::after,.md\\:text-base .font-sans.leading-6.capsize::after,.md\\:text-base .font-sans .leading-6.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-7.capsize::before, .font-sans .md\\:text-base.leading-7.capsize::before, .font-sans .md\\:text-base .leading-7.capsize::before,.md\\:text-base .font-sans.leading-7.capsize::before,.md\\:text-base .font-sans .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.532em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-7.capsize::after, .font-sans .md\\:text-base.leading-7.capsize::after, .font-sans .md\\:text-base .leading-7.capsize::after,.md\\:text-base .font-sans.leading-7.capsize::after,.md\\:text-base .font-sans .leading-7.capsize::after {
    content: '';
    margin-top: -0.488em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-8.capsize::before, .font-sans .md\\:text-base.leading-8.capsize::before, .font-sans .md\\:text-base .leading-8.capsize::before,.md\\:text-base .font-sans.leading-8.capsize::before,.md\\:text-base .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-base.capsize::before, .font-sans .md\\:leading-8.text-base.capsize::before, .font-sans .text-base .md\\:leading-8.capsize::before, .text-base .md\\:leading-8.font-sans.capsize::before, .text-base .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-8.capsize::before, .font-sans .md\\:text-base.leading-8.capsize::before, .font-sans .md\\:text-base .leading-8.capsize::before,.md\\:text-base .font-sans.leading-8.capsize::before,.md\\:text-base .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-base.capsize::before, .font-sans .md\\:leading-8.text-base.capsize::before, .font-sans .text-base .md\\:leading-8.capsize::before, .text-base .md\\:leading-8.font-sans.capsize::before, .text-base .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-8.capsize::before, .font-sans .md\\:text-base.leading-8.capsize::before, .font-sans .md\\:text-base .leading-8.capsize::before,.md\\:text-base .font-sans.leading-8.capsize::before,.md\\:text-base .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-base.capsize::before, .font-sans .md\\:leading-8.text-base.capsize::before, .font-sans .text-base .md\\:leading-8.capsize::before, .text-base .md\\:leading-8.font-sans.capsize::before, .text-base .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-8.capsize::before, .font-sans .md\\:text-base.leading-8.capsize::before, .font-sans .md\\:text-base .leading-8.capsize::before,.md\\:text-base .font-sans.leading-8.capsize::before,.md\\:text-base .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-base.capsize::before, .font-sans .md\\:leading-8.text-base.capsize::before, .font-sans .text-base .md\\:leading-8.capsize::before, .text-base .md\\:leading-8.font-sans.capsize::before, .text-base .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-8.capsize::before, .font-sans .md\\:text-base.leading-8.capsize::before, .font-sans .md\\:text-base .leading-8.capsize::before,.md\\:text-base .font-sans.leading-8.capsize::before,.md\\:text-base .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-base.capsize::before, .font-sans .md\\:leading-8.text-base.capsize::before, .font-sans .text-base .md\\:leading-8.capsize::before, .text-base .md\\:leading-8.font-sans.capsize::before, .text-base .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-8.capsize::after, .font-sans .md\\:text-base.leading-8.capsize::after, .font-sans .md\\:text-base .leading-8.capsize::after,.md\\:text-base .font-sans.leading-8.capsize::after,.md\\:text-base .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-base.capsize::after, .font-sans .md\\:leading-8.text-base.capsize::after, .font-sans .text-base .md\\:leading-8.capsize::after, .text-base .md\\:leading-8.font-sans.capsize::after, .text-base .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-8.capsize::after, .font-sans .md\\:text-base.leading-8.capsize::after, .font-sans .md\\:text-base .leading-8.capsize::after,.md\\:text-base .font-sans.leading-8.capsize::after,.md\\:text-base .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-base.capsize::after, .font-sans .md\\:leading-8.text-base.capsize::after, .font-sans .text-base .md\\:leading-8.capsize::after, .text-base .md\\:leading-8.font-sans.capsize::after, .text-base .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-8.capsize::after, .font-sans .md\\:text-base.leading-8.capsize::after, .font-sans .md\\:text-base .leading-8.capsize::after,.md\\:text-base .font-sans.leading-8.capsize::after,.md\\:text-base .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-base.capsize::after, .font-sans .md\\:leading-8.text-base.capsize::after, .font-sans .text-base .md\\:leading-8.capsize::after, .text-base .md\\:leading-8.font-sans.capsize::after, .text-base .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-8.capsize::after, .font-sans .md\\:text-base.leading-8.capsize::after, .font-sans .md\\:text-base .leading-8.capsize::after,.md\\:text-base .font-sans.leading-8.capsize::after,.md\\:text-base .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-base.capsize::after, .font-sans .md\\:leading-8.text-base.capsize::after, .font-sans .text-base .md\\:leading-8.capsize::after, .text-base .md\\:leading-8.font-sans.capsize::after, .text-base .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-8.capsize::after, .font-sans .md\\:text-base.leading-8.capsize::after, .font-sans .md\\:text-base .leading-8.capsize::after,.md\\:text-base .font-sans.leading-8.capsize::after,.md\\:text-base .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-base.capsize::after, .font-sans .md\\:leading-8.text-base.capsize::after, .font-sans .text-base .md\\:leading-8.capsize::after, .text-base .md\\:leading-8.font-sans.capsize::after, .text-base .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-9.capsize::before, .font-sans .md\\:text-base.leading-9.capsize::before, .font-sans .md\\:text-base .leading-9.capsize::before,.md\\:text-base .font-sans.leading-9.capsize::before,.md\\:text-base .font-sans .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.782em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-9.capsize::after, .font-sans .md\\:text-base.leading-9.capsize::after, .font-sans .md\\:text-base .leading-9.capsize::after,.md\\:text-base .font-sans.leading-9.capsize::after,.md\\:text-base .font-sans .leading-9.capsize::after {
    content: '';
    margin-top: -0.738em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-10.capsize::before, .font-sans .md\\:text-base.leading-10.capsize::before, .font-sans .md\\:text-base .leading-10.capsize::before,.md\\:text-base .font-sans.leading-10.capsize::before,.md\\:text-base .font-sans .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.907em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-10.capsize::after, .font-sans .md\\:text-base.leading-10.capsize::after, .font-sans .md\\:text-base .leading-10.capsize::after,.md\\:text-base .font-sans.leading-10.capsize::after,.md\\:text-base .font-sans .leading-10.capsize::after {
    content: '';
    margin-top: -0.863em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-none.capsize::before, .font-sans .md\\:text-base.leading-none.capsize::before, .font-sans .md\\:text-base .leading-none.capsize::before,.md\\:text-base .font-sans.leading-none.capsize::before,.md\\:text-base .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-base.capsize::before, .font-sans .md\\:leading-none.text-base.capsize::before, .font-sans .text-base .md\\:leading-none.capsize::before, .text-base .md\\:leading-none.font-sans.capsize::before, .text-base .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-none.capsize::before, .font-sans .md\\:text-base.leading-none.capsize::before, .font-sans .md\\:text-base .leading-none.capsize::before,.md\\:text-base .font-sans.leading-none.capsize::before,.md\\:text-base .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-base.capsize::before, .font-sans .md\\:leading-none.text-base.capsize::before, .font-sans .text-base .md\\:leading-none.capsize::before, .text-base .md\\:leading-none.font-sans.capsize::before, .text-base .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-none.capsize::before, .font-sans .md\\:text-base.leading-none.capsize::before, .font-sans .md\\:text-base .leading-none.capsize::before,.md\\:text-base .font-sans.leading-none.capsize::before,.md\\:text-base .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-base.capsize::before, .font-sans .md\\:leading-none.text-base.capsize::before, .font-sans .text-base .md\\:leading-none.capsize::before, .text-base .md\\:leading-none.font-sans.capsize::before, .text-base .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-none.capsize::before, .font-sans .md\\:text-base.leading-none.capsize::before, .font-sans .md\\:text-base .leading-none.capsize::before,.md\\:text-base .font-sans.leading-none.capsize::before,.md\\:text-base .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-base.capsize::before, .font-sans .md\\:leading-none.text-base.capsize::before, .font-sans .text-base .md\\:leading-none.capsize::before, .text-base .md\\:leading-none.font-sans.capsize::before, .text-base .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-none.capsize::before, .font-sans .md\\:text-base.leading-none.capsize::before, .font-sans .md\\:text-base .leading-none.capsize::before,.md\\:text-base .font-sans.leading-none.capsize::before,.md\\:text-base .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-base.capsize::before, .font-sans .md\\:leading-none.text-base.capsize::before, .font-sans .text-base .md\\:leading-none.capsize::before, .text-base .md\\:leading-none.font-sans.capsize::before, .text-base .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-none.capsize::after, .font-sans .md\\:text-base.leading-none.capsize::after, .font-sans .md\\:text-base .leading-none.capsize::after,.md\\:text-base .font-sans.leading-none.capsize::after,.md\\:text-base .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-base.capsize::after, .font-sans .md\\:leading-none.text-base.capsize::after, .font-sans .text-base .md\\:leading-none.capsize::after, .text-base .md\\:leading-none.font-sans.capsize::after, .text-base .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-none.capsize::after, .font-sans .md\\:text-base.leading-none.capsize::after, .font-sans .md\\:text-base .leading-none.capsize::after,.md\\:text-base .font-sans.leading-none.capsize::after,.md\\:text-base .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-base.capsize::after, .font-sans .md\\:leading-none.text-base.capsize::after, .font-sans .text-base .md\\:leading-none.capsize::after, .text-base .md\\:leading-none.font-sans.capsize::after, .text-base .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-none.capsize::after, .font-sans .md\\:text-base.leading-none.capsize::after, .font-sans .md\\:text-base .leading-none.capsize::after,.md\\:text-base .font-sans.leading-none.capsize::after,.md\\:text-base .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-base.capsize::after, .font-sans .md\\:leading-none.text-base.capsize::after, .font-sans .text-base .md\\:leading-none.capsize::after, .text-base .md\\:leading-none.font-sans.capsize::after, .text-base .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-none.capsize::after, .font-sans .md\\:text-base.leading-none.capsize::after, .font-sans .md\\:text-base .leading-none.capsize::after,.md\\:text-base .font-sans.leading-none.capsize::after,.md\\:text-base .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-base.capsize::after, .font-sans .md\\:leading-none.text-base.capsize::after, .font-sans .text-base .md\\:leading-none.capsize::after, .text-base .md\\:leading-none.font-sans.capsize::after, .text-base .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-none.capsize::after, .font-sans .md\\:text-base.leading-none.capsize::after, .font-sans .md\\:text-base .leading-none.capsize::after,.md\\:text-base .font-sans.leading-none.capsize::after,.md\\:text-base .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-base.capsize::after, .font-sans .md\\:leading-none.text-base.capsize::after, .font-sans .text-base .md\\:leading-none.capsize::after, .text-base .md\\:leading-none.font-sans.capsize::after, .text-base .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-base.leading-tight.capsize::before, .font-sans .md\\:text-base .leading-tight.capsize::before,.md\\:text-base .font-sans.leading-tight.capsize::before,.md\\:text-base .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-base.capsize::before, .font-sans .md\\:leading-tight.text-base.capsize::before, .font-sans .text-base .md\\:leading-tight.capsize::before, .text-base .md\\:leading-tight.font-sans.capsize::before, .text-base .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-base.leading-tight.capsize::before, .font-sans .md\\:text-base .leading-tight.capsize::before,.md\\:text-base .font-sans.leading-tight.capsize::before,.md\\:text-base .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-base.capsize::before, .font-sans .md\\:leading-tight.text-base.capsize::before, .font-sans .text-base .md\\:leading-tight.capsize::before, .text-base .md\\:leading-tight.font-sans.capsize::before, .text-base .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-base.leading-tight.capsize::before, .font-sans .md\\:text-base .leading-tight.capsize::before,.md\\:text-base .font-sans.leading-tight.capsize::before,.md\\:text-base .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-base.capsize::before, .font-sans .md\\:leading-tight.text-base.capsize::before, .font-sans .text-base .md\\:leading-tight.capsize::before, .text-base .md\\:leading-tight.font-sans.capsize::before, .text-base .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-base.leading-tight.capsize::before, .font-sans .md\\:text-base .leading-tight.capsize::before,.md\\:text-base .font-sans.leading-tight.capsize::before,.md\\:text-base .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-base.capsize::before, .font-sans .md\\:leading-tight.text-base.capsize::before, .font-sans .text-base .md\\:leading-tight.capsize::before, .text-base .md\\:leading-tight.font-sans.capsize::before, .text-base .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-base.leading-tight.capsize::before, .font-sans .md\\:text-base .leading-tight.capsize::before,.md\\:text-base .font-sans.leading-tight.capsize::before,.md\\:text-base .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-base.capsize::before, .font-sans .md\\:leading-tight.text-base.capsize::before, .font-sans .text-base .md\\:leading-tight.capsize::before, .text-base .md\\:leading-tight.font-sans.capsize::before, .text-base .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-base.leading-tight.capsize::after, .font-sans .md\\:text-base .leading-tight.capsize::after,.md\\:text-base .font-sans.leading-tight.capsize::after,.md\\:text-base .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-base.capsize::after, .font-sans .md\\:leading-tight.text-base.capsize::after, .font-sans .text-base .md\\:leading-tight.capsize::after, .text-base .md\\:leading-tight.font-sans.capsize::after, .text-base .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-base.leading-tight.capsize::after, .font-sans .md\\:text-base .leading-tight.capsize::after,.md\\:text-base .font-sans.leading-tight.capsize::after,.md\\:text-base .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-base.capsize::after, .font-sans .md\\:leading-tight.text-base.capsize::after, .font-sans .text-base .md\\:leading-tight.capsize::after, .text-base .md\\:leading-tight.font-sans.capsize::after, .text-base .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-base.leading-tight.capsize::after, .font-sans .md\\:text-base .leading-tight.capsize::after,.md\\:text-base .font-sans.leading-tight.capsize::after,.md\\:text-base .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-base.capsize::after, .font-sans .md\\:leading-tight.text-base.capsize::after, .font-sans .text-base .md\\:leading-tight.capsize::after, .text-base .md\\:leading-tight.font-sans.capsize::after, .text-base .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-base.leading-tight.capsize::after, .font-sans .md\\:text-base .leading-tight.capsize::after,.md\\:text-base .font-sans.leading-tight.capsize::after,.md\\:text-base .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-base.capsize::after, .font-sans .md\\:leading-tight.text-base.capsize::after, .font-sans .text-base .md\\:leading-tight.capsize::after, .text-base .md\\:leading-tight.font-sans.capsize::after, .text-base .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-base.leading-tight.capsize::after, .font-sans .md\\:text-base .leading-tight.capsize::after,.md\\:text-base .font-sans.leading-tight.capsize::after,.md\\:text-base .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-base.capsize::after, .font-sans .md\\:leading-tight.text-base.capsize::after, .font-sans .text-base .md\\:leading-tight.capsize::after, .text-base .md\\:leading-tight.font-sans.capsize::after, .text-base .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-snug.capsize::before, .font-sans .md\\:text-base.leading-snug.capsize::before, .font-sans .md\\:text-base .leading-snug.capsize::before,.md\\:text-base .font-sans.leading-snug.capsize::before,.md\\:text-base .font-sans .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3445em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-snug.capsize::after, .font-sans .md\\:text-base.leading-snug.capsize::after, .font-sans .md\\:text-base .leading-snug.capsize::after,.md\\:text-base .font-sans.leading-snug.capsize::after,.md\\:text-base .font-sans .leading-snug.capsize::after {
    content: '';
    margin-top: -0.3005em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-normal.capsize::before, .font-sans .md\\:text-base.leading-normal.capsize::before, .font-sans .md\\:text-base .leading-normal.capsize::before,.md\\:text-base .font-sans.leading-normal.capsize::before,.md\\:text-base .font-sans .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-normal.capsize::after, .font-sans .md\\:text-base.leading-normal.capsize::after, .font-sans .md\\:text-base .leading-normal.capsize::after,.md\\:text-base .font-sans.leading-normal.capsize::after,.md\\:text-base .font-sans .leading-normal.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-relaxed.capsize::before, .font-sans .md\\:text-base.leading-relaxed.capsize::before, .font-sans .md\\:text-base .leading-relaxed.capsize::before,.md\\:text-base .font-sans.leading-relaxed.capsize::before,.md\\:text-base .font-sans .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4695em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-relaxed.capsize::after, .font-sans .md\\:text-base.leading-relaxed.capsize::after, .font-sans .md\\:text-base .leading-relaxed.capsize::after,.md\\:text-base .font-sans.leading-relaxed.capsize::after,.md\\:text-base .font-sans .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4255em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-loose.capsize::before, .font-sans .md\\:text-base.leading-loose.capsize::before, .font-sans .md\\:text-base .leading-loose.capsize::before,.md\\:text-base .font-sans.leading-loose.capsize::before,.md\\:text-base .font-sans .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .md\\:text-base.font-sans.leading-loose.capsize::after, .font-sans .md\\:text-base.leading-loose.capsize::after, .font-sans .md\\:text-base .leading-loose.capsize::after,.md\\:text-base .font-sans.leading-loose.capsize::after,.md\\:text-base .font-sans .leading-loose.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-3.capsize::before, .font-sans .md\\:text-lg.leading-3.capsize::before, .font-sans .md\\:text-lg .leading-3.capsize::before,.md\\:text-lg .font-sans.leading-3.capsize::before,.md\\:text-lg .font-sans .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.0097em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-3.capsize::after, .font-sans .md\\:text-lg.leading-3.capsize::after, .font-sans .md\\:text-lg .leading-3.capsize::after,.md\\:text-lg .font-sans.leading-3.capsize::after,.md\\:text-lg .font-sans .leading-3.capsize::after {
    content: '';
    margin-top: 0.0537em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-4.capsize::before, .font-sans .md\\:text-lg.leading-4.capsize::before, .font-sans .md\\:text-lg .leading-4.capsize::before,.md\\:text-lg .font-sans.leading-4.capsize::before,.md\\:text-lg .font-sans .leading-4.capsize::before {
    content: '';
    margin-bottom: -0.1014em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-4.capsize::after, .font-sans .md\\:text-lg.leading-4.capsize::after, .font-sans .md\\:text-lg .leading-4.capsize::after,.md\\:text-lg .font-sans.leading-4.capsize::after,.md\\:text-lg .font-sans .leading-4.capsize::after {
    content: '';
    margin-top: -0.0574em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-5.capsize::before, .font-sans .md\\:text-lg.leading-5.capsize::before, .font-sans .md\\:text-lg .leading-5.capsize::before,.md\\:text-lg .font-sans.leading-5.capsize::before,.md\\:text-lg .font-sans .leading-5.capsize::before {
    content: '';
    margin-bottom: -0.2126em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-5.capsize::after, .font-sans .md\\:text-lg.leading-5.capsize::after, .font-sans .md\\:text-lg .leading-5.capsize::after,.md\\:text-lg .font-sans.leading-5.capsize::after,.md\\:text-lg .font-sans .leading-5.capsize::after {
    content: '';
    margin-top: -0.1686em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-6.capsize::before, .font-sans .md\\:text-lg.leading-6.capsize::before, .font-sans .md\\:text-lg .leading-6.capsize::before,.md\\:text-lg .font-sans.leading-6.capsize::before,.md\\:text-lg .font-sans .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.3237em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-6.capsize::after, .font-sans .md\\:text-lg.leading-6.capsize::after, .font-sans .md\\:text-lg .leading-6.capsize::after,.md\\:text-lg .font-sans.leading-6.capsize::after,.md\\:text-lg .font-sans .leading-6.capsize::after {
    content: '';
    margin-top: -0.2797em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-7.capsize::before, .font-sans .md\\:text-lg.leading-7.capsize::before, .font-sans .md\\:text-lg .leading-7.capsize::before,.md\\:text-lg .font-sans.leading-7.capsize::before,.md\\:text-lg .font-sans .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.4348em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-7.capsize::after, .font-sans .md\\:text-lg.leading-7.capsize::after, .font-sans .md\\:text-lg .leading-7.capsize::after,.md\\:text-lg .font-sans.leading-7.capsize::after,.md\\:text-lg .font-sans .leading-7.capsize::after {
    content: '';
    margin-top: -0.3908em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-8.capsize::before, .font-sans .md\\:text-lg.leading-8.capsize::before, .font-sans .md\\:text-lg .leading-8.capsize::before,.md\\:text-lg .font-sans.leading-8.capsize::before,.md\\:text-lg .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.5459em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-lg.capsize::before, .font-sans .md\\:leading-8.text-lg.capsize::before, .font-sans .text-lg .md\\:leading-8.capsize::before, .text-lg .md\\:leading-8.font-sans.capsize::before, .text-lg .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.5459em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-8.capsize::before, .font-sans .md\\:text-lg.leading-8.capsize::before, .font-sans .md\\:text-lg .leading-8.capsize::before,.md\\:text-lg .font-sans.leading-8.capsize::before,.md\\:text-lg .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.5459em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-lg.capsize::before, .font-sans .md\\:leading-8.text-lg.capsize::before, .font-sans .text-lg .md\\:leading-8.capsize::before, .text-lg .md\\:leading-8.font-sans.capsize::before, .text-lg .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.5459em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-8.capsize::before, .font-sans .md\\:text-lg.leading-8.capsize::before, .font-sans .md\\:text-lg .leading-8.capsize::before,.md\\:text-lg .font-sans.leading-8.capsize::before,.md\\:text-lg .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.5459em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-lg.capsize::before, .font-sans .md\\:leading-8.text-lg.capsize::before, .font-sans .text-lg .md\\:leading-8.capsize::before, .text-lg .md\\:leading-8.font-sans.capsize::before, .text-lg .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.5459em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-8.capsize::before, .font-sans .md\\:text-lg.leading-8.capsize::before, .font-sans .md\\:text-lg .leading-8.capsize::before,.md\\:text-lg .font-sans.leading-8.capsize::before,.md\\:text-lg .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.5459em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-lg.capsize::before, .font-sans .md\\:leading-8.text-lg.capsize::before, .font-sans .text-lg .md\\:leading-8.capsize::before, .text-lg .md\\:leading-8.font-sans.capsize::before, .text-lg .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.5459em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-8.capsize::before, .font-sans .md\\:text-lg.leading-8.capsize::before, .font-sans .md\\:text-lg .leading-8.capsize::before,.md\\:text-lg .font-sans.leading-8.capsize::before,.md\\:text-lg .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.5459em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-lg.capsize::before, .font-sans .md\\:leading-8.text-lg.capsize::before, .font-sans .text-lg .md\\:leading-8.capsize::before, .text-lg .md\\:leading-8.font-sans.capsize::before, .text-lg .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.5459em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-8.capsize::after, .font-sans .md\\:text-lg.leading-8.capsize::after, .font-sans .md\\:text-lg .leading-8.capsize::after,.md\\:text-lg .font-sans.leading-8.capsize::after,.md\\:text-lg .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.5019em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-lg.capsize::after, .font-sans .md\\:leading-8.text-lg.capsize::after, .font-sans .text-lg .md\\:leading-8.capsize::after, .text-lg .md\\:leading-8.font-sans.capsize::after, .text-lg .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.5019em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-8.capsize::after, .font-sans .md\\:text-lg.leading-8.capsize::after, .font-sans .md\\:text-lg .leading-8.capsize::after,.md\\:text-lg .font-sans.leading-8.capsize::after,.md\\:text-lg .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.5019em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-lg.capsize::after, .font-sans .md\\:leading-8.text-lg.capsize::after, .font-sans .text-lg .md\\:leading-8.capsize::after, .text-lg .md\\:leading-8.font-sans.capsize::after, .text-lg .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.5019em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-8.capsize::after, .font-sans .md\\:text-lg.leading-8.capsize::after, .font-sans .md\\:text-lg .leading-8.capsize::after,.md\\:text-lg .font-sans.leading-8.capsize::after,.md\\:text-lg .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.5019em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-lg.capsize::after, .font-sans .md\\:leading-8.text-lg.capsize::after, .font-sans .text-lg .md\\:leading-8.capsize::after, .text-lg .md\\:leading-8.font-sans.capsize::after, .text-lg .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.5019em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-8.capsize::after, .font-sans .md\\:text-lg.leading-8.capsize::after, .font-sans .md\\:text-lg .leading-8.capsize::after,.md\\:text-lg .font-sans.leading-8.capsize::after,.md\\:text-lg .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.5019em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-lg.capsize::after, .font-sans .md\\:leading-8.text-lg.capsize::after, .font-sans .text-lg .md\\:leading-8.capsize::after, .text-lg .md\\:leading-8.font-sans.capsize::after, .text-lg .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.5019em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-8.capsize::after, .font-sans .md\\:text-lg.leading-8.capsize::after, .font-sans .md\\:text-lg .leading-8.capsize::after,.md\\:text-lg .font-sans.leading-8.capsize::after,.md\\:text-lg .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.5019em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-lg.capsize::after, .font-sans .md\\:leading-8.text-lg.capsize::after, .font-sans .text-lg .md\\:leading-8.capsize::after, .text-lg .md\\:leading-8.font-sans.capsize::after, .text-lg .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.5019em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-9.capsize::before, .font-sans .md\\:text-lg.leading-9.capsize::before, .font-sans .md\\:text-lg .leading-9.capsize::before,.md\\:text-lg .font-sans.leading-9.capsize::before,.md\\:text-lg .font-sans .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-9.capsize::after, .font-sans .md\\:text-lg.leading-9.capsize::after, .font-sans .md\\:text-lg .leading-9.capsize::after,.md\\:text-lg .font-sans.leading-9.capsize::after,.md\\:text-lg .font-sans .leading-9.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-10.capsize::before, .font-sans .md\\:text-lg.leading-10.capsize::before, .font-sans .md\\:text-lg .leading-10.capsize::before,.md\\:text-lg .font-sans.leading-10.capsize::before,.md\\:text-lg .font-sans .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.7681em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-10.capsize::after, .font-sans .md\\:text-lg.leading-10.capsize::after, .font-sans .md\\:text-lg .leading-10.capsize::after,.md\\:text-lg .font-sans.leading-10.capsize::after,.md\\:text-lg .font-sans .leading-10.capsize::after {
    content: '';
    margin-top: -0.7241em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-none.capsize::before, .font-sans .md\\:text-lg.leading-none.capsize::before, .font-sans .md\\:text-lg .leading-none.capsize::before,.md\\:text-lg .font-sans.leading-none.capsize::before,.md\\:text-lg .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-lg.capsize::before, .font-sans .md\\:leading-none.text-lg.capsize::before, .font-sans .text-lg .md\\:leading-none.capsize::before, .text-lg .md\\:leading-none.font-sans.capsize::before, .text-lg .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-none.capsize::before, .font-sans .md\\:text-lg.leading-none.capsize::before, .font-sans .md\\:text-lg .leading-none.capsize::before,.md\\:text-lg .font-sans.leading-none.capsize::before,.md\\:text-lg .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-lg.capsize::before, .font-sans .md\\:leading-none.text-lg.capsize::before, .font-sans .text-lg .md\\:leading-none.capsize::before, .text-lg .md\\:leading-none.font-sans.capsize::before, .text-lg .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-none.capsize::before, .font-sans .md\\:text-lg.leading-none.capsize::before, .font-sans .md\\:text-lg .leading-none.capsize::before,.md\\:text-lg .font-sans.leading-none.capsize::before,.md\\:text-lg .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-lg.capsize::before, .font-sans .md\\:leading-none.text-lg.capsize::before, .font-sans .text-lg .md\\:leading-none.capsize::before, .text-lg .md\\:leading-none.font-sans.capsize::before, .text-lg .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-none.capsize::before, .font-sans .md\\:text-lg.leading-none.capsize::before, .font-sans .md\\:text-lg .leading-none.capsize::before,.md\\:text-lg .font-sans.leading-none.capsize::before,.md\\:text-lg .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-lg.capsize::before, .font-sans .md\\:leading-none.text-lg.capsize::before, .font-sans .text-lg .md\\:leading-none.capsize::before, .text-lg .md\\:leading-none.font-sans.capsize::before, .text-lg .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-none.capsize::before, .font-sans .md\\:text-lg.leading-none.capsize::before, .font-sans .md\\:text-lg .leading-none.capsize::before,.md\\:text-lg .font-sans.leading-none.capsize::before,.md\\:text-lg .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-lg.capsize::before, .font-sans .md\\:leading-none.text-lg.capsize::before, .font-sans .text-lg .md\\:leading-none.capsize::before, .text-lg .md\\:leading-none.font-sans.capsize::before, .text-lg .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-none.capsize::after, .font-sans .md\\:text-lg.leading-none.capsize::after, .font-sans .md\\:text-lg .leading-none.capsize::after,.md\\:text-lg .font-sans.leading-none.capsize::after,.md\\:text-lg .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-lg.capsize::after, .font-sans .md\\:leading-none.text-lg.capsize::after, .font-sans .text-lg .md\\:leading-none.capsize::after, .text-lg .md\\:leading-none.font-sans.capsize::after, .text-lg .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-none.capsize::after, .font-sans .md\\:text-lg.leading-none.capsize::after, .font-sans .md\\:text-lg .leading-none.capsize::after,.md\\:text-lg .font-sans.leading-none.capsize::after,.md\\:text-lg .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-lg.capsize::after, .font-sans .md\\:leading-none.text-lg.capsize::after, .font-sans .text-lg .md\\:leading-none.capsize::after, .text-lg .md\\:leading-none.font-sans.capsize::after, .text-lg .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-none.capsize::after, .font-sans .md\\:text-lg.leading-none.capsize::after, .font-sans .md\\:text-lg .leading-none.capsize::after,.md\\:text-lg .font-sans.leading-none.capsize::after,.md\\:text-lg .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-lg.capsize::after, .font-sans .md\\:leading-none.text-lg.capsize::after, .font-sans .text-lg .md\\:leading-none.capsize::after, .text-lg .md\\:leading-none.font-sans.capsize::after, .text-lg .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-none.capsize::after, .font-sans .md\\:text-lg.leading-none.capsize::after, .font-sans .md\\:text-lg .leading-none.capsize::after,.md\\:text-lg .font-sans.leading-none.capsize::after,.md\\:text-lg .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-lg.capsize::after, .font-sans .md\\:leading-none.text-lg.capsize::after, .font-sans .text-lg .md\\:leading-none.capsize::after, .text-lg .md\\:leading-none.font-sans.capsize::after, .text-lg .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-none.capsize::after, .font-sans .md\\:text-lg.leading-none.capsize::after, .font-sans .md\\:text-lg .leading-none.capsize::after,.md\\:text-lg .font-sans.leading-none.capsize::after,.md\\:text-lg .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-lg.capsize::after, .font-sans .md\\:leading-none.text-lg.capsize::after, .font-sans .text-lg .md\\:leading-none.capsize::after, .text-lg .md\\:leading-none.font-sans.capsize::after, .text-lg .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-lg.leading-tight.capsize::before, .font-sans .md\\:text-lg .leading-tight.capsize::before,.md\\:text-lg .font-sans.leading-tight.capsize::before,.md\\:text-lg .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-lg.capsize::before, .font-sans .md\\:leading-tight.text-lg.capsize::before, .font-sans .text-lg .md\\:leading-tight.capsize::before, .text-lg .md\\:leading-tight.font-sans.capsize::before, .text-lg .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-lg.leading-tight.capsize::before, .font-sans .md\\:text-lg .leading-tight.capsize::before,.md\\:text-lg .font-sans.leading-tight.capsize::before,.md\\:text-lg .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-lg.capsize::before, .font-sans .md\\:leading-tight.text-lg.capsize::before, .font-sans .text-lg .md\\:leading-tight.capsize::before, .text-lg .md\\:leading-tight.font-sans.capsize::before, .text-lg .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-lg.leading-tight.capsize::before, .font-sans .md\\:text-lg .leading-tight.capsize::before,.md\\:text-lg .font-sans.leading-tight.capsize::before,.md\\:text-lg .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-lg.capsize::before, .font-sans .md\\:leading-tight.text-lg.capsize::before, .font-sans .text-lg .md\\:leading-tight.capsize::before, .text-lg .md\\:leading-tight.font-sans.capsize::before, .text-lg .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-lg.leading-tight.capsize::before, .font-sans .md\\:text-lg .leading-tight.capsize::before,.md\\:text-lg .font-sans.leading-tight.capsize::before,.md\\:text-lg .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-lg.capsize::before, .font-sans .md\\:leading-tight.text-lg.capsize::before, .font-sans .text-lg .md\\:leading-tight.capsize::before, .text-lg .md\\:leading-tight.font-sans.capsize::before, .text-lg .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-lg.leading-tight.capsize::before, .font-sans .md\\:text-lg .leading-tight.capsize::before,.md\\:text-lg .font-sans.leading-tight.capsize::before,.md\\:text-lg .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-lg.capsize::before, .font-sans .md\\:leading-tight.text-lg.capsize::before, .font-sans .text-lg .md\\:leading-tight.capsize::before, .text-lg .md\\:leading-tight.font-sans.capsize::before, .text-lg .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-lg.leading-tight.capsize::after, .font-sans .md\\:text-lg .leading-tight.capsize::after,.md\\:text-lg .font-sans.leading-tight.capsize::after,.md\\:text-lg .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-lg.capsize::after, .font-sans .md\\:leading-tight.text-lg.capsize::after, .font-sans .text-lg .md\\:leading-tight.capsize::after, .text-lg .md\\:leading-tight.font-sans.capsize::after, .text-lg .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-lg.leading-tight.capsize::after, .font-sans .md\\:text-lg .leading-tight.capsize::after,.md\\:text-lg .font-sans.leading-tight.capsize::after,.md\\:text-lg .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-lg.capsize::after, .font-sans .md\\:leading-tight.text-lg.capsize::after, .font-sans .text-lg .md\\:leading-tight.capsize::after, .text-lg .md\\:leading-tight.font-sans.capsize::after, .text-lg .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-lg.leading-tight.capsize::after, .font-sans .md\\:text-lg .leading-tight.capsize::after,.md\\:text-lg .font-sans.leading-tight.capsize::after,.md\\:text-lg .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-lg.capsize::after, .font-sans .md\\:leading-tight.text-lg.capsize::after, .font-sans .text-lg .md\\:leading-tight.capsize::after, .text-lg .md\\:leading-tight.font-sans.capsize::after, .text-lg .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-lg.leading-tight.capsize::after, .font-sans .md\\:text-lg .leading-tight.capsize::after,.md\\:text-lg .font-sans.leading-tight.capsize::after,.md\\:text-lg .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-lg.capsize::after, .font-sans .md\\:leading-tight.text-lg.capsize::after, .font-sans .text-lg .md\\:leading-tight.capsize::after, .text-lg .md\\:leading-tight.font-sans.capsize::after, .text-lg .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-lg.leading-tight.capsize::after, .font-sans .md\\:text-lg .leading-tight.capsize::after,.md\\:text-lg .font-sans.leading-tight.capsize::after,.md\\:text-lg .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-lg.capsize::after, .font-sans .md\\:leading-tight.text-lg.capsize::after, .font-sans .text-lg .md\\:leading-tight.capsize::after, .text-lg .md\\:leading-tight.font-sans.capsize::after, .text-lg .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-snug.capsize::before, .font-sans .md\\:text-lg.leading-snug.capsize::before, .font-sans .md\\:text-lg .leading-snug.capsize::before,.md\\:text-lg .font-sans.leading-snug.capsize::before,.md\\:text-lg .font-sans .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3445em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-snug.capsize::after, .font-sans .md\\:text-lg.leading-snug.capsize::after, .font-sans .md\\:text-lg .leading-snug.capsize::after,.md\\:text-lg .font-sans.leading-snug.capsize::after,.md\\:text-lg .font-sans .leading-snug.capsize::after {
    content: '';
    margin-top: -0.3005em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-normal.capsize::before, .font-sans .md\\:text-lg.leading-normal.capsize::before, .font-sans .md\\:text-lg .leading-normal.capsize::before,.md\\:text-lg .font-sans.leading-normal.capsize::before,.md\\:text-lg .font-sans .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-normal.capsize::after, .font-sans .md\\:text-lg.leading-normal.capsize::after, .font-sans .md\\:text-lg .leading-normal.capsize::after,.md\\:text-lg .font-sans.leading-normal.capsize::after,.md\\:text-lg .font-sans .leading-normal.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-relaxed.capsize::before, .font-sans .md\\:text-lg.leading-relaxed.capsize::before, .font-sans .md\\:text-lg .leading-relaxed.capsize::before,.md\\:text-lg .font-sans.leading-relaxed.capsize::before,.md\\:text-lg .font-sans .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4695em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-relaxed.capsize::after, .font-sans .md\\:text-lg.leading-relaxed.capsize::after, .font-sans .md\\:text-lg .leading-relaxed.capsize::after,.md\\:text-lg .font-sans.leading-relaxed.capsize::after,.md\\:text-lg .font-sans .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4255em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-loose.capsize::before, .font-sans .md\\:text-lg.leading-loose.capsize::before, .font-sans .md\\:text-lg .leading-loose.capsize::before,.md\\:text-lg .font-sans.leading-loose.capsize::before,.md\\:text-lg .font-sans .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .md\\:text-lg.font-sans.leading-loose.capsize::after, .font-sans .md\\:text-lg.leading-loose.capsize::after, .font-sans .md\\:text-lg .leading-loose.capsize::after,.md\\:text-lg .font-sans.leading-loose.capsize::after,.md\\:text-lg .font-sans .leading-loose.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-xl.capsize::before, .font-sans .md\\:leading-8.text-xl.capsize::before, .font-sans .text-xl .md\\:leading-8.capsize::before, .text-xl .md\\:leading-8.font-sans.capsize::before, .text-xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.457em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-xl.capsize::after, .font-sans .md\\:leading-8.text-xl.capsize::after, .font-sans .text-xl .md\\:leading-8.capsize::after, .text-xl .md\\:leading-8.font-sans.capsize::after, .text-xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.413em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-xl.capsize::before, .font-sans .md\\:leading-none.text-xl.capsize::before, .font-sans .text-xl .md\\:leading-none.capsize::before, .text-xl .md\\:leading-none.font-sans.capsize::before, .text-xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-xl.capsize::after, .font-sans .md\\:leading-none.text-xl.capsize::after, .font-sans .text-xl .md\\:leading-none.capsize::after, .text-xl .md\\:leading-none.font-sans.capsize::after, .text-xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-xl.capsize::before, .font-sans .md\\:leading-tight.text-xl.capsize::before, .font-sans .text-xl .md\\:leading-tight.capsize::before, .text-xl .md\\:leading-tight.font-sans.capsize::before, .text-xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-xl.capsize::after, .font-sans .md\\:leading-tight.text-xl.capsize::after, .font-sans .text-xl .md\\:leading-tight.capsize::after, .text-xl .md\\:leading-tight.font-sans.capsize::after, .text-xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-2xl.capsize::before, .font-sans .md\\:leading-8.text-2xl.capsize::before, .font-sans .text-2xl .md\\:leading-8.capsize::before, .text-2xl .md\\:leading-8.font-sans.capsize::before, .text-2xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.3237em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-2xl.capsize::after, .font-sans .md\\:leading-8.text-2xl.capsize::after, .font-sans .text-2xl .md\\:leading-8.capsize::after, .text-2xl .md\\:leading-8.font-sans.capsize::after, .text-2xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.2797em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-2xl.capsize::before, .font-sans .md\\:leading-none.text-2xl.capsize::before, .font-sans .text-2xl .md\\:leading-none.capsize::before, .text-2xl .md\\:leading-none.font-sans.capsize::before, .text-2xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-2xl.capsize::after, .font-sans .md\\:leading-none.text-2xl.capsize::after, .font-sans .text-2xl .md\\:leading-none.capsize::after, .text-2xl .md\\:leading-none.font-sans.capsize::after, .text-2xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-2xl.capsize::before, .font-sans .md\\:leading-tight.text-2xl.capsize::before, .font-sans .text-2xl .md\\:leading-tight.capsize::before, .text-2xl .md\\:leading-tight.font-sans.capsize::before, .text-2xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-2xl.capsize::after, .font-sans .md\\:leading-tight.text-2xl.capsize::after, .font-sans .text-2xl .md\\:leading-tight.capsize::after, .text-2xl .md\\:leading-tight.font-sans.capsize::after, .text-2xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-3.capsize::before, .font-sans .md\\:text-3xl.leading-3.capsize::before, .font-sans .md\\:text-3xl .leading-3.capsize::before,.md\\:text-3xl .font-sans.leading-3.capsize::before,.md\\:text-3xl .font-sans .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.143em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-3.capsize::after, .font-sans .md\\:text-3xl.leading-3.capsize::after, .font-sans .md\\:text-3xl .leading-3.capsize::after,.md\\:text-3xl .font-sans.leading-3.capsize::after,.md\\:text-3xl .font-sans .leading-3.capsize::after {
    content: '';
    margin-top: 0.187em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-4.capsize::before, .font-sans .md\\:text-3xl.leading-4.capsize::before, .font-sans .md\\:text-3xl .leading-4.capsize::before,.md\\:text-3xl .font-sans.leading-4.capsize::before,.md\\:text-3xl .font-sans .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.0763em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-4.capsize::after, .font-sans .md\\:text-3xl.leading-4.capsize::after, .font-sans .md\\:text-3xl .leading-4.capsize::after,.md\\:text-3xl .font-sans.leading-4.capsize::after,.md\\:text-3xl .font-sans .leading-4.capsize::after {
    content: '';
    margin-top: 0.1203em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-5.capsize::before, .font-sans .md\\:text-3xl.leading-5.capsize::before, .font-sans .md\\:text-3xl .leading-5.capsize::before,.md\\:text-3xl .font-sans.leading-5.capsize::before,.md\\:text-3xl .font-sans .leading-5.capsize::before {
    content: '';
    margin-bottom: 0.0097em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-5.capsize::after, .font-sans .md\\:text-3xl.leading-5.capsize::after, .font-sans .md\\:text-3xl .leading-5.capsize::after,.md\\:text-3xl .font-sans.leading-5.capsize::after,.md\\:text-3xl .font-sans .leading-5.capsize::after {
    content: '';
    margin-top: 0.0537em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-6.capsize::before, .font-sans .md\\:text-3xl.leading-6.capsize::before, .font-sans .md\\:text-3xl .leading-6.capsize::before,.md\\:text-3xl .font-sans.leading-6.capsize::before,.md\\:text-3xl .font-sans .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.057em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-6.capsize::after, .font-sans .md\\:text-3xl.leading-6.capsize::after, .font-sans .md\\:text-3xl .leading-6.capsize::after,.md\\:text-3xl .font-sans.leading-6.capsize::after,.md\\:text-3xl .font-sans .leading-6.capsize::after {
    content: '';
    margin-top: -0.013em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-7.capsize::before, .font-sans .md\\:text-3xl.leading-7.capsize::before, .font-sans .md\\:text-3xl .leading-7.capsize::before,.md\\:text-3xl .font-sans.leading-7.capsize::before,.md\\:text-3xl .font-sans .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.1237em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-7.capsize::after, .font-sans .md\\:text-3xl.leading-7.capsize::after, .font-sans .md\\:text-3xl .leading-7.capsize::after,.md\\:text-3xl .font-sans.leading-7.capsize::after,.md\\:text-3xl .font-sans .leading-7.capsize::after {
    content: '';
    margin-top: -0.0797em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-8.capsize::before, .font-sans .md\\:text-3xl.leading-8.capsize::before, .font-sans .md\\:text-3xl .leading-8.capsize::before,.md\\:text-3xl .font-sans.leading-8.capsize::before,.md\\:text-3xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1903em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-3xl.capsize::before, .font-sans .md\\:leading-8.text-3xl.capsize::before, .font-sans .text-3xl .md\\:leading-8.capsize::before, .text-3xl .md\\:leading-8.font-sans.capsize::before, .text-3xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1903em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-8.capsize::before, .font-sans .md\\:text-3xl.leading-8.capsize::before, .font-sans .md\\:text-3xl .leading-8.capsize::before,.md\\:text-3xl .font-sans.leading-8.capsize::before,.md\\:text-3xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1903em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-3xl.capsize::before, .font-sans .md\\:leading-8.text-3xl.capsize::before, .font-sans .text-3xl .md\\:leading-8.capsize::before, .text-3xl .md\\:leading-8.font-sans.capsize::before, .text-3xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1903em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-8.capsize::before, .font-sans .md\\:text-3xl.leading-8.capsize::before, .font-sans .md\\:text-3xl .leading-8.capsize::before,.md\\:text-3xl .font-sans.leading-8.capsize::before,.md\\:text-3xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1903em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-3xl.capsize::before, .font-sans .md\\:leading-8.text-3xl.capsize::before, .font-sans .text-3xl .md\\:leading-8.capsize::before, .text-3xl .md\\:leading-8.font-sans.capsize::before, .text-3xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1903em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-8.capsize::before, .font-sans .md\\:text-3xl.leading-8.capsize::before, .font-sans .md\\:text-3xl .leading-8.capsize::before,.md\\:text-3xl .font-sans.leading-8.capsize::before,.md\\:text-3xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1903em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-3xl.capsize::before, .font-sans .md\\:leading-8.text-3xl.capsize::before, .font-sans .text-3xl .md\\:leading-8.capsize::before, .text-3xl .md\\:leading-8.font-sans.capsize::before, .text-3xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1903em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-8.capsize::before, .font-sans .md\\:text-3xl.leading-8.capsize::before, .font-sans .md\\:text-3xl .leading-8.capsize::before,.md\\:text-3xl .font-sans.leading-8.capsize::before,.md\\:text-3xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1903em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-3xl.capsize::before, .font-sans .md\\:leading-8.text-3xl.capsize::before, .font-sans .text-3xl .md\\:leading-8.capsize::before, .text-3xl .md\\:leading-8.font-sans.capsize::before, .text-3xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1903em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-8.capsize::after, .font-sans .md\\:text-3xl.leading-8.capsize::after, .font-sans .md\\:text-3xl .leading-8.capsize::after,.md\\:text-3xl .font-sans.leading-8.capsize::after,.md\\:text-3xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.1463em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-3xl.capsize::after, .font-sans .md\\:leading-8.text-3xl.capsize::after, .font-sans .text-3xl .md\\:leading-8.capsize::after, .text-3xl .md\\:leading-8.font-sans.capsize::after, .text-3xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.1463em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-8.capsize::after, .font-sans .md\\:text-3xl.leading-8.capsize::after, .font-sans .md\\:text-3xl .leading-8.capsize::after,.md\\:text-3xl .font-sans.leading-8.capsize::after,.md\\:text-3xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.1463em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-3xl.capsize::after, .font-sans .md\\:leading-8.text-3xl.capsize::after, .font-sans .text-3xl .md\\:leading-8.capsize::after, .text-3xl .md\\:leading-8.font-sans.capsize::after, .text-3xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.1463em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-8.capsize::after, .font-sans .md\\:text-3xl.leading-8.capsize::after, .font-sans .md\\:text-3xl .leading-8.capsize::after,.md\\:text-3xl .font-sans.leading-8.capsize::after,.md\\:text-3xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.1463em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-3xl.capsize::after, .font-sans .md\\:leading-8.text-3xl.capsize::after, .font-sans .text-3xl .md\\:leading-8.capsize::after, .text-3xl .md\\:leading-8.font-sans.capsize::after, .text-3xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.1463em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-8.capsize::after, .font-sans .md\\:text-3xl.leading-8.capsize::after, .font-sans .md\\:text-3xl .leading-8.capsize::after,.md\\:text-3xl .font-sans.leading-8.capsize::after,.md\\:text-3xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.1463em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-3xl.capsize::after, .font-sans .md\\:leading-8.text-3xl.capsize::after, .font-sans .text-3xl .md\\:leading-8.capsize::after, .text-3xl .md\\:leading-8.font-sans.capsize::after, .text-3xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.1463em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-8.capsize::after, .font-sans .md\\:text-3xl.leading-8.capsize::after, .font-sans .md\\:text-3xl .leading-8.capsize::after,.md\\:text-3xl .font-sans.leading-8.capsize::after,.md\\:text-3xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.1463em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-3xl.capsize::after, .font-sans .md\\:leading-8.text-3xl.capsize::after, .font-sans .text-3xl .md\\:leading-8.capsize::after, .text-3xl .md\\:leading-8.font-sans.capsize::after, .text-3xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.1463em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-9.capsize::before, .font-sans .md\\:text-3xl.leading-9.capsize::before, .font-sans .md\\:text-3xl .leading-9.capsize::before,.md\\:text-3xl .font-sans.leading-9.capsize::before,.md\\:text-3xl .font-sans .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.257em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-9.capsize::after, .font-sans .md\\:text-3xl.leading-9.capsize::after, .font-sans .md\\:text-3xl .leading-9.capsize::after,.md\\:text-3xl .font-sans.leading-9.capsize::after,.md\\:text-3xl .font-sans .leading-9.capsize::after {
    content: '';
    margin-top: -0.213em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-10.capsize::before, .font-sans .md\\:text-3xl.leading-10.capsize::before, .font-sans .md\\:text-3xl .leading-10.capsize::before,.md\\:text-3xl .font-sans.leading-10.capsize::before,.md\\:text-3xl .font-sans .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.3237em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-10.capsize::after, .font-sans .md\\:text-3xl.leading-10.capsize::after, .font-sans .md\\:text-3xl .leading-10.capsize::after,.md\\:text-3xl .font-sans.leading-10.capsize::after,.md\\:text-3xl .font-sans .leading-10.capsize::after {
    content: '';
    margin-top: -0.2797em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-none.capsize::before, .font-sans .md\\:text-3xl.leading-none.capsize::before, .font-sans .md\\:text-3xl .leading-none.capsize::before,.md\\:text-3xl .font-sans.leading-none.capsize::before,.md\\:text-3xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-3xl.capsize::before, .font-sans .md\\:leading-none.text-3xl.capsize::before, .font-sans .text-3xl .md\\:leading-none.capsize::before, .text-3xl .md\\:leading-none.font-sans.capsize::before, .text-3xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-none.capsize::before, .font-sans .md\\:text-3xl.leading-none.capsize::before, .font-sans .md\\:text-3xl .leading-none.capsize::before,.md\\:text-3xl .font-sans.leading-none.capsize::before,.md\\:text-3xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-3xl.capsize::before, .font-sans .md\\:leading-none.text-3xl.capsize::before, .font-sans .text-3xl .md\\:leading-none.capsize::before, .text-3xl .md\\:leading-none.font-sans.capsize::before, .text-3xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-none.capsize::before, .font-sans .md\\:text-3xl.leading-none.capsize::before, .font-sans .md\\:text-3xl .leading-none.capsize::before,.md\\:text-3xl .font-sans.leading-none.capsize::before,.md\\:text-3xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-3xl.capsize::before, .font-sans .md\\:leading-none.text-3xl.capsize::before, .font-sans .text-3xl .md\\:leading-none.capsize::before, .text-3xl .md\\:leading-none.font-sans.capsize::before, .text-3xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-none.capsize::before, .font-sans .md\\:text-3xl.leading-none.capsize::before, .font-sans .md\\:text-3xl .leading-none.capsize::before,.md\\:text-3xl .font-sans.leading-none.capsize::before,.md\\:text-3xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-3xl.capsize::before, .font-sans .md\\:leading-none.text-3xl.capsize::before, .font-sans .text-3xl .md\\:leading-none.capsize::before, .text-3xl .md\\:leading-none.font-sans.capsize::before, .text-3xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-none.capsize::before, .font-sans .md\\:text-3xl.leading-none.capsize::before, .font-sans .md\\:text-3xl .leading-none.capsize::before,.md\\:text-3xl .font-sans.leading-none.capsize::before,.md\\:text-3xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-3xl.capsize::before, .font-sans .md\\:leading-none.text-3xl.capsize::before, .font-sans .text-3xl .md\\:leading-none.capsize::before, .text-3xl .md\\:leading-none.font-sans.capsize::before, .text-3xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-none.capsize::after, .font-sans .md\\:text-3xl.leading-none.capsize::after, .font-sans .md\\:text-3xl .leading-none.capsize::after,.md\\:text-3xl .font-sans.leading-none.capsize::after,.md\\:text-3xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-3xl.capsize::after, .font-sans .md\\:leading-none.text-3xl.capsize::after, .font-sans .text-3xl .md\\:leading-none.capsize::after, .text-3xl .md\\:leading-none.font-sans.capsize::after, .text-3xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-none.capsize::after, .font-sans .md\\:text-3xl.leading-none.capsize::after, .font-sans .md\\:text-3xl .leading-none.capsize::after,.md\\:text-3xl .font-sans.leading-none.capsize::after,.md\\:text-3xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-3xl.capsize::after, .font-sans .md\\:leading-none.text-3xl.capsize::after, .font-sans .text-3xl .md\\:leading-none.capsize::after, .text-3xl .md\\:leading-none.font-sans.capsize::after, .text-3xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-none.capsize::after, .font-sans .md\\:text-3xl.leading-none.capsize::after, .font-sans .md\\:text-3xl .leading-none.capsize::after,.md\\:text-3xl .font-sans.leading-none.capsize::after,.md\\:text-3xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-3xl.capsize::after, .font-sans .md\\:leading-none.text-3xl.capsize::after, .font-sans .text-3xl .md\\:leading-none.capsize::after, .text-3xl .md\\:leading-none.font-sans.capsize::after, .text-3xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-none.capsize::after, .font-sans .md\\:text-3xl.leading-none.capsize::after, .font-sans .md\\:text-3xl .leading-none.capsize::after,.md\\:text-3xl .font-sans.leading-none.capsize::after,.md\\:text-3xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-3xl.capsize::after, .font-sans .md\\:leading-none.text-3xl.capsize::after, .font-sans .text-3xl .md\\:leading-none.capsize::after, .text-3xl .md\\:leading-none.font-sans.capsize::after, .text-3xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-none.capsize::after, .font-sans .md\\:text-3xl.leading-none.capsize::after, .font-sans .md\\:text-3xl .leading-none.capsize::after,.md\\:text-3xl .font-sans.leading-none.capsize::after,.md\\:text-3xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-3xl.capsize::after, .font-sans .md\\:leading-none.text-3xl.capsize::after, .font-sans .text-3xl .md\\:leading-none.capsize::after, .text-3xl .md\\:leading-none.font-sans.capsize::after, .text-3xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-3xl.leading-tight.capsize::before, .font-sans .md\\:text-3xl .leading-tight.capsize::before,.md\\:text-3xl .font-sans.leading-tight.capsize::before,.md\\:text-3xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-3xl.capsize::before, .font-sans .md\\:leading-tight.text-3xl.capsize::before, .font-sans .text-3xl .md\\:leading-tight.capsize::before, .text-3xl .md\\:leading-tight.font-sans.capsize::before, .text-3xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-3xl.leading-tight.capsize::before, .font-sans .md\\:text-3xl .leading-tight.capsize::before,.md\\:text-3xl .font-sans.leading-tight.capsize::before,.md\\:text-3xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-3xl.capsize::before, .font-sans .md\\:leading-tight.text-3xl.capsize::before, .font-sans .text-3xl .md\\:leading-tight.capsize::before, .text-3xl .md\\:leading-tight.font-sans.capsize::before, .text-3xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-3xl.leading-tight.capsize::before, .font-sans .md\\:text-3xl .leading-tight.capsize::before,.md\\:text-3xl .font-sans.leading-tight.capsize::before,.md\\:text-3xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-3xl.capsize::before, .font-sans .md\\:leading-tight.text-3xl.capsize::before, .font-sans .text-3xl .md\\:leading-tight.capsize::before, .text-3xl .md\\:leading-tight.font-sans.capsize::before, .text-3xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-3xl.leading-tight.capsize::before, .font-sans .md\\:text-3xl .leading-tight.capsize::before,.md\\:text-3xl .font-sans.leading-tight.capsize::before,.md\\:text-3xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-3xl.capsize::before, .font-sans .md\\:leading-tight.text-3xl.capsize::before, .font-sans .text-3xl .md\\:leading-tight.capsize::before, .text-3xl .md\\:leading-tight.font-sans.capsize::before, .text-3xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-3xl.leading-tight.capsize::before, .font-sans .md\\:text-3xl .leading-tight.capsize::before,.md\\:text-3xl .font-sans.leading-tight.capsize::before,.md\\:text-3xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-3xl.capsize::before, .font-sans .md\\:leading-tight.text-3xl.capsize::before, .font-sans .text-3xl .md\\:leading-tight.capsize::before, .text-3xl .md\\:leading-tight.font-sans.capsize::before, .text-3xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-3xl.leading-tight.capsize::after, .font-sans .md\\:text-3xl .leading-tight.capsize::after,.md\\:text-3xl .font-sans.leading-tight.capsize::after,.md\\:text-3xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-3xl.capsize::after, .font-sans .md\\:leading-tight.text-3xl.capsize::after, .font-sans .text-3xl .md\\:leading-tight.capsize::after, .text-3xl .md\\:leading-tight.font-sans.capsize::after, .text-3xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-3xl.leading-tight.capsize::after, .font-sans .md\\:text-3xl .leading-tight.capsize::after,.md\\:text-3xl .font-sans.leading-tight.capsize::after,.md\\:text-3xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-3xl.capsize::after, .font-sans .md\\:leading-tight.text-3xl.capsize::after, .font-sans .text-3xl .md\\:leading-tight.capsize::after, .text-3xl .md\\:leading-tight.font-sans.capsize::after, .text-3xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-3xl.leading-tight.capsize::after, .font-sans .md\\:text-3xl .leading-tight.capsize::after,.md\\:text-3xl .font-sans.leading-tight.capsize::after,.md\\:text-3xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-3xl.capsize::after, .font-sans .md\\:leading-tight.text-3xl.capsize::after, .font-sans .text-3xl .md\\:leading-tight.capsize::after, .text-3xl .md\\:leading-tight.font-sans.capsize::after, .text-3xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-3xl.leading-tight.capsize::after, .font-sans .md\\:text-3xl .leading-tight.capsize::after,.md\\:text-3xl .font-sans.leading-tight.capsize::after,.md\\:text-3xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-3xl.capsize::after, .font-sans .md\\:leading-tight.text-3xl.capsize::after, .font-sans .text-3xl .md\\:leading-tight.capsize::after, .text-3xl .md\\:leading-tight.font-sans.capsize::after, .text-3xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-3xl.leading-tight.capsize::after, .font-sans .md\\:text-3xl .leading-tight.capsize::after,.md\\:text-3xl .font-sans.leading-tight.capsize::after,.md\\:text-3xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-3xl.capsize::after, .font-sans .md\\:leading-tight.text-3xl.capsize::after, .font-sans .text-3xl .md\\:leading-tight.capsize::after, .text-3xl .md\\:leading-tight.font-sans.capsize::after, .text-3xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-snug.capsize::before, .font-sans .md\\:text-3xl.leading-snug.capsize::before, .font-sans .md\\:text-3xl .leading-snug.capsize::before,.md\\:text-3xl .font-sans.leading-snug.capsize::before,.md\\:text-3xl .font-sans .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3445em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-snug.capsize::after, .font-sans .md\\:text-3xl.leading-snug.capsize::after, .font-sans .md\\:text-3xl .leading-snug.capsize::after,.md\\:text-3xl .font-sans.leading-snug.capsize::after,.md\\:text-3xl .font-sans .leading-snug.capsize::after {
    content: '';
    margin-top: -0.3005em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-normal.capsize::before, .font-sans .md\\:text-3xl.leading-normal.capsize::before, .font-sans .md\\:text-3xl .leading-normal.capsize::before,.md\\:text-3xl .font-sans.leading-normal.capsize::before,.md\\:text-3xl .font-sans .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-normal.capsize::after, .font-sans .md\\:text-3xl.leading-normal.capsize::after, .font-sans .md\\:text-3xl .leading-normal.capsize::after,.md\\:text-3xl .font-sans.leading-normal.capsize::after,.md\\:text-3xl .font-sans .leading-normal.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-relaxed.capsize::before, .font-sans .md\\:text-3xl.leading-relaxed.capsize::before, .font-sans .md\\:text-3xl .leading-relaxed.capsize::before,.md\\:text-3xl .font-sans.leading-relaxed.capsize::before,.md\\:text-3xl .font-sans .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4695em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-relaxed.capsize::after, .font-sans .md\\:text-3xl.leading-relaxed.capsize::after, .font-sans .md\\:text-3xl .leading-relaxed.capsize::after,.md\\:text-3xl .font-sans.leading-relaxed.capsize::after,.md\\:text-3xl .font-sans .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4255em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-loose.capsize::before, .font-sans .md\\:text-3xl.leading-loose.capsize::before, .font-sans .md\\:text-3xl .leading-loose.capsize::before,.md\\:text-3xl .font-sans.leading-loose.capsize::before,.md\\:text-3xl .font-sans .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .md\\:text-3xl.font-sans.leading-loose.capsize::after, .font-sans .md\\:text-3xl.leading-loose.capsize::after, .font-sans .md\\:text-3xl .leading-loose.capsize::after,.md\\:text-3xl .font-sans.leading-loose.capsize::after,.md\\:text-3xl .font-sans .leading-loose.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-3.capsize::before, .font-sans .md\\:text-4xl.leading-3.capsize::before, .font-sans .md\\:text-4xl .leading-3.capsize::before,.md\\:text-4xl .font-sans.leading-3.capsize::before,.md\\:text-4xl .font-sans .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.1763em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-3.capsize::after, .font-sans .md\\:text-4xl.leading-3.capsize::after, .font-sans .md\\:text-4xl .leading-3.capsize::after,.md\\:text-4xl .font-sans.leading-3.capsize::after,.md\\:text-4xl .font-sans .leading-3.capsize::after {
    content: '';
    margin-top: 0.2203em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-4.capsize::before, .font-sans .md\\:text-4xl.leading-4.capsize::before, .font-sans .md\\:text-4xl .leading-4.capsize::before,.md\\:text-4xl .font-sans.leading-4.capsize::before,.md\\:text-4xl .font-sans .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.1208em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-4.capsize::after, .font-sans .md\\:text-4xl.leading-4.capsize::after, .font-sans .md\\:text-4xl .leading-4.capsize::after,.md\\:text-4xl .font-sans.leading-4.capsize::after,.md\\:text-4xl .font-sans .leading-4.capsize::after {
    content: '';
    margin-top: 0.1648em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-5.capsize::before, .font-sans .md\\:text-4xl.leading-5.capsize::before, .font-sans .md\\:text-4xl .leading-5.capsize::before,.md\\:text-4xl .font-sans.leading-5.capsize::before,.md\\:text-4xl .font-sans .leading-5.capsize::before {
    content: '';
    margin-bottom: 0.0652em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-5.capsize::after, .font-sans .md\\:text-4xl.leading-5.capsize::after, .font-sans .md\\:text-4xl .leading-5.capsize::after,.md\\:text-4xl .font-sans.leading-5.capsize::after,.md\\:text-4xl .font-sans .leading-5.capsize::after {
    content: '';
    margin-top: 0.1092em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-6.capsize::before, .font-sans .md\\:text-4xl.leading-6.capsize::before, .font-sans .md\\:text-4xl .leading-6.capsize::before,.md\\:text-4xl .font-sans.leading-6.capsize::before,.md\\:text-4xl .font-sans .leading-6.capsize::before {
    content: '';
    margin-bottom: 0.0097em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-6.capsize::after, .font-sans .md\\:text-4xl.leading-6.capsize::after, .font-sans .md\\:text-4xl .leading-6.capsize::after,.md\\:text-4xl .font-sans.leading-6.capsize::after,.md\\:text-4xl .font-sans .leading-6.capsize::after {
    content: '';
    margin-top: 0.0537em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-7.capsize::before, .font-sans .md\\:text-4xl.leading-7.capsize::before, .font-sans .md\\:text-4xl .leading-7.capsize::before,.md\\:text-4xl .font-sans.leading-7.capsize::before,.md\\:text-4xl .font-sans .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.0459em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-7.capsize::after, .font-sans .md\\:text-4xl.leading-7.capsize::after, .font-sans .md\\:text-4xl .leading-7.capsize::after,.md\\:text-4xl .font-sans.leading-7.capsize::after,.md\\:text-4xl .font-sans .leading-7.capsize::after {
    content: '';
    margin-top: -0.0019em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-8.capsize::before, .font-sans .md\\:text-4xl.leading-8.capsize::before, .font-sans .md\\:text-4xl .leading-8.capsize::before,.md\\:text-4xl .font-sans.leading-8.capsize::before,.md\\:text-4xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1014em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-4xl.capsize::before, .font-sans .md\\:leading-8.text-4xl.capsize::before, .font-sans .text-4xl .md\\:leading-8.capsize::before, .text-4xl .md\\:leading-8.font-sans.capsize::before, .text-4xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1014em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-8.capsize::before, .font-sans .md\\:text-4xl.leading-8.capsize::before, .font-sans .md\\:text-4xl .leading-8.capsize::before,.md\\:text-4xl .font-sans.leading-8.capsize::before,.md\\:text-4xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1014em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-4xl.capsize::before, .font-sans .md\\:leading-8.text-4xl.capsize::before, .font-sans .text-4xl .md\\:leading-8.capsize::before, .text-4xl .md\\:leading-8.font-sans.capsize::before, .text-4xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1014em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-8.capsize::before, .font-sans .md\\:text-4xl.leading-8.capsize::before, .font-sans .md\\:text-4xl .leading-8.capsize::before,.md\\:text-4xl .font-sans.leading-8.capsize::before,.md\\:text-4xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1014em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-4xl.capsize::before, .font-sans .md\\:leading-8.text-4xl.capsize::before, .font-sans .text-4xl .md\\:leading-8.capsize::before, .text-4xl .md\\:leading-8.font-sans.capsize::before, .text-4xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1014em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-8.capsize::before, .font-sans .md\\:text-4xl.leading-8.capsize::before, .font-sans .md\\:text-4xl .leading-8.capsize::before,.md\\:text-4xl .font-sans.leading-8.capsize::before,.md\\:text-4xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1014em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-4xl.capsize::before, .font-sans .md\\:leading-8.text-4xl.capsize::before, .font-sans .text-4xl .md\\:leading-8.capsize::before, .text-4xl .md\\:leading-8.font-sans.capsize::before, .text-4xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1014em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-8.capsize::before, .font-sans .md\\:text-4xl.leading-8.capsize::before, .font-sans .md\\:text-4xl .leading-8.capsize::before,.md\\:text-4xl .font-sans.leading-8.capsize::before,.md\\:text-4xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1014em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-4xl.capsize::before, .font-sans .md\\:leading-8.text-4xl.capsize::before, .font-sans .text-4xl .md\\:leading-8.capsize::before, .text-4xl .md\\:leading-8.font-sans.capsize::before, .text-4xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1014em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-8.capsize::after, .font-sans .md\\:text-4xl.leading-8.capsize::after, .font-sans .md\\:text-4xl .leading-8.capsize::after,.md\\:text-4xl .font-sans.leading-8.capsize::after,.md\\:text-4xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.0574em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-4xl.capsize::after, .font-sans .md\\:leading-8.text-4xl.capsize::after, .font-sans .text-4xl .md\\:leading-8.capsize::after, .text-4xl .md\\:leading-8.font-sans.capsize::after, .text-4xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.0574em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-8.capsize::after, .font-sans .md\\:text-4xl.leading-8.capsize::after, .font-sans .md\\:text-4xl .leading-8.capsize::after,.md\\:text-4xl .font-sans.leading-8.capsize::after,.md\\:text-4xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.0574em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-4xl.capsize::after, .font-sans .md\\:leading-8.text-4xl.capsize::after, .font-sans .text-4xl .md\\:leading-8.capsize::after, .text-4xl .md\\:leading-8.font-sans.capsize::after, .text-4xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.0574em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-8.capsize::after, .font-sans .md\\:text-4xl.leading-8.capsize::after, .font-sans .md\\:text-4xl .leading-8.capsize::after,.md\\:text-4xl .font-sans.leading-8.capsize::after,.md\\:text-4xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.0574em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-4xl.capsize::after, .font-sans .md\\:leading-8.text-4xl.capsize::after, .font-sans .text-4xl .md\\:leading-8.capsize::after, .text-4xl .md\\:leading-8.font-sans.capsize::after, .text-4xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.0574em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-8.capsize::after, .font-sans .md\\:text-4xl.leading-8.capsize::after, .font-sans .md\\:text-4xl .leading-8.capsize::after,.md\\:text-4xl .font-sans.leading-8.capsize::after,.md\\:text-4xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.0574em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-4xl.capsize::after, .font-sans .md\\:leading-8.text-4xl.capsize::after, .font-sans .text-4xl .md\\:leading-8.capsize::after, .text-4xl .md\\:leading-8.font-sans.capsize::after, .text-4xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.0574em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-8.capsize::after, .font-sans .md\\:text-4xl.leading-8.capsize::after, .font-sans .md\\:text-4xl .leading-8.capsize::after,.md\\:text-4xl .font-sans.leading-8.capsize::after,.md\\:text-4xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.0574em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-4xl.capsize::after, .font-sans .md\\:leading-8.text-4xl.capsize::after, .font-sans .text-4xl .md\\:leading-8.capsize::after, .text-4xl .md\\:leading-8.font-sans.capsize::after, .text-4xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.0574em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-9.capsize::before, .font-sans .md\\:text-4xl.leading-9.capsize::before, .font-sans .md\\:text-4xl .leading-9.capsize::before,.md\\:text-4xl .font-sans.leading-9.capsize::before,.md\\:text-4xl .font-sans .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-9.capsize::after, .font-sans .md\\:text-4xl.leading-9.capsize::after, .font-sans .md\\:text-4xl .leading-9.capsize::after,.md\\:text-4xl .font-sans.leading-9.capsize::after,.md\\:text-4xl .font-sans .leading-9.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-10.capsize::before, .font-sans .md\\:text-4xl.leading-10.capsize::before, .font-sans .md\\:text-4xl .leading-10.capsize::before,.md\\:text-4xl .font-sans.leading-10.capsize::before,.md\\:text-4xl .font-sans .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.2126em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-10.capsize::after, .font-sans .md\\:text-4xl.leading-10.capsize::after, .font-sans .md\\:text-4xl .leading-10.capsize::after,.md\\:text-4xl .font-sans.leading-10.capsize::after,.md\\:text-4xl .font-sans .leading-10.capsize::after {
    content: '';
    margin-top: -0.1686em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-none.capsize::before, .font-sans .md\\:text-4xl.leading-none.capsize::before, .font-sans .md\\:text-4xl .leading-none.capsize::before,.md\\:text-4xl .font-sans.leading-none.capsize::before,.md\\:text-4xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-4xl.capsize::before, .font-sans .md\\:leading-none.text-4xl.capsize::before, .font-sans .text-4xl .md\\:leading-none.capsize::before, .text-4xl .md\\:leading-none.font-sans.capsize::before, .text-4xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-none.capsize::before, .font-sans .md\\:text-4xl.leading-none.capsize::before, .font-sans .md\\:text-4xl .leading-none.capsize::before,.md\\:text-4xl .font-sans.leading-none.capsize::before,.md\\:text-4xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-4xl.capsize::before, .font-sans .md\\:leading-none.text-4xl.capsize::before, .font-sans .text-4xl .md\\:leading-none.capsize::before, .text-4xl .md\\:leading-none.font-sans.capsize::before, .text-4xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-none.capsize::before, .font-sans .md\\:text-4xl.leading-none.capsize::before, .font-sans .md\\:text-4xl .leading-none.capsize::before,.md\\:text-4xl .font-sans.leading-none.capsize::before,.md\\:text-4xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-4xl.capsize::before, .font-sans .md\\:leading-none.text-4xl.capsize::before, .font-sans .text-4xl .md\\:leading-none.capsize::before, .text-4xl .md\\:leading-none.font-sans.capsize::before, .text-4xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-none.capsize::before, .font-sans .md\\:text-4xl.leading-none.capsize::before, .font-sans .md\\:text-4xl .leading-none.capsize::before,.md\\:text-4xl .font-sans.leading-none.capsize::before,.md\\:text-4xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-4xl.capsize::before, .font-sans .md\\:leading-none.text-4xl.capsize::before, .font-sans .text-4xl .md\\:leading-none.capsize::before, .text-4xl .md\\:leading-none.font-sans.capsize::before, .text-4xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-none.capsize::before, .font-sans .md\\:text-4xl.leading-none.capsize::before, .font-sans .md\\:text-4xl .leading-none.capsize::before,.md\\:text-4xl .font-sans.leading-none.capsize::before,.md\\:text-4xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-4xl.capsize::before, .font-sans .md\\:leading-none.text-4xl.capsize::before, .font-sans .text-4xl .md\\:leading-none.capsize::before, .text-4xl .md\\:leading-none.font-sans.capsize::before, .text-4xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-none.capsize::after, .font-sans .md\\:text-4xl.leading-none.capsize::after, .font-sans .md\\:text-4xl .leading-none.capsize::after,.md\\:text-4xl .font-sans.leading-none.capsize::after,.md\\:text-4xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-4xl.capsize::after, .font-sans .md\\:leading-none.text-4xl.capsize::after, .font-sans .text-4xl .md\\:leading-none.capsize::after, .text-4xl .md\\:leading-none.font-sans.capsize::after, .text-4xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-none.capsize::after, .font-sans .md\\:text-4xl.leading-none.capsize::after, .font-sans .md\\:text-4xl .leading-none.capsize::after,.md\\:text-4xl .font-sans.leading-none.capsize::after,.md\\:text-4xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-4xl.capsize::after, .font-sans .md\\:leading-none.text-4xl.capsize::after, .font-sans .text-4xl .md\\:leading-none.capsize::after, .text-4xl .md\\:leading-none.font-sans.capsize::after, .text-4xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-none.capsize::after, .font-sans .md\\:text-4xl.leading-none.capsize::after, .font-sans .md\\:text-4xl .leading-none.capsize::after,.md\\:text-4xl .font-sans.leading-none.capsize::after,.md\\:text-4xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-4xl.capsize::after, .font-sans .md\\:leading-none.text-4xl.capsize::after, .font-sans .text-4xl .md\\:leading-none.capsize::after, .text-4xl .md\\:leading-none.font-sans.capsize::after, .text-4xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-none.capsize::after, .font-sans .md\\:text-4xl.leading-none.capsize::after, .font-sans .md\\:text-4xl .leading-none.capsize::after,.md\\:text-4xl .font-sans.leading-none.capsize::after,.md\\:text-4xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-4xl.capsize::after, .font-sans .md\\:leading-none.text-4xl.capsize::after, .font-sans .text-4xl .md\\:leading-none.capsize::after, .text-4xl .md\\:leading-none.font-sans.capsize::after, .text-4xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-none.capsize::after, .font-sans .md\\:text-4xl.leading-none.capsize::after, .font-sans .md\\:text-4xl .leading-none.capsize::after,.md\\:text-4xl .font-sans.leading-none.capsize::after,.md\\:text-4xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-4xl.capsize::after, .font-sans .md\\:leading-none.text-4xl.capsize::after, .font-sans .text-4xl .md\\:leading-none.capsize::after, .text-4xl .md\\:leading-none.font-sans.capsize::after, .text-4xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-4xl.leading-tight.capsize::before, .font-sans .md\\:text-4xl .leading-tight.capsize::before,.md\\:text-4xl .font-sans.leading-tight.capsize::before,.md\\:text-4xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-4xl.capsize::before, .font-sans .md\\:leading-tight.text-4xl.capsize::before, .font-sans .text-4xl .md\\:leading-tight.capsize::before, .text-4xl .md\\:leading-tight.font-sans.capsize::before, .text-4xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-4xl.leading-tight.capsize::before, .font-sans .md\\:text-4xl .leading-tight.capsize::before,.md\\:text-4xl .font-sans.leading-tight.capsize::before,.md\\:text-4xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-4xl.capsize::before, .font-sans .md\\:leading-tight.text-4xl.capsize::before, .font-sans .text-4xl .md\\:leading-tight.capsize::before, .text-4xl .md\\:leading-tight.font-sans.capsize::before, .text-4xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-4xl.leading-tight.capsize::before, .font-sans .md\\:text-4xl .leading-tight.capsize::before,.md\\:text-4xl .font-sans.leading-tight.capsize::before,.md\\:text-4xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-4xl.capsize::before, .font-sans .md\\:leading-tight.text-4xl.capsize::before, .font-sans .text-4xl .md\\:leading-tight.capsize::before, .text-4xl .md\\:leading-tight.font-sans.capsize::before, .text-4xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-4xl.leading-tight.capsize::before, .font-sans .md\\:text-4xl .leading-tight.capsize::before,.md\\:text-4xl .font-sans.leading-tight.capsize::before,.md\\:text-4xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-4xl.capsize::before, .font-sans .md\\:leading-tight.text-4xl.capsize::before, .font-sans .text-4xl .md\\:leading-tight.capsize::before, .text-4xl .md\\:leading-tight.font-sans.capsize::before, .text-4xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-4xl.leading-tight.capsize::before, .font-sans .md\\:text-4xl .leading-tight.capsize::before,.md\\:text-4xl .font-sans.leading-tight.capsize::before,.md\\:text-4xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-4xl.capsize::before, .font-sans .md\\:leading-tight.text-4xl.capsize::before, .font-sans .text-4xl .md\\:leading-tight.capsize::before, .text-4xl .md\\:leading-tight.font-sans.capsize::before, .text-4xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-4xl.leading-tight.capsize::after, .font-sans .md\\:text-4xl .leading-tight.capsize::after,.md\\:text-4xl .font-sans.leading-tight.capsize::after,.md\\:text-4xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-4xl.capsize::after, .font-sans .md\\:leading-tight.text-4xl.capsize::after, .font-sans .text-4xl .md\\:leading-tight.capsize::after, .text-4xl .md\\:leading-tight.font-sans.capsize::after, .text-4xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-4xl.leading-tight.capsize::after, .font-sans .md\\:text-4xl .leading-tight.capsize::after,.md\\:text-4xl .font-sans.leading-tight.capsize::after,.md\\:text-4xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-4xl.capsize::after, .font-sans .md\\:leading-tight.text-4xl.capsize::after, .font-sans .text-4xl .md\\:leading-tight.capsize::after, .text-4xl .md\\:leading-tight.font-sans.capsize::after, .text-4xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-4xl.leading-tight.capsize::after, .font-sans .md\\:text-4xl .leading-tight.capsize::after,.md\\:text-4xl .font-sans.leading-tight.capsize::after,.md\\:text-4xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-4xl.capsize::after, .font-sans .md\\:leading-tight.text-4xl.capsize::after, .font-sans .text-4xl .md\\:leading-tight.capsize::after, .text-4xl .md\\:leading-tight.font-sans.capsize::after, .text-4xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-4xl.leading-tight.capsize::after, .font-sans .md\\:text-4xl .leading-tight.capsize::after,.md\\:text-4xl .font-sans.leading-tight.capsize::after,.md\\:text-4xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-4xl.capsize::after, .font-sans .md\\:leading-tight.text-4xl.capsize::after, .font-sans .text-4xl .md\\:leading-tight.capsize::after, .text-4xl .md\\:leading-tight.font-sans.capsize::after, .text-4xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-4xl.leading-tight.capsize::after, .font-sans .md\\:text-4xl .leading-tight.capsize::after,.md\\:text-4xl .font-sans.leading-tight.capsize::after,.md\\:text-4xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-4xl.capsize::after, .font-sans .md\\:leading-tight.text-4xl.capsize::after, .font-sans .text-4xl .md\\:leading-tight.capsize::after, .text-4xl .md\\:leading-tight.font-sans.capsize::after, .text-4xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-snug.capsize::before, .font-sans .md\\:text-4xl.leading-snug.capsize::before, .font-sans .md\\:text-4xl .leading-snug.capsize::before,.md\\:text-4xl .font-sans.leading-snug.capsize::before,.md\\:text-4xl .font-sans .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3445em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-snug.capsize::after, .font-sans .md\\:text-4xl.leading-snug.capsize::after, .font-sans .md\\:text-4xl .leading-snug.capsize::after,.md\\:text-4xl .font-sans.leading-snug.capsize::after,.md\\:text-4xl .font-sans .leading-snug.capsize::after {
    content: '';
    margin-top: -0.3005em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-normal.capsize::before, .font-sans .md\\:text-4xl.leading-normal.capsize::before, .font-sans .md\\:text-4xl .leading-normal.capsize::before,.md\\:text-4xl .font-sans.leading-normal.capsize::before,.md\\:text-4xl .font-sans .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-normal.capsize::after, .font-sans .md\\:text-4xl.leading-normal.capsize::after, .font-sans .md\\:text-4xl .leading-normal.capsize::after,.md\\:text-4xl .font-sans.leading-normal.capsize::after,.md\\:text-4xl .font-sans .leading-normal.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-relaxed.capsize::before, .font-sans .md\\:text-4xl.leading-relaxed.capsize::before, .font-sans .md\\:text-4xl .leading-relaxed.capsize::before,.md\\:text-4xl .font-sans.leading-relaxed.capsize::before,.md\\:text-4xl .font-sans .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4695em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-relaxed.capsize::after, .font-sans .md\\:text-4xl.leading-relaxed.capsize::after, .font-sans .md\\:text-4xl .leading-relaxed.capsize::after,.md\\:text-4xl .font-sans.leading-relaxed.capsize::after,.md\\:text-4xl .font-sans .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4255em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-loose.capsize::before, .font-sans .md\\:text-4xl.leading-loose.capsize::before, .font-sans .md\\:text-4xl .leading-loose.capsize::before,.md\\:text-4xl .font-sans.leading-loose.capsize::before,.md\\:text-4xl .font-sans .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .md\\:text-4xl.font-sans.leading-loose.capsize::after, .font-sans .md\\:text-4xl.leading-loose.capsize::after, .font-sans .md\\:text-4xl .leading-loose.capsize::after,.md\\:text-4xl .font-sans.leading-loose.capsize::after,.md\\:text-4xl .font-sans .leading-loose.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-5xl.capsize::before, .font-sans .md\\:leading-8.text-5xl.capsize::before, .font-sans .text-5xl .md\\:leading-8.capsize::before, .text-5xl .md\\:leading-8.font-sans.capsize::before, .text-5xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.0097em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-5xl.capsize::after, .font-sans .md\\:leading-8.text-5xl.capsize::after, .font-sans .text-5xl .md\\:leading-8.capsize::after, .text-5xl .md\\:leading-8.font-sans.capsize::after, .text-5xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.0537em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-5xl.capsize::before, .font-sans .md\\:leading-none.text-5xl.capsize::before, .font-sans .text-5xl .md\\:leading-none.capsize::before, .text-5xl .md\\:leading-none.font-sans.capsize::before, .text-5xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-5xl.capsize::after, .font-sans .md\\:leading-none.text-5xl.capsize::after, .font-sans .text-5xl .md\\:leading-none.capsize::after, .text-5xl .md\\:leading-none.font-sans.capsize::after, .text-5xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-5xl.capsize::before, .font-sans .md\\:leading-tight.text-5xl.capsize::before, .font-sans .text-5xl .md\\:leading-tight.capsize::before, .text-5xl .md\\:leading-tight.font-sans.capsize::before, .text-5xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-5xl.capsize::after, .font-sans .md\\:leading-tight.text-5xl.capsize::after, .font-sans .text-5xl .md\\:leading-tight.capsize::after, .text-5xl .md\\:leading-tight.font-sans.capsize::after, .text-5xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-3.capsize::before, .font-sans .md\\:text-6xl.leading-3.capsize::before, .font-sans .md\\:text-6xl .leading-3.capsize::before,.md\\:text-6xl .font-sans.leading-3.capsize::before,.md\\:text-6xl .font-sans .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.243em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-3.capsize::after, .font-sans .md\\:text-6xl.leading-3.capsize::after, .font-sans .md\\:text-6xl .leading-3.capsize::after,.md\\:text-6xl .font-sans.leading-3.capsize::after,.md\\:text-6xl .font-sans .leading-3.capsize::after {
    content: '';
    margin-top: 0.287em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-4.capsize::before, .font-sans .md\\:text-6xl.leading-4.capsize::before, .font-sans .md\\:text-6xl .leading-4.capsize::before,.md\\:text-6xl .font-sans.leading-4.capsize::before,.md\\:text-6xl .font-sans .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.2097em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-4.capsize::after, .font-sans .md\\:text-6xl.leading-4.capsize::after, .font-sans .md\\:text-6xl .leading-4.capsize::after,.md\\:text-6xl .font-sans.leading-4.capsize::after,.md\\:text-6xl .font-sans .leading-4.capsize::after {
    content: '';
    margin-top: 0.2537em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-5.capsize::before, .font-sans .md\\:text-6xl.leading-5.capsize::before, .font-sans .md\\:text-6xl .leading-5.capsize::before,.md\\:text-6xl .font-sans.leading-5.capsize::before,.md\\:text-6xl .font-sans .leading-5.capsize::before {
    content: '';
    margin-bottom: 0.1763em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-5.capsize::after, .font-sans .md\\:text-6xl.leading-5.capsize::after, .font-sans .md\\:text-6xl .leading-5.capsize::after,.md\\:text-6xl .font-sans.leading-5.capsize::after,.md\\:text-6xl .font-sans .leading-5.capsize::after {
    content: '';
    margin-top: 0.2203em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-6.capsize::before, .font-sans .md\\:text-6xl.leading-6.capsize::before, .font-sans .md\\:text-6xl .leading-6.capsize::before,.md\\:text-6xl .font-sans.leading-6.capsize::before,.md\\:text-6xl .font-sans .leading-6.capsize::before {
    content: '';
    margin-bottom: 0.143em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-6.capsize::after, .font-sans .md\\:text-6xl.leading-6.capsize::after, .font-sans .md\\:text-6xl .leading-6.capsize::after,.md\\:text-6xl .font-sans.leading-6.capsize::after,.md\\:text-6xl .font-sans .leading-6.capsize::after {
    content: '';
    margin-top: 0.187em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-7.capsize::before, .font-sans .md\\:text-6xl.leading-7.capsize::before, .font-sans .md\\:text-6xl .leading-7.capsize::before,.md\\:text-6xl .font-sans.leading-7.capsize::before,.md\\:text-6xl .font-sans .leading-7.capsize::before {
    content: '';
    margin-bottom: 0.1097em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-7.capsize::after, .font-sans .md\\:text-6xl.leading-7.capsize::after, .font-sans .md\\:text-6xl .leading-7.capsize::after,.md\\:text-6xl .font-sans.leading-7.capsize::after,.md\\:text-6xl .font-sans .leading-7.capsize::after {
    content: '';
    margin-top: 0.1537em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-8.capsize::before, .font-sans .md\\:text-6xl.leading-8.capsize::before, .font-sans .md\\:text-6xl .leading-8.capsize::before,.md\\:text-6xl .font-sans.leading-8.capsize::before,.md\\:text-6xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.0763em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-6xl.capsize::before, .font-sans .md\\:leading-8.text-6xl.capsize::before, .font-sans .text-6xl .md\\:leading-8.capsize::before, .text-6xl .md\\:leading-8.font-sans.capsize::before, .text-6xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.0763em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-8.capsize::before, .font-sans .md\\:text-6xl.leading-8.capsize::before, .font-sans .md\\:text-6xl .leading-8.capsize::before,.md\\:text-6xl .font-sans.leading-8.capsize::before,.md\\:text-6xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.0763em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-6xl.capsize::before, .font-sans .md\\:leading-8.text-6xl.capsize::before, .font-sans .text-6xl .md\\:leading-8.capsize::before, .text-6xl .md\\:leading-8.font-sans.capsize::before, .text-6xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.0763em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-8.capsize::before, .font-sans .md\\:text-6xl.leading-8.capsize::before, .font-sans .md\\:text-6xl .leading-8.capsize::before,.md\\:text-6xl .font-sans.leading-8.capsize::before,.md\\:text-6xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.0763em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-6xl.capsize::before, .font-sans .md\\:leading-8.text-6xl.capsize::before, .font-sans .text-6xl .md\\:leading-8.capsize::before, .text-6xl .md\\:leading-8.font-sans.capsize::before, .text-6xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.0763em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-8.capsize::before, .font-sans .md\\:text-6xl.leading-8.capsize::before, .font-sans .md\\:text-6xl .leading-8.capsize::before,.md\\:text-6xl .font-sans.leading-8.capsize::before,.md\\:text-6xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.0763em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-6xl.capsize::before, .font-sans .md\\:leading-8.text-6xl.capsize::before, .font-sans .text-6xl .md\\:leading-8.capsize::before, .text-6xl .md\\:leading-8.font-sans.capsize::before, .text-6xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.0763em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-8.capsize::before, .font-sans .md\\:text-6xl.leading-8.capsize::before, .font-sans .md\\:text-6xl .leading-8.capsize::before,.md\\:text-6xl .font-sans.leading-8.capsize::before,.md\\:text-6xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.0763em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-6xl.capsize::before, .font-sans .md\\:leading-8.text-6xl.capsize::before, .font-sans .text-6xl .md\\:leading-8.capsize::before, .text-6xl .md\\:leading-8.font-sans.capsize::before, .text-6xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.0763em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-8.capsize::after, .font-sans .md\\:text-6xl.leading-8.capsize::after, .font-sans .md\\:text-6xl .leading-8.capsize::after,.md\\:text-6xl .font-sans.leading-8.capsize::after,.md\\:text-6xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: 0.1203em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-6xl.capsize::after, .font-sans .md\\:leading-8.text-6xl.capsize::after, .font-sans .text-6xl .md\\:leading-8.capsize::after, .text-6xl .md\\:leading-8.font-sans.capsize::after, .text-6xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.1203em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-8.capsize::after, .font-sans .md\\:text-6xl.leading-8.capsize::after, .font-sans .md\\:text-6xl .leading-8.capsize::after,.md\\:text-6xl .font-sans.leading-8.capsize::after,.md\\:text-6xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: 0.1203em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-6xl.capsize::after, .font-sans .md\\:leading-8.text-6xl.capsize::after, .font-sans .text-6xl .md\\:leading-8.capsize::after, .text-6xl .md\\:leading-8.font-sans.capsize::after, .text-6xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.1203em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-8.capsize::after, .font-sans .md\\:text-6xl.leading-8.capsize::after, .font-sans .md\\:text-6xl .leading-8.capsize::after,.md\\:text-6xl .font-sans.leading-8.capsize::after,.md\\:text-6xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: 0.1203em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-6xl.capsize::after, .font-sans .md\\:leading-8.text-6xl.capsize::after, .font-sans .text-6xl .md\\:leading-8.capsize::after, .text-6xl .md\\:leading-8.font-sans.capsize::after, .text-6xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.1203em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-8.capsize::after, .font-sans .md\\:text-6xl.leading-8.capsize::after, .font-sans .md\\:text-6xl .leading-8.capsize::after,.md\\:text-6xl .font-sans.leading-8.capsize::after,.md\\:text-6xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: 0.1203em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-6xl.capsize::after, .font-sans .md\\:leading-8.text-6xl.capsize::after, .font-sans .text-6xl .md\\:leading-8.capsize::after, .text-6xl .md\\:leading-8.font-sans.capsize::after, .text-6xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.1203em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-8.capsize::after, .font-sans .md\\:text-6xl.leading-8.capsize::after, .font-sans .md\\:text-6xl .leading-8.capsize::after,.md\\:text-6xl .font-sans.leading-8.capsize::after,.md\\:text-6xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: 0.1203em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-6xl.capsize::after, .font-sans .md\\:leading-8.text-6xl.capsize::after, .font-sans .text-6xl .md\\:leading-8.capsize::after, .text-6xl .md\\:leading-8.font-sans.capsize::after, .text-6xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.1203em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-9.capsize::before, .font-sans .md\\:text-6xl.leading-9.capsize::before, .font-sans .md\\:text-6xl .leading-9.capsize::before,.md\\:text-6xl .font-sans.leading-9.capsize::before,.md\\:text-6xl .font-sans .leading-9.capsize::before {
    content: '';
    margin-bottom: 0.043em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-9.capsize::after, .font-sans .md\\:text-6xl.leading-9.capsize::after, .font-sans .md\\:text-6xl .leading-9.capsize::after,.md\\:text-6xl .font-sans.leading-9.capsize::after,.md\\:text-6xl .font-sans .leading-9.capsize::after {
    content: '';
    margin-top: 0.087em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-10.capsize::before, .font-sans .md\\:text-6xl.leading-10.capsize::before, .font-sans .md\\:text-6xl .leading-10.capsize::before,.md\\:text-6xl .font-sans.leading-10.capsize::before,.md\\:text-6xl .font-sans .leading-10.capsize::before {
    content: '';
    margin-bottom: 0.0097em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-10.capsize::after, .font-sans .md\\:text-6xl.leading-10.capsize::after, .font-sans .md\\:text-6xl .leading-10.capsize::after,.md\\:text-6xl .font-sans.leading-10.capsize::after,.md\\:text-6xl .font-sans .leading-10.capsize::after {
    content: '';
    margin-top: 0.0537em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-none.capsize::before, .font-sans .md\\:text-6xl.leading-none.capsize::before, .font-sans .md\\:text-6xl .leading-none.capsize::before,.md\\:text-6xl .font-sans.leading-none.capsize::before,.md\\:text-6xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-6xl.capsize::before, .font-sans .md\\:leading-none.text-6xl.capsize::before, .font-sans .text-6xl .md\\:leading-none.capsize::before, .text-6xl .md\\:leading-none.font-sans.capsize::before, .text-6xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-none.capsize::before, .font-sans .md\\:text-6xl.leading-none.capsize::before, .font-sans .md\\:text-6xl .leading-none.capsize::before,.md\\:text-6xl .font-sans.leading-none.capsize::before,.md\\:text-6xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-6xl.capsize::before, .font-sans .md\\:leading-none.text-6xl.capsize::before, .font-sans .text-6xl .md\\:leading-none.capsize::before, .text-6xl .md\\:leading-none.font-sans.capsize::before, .text-6xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-none.capsize::before, .font-sans .md\\:text-6xl.leading-none.capsize::before, .font-sans .md\\:text-6xl .leading-none.capsize::before,.md\\:text-6xl .font-sans.leading-none.capsize::before,.md\\:text-6xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-6xl.capsize::before, .font-sans .md\\:leading-none.text-6xl.capsize::before, .font-sans .text-6xl .md\\:leading-none.capsize::before, .text-6xl .md\\:leading-none.font-sans.capsize::before, .text-6xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-none.capsize::before, .font-sans .md\\:text-6xl.leading-none.capsize::before, .font-sans .md\\:text-6xl .leading-none.capsize::before,.md\\:text-6xl .font-sans.leading-none.capsize::before,.md\\:text-6xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-6xl.capsize::before, .font-sans .md\\:leading-none.text-6xl.capsize::before, .font-sans .text-6xl .md\\:leading-none.capsize::before, .text-6xl .md\\:leading-none.font-sans.capsize::before, .text-6xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-none.capsize::before, .font-sans .md\\:text-6xl.leading-none.capsize::before, .font-sans .md\\:text-6xl .leading-none.capsize::before,.md\\:text-6xl .font-sans.leading-none.capsize::before,.md\\:text-6xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-6xl.capsize::before, .font-sans .md\\:leading-none.text-6xl.capsize::before, .font-sans .text-6xl .md\\:leading-none.capsize::before, .text-6xl .md\\:leading-none.font-sans.capsize::before, .text-6xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-none.capsize::after, .font-sans .md\\:text-6xl.leading-none.capsize::after, .font-sans .md\\:text-6xl .leading-none.capsize::after,.md\\:text-6xl .font-sans.leading-none.capsize::after,.md\\:text-6xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-6xl.capsize::after, .font-sans .md\\:leading-none.text-6xl.capsize::after, .font-sans .text-6xl .md\\:leading-none.capsize::after, .text-6xl .md\\:leading-none.font-sans.capsize::after, .text-6xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-none.capsize::after, .font-sans .md\\:text-6xl.leading-none.capsize::after, .font-sans .md\\:text-6xl .leading-none.capsize::after,.md\\:text-6xl .font-sans.leading-none.capsize::after,.md\\:text-6xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-6xl.capsize::after, .font-sans .md\\:leading-none.text-6xl.capsize::after, .font-sans .text-6xl .md\\:leading-none.capsize::after, .text-6xl .md\\:leading-none.font-sans.capsize::after, .text-6xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-none.capsize::after, .font-sans .md\\:text-6xl.leading-none.capsize::after, .font-sans .md\\:text-6xl .leading-none.capsize::after,.md\\:text-6xl .font-sans.leading-none.capsize::after,.md\\:text-6xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-6xl.capsize::after, .font-sans .md\\:leading-none.text-6xl.capsize::after, .font-sans .text-6xl .md\\:leading-none.capsize::after, .text-6xl .md\\:leading-none.font-sans.capsize::after, .text-6xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-none.capsize::after, .font-sans .md\\:text-6xl.leading-none.capsize::after, .font-sans .md\\:text-6xl .leading-none.capsize::after,.md\\:text-6xl .font-sans.leading-none.capsize::after,.md\\:text-6xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-6xl.capsize::after, .font-sans .md\\:leading-none.text-6xl.capsize::after, .font-sans .text-6xl .md\\:leading-none.capsize::after, .text-6xl .md\\:leading-none.font-sans.capsize::after, .text-6xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-none.capsize::after, .font-sans .md\\:text-6xl.leading-none.capsize::after, .font-sans .md\\:text-6xl .leading-none.capsize::after,.md\\:text-6xl .font-sans.leading-none.capsize::after,.md\\:text-6xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-6xl.capsize::after, .font-sans .md\\:leading-none.text-6xl.capsize::after, .font-sans .text-6xl .md\\:leading-none.capsize::after, .text-6xl .md\\:leading-none.font-sans.capsize::after, .text-6xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-6xl.leading-tight.capsize::before, .font-sans .md\\:text-6xl .leading-tight.capsize::before,.md\\:text-6xl .font-sans.leading-tight.capsize::before,.md\\:text-6xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-6xl.capsize::before, .font-sans .md\\:leading-tight.text-6xl.capsize::before, .font-sans .text-6xl .md\\:leading-tight.capsize::before, .text-6xl .md\\:leading-tight.font-sans.capsize::before, .text-6xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-6xl.leading-tight.capsize::before, .font-sans .md\\:text-6xl .leading-tight.capsize::before,.md\\:text-6xl .font-sans.leading-tight.capsize::before,.md\\:text-6xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-6xl.capsize::before, .font-sans .md\\:leading-tight.text-6xl.capsize::before, .font-sans .text-6xl .md\\:leading-tight.capsize::before, .text-6xl .md\\:leading-tight.font-sans.capsize::before, .text-6xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-6xl.leading-tight.capsize::before, .font-sans .md\\:text-6xl .leading-tight.capsize::before,.md\\:text-6xl .font-sans.leading-tight.capsize::before,.md\\:text-6xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-6xl.capsize::before, .font-sans .md\\:leading-tight.text-6xl.capsize::before, .font-sans .text-6xl .md\\:leading-tight.capsize::before, .text-6xl .md\\:leading-tight.font-sans.capsize::before, .text-6xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-6xl.leading-tight.capsize::before, .font-sans .md\\:text-6xl .leading-tight.capsize::before,.md\\:text-6xl .font-sans.leading-tight.capsize::before,.md\\:text-6xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-6xl.capsize::before, .font-sans .md\\:leading-tight.text-6xl.capsize::before, .font-sans .text-6xl .md\\:leading-tight.capsize::before, .text-6xl .md\\:leading-tight.font-sans.capsize::before, .text-6xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-6xl.leading-tight.capsize::before, .font-sans .md\\:text-6xl .leading-tight.capsize::before,.md\\:text-6xl .font-sans.leading-tight.capsize::before,.md\\:text-6xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-6xl.capsize::before, .font-sans .md\\:leading-tight.text-6xl.capsize::before, .font-sans .text-6xl .md\\:leading-tight.capsize::before, .text-6xl .md\\:leading-tight.font-sans.capsize::before, .text-6xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-6xl.leading-tight.capsize::after, .font-sans .md\\:text-6xl .leading-tight.capsize::after,.md\\:text-6xl .font-sans.leading-tight.capsize::after,.md\\:text-6xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-6xl.capsize::after, .font-sans .md\\:leading-tight.text-6xl.capsize::after, .font-sans .text-6xl .md\\:leading-tight.capsize::after, .text-6xl .md\\:leading-tight.font-sans.capsize::after, .text-6xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-6xl.leading-tight.capsize::after, .font-sans .md\\:text-6xl .leading-tight.capsize::after,.md\\:text-6xl .font-sans.leading-tight.capsize::after,.md\\:text-6xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-6xl.capsize::after, .font-sans .md\\:leading-tight.text-6xl.capsize::after, .font-sans .text-6xl .md\\:leading-tight.capsize::after, .text-6xl .md\\:leading-tight.font-sans.capsize::after, .text-6xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-6xl.leading-tight.capsize::after, .font-sans .md\\:text-6xl .leading-tight.capsize::after,.md\\:text-6xl .font-sans.leading-tight.capsize::after,.md\\:text-6xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-6xl.capsize::after, .font-sans .md\\:leading-tight.text-6xl.capsize::after, .font-sans .text-6xl .md\\:leading-tight.capsize::after, .text-6xl .md\\:leading-tight.font-sans.capsize::after, .text-6xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-6xl.leading-tight.capsize::after, .font-sans .md\\:text-6xl .leading-tight.capsize::after,.md\\:text-6xl .font-sans.leading-tight.capsize::after,.md\\:text-6xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-6xl.capsize::after, .font-sans .md\\:leading-tight.text-6xl.capsize::after, .font-sans .text-6xl .md\\:leading-tight.capsize::after, .text-6xl .md\\:leading-tight.font-sans.capsize::after, .text-6xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-6xl.leading-tight.capsize::after, .font-sans .md\\:text-6xl .leading-tight.capsize::after,.md\\:text-6xl .font-sans.leading-tight.capsize::after,.md\\:text-6xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-6xl.capsize::after, .font-sans .md\\:leading-tight.text-6xl.capsize::after, .font-sans .text-6xl .md\\:leading-tight.capsize::after, .text-6xl .md\\:leading-tight.font-sans.capsize::after, .text-6xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-snug.capsize::before, .font-sans .md\\:text-6xl.leading-snug.capsize::before, .font-sans .md\\:text-6xl .leading-snug.capsize::before,.md\\:text-6xl .font-sans.leading-snug.capsize::before,.md\\:text-6xl .font-sans .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3445em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-snug.capsize::after, .font-sans .md\\:text-6xl.leading-snug.capsize::after, .font-sans .md\\:text-6xl .leading-snug.capsize::after,.md\\:text-6xl .font-sans.leading-snug.capsize::after,.md\\:text-6xl .font-sans .leading-snug.capsize::after {
    content: '';
    margin-top: -0.3005em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-normal.capsize::before, .font-sans .md\\:text-6xl.leading-normal.capsize::before, .font-sans .md\\:text-6xl .leading-normal.capsize::before,.md\\:text-6xl .font-sans.leading-normal.capsize::before,.md\\:text-6xl .font-sans .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-normal.capsize::after, .font-sans .md\\:text-6xl.leading-normal.capsize::after, .font-sans .md\\:text-6xl .leading-normal.capsize::after,.md\\:text-6xl .font-sans.leading-normal.capsize::after,.md\\:text-6xl .font-sans .leading-normal.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-relaxed.capsize::before, .font-sans .md\\:text-6xl.leading-relaxed.capsize::before, .font-sans .md\\:text-6xl .leading-relaxed.capsize::before,.md\\:text-6xl .font-sans.leading-relaxed.capsize::before,.md\\:text-6xl .font-sans .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4695em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-relaxed.capsize::after, .font-sans .md\\:text-6xl.leading-relaxed.capsize::after, .font-sans .md\\:text-6xl .leading-relaxed.capsize::after,.md\\:text-6xl .font-sans.leading-relaxed.capsize::after,.md\\:text-6xl .font-sans .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4255em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-loose.capsize::before, .font-sans .md\\:text-6xl.leading-loose.capsize::before, .font-sans .md\\:text-6xl .leading-loose.capsize::before,.md\\:text-6xl .font-sans.leading-loose.capsize::before,.md\\:text-6xl .font-sans .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .md\\:text-6xl.font-sans.leading-loose.capsize::after, .font-sans .md\\:text-6xl.leading-loose.capsize::after, .font-sans .md\\:text-6xl .leading-loose.capsize::after,.md\\:text-6xl .font-sans.leading-loose.capsize::after,.md\\:text-6xl .font-sans .leading-loose.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-3.capsize::before, .font-sans .md\\:text-7xl.leading-3.capsize::before, .font-sans .md\\:text-7xl .leading-3.capsize::before,.md\\:text-7xl .font-sans.leading-3.capsize::before,.md\\:text-7xl .font-sans .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.2597em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-3.capsize::after, .font-sans .md\\:text-7xl.leading-3.capsize::after, .font-sans .md\\:text-7xl .leading-3.capsize::after,.md\\:text-7xl .font-sans.leading-3.capsize::after,.md\\:text-7xl .font-sans .leading-3.capsize::after {
    content: '';
    margin-top: 0.3037em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-4.capsize::before, .font-sans .md\\:text-7xl.leading-4.capsize::before, .font-sans .md\\:text-7xl .leading-4.capsize::before,.md\\:text-7xl .font-sans.leading-4.capsize::before,.md\\:text-7xl .font-sans .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.2319em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-4.capsize::after, .font-sans .md\\:text-7xl.leading-4.capsize::after, .font-sans .md\\:text-7xl .leading-4.capsize::after,.md\\:text-7xl .font-sans.leading-4.capsize::after,.md\\:text-7xl .font-sans .leading-4.capsize::after {
    content: '';
    margin-top: 0.2759em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-5.capsize::before, .font-sans .md\\:text-7xl.leading-5.capsize::before, .font-sans .md\\:text-7xl .leading-5.capsize::before,.md\\:text-7xl .font-sans.leading-5.capsize::before,.md\\:text-7xl .font-sans .leading-5.capsize::before {
    content: '';
    margin-bottom: 0.2041em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-5.capsize::after, .font-sans .md\\:text-7xl.leading-5.capsize::after, .font-sans .md\\:text-7xl .leading-5.capsize::after,.md\\:text-7xl .font-sans.leading-5.capsize::after,.md\\:text-7xl .font-sans .leading-5.capsize::after {
    content: '';
    margin-top: 0.2481em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-6.capsize::before, .font-sans .md\\:text-7xl.leading-6.capsize::before, .font-sans .md\\:text-7xl .leading-6.capsize::before,.md\\:text-7xl .font-sans.leading-6.capsize::before,.md\\:text-7xl .font-sans .leading-6.capsize::before {
    content: '';
    margin-bottom: 0.1763em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-6.capsize::after, .font-sans .md\\:text-7xl.leading-6.capsize::after, .font-sans .md\\:text-7xl .leading-6.capsize::after,.md\\:text-7xl .font-sans.leading-6.capsize::after,.md\\:text-7xl .font-sans .leading-6.capsize::after {
    content: '';
    margin-top: 0.2203em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-7.capsize::before, .font-sans .md\\:text-7xl.leading-7.capsize::before, .font-sans .md\\:text-7xl .leading-7.capsize::before,.md\\:text-7xl .font-sans.leading-7.capsize::before,.md\\:text-7xl .font-sans .leading-7.capsize::before {
    content: '';
    margin-bottom: 0.1486em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-7.capsize::after, .font-sans .md\\:text-7xl.leading-7.capsize::after, .font-sans .md\\:text-7xl .leading-7.capsize::after,.md\\:text-7xl .font-sans.leading-7.capsize::after,.md\\:text-7xl .font-sans .leading-7.capsize::after {
    content: '';
    margin-top: 0.1926em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-8.capsize::before, .font-sans .md\\:text-7xl.leading-8.capsize::before, .font-sans .md\\:text-7xl .leading-8.capsize::before,.md\\:text-7xl .font-sans.leading-8.capsize::before,.md\\:text-7xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1208em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-7xl.capsize::before, .font-sans .md\\:leading-8.text-7xl.capsize::before, .font-sans .text-7xl .md\\:leading-8.capsize::before, .text-7xl .md\\:leading-8.font-sans.capsize::before, .text-7xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1208em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-8.capsize::before, .font-sans .md\\:text-7xl.leading-8.capsize::before, .font-sans .md\\:text-7xl .leading-8.capsize::before,.md\\:text-7xl .font-sans.leading-8.capsize::before,.md\\:text-7xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1208em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-7xl.capsize::before, .font-sans .md\\:leading-8.text-7xl.capsize::before, .font-sans .text-7xl .md\\:leading-8.capsize::before, .text-7xl .md\\:leading-8.font-sans.capsize::before, .text-7xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1208em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-8.capsize::before, .font-sans .md\\:text-7xl.leading-8.capsize::before, .font-sans .md\\:text-7xl .leading-8.capsize::before,.md\\:text-7xl .font-sans.leading-8.capsize::before,.md\\:text-7xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1208em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-7xl.capsize::before, .font-sans .md\\:leading-8.text-7xl.capsize::before, .font-sans .text-7xl .md\\:leading-8.capsize::before, .text-7xl .md\\:leading-8.font-sans.capsize::before, .text-7xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1208em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-8.capsize::before, .font-sans .md\\:text-7xl.leading-8.capsize::before, .font-sans .md\\:text-7xl .leading-8.capsize::before,.md\\:text-7xl .font-sans.leading-8.capsize::before,.md\\:text-7xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1208em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-7xl.capsize::before, .font-sans .md\\:leading-8.text-7xl.capsize::before, .font-sans .text-7xl .md\\:leading-8.capsize::before, .text-7xl .md\\:leading-8.font-sans.capsize::before, .text-7xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1208em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-8.capsize::before, .font-sans .md\\:text-7xl.leading-8.capsize::before, .font-sans .md\\:text-7xl .leading-8.capsize::before,.md\\:text-7xl .font-sans.leading-8.capsize::before,.md\\:text-7xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1208em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-7xl.capsize::before, .font-sans .md\\:leading-8.text-7xl.capsize::before, .font-sans .text-7xl .md\\:leading-8.capsize::before, .text-7xl .md\\:leading-8.font-sans.capsize::before, .text-7xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1208em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-8.capsize::after, .font-sans .md\\:text-7xl.leading-8.capsize::after, .font-sans .md\\:text-7xl .leading-8.capsize::after,.md\\:text-7xl .font-sans.leading-8.capsize::after,.md\\:text-7xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: 0.1648em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-7xl.capsize::after, .font-sans .md\\:leading-8.text-7xl.capsize::after, .font-sans .text-7xl .md\\:leading-8.capsize::after, .text-7xl .md\\:leading-8.font-sans.capsize::after, .text-7xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.1648em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-8.capsize::after, .font-sans .md\\:text-7xl.leading-8.capsize::after, .font-sans .md\\:text-7xl .leading-8.capsize::after,.md\\:text-7xl .font-sans.leading-8.capsize::after,.md\\:text-7xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: 0.1648em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-7xl.capsize::after, .font-sans .md\\:leading-8.text-7xl.capsize::after, .font-sans .text-7xl .md\\:leading-8.capsize::after, .text-7xl .md\\:leading-8.font-sans.capsize::after, .text-7xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.1648em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-8.capsize::after, .font-sans .md\\:text-7xl.leading-8.capsize::after, .font-sans .md\\:text-7xl .leading-8.capsize::after,.md\\:text-7xl .font-sans.leading-8.capsize::after,.md\\:text-7xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: 0.1648em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-7xl.capsize::after, .font-sans .md\\:leading-8.text-7xl.capsize::after, .font-sans .text-7xl .md\\:leading-8.capsize::after, .text-7xl .md\\:leading-8.font-sans.capsize::after, .text-7xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.1648em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-8.capsize::after, .font-sans .md\\:text-7xl.leading-8.capsize::after, .font-sans .md\\:text-7xl .leading-8.capsize::after,.md\\:text-7xl .font-sans.leading-8.capsize::after,.md\\:text-7xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: 0.1648em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-7xl.capsize::after, .font-sans .md\\:leading-8.text-7xl.capsize::after, .font-sans .text-7xl .md\\:leading-8.capsize::after, .text-7xl .md\\:leading-8.font-sans.capsize::after, .text-7xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.1648em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-8.capsize::after, .font-sans .md\\:text-7xl.leading-8.capsize::after, .font-sans .md\\:text-7xl .leading-8.capsize::after,.md\\:text-7xl .font-sans.leading-8.capsize::after,.md\\:text-7xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: 0.1648em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-7xl.capsize::after, .font-sans .md\\:leading-8.text-7xl.capsize::after, .font-sans .text-7xl .md\\:leading-8.capsize::after, .text-7xl .md\\:leading-8.font-sans.capsize::after, .text-7xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.1648em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-9.capsize::before, .font-sans .md\\:text-7xl.leading-9.capsize::before, .font-sans .md\\:text-7xl .leading-9.capsize::before,.md\\:text-7xl .font-sans.leading-9.capsize::before,.md\\:text-7xl .font-sans .leading-9.capsize::before {
    content: '';
    margin-bottom: 0.093em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-9.capsize::after, .font-sans .md\\:text-7xl.leading-9.capsize::after, .font-sans .md\\:text-7xl .leading-9.capsize::after,.md\\:text-7xl .font-sans.leading-9.capsize::after,.md\\:text-7xl .font-sans .leading-9.capsize::after {
    content: '';
    margin-top: 0.137em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-10.capsize::before, .font-sans .md\\:text-7xl.leading-10.capsize::before, .font-sans .md\\:text-7xl .leading-10.capsize::before,.md\\:text-7xl .font-sans.leading-10.capsize::before,.md\\:text-7xl .font-sans .leading-10.capsize::before {
    content: '';
    margin-bottom: 0.0652em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-10.capsize::after, .font-sans .md\\:text-7xl.leading-10.capsize::after, .font-sans .md\\:text-7xl .leading-10.capsize::after,.md\\:text-7xl .font-sans.leading-10.capsize::after,.md\\:text-7xl .font-sans .leading-10.capsize::after {
    content: '';
    margin-top: 0.1092em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-none.capsize::before, .font-sans .md\\:text-7xl.leading-none.capsize::before, .font-sans .md\\:text-7xl .leading-none.capsize::before,.md\\:text-7xl .font-sans.leading-none.capsize::before,.md\\:text-7xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-7xl.capsize::before, .font-sans .md\\:leading-none.text-7xl.capsize::before, .font-sans .text-7xl .md\\:leading-none.capsize::before, .text-7xl .md\\:leading-none.font-sans.capsize::before, .text-7xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-none.capsize::before, .font-sans .md\\:text-7xl.leading-none.capsize::before, .font-sans .md\\:text-7xl .leading-none.capsize::before,.md\\:text-7xl .font-sans.leading-none.capsize::before,.md\\:text-7xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-7xl.capsize::before, .font-sans .md\\:leading-none.text-7xl.capsize::before, .font-sans .text-7xl .md\\:leading-none.capsize::before, .text-7xl .md\\:leading-none.font-sans.capsize::before, .text-7xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-none.capsize::before, .font-sans .md\\:text-7xl.leading-none.capsize::before, .font-sans .md\\:text-7xl .leading-none.capsize::before,.md\\:text-7xl .font-sans.leading-none.capsize::before,.md\\:text-7xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-7xl.capsize::before, .font-sans .md\\:leading-none.text-7xl.capsize::before, .font-sans .text-7xl .md\\:leading-none.capsize::before, .text-7xl .md\\:leading-none.font-sans.capsize::before, .text-7xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-none.capsize::before, .font-sans .md\\:text-7xl.leading-none.capsize::before, .font-sans .md\\:text-7xl .leading-none.capsize::before,.md\\:text-7xl .font-sans.leading-none.capsize::before,.md\\:text-7xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-7xl.capsize::before, .font-sans .md\\:leading-none.text-7xl.capsize::before, .font-sans .text-7xl .md\\:leading-none.capsize::before, .text-7xl .md\\:leading-none.font-sans.capsize::before, .text-7xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-none.capsize::before, .font-sans .md\\:text-7xl.leading-none.capsize::before, .font-sans .md\\:text-7xl .leading-none.capsize::before,.md\\:text-7xl .font-sans.leading-none.capsize::before,.md\\:text-7xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-7xl.capsize::before, .font-sans .md\\:leading-none.text-7xl.capsize::before, .font-sans .text-7xl .md\\:leading-none.capsize::before, .text-7xl .md\\:leading-none.font-sans.capsize::before, .text-7xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-none.capsize::after, .font-sans .md\\:text-7xl.leading-none.capsize::after, .font-sans .md\\:text-7xl .leading-none.capsize::after,.md\\:text-7xl .font-sans.leading-none.capsize::after,.md\\:text-7xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-7xl.capsize::after, .font-sans .md\\:leading-none.text-7xl.capsize::after, .font-sans .text-7xl .md\\:leading-none.capsize::after, .text-7xl .md\\:leading-none.font-sans.capsize::after, .text-7xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-none.capsize::after, .font-sans .md\\:text-7xl.leading-none.capsize::after, .font-sans .md\\:text-7xl .leading-none.capsize::after,.md\\:text-7xl .font-sans.leading-none.capsize::after,.md\\:text-7xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-7xl.capsize::after, .font-sans .md\\:leading-none.text-7xl.capsize::after, .font-sans .text-7xl .md\\:leading-none.capsize::after, .text-7xl .md\\:leading-none.font-sans.capsize::after, .text-7xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-none.capsize::after, .font-sans .md\\:text-7xl.leading-none.capsize::after, .font-sans .md\\:text-7xl .leading-none.capsize::after,.md\\:text-7xl .font-sans.leading-none.capsize::after,.md\\:text-7xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-7xl.capsize::after, .font-sans .md\\:leading-none.text-7xl.capsize::after, .font-sans .text-7xl .md\\:leading-none.capsize::after, .text-7xl .md\\:leading-none.font-sans.capsize::after, .text-7xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-none.capsize::after, .font-sans .md\\:text-7xl.leading-none.capsize::after, .font-sans .md\\:text-7xl .leading-none.capsize::after,.md\\:text-7xl .font-sans.leading-none.capsize::after,.md\\:text-7xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-7xl.capsize::after, .font-sans .md\\:leading-none.text-7xl.capsize::after, .font-sans .text-7xl .md\\:leading-none.capsize::after, .text-7xl .md\\:leading-none.font-sans.capsize::after, .text-7xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-none.capsize::after, .font-sans .md\\:text-7xl.leading-none.capsize::after, .font-sans .md\\:text-7xl .leading-none.capsize::after,.md\\:text-7xl .font-sans.leading-none.capsize::after,.md\\:text-7xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-7xl.capsize::after, .font-sans .md\\:leading-none.text-7xl.capsize::after, .font-sans .text-7xl .md\\:leading-none.capsize::after, .text-7xl .md\\:leading-none.font-sans.capsize::after, .text-7xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-7xl.leading-tight.capsize::before, .font-sans .md\\:text-7xl .leading-tight.capsize::before,.md\\:text-7xl .font-sans.leading-tight.capsize::before,.md\\:text-7xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-7xl.capsize::before, .font-sans .md\\:leading-tight.text-7xl.capsize::before, .font-sans .text-7xl .md\\:leading-tight.capsize::before, .text-7xl .md\\:leading-tight.font-sans.capsize::before, .text-7xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-7xl.leading-tight.capsize::before, .font-sans .md\\:text-7xl .leading-tight.capsize::before,.md\\:text-7xl .font-sans.leading-tight.capsize::before,.md\\:text-7xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-7xl.capsize::before, .font-sans .md\\:leading-tight.text-7xl.capsize::before, .font-sans .text-7xl .md\\:leading-tight.capsize::before, .text-7xl .md\\:leading-tight.font-sans.capsize::before, .text-7xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-7xl.leading-tight.capsize::before, .font-sans .md\\:text-7xl .leading-tight.capsize::before,.md\\:text-7xl .font-sans.leading-tight.capsize::before,.md\\:text-7xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-7xl.capsize::before, .font-sans .md\\:leading-tight.text-7xl.capsize::before, .font-sans .text-7xl .md\\:leading-tight.capsize::before, .text-7xl .md\\:leading-tight.font-sans.capsize::before, .text-7xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-7xl.leading-tight.capsize::before, .font-sans .md\\:text-7xl .leading-tight.capsize::before,.md\\:text-7xl .font-sans.leading-tight.capsize::before,.md\\:text-7xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-7xl.capsize::before, .font-sans .md\\:leading-tight.text-7xl.capsize::before, .font-sans .text-7xl .md\\:leading-tight.capsize::before, .text-7xl .md\\:leading-tight.font-sans.capsize::before, .text-7xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-7xl.leading-tight.capsize::before, .font-sans .md\\:text-7xl .leading-tight.capsize::before,.md\\:text-7xl .font-sans.leading-tight.capsize::before,.md\\:text-7xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-7xl.capsize::before, .font-sans .md\\:leading-tight.text-7xl.capsize::before, .font-sans .text-7xl .md\\:leading-tight.capsize::before, .text-7xl .md\\:leading-tight.font-sans.capsize::before, .text-7xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-7xl.leading-tight.capsize::after, .font-sans .md\\:text-7xl .leading-tight.capsize::after,.md\\:text-7xl .font-sans.leading-tight.capsize::after,.md\\:text-7xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-7xl.capsize::after, .font-sans .md\\:leading-tight.text-7xl.capsize::after, .font-sans .text-7xl .md\\:leading-tight.capsize::after, .text-7xl .md\\:leading-tight.font-sans.capsize::after, .text-7xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-7xl.leading-tight.capsize::after, .font-sans .md\\:text-7xl .leading-tight.capsize::after,.md\\:text-7xl .font-sans.leading-tight.capsize::after,.md\\:text-7xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-7xl.capsize::after, .font-sans .md\\:leading-tight.text-7xl.capsize::after, .font-sans .text-7xl .md\\:leading-tight.capsize::after, .text-7xl .md\\:leading-tight.font-sans.capsize::after, .text-7xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-7xl.leading-tight.capsize::after, .font-sans .md\\:text-7xl .leading-tight.capsize::after,.md\\:text-7xl .font-sans.leading-tight.capsize::after,.md\\:text-7xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-7xl.capsize::after, .font-sans .md\\:leading-tight.text-7xl.capsize::after, .font-sans .text-7xl .md\\:leading-tight.capsize::after, .text-7xl .md\\:leading-tight.font-sans.capsize::after, .text-7xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-7xl.leading-tight.capsize::after, .font-sans .md\\:text-7xl .leading-tight.capsize::after,.md\\:text-7xl .font-sans.leading-tight.capsize::after,.md\\:text-7xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-7xl.capsize::after, .font-sans .md\\:leading-tight.text-7xl.capsize::after, .font-sans .text-7xl .md\\:leading-tight.capsize::after, .text-7xl .md\\:leading-tight.font-sans.capsize::after, .text-7xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-7xl.leading-tight.capsize::after, .font-sans .md\\:text-7xl .leading-tight.capsize::after,.md\\:text-7xl .font-sans.leading-tight.capsize::after,.md\\:text-7xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-7xl.capsize::after, .font-sans .md\\:leading-tight.text-7xl.capsize::after, .font-sans .text-7xl .md\\:leading-tight.capsize::after, .text-7xl .md\\:leading-tight.font-sans.capsize::after, .text-7xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-snug.capsize::before, .font-sans .md\\:text-7xl.leading-snug.capsize::before, .font-sans .md\\:text-7xl .leading-snug.capsize::before,.md\\:text-7xl .font-sans.leading-snug.capsize::before,.md\\:text-7xl .font-sans .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3445em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-snug.capsize::after, .font-sans .md\\:text-7xl.leading-snug.capsize::after, .font-sans .md\\:text-7xl .leading-snug.capsize::after,.md\\:text-7xl .font-sans.leading-snug.capsize::after,.md\\:text-7xl .font-sans .leading-snug.capsize::after {
    content: '';
    margin-top: -0.3005em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-normal.capsize::before, .font-sans .md\\:text-7xl.leading-normal.capsize::before, .font-sans .md\\:text-7xl .leading-normal.capsize::before,.md\\:text-7xl .font-sans.leading-normal.capsize::before,.md\\:text-7xl .font-sans .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-normal.capsize::after, .font-sans .md\\:text-7xl.leading-normal.capsize::after, .font-sans .md\\:text-7xl .leading-normal.capsize::after,.md\\:text-7xl .font-sans.leading-normal.capsize::after,.md\\:text-7xl .font-sans .leading-normal.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-relaxed.capsize::before, .font-sans .md\\:text-7xl.leading-relaxed.capsize::before, .font-sans .md\\:text-7xl .leading-relaxed.capsize::before,.md\\:text-7xl .font-sans.leading-relaxed.capsize::before,.md\\:text-7xl .font-sans .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4695em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-relaxed.capsize::after, .font-sans .md\\:text-7xl.leading-relaxed.capsize::after, .font-sans .md\\:text-7xl .leading-relaxed.capsize::after,.md\\:text-7xl .font-sans.leading-relaxed.capsize::after,.md\\:text-7xl .font-sans .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4255em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-loose.capsize::before, .font-sans .md\\:text-7xl.leading-loose.capsize::before, .font-sans .md\\:text-7xl .leading-loose.capsize::before,.md\\:text-7xl .font-sans.leading-loose.capsize::before,.md\\:text-7xl .font-sans .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .md\\:text-7xl.font-sans.leading-loose.capsize::after, .font-sans .md\\:text-7xl.leading-loose.capsize::after, .font-sans .md\\:text-7xl .leading-loose.capsize::after,.md\\:text-7xl .font-sans.leading-loose.capsize::after,.md\\:text-7xl .font-sans .leading-loose.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-8xl.capsize::before, .font-sans .md\\:leading-8.text-8xl.capsize::before, .font-sans .text-8xl .md\\:leading-8.capsize::before, .text-8xl .md\\:leading-8.font-sans.capsize::before, .text-8xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1763em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-8xl.capsize::after, .font-sans .md\\:leading-8.text-8xl.capsize::after, .font-sans .text-8xl .md\\:leading-8.capsize::after, .text-8xl .md\\:leading-8.font-sans.capsize::after, .text-8xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.2203em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-8xl.capsize::before, .font-sans .md\\:leading-none.text-8xl.capsize::before, .font-sans .text-8xl .md\\:leading-none.capsize::before, .text-8xl .md\\:leading-none.font-sans.capsize::before, .text-8xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-8xl.capsize::after, .font-sans .md\\:leading-none.text-8xl.capsize::after, .font-sans .text-8xl .md\\:leading-none.capsize::after, .text-8xl .md\\:leading-none.font-sans.capsize::after, .text-8xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-8xl.capsize::before, .font-sans .md\\:leading-tight.text-8xl.capsize::before, .font-sans .text-8xl .md\\:leading-tight.capsize::before, .text-8xl .md\\:leading-tight.font-sans.capsize::before, .text-8xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-8xl.capsize::after, .font-sans .md\\:leading-tight.text-8xl.capsize::after, .font-sans .text-8xl .md\\:leading-tight.capsize::after, .text-8xl .md\\:leading-tight.font-sans.capsize::after, .text-8xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-9xl.capsize::before, .font-sans .md\\:leading-8.text-9xl.capsize::before, .font-sans .text-9xl .md\\:leading-8.capsize::before, .text-9xl .md\\:leading-8.font-sans.capsize::before, .text-9xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.218em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-9xl.capsize::after, .font-sans .md\\:leading-8.text-9xl.capsize::after, .font-sans .text-9xl .md\\:leading-8.capsize::after, .text-9xl .md\\:leading-8.font-sans.capsize::after, .text-9xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.262em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-9xl.capsize::before, .font-sans .md\\:leading-none.text-9xl.capsize::before, .font-sans .text-9xl .md\\:leading-none.capsize::before, .text-9xl .md\\:leading-none.font-sans.capsize::before, .text-9xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-9xl.capsize::after, .font-sans .md\\:leading-none.text-9xl.capsize::after, .font-sans .text-9xl .md\\:leading-none.capsize::after, .text-9xl .md\\:leading-none.font-sans.capsize::after, .text-9xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-9xl.capsize::before, .font-sans .md\\:leading-tight.text-9xl.capsize::before, .font-sans .text-9xl .md\\:leading-tight.capsize::before, .text-9xl .md\\:leading-tight.font-sans.capsize::before, .text-9xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-9xl.capsize::after, .font-sans .md\\:leading-tight.text-9xl.capsize::after, .font-sans .text-9xl .md\\:leading-tight.capsize::after, .text-9xl .md\\:leading-tight.font-sans.capsize::after, .text-9xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-3.capsize::before, .font-sans .md\\:text-1xl.leading-3.capsize::before, .font-sans .md\\:text-1xl .leading-3.capsize::before,.md\\:text-1xl .font-sans.leading-3.capsize::before,.md\\:text-1xl .font-sans .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.0703em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-3.capsize::after, .font-sans .md\\:text-1xl.leading-3.capsize::after, .font-sans .md\\:text-1xl .leading-3.capsize::after,.md\\:text-1xl .font-sans.leading-3.capsize::after,.md\\:text-1xl .font-sans .leading-3.capsize::after {
    content: '';
    margin-top: 0.1143em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-4.capsize::before, .font-sans .md\\:text-1xl.leading-4.capsize::before, .font-sans .md\\:text-1xl .leading-4.capsize::before,.md\\:text-1xl .font-sans.leading-4.capsize::before,.md\\:text-1xl .font-sans .leading-4.capsize::before {
    content: '';
    margin-bottom: -0.0206em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-4.capsize::after, .font-sans .md\\:text-1xl.leading-4.capsize::after, .font-sans .md\\:text-1xl .leading-4.capsize::after,.md\\:text-1xl .font-sans.leading-4.capsize::after,.md\\:text-1xl .font-sans .leading-4.capsize::after {
    content: '';
    margin-top: 0.0234em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-5.capsize::before, .font-sans .md\\:text-1xl.leading-5.capsize::before, .font-sans .md\\:text-1xl .leading-5.capsize::before,.md\\:text-1xl .font-sans.leading-5.capsize::before,.md\\:text-1xl .font-sans .leading-5.capsize::before {
    content: '';
    margin-bottom: -0.1115em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-5.capsize::after, .font-sans .md\\:text-1xl.leading-5.capsize::after, .font-sans .md\\:text-1xl .leading-5.capsize::after,.md\\:text-1xl .font-sans.leading-5.capsize::after,.md\\:text-1xl .font-sans .leading-5.capsize::after {
    content: '';
    margin-top: -0.0675em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-6.capsize::before, .font-sans .md\\:text-1xl.leading-6.capsize::before, .font-sans .md\\:text-1xl .leading-6.capsize::before,.md\\:text-1xl .font-sans.leading-6.capsize::before,.md\\:text-1xl .font-sans .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.2025em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-6.capsize::after, .font-sans .md\\:text-1xl.leading-6.capsize::after, .font-sans .md\\:text-1xl .leading-6.capsize::after,.md\\:text-1xl .font-sans.leading-6.capsize::after,.md\\:text-1xl .font-sans .leading-6.capsize::after {
    content: '';
    margin-top: -0.1585em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-7.capsize::before, .font-sans .md\\:text-1xl.leading-7.capsize::before, .font-sans .md\\:text-1xl .leading-7.capsize::before,.md\\:text-1xl .font-sans.leading-7.capsize::before,.md\\:text-1xl .font-sans .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.2934em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-7.capsize::after, .font-sans .md\\:text-1xl.leading-7.capsize::after, .font-sans .md\\:text-1xl .leading-7.capsize::after,.md\\:text-1xl .font-sans.leading-7.capsize::after,.md\\:text-1xl .font-sans .leading-7.capsize::after {
    content: '';
    margin-top: -0.2494em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-8.capsize::before, .font-sans .md\\:text-1xl.leading-8.capsize::before, .font-sans .md\\:text-1xl .leading-8.capsize::before,.md\\:text-1xl .font-sans.leading-8.capsize::before,.md\\:text-1xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.3843em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-1xl.capsize::before, .font-sans .md\\:leading-8.text-1xl.capsize::before, .font-sans .text-1xl .md\\:leading-8.capsize::before, .text-1xl .md\\:leading-8.font-sans.capsize::before, .text-1xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.3843em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-8.capsize::before, .font-sans .md\\:text-1xl.leading-8.capsize::before, .font-sans .md\\:text-1xl .leading-8.capsize::before,.md\\:text-1xl .font-sans.leading-8.capsize::before,.md\\:text-1xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.3843em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-1xl.capsize::before, .font-sans .md\\:leading-8.text-1xl.capsize::before, .font-sans .text-1xl .md\\:leading-8.capsize::before, .text-1xl .md\\:leading-8.font-sans.capsize::before, .text-1xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.3843em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-8.capsize::before, .font-sans .md\\:text-1xl.leading-8.capsize::before, .font-sans .md\\:text-1xl .leading-8.capsize::before,.md\\:text-1xl .font-sans.leading-8.capsize::before,.md\\:text-1xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.3843em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-1xl.capsize::before, .font-sans .md\\:leading-8.text-1xl.capsize::before, .font-sans .text-1xl .md\\:leading-8.capsize::before, .text-1xl .md\\:leading-8.font-sans.capsize::before, .text-1xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.3843em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-8.capsize::before, .font-sans .md\\:text-1xl.leading-8.capsize::before, .font-sans .md\\:text-1xl .leading-8.capsize::before,.md\\:text-1xl .font-sans.leading-8.capsize::before,.md\\:text-1xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.3843em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-1xl.capsize::before, .font-sans .md\\:leading-8.text-1xl.capsize::before, .font-sans .text-1xl .md\\:leading-8.capsize::before, .text-1xl .md\\:leading-8.font-sans.capsize::before, .text-1xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.3843em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-8.capsize::before, .font-sans .md\\:text-1xl.leading-8.capsize::before, .font-sans .md\\:text-1xl .leading-8.capsize::before,.md\\:text-1xl .font-sans.leading-8.capsize::before,.md\\:text-1xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.3843em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-1xl.capsize::before, .font-sans .md\\:leading-8.text-1xl.capsize::before, .font-sans .text-1xl .md\\:leading-8.capsize::before, .text-1xl .md\\:leading-8.font-sans.capsize::before, .text-1xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.3843em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-8.capsize::after, .font-sans .md\\:text-1xl.leading-8.capsize::after, .font-sans .md\\:text-1xl .leading-8.capsize::after,.md\\:text-1xl .font-sans.leading-8.capsize::after,.md\\:text-1xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.3403em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-1xl.capsize::after, .font-sans .md\\:leading-8.text-1xl.capsize::after, .font-sans .text-1xl .md\\:leading-8.capsize::after, .text-1xl .md\\:leading-8.font-sans.capsize::after, .text-1xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.3403em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-8.capsize::after, .font-sans .md\\:text-1xl.leading-8.capsize::after, .font-sans .md\\:text-1xl .leading-8.capsize::after,.md\\:text-1xl .font-sans.leading-8.capsize::after,.md\\:text-1xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.3403em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-1xl.capsize::after, .font-sans .md\\:leading-8.text-1xl.capsize::after, .font-sans .text-1xl .md\\:leading-8.capsize::after, .text-1xl .md\\:leading-8.font-sans.capsize::after, .text-1xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.3403em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-8.capsize::after, .font-sans .md\\:text-1xl.leading-8.capsize::after, .font-sans .md\\:text-1xl .leading-8.capsize::after,.md\\:text-1xl .font-sans.leading-8.capsize::after,.md\\:text-1xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.3403em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-1xl.capsize::after, .font-sans .md\\:leading-8.text-1xl.capsize::after, .font-sans .text-1xl .md\\:leading-8.capsize::after, .text-1xl .md\\:leading-8.font-sans.capsize::after, .text-1xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.3403em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-8.capsize::after, .font-sans .md\\:text-1xl.leading-8.capsize::after, .font-sans .md\\:text-1xl .leading-8.capsize::after,.md\\:text-1xl .font-sans.leading-8.capsize::after,.md\\:text-1xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.3403em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-1xl.capsize::after, .font-sans .md\\:leading-8.text-1xl.capsize::after, .font-sans .text-1xl .md\\:leading-8.capsize::after, .text-1xl .md\\:leading-8.font-sans.capsize::after, .text-1xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.3403em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-8.capsize::after, .font-sans .md\\:text-1xl.leading-8.capsize::after, .font-sans .md\\:text-1xl .leading-8.capsize::after,.md\\:text-1xl .font-sans.leading-8.capsize::after,.md\\:text-1xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.3403em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-1xl.capsize::after, .font-sans .md\\:leading-8.text-1xl.capsize::after, .font-sans .text-1xl .md\\:leading-8.capsize::after, .text-1xl .md\\:leading-8.font-sans.capsize::after, .text-1xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.3403em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-9.capsize::before, .font-sans .md\\:text-1xl.leading-9.capsize::before, .font-sans .md\\:text-1xl .leading-9.capsize::before,.md\\:text-1xl .font-sans.leading-9.capsize::before,.md\\:text-1xl .font-sans .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.4752em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-9.capsize::after, .font-sans .md\\:text-1xl.leading-9.capsize::after, .font-sans .md\\:text-1xl .leading-9.capsize::after,.md\\:text-1xl .font-sans.leading-9.capsize::after,.md\\:text-1xl .font-sans .leading-9.capsize::after {
    content: '';
    margin-top: -0.4312em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-10.capsize::before, .font-sans .md\\:text-1xl.leading-10.capsize::before, .font-sans .md\\:text-1xl .leading-10.capsize::before,.md\\:text-1xl .font-sans.leading-10.capsize::before,.md\\:text-1xl .font-sans .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.5661em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-10.capsize::after, .font-sans .md\\:text-1xl.leading-10.capsize::after, .font-sans .md\\:text-1xl .leading-10.capsize::after,.md\\:text-1xl .font-sans.leading-10.capsize::after,.md\\:text-1xl .font-sans .leading-10.capsize::after {
    content: '';
    margin-top: -0.5221em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-none.capsize::before, .font-sans .md\\:text-1xl.leading-none.capsize::before, .font-sans .md\\:text-1xl .leading-none.capsize::before,.md\\:text-1xl .font-sans.leading-none.capsize::before,.md\\:text-1xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-1xl.capsize::before, .font-sans .md\\:leading-none.text-1xl.capsize::before, .font-sans .text-1xl .md\\:leading-none.capsize::before, .text-1xl .md\\:leading-none.font-sans.capsize::before, .text-1xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-none.capsize::before, .font-sans .md\\:text-1xl.leading-none.capsize::before, .font-sans .md\\:text-1xl .leading-none.capsize::before,.md\\:text-1xl .font-sans.leading-none.capsize::before,.md\\:text-1xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-1xl.capsize::before, .font-sans .md\\:leading-none.text-1xl.capsize::before, .font-sans .text-1xl .md\\:leading-none.capsize::before, .text-1xl .md\\:leading-none.font-sans.capsize::before, .text-1xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-none.capsize::before, .font-sans .md\\:text-1xl.leading-none.capsize::before, .font-sans .md\\:text-1xl .leading-none.capsize::before,.md\\:text-1xl .font-sans.leading-none.capsize::before,.md\\:text-1xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-1xl.capsize::before, .font-sans .md\\:leading-none.text-1xl.capsize::before, .font-sans .text-1xl .md\\:leading-none.capsize::before, .text-1xl .md\\:leading-none.font-sans.capsize::before, .text-1xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-none.capsize::before, .font-sans .md\\:text-1xl.leading-none.capsize::before, .font-sans .md\\:text-1xl .leading-none.capsize::before,.md\\:text-1xl .font-sans.leading-none.capsize::before,.md\\:text-1xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-1xl.capsize::before, .font-sans .md\\:leading-none.text-1xl.capsize::before, .font-sans .text-1xl .md\\:leading-none.capsize::before, .text-1xl .md\\:leading-none.font-sans.capsize::before, .text-1xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-none.capsize::before, .font-sans .md\\:text-1xl.leading-none.capsize::before, .font-sans .md\\:text-1xl .leading-none.capsize::before,.md\\:text-1xl .font-sans.leading-none.capsize::before,.md\\:text-1xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-1xl.capsize::before, .font-sans .md\\:leading-none.text-1xl.capsize::before, .font-sans .text-1xl .md\\:leading-none.capsize::before, .text-1xl .md\\:leading-none.font-sans.capsize::before, .text-1xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-none.capsize::after, .font-sans .md\\:text-1xl.leading-none.capsize::after, .font-sans .md\\:text-1xl .leading-none.capsize::after,.md\\:text-1xl .font-sans.leading-none.capsize::after,.md\\:text-1xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-1xl.capsize::after, .font-sans .md\\:leading-none.text-1xl.capsize::after, .font-sans .text-1xl .md\\:leading-none.capsize::after, .text-1xl .md\\:leading-none.font-sans.capsize::after, .text-1xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-none.capsize::after, .font-sans .md\\:text-1xl.leading-none.capsize::after, .font-sans .md\\:text-1xl .leading-none.capsize::after,.md\\:text-1xl .font-sans.leading-none.capsize::after,.md\\:text-1xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-1xl.capsize::after, .font-sans .md\\:leading-none.text-1xl.capsize::after, .font-sans .text-1xl .md\\:leading-none.capsize::after, .text-1xl .md\\:leading-none.font-sans.capsize::after, .text-1xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-none.capsize::after, .font-sans .md\\:text-1xl.leading-none.capsize::after, .font-sans .md\\:text-1xl .leading-none.capsize::after,.md\\:text-1xl .font-sans.leading-none.capsize::after,.md\\:text-1xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-1xl.capsize::after, .font-sans .md\\:leading-none.text-1xl.capsize::after, .font-sans .text-1xl .md\\:leading-none.capsize::after, .text-1xl .md\\:leading-none.font-sans.capsize::after, .text-1xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-none.capsize::after, .font-sans .md\\:text-1xl.leading-none.capsize::after, .font-sans .md\\:text-1xl .leading-none.capsize::after,.md\\:text-1xl .font-sans.leading-none.capsize::after,.md\\:text-1xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-1xl.capsize::after, .font-sans .md\\:leading-none.text-1xl.capsize::after, .font-sans .text-1xl .md\\:leading-none.capsize::after, .text-1xl .md\\:leading-none.font-sans.capsize::after, .text-1xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-none.capsize::after, .font-sans .md\\:text-1xl.leading-none.capsize::after, .font-sans .md\\:text-1xl .leading-none.capsize::after,.md\\:text-1xl .font-sans.leading-none.capsize::after,.md\\:text-1xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-1xl.capsize::after, .font-sans .md\\:leading-none.text-1xl.capsize::after, .font-sans .text-1xl .md\\:leading-none.capsize::after, .text-1xl .md\\:leading-none.font-sans.capsize::after, .text-1xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-1xl.leading-tight.capsize::before, .font-sans .md\\:text-1xl .leading-tight.capsize::before,.md\\:text-1xl .font-sans.leading-tight.capsize::before,.md\\:text-1xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-1xl.capsize::before, .font-sans .md\\:leading-tight.text-1xl.capsize::before, .font-sans .text-1xl .md\\:leading-tight.capsize::before, .text-1xl .md\\:leading-tight.font-sans.capsize::before, .text-1xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-1xl.leading-tight.capsize::before, .font-sans .md\\:text-1xl .leading-tight.capsize::before,.md\\:text-1xl .font-sans.leading-tight.capsize::before,.md\\:text-1xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-1xl.capsize::before, .font-sans .md\\:leading-tight.text-1xl.capsize::before, .font-sans .text-1xl .md\\:leading-tight.capsize::before, .text-1xl .md\\:leading-tight.font-sans.capsize::before, .text-1xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-1xl.leading-tight.capsize::before, .font-sans .md\\:text-1xl .leading-tight.capsize::before,.md\\:text-1xl .font-sans.leading-tight.capsize::before,.md\\:text-1xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-1xl.capsize::before, .font-sans .md\\:leading-tight.text-1xl.capsize::before, .font-sans .text-1xl .md\\:leading-tight.capsize::before, .text-1xl .md\\:leading-tight.font-sans.capsize::before, .text-1xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-1xl.leading-tight.capsize::before, .font-sans .md\\:text-1xl .leading-tight.capsize::before,.md\\:text-1xl .font-sans.leading-tight.capsize::before,.md\\:text-1xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-1xl.capsize::before, .font-sans .md\\:leading-tight.text-1xl.capsize::before, .font-sans .text-1xl .md\\:leading-tight.capsize::before, .text-1xl .md\\:leading-tight.font-sans.capsize::before, .text-1xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-tight.capsize::before, .font-sans .md\\:text-1xl.leading-tight.capsize::before, .font-sans .md\\:text-1xl .leading-tight.capsize::before,.md\\:text-1xl .font-sans.leading-tight.capsize::before,.md\\:text-1xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-1xl.capsize::before, .font-sans .md\\:leading-tight.text-1xl.capsize::before, .font-sans .text-1xl .md\\:leading-tight.capsize::before, .text-1xl .md\\:leading-tight.font-sans.capsize::before, .text-1xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-1xl.leading-tight.capsize::after, .font-sans .md\\:text-1xl .leading-tight.capsize::after,.md\\:text-1xl .font-sans.leading-tight.capsize::after,.md\\:text-1xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-1xl.capsize::after, .font-sans .md\\:leading-tight.text-1xl.capsize::after, .font-sans .text-1xl .md\\:leading-tight.capsize::after, .text-1xl .md\\:leading-tight.font-sans.capsize::after, .text-1xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-1xl.leading-tight.capsize::after, .font-sans .md\\:text-1xl .leading-tight.capsize::after,.md\\:text-1xl .font-sans.leading-tight.capsize::after,.md\\:text-1xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-1xl.capsize::after, .font-sans .md\\:leading-tight.text-1xl.capsize::after, .font-sans .text-1xl .md\\:leading-tight.capsize::after, .text-1xl .md\\:leading-tight.font-sans.capsize::after, .text-1xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-1xl.leading-tight.capsize::after, .font-sans .md\\:text-1xl .leading-tight.capsize::after,.md\\:text-1xl .font-sans.leading-tight.capsize::after,.md\\:text-1xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-1xl.capsize::after, .font-sans .md\\:leading-tight.text-1xl.capsize::after, .font-sans .text-1xl .md\\:leading-tight.capsize::after, .text-1xl .md\\:leading-tight.font-sans.capsize::after, .text-1xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-1xl.leading-tight.capsize::after, .font-sans .md\\:text-1xl .leading-tight.capsize::after,.md\\:text-1xl .font-sans.leading-tight.capsize::after,.md\\:text-1xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-1xl.capsize::after, .font-sans .md\\:leading-tight.text-1xl.capsize::after, .font-sans .text-1xl .md\\:leading-tight.capsize::after, .text-1xl .md\\:leading-tight.font-sans.capsize::after, .text-1xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-tight.capsize::after, .font-sans .md\\:text-1xl.leading-tight.capsize::after, .font-sans .md\\:text-1xl .leading-tight.capsize::after,.md\\:text-1xl .font-sans.leading-tight.capsize::after,.md\\:text-1xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-1xl.capsize::after, .font-sans .md\\:leading-tight.text-1xl.capsize::after, .font-sans .text-1xl .md\\:leading-tight.capsize::after, .text-1xl .md\\:leading-tight.font-sans.capsize::after, .text-1xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-snug.capsize::before, .font-sans .md\\:text-1xl.leading-snug.capsize::before, .font-sans .md\\:text-1xl .leading-snug.capsize::before,.md\\:text-1xl .font-sans.leading-snug.capsize::before,.md\\:text-1xl .font-sans .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3445em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-snug.capsize::after, .font-sans .md\\:text-1xl.leading-snug.capsize::after, .font-sans .md\\:text-1xl .leading-snug.capsize::after,.md\\:text-1xl .font-sans.leading-snug.capsize::after,.md\\:text-1xl .font-sans .leading-snug.capsize::after {
    content: '';
    margin-top: -0.3005em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-normal.capsize::before, .font-sans .md\\:text-1xl.leading-normal.capsize::before, .font-sans .md\\:text-1xl .leading-normal.capsize::before,.md\\:text-1xl .font-sans.leading-normal.capsize::before,.md\\:text-1xl .font-sans .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-normal.capsize::after, .font-sans .md\\:text-1xl.leading-normal.capsize::after, .font-sans .md\\:text-1xl .leading-normal.capsize::after,.md\\:text-1xl .font-sans.leading-normal.capsize::after,.md\\:text-1xl .font-sans .leading-normal.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-relaxed.capsize::before, .font-sans .md\\:text-1xl.leading-relaxed.capsize::before, .font-sans .md\\:text-1xl .leading-relaxed.capsize::before,.md\\:text-1xl .font-sans.leading-relaxed.capsize::before,.md\\:text-1xl .font-sans .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4695em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-relaxed.capsize::after, .font-sans .md\\:text-1xl.leading-relaxed.capsize::after, .font-sans .md\\:text-1xl .leading-relaxed.capsize::after,.md\\:text-1xl .font-sans.leading-relaxed.capsize::after,.md\\:text-1xl .font-sans .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4255em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-loose.capsize::before, .font-sans .md\\:text-1xl.leading-loose.capsize::before, .font-sans .md\\:text-1xl .leading-loose.capsize::before,.md\\:text-1xl .font-sans.leading-loose.capsize::before,.md\\:text-1xl .font-sans .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .md\\:text-1xl.font-sans.leading-loose.capsize::after, .font-sans .md\\:text-1xl.leading-loose.capsize::after, .font-sans .md\\:text-1xl .leading-loose.capsize::after,.md\\:text-1xl .font-sans.leading-loose.capsize::after,.md\\:text-1xl .font-sans .leading-loose.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-3.3xl.capsize::before, .font-sans .md\\:leading-8.text-3.3xl.capsize::before, .font-sans .text-3.3xl .md\\:leading-8.capsize::before, .text-3.3xl .md\\:leading-8.font-sans.capsize::before, .text-3.3xl .font-sans .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-8.font-sans.text-3.3xl.capsize::after, .font-sans .md\\:leading-8.text-3.3xl.capsize::after, .font-sans .text-3.3xl .md\\:leading-8.capsize::after, .text-3.3xl .md\\:leading-8.font-sans.capsize::after, .text-3.3xl .font-sans .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-3.3xl.capsize::before, .font-sans .md\\:leading-none.text-3.3xl.capsize::before, .font-sans .text-3.3xl .md\\:leading-none.capsize::before, .text-3.3xl .md\\:leading-none.font-sans.capsize::before, .text-3.3xl .font-sans .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .md\\:leading-none.font-sans.text-3.3xl.capsize::after, .font-sans .md\\:leading-none.text-3.3xl.capsize::after, .font-sans .text-3.3xl .md\\:leading-none.capsize::after, .text-3.3xl .md\\:leading-none.font-sans.capsize::after, .text-3.3xl .font-sans .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-3.3xl.capsize::before, .font-sans .md\\:leading-tight.text-3.3xl.capsize::before, .font-sans .text-3.3xl .md\\:leading-tight.capsize::before, .text-3.3xl .md\\:leading-tight.font-sans.capsize::before, .text-3.3xl .font-sans .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .md\\:leading-tight.font-sans.text-3.3xl.capsize::after, .font-sans .md\\:leading-tight.text-3.3xl.capsize::after, .font-sans .text-3.3xl .md\\:leading-tight.capsize::after, .text-3.3xl .md\\:leading-tight.font-sans.capsize::after, .text-3.3xl .font-sans .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-xs.capsize::before, .font-serif .md\\:leading-8.text-xs.capsize::before, .font-serif .text-xs .md\\:leading-8.capsize::before, .text-xs .md\\:leading-8.font-serif.capsize::before, .text-xs .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.9533em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-xs.capsize::after, .font-serif .md\\:leading-8.text-xs.capsize::after, .font-serif .text-xs .md\\:leading-8.capsize::after, .text-xs .md\\:leading-8.font-serif.capsize::after, .text-xs .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.9333em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-xs.capsize::before, .font-serif .md\\:leading-none.text-xs.capsize::before, .font-serif .text-xs .md\\:leading-none.capsize::before, .text-xs .md\\:leading-none.font-serif.capsize::before, .text-xs .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-xs.capsize::after, .font-serif .md\\:leading-none.text-xs.capsize::after, .font-serif .text-xs .md\\:leading-none.capsize::after, .text-xs .md\\:leading-none.font-serif.capsize::after, .text-xs .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-xs.capsize::before, .font-serif .md\\:leading-tight.text-xs.capsize::before, .font-serif .text-xs .md\\:leading-tight.capsize::before, .text-xs .md\\:leading-tight.font-serif.capsize::before, .text-xs .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-xs.capsize::after, .font-serif .md\\:leading-tight.text-xs.capsize::after, .font-serif .text-xs .md\\:leading-tight.capsize::after, .text-xs .md\\:leading-tight.font-serif.capsize::after, .text-xs .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-sm.capsize::before, .font-serif .md\\:leading-8.text-sm.capsize::before, .font-serif .text-sm .md\\:leading-8.capsize::before, .text-sm .md\\:leading-8.font-serif.capsize::before, .text-sm .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.7629em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-sm.capsize::after, .font-serif .md\\:leading-8.text-sm.capsize::after, .font-serif .text-sm .md\\:leading-8.capsize::after, .text-sm .md\\:leading-8.font-serif.capsize::after, .text-sm .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.7429em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-sm.capsize::before, .font-serif .md\\:leading-none.text-sm.capsize::before, .font-serif .text-sm .md\\:leading-none.capsize::before, .text-sm .md\\:leading-none.font-serif.capsize::before, .text-sm .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-sm.capsize::after, .font-serif .md\\:leading-none.text-sm.capsize::after, .font-serif .text-sm .md\\:leading-none.capsize::after, .text-sm .md\\:leading-none.font-serif.capsize::after, .text-sm .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-sm.capsize::before, .font-serif .md\\:leading-tight.text-sm.capsize::before, .font-serif .text-sm .md\\:leading-tight.capsize::before, .text-sm .md\\:leading-tight.font-serif.capsize::before, .text-sm .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-sm.capsize::after, .font-serif .md\\:leading-tight.text-sm.capsize::after, .font-serif .text-sm .md\\:leading-tight.capsize::after, .text-sm .md\\:leading-tight.font-serif.capsize::after, .text-sm .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-3.capsize::before, .font-serif .md\\:text-base.leading-3.capsize::before, .font-serif .md\\:text-base .leading-3.capsize::before,.md\\:text-base .font-serif.leading-3.capsize::before,.md\\:text-base .font-serif .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.005em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-3.capsize::after, .font-serif .md\\:text-base.leading-3.capsize::after, .font-serif .md\\:text-base .leading-3.capsize::after,.md\\:text-base .font-serif.leading-3.capsize::after,.md\\:text-base .font-serif .leading-3.capsize::after {
    content: '';
    margin-top: 0.025em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-4.capsize::before, .font-serif .md\\:text-base.leading-4.capsize::before, .font-serif .md\\:text-base .leading-4.capsize::before,.md\\:text-base .font-serif.leading-4.capsize::before,.md\\:text-base .font-serif .leading-4.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-4.capsize::after, .font-serif .md\\:text-base.leading-4.capsize::after, .font-serif .md\\:text-base .leading-4.capsize::after,.md\\:text-base .font-serif.leading-4.capsize::after,.md\\:text-base .font-serif .leading-4.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-5.capsize::before, .font-serif .md\\:text-base.leading-5.capsize::before, .font-serif .md\\:text-base .leading-5.capsize::before,.md\\:text-base .font-serif.leading-5.capsize::before,.md\\:text-base .font-serif .leading-5.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-5.capsize::after, .font-serif .md\\:text-base.leading-5.capsize::after, .font-serif .md\\:text-base .leading-5.capsize::after,.md\\:text-base .font-serif.leading-5.capsize::after,.md\\:text-base .font-serif .leading-5.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-6.capsize::before, .font-serif .md\\:text-base.leading-6.capsize::before, .font-serif .md\\:text-base .leading-6.capsize::before,.md\\:text-base .font-serif.leading-6.capsize::before,.md\\:text-base .font-serif .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-6.capsize::after, .font-serif .md\\:text-base.leading-6.capsize::after, .font-serif .md\\:text-base .leading-6.capsize::after,.md\\:text-base .font-serif.leading-6.capsize::after,.md\\:text-base .font-serif .leading-6.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-7.capsize::before, .font-serif .md\\:text-base.leading-7.capsize::before, .font-serif .md\\:text-base .leading-7.capsize::before,.md\\:text-base .font-serif.leading-7.capsize::before,.md\\:text-base .font-serif .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.495em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-7.capsize::after, .font-serif .md\\:text-base.leading-7.capsize::after, .font-serif .md\\:text-base .leading-7.capsize::after,.md\\:text-base .font-serif.leading-7.capsize::after,.md\\:text-base .font-serif .leading-7.capsize::after {
    content: '';
    margin-top: -0.475em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-8.capsize::before, .font-serif .md\\:text-base.leading-8.capsize::before, .font-serif .md\\:text-base .leading-8.capsize::before,.md\\:text-base .font-serif.leading-8.capsize::before,.md\\:text-base .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-base.capsize::before, .font-serif .md\\:leading-8.text-base.capsize::before, .font-serif .text-base .md\\:leading-8.capsize::before, .text-base .md\\:leading-8.font-serif.capsize::before, .text-base .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-8.capsize::before, .font-serif .md\\:text-base.leading-8.capsize::before, .font-serif .md\\:text-base .leading-8.capsize::before,.md\\:text-base .font-serif.leading-8.capsize::before,.md\\:text-base .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-base.capsize::before, .font-serif .md\\:leading-8.text-base.capsize::before, .font-serif .text-base .md\\:leading-8.capsize::before, .text-base .md\\:leading-8.font-serif.capsize::before, .text-base .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-8.capsize::before, .font-serif .md\\:text-base.leading-8.capsize::before, .font-serif .md\\:text-base .leading-8.capsize::before,.md\\:text-base .font-serif.leading-8.capsize::before,.md\\:text-base .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-base.capsize::before, .font-serif .md\\:leading-8.text-base.capsize::before, .font-serif .text-base .md\\:leading-8.capsize::before, .text-base .md\\:leading-8.font-serif.capsize::before, .text-base .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-8.capsize::before, .font-serif .md\\:text-base.leading-8.capsize::before, .font-serif .md\\:text-base .leading-8.capsize::before,.md\\:text-base .font-serif.leading-8.capsize::before,.md\\:text-base .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-base.capsize::before, .font-serif .md\\:leading-8.text-base.capsize::before, .font-serif .text-base .md\\:leading-8.capsize::before, .text-base .md\\:leading-8.font-serif.capsize::before, .text-base .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-8.capsize::before, .font-serif .md\\:text-base.leading-8.capsize::before, .font-serif .md\\:text-base .leading-8.capsize::before,.md\\:text-base .font-serif.leading-8.capsize::before,.md\\:text-base .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-base.capsize::before, .font-serif .md\\:leading-8.text-base.capsize::before, .font-serif .text-base .md\\:leading-8.capsize::before, .text-base .md\\:leading-8.font-serif.capsize::before, .text-base .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-8.capsize::after, .font-serif .md\\:text-base.leading-8.capsize::after, .font-serif .md\\:text-base .leading-8.capsize::after,.md\\:text-base .font-serif.leading-8.capsize::after,.md\\:text-base .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-base.capsize::after, .font-serif .md\\:leading-8.text-base.capsize::after, .font-serif .text-base .md\\:leading-8.capsize::after, .text-base .md\\:leading-8.font-serif.capsize::after, .text-base .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-8.capsize::after, .font-serif .md\\:text-base.leading-8.capsize::after, .font-serif .md\\:text-base .leading-8.capsize::after,.md\\:text-base .font-serif.leading-8.capsize::after,.md\\:text-base .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-base.capsize::after, .font-serif .md\\:leading-8.text-base.capsize::after, .font-serif .text-base .md\\:leading-8.capsize::after, .text-base .md\\:leading-8.font-serif.capsize::after, .text-base .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-8.capsize::after, .font-serif .md\\:text-base.leading-8.capsize::after, .font-serif .md\\:text-base .leading-8.capsize::after,.md\\:text-base .font-serif.leading-8.capsize::after,.md\\:text-base .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-base.capsize::after, .font-serif .md\\:leading-8.text-base.capsize::after, .font-serif .text-base .md\\:leading-8.capsize::after, .text-base .md\\:leading-8.font-serif.capsize::after, .text-base .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-8.capsize::after, .font-serif .md\\:text-base.leading-8.capsize::after, .font-serif .md\\:text-base .leading-8.capsize::after,.md\\:text-base .font-serif.leading-8.capsize::after,.md\\:text-base .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-base.capsize::after, .font-serif .md\\:leading-8.text-base.capsize::after, .font-serif .text-base .md\\:leading-8.capsize::after, .text-base .md\\:leading-8.font-serif.capsize::after, .text-base .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-8.capsize::after, .font-serif .md\\:text-base.leading-8.capsize::after, .font-serif .md\\:text-base .leading-8.capsize::after,.md\\:text-base .font-serif.leading-8.capsize::after,.md\\:text-base .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-base.capsize::after, .font-serif .md\\:leading-8.text-base.capsize::after, .font-serif .text-base .md\\:leading-8.capsize::after, .text-base .md\\:leading-8.font-serif.capsize::after, .text-base .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-9.capsize::before, .font-serif .md\\:text-base.leading-9.capsize::before, .font-serif .md\\:text-base .leading-9.capsize::before,.md\\:text-base .font-serif.leading-9.capsize::before,.md\\:text-base .font-serif .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.745em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-9.capsize::after, .font-serif .md\\:text-base.leading-9.capsize::after, .font-serif .md\\:text-base .leading-9.capsize::after,.md\\:text-base .font-serif.leading-9.capsize::after,.md\\:text-base .font-serif .leading-9.capsize::after {
    content: '';
    margin-top: -0.725em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-10.capsize::before, .font-serif .md\\:text-base.leading-10.capsize::before, .font-serif .md\\:text-base .leading-10.capsize::before,.md\\:text-base .font-serif.leading-10.capsize::before,.md\\:text-base .font-serif .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.87em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-10.capsize::after, .font-serif .md\\:text-base.leading-10.capsize::after, .font-serif .md\\:text-base .leading-10.capsize::after,.md\\:text-base .font-serif.leading-10.capsize::after,.md\\:text-base .font-serif .leading-10.capsize::after {
    content: '';
    margin-top: -0.85em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-none.capsize::before, .font-serif .md\\:text-base.leading-none.capsize::before, .font-serif .md\\:text-base .leading-none.capsize::before,.md\\:text-base .font-serif.leading-none.capsize::before,.md\\:text-base .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-base.capsize::before, .font-serif .md\\:leading-none.text-base.capsize::before, .font-serif .text-base .md\\:leading-none.capsize::before, .text-base .md\\:leading-none.font-serif.capsize::before, .text-base .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-none.capsize::before, .font-serif .md\\:text-base.leading-none.capsize::before, .font-serif .md\\:text-base .leading-none.capsize::before,.md\\:text-base .font-serif.leading-none.capsize::before,.md\\:text-base .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-base.capsize::before, .font-serif .md\\:leading-none.text-base.capsize::before, .font-serif .text-base .md\\:leading-none.capsize::before, .text-base .md\\:leading-none.font-serif.capsize::before, .text-base .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-none.capsize::before, .font-serif .md\\:text-base.leading-none.capsize::before, .font-serif .md\\:text-base .leading-none.capsize::before,.md\\:text-base .font-serif.leading-none.capsize::before,.md\\:text-base .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-base.capsize::before, .font-serif .md\\:leading-none.text-base.capsize::before, .font-serif .text-base .md\\:leading-none.capsize::before, .text-base .md\\:leading-none.font-serif.capsize::before, .text-base .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-none.capsize::before, .font-serif .md\\:text-base.leading-none.capsize::before, .font-serif .md\\:text-base .leading-none.capsize::before,.md\\:text-base .font-serif.leading-none.capsize::before,.md\\:text-base .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-base.capsize::before, .font-serif .md\\:leading-none.text-base.capsize::before, .font-serif .text-base .md\\:leading-none.capsize::before, .text-base .md\\:leading-none.font-serif.capsize::before, .text-base .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-none.capsize::before, .font-serif .md\\:text-base.leading-none.capsize::before, .font-serif .md\\:text-base .leading-none.capsize::before,.md\\:text-base .font-serif.leading-none.capsize::before,.md\\:text-base .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-base.capsize::before, .font-serif .md\\:leading-none.text-base.capsize::before, .font-serif .text-base .md\\:leading-none.capsize::before, .text-base .md\\:leading-none.font-serif.capsize::before, .text-base .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-none.capsize::after, .font-serif .md\\:text-base.leading-none.capsize::after, .font-serif .md\\:text-base .leading-none.capsize::after,.md\\:text-base .font-serif.leading-none.capsize::after,.md\\:text-base .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-base.capsize::after, .font-serif .md\\:leading-none.text-base.capsize::after, .font-serif .text-base .md\\:leading-none.capsize::after, .text-base .md\\:leading-none.font-serif.capsize::after, .text-base .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-none.capsize::after, .font-serif .md\\:text-base.leading-none.capsize::after, .font-serif .md\\:text-base .leading-none.capsize::after,.md\\:text-base .font-serif.leading-none.capsize::after,.md\\:text-base .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-base.capsize::after, .font-serif .md\\:leading-none.text-base.capsize::after, .font-serif .text-base .md\\:leading-none.capsize::after, .text-base .md\\:leading-none.font-serif.capsize::after, .text-base .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-none.capsize::after, .font-serif .md\\:text-base.leading-none.capsize::after, .font-serif .md\\:text-base .leading-none.capsize::after,.md\\:text-base .font-serif.leading-none.capsize::after,.md\\:text-base .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-base.capsize::after, .font-serif .md\\:leading-none.text-base.capsize::after, .font-serif .text-base .md\\:leading-none.capsize::after, .text-base .md\\:leading-none.font-serif.capsize::after, .text-base .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-none.capsize::after, .font-serif .md\\:text-base.leading-none.capsize::after, .font-serif .md\\:text-base .leading-none.capsize::after,.md\\:text-base .font-serif.leading-none.capsize::after,.md\\:text-base .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-base.capsize::after, .font-serif .md\\:leading-none.text-base.capsize::after, .font-serif .text-base .md\\:leading-none.capsize::after, .text-base .md\\:leading-none.font-serif.capsize::after, .text-base .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-none.capsize::after, .font-serif .md\\:text-base.leading-none.capsize::after, .font-serif .md\\:text-base .leading-none.capsize::after,.md\\:text-base .font-serif.leading-none.capsize::after,.md\\:text-base .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-base.capsize::after, .font-serif .md\\:leading-none.text-base.capsize::after, .font-serif .text-base .md\\:leading-none.capsize::after, .text-base .md\\:leading-none.font-serif.capsize::after, .text-base .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-base.leading-tight.capsize::before, .font-serif .md\\:text-base .leading-tight.capsize::before,.md\\:text-base .font-serif.leading-tight.capsize::before,.md\\:text-base .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-base.capsize::before, .font-serif .md\\:leading-tight.text-base.capsize::before, .font-serif .text-base .md\\:leading-tight.capsize::before, .text-base .md\\:leading-tight.font-serif.capsize::before, .text-base .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-base.leading-tight.capsize::before, .font-serif .md\\:text-base .leading-tight.capsize::before,.md\\:text-base .font-serif.leading-tight.capsize::before,.md\\:text-base .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-base.capsize::before, .font-serif .md\\:leading-tight.text-base.capsize::before, .font-serif .text-base .md\\:leading-tight.capsize::before, .text-base .md\\:leading-tight.font-serif.capsize::before, .text-base .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-base.leading-tight.capsize::before, .font-serif .md\\:text-base .leading-tight.capsize::before,.md\\:text-base .font-serif.leading-tight.capsize::before,.md\\:text-base .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-base.capsize::before, .font-serif .md\\:leading-tight.text-base.capsize::before, .font-serif .text-base .md\\:leading-tight.capsize::before, .text-base .md\\:leading-tight.font-serif.capsize::before, .text-base .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-base.leading-tight.capsize::before, .font-serif .md\\:text-base .leading-tight.capsize::before,.md\\:text-base .font-serif.leading-tight.capsize::before,.md\\:text-base .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-base.capsize::before, .font-serif .md\\:leading-tight.text-base.capsize::before, .font-serif .text-base .md\\:leading-tight.capsize::before, .text-base .md\\:leading-tight.font-serif.capsize::before, .text-base .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-base.leading-tight.capsize::before, .font-serif .md\\:text-base .leading-tight.capsize::before,.md\\:text-base .font-serif.leading-tight.capsize::before,.md\\:text-base .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-base.capsize::before, .font-serif .md\\:leading-tight.text-base.capsize::before, .font-serif .text-base .md\\:leading-tight.capsize::before, .text-base .md\\:leading-tight.font-serif.capsize::before, .text-base .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-base.leading-tight.capsize::after, .font-serif .md\\:text-base .leading-tight.capsize::after,.md\\:text-base .font-serif.leading-tight.capsize::after,.md\\:text-base .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-base.capsize::after, .font-serif .md\\:leading-tight.text-base.capsize::after, .font-serif .text-base .md\\:leading-tight.capsize::after, .text-base .md\\:leading-tight.font-serif.capsize::after, .text-base .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-base.leading-tight.capsize::after, .font-serif .md\\:text-base .leading-tight.capsize::after,.md\\:text-base .font-serif.leading-tight.capsize::after,.md\\:text-base .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-base.capsize::after, .font-serif .md\\:leading-tight.text-base.capsize::after, .font-serif .text-base .md\\:leading-tight.capsize::after, .text-base .md\\:leading-tight.font-serif.capsize::after, .text-base .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-base.leading-tight.capsize::after, .font-serif .md\\:text-base .leading-tight.capsize::after,.md\\:text-base .font-serif.leading-tight.capsize::after,.md\\:text-base .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-base.capsize::after, .font-serif .md\\:leading-tight.text-base.capsize::after, .font-serif .text-base .md\\:leading-tight.capsize::after, .text-base .md\\:leading-tight.font-serif.capsize::after, .text-base .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-base.leading-tight.capsize::after, .font-serif .md\\:text-base .leading-tight.capsize::after,.md\\:text-base .font-serif.leading-tight.capsize::after,.md\\:text-base .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-base.capsize::after, .font-serif .md\\:leading-tight.text-base.capsize::after, .font-serif .text-base .md\\:leading-tight.capsize::after, .text-base .md\\:leading-tight.font-serif.capsize::after, .text-base .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-base.leading-tight.capsize::after, .font-serif .md\\:text-base .leading-tight.capsize::after,.md\\:text-base .font-serif.leading-tight.capsize::after,.md\\:text-base .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-base.capsize::after, .font-serif .md\\:leading-tight.text-base.capsize::after, .font-serif .text-base .md\\:leading-tight.capsize::after, .text-base .md\\:leading-tight.font-serif.capsize::after, .text-base .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-snug.capsize::before, .font-serif .md\\:text-base.leading-snug.capsize::before, .font-serif .md\\:text-base .leading-snug.capsize::before,.md\\:text-base .font-serif.leading-snug.capsize::before,.md\\:text-base .font-serif .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3075em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-snug.capsize::after, .font-serif .md\\:text-base.leading-snug.capsize::after, .font-serif .md\\:text-base .leading-snug.capsize::after,.md\\:text-base .font-serif.leading-snug.capsize::after,.md\\:text-base .font-serif .leading-snug.capsize::after {
    content: '';
    margin-top: -0.2875em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-normal.capsize::before, .font-serif .md\\:text-base.leading-normal.capsize::before, .font-serif .md\\:text-base .leading-normal.capsize::before,.md\\:text-base .font-serif.leading-normal.capsize::before,.md\\:text-base .font-serif .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-normal.capsize::after, .font-serif .md\\:text-base.leading-normal.capsize::after, .font-serif .md\\:text-base .leading-normal.capsize::after,.md\\:text-base .font-serif.leading-normal.capsize::after,.md\\:text-base .font-serif .leading-normal.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-relaxed.capsize::before, .font-serif .md\\:text-base.leading-relaxed.capsize::before, .font-serif .md\\:text-base .leading-relaxed.capsize::before,.md\\:text-base .font-serif.leading-relaxed.capsize::before,.md\\:text-base .font-serif .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4325em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-relaxed.capsize::after, .font-serif .md\\:text-base.leading-relaxed.capsize::after, .font-serif .md\\:text-base .leading-relaxed.capsize::after,.md\\:text-base .font-serif.leading-relaxed.capsize::after,.md\\:text-base .font-serif .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4125em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-loose.capsize::before, .font-serif .md\\:text-base.leading-loose.capsize::before, .font-serif .md\\:text-base .leading-loose.capsize::before,.md\\:text-base .font-serif.leading-loose.capsize::before,.md\\:text-base .font-serif .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .md\\:text-base.font-serif.leading-loose.capsize::after, .font-serif .md\\:text-base.leading-loose.capsize::after, .font-serif .md\\:text-base .leading-loose.capsize::after,.md\\:text-base .font-serif.leading-loose.capsize::after,.md\\:text-base .font-serif .leading-loose.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-3.capsize::before, .font-serif .md\\:text-lg.leading-3.capsize::before, .font-serif .md\\:text-lg .leading-3.capsize::before,.md\\:text-lg .font-serif.leading-3.capsize::before,.md\\:text-lg .font-serif .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.0467em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-3.capsize::after, .font-serif .md\\:text-lg.leading-3.capsize::after, .font-serif .md\\:text-lg .leading-3.capsize::after,.md\\:text-lg .font-serif.leading-3.capsize::after,.md\\:text-lg .font-serif .leading-3.capsize::after {
    content: '';
    margin-top: 0.0667em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-4.capsize::before, .font-serif .md\\:text-lg.leading-4.capsize::before, .font-serif .md\\:text-lg .leading-4.capsize::before,.md\\:text-lg .font-serif.leading-4.capsize::before,.md\\:text-lg .font-serif .leading-4.capsize::before {
    content: '';
    margin-bottom: -0.0644em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-4.capsize::after, .font-serif .md\\:text-lg.leading-4.capsize::after, .font-serif .md\\:text-lg .leading-4.capsize::after,.md\\:text-lg .font-serif.leading-4.capsize::after,.md\\:text-lg .font-serif .leading-4.capsize::after {
    content: '';
    margin-top: -0.0444em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-5.capsize::before, .font-serif .md\\:text-lg.leading-5.capsize::before, .font-serif .md\\:text-lg .leading-5.capsize::before,.md\\:text-lg .font-serif.leading-5.capsize::before,.md\\:text-lg .font-serif .leading-5.capsize::before {
    content: '';
    margin-bottom: -0.1756em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-5.capsize::after, .font-serif .md\\:text-lg.leading-5.capsize::after, .font-serif .md\\:text-lg .leading-5.capsize::after,.md\\:text-lg .font-serif.leading-5.capsize::after,.md\\:text-lg .font-serif .leading-5.capsize::after {
    content: '';
    margin-top: -0.1556em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-6.capsize::before, .font-serif .md\\:text-lg.leading-6.capsize::before, .font-serif .md\\:text-lg .leading-6.capsize::before,.md\\:text-lg .font-serif.leading-6.capsize::before,.md\\:text-lg .font-serif .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.2867em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-6.capsize::after, .font-serif .md\\:text-lg.leading-6.capsize::after, .font-serif .md\\:text-lg .leading-6.capsize::after,.md\\:text-lg .font-serif.leading-6.capsize::after,.md\\:text-lg .font-serif .leading-6.capsize::after {
    content: '';
    margin-top: -0.2667em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-7.capsize::before, .font-serif .md\\:text-lg.leading-7.capsize::before, .font-serif .md\\:text-lg .leading-7.capsize::before,.md\\:text-lg .font-serif.leading-7.capsize::before,.md\\:text-lg .font-serif .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.3978em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-7.capsize::after, .font-serif .md\\:text-lg.leading-7.capsize::after, .font-serif .md\\:text-lg .leading-7.capsize::after,.md\\:text-lg .font-serif.leading-7.capsize::after,.md\\:text-lg .font-serif .leading-7.capsize::after {
    content: '';
    margin-top: -0.3778em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-8.capsize::before, .font-serif .md\\:text-lg.leading-8.capsize::before, .font-serif .md\\:text-lg .leading-8.capsize::before,.md\\:text-lg .font-serif.leading-8.capsize::before,.md\\:text-lg .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.5089em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-lg.capsize::before, .font-serif .md\\:leading-8.text-lg.capsize::before, .font-serif .text-lg .md\\:leading-8.capsize::before, .text-lg .md\\:leading-8.font-serif.capsize::before, .text-lg .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.5089em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-8.capsize::before, .font-serif .md\\:text-lg.leading-8.capsize::before, .font-serif .md\\:text-lg .leading-8.capsize::before,.md\\:text-lg .font-serif.leading-8.capsize::before,.md\\:text-lg .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.5089em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-lg.capsize::before, .font-serif .md\\:leading-8.text-lg.capsize::before, .font-serif .text-lg .md\\:leading-8.capsize::before, .text-lg .md\\:leading-8.font-serif.capsize::before, .text-lg .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.5089em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-8.capsize::before, .font-serif .md\\:text-lg.leading-8.capsize::before, .font-serif .md\\:text-lg .leading-8.capsize::before,.md\\:text-lg .font-serif.leading-8.capsize::before,.md\\:text-lg .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.5089em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-lg.capsize::before, .font-serif .md\\:leading-8.text-lg.capsize::before, .font-serif .text-lg .md\\:leading-8.capsize::before, .text-lg .md\\:leading-8.font-serif.capsize::before, .text-lg .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.5089em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-8.capsize::before, .font-serif .md\\:text-lg.leading-8.capsize::before, .font-serif .md\\:text-lg .leading-8.capsize::before,.md\\:text-lg .font-serif.leading-8.capsize::before,.md\\:text-lg .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.5089em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-lg.capsize::before, .font-serif .md\\:leading-8.text-lg.capsize::before, .font-serif .text-lg .md\\:leading-8.capsize::before, .text-lg .md\\:leading-8.font-serif.capsize::before, .text-lg .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.5089em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-8.capsize::before, .font-serif .md\\:text-lg.leading-8.capsize::before, .font-serif .md\\:text-lg .leading-8.capsize::before,.md\\:text-lg .font-serif.leading-8.capsize::before,.md\\:text-lg .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.5089em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-lg.capsize::before, .font-serif .md\\:leading-8.text-lg.capsize::before, .font-serif .text-lg .md\\:leading-8.capsize::before, .text-lg .md\\:leading-8.font-serif.capsize::before, .text-lg .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.5089em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-8.capsize::after, .font-serif .md\\:text-lg.leading-8.capsize::after, .font-serif .md\\:text-lg .leading-8.capsize::after,.md\\:text-lg .font-serif.leading-8.capsize::after,.md\\:text-lg .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.4889em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-lg.capsize::after, .font-serif .md\\:leading-8.text-lg.capsize::after, .font-serif .text-lg .md\\:leading-8.capsize::after, .text-lg .md\\:leading-8.font-serif.capsize::after, .text-lg .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.4889em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-8.capsize::after, .font-serif .md\\:text-lg.leading-8.capsize::after, .font-serif .md\\:text-lg .leading-8.capsize::after,.md\\:text-lg .font-serif.leading-8.capsize::after,.md\\:text-lg .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.4889em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-lg.capsize::after, .font-serif .md\\:leading-8.text-lg.capsize::after, .font-serif .text-lg .md\\:leading-8.capsize::after, .text-lg .md\\:leading-8.font-serif.capsize::after, .text-lg .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.4889em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-8.capsize::after, .font-serif .md\\:text-lg.leading-8.capsize::after, .font-serif .md\\:text-lg .leading-8.capsize::after,.md\\:text-lg .font-serif.leading-8.capsize::after,.md\\:text-lg .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.4889em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-lg.capsize::after, .font-serif .md\\:leading-8.text-lg.capsize::after, .font-serif .text-lg .md\\:leading-8.capsize::after, .text-lg .md\\:leading-8.font-serif.capsize::after, .text-lg .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.4889em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-8.capsize::after, .font-serif .md\\:text-lg.leading-8.capsize::after, .font-serif .md\\:text-lg .leading-8.capsize::after,.md\\:text-lg .font-serif.leading-8.capsize::after,.md\\:text-lg .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.4889em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-lg.capsize::after, .font-serif .md\\:leading-8.text-lg.capsize::after, .font-serif .text-lg .md\\:leading-8.capsize::after, .text-lg .md\\:leading-8.font-serif.capsize::after, .text-lg .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.4889em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-8.capsize::after, .font-serif .md\\:text-lg.leading-8.capsize::after, .font-serif .md\\:text-lg .leading-8.capsize::after,.md\\:text-lg .font-serif.leading-8.capsize::after,.md\\:text-lg .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.4889em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-lg.capsize::after, .font-serif .md\\:leading-8.text-lg.capsize::after, .font-serif .text-lg .md\\:leading-8.capsize::after, .text-lg .md\\:leading-8.font-serif.capsize::after, .text-lg .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.4889em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-9.capsize::before, .font-serif .md\\:text-lg.leading-9.capsize::before, .font-serif .md\\:text-lg .leading-9.capsize::before,.md\\:text-lg .font-serif.leading-9.capsize::before,.md\\:text-lg .font-serif .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-9.capsize::after, .font-serif .md\\:text-lg.leading-9.capsize::after, .font-serif .md\\:text-lg .leading-9.capsize::after,.md\\:text-lg .font-serif.leading-9.capsize::after,.md\\:text-lg .font-serif .leading-9.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-10.capsize::before, .font-serif .md\\:text-lg.leading-10.capsize::before, .font-serif .md\\:text-lg .leading-10.capsize::before,.md\\:text-lg .font-serif.leading-10.capsize::before,.md\\:text-lg .font-serif .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.7311em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-10.capsize::after, .font-serif .md\\:text-lg.leading-10.capsize::after, .font-serif .md\\:text-lg .leading-10.capsize::after,.md\\:text-lg .font-serif.leading-10.capsize::after,.md\\:text-lg .font-serif .leading-10.capsize::after {
    content: '';
    margin-top: -0.7111em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-none.capsize::before, .font-serif .md\\:text-lg.leading-none.capsize::before, .font-serif .md\\:text-lg .leading-none.capsize::before,.md\\:text-lg .font-serif.leading-none.capsize::before,.md\\:text-lg .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-lg.capsize::before, .font-serif .md\\:leading-none.text-lg.capsize::before, .font-serif .text-lg .md\\:leading-none.capsize::before, .text-lg .md\\:leading-none.font-serif.capsize::before, .text-lg .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-none.capsize::before, .font-serif .md\\:text-lg.leading-none.capsize::before, .font-serif .md\\:text-lg .leading-none.capsize::before,.md\\:text-lg .font-serif.leading-none.capsize::before,.md\\:text-lg .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-lg.capsize::before, .font-serif .md\\:leading-none.text-lg.capsize::before, .font-serif .text-lg .md\\:leading-none.capsize::before, .text-lg .md\\:leading-none.font-serif.capsize::before, .text-lg .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-none.capsize::before, .font-serif .md\\:text-lg.leading-none.capsize::before, .font-serif .md\\:text-lg .leading-none.capsize::before,.md\\:text-lg .font-serif.leading-none.capsize::before,.md\\:text-lg .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-lg.capsize::before, .font-serif .md\\:leading-none.text-lg.capsize::before, .font-serif .text-lg .md\\:leading-none.capsize::before, .text-lg .md\\:leading-none.font-serif.capsize::before, .text-lg .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-none.capsize::before, .font-serif .md\\:text-lg.leading-none.capsize::before, .font-serif .md\\:text-lg .leading-none.capsize::before,.md\\:text-lg .font-serif.leading-none.capsize::before,.md\\:text-lg .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-lg.capsize::before, .font-serif .md\\:leading-none.text-lg.capsize::before, .font-serif .text-lg .md\\:leading-none.capsize::before, .text-lg .md\\:leading-none.font-serif.capsize::before, .text-lg .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-none.capsize::before, .font-serif .md\\:text-lg.leading-none.capsize::before, .font-serif .md\\:text-lg .leading-none.capsize::before,.md\\:text-lg .font-serif.leading-none.capsize::before,.md\\:text-lg .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-lg.capsize::before, .font-serif .md\\:leading-none.text-lg.capsize::before, .font-serif .text-lg .md\\:leading-none.capsize::before, .text-lg .md\\:leading-none.font-serif.capsize::before, .text-lg .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-none.capsize::after, .font-serif .md\\:text-lg.leading-none.capsize::after, .font-serif .md\\:text-lg .leading-none.capsize::after,.md\\:text-lg .font-serif.leading-none.capsize::after,.md\\:text-lg .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-lg.capsize::after, .font-serif .md\\:leading-none.text-lg.capsize::after, .font-serif .text-lg .md\\:leading-none.capsize::after, .text-lg .md\\:leading-none.font-serif.capsize::after, .text-lg .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-none.capsize::after, .font-serif .md\\:text-lg.leading-none.capsize::after, .font-serif .md\\:text-lg .leading-none.capsize::after,.md\\:text-lg .font-serif.leading-none.capsize::after,.md\\:text-lg .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-lg.capsize::after, .font-serif .md\\:leading-none.text-lg.capsize::after, .font-serif .text-lg .md\\:leading-none.capsize::after, .text-lg .md\\:leading-none.font-serif.capsize::after, .text-lg .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-none.capsize::after, .font-serif .md\\:text-lg.leading-none.capsize::after, .font-serif .md\\:text-lg .leading-none.capsize::after,.md\\:text-lg .font-serif.leading-none.capsize::after,.md\\:text-lg .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-lg.capsize::after, .font-serif .md\\:leading-none.text-lg.capsize::after, .font-serif .text-lg .md\\:leading-none.capsize::after, .text-lg .md\\:leading-none.font-serif.capsize::after, .text-lg .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-none.capsize::after, .font-serif .md\\:text-lg.leading-none.capsize::after, .font-serif .md\\:text-lg .leading-none.capsize::after,.md\\:text-lg .font-serif.leading-none.capsize::after,.md\\:text-lg .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-lg.capsize::after, .font-serif .md\\:leading-none.text-lg.capsize::after, .font-serif .text-lg .md\\:leading-none.capsize::after, .text-lg .md\\:leading-none.font-serif.capsize::after, .text-lg .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-none.capsize::after, .font-serif .md\\:text-lg.leading-none.capsize::after, .font-serif .md\\:text-lg .leading-none.capsize::after,.md\\:text-lg .font-serif.leading-none.capsize::after,.md\\:text-lg .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-lg.capsize::after, .font-serif .md\\:leading-none.text-lg.capsize::after, .font-serif .text-lg .md\\:leading-none.capsize::after, .text-lg .md\\:leading-none.font-serif.capsize::after, .text-lg .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-lg.leading-tight.capsize::before, .font-serif .md\\:text-lg .leading-tight.capsize::before,.md\\:text-lg .font-serif.leading-tight.capsize::before,.md\\:text-lg .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-lg.capsize::before, .font-serif .md\\:leading-tight.text-lg.capsize::before, .font-serif .text-lg .md\\:leading-tight.capsize::before, .text-lg .md\\:leading-tight.font-serif.capsize::before, .text-lg .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-lg.leading-tight.capsize::before, .font-serif .md\\:text-lg .leading-tight.capsize::before,.md\\:text-lg .font-serif.leading-tight.capsize::before,.md\\:text-lg .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-lg.capsize::before, .font-serif .md\\:leading-tight.text-lg.capsize::before, .font-serif .text-lg .md\\:leading-tight.capsize::before, .text-lg .md\\:leading-tight.font-serif.capsize::before, .text-lg .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-lg.leading-tight.capsize::before, .font-serif .md\\:text-lg .leading-tight.capsize::before,.md\\:text-lg .font-serif.leading-tight.capsize::before,.md\\:text-lg .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-lg.capsize::before, .font-serif .md\\:leading-tight.text-lg.capsize::before, .font-serif .text-lg .md\\:leading-tight.capsize::before, .text-lg .md\\:leading-tight.font-serif.capsize::before, .text-lg .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-lg.leading-tight.capsize::before, .font-serif .md\\:text-lg .leading-tight.capsize::before,.md\\:text-lg .font-serif.leading-tight.capsize::before,.md\\:text-lg .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-lg.capsize::before, .font-serif .md\\:leading-tight.text-lg.capsize::before, .font-serif .text-lg .md\\:leading-tight.capsize::before, .text-lg .md\\:leading-tight.font-serif.capsize::before, .text-lg .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-lg.leading-tight.capsize::before, .font-serif .md\\:text-lg .leading-tight.capsize::before,.md\\:text-lg .font-serif.leading-tight.capsize::before,.md\\:text-lg .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-lg.capsize::before, .font-serif .md\\:leading-tight.text-lg.capsize::before, .font-serif .text-lg .md\\:leading-tight.capsize::before, .text-lg .md\\:leading-tight.font-serif.capsize::before, .text-lg .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-lg.leading-tight.capsize::after, .font-serif .md\\:text-lg .leading-tight.capsize::after,.md\\:text-lg .font-serif.leading-tight.capsize::after,.md\\:text-lg .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-lg.capsize::after, .font-serif .md\\:leading-tight.text-lg.capsize::after, .font-serif .text-lg .md\\:leading-tight.capsize::after, .text-lg .md\\:leading-tight.font-serif.capsize::after, .text-lg .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-lg.leading-tight.capsize::after, .font-serif .md\\:text-lg .leading-tight.capsize::after,.md\\:text-lg .font-serif.leading-tight.capsize::after,.md\\:text-lg .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-lg.capsize::after, .font-serif .md\\:leading-tight.text-lg.capsize::after, .font-serif .text-lg .md\\:leading-tight.capsize::after, .text-lg .md\\:leading-tight.font-serif.capsize::after, .text-lg .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-lg.leading-tight.capsize::after, .font-serif .md\\:text-lg .leading-tight.capsize::after,.md\\:text-lg .font-serif.leading-tight.capsize::after,.md\\:text-lg .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-lg.capsize::after, .font-serif .md\\:leading-tight.text-lg.capsize::after, .font-serif .text-lg .md\\:leading-tight.capsize::after, .text-lg .md\\:leading-tight.font-serif.capsize::after, .text-lg .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-lg.leading-tight.capsize::after, .font-serif .md\\:text-lg .leading-tight.capsize::after,.md\\:text-lg .font-serif.leading-tight.capsize::after,.md\\:text-lg .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-lg.capsize::after, .font-serif .md\\:leading-tight.text-lg.capsize::after, .font-serif .text-lg .md\\:leading-tight.capsize::after, .text-lg .md\\:leading-tight.font-serif.capsize::after, .text-lg .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-lg.leading-tight.capsize::after, .font-serif .md\\:text-lg .leading-tight.capsize::after,.md\\:text-lg .font-serif.leading-tight.capsize::after,.md\\:text-lg .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-lg.capsize::after, .font-serif .md\\:leading-tight.text-lg.capsize::after, .font-serif .text-lg .md\\:leading-tight.capsize::after, .text-lg .md\\:leading-tight.font-serif.capsize::after, .text-lg .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-snug.capsize::before, .font-serif .md\\:text-lg.leading-snug.capsize::before, .font-serif .md\\:text-lg .leading-snug.capsize::before,.md\\:text-lg .font-serif.leading-snug.capsize::before,.md\\:text-lg .font-serif .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3075em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-snug.capsize::after, .font-serif .md\\:text-lg.leading-snug.capsize::after, .font-serif .md\\:text-lg .leading-snug.capsize::after,.md\\:text-lg .font-serif.leading-snug.capsize::after,.md\\:text-lg .font-serif .leading-snug.capsize::after {
    content: '';
    margin-top: -0.2875em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-normal.capsize::before, .font-serif .md\\:text-lg.leading-normal.capsize::before, .font-serif .md\\:text-lg .leading-normal.capsize::before,.md\\:text-lg .font-serif.leading-normal.capsize::before,.md\\:text-lg .font-serif .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-normal.capsize::after, .font-serif .md\\:text-lg.leading-normal.capsize::after, .font-serif .md\\:text-lg .leading-normal.capsize::after,.md\\:text-lg .font-serif.leading-normal.capsize::after,.md\\:text-lg .font-serif .leading-normal.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-relaxed.capsize::before, .font-serif .md\\:text-lg.leading-relaxed.capsize::before, .font-serif .md\\:text-lg .leading-relaxed.capsize::before,.md\\:text-lg .font-serif.leading-relaxed.capsize::before,.md\\:text-lg .font-serif .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4325em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-relaxed.capsize::after, .font-serif .md\\:text-lg.leading-relaxed.capsize::after, .font-serif .md\\:text-lg .leading-relaxed.capsize::after,.md\\:text-lg .font-serif.leading-relaxed.capsize::after,.md\\:text-lg .font-serif .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4125em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-loose.capsize::before, .font-serif .md\\:text-lg.leading-loose.capsize::before, .font-serif .md\\:text-lg .leading-loose.capsize::before,.md\\:text-lg .font-serif.leading-loose.capsize::before,.md\\:text-lg .font-serif .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .md\\:text-lg.font-serif.leading-loose.capsize::after, .font-serif .md\\:text-lg.leading-loose.capsize::after, .font-serif .md\\:text-lg .leading-loose.capsize::after,.md\\:text-lg .font-serif.leading-loose.capsize::after,.md\\:text-lg .font-serif .leading-loose.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-xl.capsize::before, .font-serif .md\\:leading-8.text-xl.capsize::before, .font-serif .text-xl .md\\:leading-8.capsize::before, .text-xl .md\\:leading-8.font-serif.capsize::before, .text-xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.42em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-xl.capsize::after, .font-serif .md\\:leading-8.text-xl.capsize::after, .font-serif .text-xl .md\\:leading-8.capsize::after, .text-xl .md\\:leading-8.font-serif.capsize::after, .text-xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.4em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-xl.capsize::before, .font-serif .md\\:leading-none.text-xl.capsize::before, .font-serif .text-xl .md\\:leading-none.capsize::before, .text-xl .md\\:leading-none.font-serif.capsize::before, .text-xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-xl.capsize::after, .font-serif .md\\:leading-none.text-xl.capsize::after, .font-serif .text-xl .md\\:leading-none.capsize::after, .text-xl .md\\:leading-none.font-serif.capsize::after, .text-xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-xl.capsize::before, .font-serif .md\\:leading-tight.text-xl.capsize::before, .font-serif .text-xl .md\\:leading-tight.capsize::before, .text-xl .md\\:leading-tight.font-serif.capsize::before, .text-xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-xl.capsize::after, .font-serif .md\\:leading-tight.text-xl.capsize::after, .font-serif .text-xl .md\\:leading-tight.capsize::after, .text-xl .md\\:leading-tight.font-serif.capsize::after, .text-xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-2xl.capsize::before, .font-serif .md\\:leading-8.text-2xl.capsize::before, .font-serif .text-2xl .md\\:leading-8.capsize::before, .text-2xl .md\\:leading-8.font-serif.capsize::before, .text-2xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.2867em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-2xl.capsize::after, .font-serif .md\\:leading-8.text-2xl.capsize::after, .font-serif .text-2xl .md\\:leading-8.capsize::after, .text-2xl .md\\:leading-8.font-serif.capsize::after, .text-2xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.2667em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-2xl.capsize::before, .font-serif .md\\:leading-none.text-2xl.capsize::before, .font-serif .text-2xl .md\\:leading-none.capsize::before, .text-2xl .md\\:leading-none.font-serif.capsize::before, .text-2xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-2xl.capsize::after, .font-serif .md\\:leading-none.text-2xl.capsize::after, .font-serif .text-2xl .md\\:leading-none.capsize::after, .text-2xl .md\\:leading-none.font-serif.capsize::after, .text-2xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-2xl.capsize::before, .font-serif .md\\:leading-tight.text-2xl.capsize::before, .font-serif .text-2xl .md\\:leading-tight.capsize::before, .text-2xl .md\\:leading-tight.font-serif.capsize::before, .text-2xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-2xl.capsize::after, .font-serif .md\\:leading-tight.text-2xl.capsize::after, .font-serif .text-2xl .md\\:leading-tight.capsize::after, .text-2xl .md\\:leading-tight.font-serif.capsize::after, .text-2xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-3.capsize::before, .font-serif .md\\:text-3xl.leading-3.capsize::before, .font-serif .md\\:text-3xl .leading-3.capsize::before,.md\\:text-3xl .font-serif.leading-3.capsize::before,.md\\:text-3xl .font-serif .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.18em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-3.capsize::after, .font-serif .md\\:text-3xl.leading-3.capsize::after, .font-serif .md\\:text-3xl .leading-3.capsize::after,.md\\:text-3xl .font-serif.leading-3.capsize::after,.md\\:text-3xl .font-serif .leading-3.capsize::after {
    content: '';
    margin-top: 0.2em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-4.capsize::before, .font-serif .md\\:text-3xl.leading-4.capsize::before, .font-serif .md\\:text-3xl .leading-4.capsize::before,.md\\:text-3xl .font-serif.leading-4.capsize::before,.md\\:text-3xl .font-serif .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.1133em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-4.capsize::after, .font-serif .md\\:text-3xl.leading-4.capsize::after, .font-serif .md\\:text-3xl .leading-4.capsize::after,.md\\:text-3xl .font-serif.leading-4.capsize::after,.md\\:text-3xl .font-serif .leading-4.capsize::after {
    content: '';
    margin-top: 0.1333em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-5.capsize::before, .font-serif .md\\:text-3xl.leading-5.capsize::before, .font-serif .md\\:text-3xl .leading-5.capsize::before,.md\\:text-3xl .font-serif.leading-5.capsize::before,.md\\:text-3xl .font-serif .leading-5.capsize::before {
    content: '';
    margin-bottom: 0.0467em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-5.capsize::after, .font-serif .md\\:text-3xl.leading-5.capsize::after, .font-serif .md\\:text-3xl .leading-5.capsize::after,.md\\:text-3xl .font-serif.leading-5.capsize::after,.md\\:text-3xl .font-serif .leading-5.capsize::after {
    content: '';
    margin-top: 0.0667em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-6.capsize::before, .font-serif .md\\:text-3xl.leading-6.capsize::before, .font-serif .md\\:text-3xl .leading-6.capsize::before,.md\\:text-3xl .font-serif.leading-6.capsize::before,.md\\:text-3xl .font-serif .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.02em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-6.capsize::after, .font-serif .md\\:text-3xl.leading-6.capsize::after, .font-serif .md\\:text-3xl .leading-6.capsize::after,.md\\:text-3xl .font-serif.leading-6.capsize::after,.md\\:text-3xl .font-serif .leading-6.capsize::after {
    content: '';
    margin-top: 0em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-7.capsize::before, .font-serif .md\\:text-3xl.leading-7.capsize::before, .font-serif .md\\:text-3xl .leading-7.capsize::before,.md\\:text-3xl .font-serif.leading-7.capsize::before,.md\\:text-3xl .font-serif .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.0867em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-7.capsize::after, .font-serif .md\\:text-3xl.leading-7.capsize::after, .font-serif .md\\:text-3xl .leading-7.capsize::after,.md\\:text-3xl .font-serif.leading-7.capsize::after,.md\\:text-3xl .font-serif .leading-7.capsize::after {
    content: '';
    margin-top: -0.0667em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-8.capsize::before, .font-serif .md\\:text-3xl.leading-8.capsize::before, .font-serif .md\\:text-3xl .leading-8.capsize::before,.md\\:text-3xl .font-serif.leading-8.capsize::before,.md\\:text-3xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1533em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-3xl.capsize::before, .font-serif .md\\:leading-8.text-3xl.capsize::before, .font-serif .text-3xl .md\\:leading-8.capsize::before, .text-3xl .md\\:leading-8.font-serif.capsize::before, .text-3xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1533em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-8.capsize::before, .font-serif .md\\:text-3xl.leading-8.capsize::before, .font-serif .md\\:text-3xl .leading-8.capsize::before,.md\\:text-3xl .font-serif.leading-8.capsize::before,.md\\:text-3xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1533em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-3xl.capsize::before, .font-serif .md\\:leading-8.text-3xl.capsize::before, .font-serif .text-3xl .md\\:leading-8.capsize::before, .text-3xl .md\\:leading-8.font-serif.capsize::before, .text-3xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1533em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-8.capsize::before, .font-serif .md\\:text-3xl.leading-8.capsize::before, .font-serif .md\\:text-3xl .leading-8.capsize::before,.md\\:text-3xl .font-serif.leading-8.capsize::before,.md\\:text-3xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1533em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-3xl.capsize::before, .font-serif .md\\:leading-8.text-3xl.capsize::before, .font-serif .text-3xl .md\\:leading-8.capsize::before, .text-3xl .md\\:leading-8.font-serif.capsize::before, .text-3xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1533em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-8.capsize::before, .font-serif .md\\:text-3xl.leading-8.capsize::before, .font-serif .md\\:text-3xl .leading-8.capsize::before,.md\\:text-3xl .font-serif.leading-8.capsize::before,.md\\:text-3xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1533em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-3xl.capsize::before, .font-serif .md\\:leading-8.text-3xl.capsize::before, .font-serif .text-3xl .md\\:leading-8.capsize::before, .text-3xl .md\\:leading-8.font-serif.capsize::before, .text-3xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1533em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-8.capsize::before, .font-serif .md\\:text-3xl.leading-8.capsize::before, .font-serif .md\\:text-3xl .leading-8.capsize::before,.md\\:text-3xl .font-serif.leading-8.capsize::before,.md\\:text-3xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1533em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-3xl.capsize::before, .font-serif .md\\:leading-8.text-3xl.capsize::before, .font-serif .text-3xl .md\\:leading-8.capsize::before, .text-3xl .md\\:leading-8.font-serif.capsize::before, .text-3xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1533em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-8.capsize::after, .font-serif .md\\:text-3xl.leading-8.capsize::after, .font-serif .md\\:text-3xl .leading-8.capsize::after,.md\\:text-3xl .font-serif.leading-8.capsize::after,.md\\:text-3xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.1333em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-3xl.capsize::after, .font-serif .md\\:leading-8.text-3xl.capsize::after, .font-serif .text-3xl .md\\:leading-8.capsize::after, .text-3xl .md\\:leading-8.font-serif.capsize::after, .text-3xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.1333em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-8.capsize::after, .font-serif .md\\:text-3xl.leading-8.capsize::after, .font-serif .md\\:text-3xl .leading-8.capsize::after,.md\\:text-3xl .font-serif.leading-8.capsize::after,.md\\:text-3xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.1333em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-3xl.capsize::after, .font-serif .md\\:leading-8.text-3xl.capsize::after, .font-serif .text-3xl .md\\:leading-8.capsize::after, .text-3xl .md\\:leading-8.font-serif.capsize::after, .text-3xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.1333em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-8.capsize::after, .font-serif .md\\:text-3xl.leading-8.capsize::after, .font-serif .md\\:text-3xl .leading-8.capsize::after,.md\\:text-3xl .font-serif.leading-8.capsize::after,.md\\:text-3xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.1333em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-3xl.capsize::after, .font-serif .md\\:leading-8.text-3xl.capsize::after, .font-serif .text-3xl .md\\:leading-8.capsize::after, .text-3xl .md\\:leading-8.font-serif.capsize::after, .text-3xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.1333em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-8.capsize::after, .font-serif .md\\:text-3xl.leading-8.capsize::after, .font-serif .md\\:text-3xl .leading-8.capsize::after,.md\\:text-3xl .font-serif.leading-8.capsize::after,.md\\:text-3xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.1333em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-3xl.capsize::after, .font-serif .md\\:leading-8.text-3xl.capsize::after, .font-serif .text-3xl .md\\:leading-8.capsize::after, .text-3xl .md\\:leading-8.font-serif.capsize::after, .text-3xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.1333em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-8.capsize::after, .font-serif .md\\:text-3xl.leading-8.capsize::after, .font-serif .md\\:text-3xl .leading-8.capsize::after,.md\\:text-3xl .font-serif.leading-8.capsize::after,.md\\:text-3xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.1333em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-3xl.capsize::after, .font-serif .md\\:leading-8.text-3xl.capsize::after, .font-serif .text-3xl .md\\:leading-8.capsize::after, .text-3xl .md\\:leading-8.font-serif.capsize::after, .text-3xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.1333em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-9.capsize::before, .font-serif .md\\:text-3xl.leading-9.capsize::before, .font-serif .md\\:text-3xl .leading-9.capsize::before,.md\\:text-3xl .font-serif.leading-9.capsize::before,.md\\:text-3xl .font-serif .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.22em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-9.capsize::after, .font-serif .md\\:text-3xl.leading-9.capsize::after, .font-serif .md\\:text-3xl .leading-9.capsize::after,.md\\:text-3xl .font-serif.leading-9.capsize::after,.md\\:text-3xl .font-serif .leading-9.capsize::after {
    content: '';
    margin-top: -0.2em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-10.capsize::before, .font-serif .md\\:text-3xl.leading-10.capsize::before, .font-serif .md\\:text-3xl .leading-10.capsize::before,.md\\:text-3xl .font-serif.leading-10.capsize::before,.md\\:text-3xl .font-serif .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.2867em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-10.capsize::after, .font-serif .md\\:text-3xl.leading-10.capsize::after, .font-serif .md\\:text-3xl .leading-10.capsize::after,.md\\:text-3xl .font-serif.leading-10.capsize::after,.md\\:text-3xl .font-serif .leading-10.capsize::after {
    content: '';
    margin-top: -0.2667em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-none.capsize::before, .font-serif .md\\:text-3xl.leading-none.capsize::before, .font-serif .md\\:text-3xl .leading-none.capsize::before,.md\\:text-3xl .font-serif.leading-none.capsize::before,.md\\:text-3xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-3xl.capsize::before, .font-serif .md\\:leading-none.text-3xl.capsize::before, .font-serif .text-3xl .md\\:leading-none.capsize::before, .text-3xl .md\\:leading-none.font-serif.capsize::before, .text-3xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-none.capsize::before, .font-serif .md\\:text-3xl.leading-none.capsize::before, .font-serif .md\\:text-3xl .leading-none.capsize::before,.md\\:text-3xl .font-serif.leading-none.capsize::before,.md\\:text-3xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-3xl.capsize::before, .font-serif .md\\:leading-none.text-3xl.capsize::before, .font-serif .text-3xl .md\\:leading-none.capsize::before, .text-3xl .md\\:leading-none.font-serif.capsize::before, .text-3xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-none.capsize::before, .font-serif .md\\:text-3xl.leading-none.capsize::before, .font-serif .md\\:text-3xl .leading-none.capsize::before,.md\\:text-3xl .font-serif.leading-none.capsize::before,.md\\:text-3xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-3xl.capsize::before, .font-serif .md\\:leading-none.text-3xl.capsize::before, .font-serif .text-3xl .md\\:leading-none.capsize::before, .text-3xl .md\\:leading-none.font-serif.capsize::before, .text-3xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-none.capsize::before, .font-serif .md\\:text-3xl.leading-none.capsize::before, .font-serif .md\\:text-3xl .leading-none.capsize::before,.md\\:text-3xl .font-serif.leading-none.capsize::before,.md\\:text-3xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-3xl.capsize::before, .font-serif .md\\:leading-none.text-3xl.capsize::before, .font-serif .text-3xl .md\\:leading-none.capsize::before, .text-3xl .md\\:leading-none.font-serif.capsize::before, .text-3xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-none.capsize::before, .font-serif .md\\:text-3xl.leading-none.capsize::before, .font-serif .md\\:text-3xl .leading-none.capsize::before,.md\\:text-3xl .font-serif.leading-none.capsize::before,.md\\:text-3xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-3xl.capsize::before, .font-serif .md\\:leading-none.text-3xl.capsize::before, .font-serif .text-3xl .md\\:leading-none.capsize::before, .text-3xl .md\\:leading-none.font-serif.capsize::before, .text-3xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-none.capsize::after, .font-serif .md\\:text-3xl.leading-none.capsize::after, .font-serif .md\\:text-3xl .leading-none.capsize::after,.md\\:text-3xl .font-serif.leading-none.capsize::after,.md\\:text-3xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-3xl.capsize::after, .font-serif .md\\:leading-none.text-3xl.capsize::after, .font-serif .text-3xl .md\\:leading-none.capsize::after, .text-3xl .md\\:leading-none.font-serif.capsize::after, .text-3xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-none.capsize::after, .font-serif .md\\:text-3xl.leading-none.capsize::after, .font-serif .md\\:text-3xl .leading-none.capsize::after,.md\\:text-3xl .font-serif.leading-none.capsize::after,.md\\:text-3xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-3xl.capsize::after, .font-serif .md\\:leading-none.text-3xl.capsize::after, .font-serif .text-3xl .md\\:leading-none.capsize::after, .text-3xl .md\\:leading-none.font-serif.capsize::after, .text-3xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-none.capsize::after, .font-serif .md\\:text-3xl.leading-none.capsize::after, .font-serif .md\\:text-3xl .leading-none.capsize::after,.md\\:text-3xl .font-serif.leading-none.capsize::after,.md\\:text-3xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-3xl.capsize::after, .font-serif .md\\:leading-none.text-3xl.capsize::after, .font-serif .text-3xl .md\\:leading-none.capsize::after, .text-3xl .md\\:leading-none.font-serif.capsize::after, .text-3xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-none.capsize::after, .font-serif .md\\:text-3xl.leading-none.capsize::after, .font-serif .md\\:text-3xl .leading-none.capsize::after,.md\\:text-3xl .font-serif.leading-none.capsize::after,.md\\:text-3xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-3xl.capsize::after, .font-serif .md\\:leading-none.text-3xl.capsize::after, .font-serif .text-3xl .md\\:leading-none.capsize::after, .text-3xl .md\\:leading-none.font-serif.capsize::after, .text-3xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-none.capsize::after, .font-serif .md\\:text-3xl.leading-none.capsize::after, .font-serif .md\\:text-3xl .leading-none.capsize::after,.md\\:text-3xl .font-serif.leading-none.capsize::after,.md\\:text-3xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-3xl.capsize::after, .font-serif .md\\:leading-none.text-3xl.capsize::after, .font-serif .text-3xl .md\\:leading-none.capsize::after, .text-3xl .md\\:leading-none.font-serif.capsize::after, .text-3xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-3xl.leading-tight.capsize::before, .font-serif .md\\:text-3xl .leading-tight.capsize::before,.md\\:text-3xl .font-serif.leading-tight.capsize::before,.md\\:text-3xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-3xl.capsize::before, .font-serif .md\\:leading-tight.text-3xl.capsize::before, .font-serif .text-3xl .md\\:leading-tight.capsize::before, .text-3xl .md\\:leading-tight.font-serif.capsize::before, .text-3xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-3xl.leading-tight.capsize::before, .font-serif .md\\:text-3xl .leading-tight.capsize::before,.md\\:text-3xl .font-serif.leading-tight.capsize::before,.md\\:text-3xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-3xl.capsize::before, .font-serif .md\\:leading-tight.text-3xl.capsize::before, .font-serif .text-3xl .md\\:leading-tight.capsize::before, .text-3xl .md\\:leading-tight.font-serif.capsize::before, .text-3xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-3xl.leading-tight.capsize::before, .font-serif .md\\:text-3xl .leading-tight.capsize::before,.md\\:text-3xl .font-serif.leading-tight.capsize::before,.md\\:text-3xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-3xl.capsize::before, .font-serif .md\\:leading-tight.text-3xl.capsize::before, .font-serif .text-3xl .md\\:leading-tight.capsize::before, .text-3xl .md\\:leading-tight.font-serif.capsize::before, .text-3xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-3xl.leading-tight.capsize::before, .font-serif .md\\:text-3xl .leading-tight.capsize::before,.md\\:text-3xl .font-serif.leading-tight.capsize::before,.md\\:text-3xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-3xl.capsize::before, .font-serif .md\\:leading-tight.text-3xl.capsize::before, .font-serif .text-3xl .md\\:leading-tight.capsize::before, .text-3xl .md\\:leading-tight.font-serif.capsize::before, .text-3xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-3xl.leading-tight.capsize::before, .font-serif .md\\:text-3xl .leading-tight.capsize::before,.md\\:text-3xl .font-serif.leading-tight.capsize::before,.md\\:text-3xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-3xl.capsize::before, .font-serif .md\\:leading-tight.text-3xl.capsize::before, .font-serif .text-3xl .md\\:leading-tight.capsize::before, .text-3xl .md\\:leading-tight.font-serif.capsize::before, .text-3xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-3xl.leading-tight.capsize::after, .font-serif .md\\:text-3xl .leading-tight.capsize::after,.md\\:text-3xl .font-serif.leading-tight.capsize::after,.md\\:text-3xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-3xl.capsize::after, .font-serif .md\\:leading-tight.text-3xl.capsize::after, .font-serif .text-3xl .md\\:leading-tight.capsize::after, .text-3xl .md\\:leading-tight.font-serif.capsize::after, .text-3xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-3xl.leading-tight.capsize::after, .font-serif .md\\:text-3xl .leading-tight.capsize::after,.md\\:text-3xl .font-serif.leading-tight.capsize::after,.md\\:text-3xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-3xl.capsize::after, .font-serif .md\\:leading-tight.text-3xl.capsize::after, .font-serif .text-3xl .md\\:leading-tight.capsize::after, .text-3xl .md\\:leading-tight.font-serif.capsize::after, .text-3xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-3xl.leading-tight.capsize::after, .font-serif .md\\:text-3xl .leading-tight.capsize::after,.md\\:text-3xl .font-serif.leading-tight.capsize::after,.md\\:text-3xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-3xl.capsize::after, .font-serif .md\\:leading-tight.text-3xl.capsize::after, .font-serif .text-3xl .md\\:leading-tight.capsize::after, .text-3xl .md\\:leading-tight.font-serif.capsize::after, .text-3xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-3xl.leading-tight.capsize::after, .font-serif .md\\:text-3xl .leading-tight.capsize::after,.md\\:text-3xl .font-serif.leading-tight.capsize::after,.md\\:text-3xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-3xl.capsize::after, .font-serif .md\\:leading-tight.text-3xl.capsize::after, .font-serif .text-3xl .md\\:leading-tight.capsize::after, .text-3xl .md\\:leading-tight.font-serif.capsize::after, .text-3xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-3xl.leading-tight.capsize::after, .font-serif .md\\:text-3xl .leading-tight.capsize::after,.md\\:text-3xl .font-serif.leading-tight.capsize::after,.md\\:text-3xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-3xl.capsize::after, .font-serif .md\\:leading-tight.text-3xl.capsize::after, .font-serif .text-3xl .md\\:leading-tight.capsize::after, .text-3xl .md\\:leading-tight.font-serif.capsize::after, .text-3xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-snug.capsize::before, .font-serif .md\\:text-3xl.leading-snug.capsize::before, .font-serif .md\\:text-3xl .leading-snug.capsize::before,.md\\:text-3xl .font-serif.leading-snug.capsize::before,.md\\:text-3xl .font-serif .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3075em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-snug.capsize::after, .font-serif .md\\:text-3xl.leading-snug.capsize::after, .font-serif .md\\:text-3xl .leading-snug.capsize::after,.md\\:text-3xl .font-serif.leading-snug.capsize::after,.md\\:text-3xl .font-serif .leading-snug.capsize::after {
    content: '';
    margin-top: -0.2875em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-normal.capsize::before, .font-serif .md\\:text-3xl.leading-normal.capsize::before, .font-serif .md\\:text-3xl .leading-normal.capsize::before,.md\\:text-3xl .font-serif.leading-normal.capsize::before,.md\\:text-3xl .font-serif .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-normal.capsize::after, .font-serif .md\\:text-3xl.leading-normal.capsize::after, .font-serif .md\\:text-3xl .leading-normal.capsize::after,.md\\:text-3xl .font-serif.leading-normal.capsize::after,.md\\:text-3xl .font-serif .leading-normal.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-relaxed.capsize::before, .font-serif .md\\:text-3xl.leading-relaxed.capsize::before, .font-serif .md\\:text-3xl .leading-relaxed.capsize::before,.md\\:text-3xl .font-serif.leading-relaxed.capsize::before,.md\\:text-3xl .font-serif .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4325em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-relaxed.capsize::after, .font-serif .md\\:text-3xl.leading-relaxed.capsize::after, .font-serif .md\\:text-3xl .leading-relaxed.capsize::after,.md\\:text-3xl .font-serif.leading-relaxed.capsize::after,.md\\:text-3xl .font-serif .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4125em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-loose.capsize::before, .font-serif .md\\:text-3xl.leading-loose.capsize::before, .font-serif .md\\:text-3xl .leading-loose.capsize::before,.md\\:text-3xl .font-serif.leading-loose.capsize::before,.md\\:text-3xl .font-serif .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .md\\:text-3xl.font-serif.leading-loose.capsize::after, .font-serif .md\\:text-3xl.leading-loose.capsize::after, .font-serif .md\\:text-3xl .leading-loose.capsize::after,.md\\:text-3xl .font-serif.leading-loose.capsize::after,.md\\:text-3xl .font-serif .leading-loose.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-3.capsize::before, .font-serif .md\\:text-4xl.leading-3.capsize::before, .font-serif .md\\:text-4xl .leading-3.capsize::before,.md\\:text-4xl .font-serif.leading-3.capsize::before,.md\\:text-4xl .font-serif .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.2133em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-3.capsize::after, .font-serif .md\\:text-4xl.leading-3.capsize::after, .font-serif .md\\:text-4xl .leading-3.capsize::after,.md\\:text-4xl .font-serif.leading-3.capsize::after,.md\\:text-4xl .font-serif .leading-3.capsize::after {
    content: '';
    margin-top: 0.2333em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-4.capsize::before, .font-serif .md\\:text-4xl.leading-4.capsize::before, .font-serif .md\\:text-4xl .leading-4.capsize::before,.md\\:text-4xl .font-serif.leading-4.capsize::before,.md\\:text-4xl .font-serif .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.1578em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-4.capsize::after, .font-serif .md\\:text-4xl.leading-4.capsize::after, .font-serif .md\\:text-4xl .leading-4.capsize::after,.md\\:text-4xl .font-serif.leading-4.capsize::after,.md\\:text-4xl .font-serif .leading-4.capsize::after {
    content: '';
    margin-top: 0.1778em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-5.capsize::before, .font-serif .md\\:text-4xl.leading-5.capsize::before, .font-serif .md\\:text-4xl .leading-5.capsize::before,.md\\:text-4xl .font-serif.leading-5.capsize::before,.md\\:text-4xl .font-serif .leading-5.capsize::before {
    content: '';
    margin-bottom: 0.1022em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-5.capsize::after, .font-serif .md\\:text-4xl.leading-5.capsize::after, .font-serif .md\\:text-4xl .leading-5.capsize::after,.md\\:text-4xl .font-serif.leading-5.capsize::after,.md\\:text-4xl .font-serif .leading-5.capsize::after {
    content: '';
    margin-top: 0.1222em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-6.capsize::before, .font-serif .md\\:text-4xl.leading-6.capsize::before, .font-serif .md\\:text-4xl .leading-6.capsize::before,.md\\:text-4xl .font-serif.leading-6.capsize::before,.md\\:text-4xl .font-serif .leading-6.capsize::before {
    content: '';
    margin-bottom: 0.0467em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-6.capsize::after, .font-serif .md\\:text-4xl.leading-6.capsize::after, .font-serif .md\\:text-4xl .leading-6.capsize::after,.md\\:text-4xl .font-serif.leading-6.capsize::after,.md\\:text-4xl .font-serif .leading-6.capsize::after {
    content: '';
    margin-top: 0.0667em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-7.capsize::before, .font-serif .md\\:text-4xl.leading-7.capsize::before, .font-serif .md\\:text-4xl .leading-7.capsize::before,.md\\:text-4xl .font-serif.leading-7.capsize::before,.md\\:text-4xl .font-serif .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.0089em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-7.capsize::after, .font-serif .md\\:text-4xl.leading-7.capsize::after, .font-serif .md\\:text-4xl .leading-7.capsize::after,.md\\:text-4xl .font-serif.leading-7.capsize::after,.md\\:text-4xl .font-serif .leading-7.capsize::after {
    content: '';
    margin-top: 0.0111em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-8.capsize::before, .font-serif .md\\:text-4xl.leading-8.capsize::before, .font-serif .md\\:text-4xl .leading-8.capsize::before,.md\\:text-4xl .font-serif.leading-8.capsize::before,.md\\:text-4xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.0644em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-4xl.capsize::before, .font-serif .md\\:leading-8.text-4xl.capsize::before, .font-serif .text-4xl .md\\:leading-8.capsize::before, .text-4xl .md\\:leading-8.font-serif.capsize::before, .text-4xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.0644em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-8.capsize::before, .font-serif .md\\:text-4xl.leading-8.capsize::before, .font-serif .md\\:text-4xl .leading-8.capsize::before,.md\\:text-4xl .font-serif.leading-8.capsize::before,.md\\:text-4xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.0644em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-4xl.capsize::before, .font-serif .md\\:leading-8.text-4xl.capsize::before, .font-serif .text-4xl .md\\:leading-8.capsize::before, .text-4xl .md\\:leading-8.font-serif.capsize::before, .text-4xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.0644em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-8.capsize::before, .font-serif .md\\:text-4xl.leading-8.capsize::before, .font-serif .md\\:text-4xl .leading-8.capsize::before,.md\\:text-4xl .font-serif.leading-8.capsize::before,.md\\:text-4xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.0644em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-4xl.capsize::before, .font-serif .md\\:leading-8.text-4xl.capsize::before, .font-serif .text-4xl .md\\:leading-8.capsize::before, .text-4xl .md\\:leading-8.font-serif.capsize::before, .text-4xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.0644em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-8.capsize::before, .font-serif .md\\:text-4xl.leading-8.capsize::before, .font-serif .md\\:text-4xl .leading-8.capsize::before,.md\\:text-4xl .font-serif.leading-8.capsize::before,.md\\:text-4xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.0644em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-4xl.capsize::before, .font-serif .md\\:leading-8.text-4xl.capsize::before, .font-serif .text-4xl .md\\:leading-8.capsize::before, .text-4xl .md\\:leading-8.font-serif.capsize::before, .text-4xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.0644em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-8.capsize::before, .font-serif .md\\:text-4xl.leading-8.capsize::before, .font-serif .md\\:text-4xl .leading-8.capsize::before,.md\\:text-4xl .font-serif.leading-8.capsize::before,.md\\:text-4xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.0644em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-4xl.capsize::before, .font-serif .md\\:leading-8.text-4xl.capsize::before, .font-serif .text-4xl .md\\:leading-8.capsize::before, .text-4xl .md\\:leading-8.font-serif.capsize::before, .text-4xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.0644em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-8.capsize::after, .font-serif .md\\:text-4xl.leading-8.capsize::after, .font-serif .md\\:text-4xl .leading-8.capsize::after,.md\\:text-4xl .font-serif.leading-8.capsize::after,.md\\:text-4xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.0444em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-4xl.capsize::after, .font-serif .md\\:leading-8.text-4xl.capsize::after, .font-serif .text-4xl .md\\:leading-8.capsize::after, .text-4xl .md\\:leading-8.font-serif.capsize::after, .text-4xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.0444em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-8.capsize::after, .font-serif .md\\:text-4xl.leading-8.capsize::after, .font-serif .md\\:text-4xl .leading-8.capsize::after,.md\\:text-4xl .font-serif.leading-8.capsize::after,.md\\:text-4xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.0444em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-4xl.capsize::after, .font-serif .md\\:leading-8.text-4xl.capsize::after, .font-serif .text-4xl .md\\:leading-8.capsize::after, .text-4xl .md\\:leading-8.font-serif.capsize::after, .text-4xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.0444em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-8.capsize::after, .font-serif .md\\:text-4xl.leading-8.capsize::after, .font-serif .md\\:text-4xl .leading-8.capsize::after,.md\\:text-4xl .font-serif.leading-8.capsize::after,.md\\:text-4xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.0444em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-4xl.capsize::after, .font-serif .md\\:leading-8.text-4xl.capsize::after, .font-serif .text-4xl .md\\:leading-8.capsize::after, .text-4xl .md\\:leading-8.font-serif.capsize::after, .text-4xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.0444em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-8.capsize::after, .font-serif .md\\:text-4xl.leading-8.capsize::after, .font-serif .md\\:text-4xl .leading-8.capsize::after,.md\\:text-4xl .font-serif.leading-8.capsize::after,.md\\:text-4xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.0444em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-4xl.capsize::after, .font-serif .md\\:leading-8.text-4xl.capsize::after, .font-serif .text-4xl .md\\:leading-8.capsize::after, .text-4xl .md\\:leading-8.font-serif.capsize::after, .text-4xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.0444em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-8.capsize::after, .font-serif .md\\:text-4xl.leading-8.capsize::after, .font-serif .md\\:text-4xl .leading-8.capsize::after,.md\\:text-4xl .font-serif.leading-8.capsize::after,.md\\:text-4xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.0444em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-4xl.capsize::after, .font-serif .md\\:leading-8.text-4xl.capsize::after, .font-serif .text-4xl .md\\:leading-8.capsize::after, .text-4xl .md\\:leading-8.font-serif.capsize::after, .text-4xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.0444em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-9.capsize::before, .font-serif .md\\:text-4xl.leading-9.capsize::before, .font-serif .md\\:text-4xl .leading-9.capsize::before,.md\\:text-4xl .font-serif.leading-9.capsize::before,.md\\:text-4xl .font-serif .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-9.capsize::after, .font-serif .md\\:text-4xl.leading-9.capsize::after, .font-serif .md\\:text-4xl .leading-9.capsize::after,.md\\:text-4xl .font-serif.leading-9.capsize::after,.md\\:text-4xl .font-serif .leading-9.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-10.capsize::before, .font-serif .md\\:text-4xl.leading-10.capsize::before, .font-serif .md\\:text-4xl .leading-10.capsize::before,.md\\:text-4xl .font-serif.leading-10.capsize::before,.md\\:text-4xl .font-serif .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.1756em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-10.capsize::after, .font-serif .md\\:text-4xl.leading-10.capsize::after, .font-serif .md\\:text-4xl .leading-10.capsize::after,.md\\:text-4xl .font-serif.leading-10.capsize::after,.md\\:text-4xl .font-serif .leading-10.capsize::after {
    content: '';
    margin-top: -0.1556em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-none.capsize::before, .font-serif .md\\:text-4xl.leading-none.capsize::before, .font-serif .md\\:text-4xl .leading-none.capsize::before,.md\\:text-4xl .font-serif.leading-none.capsize::before,.md\\:text-4xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-4xl.capsize::before, .font-serif .md\\:leading-none.text-4xl.capsize::before, .font-serif .text-4xl .md\\:leading-none.capsize::before, .text-4xl .md\\:leading-none.font-serif.capsize::before, .text-4xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-none.capsize::before, .font-serif .md\\:text-4xl.leading-none.capsize::before, .font-serif .md\\:text-4xl .leading-none.capsize::before,.md\\:text-4xl .font-serif.leading-none.capsize::before,.md\\:text-4xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-4xl.capsize::before, .font-serif .md\\:leading-none.text-4xl.capsize::before, .font-serif .text-4xl .md\\:leading-none.capsize::before, .text-4xl .md\\:leading-none.font-serif.capsize::before, .text-4xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-none.capsize::before, .font-serif .md\\:text-4xl.leading-none.capsize::before, .font-serif .md\\:text-4xl .leading-none.capsize::before,.md\\:text-4xl .font-serif.leading-none.capsize::before,.md\\:text-4xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-4xl.capsize::before, .font-serif .md\\:leading-none.text-4xl.capsize::before, .font-serif .text-4xl .md\\:leading-none.capsize::before, .text-4xl .md\\:leading-none.font-serif.capsize::before, .text-4xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-none.capsize::before, .font-serif .md\\:text-4xl.leading-none.capsize::before, .font-serif .md\\:text-4xl .leading-none.capsize::before,.md\\:text-4xl .font-serif.leading-none.capsize::before,.md\\:text-4xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-4xl.capsize::before, .font-serif .md\\:leading-none.text-4xl.capsize::before, .font-serif .text-4xl .md\\:leading-none.capsize::before, .text-4xl .md\\:leading-none.font-serif.capsize::before, .text-4xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-none.capsize::before, .font-serif .md\\:text-4xl.leading-none.capsize::before, .font-serif .md\\:text-4xl .leading-none.capsize::before,.md\\:text-4xl .font-serif.leading-none.capsize::before,.md\\:text-4xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-4xl.capsize::before, .font-serif .md\\:leading-none.text-4xl.capsize::before, .font-serif .text-4xl .md\\:leading-none.capsize::before, .text-4xl .md\\:leading-none.font-serif.capsize::before, .text-4xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-none.capsize::after, .font-serif .md\\:text-4xl.leading-none.capsize::after, .font-serif .md\\:text-4xl .leading-none.capsize::after,.md\\:text-4xl .font-serif.leading-none.capsize::after,.md\\:text-4xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-4xl.capsize::after, .font-serif .md\\:leading-none.text-4xl.capsize::after, .font-serif .text-4xl .md\\:leading-none.capsize::after, .text-4xl .md\\:leading-none.font-serif.capsize::after, .text-4xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-none.capsize::after, .font-serif .md\\:text-4xl.leading-none.capsize::after, .font-serif .md\\:text-4xl .leading-none.capsize::after,.md\\:text-4xl .font-serif.leading-none.capsize::after,.md\\:text-4xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-4xl.capsize::after, .font-serif .md\\:leading-none.text-4xl.capsize::after, .font-serif .text-4xl .md\\:leading-none.capsize::after, .text-4xl .md\\:leading-none.font-serif.capsize::after, .text-4xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-none.capsize::after, .font-serif .md\\:text-4xl.leading-none.capsize::after, .font-serif .md\\:text-4xl .leading-none.capsize::after,.md\\:text-4xl .font-serif.leading-none.capsize::after,.md\\:text-4xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-4xl.capsize::after, .font-serif .md\\:leading-none.text-4xl.capsize::after, .font-serif .text-4xl .md\\:leading-none.capsize::after, .text-4xl .md\\:leading-none.font-serif.capsize::after, .text-4xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-none.capsize::after, .font-serif .md\\:text-4xl.leading-none.capsize::after, .font-serif .md\\:text-4xl .leading-none.capsize::after,.md\\:text-4xl .font-serif.leading-none.capsize::after,.md\\:text-4xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-4xl.capsize::after, .font-serif .md\\:leading-none.text-4xl.capsize::after, .font-serif .text-4xl .md\\:leading-none.capsize::after, .text-4xl .md\\:leading-none.font-serif.capsize::after, .text-4xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-none.capsize::after, .font-serif .md\\:text-4xl.leading-none.capsize::after, .font-serif .md\\:text-4xl .leading-none.capsize::after,.md\\:text-4xl .font-serif.leading-none.capsize::after,.md\\:text-4xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-4xl.capsize::after, .font-serif .md\\:leading-none.text-4xl.capsize::after, .font-serif .text-4xl .md\\:leading-none.capsize::after, .text-4xl .md\\:leading-none.font-serif.capsize::after, .text-4xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-4xl.leading-tight.capsize::before, .font-serif .md\\:text-4xl .leading-tight.capsize::before,.md\\:text-4xl .font-serif.leading-tight.capsize::before,.md\\:text-4xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-4xl.capsize::before, .font-serif .md\\:leading-tight.text-4xl.capsize::before, .font-serif .text-4xl .md\\:leading-tight.capsize::before, .text-4xl .md\\:leading-tight.font-serif.capsize::before, .text-4xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-4xl.leading-tight.capsize::before, .font-serif .md\\:text-4xl .leading-tight.capsize::before,.md\\:text-4xl .font-serif.leading-tight.capsize::before,.md\\:text-4xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-4xl.capsize::before, .font-serif .md\\:leading-tight.text-4xl.capsize::before, .font-serif .text-4xl .md\\:leading-tight.capsize::before, .text-4xl .md\\:leading-tight.font-serif.capsize::before, .text-4xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-4xl.leading-tight.capsize::before, .font-serif .md\\:text-4xl .leading-tight.capsize::before,.md\\:text-4xl .font-serif.leading-tight.capsize::before,.md\\:text-4xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-4xl.capsize::before, .font-serif .md\\:leading-tight.text-4xl.capsize::before, .font-serif .text-4xl .md\\:leading-tight.capsize::before, .text-4xl .md\\:leading-tight.font-serif.capsize::before, .text-4xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-4xl.leading-tight.capsize::before, .font-serif .md\\:text-4xl .leading-tight.capsize::before,.md\\:text-4xl .font-serif.leading-tight.capsize::before,.md\\:text-4xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-4xl.capsize::before, .font-serif .md\\:leading-tight.text-4xl.capsize::before, .font-serif .text-4xl .md\\:leading-tight.capsize::before, .text-4xl .md\\:leading-tight.font-serif.capsize::before, .text-4xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-4xl.leading-tight.capsize::before, .font-serif .md\\:text-4xl .leading-tight.capsize::before,.md\\:text-4xl .font-serif.leading-tight.capsize::before,.md\\:text-4xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-4xl.capsize::before, .font-serif .md\\:leading-tight.text-4xl.capsize::before, .font-serif .text-4xl .md\\:leading-tight.capsize::before, .text-4xl .md\\:leading-tight.font-serif.capsize::before, .text-4xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-4xl.leading-tight.capsize::after, .font-serif .md\\:text-4xl .leading-tight.capsize::after,.md\\:text-4xl .font-serif.leading-tight.capsize::after,.md\\:text-4xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-4xl.capsize::after, .font-serif .md\\:leading-tight.text-4xl.capsize::after, .font-serif .text-4xl .md\\:leading-tight.capsize::after, .text-4xl .md\\:leading-tight.font-serif.capsize::after, .text-4xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-4xl.leading-tight.capsize::after, .font-serif .md\\:text-4xl .leading-tight.capsize::after,.md\\:text-4xl .font-serif.leading-tight.capsize::after,.md\\:text-4xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-4xl.capsize::after, .font-serif .md\\:leading-tight.text-4xl.capsize::after, .font-serif .text-4xl .md\\:leading-tight.capsize::after, .text-4xl .md\\:leading-tight.font-serif.capsize::after, .text-4xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-4xl.leading-tight.capsize::after, .font-serif .md\\:text-4xl .leading-tight.capsize::after,.md\\:text-4xl .font-serif.leading-tight.capsize::after,.md\\:text-4xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-4xl.capsize::after, .font-serif .md\\:leading-tight.text-4xl.capsize::after, .font-serif .text-4xl .md\\:leading-tight.capsize::after, .text-4xl .md\\:leading-tight.font-serif.capsize::after, .text-4xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-4xl.leading-tight.capsize::after, .font-serif .md\\:text-4xl .leading-tight.capsize::after,.md\\:text-4xl .font-serif.leading-tight.capsize::after,.md\\:text-4xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-4xl.capsize::after, .font-serif .md\\:leading-tight.text-4xl.capsize::after, .font-serif .text-4xl .md\\:leading-tight.capsize::after, .text-4xl .md\\:leading-tight.font-serif.capsize::after, .text-4xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-4xl.leading-tight.capsize::after, .font-serif .md\\:text-4xl .leading-tight.capsize::after,.md\\:text-4xl .font-serif.leading-tight.capsize::after,.md\\:text-4xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-4xl.capsize::after, .font-serif .md\\:leading-tight.text-4xl.capsize::after, .font-serif .text-4xl .md\\:leading-tight.capsize::after, .text-4xl .md\\:leading-tight.font-serif.capsize::after, .text-4xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-snug.capsize::before, .font-serif .md\\:text-4xl.leading-snug.capsize::before, .font-serif .md\\:text-4xl .leading-snug.capsize::before,.md\\:text-4xl .font-serif.leading-snug.capsize::before,.md\\:text-4xl .font-serif .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3075em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-snug.capsize::after, .font-serif .md\\:text-4xl.leading-snug.capsize::after, .font-serif .md\\:text-4xl .leading-snug.capsize::after,.md\\:text-4xl .font-serif.leading-snug.capsize::after,.md\\:text-4xl .font-serif .leading-snug.capsize::after {
    content: '';
    margin-top: -0.2875em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-normal.capsize::before, .font-serif .md\\:text-4xl.leading-normal.capsize::before, .font-serif .md\\:text-4xl .leading-normal.capsize::before,.md\\:text-4xl .font-serif.leading-normal.capsize::before,.md\\:text-4xl .font-serif .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-normal.capsize::after, .font-serif .md\\:text-4xl.leading-normal.capsize::after, .font-serif .md\\:text-4xl .leading-normal.capsize::after,.md\\:text-4xl .font-serif.leading-normal.capsize::after,.md\\:text-4xl .font-serif .leading-normal.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-relaxed.capsize::before, .font-serif .md\\:text-4xl.leading-relaxed.capsize::before, .font-serif .md\\:text-4xl .leading-relaxed.capsize::before,.md\\:text-4xl .font-serif.leading-relaxed.capsize::before,.md\\:text-4xl .font-serif .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4325em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-relaxed.capsize::after, .font-serif .md\\:text-4xl.leading-relaxed.capsize::after, .font-serif .md\\:text-4xl .leading-relaxed.capsize::after,.md\\:text-4xl .font-serif.leading-relaxed.capsize::after,.md\\:text-4xl .font-serif .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4125em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-loose.capsize::before, .font-serif .md\\:text-4xl.leading-loose.capsize::before, .font-serif .md\\:text-4xl .leading-loose.capsize::before,.md\\:text-4xl .font-serif.leading-loose.capsize::before,.md\\:text-4xl .font-serif .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .md\\:text-4xl.font-serif.leading-loose.capsize::after, .font-serif .md\\:text-4xl.leading-loose.capsize::after, .font-serif .md\\:text-4xl .leading-loose.capsize::after,.md\\:text-4xl .font-serif.leading-loose.capsize::after,.md\\:text-4xl .font-serif .leading-loose.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-5xl.capsize::before, .font-serif .md\\:leading-8.text-5xl.capsize::before, .font-serif .text-5xl .md\\:leading-8.capsize::before, .text-5xl .md\\:leading-8.font-serif.capsize::before, .text-5xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.0467em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-5xl.capsize::after, .font-serif .md\\:leading-8.text-5xl.capsize::after, .font-serif .text-5xl .md\\:leading-8.capsize::after, .text-5xl .md\\:leading-8.font-serif.capsize::after, .text-5xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.0667em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-5xl.capsize::before, .font-serif .md\\:leading-none.text-5xl.capsize::before, .font-serif .text-5xl .md\\:leading-none.capsize::before, .text-5xl .md\\:leading-none.font-serif.capsize::before, .text-5xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-5xl.capsize::after, .font-serif .md\\:leading-none.text-5xl.capsize::after, .font-serif .text-5xl .md\\:leading-none.capsize::after, .text-5xl .md\\:leading-none.font-serif.capsize::after, .text-5xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-5xl.capsize::before, .font-serif .md\\:leading-tight.text-5xl.capsize::before, .font-serif .text-5xl .md\\:leading-tight.capsize::before, .text-5xl .md\\:leading-tight.font-serif.capsize::before, .text-5xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-5xl.capsize::after, .font-serif .md\\:leading-tight.text-5xl.capsize::after, .font-serif .text-5xl .md\\:leading-tight.capsize::after, .text-5xl .md\\:leading-tight.font-serif.capsize::after, .text-5xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-3.capsize::before, .font-serif .md\\:text-6xl.leading-3.capsize::before, .font-serif .md\\:text-6xl .leading-3.capsize::before,.md\\:text-6xl .font-serif.leading-3.capsize::before,.md\\:text-6xl .font-serif .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.28em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-3.capsize::after, .font-serif .md\\:text-6xl.leading-3.capsize::after, .font-serif .md\\:text-6xl .leading-3.capsize::after,.md\\:text-6xl .font-serif.leading-3.capsize::after,.md\\:text-6xl .font-serif .leading-3.capsize::after {
    content: '';
    margin-top: 0.3em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-4.capsize::before, .font-serif .md\\:text-6xl.leading-4.capsize::before, .font-serif .md\\:text-6xl .leading-4.capsize::before,.md\\:text-6xl .font-serif.leading-4.capsize::before,.md\\:text-6xl .font-serif .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.2467em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-4.capsize::after, .font-serif .md\\:text-6xl.leading-4.capsize::after, .font-serif .md\\:text-6xl .leading-4.capsize::after,.md\\:text-6xl .font-serif.leading-4.capsize::after,.md\\:text-6xl .font-serif .leading-4.capsize::after {
    content: '';
    margin-top: 0.2667em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-5.capsize::before, .font-serif .md\\:text-6xl.leading-5.capsize::before, .font-serif .md\\:text-6xl .leading-5.capsize::before,.md\\:text-6xl .font-serif.leading-5.capsize::before,.md\\:text-6xl .font-serif .leading-5.capsize::before {
    content: '';
    margin-bottom: 0.2133em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-5.capsize::after, .font-serif .md\\:text-6xl.leading-5.capsize::after, .font-serif .md\\:text-6xl .leading-5.capsize::after,.md\\:text-6xl .font-serif.leading-5.capsize::after,.md\\:text-6xl .font-serif .leading-5.capsize::after {
    content: '';
    margin-top: 0.2333em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-6.capsize::before, .font-serif .md\\:text-6xl.leading-6.capsize::before, .font-serif .md\\:text-6xl .leading-6.capsize::before,.md\\:text-6xl .font-serif.leading-6.capsize::before,.md\\:text-6xl .font-serif .leading-6.capsize::before {
    content: '';
    margin-bottom: 0.18em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-6.capsize::after, .font-serif .md\\:text-6xl.leading-6.capsize::after, .font-serif .md\\:text-6xl .leading-6.capsize::after,.md\\:text-6xl .font-serif.leading-6.capsize::after,.md\\:text-6xl .font-serif .leading-6.capsize::after {
    content: '';
    margin-top: 0.2em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-7.capsize::before, .font-serif .md\\:text-6xl.leading-7.capsize::before, .font-serif .md\\:text-6xl .leading-7.capsize::before,.md\\:text-6xl .font-serif.leading-7.capsize::before,.md\\:text-6xl .font-serif .leading-7.capsize::before {
    content: '';
    margin-bottom: 0.1467em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-7.capsize::after, .font-serif .md\\:text-6xl.leading-7.capsize::after, .font-serif .md\\:text-6xl .leading-7.capsize::after,.md\\:text-6xl .font-serif.leading-7.capsize::after,.md\\:text-6xl .font-serif .leading-7.capsize::after {
    content: '';
    margin-top: 0.1667em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-8.capsize::before, .font-serif .md\\:text-6xl.leading-8.capsize::before, .font-serif .md\\:text-6xl .leading-8.capsize::before,.md\\:text-6xl .font-serif.leading-8.capsize::before,.md\\:text-6xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1133em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-6xl.capsize::before, .font-serif .md\\:leading-8.text-6xl.capsize::before, .font-serif .text-6xl .md\\:leading-8.capsize::before, .text-6xl .md\\:leading-8.font-serif.capsize::before, .text-6xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1133em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-8.capsize::before, .font-serif .md\\:text-6xl.leading-8.capsize::before, .font-serif .md\\:text-6xl .leading-8.capsize::before,.md\\:text-6xl .font-serif.leading-8.capsize::before,.md\\:text-6xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1133em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-6xl.capsize::before, .font-serif .md\\:leading-8.text-6xl.capsize::before, .font-serif .text-6xl .md\\:leading-8.capsize::before, .text-6xl .md\\:leading-8.font-serif.capsize::before, .text-6xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1133em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-8.capsize::before, .font-serif .md\\:text-6xl.leading-8.capsize::before, .font-serif .md\\:text-6xl .leading-8.capsize::before,.md\\:text-6xl .font-serif.leading-8.capsize::before,.md\\:text-6xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1133em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-6xl.capsize::before, .font-serif .md\\:leading-8.text-6xl.capsize::before, .font-serif .text-6xl .md\\:leading-8.capsize::before, .text-6xl .md\\:leading-8.font-serif.capsize::before, .text-6xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1133em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-8.capsize::before, .font-serif .md\\:text-6xl.leading-8.capsize::before, .font-serif .md\\:text-6xl .leading-8.capsize::before,.md\\:text-6xl .font-serif.leading-8.capsize::before,.md\\:text-6xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1133em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-6xl.capsize::before, .font-serif .md\\:leading-8.text-6xl.capsize::before, .font-serif .text-6xl .md\\:leading-8.capsize::before, .text-6xl .md\\:leading-8.font-serif.capsize::before, .text-6xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1133em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-8.capsize::before, .font-serif .md\\:text-6xl.leading-8.capsize::before, .font-serif .md\\:text-6xl .leading-8.capsize::before,.md\\:text-6xl .font-serif.leading-8.capsize::before,.md\\:text-6xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1133em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-6xl.capsize::before, .font-serif .md\\:leading-8.text-6xl.capsize::before, .font-serif .text-6xl .md\\:leading-8.capsize::before, .text-6xl .md\\:leading-8.font-serif.capsize::before, .text-6xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1133em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-8.capsize::after, .font-serif .md\\:text-6xl.leading-8.capsize::after, .font-serif .md\\:text-6xl .leading-8.capsize::after,.md\\:text-6xl .font-serif.leading-8.capsize::after,.md\\:text-6xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: 0.1333em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-6xl.capsize::after, .font-serif .md\\:leading-8.text-6xl.capsize::after, .font-serif .text-6xl .md\\:leading-8.capsize::after, .text-6xl .md\\:leading-8.font-serif.capsize::after, .text-6xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.1333em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-8.capsize::after, .font-serif .md\\:text-6xl.leading-8.capsize::after, .font-serif .md\\:text-6xl .leading-8.capsize::after,.md\\:text-6xl .font-serif.leading-8.capsize::after,.md\\:text-6xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: 0.1333em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-6xl.capsize::after, .font-serif .md\\:leading-8.text-6xl.capsize::after, .font-serif .text-6xl .md\\:leading-8.capsize::after, .text-6xl .md\\:leading-8.font-serif.capsize::after, .text-6xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.1333em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-8.capsize::after, .font-serif .md\\:text-6xl.leading-8.capsize::after, .font-serif .md\\:text-6xl .leading-8.capsize::after,.md\\:text-6xl .font-serif.leading-8.capsize::after,.md\\:text-6xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: 0.1333em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-6xl.capsize::after, .font-serif .md\\:leading-8.text-6xl.capsize::after, .font-serif .text-6xl .md\\:leading-8.capsize::after, .text-6xl .md\\:leading-8.font-serif.capsize::after, .text-6xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.1333em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-8.capsize::after, .font-serif .md\\:text-6xl.leading-8.capsize::after, .font-serif .md\\:text-6xl .leading-8.capsize::after,.md\\:text-6xl .font-serif.leading-8.capsize::after,.md\\:text-6xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: 0.1333em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-6xl.capsize::after, .font-serif .md\\:leading-8.text-6xl.capsize::after, .font-serif .text-6xl .md\\:leading-8.capsize::after, .text-6xl .md\\:leading-8.font-serif.capsize::after, .text-6xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.1333em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-8.capsize::after, .font-serif .md\\:text-6xl.leading-8.capsize::after, .font-serif .md\\:text-6xl .leading-8.capsize::after,.md\\:text-6xl .font-serif.leading-8.capsize::after,.md\\:text-6xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: 0.1333em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-6xl.capsize::after, .font-serif .md\\:leading-8.text-6xl.capsize::after, .font-serif .text-6xl .md\\:leading-8.capsize::after, .text-6xl .md\\:leading-8.font-serif.capsize::after, .text-6xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.1333em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-9.capsize::before, .font-serif .md\\:text-6xl.leading-9.capsize::before, .font-serif .md\\:text-6xl .leading-9.capsize::before,.md\\:text-6xl .font-serif.leading-9.capsize::before,.md\\:text-6xl .font-serif .leading-9.capsize::before {
    content: '';
    margin-bottom: 0.08em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-9.capsize::after, .font-serif .md\\:text-6xl.leading-9.capsize::after, .font-serif .md\\:text-6xl .leading-9.capsize::after,.md\\:text-6xl .font-serif.leading-9.capsize::after,.md\\:text-6xl .font-serif .leading-9.capsize::after {
    content: '';
    margin-top: 0.1em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-10.capsize::before, .font-serif .md\\:text-6xl.leading-10.capsize::before, .font-serif .md\\:text-6xl .leading-10.capsize::before,.md\\:text-6xl .font-serif.leading-10.capsize::before,.md\\:text-6xl .font-serif .leading-10.capsize::before {
    content: '';
    margin-bottom: 0.0467em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-10.capsize::after, .font-serif .md\\:text-6xl.leading-10.capsize::after, .font-serif .md\\:text-6xl .leading-10.capsize::after,.md\\:text-6xl .font-serif.leading-10.capsize::after,.md\\:text-6xl .font-serif .leading-10.capsize::after {
    content: '';
    margin-top: 0.0667em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-none.capsize::before, .font-serif .md\\:text-6xl.leading-none.capsize::before, .font-serif .md\\:text-6xl .leading-none.capsize::before,.md\\:text-6xl .font-serif.leading-none.capsize::before,.md\\:text-6xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-6xl.capsize::before, .font-serif .md\\:leading-none.text-6xl.capsize::before, .font-serif .text-6xl .md\\:leading-none.capsize::before, .text-6xl .md\\:leading-none.font-serif.capsize::before, .text-6xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-none.capsize::before, .font-serif .md\\:text-6xl.leading-none.capsize::before, .font-serif .md\\:text-6xl .leading-none.capsize::before,.md\\:text-6xl .font-serif.leading-none.capsize::before,.md\\:text-6xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-6xl.capsize::before, .font-serif .md\\:leading-none.text-6xl.capsize::before, .font-serif .text-6xl .md\\:leading-none.capsize::before, .text-6xl .md\\:leading-none.font-serif.capsize::before, .text-6xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-none.capsize::before, .font-serif .md\\:text-6xl.leading-none.capsize::before, .font-serif .md\\:text-6xl .leading-none.capsize::before,.md\\:text-6xl .font-serif.leading-none.capsize::before,.md\\:text-6xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-6xl.capsize::before, .font-serif .md\\:leading-none.text-6xl.capsize::before, .font-serif .text-6xl .md\\:leading-none.capsize::before, .text-6xl .md\\:leading-none.font-serif.capsize::before, .text-6xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-none.capsize::before, .font-serif .md\\:text-6xl.leading-none.capsize::before, .font-serif .md\\:text-6xl .leading-none.capsize::before,.md\\:text-6xl .font-serif.leading-none.capsize::before,.md\\:text-6xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-6xl.capsize::before, .font-serif .md\\:leading-none.text-6xl.capsize::before, .font-serif .text-6xl .md\\:leading-none.capsize::before, .text-6xl .md\\:leading-none.font-serif.capsize::before, .text-6xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-none.capsize::before, .font-serif .md\\:text-6xl.leading-none.capsize::before, .font-serif .md\\:text-6xl .leading-none.capsize::before,.md\\:text-6xl .font-serif.leading-none.capsize::before,.md\\:text-6xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-6xl.capsize::before, .font-serif .md\\:leading-none.text-6xl.capsize::before, .font-serif .text-6xl .md\\:leading-none.capsize::before, .text-6xl .md\\:leading-none.font-serif.capsize::before, .text-6xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-none.capsize::after, .font-serif .md\\:text-6xl.leading-none.capsize::after, .font-serif .md\\:text-6xl .leading-none.capsize::after,.md\\:text-6xl .font-serif.leading-none.capsize::after,.md\\:text-6xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-6xl.capsize::after, .font-serif .md\\:leading-none.text-6xl.capsize::after, .font-serif .text-6xl .md\\:leading-none.capsize::after, .text-6xl .md\\:leading-none.font-serif.capsize::after, .text-6xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-none.capsize::after, .font-serif .md\\:text-6xl.leading-none.capsize::after, .font-serif .md\\:text-6xl .leading-none.capsize::after,.md\\:text-6xl .font-serif.leading-none.capsize::after,.md\\:text-6xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-6xl.capsize::after, .font-serif .md\\:leading-none.text-6xl.capsize::after, .font-serif .text-6xl .md\\:leading-none.capsize::after, .text-6xl .md\\:leading-none.font-serif.capsize::after, .text-6xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-none.capsize::after, .font-serif .md\\:text-6xl.leading-none.capsize::after, .font-serif .md\\:text-6xl .leading-none.capsize::after,.md\\:text-6xl .font-serif.leading-none.capsize::after,.md\\:text-6xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-6xl.capsize::after, .font-serif .md\\:leading-none.text-6xl.capsize::after, .font-serif .text-6xl .md\\:leading-none.capsize::after, .text-6xl .md\\:leading-none.font-serif.capsize::after, .text-6xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-none.capsize::after, .font-serif .md\\:text-6xl.leading-none.capsize::after, .font-serif .md\\:text-6xl .leading-none.capsize::after,.md\\:text-6xl .font-serif.leading-none.capsize::after,.md\\:text-6xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-6xl.capsize::after, .font-serif .md\\:leading-none.text-6xl.capsize::after, .font-serif .text-6xl .md\\:leading-none.capsize::after, .text-6xl .md\\:leading-none.font-serif.capsize::after, .text-6xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-none.capsize::after, .font-serif .md\\:text-6xl.leading-none.capsize::after, .font-serif .md\\:text-6xl .leading-none.capsize::after,.md\\:text-6xl .font-serif.leading-none.capsize::after,.md\\:text-6xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-6xl.capsize::after, .font-serif .md\\:leading-none.text-6xl.capsize::after, .font-serif .text-6xl .md\\:leading-none.capsize::after, .text-6xl .md\\:leading-none.font-serif.capsize::after, .text-6xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-6xl.leading-tight.capsize::before, .font-serif .md\\:text-6xl .leading-tight.capsize::before,.md\\:text-6xl .font-serif.leading-tight.capsize::before,.md\\:text-6xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-6xl.capsize::before, .font-serif .md\\:leading-tight.text-6xl.capsize::before, .font-serif .text-6xl .md\\:leading-tight.capsize::before, .text-6xl .md\\:leading-tight.font-serif.capsize::before, .text-6xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-6xl.leading-tight.capsize::before, .font-serif .md\\:text-6xl .leading-tight.capsize::before,.md\\:text-6xl .font-serif.leading-tight.capsize::before,.md\\:text-6xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-6xl.capsize::before, .font-serif .md\\:leading-tight.text-6xl.capsize::before, .font-serif .text-6xl .md\\:leading-tight.capsize::before, .text-6xl .md\\:leading-tight.font-serif.capsize::before, .text-6xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-6xl.leading-tight.capsize::before, .font-serif .md\\:text-6xl .leading-tight.capsize::before,.md\\:text-6xl .font-serif.leading-tight.capsize::before,.md\\:text-6xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-6xl.capsize::before, .font-serif .md\\:leading-tight.text-6xl.capsize::before, .font-serif .text-6xl .md\\:leading-tight.capsize::before, .text-6xl .md\\:leading-tight.font-serif.capsize::before, .text-6xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-6xl.leading-tight.capsize::before, .font-serif .md\\:text-6xl .leading-tight.capsize::before,.md\\:text-6xl .font-serif.leading-tight.capsize::before,.md\\:text-6xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-6xl.capsize::before, .font-serif .md\\:leading-tight.text-6xl.capsize::before, .font-serif .text-6xl .md\\:leading-tight.capsize::before, .text-6xl .md\\:leading-tight.font-serif.capsize::before, .text-6xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-6xl.leading-tight.capsize::before, .font-serif .md\\:text-6xl .leading-tight.capsize::before,.md\\:text-6xl .font-serif.leading-tight.capsize::before,.md\\:text-6xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-6xl.capsize::before, .font-serif .md\\:leading-tight.text-6xl.capsize::before, .font-serif .text-6xl .md\\:leading-tight.capsize::before, .text-6xl .md\\:leading-tight.font-serif.capsize::before, .text-6xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-6xl.leading-tight.capsize::after, .font-serif .md\\:text-6xl .leading-tight.capsize::after,.md\\:text-6xl .font-serif.leading-tight.capsize::after,.md\\:text-6xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-6xl.capsize::after, .font-serif .md\\:leading-tight.text-6xl.capsize::after, .font-serif .text-6xl .md\\:leading-tight.capsize::after, .text-6xl .md\\:leading-tight.font-serif.capsize::after, .text-6xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-6xl.leading-tight.capsize::after, .font-serif .md\\:text-6xl .leading-tight.capsize::after,.md\\:text-6xl .font-serif.leading-tight.capsize::after,.md\\:text-6xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-6xl.capsize::after, .font-serif .md\\:leading-tight.text-6xl.capsize::after, .font-serif .text-6xl .md\\:leading-tight.capsize::after, .text-6xl .md\\:leading-tight.font-serif.capsize::after, .text-6xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-6xl.leading-tight.capsize::after, .font-serif .md\\:text-6xl .leading-tight.capsize::after,.md\\:text-6xl .font-serif.leading-tight.capsize::after,.md\\:text-6xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-6xl.capsize::after, .font-serif .md\\:leading-tight.text-6xl.capsize::after, .font-serif .text-6xl .md\\:leading-tight.capsize::after, .text-6xl .md\\:leading-tight.font-serif.capsize::after, .text-6xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-6xl.leading-tight.capsize::after, .font-serif .md\\:text-6xl .leading-tight.capsize::after,.md\\:text-6xl .font-serif.leading-tight.capsize::after,.md\\:text-6xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-6xl.capsize::after, .font-serif .md\\:leading-tight.text-6xl.capsize::after, .font-serif .text-6xl .md\\:leading-tight.capsize::after, .text-6xl .md\\:leading-tight.font-serif.capsize::after, .text-6xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-6xl.leading-tight.capsize::after, .font-serif .md\\:text-6xl .leading-tight.capsize::after,.md\\:text-6xl .font-serif.leading-tight.capsize::after,.md\\:text-6xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-6xl.capsize::after, .font-serif .md\\:leading-tight.text-6xl.capsize::after, .font-serif .text-6xl .md\\:leading-tight.capsize::after, .text-6xl .md\\:leading-tight.font-serif.capsize::after, .text-6xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-snug.capsize::before, .font-serif .md\\:text-6xl.leading-snug.capsize::before, .font-serif .md\\:text-6xl .leading-snug.capsize::before,.md\\:text-6xl .font-serif.leading-snug.capsize::before,.md\\:text-6xl .font-serif .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3075em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-snug.capsize::after, .font-serif .md\\:text-6xl.leading-snug.capsize::after, .font-serif .md\\:text-6xl .leading-snug.capsize::after,.md\\:text-6xl .font-serif.leading-snug.capsize::after,.md\\:text-6xl .font-serif .leading-snug.capsize::after {
    content: '';
    margin-top: -0.2875em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-normal.capsize::before, .font-serif .md\\:text-6xl.leading-normal.capsize::before, .font-serif .md\\:text-6xl .leading-normal.capsize::before,.md\\:text-6xl .font-serif.leading-normal.capsize::before,.md\\:text-6xl .font-serif .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-normal.capsize::after, .font-serif .md\\:text-6xl.leading-normal.capsize::after, .font-serif .md\\:text-6xl .leading-normal.capsize::after,.md\\:text-6xl .font-serif.leading-normal.capsize::after,.md\\:text-6xl .font-serif .leading-normal.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-relaxed.capsize::before, .font-serif .md\\:text-6xl.leading-relaxed.capsize::before, .font-serif .md\\:text-6xl .leading-relaxed.capsize::before,.md\\:text-6xl .font-serif.leading-relaxed.capsize::before,.md\\:text-6xl .font-serif .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4325em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-relaxed.capsize::after, .font-serif .md\\:text-6xl.leading-relaxed.capsize::after, .font-serif .md\\:text-6xl .leading-relaxed.capsize::after,.md\\:text-6xl .font-serif.leading-relaxed.capsize::after,.md\\:text-6xl .font-serif .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4125em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-loose.capsize::before, .font-serif .md\\:text-6xl.leading-loose.capsize::before, .font-serif .md\\:text-6xl .leading-loose.capsize::before,.md\\:text-6xl .font-serif.leading-loose.capsize::before,.md\\:text-6xl .font-serif .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .md\\:text-6xl.font-serif.leading-loose.capsize::after, .font-serif .md\\:text-6xl.leading-loose.capsize::after, .font-serif .md\\:text-6xl .leading-loose.capsize::after,.md\\:text-6xl .font-serif.leading-loose.capsize::after,.md\\:text-6xl .font-serif .leading-loose.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-3.capsize::before, .font-serif .md\\:text-7xl.leading-3.capsize::before, .font-serif .md\\:text-7xl .leading-3.capsize::before,.md\\:text-7xl .font-serif.leading-3.capsize::before,.md\\:text-7xl .font-serif .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.2967em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-3.capsize::after, .font-serif .md\\:text-7xl.leading-3.capsize::after, .font-serif .md\\:text-7xl .leading-3.capsize::after,.md\\:text-7xl .font-serif.leading-3.capsize::after,.md\\:text-7xl .font-serif .leading-3.capsize::after {
    content: '';
    margin-top: 0.3167em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-4.capsize::before, .font-serif .md\\:text-7xl.leading-4.capsize::before, .font-serif .md\\:text-7xl .leading-4.capsize::before,.md\\:text-7xl .font-serif.leading-4.capsize::before,.md\\:text-7xl .font-serif .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.2689em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-4.capsize::after, .font-serif .md\\:text-7xl.leading-4.capsize::after, .font-serif .md\\:text-7xl .leading-4.capsize::after,.md\\:text-7xl .font-serif.leading-4.capsize::after,.md\\:text-7xl .font-serif .leading-4.capsize::after {
    content: '';
    margin-top: 0.2889em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-5.capsize::before, .font-serif .md\\:text-7xl.leading-5.capsize::before, .font-serif .md\\:text-7xl .leading-5.capsize::before,.md\\:text-7xl .font-serif.leading-5.capsize::before,.md\\:text-7xl .font-serif .leading-5.capsize::before {
    content: '';
    margin-bottom: 0.2411em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-5.capsize::after, .font-serif .md\\:text-7xl.leading-5.capsize::after, .font-serif .md\\:text-7xl .leading-5.capsize::after,.md\\:text-7xl .font-serif.leading-5.capsize::after,.md\\:text-7xl .font-serif .leading-5.capsize::after {
    content: '';
    margin-top: 0.2611em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-6.capsize::before, .font-serif .md\\:text-7xl.leading-6.capsize::before, .font-serif .md\\:text-7xl .leading-6.capsize::before,.md\\:text-7xl .font-serif.leading-6.capsize::before,.md\\:text-7xl .font-serif .leading-6.capsize::before {
    content: '';
    margin-bottom: 0.2133em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-6.capsize::after, .font-serif .md\\:text-7xl.leading-6.capsize::after, .font-serif .md\\:text-7xl .leading-6.capsize::after,.md\\:text-7xl .font-serif.leading-6.capsize::after,.md\\:text-7xl .font-serif .leading-6.capsize::after {
    content: '';
    margin-top: 0.2333em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-7.capsize::before, .font-serif .md\\:text-7xl.leading-7.capsize::before, .font-serif .md\\:text-7xl .leading-7.capsize::before,.md\\:text-7xl .font-serif.leading-7.capsize::before,.md\\:text-7xl .font-serif .leading-7.capsize::before {
    content: '';
    margin-bottom: 0.1856em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-7.capsize::after, .font-serif .md\\:text-7xl.leading-7.capsize::after, .font-serif .md\\:text-7xl .leading-7.capsize::after,.md\\:text-7xl .font-serif.leading-7.capsize::after,.md\\:text-7xl .font-serif .leading-7.capsize::after {
    content: '';
    margin-top: 0.2056em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-8.capsize::before, .font-serif .md\\:text-7xl.leading-8.capsize::before, .font-serif .md\\:text-7xl .leading-8.capsize::before,.md\\:text-7xl .font-serif.leading-8.capsize::before,.md\\:text-7xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1578em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-7xl.capsize::before, .font-serif .md\\:leading-8.text-7xl.capsize::before, .font-serif .text-7xl .md\\:leading-8.capsize::before, .text-7xl .md\\:leading-8.font-serif.capsize::before, .text-7xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1578em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-8.capsize::before, .font-serif .md\\:text-7xl.leading-8.capsize::before, .font-serif .md\\:text-7xl .leading-8.capsize::before,.md\\:text-7xl .font-serif.leading-8.capsize::before,.md\\:text-7xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1578em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-7xl.capsize::before, .font-serif .md\\:leading-8.text-7xl.capsize::before, .font-serif .text-7xl .md\\:leading-8.capsize::before, .text-7xl .md\\:leading-8.font-serif.capsize::before, .text-7xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1578em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-8.capsize::before, .font-serif .md\\:text-7xl.leading-8.capsize::before, .font-serif .md\\:text-7xl .leading-8.capsize::before,.md\\:text-7xl .font-serif.leading-8.capsize::before,.md\\:text-7xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1578em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-7xl.capsize::before, .font-serif .md\\:leading-8.text-7xl.capsize::before, .font-serif .text-7xl .md\\:leading-8.capsize::before, .text-7xl .md\\:leading-8.font-serif.capsize::before, .text-7xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1578em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-8.capsize::before, .font-serif .md\\:text-7xl.leading-8.capsize::before, .font-serif .md\\:text-7xl .leading-8.capsize::before,.md\\:text-7xl .font-serif.leading-8.capsize::before,.md\\:text-7xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1578em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-7xl.capsize::before, .font-serif .md\\:leading-8.text-7xl.capsize::before, .font-serif .text-7xl .md\\:leading-8.capsize::before, .text-7xl .md\\:leading-8.font-serif.capsize::before, .text-7xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1578em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-8.capsize::before, .font-serif .md\\:text-7xl.leading-8.capsize::before, .font-serif .md\\:text-7xl .leading-8.capsize::before,.md\\:text-7xl .font-serif.leading-8.capsize::before,.md\\:text-7xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1578em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-7xl.capsize::before, .font-serif .md\\:leading-8.text-7xl.capsize::before, .font-serif .text-7xl .md\\:leading-8.capsize::before, .text-7xl .md\\:leading-8.font-serif.capsize::before, .text-7xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1578em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-8.capsize::after, .font-serif .md\\:text-7xl.leading-8.capsize::after, .font-serif .md\\:text-7xl .leading-8.capsize::after,.md\\:text-7xl .font-serif.leading-8.capsize::after,.md\\:text-7xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: 0.1778em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-7xl.capsize::after, .font-serif .md\\:leading-8.text-7xl.capsize::after, .font-serif .text-7xl .md\\:leading-8.capsize::after, .text-7xl .md\\:leading-8.font-serif.capsize::after, .text-7xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.1778em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-8.capsize::after, .font-serif .md\\:text-7xl.leading-8.capsize::after, .font-serif .md\\:text-7xl .leading-8.capsize::after,.md\\:text-7xl .font-serif.leading-8.capsize::after,.md\\:text-7xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: 0.1778em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-7xl.capsize::after, .font-serif .md\\:leading-8.text-7xl.capsize::after, .font-serif .text-7xl .md\\:leading-8.capsize::after, .text-7xl .md\\:leading-8.font-serif.capsize::after, .text-7xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.1778em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-8.capsize::after, .font-serif .md\\:text-7xl.leading-8.capsize::after, .font-serif .md\\:text-7xl .leading-8.capsize::after,.md\\:text-7xl .font-serif.leading-8.capsize::after,.md\\:text-7xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: 0.1778em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-7xl.capsize::after, .font-serif .md\\:leading-8.text-7xl.capsize::after, .font-serif .text-7xl .md\\:leading-8.capsize::after, .text-7xl .md\\:leading-8.font-serif.capsize::after, .text-7xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.1778em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-8.capsize::after, .font-serif .md\\:text-7xl.leading-8.capsize::after, .font-serif .md\\:text-7xl .leading-8.capsize::after,.md\\:text-7xl .font-serif.leading-8.capsize::after,.md\\:text-7xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: 0.1778em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-7xl.capsize::after, .font-serif .md\\:leading-8.text-7xl.capsize::after, .font-serif .text-7xl .md\\:leading-8.capsize::after, .text-7xl .md\\:leading-8.font-serif.capsize::after, .text-7xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.1778em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-8.capsize::after, .font-serif .md\\:text-7xl.leading-8.capsize::after, .font-serif .md\\:text-7xl .leading-8.capsize::after,.md\\:text-7xl .font-serif.leading-8.capsize::after,.md\\:text-7xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: 0.1778em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-7xl.capsize::after, .font-serif .md\\:leading-8.text-7xl.capsize::after, .font-serif .text-7xl .md\\:leading-8.capsize::after, .text-7xl .md\\:leading-8.font-serif.capsize::after, .text-7xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.1778em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-9.capsize::before, .font-serif .md\\:text-7xl.leading-9.capsize::before, .font-serif .md\\:text-7xl .leading-9.capsize::before,.md\\:text-7xl .font-serif.leading-9.capsize::before,.md\\:text-7xl .font-serif .leading-9.capsize::before {
    content: '';
    margin-bottom: 0.13em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-9.capsize::after, .font-serif .md\\:text-7xl.leading-9.capsize::after, .font-serif .md\\:text-7xl .leading-9.capsize::after,.md\\:text-7xl .font-serif.leading-9.capsize::after,.md\\:text-7xl .font-serif .leading-9.capsize::after {
    content: '';
    margin-top: 0.15em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-10.capsize::before, .font-serif .md\\:text-7xl.leading-10.capsize::before, .font-serif .md\\:text-7xl .leading-10.capsize::before,.md\\:text-7xl .font-serif.leading-10.capsize::before,.md\\:text-7xl .font-serif .leading-10.capsize::before {
    content: '';
    margin-bottom: 0.1022em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-10.capsize::after, .font-serif .md\\:text-7xl.leading-10.capsize::after, .font-serif .md\\:text-7xl .leading-10.capsize::after,.md\\:text-7xl .font-serif.leading-10.capsize::after,.md\\:text-7xl .font-serif .leading-10.capsize::after {
    content: '';
    margin-top: 0.1222em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-none.capsize::before, .font-serif .md\\:text-7xl.leading-none.capsize::before, .font-serif .md\\:text-7xl .leading-none.capsize::before,.md\\:text-7xl .font-serif.leading-none.capsize::before,.md\\:text-7xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-7xl.capsize::before, .font-serif .md\\:leading-none.text-7xl.capsize::before, .font-serif .text-7xl .md\\:leading-none.capsize::before, .text-7xl .md\\:leading-none.font-serif.capsize::before, .text-7xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-none.capsize::before, .font-serif .md\\:text-7xl.leading-none.capsize::before, .font-serif .md\\:text-7xl .leading-none.capsize::before,.md\\:text-7xl .font-serif.leading-none.capsize::before,.md\\:text-7xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-7xl.capsize::before, .font-serif .md\\:leading-none.text-7xl.capsize::before, .font-serif .text-7xl .md\\:leading-none.capsize::before, .text-7xl .md\\:leading-none.font-serif.capsize::before, .text-7xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-none.capsize::before, .font-serif .md\\:text-7xl.leading-none.capsize::before, .font-serif .md\\:text-7xl .leading-none.capsize::before,.md\\:text-7xl .font-serif.leading-none.capsize::before,.md\\:text-7xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-7xl.capsize::before, .font-serif .md\\:leading-none.text-7xl.capsize::before, .font-serif .text-7xl .md\\:leading-none.capsize::before, .text-7xl .md\\:leading-none.font-serif.capsize::before, .text-7xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-none.capsize::before, .font-serif .md\\:text-7xl.leading-none.capsize::before, .font-serif .md\\:text-7xl .leading-none.capsize::before,.md\\:text-7xl .font-serif.leading-none.capsize::before,.md\\:text-7xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-7xl.capsize::before, .font-serif .md\\:leading-none.text-7xl.capsize::before, .font-serif .text-7xl .md\\:leading-none.capsize::before, .text-7xl .md\\:leading-none.font-serif.capsize::before, .text-7xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-none.capsize::before, .font-serif .md\\:text-7xl.leading-none.capsize::before, .font-serif .md\\:text-7xl .leading-none.capsize::before,.md\\:text-7xl .font-serif.leading-none.capsize::before,.md\\:text-7xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-7xl.capsize::before, .font-serif .md\\:leading-none.text-7xl.capsize::before, .font-serif .text-7xl .md\\:leading-none.capsize::before, .text-7xl .md\\:leading-none.font-serif.capsize::before, .text-7xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-none.capsize::after, .font-serif .md\\:text-7xl.leading-none.capsize::after, .font-serif .md\\:text-7xl .leading-none.capsize::after,.md\\:text-7xl .font-serif.leading-none.capsize::after,.md\\:text-7xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-7xl.capsize::after, .font-serif .md\\:leading-none.text-7xl.capsize::after, .font-serif .text-7xl .md\\:leading-none.capsize::after, .text-7xl .md\\:leading-none.font-serif.capsize::after, .text-7xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-none.capsize::after, .font-serif .md\\:text-7xl.leading-none.capsize::after, .font-serif .md\\:text-7xl .leading-none.capsize::after,.md\\:text-7xl .font-serif.leading-none.capsize::after,.md\\:text-7xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-7xl.capsize::after, .font-serif .md\\:leading-none.text-7xl.capsize::after, .font-serif .text-7xl .md\\:leading-none.capsize::after, .text-7xl .md\\:leading-none.font-serif.capsize::after, .text-7xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-none.capsize::after, .font-serif .md\\:text-7xl.leading-none.capsize::after, .font-serif .md\\:text-7xl .leading-none.capsize::after,.md\\:text-7xl .font-serif.leading-none.capsize::after,.md\\:text-7xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-7xl.capsize::after, .font-serif .md\\:leading-none.text-7xl.capsize::after, .font-serif .text-7xl .md\\:leading-none.capsize::after, .text-7xl .md\\:leading-none.font-serif.capsize::after, .text-7xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-none.capsize::after, .font-serif .md\\:text-7xl.leading-none.capsize::after, .font-serif .md\\:text-7xl .leading-none.capsize::after,.md\\:text-7xl .font-serif.leading-none.capsize::after,.md\\:text-7xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-7xl.capsize::after, .font-serif .md\\:leading-none.text-7xl.capsize::after, .font-serif .text-7xl .md\\:leading-none.capsize::after, .text-7xl .md\\:leading-none.font-serif.capsize::after, .text-7xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-none.capsize::after, .font-serif .md\\:text-7xl.leading-none.capsize::after, .font-serif .md\\:text-7xl .leading-none.capsize::after,.md\\:text-7xl .font-serif.leading-none.capsize::after,.md\\:text-7xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-7xl.capsize::after, .font-serif .md\\:leading-none.text-7xl.capsize::after, .font-serif .text-7xl .md\\:leading-none.capsize::after, .text-7xl .md\\:leading-none.font-serif.capsize::after, .text-7xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-7xl.leading-tight.capsize::before, .font-serif .md\\:text-7xl .leading-tight.capsize::before,.md\\:text-7xl .font-serif.leading-tight.capsize::before,.md\\:text-7xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-7xl.capsize::before, .font-serif .md\\:leading-tight.text-7xl.capsize::before, .font-serif .text-7xl .md\\:leading-tight.capsize::before, .text-7xl .md\\:leading-tight.font-serif.capsize::before, .text-7xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-7xl.leading-tight.capsize::before, .font-serif .md\\:text-7xl .leading-tight.capsize::before,.md\\:text-7xl .font-serif.leading-tight.capsize::before,.md\\:text-7xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-7xl.capsize::before, .font-serif .md\\:leading-tight.text-7xl.capsize::before, .font-serif .text-7xl .md\\:leading-tight.capsize::before, .text-7xl .md\\:leading-tight.font-serif.capsize::before, .text-7xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-7xl.leading-tight.capsize::before, .font-serif .md\\:text-7xl .leading-tight.capsize::before,.md\\:text-7xl .font-serif.leading-tight.capsize::before,.md\\:text-7xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-7xl.capsize::before, .font-serif .md\\:leading-tight.text-7xl.capsize::before, .font-serif .text-7xl .md\\:leading-tight.capsize::before, .text-7xl .md\\:leading-tight.font-serif.capsize::before, .text-7xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-7xl.leading-tight.capsize::before, .font-serif .md\\:text-7xl .leading-tight.capsize::before,.md\\:text-7xl .font-serif.leading-tight.capsize::before,.md\\:text-7xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-7xl.capsize::before, .font-serif .md\\:leading-tight.text-7xl.capsize::before, .font-serif .text-7xl .md\\:leading-tight.capsize::before, .text-7xl .md\\:leading-tight.font-serif.capsize::before, .text-7xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-7xl.leading-tight.capsize::before, .font-serif .md\\:text-7xl .leading-tight.capsize::before,.md\\:text-7xl .font-serif.leading-tight.capsize::before,.md\\:text-7xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-7xl.capsize::before, .font-serif .md\\:leading-tight.text-7xl.capsize::before, .font-serif .text-7xl .md\\:leading-tight.capsize::before, .text-7xl .md\\:leading-tight.font-serif.capsize::before, .text-7xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-7xl.leading-tight.capsize::after, .font-serif .md\\:text-7xl .leading-tight.capsize::after,.md\\:text-7xl .font-serif.leading-tight.capsize::after,.md\\:text-7xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-7xl.capsize::after, .font-serif .md\\:leading-tight.text-7xl.capsize::after, .font-serif .text-7xl .md\\:leading-tight.capsize::after, .text-7xl .md\\:leading-tight.font-serif.capsize::after, .text-7xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-7xl.leading-tight.capsize::after, .font-serif .md\\:text-7xl .leading-tight.capsize::after,.md\\:text-7xl .font-serif.leading-tight.capsize::after,.md\\:text-7xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-7xl.capsize::after, .font-serif .md\\:leading-tight.text-7xl.capsize::after, .font-serif .text-7xl .md\\:leading-tight.capsize::after, .text-7xl .md\\:leading-tight.font-serif.capsize::after, .text-7xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-7xl.leading-tight.capsize::after, .font-serif .md\\:text-7xl .leading-tight.capsize::after,.md\\:text-7xl .font-serif.leading-tight.capsize::after,.md\\:text-7xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-7xl.capsize::after, .font-serif .md\\:leading-tight.text-7xl.capsize::after, .font-serif .text-7xl .md\\:leading-tight.capsize::after, .text-7xl .md\\:leading-tight.font-serif.capsize::after, .text-7xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-7xl.leading-tight.capsize::after, .font-serif .md\\:text-7xl .leading-tight.capsize::after,.md\\:text-7xl .font-serif.leading-tight.capsize::after,.md\\:text-7xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-7xl.capsize::after, .font-serif .md\\:leading-tight.text-7xl.capsize::after, .font-serif .text-7xl .md\\:leading-tight.capsize::after, .text-7xl .md\\:leading-tight.font-serif.capsize::after, .text-7xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-7xl.leading-tight.capsize::after, .font-serif .md\\:text-7xl .leading-tight.capsize::after,.md\\:text-7xl .font-serif.leading-tight.capsize::after,.md\\:text-7xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-7xl.capsize::after, .font-serif .md\\:leading-tight.text-7xl.capsize::after, .font-serif .text-7xl .md\\:leading-tight.capsize::after, .text-7xl .md\\:leading-tight.font-serif.capsize::after, .text-7xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-snug.capsize::before, .font-serif .md\\:text-7xl.leading-snug.capsize::before, .font-serif .md\\:text-7xl .leading-snug.capsize::before,.md\\:text-7xl .font-serif.leading-snug.capsize::before,.md\\:text-7xl .font-serif .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3075em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-snug.capsize::after, .font-serif .md\\:text-7xl.leading-snug.capsize::after, .font-serif .md\\:text-7xl .leading-snug.capsize::after,.md\\:text-7xl .font-serif.leading-snug.capsize::after,.md\\:text-7xl .font-serif .leading-snug.capsize::after {
    content: '';
    margin-top: -0.2875em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-normal.capsize::before, .font-serif .md\\:text-7xl.leading-normal.capsize::before, .font-serif .md\\:text-7xl .leading-normal.capsize::before,.md\\:text-7xl .font-serif.leading-normal.capsize::before,.md\\:text-7xl .font-serif .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-normal.capsize::after, .font-serif .md\\:text-7xl.leading-normal.capsize::after, .font-serif .md\\:text-7xl .leading-normal.capsize::after,.md\\:text-7xl .font-serif.leading-normal.capsize::after,.md\\:text-7xl .font-serif .leading-normal.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-relaxed.capsize::before, .font-serif .md\\:text-7xl.leading-relaxed.capsize::before, .font-serif .md\\:text-7xl .leading-relaxed.capsize::before,.md\\:text-7xl .font-serif.leading-relaxed.capsize::before,.md\\:text-7xl .font-serif .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4325em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-relaxed.capsize::after, .font-serif .md\\:text-7xl.leading-relaxed.capsize::after, .font-serif .md\\:text-7xl .leading-relaxed.capsize::after,.md\\:text-7xl .font-serif.leading-relaxed.capsize::after,.md\\:text-7xl .font-serif .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4125em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-loose.capsize::before, .font-serif .md\\:text-7xl.leading-loose.capsize::before, .font-serif .md\\:text-7xl .leading-loose.capsize::before,.md\\:text-7xl .font-serif.leading-loose.capsize::before,.md\\:text-7xl .font-serif .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .md\\:text-7xl.font-serif.leading-loose.capsize::after, .font-serif .md\\:text-7xl.leading-loose.capsize::after, .font-serif .md\\:text-7xl .leading-loose.capsize::after,.md\\:text-7xl .font-serif.leading-loose.capsize::after,.md\\:text-7xl .font-serif .leading-loose.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-8xl.capsize::before, .font-serif .md\\:leading-8.text-8xl.capsize::before, .font-serif .text-8xl .md\\:leading-8.capsize::before, .text-8xl .md\\:leading-8.font-serif.capsize::before, .text-8xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.2133em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-8xl.capsize::after, .font-serif .md\\:leading-8.text-8xl.capsize::after, .font-serif .text-8xl .md\\:leading-8.capsize::after, .text-8xl .md\\:leading-8.font-serif.capsize::after, .text-8xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.2333em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-8xl.capsize::before, .font-serif .md\\:leading-none.text-8xl.capsize::before, .font-serif .text-8xl .md\\:leading-none.capsize::before, .text-8xl .md\\:leading-none.font-serif.capsize::before, .text-8xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-8xl.capsize::after, .font-serif .md\\:leading-none.text-8xl.capsize::after, .font-serif .text-8xl .md\\:leading-none.capsize::after, .text-8xl .md\\:leading-none.font-serif.capsize::after, .text-8xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-8xl.capsize::before, .font-serif .md\\:leading-tight.text-8xl.capsize::before, .font-serif .text-8xl .md\\:leading-tight.capsize::before, .text-8xl .md\\:leading-tight.font-serif.capsize::before, .text-8xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-8xl.capsize::after, .font-serif .md\\:leading-tight.text-8xl.capsize::after, .font-serif .text-8xl .md\\:leading-tight.capsize::after, .text-8xl .md\\:leading-tight.font-serif.capsize::after, .text-8xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-9xl.capsize::before, .font-serif .md\\:leading-8.text-9xl.capsize::before, .font-serif .text-9xl .md\\:leading-8.capsize::before, .text-9xl .md\\:leading-8.font-serif.capsize::before, .text-9xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: 0.255em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-9xl.capsize::after, .font-serif .md\\:leading-8.text-9xl.capsize::after, .font-serif .text-9xl .md\\:leading-8.capsize::after, .text-9xl .md\\:leading-8.font-serif.capsize::after, .text-9xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: 0.275em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-9xl.capsize::before, .font-serif .md\\:leading-none.text-9xl.capsize::before, .font-serif .text-9xl .md\\:leading-none.capsize::before, .text-9xl .md\\:leading-none.font-serif.capsize::before, .text-9xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-9xl.capsize::after, .font-serif .md\\:leading-none.text-9xl.capsize::after, .font-serif .text-9xl .md\\:leading-none.capsize::after, .text-9xl .md\\:leading-none.font-serif.capsize::after, .text-9xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-9xl.capsize::before, .font-serif .md\\:leading-tight.text-9xl.capsize::before, .font-serif .text-9xl .md\\:leading-tight.capsize::before, .text-9xl .md\\:leading-tight.font-serif.capsize::before, .text-9xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-9xl.capsize::after, .font-serif .md\\:leading-tight.text-9xl.capsize::after, .font-serif .text-9xl .md\\:leading-tight.capsize::after, .text-9xl .md\\:leading-tight.font-serif.capsize::after, .text-9xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-3.capsize::before, .font-serif .md\\:text-1xl.leading-3.capsize::before, .font-serif .md\\:text-1xl .leading-3.capsize::before,.md\\:text-1xl .font-serif.leading-3.capsize::before,.md\\:text-1xl .font-serif .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.1073em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-3.capsize::after, .font-serif .md\\:text-1xl.leading-3.capsize::after, .font-serif .md\\:text-1xl .leading-3.capsize::after,.md\\:text-1xl .font-serif.leading-3.capsize::after,.md\\:text-1xl .font-serif .leading-3.capsize::after {
    content: '';
    margin-top: 0.1273em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-4.capsize::before, .font-serif .md\\:text-1xl.leading-4.capsize::before, .font-serif .md\\:text-1xl .leading-4.capsize::before,.md\\:text-1xl .font-serif.leading-4.capsize::before,.md\\:text-1xl .font-serif .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.0164em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-4.capsize::after, .font-serif .md\\:text-1xl.leading-4.capsize::after, .font-serif .md\\:text-1xl .leading-4.capsize::after,.md\\:text-1xl .font-serif.leading-4.capsize::after,.md\\:text-1xl .font-serif .leading-4.capsize::after {
    content: '';
    margin-top: 0.0364em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-5.capsize::before, .font-serif .md\\:text-1xl.leading-5.capsize::before, .font-serif .md\\:text-1xl .leading-5.capsize::before,.md\\:text-1xl .font-serif.leading-5.capsize::before,.md\\:text-1xl .font-serif .leading-5.capsize::before {
    content: '';
    margin-bottom: -0.0745em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-5.capsize::after, .font-serif .md\\:text-1xl.leading-5.capsize::after, .font-serif .md\\:text-1xl .leading-5.capsize::after,.md\\:text-1xl .font-serif.leading-5.capsize::after,.md\\:text-1xl .font-serif .leading-5.capsize::after {
    content: '';
    margin-top: -0.0545em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-6.capsize::before, .font-serif .md\\:text-1xl.leading-6.capsize::before, .font-serif .md\\:text-1xl .leading-6.capsize::before,.md\\:text-1xl .font-serif.leading-6.capsize::before,.md\\:text-1xl .font-serif .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.1655em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-6.capsize::after, .font-serif .md\\:text-1xl.leading-6.capsize::after, .font-serif .md\\:text-1xl .leading-6.capsize::after,.md\\:text-1xl .font-serif.leading-6.capsize::after,.md\\:text-1xl .font-serif .leading-6.capsize::after {
    content: '';
    margin-top: -0.1455em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-7.capsize::before, .font-serif .md\\:text-1xl.leading-7.capsize::before, .font-serif .md\\:text-1xl .leading-7.capsize::before,.md\\:text-1xl .font-serif.leading-7.capsize::before,.md\\:text-1xl .font-serif .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.2564em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-7.capsize::after, .font-serif .md\\:text-1xl.leading-7.capsize::after, .font-serif .md\\:text-1xl .leading-7.capsize::after,.md\\:text-1xl .font-serif.leading-7.capsize::after,.md\\:text-1xl .font-serif .leading-7.capsize::after {
    content: '';
    margin-top: -0.2364em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-8.capsize::before, .font-serif .md\\:text-1xl.leading-8.capsize::before, .font-serif .md\\:text-1xl .leading-8.capsize::before,.md\\:text-1xl .font-serif.leading-8.capsize::before,.md\\:text-1xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.3473em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-1xl.capsize::before, .font-serif .md\\:leading-8.text-1xl.capsize::before, .font-serif .text-1xl .md\\:leading-8.capsize::before, .text-1xl .md\\:leading-8.font-serif.capsize::before, .text-1xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.3473em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-8.capsize::before, .font-serif .md\\:text-1xl.leading-8.capsize::before, .font-serif .md\\:text-1xl .leading-8.capsize::before,.md\\:text-1xl .font-serif.leading-8.capsize::before,.md\\:text-1xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.3473em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-1xl.capsize::before, .font-serif .md\\:leading-8.text-1xl.capsize::before, .font-serif .text-1xl .md\\:leading-8.capsize::before, .text-1xl .md\\:leading-8.font-serif.capsize::before, .text-1xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.3473em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-8.capsize::before, .font-serif .md\\:text-1xl.leading-8.capsize::before, .font-serif .md\\:text-1xl .leading-8.capsize::before,.md\\:text-1xl .font-serif.leading-8.capsize::before,.md\\:text-1xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.3473em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-1xl.capsize::before, .font-serif .md\\:leading-8.text-1xl.capsize::before, .font-serif .text-1xl .md\\:leading-8.capsize::before, .text-1xl .md\\:leading-8.font-serif.capsize::before, .text-1xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.3473em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-8.capsize::before, .font-serif .md\\:text-1xl.leading-8.capsize::before, .font-serif .md\\:text-1xl .leading-8.capsize::before,.md\\:text-1xl .font-serif.leading-8.capsize::before,.md\\:text-1xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.3473em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-1xl.capsize::before, .font-serif .md\\:leading-8.text-1xl.capsize::before, .font-serif .text-1xl .md\\:leading-8.capsize::before, .text-1xl .md\\:leading-8.font-serif.capsize::before, .text-1xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.3473em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-8.capsize::before, .font-serif .md\\:text-1xl.leading-8.capsize::before, .font-serif .md\\:text-1xl .leading-8.capsize::before,.md\\:text-1xl .font-serif.leading-8.capsize::before,.md\\:text-1xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.3473em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-1xl.capsize::before, .font-serif .md\\:leading-8.text-1xl.capsize::before, .font-serif .text-1xl .md\\:leading-8.capsize::before, .text-1xl .md\\:leading-8.font-serif.capsize::before, .text-1xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.3473em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-8.capsize::after, .font-serif .md\\:text-1xl.leading-8.capsize::after, .font-serif .md\\:text-1xl .leading-8.capsize::after,.md\\:text-1xl .font-serif.leading-8.capsize::after,.md\\:text-1xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.3273em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-1xl.capsize::after, .font-serif .md\\:leading-8.text-1xl.capsize::after, .font-serif .text-1xl .md\\:leading-8.capsize::after, .text-1xl .md\\:leading-8.font-serif.capsize::after, .text-1xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.3273em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-8.capsize::after, .font-serif .md\\:text-1xl.leading-8.capsize::after, .font-serif .md\\:text-1xl .leading-8.capsize::after,.md\\:text-1xl .font-serif.leading-8.capsize::after,.md\\:text-1xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.3273em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-1xl.capsize::after, .font-serif .md\\:leading-8.text-1xl.capsize::after, .font-serif .text-1xl .md\\:leading-8.capsize::after, .text-1xl .md\\:leading-8.font-serif.capsize::after, .text-1xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.3273em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-8.capsize::after, .font-serif .md\\:text-1xl.leading-8.capsize::after, .font-serif .md\\:text-1xl .leading-8.capsize::after,.md\\:text-1xl .font-serif.leading-8.capsize::after,.md\\:text-1xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.3273em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-1xl.capsize::after, .font-serif .md\\:leading-8.text-1xl.capsize::after, .font-serif .text-1xl .md\\:leading-8.capsize::after, .text-1xl .md\\:leading-8.font-serif.capsize::after, .text-1xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.3273em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-8.capsize::after, .font-serif .md\\:text-1xl.leading-8.capsize::after, .font-serif .md\\:text-1xl .leading-8.capsize::after,.md\\:text-1xl .font-serif.leading-8.capsize::after,.md\\:text-1xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.3273em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-1xl.capsize::after, .font-serif .md\\:leading-8.text-1xl.capsize::after, .font-serif .text-1xl .md\\:leading-8.capsize::after, .text-1xl .md\\:leading-8.font-serif.capsize::after, .text-1xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.3273em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-8.capsize::after, .font-serif .md\\:text-1xl.leading-8.capsize::after, .font-serif .md\\:text-1xl .leading-8.capsize::after,.md\\:text-1xl .font-serif.leading-8.capsize::after,.md\\:text-1xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.3273em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-1xl.capsize::after, .font-serif .md\\:leading-8.text-1xl.capsize::after, .font-serif .text-1xl .md\\:leading-8.capsize::after, .text-1xl .md\\:leading-8.font-serif.capsize::after, .text-1xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.3273em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-9.capsize::before, .font-serif .md\\:text-1xl.leading-9.capsize::before, .font-serif .md\\:text-1xl .leading-9.capsize::before,.md\\:text-1xl .font-serif.leading-9.capsize::before,.md\\:text-1xl .font-serif .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.4382em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-9.capsize::after, .font-serif .md\\:text-1xl.leading-9.capsize::after, .font-serif .md\\:text-1xl .leading-9.capsize::after,.md\\:text-1xl .font-serif.leading-9.capsize::after,.md\\:text-1xl .font-serif .leading-9.capsize::after {
    content: '';
    margin-top: -0.4182em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-10.capsize::before, .font-serif .md\\:text-1xl.leading-10.capsize::before, .font-serif .md\\:text-1xl .leading-10.capsize::before,.md\\:text-1xl .font-serif.leading-10.capsize::before,.md\\:text-1xl .font-serif .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.5291em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-10.capsize::after, .font-serif .md\\:text-1xl.leading-10.capsize::after, .font-serif .md\\:text-1xl .leading-10.capsize::after,.md\\:text-1xl .font-serif.leading-10.capsize::after,.md\\:text-1xl .font-serif .leading-10.capsize::after {
    content: '';
    margin-top: -0.5091em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-none.capsize::before, .font-serif .md\\:text-1xl.leading-none.capsize::before, .font-serif .md\\:text-1xl .leading-none.capsize::before,.md\\:text-1xl .font-serif.leading-none.capsize::before,.md\\:text-1xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-1xl.capsize::before, .font-serif .md\\:leading-none.text-1xl.capsize::before, .font-serif .text-1xl .md\\:leading-none.capsize::before, .text-1xl .md\\:leading-none.font-serif.capsize::before, .text-1xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-none.capsize::before, .font-serif .md\\:text-1xl.leading-none.capsize::before, .font-serif .md\\:text-1xl .leading-none.capsize::before,.md\\:text-1xl .font-serif.leading-none.capsize::before,.md\\:text-1xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-1xl.capsize::before, .font-serif .md\\:leading-none.text-1xl.capsize::before, .font-serif .text-1xl .md\\:leading-none.capsize::before, .text-1xl .md\\:leading-none.font-serif.capsize::before, .text-1xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-none.capsize::before, .font-serif .md\\:text-1xl.leading-none.capsize::before, .font-serif .md\\:text-1xl .leading-none.capsize::before,.md\\:text-1xl .font-serif.leading-none.capsize::before,.md\\:text-1xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-1xl.capsize::before, .font-serif .md\\:leading-none.text-1xl.capsize::before, .font-serif .text-1xl .md\\:leading-none.capsize::before, .text-1xl .md\\:leading-none.font-serif.capsize::before, .text-1xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-none.capsize::before, .font-serif .md\\:text-1xl.leading-none.capsize::before, .font-serif .md\\:text-1xl .leading-none.capsize::before,.md\\:text-1xl .font-serif.leading-none.capsize::before,.md\\:text-1xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-1xl.capsize::before, .font-serif .md\\:leading-none.text-1xl.capsize::before, .font-serif .text-1xl .md\\:leading-none.capsize::before, .text-1xl .md\\:leading-none.font-serif.capsize::before, .text-1xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-none.capsize::before, .font-serif .md\\:text-1xl.leading-none.capsize::before, .font-serif .md\\:text-1xl .leading-none.capsize::before,.md\\:text-1xl .font-serif.leading-none.capsize::before,.md\\:text-1xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-1xl.capsize::before, .font-serif .md\\:leading-none.text-1xl.capsize::before, .font-serif .text-1xl .md\\:leading-none.capsize::before, .text-1xl .md\\:leading-none.font-serif.capsize::before, .text-1xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-none.capsize::after, .font-serif .md\\:text-1xl.leading-none.capsize::after, .font-serif .md\\:text-1xl .leading-none.capsize::after,.md\\:text-1xl .font-serif.leading-none.capsize::after,.md\\:text-1xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-1xl.capsize::after, .font-serif .md\\:leading-none.text-1xl.capsize::after, .font-serif .text-1xl .md\\:leading-none.capsize::after, .text-1xl .md\\:leading-none.font-serif.capsize::after, .text-1xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-none.capsize::after, .font-serif .md\\:text-1xl.leading-none.capsize::after, .font-serif .md\\:text-1xl .leading-none.capsize::after,.md\\:text-1xl .font-serif.leading-none.capsize::after,.md\\:text-1xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-1xl.capsize::after, .font-serif .md\\:leading-none.text-1xl.capsize::after, .font-serif .text-1xl .md\\:leading-none.capsize::after, .text-1xl .md\\:leading-none.font-serif.capsize::after, .text-1xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-none.capsize::after, .font-serif .md\\:text-1xl.leading-none.capsize::after, .font-serif .md\\:text-1xl .leading-none.capsize::after,.md\\:text-1xl .font-serif.leading-none.capsize::after,.md\\:text-1xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-1xl.capsize::after, .font-serif .md\\:leading-none.text-1xl.capsize::after, .font-serif .text-1xl .md\\:leading-none.capsize::after, .text-1xl .md\\:leading-none.font-serif.capsize::after, .text-1xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-none.capsize::after, .font-serif .md\\:text-1xl.leading-none.capsize::after, .font-serif .md\\:text-1xl .leading-none.capsize::after,.md\\:text-1xl .font-serif.leading-none.capsize::after,.md\\:text-1xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-1xl.capsize::after, .font-serif .md\\:leading-none.text-1xl.capsize::after, .font-serif .text-1xl .md\\:leading-none.capsize::after, .text-1xl .md\\:leading-none.font-serif.capsize::after, .text-1xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-none.capsize::after, .font-serif .md\\:text-1xl.leading-none.capsize::after, .font-serif .md\\:text-1xl .leading-none.capsize::after,.md\\:text-1xl .font-serif.leading-none.capsize::after,.md\\:text-1xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-1xl.capsize::after, .font-serif .md\\:leading-none.text-1xl.capsize::after, .font-serif .text-1xl .md\\:leading-none.capsize::after, .text-1xl .md\\:leading-none.font-serif.capsize::after, .text-1xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-1xl.leading-tight.capsize::before, .font-serif .md\\:text-1xl .leading-tight.capsize::before,.md\\:text-1xl .font-serif.leading-tight.capsize::before,.md\\:text-1xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-1xl.capsize::before, .font-serif .md\\:leading-tight.text-1xl.capsize::before, .font-serif .text-1xl .md\\:leading-tight.capsize::before, .text-1xl .md\\:leading-tight.font-serif.capsize::before, .text-1xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-1xl.leading-tight.capsize::before, .font-serif .md\\:text-1xl .leading-tight.capsize::before,.md\\:text-1xl .font-serif.leading-tight.capsize::before,.md\\:text-1xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-1xl.capsize::before, .font-serif .md\\:leading-tight.text-1xl.capsize::before, .font-serif .text-1xl .md\\:leading-tight.capsize::before, .text-1xl .md\\:leading-tight.font-serif.capsize::before, .text-1xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-1xl.leading-tight.capsize::before, .font-serif .md\\:text-1xl .leading-tight.capsize::before,.md\\:text-1xl .font-serif.leading-tight.capsize::before,.md\\:text-1xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-1xl.capsize::before, .font-serif .md\\:leading-tight.text-1xl.capsize::before, .font-serif .text-1xl .md\\:leading-tight.capsize::before, .text-1xl .md\\:leading-tight.font-serif.capsize::before, .text-1xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-1xl.leading-tight.capsize::before, .font-serif .md\\:text-1xl .leading-tight.capsize::before,.md\\:text-1xl .font-serif.leading-tight.capsize::before,.md\\:text-1xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-1xl.capsize::before, .font-serif .md\\:leading-tight.text-1xl.capsize::before, .font-serif .text-1xl .md\\:leading-tight.capsize::before, .text-1xl .md\\:leading-tight.font-serif.capsize::before, .text-1xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-tight.capsize::before, .font-serif .md\\:text-1xl.leading-tight.capsize::before, .font-serif .md\\:text-1xl .leading-tight.capsize::before,.md\\:text-1xl .font-serif.leading-tight.capsize::before,.md\\:text-1xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-1xl.capsize::before, .font-serif .md\\:leading-tight.text-1xl.capsize::before, .font-serif .text-1xl .md\\:leading-tight.capsize::before, .text-1xl .md\\:leading-tight.font-serif.capsize::before, .text-1xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-1xl.leading-tight.capsize::after, .font-serif .md\\:text-1xl .leading-tight.capsize::after,.md\\:text-1xl .font-serif.leading-tight.capsize::after,.md\\:text-1xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-1xl.capsize::after, .font-serif .md\\:leading-tight.text-1xl.capsize::after, .font-serif .text-1xl .md\\:leading-tight.capsize::after, .text-1xl .md\\:leading-tight.font-serif.capsize::after, .text-1xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-1xl.leading-tight.capsize::after, .font-serif .md\\:text-1xl .leading-tight.capsize::after,.md\\:text-1xl .font-serif.leading-tight.capsize::after,.md\\:text-1xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-1xl.capsize::after, .font-serif .md\\:leading-tight.text-1xl.capsize::after, .font-serif .text-1xl .md\\:leading-tight.capsize::after, .text-1xl .md\\:leading-tight.font-serif.capsize::after, .text-1xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-1xl.leading-tight.capsize::after, .font-serif .md\\:text-1xl .leading-tight.capsize::after,.md\\:text-1xl .font-serif.leading-tight.capsize::after,.md\\:text-1xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-1xl.capsize::after, .font-serif .md\\:leading-tight.text-1xl.capsize::after, .font-serif .text-1xl .md\\:leading-tight.capsize::after, .text-1xl .md\\:leading-tight.font-serif.capsize::after, .text-1xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-1xl.leading-tight.capsize::after, .font-serif .md\\:text-1xl .leading-tight.capsize::after,.md\\:text-1xl .font-serif.leading-tight.capsize::after,.md\\:text-1xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-1xl.capsize::after, .font-serif .md\\:leading-tight.text-1xl.capsize::after, .font-serif .text-1xl .md\\:leading-tight.capsize::after, .text-1xl .md\\:leading-tight.font-serif.capsize::after, .text-1xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-tight.capsize::after, .font-serif .md\\:text-1xl.leading-tight.capsize::after, .font-serif .md\\:text-1xl .leading-tight.capsize::after,.md\\:text-1xl .font-serif.leading-tight.capsize::after,.md\\:text-1xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-1xl.capsize::after, .font-serif .md\\:leading-tight.text-1xl.capsize::after, .font-serif .text-1xl .md\\:leading-tight.capsize::after, .text-1xl .md\\:leading-tight.font-serif.capsize::after, .text-1xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-snug.capsize::before, .font-serif .md\\:text-1xl.leading-snug.capsize::before, .font-serif .md\\:text-1xl .leading-snug.capsize::before,.md\\:text-1xl .font-serif.leading-snug.capsize::before,.md\\:text-1xl .font-serif .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3075em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-snug.capsize::after, .font-serif .md\\:text-1xl.leading-snug.capsize::after, .font-serif .md\\:text-1xl .leading-snug.capsize::after,.md\\:text-1xl .font-serif.leading-snug.capsize::after,.md\\:text-1xl .font-serif .leading-snug.capsize::after {
    content: '';
    margin-top: -0.2875em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-normal.capsize::before, .font-serif .md\\:text-1xl.leading-normal.capsize::before, .font-serif .md\\:text-1xl .leading-normal.capsize::before,.md\\:text-1xl .font-serif.leading-normal.capsize::before,.md\\:text-1xl .font-serif .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-normal.capsize::after, .font-serif .md\\:text-1xl.leading-normal.capsize::after, .font-serif .md\\:text-1xl .leading-normal.capsize::after,.md\\:text-1xl .font-serif.leading-normal.capsize::after,.md\\:text-1xl .font-serif .leading-normal.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-relaxed.capsize::before, .font-serif .md\\:text-1xl.leading-relaxed.capsize::before, .font-serif .md\\:text-1xl .leading-relaxed.capsize::before,.md\\:text-1xl .font-serif.leading-relaxed.capsize::before,.md\\:text-1xl .font-serif .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4325em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-relaxed.capsize::after, .font-serif .md\\:text-1xl.leading-relaxed.capsize::after, .font-serif .md\\:text-1xl .leading-relaxed.capsize::after,.md\\:text-1xl .font-serif.leading-relaxed.capsize::after,.md\\:text-1xl .font-serif .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4125em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-loose.capsize::before, .font-serif .md\\:text-1xl.leading-loose.capsize::before, .font-serif .md\\:text-1xl .leading-loose.capsize::before,.md\\:text-1xl .font-serif.leading-loose.capsize::before,.md\\:text-1xl .font-serif .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .md\\:text-1xl.font-serif.leading-loose.capsize::after, .font-serif .md\\:text-1xl.leading-loose.capsize::after, .font-serif .md\\:text-1xl .leading-loose.capsize::after,.md\\:text-1xl .font-serif.leading-loose.capsize::after,.md\\:text-1xl .font-serif .leading-loose.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-3.3xl.capsize::before, .font-serif .md\\:leading-8.text-3.3xl.capsize::before, .font-serif .text-3.3xl .md\\:leading-8.capsize::before, .text-3.3xl .md\\:leading-8.font-serif.capsize::before, .text-3.3xl .font-serif .md\\:leading-8.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-8.font-serif.text-3.3xl.capsize::after, .font-serif .md\\:leading-8.text-3.3xl.capsize::after, .font-serif .text-3.3xl .md\\:leading-8.capsize::after, .text-3.3xl .md\\:leading-8.font-serif.capsize::after, .text-3.3xl .font-serif .md\\:leading-8.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-3.3xl.capsize::before, .font-serif .md\\:leading-none.text-3.3xl.capsize::before, .font-serif .text-3.3xl .md\\:leading-none.capsize::before, .text-3.3xl .md\\:leading-none.font-serif.capsize::before, .text-3.3xl .font-serif .md\\:leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .md\\:leading-none.font-serif.text-3.3xl.capsize::after, .font-serif .md\\:leading-none.text-3.3xl.capsize::after, .font-serif .text-3.3xl .md\\:leading-none.capsize::after, .text-3.3xl .md\\:leading-none.font-serif.capsize::after, .text-3.3xl .font-serif .md\\:leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-3.3xl.capsize::before, .font-serif .md\\:leading-tight.text-3.3xl.capsize::before, .font-serif .text-3.3xl .md\\:leading-tight.capsize::before, .text-3.3xl .md\\:leading-tight.font-serif.capsize::before, .text-3.3xl .font-serif .md\\:leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .md\\:leading-tight.font-serif.text-3.3xl.capsize::after, .font-serif .md\\:leading-tight.text-3.3xl.capsize::after, .font-serif .text-3.3xl .md\\:leading-tight.capsize::after, .text-3.3xl .md\\:leading-tight.font-serif.capsize::after, .text-3.3xl .font-serif .md\\:leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .md\\:hover\\:border-black:hover {
    --tw-border-opacity: 1;
    border-color: rgb(33 33 33 / var(--tw-border-opacity));
  }

  .md\\:hover\\:text-black:hover {
    --tw-text-opacity: 1;
    color: rgb(33 33 33 / var(--tw-text-opacity));
  }

  .group\\/card:nth-child(odd) .group-odd\\/card\\:md\\:flex-row-reverse {
    flex-direction: row-reverse;
  }

  .group\\/card:nth-child(odd) .md\\:group-odd\\/card\\:pl-12 {
    padding-left: 3rem;
  }

  .group\\/card:nth-child(odd) .md\\:group-odd\\/card\\:pr-0 {
    padding-right: 0px;
  }

  .group\\/card:nth-child(even) .md\\:group-even\\/card\\:pl-0 {
    padding-left: 0px;
  }

  .group\\/card:nth-child(even) .md\\:group-even\\/card\\:pr-12 {
    padding-right: 3rem;
  }

  .group:hover .group-hover\\:md\\:w-3\\/6 {
    width: 50%;
  }

  .group\\/card:hover .md\\:group-hover\\/card\\:scale-105 {
    --tw-scale-x: 1.05;
    --tw-scale-y: 1.05;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
}
@media (min-width: 992px) {

  .lg\\:bottom-10 {
    bottom: 2.5rem;
  }

  .lg\\:bottom-6 {
    bottom: 1.5rem;
  }

  .lg\\:order-2 {
    order: 2;
  }

  .lg\\:order-last {
    order: 9999;
  }

  .lg\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .lg\\:m-10 {
    margin: 2.5rem;
  }

  .lg\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .lg\\:mb-0 {
    margin-bottom: 0px;
  }

  .lg\\:mb-10 {
    margin-bottom: 2.5rem;
  }

  .lg\\:mb-16 {
    margin-bottom: 4rem;
  }

  .lg\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .lg\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .lg\\:mb-8 {
    margin-bottom: 2rem;
  }

  .lg\\:mt-6 {
    margin-top: 1.5rem;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:grid {
    display: grid;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-full {
    height: 100%;
  }

  .lg\\:w-20 {
    width: 5rem;
  }

  .lg\\:w-28 {
    width: 7rem;
  }

  .lg\\:w-3\\/4 {
    width: 75%;
  }

  .lg\\:w-44 {
    width: 11rem;
  }

  .lg\\:max-w-screen-2xl {
    max-width: 1380px;
  }

  .lg\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .lg\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:gap-10 {
    gap: 2.5rem;
  }

  .lg\\:gap-12 {
    gap: 3rem;
  }

  .lg\\:gap-14 {
    gap: 3.5rem;
  }

  .lg\\:gap-20 {
    gap: 5rem;
  }

  .lg\\:gap-4 {
    gap: 1rem;
  }

  .lg\\:gap-8 {
    gap: 2rem;
  }

  .lg\\:overflow-x-visible {
    overflow-x: visible;
  }

  .lg\\:p-0 {
    padding: 0px;
  }

  .lg\\:p-10 {
    padding: 2.5rem;
  }

  .lg\\:p-\\[calc\\(1\\.5vw\\+1rem\\)\\] {
    padding: calc(1.5vw + 1rem);
  }

  .lg\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .lg\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .lg\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .lg\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .lg\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .lg\\:py-24 {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .lg\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .lg\\:pb-0 {
    padding-bottom: 0px;
  }

  .lg\\:pb-10 {
    padding-bottom: 2.5rem;
  }

  .lg\\:pl-\\[72px\\] {
    padding-left: 72px;
  }

  .lg\\:pt-10 {
    padding-top: 2.5rem;
  }

  .lg\\:pt-16 {
    padding-top: 4rem;
  }

  .lg\\:pt-20 {
    padding-top: 5rem;
  }

  .lg\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .lg\\:text-3\\.3xl {
    font-size: 2rem;
    line-height: 2.625rem;
  }

  .lg\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .lg\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .lg\\:text-7xl {
    font-size: 4.5rem;
    line-height: 1;
  }

  .lg\\:text-\\[110px\\] {
    font-size: 110px;
  }

  .lg\\:text-\\[32px\\] {
    font-size: 32px;
  }

  .lg\\:text-\\[40px\\] {
    font-size: 40px;
  }

  .lg\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .lg\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .lg\\:text-sm\\/none {
    font-size: 0.875rem;
    line-height: 1;
  }

  .lg\\:font-medium {
    font-weight: 500;
  }

  .lg\\:leading-\\[1\\.31\\] {
    line-height: 1.31;
  }

  .lg\\:opacity-0 {
    opacity: 0;
  }

  .lg\\:text-sm.font-sans.leading-3.capsize::before, .font-sans .lg\\:text-sm.leading-3.capsize::before, .font-sans .lg\\:text-sm .leading-3.capsize::before,.lg\\:text-sm .font-sans.leading-3.capsize::before,.lg\\:text-sm .font-sans .leading-3.capsize::before {
    content: '';
    margin-bottom: -0.0856em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-3.capsize::after, .font-sans .lg\\:text-sm.leading-3.capsize::after, .font-sans .lg\\:text-sm .leading-3.capsize::after,.lg\\:text-sm .font-sans.leading-3.capsize::after,.lg\\:text-sm .font-sans .leading-3.capsize::after {
    content: '';
    margin-top: -0.0416em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-4.capsize::before, .font-sans .lg\\:text-sm.leading-4.capsize::before, .font-sans .lg\\:text-sm .leading-4.capsize::before,.lg\\:text-sm .font-sans.leading-4.capsize::before,.lg\\:text-sm .font-sans .leading-4.capsize::before {
    content: '';
    margin-bottom: -0.2284em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-4.capsize::after, .font-sans .lg\\:text-sm.leading-4.capsize::after, .font-sans .lg\\:text-sm .leading-4.capsize::after,.lg\\:text-sm .font-sans.leading-4.capsize::after,.lg\\:text-sm .font-sans .leading-4.capsize::after {
    content: '';
    margin-top: -0.1844em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-5.capsize::before, .font-sans .lg\\:text-sm.leading-5.capsize::before, .font-sans .lg\\:text-sm .leading-5.capsize::before,.lg\\:text-sm .font-sans.leading-5.capsize::before,.lg\\:text-sm .font-sans .leading-5.capsize::before {
    content: '';
    margin-bottom: -0.3713em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-5.capsize::after, .font-sans .lg\\:text-sm.leading-5.capsize::after, .font-sans .lg\\:text-sm .leading-5.capsize::after,.lg\\:text-sm .font-sans.leading-5.capsize::after,.lg\\:text-sm .font-sans .leading-5.capsize::after {
    content: '';
    margin-top: -0.3273em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-6.capsize::before, .font-sans .lg\\:text-sm.leading-6.capsize::before, .font-sans .lg\\:text-sm .leading-6.capsize::before,.lg\\:text-sm .font-sans.leading-6.capsize::before,.lg\\:text-sm .font-sans .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.5141em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-6.capsize::after, .font-sans .lg\\:text-sm.leading-6.capsize::after, .font-sans .lg\\:text-sm .leading-6.capsize::after,.lg\\:text-sm .font-sans.leading-6.capsize::after,.lg\\:text-sm .font-sans .leading-6.capsize::after {
    content: '';
    margin-top: -0.4701em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-7.capsize::before, .font-sans .lg\\:text-sm.leading-7.capsize::before, .font-sans .lg\\:text-sm .leading-7.capsize::before,.lg\\:text-sm .font-sans.leading-7.capsize::before,.lg\\:text-sm .font-sans .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-7.capsize::after, .font-sans .lg\\:text-sm.leading-7.capsize::after, .font-sans .lg\\:text-sm .leading-7.capsize::after,.lg\\:text-sm .font-sans.leading-7.capsize::after,.lg\\:text-sm .font-sans .leading-7.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-8.capsize::before, .font-sans .lg\\:text-sm.leading-8.capsize::before, .font-sans .lg\\:text-sm .leading-8.capsize::before,.lg\\:text-sm .font-sans.leading-8.capsize::before,.lg\\:text-sm .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.7999em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-8.capsize::after, .font-sans .lg\\:text-sm.leading-8.capsize::after, .font-sans .lg\\:text-sm .leading-8.capsize::after,.lg\\:text-sm .font-sans.leading-8.capsize::after,.lg\\:text-sm .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.7559em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-9.capsize::before, .font-sans .lg\\:text-sm.leading-9.capsize::before, .font-sans .lg\\:text-sm .leading-9.capsize::before,.lg\\:text-sm .font-sans.leading-9.capsize::before,.lg\\:text-sm .font-sans .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.9427em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-9.capsize::after, .font-sans .lg\\:text-sm.leading-9.capsize::after, .font-sans .lg\\:text-sm .leading-9.capsize::after,.lg\\:text-sm .font-sans.leading-9.capsize::after,.lg\\:text-sm .font-sans .leading-9.capsize::after {
    content: '';
    margin-top: -0.8987em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-10.capsize::before, .font-sans .lg\\:text-sm.leading-10.capsize::before, .font-sans .lg\\:text-sm .leading-10.capsize::before,.lg\\:text-sm .font-sans.leading-10.capsize::before,.lg\\:text-sm .font-sans .leading-10.capsize::before {
    content: '';
    margin-bottom: -1.0856em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-10.capsize::after, .font-sans .lg\\:text-sm.leading-10.capsize::after, .font-sans .lg\\:text-sm .leading-10.capsize::after,.lg\\:text-sm .font-sans.leading-10.capsize::after,.lg\\:text-sm .font-sans .leading-10.capsize::after {
    content: '';
    margin-top: -1.0416em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-none.capsize::before, .font-sans .lg\\:text-sm.leading-none.capsize::before, .font-sans .lg\\:text-sm .leading-none.capsize::before,.lg\\:text-sm .font-sans.leading-none.capsize::before,.lg\\:text-sm .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-none.capsize::after, .font-sans .lg\\:text-sm.leading-none.capsize::after, .font-sans .lg\\:text-sm .leading-none.capsize::after,.lg\\:text-sm .font-sans.leading-none.capsize::after,.lg\\:text-sm .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-tight.capsize::before, .font-sans .lg\\:text-sm.leading-tight.capsize::before, .font-sans .lg\\:text-sm .leading-tight.capsize::before,.lg\\:text-sm .font-sans.leading-tight.capsize::before,.lg\\:text-sm .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-tight.capsize::after, .font-sans .lg\\:text-sm.leading-tight.capsize::after, .font-sans .lg\\:text-sm .leading-tight.capsize::after,.lg\\:text-sm .font-sans.leading-tight.capsize::after,.lg\\:text-sm .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-snug.capsize::before, .font-sans .lg\\:text-sm.leading-snug.capsize::before, .font-sans .lg\\:text-sm .leading-snug.capsize::before,.lg\\:text-sm .font-sans.leading-snug.capsize::before,.lg\\:text-sm .font-sans .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3445em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-snug.capsize::after, .font-sans .lg\\:text-sm.leading-snug.capsize::after, .font-sans .lg\\:text-sm .leading-snug.capsize::after,.lg\\:text-sm .font-sans.leading-snug.capsize::after,.lg\\:text-sm .font-sans .leading-snug.capsize::after {
    content: '';
    margin-top: -0.3005em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-normal.capsize::before, .font-sans .lg\\:text-sm.leading-normal.capsize::before, .font-sans .lg\\:text-sm .leading-normal.capsize::before,.lg\\:text-sm .font-sans.leading-normal.capsize::before,.lg\\:text-sm .font-sans .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-normal.capsize::after, .font-sans .lg\\:text-sm.leading-normal.capsize::after, .font-sans .lg\\:text-sm .leading-normal.capsize::after,.lg\\:text-sm .font-sans.leading-normal.capsize::after,.lg\\:text-sm .font-sans .leading-normal.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-relaxed.capsize::before, .font-sans .lg\\:text-sm.leading-relaxed.capsize::before, .font-sans .lg\\:text-sm .leading-relaxed.capsize::before,.lg\\:text-sm .font-sans.leading-relaxed.capsize::before,.lg\\:text-sm .font-sans .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4695em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-relaxed.capsize::after, .font-sans .lg\\:text-sm.leading-relaxed.capsize::after, .font-sans .lg\\:text-sm .leading-relaxed.capsize::after,.lg\\:text-sm .font-sans.leading-relaxed.capsize::after,.lg\\:text-sm .font-sans .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4255em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-loose.capsize::before, .font-sans .lg\\:text-sm.leading-loose.capsize::before, .font-sans .lg\\:text-sm .leading-loose.capsize::before,.lg\\:text-sm .font-sans.leading-loose.capsize::before,.lg\\:text-sm .font-sans .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .lg\\:text-sm.font-sans.leading-loose.capsize::after, .font-sans .lg\\:text-sm.leading-loose.capsize::after, .font-sans .lg\\:text-sm .leading-loose.capsize::after,.lg\\:text-sm .font-sans.leading-loose.capsize::after,.lg\\:text-sm .font-sans .leading-loose.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-3.capsize::before, .font-sans .lg\\:text-base.leading-3.capsize::before, .font-sans .lg\\:text-base .leading-3.capsize::before,.lg\\:text-base .font-sans.leading-3.capsize::before,.lg\\:text-base .font-sans .leading-3.capsize::before {
    content: '';
    margin-bottom: -0.032em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-3.capsize::after, .font-sans .lg\\:text-base.leading-3.capsize::after, .font-sans .lg\\:text-base .leading-3.capsize::after,.lg\\:text-base .font-sans.leading-3.capsize::after,.lg\\:text-base .font-sans .leading-3.capsize::after {
    content: '';
    margin-top: 0.012em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-4.capsize::before, .font-sans .lg\\:text-base.leading-4.capsize::before, .font-sans .lg\\:text-base .leading-4.capsize::before,.lg\\:text-base .font-sans.leading-4.capsize::before,.lg\\:text-base .font-sans .leading-4.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-4.capsize::after, .font-sans .lg\\:text-base.leading-4.capsize::after, .font-sans .lg\\:text-base .leading-4.capsize::after,.lg\\:text-base .font-sans.leading-4.capsize::after,.lg\\:text-base .font-sans .leading-4.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-5.capsize::before, .font-sans .lg\\:text-base.leading-5.capsize::before, .font-sans .lg\\:text-base .leading-5.capsize::before,.lg\\:text-base .font-sans.leading-5.capsize::before,.lg\\:text-base .font-sans .leading-5.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-5.capsize::after, .font-sans .lg\\:text-base.leading-5.capsize::after, .font-sans .lg\\:text-base .leading-5.capsize::after,.lg\\:text-base .font-sans.leading-5.capsize::after,.lg\\:text-base .font-sans .leading-5.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-6.capsize::before, .font-sans .lg\\:text-base.leading-6.capsize::before, .font-sans .lg\\:text-base .leading-6.capsize::before,.lg\\:text-base .font-sans.leading-6.capsize::before,.lg\\:text-base .font-sans .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-6.capsize::after, .font-sans .lg\\:text-base.leading-6.capsize::after, .font-sans .lg\\:text-base .leading-6.capsize::after,.lg\\:text-base .font-sans.leading-6.capsize::after,.lg\\:text-base .font-sans .leading-6.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-7.capsize::before, .font-sans .lg\\:text-base.leading-7.capsize::before, .font-sans .lg\\:text-base .leading-7.capsize::before,.lg\\:text-base .font-sans.leading-7.capsize::before,.lg\\:text-base .font-sans .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.532em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-7.capsize::after, .font-sans .lg\\:text-base.leading-7.capsize::after, .font-sans .lg\\:text-base .leading-7.capsize::after,.lg\\:text-base .font-sans.leading-7.capsize::after,.lg\\:text-base .font-sans .leading-7.capsize::after {
    content: '';
    margin-top: -0.488em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-8.capsize::before, .font-sans .lg\\:text-base.leading-8.capsize::before, .font-sans .lg\\:text-base .leading-8.capsize::before,.lg\\:text-base .font-sans.leading-8.capsize::before,.lg\\:text-base .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-8.capsize::after, .font-sans .lg\\:text-base.leading-8.capsize::after, .font-sans .lg\\:text-base .leading-8.capsize::after,.lg\\:text-base .font-sans.leading-8.capsize::after,.lg\\:text-base .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-9.capsize::before, .font-sans .lg\\:text-base.leading-9.capsize::before, .font-sans .lg\\:text-base .leading-9.capsize::before,.lg\\:text-base .font-sans.leading-9.capsize::before,.lg\\:text-base .font-sans .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.782em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-9.capsize::after, .font-sans .lg\\:text-base.leading-9.capsize::after, .font-sans .lg\\:text-base .leading-9.capsize::after,.lg\\:text-base .font-sans.leading-9.capsize::after,.lg\\:text-base .font-sans .leading-9.capsize::after {
    content: '';
    margin-top: -0.738em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-10.capsize::before, .font-sans .lg\\:text-base.leading-10.capsize::before, .font-sans .lg\\:text-base .leading-10.capsize::before,.lg\\:text-base .font-sans.leading-10.capsize::before,.lg\\:text-base .font-sans .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.907em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-10.capsize::after, .font-sans .lg\\:text-base.leading-10.capsize::after, .font-sans .lg\\:text-base .leading-10.capsize::after,.lg\\:text-base .font-sans.leading-10.capsize::after,.lg\\:text-base .font-sans .leading-10.capsize::after {
    content: '';
    margin-top: -0.863em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-none.capsize::before, .font-sans .lg\\:text-base.leading-none.capsize::before, .font-sans .lg\\:text-base .leading-none.capsize::before,.lg\\:text-base .font-sans.leading-none.capsize::before,.lg\\:text-base .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-none.capsize::after, .font-sans .lg\\:text-base.leading-none.capsize::after, .font-sans .lg\\:text-base .leading-none.capsize::after,.lg\\:text-base .font-sans.leading-none.capsize::after,.lg\\:text-base .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-tight.capsize::before, .font-sans .lg\\:text-base.leading-tight.capsize::before, .font-sans .lg\\:text-base .leading-tight.capsize::before,.lg\\:text-base .font-sans.leading-tight.capsize::before,.lg\\:text-base .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-tight.capsize::after, .font-sans .lg\\:text-base.leading-tight.capsize::after, .font-sans .lg\\:text-base .leading-tight.capsize::after,.lg\\:text-base .font-sans.leading-tight.capsize::after,.lg\\:text-base .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-snug.capsize::before, .font-sans .lg\\:text-base.leading-snug.capsize::before, .font-sans .lg\\:text-base .leading-snug.capsize::before,.lg\\:text-base .font-sans.leading-snug.capsize::before,.lg\\:text-base .font-sans .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3445em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-snug.capsize::after, .font-sans .lg\\:text-base.leading-snug.capsize::after, .font-sans .lg\\:text-base .leading-snug.capsize::after,.lg\\:text-base .font-sans.leading-snug.capsize::after,.lg\\:text-base .font-sans .leading-snug.capsize::after {
    content: '';
    margin-top: -0.3005em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-normal.capsize::before, .font-sans .lg\\:text-base.leading-normal.capsize::before, .font-sans .lg\\:text-base .leading-normal.capsize::before,.lg\\:text-base .font-sans.leading-normal.capsize::before,.lg\\:text-base .font-sans .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-normal.capsize::after, .font-sans .lg\\:text-base.leading-normal.capsize::after, .font-sans .lg\\:text-base .leading-normal.capsize::after,.lg\\:text-base .font-sans.leading-normal.capsize::after,.lg\\:text-base .font-sans .leading-normal.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-relaxed.capsize::before, .font-sans .lg\\:text-base.leading-relaxed.capsize::before, .font-sans .lg\\:text-base .leading-relaxed.capsize::before,.lg\\:text-base .font-sans.leading-relaxed.capsize::before,.lg\\:text-base .font-sans .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4695em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-relaxed.capsize::after, .font-sans .lg\\:text-base.leading-relaxed.capsize::after, .font-sans .lg\\:text-base .leading-relaxed.capsize::after,.lg\\:text-base .font-sans.leading-relaxed.capsize::after,.lg\\:text-base .font-sans .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4255em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-loose.capsize::before, .font-sans .lg\\:text-base.leading-loose.capsize::before, .font-sans .lg\\:text-base .leading-loose.capsize::before,.lg\\:text-base .font-sans.leading-loose.capsize::before,.lg\\:text-base .font-sans .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .lg\\:text-base.font-sans.leading-loose.capsize::after, .font-sans .lg\\:text-base.leading-loose.capsize::after, .font-sans .lg\\:text-base .leading-loose.capsize::after,.lg\\:text-base .font-sans.leading-loose.capsize::after,.lg\\:text-base .font-sans .leading-loose.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-3.capsize::before, .font-sans .lg\\:text-2xl.leading-3.capsize::before, .font-sans .lg\\:text-2xl .leading-3.capsize::before,.lg\\:text-2xl .font-sans.leading-3.capsize::before,.lg\\:text-2xl .font-sans .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.093em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-3.capsize::after, .font-sans .lg\\:text-2xl.leading-3.capsize::after, .font-sans .lg\\:text-2xl .leading-3.capsize::after,.lg\\:text-2xl .font-sans.leading-3.capsize::after,.lg\\:text-2xl .font-sans .leading-3.capsize::after {
    content: '';
    margin-top: 0.137em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-4.capsize::before, .font-sans .lg\\:text-2xl.leading-4.capsize::before, .font-sans .lg\\:text-2xl .leading-4.capsize::before,.lg\\:text-2xl .font-sans.leading-4.capsize::before,.lg\\:text-2xl .font-sans .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.0097em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-4.capsize::after, .font-sans .lg\\:text-2xl.leading-4.capsize::after, .font-sans .lg\\:text-2xl .leading-4.capsize::after,.lg\\:text-2xl .font-sans.leading-4.capsize::after,.lg\\:text-2xl .font-sans .leading-4.capsize::after {
    content: '';
    margin-top: 0.0537em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-5.capsize::before, .font-sans .lg\\:text-2xl.leading-5.capsize::before, .font-sans .lg\\:text-2xl .leading-5.capsize::before,.lg\\:text-2xl .font-sans.leading-5.capsize::before,.lg\\:text-2xl .font-sans .leading-5.capsize::before {
    content: '';
    margin-bottom: -0.0737em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-5.capsize::after, .font-sans .lg\\:text-2xl.leading-5.capsize::after, .font-sans .lg\\:text-2xl .leading-5.capsize::after,.lg\\:text-2xl .font-sans.leading-5.capsize::after,.lg\\:text-2xl .font-sans .leading-5.capsize::after {
    content: '';
    margin-top: -0.0297em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-6.capsize::before, .font-sans .lg\\:text-2xl.leading-6.capsize::before, .font-sans .lg\\:text-2xl .leading-6.capsize::before,.lg\\:text-2xl .font-sans.leading-6.capsize::before,.lg\\:text-2xl .font-sans .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-6.capsize::after, .font-sans .lg\\:text-2xl.leading-6.capsize::after, .font-sans .lg\\:text-2xl .leading-6.capsize::after,.lg\\:text-2xl .font-sans.leading-6.capsize::after,.lg\\:text-2xl .font-sans .leading-6.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-7.capsize::before, .font-sans .lg\\:text-2xl.leading-7.capsize::before, .font-sans .lg\\:text-2xl .leading-7.capsize::before,.lg\\:text-2xl .font-sans.leading-7.capsize::before,.lg\\:text-2xl .font-sans .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.2403em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-7.capsize::after, .font-sans .lg\\:text-2xl.leading-7.capsize::after, .font-sans .lg\\:text-2xl .leading-7.capsize::after,.lg\\:text-2xl .font-sans.leading-7.capsize::after,.lg\\:text-2xl .font-sans .leading-7.capsize::after {
    content: '';
    margin-top: -0.1963em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-8.capsize::before, .font-sans .lg\\:text-2xl.leading-8.capsize::before, .font-sans .lg\\:text-2xl .leading-8.capsize::before,.lg\\:text-2xl .font-sans.leading-8.capsize::before,.lg\\:text-2xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.3237em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-8.capsize::after, .font-sans .lg\\:text-2xl.leading-8.capsize::after, .font-sans .lg\\:text-2xl .leading-8.capsize::after,.lg\\:text-2xl .font-sans.leading-8.capsize::after,.lg\\:text-2xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.2797em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-9.capsize::before, .font-sans .lg\\:text-2xl.leading-9.capsize::before, .font-sans .lg\\:text-2xl .leading-9.capsize::before,.lg\\:text-2xl .font-sans.leading-9.capsize::before,.lg\\:text-2xl .font-sans .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-9.capsize::after, .font-sans .lg\\:text-2xl.leading-9.capsize::after, .font-sans .lg\\:text-2xl .leading-9.capsize::after,.lg\\:text-2xl .font-sans.leading-9.capsize::after,.lg\\:text-2xl .font-sans .leading-9.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-10.capsize::before, .font-sans .lg\\:text-2xl.leading-10.capsize::before, .font-sans .lg\\:text-2xl .leading-10.capsize::before,.lg\\:text-2xl .font-sans.leading-10.capsize::before,.lg\\:text-2xl .font-sans .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.4903em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-10.capsize::after, .font-sans .lg\\:text-2xl.leading-10.capsize::after, .font-sans .lg\\:text-2xl .leading-10.capsize::after,.lg\\:text-2xl .font-sans.leading-10.capsize::after,.lg\\:text-2xl .font-sans .leading-10.capsize::after {
    content: '';
    margin-top: -0.4463em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-none.capsize::before, .font-sans .lg\\:text-2xl.leading-none.capsize::before, .font-sans .lg\\:text-2xl .leading-none.capsize::before,.lg\\:text-2xl .font-sans.leading-none.capsize::before,.lg\\:text-2xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-none.capsize::after, .font-sans .lg\\:text-2xl.leading-none.capsize::after, .font-sans .lg\\:text-2xl .leading-none.capsize::after,.lg\\:text-2xl .font-sans.leading-none.capsize::after,.lg\\:text-2xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-tight.capsize::before, .font-sans .lg\\:text-2xl.leading-tight.capsize::before, .font-sans .lg\\:text-2xl .leading-tight.capsize::before,.lg\\:text-2xl .font-sans.leading-tight.capsize::before,.lg\\:text-2xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-tight.capsize::after, .font-sans .lg\\:text-2xl.leading-tight.capsize::after, .font-sans .lg\\:text-2xl .leading-tight.capsize::after,.lg\\:text-2xl .font-sans.leading-tight.capsize::after,.lg\\:text-2xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-snug.capsize::before, .font-sans .lg\\:text-2xl.leading-snug.capsize::before, .font-sans .lg\\:text-2xl .leading-snug.capsize::before,.lg\\:text-2xl .font-sans.leading-snug.capsize::before,.lg\\:text-2xl .font-sans .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3445em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-snug.capsize::after, .font-sans .lg\\:text-2xl.leading-snug.capsize::after, .font-sans .lg\\:text-2xl .leading-snug.capsize::after,.lg\\:text-2xl .font-sans.leading-snug.capsize::after,.lg\\:text-2xl .font-sans .leading-snug.capsize::after {
    content: '';
    margin-top: -0.3005em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-normal.capsize::before, .font-sans .lg\\:text-2xl.leading-normal.capsize::before, .font-sans .lg\\:text-2xl .leading-normal.capsize::before,.lg\\:text-2xl .font-sans.leading-normal.capsize::before,.lg\\:text-2xl .font-sans .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-normal.capsize::after, .font-sans .lg\\:text-2xl.leading-normal.capsize::after, .font-sans .lg\\:text-2xl .leading-normal.capsize::after,.lg\\:text-2xl .font-sans.leading-normal.capsize::after,.lg\\:text-2xl .font-sans .leading-normal.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-relaxed.capsize::before, .font-sans .lg\\:text-2xl.leading-relaxed.capsize::before, .font-sans .lg\\:text-2xl .leading-relaxed.capsize::before,.lg\\:text-2xl .font-sans.leading-relaxed.capsize::before,.lg\\:text-2xl .font-sans .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4695em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-relaxed.capsize::after, .font-sans .lg\\:text-2xl.leading-relaxed.capsize::after, .font-sans .lg\\:text-2xl .leading-relaxed.capsize::after,.lg\\:text-2xl .font-sans.leading-relaxed.capsize::after,.lg\\:text-2xl .font-sans .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4255em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-loose.capsize::before, .font-sans .lg\\:text-2xl.leading-loose.capsize::before, .font-sans .lg\\:text-2xl .leading-loose.capsize::before,.lg\\:text-2xl .font-sans.leading-loose.capsize::before,.lg\\:text-2xl .font-sans .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .lg\\:text-2xl.font-sans.leading-loose.capsize::after, .font-sans .lg\\:text-2xl.leading-loose.capsize::after, .font-sans .lg\\:text-2xl .leading-loose.capsize::after,.lg\\:text-2xl .font-sans.leading-loose.capsize::after,.lg\\:text-2xl .font-sans .leading-loose.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-3.capsize::before, .font-sans .lg\\:text-3xl.leading-3.capsize::before, .font-sans .lg\\:text-3xl .leading-3.capsize::before,.lg\\:text-3xl .font-sans.leading-3.capsize::before,.lg\\:text-3xl .font-sans .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.143em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-3.capsize::after, .font-sans .lg\\:text-3xl.leading-3.capsize::after, .font-sans .lg\\:text-3xl .leading-3.capsize::after,.lg\\:text-3xl .font-sans.leading-3.capsize::after,.lg\\:text-3xl .font-sans .leading-3.capsize::after {
    content: '';
    margin-top: 0.187em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-4.capsize::before, .font-sans .lg\\:text-3xl.leading-4.capsize::before, .font-sans .lg\\:text-3xl .leading-4.capsize::before,.lg\\:text-3xl .font-sans.leading-4.capsize::before,.lg\\:text-3xl .font-sans .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.0763em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-4.capsize::after, .font-sans .lg\\:text-3xl.leading-4.capsize::after, .font-sans .lg\\:text-3xl .leading-4.capsize::after,.lg\\:text-3xl .font-sans.leading-4.capsize::after,.lg\\:text-3xl .font-sans .leading-4.capsize::after {
    content: '';
    margin-top: 0.1203em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-5.capsize::before, .font-sans .lg\\:text-3xl.leading-5.capsize::before, .font-sans .lg\\:text-3xl .leading-5.capsize::before,.lg\\:text-3xl .font-sans.leading-5.capsize::before,.lg\\:text-3xl .font-sans .leading-5.capsize::before {
    content: '';
    margin-bottom: 0.0097em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-5.capsize::after, .font-sans .lg\\:text-3xl.leading-5.capsize::after, .font-sans .lg\\:text-3xl .leading-5.capsize::after,.lg\\:text-3xl .font-sans.leading-5.capsize::after,.lg\\:text-3xl .font-sans .leading-5.capsize::after {
    content: '';
    margin-top: 0.0537em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-6.capsize::before, .font-sans .lg\\:text-3xl.leading-6.capsize::before, .font-sans .lg\\:text-3xl .leading-6.capsize::before,.lg\\:text-3xl .font-sans.leading-6.capsize::before,.lg\\:text-3xl .font-sans .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.057em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-6.capsize::after, .font-sans .lg\\:text-3xl.leading-6.capsize::after, .font-sans .lg\\:text-3xl .leading-6.capsize::after,.lg\\:text-3xl .font-sans.leading-6.capsize::after,.lg\\:text-3xl .font-sans .leading-6.capsize::after {
    content: '';
    margin-top: -0.013em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-7.capsize::before, .font-sans .lg\\:text-3xl.leading-7.capsize::before, .font-sans .lg\\:text-3xl .leading-7.capsize::before,.lg\\:text-3xl .font-sans.leading-7.capsize::before,.lg\\:text-3xl .font-sans .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.1237em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-7.capsize::after, .font-sans .lg\\:text-3xl.leading-7.capsize::after, .font-sans .lg\\:text-3xl .leading-7.capsize::after,.lg\\:text-3xl .font-sans.leading-7.capsize::after,.lg\\:text-3xl .font-sans .leading-7.capsize::after {
    content: '';
    margin-top: -0.0797em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-8.capsize::before, .font-sans .lg\\:text-3xl.leading-8.capsize::before, .font-sans .lg\\:text-3xl .leading-8.capsize::before,.lg\\:text-3xl .font-sans.leading-8.capsize::before,.lg\\:text-3xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1903em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-8.capsize::after, .font-sans .lg\\:text-3xl.leading-8.capsize::after, .font-sans .lg\\:text-3xl .leading-8.capsize::after,.lg\\:text-3xl .font-sans.leading-8.capsize::after,.lg\\:text-3xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.1463em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-9.capsize::before, .font-sans .lg\\:text-3xl.leading-9.capsize::before, .font-sans .lg\\:text-3xl .leading-9.capsize::before,.lg\\:text-3xl .font-sans.leading-9.capsize::before,.lg\\:text-3xl .font-sans .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.257em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-9.capsize::after, .font-sans .lg\\:text-3xl.leading-9.capsize::after, .font-sans .lg\\:text-3xl .leading-9.capsize::after,.lg\\:text-3xl .font-sans.leading-9.capsize::after,.lg\\:text-3xl .font-sans .leading-9.capsize::after {
    content: '';
    margin-top: -0.213em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-10.capsize::before, .font-sans .lg\\:text-3xl.leading-10.capsize::before, .font-sans .lg\\:text-3xl .leading-10.capsize::before,.lg\\:text-3xl .font-sans.leading-10.capsize::before,.lg\\:text-3xl .font-sans .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.3237em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-10.capsize::after, .font-sans .lg\\:text-3xl.leading-10.capsize::after, .font-sans .lg\\:text-3xl .leading-10.capsize::after,.lg\\:text-3xl .font-sans.leading-10.capsize::after,.lg\\:text-3xl .font-sans .leading-10.capsize::after {
    content: '';
    margin-top: -0.2797em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-none.capsize::before, .font-sans .lg\\:text-3xl.leading-none.capsize::before, .font-sans .lg\\:text-3xl .leading-none.capsize::before,.lg\\:text-3xl .font-sans.leading-none.capsize::before,.lg\\:text-3xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-none.capsize::after, .font-sans .lg\\:text-3xl.leading-none.capsize::after, .font-sans .lg\\:text-3xl .leading-none.capsize::after,.lg\\:text-3xl .font-sans.leading-none.capsize::after,.lg\\:text-3xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-tight.capsize::before, .font-sans .lg\\:text-3xl.leading-tight.capsize::before, .font-sans .lg\\:text-3xl .leading-tight.capsize::before,.lg\\:text-3xl .font-sans.leading-tight.capsize::before,.lg\\:text-3xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-tight.capsize::after, .font-sans .lg\\:text-3xl.leading-tight.capsize::after, .font-sans .lg\\:text-3xl .leading-tight.capsize::after,.lg\\:text-3xl .font-sans.leading-tight.capsize::after,.lg\\:text-3xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-snug.capsize::before, .font-sans .lg\\:text-3xl.leading-snug.capsize::before, .font-sans .lg\\:text-3xl .leading-snug.capsize::before,.lg\\:text-3xl .font-sans.leading-snug.capsize::before,.lg\\:text-3xl .font-sans .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3445em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-snug.capsize::after, .font-sans .lg\\:text-3xl.leading-snug.capsize::after, .font-sans .lg\\:text-3xl .leading-snug.capsize::after,.lg\\:text-3xl .font-sans.leading-snug.capsize::after,.lg\\:text-3xl .font-sans .leading-snug.capsize::after {
    content: '';
    margin-top: -0.3005em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-normal.capsize::before, .font-sans .lg\\:text-3xl.leading-normal.capsize::before, .font-sans .lg\\:text-3xl .leading-normal.capsize::before,.lg\\:text-3xl .font-sans.leading-normal.capsize::before,.lg\\:text-3xl .font-sans .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-normal.capsize::after, .font-sans .lg\\:text-3xl.leading-normal.capsize::after, .font-sans .lg\\:text-3xl .leading-normal.capsize::after,.lg\\:text-3xl .font-sans.leading-normal.capsize::after,.lg\\:text-3xl .font-sans .leading-normal.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-relaxed.capsize::before, .font-sans .lg\\:text-3xl.leading-relaxed.capsize::before, .font-sans .lg\\:text-3xl .leading-relaxed.capsize::before,.lg\\:text-3xl .font-sans.leading-relaxed.capsize::before,.lg\\:text-3xl .font-sans .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4695em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-relaxed.capsize::after, .font-sans .lg\\:text-3xl.leading-relaxed.capsize::after, .font-sans .lg\\:text-3xl .leading-relaxed.capsize::after,.lg\\:text-3xl .font-sans.leading-relaxed.capsize::after,.lg\\:text-3xl .font-sans .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4255em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-loose.capsize::before, .font-sans .lg\\:text-3xl.leading-loose.capsize::before, .font-sans .lg\\:text-3xl .leading-loose.capsize::before,.lg\\:text-3xl .font-sans.leading-loose.capsize::before,.lg\\:text-3xl .font-sans .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .lg\\:text-3xl.font-sans.leading-loose.capsize::after, .font-sans .lg\\:text-3xl.leading-loose.capsize::after, .font-sans .lg\\:text-3xl .leading-loose.capsize::after,.lg\\:text-3xl .font-sans.leading-loose.capsize::after,.lg\\:text-3xl .font-sans .leading-loose.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-3.capsize::before, .font-sans .lg\\:text-5xl.leading-3.capsize::before, .font-sans .lg\\:text-5xl .leading-3.capsize::before,.lg\\:text-5xl .font-sans.leading-3.capsize::before,.lg\\:text-5xl .font-sans .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.218em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-3.capsize::after, .font-sans .lg\\:text-5xl.leading-3.capsize::after, .font-sans .lg\\:text-5xl .leading-3.capsize::after,.lg\\:text-5xl .font-sans.leading-3.capsize::after,.lg\\:text-5xl .font-sans .leading-3.capsize::after {
    content: '';
    margin-top: 0.262em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-4.capsize::before, .font-sans .lg\\:text-5xl.leading-4.capsize::before, .font-sans .lg\\:text-5xl .leading-4.capsize::before,.lg\\:text-5xl .font-sans.leading-4.capsize::before,.lg\\:text-5xl .font-sans .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.1763em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-4.capsize::after, .font-sans .lg\\:text-5xl.leading-4.capsize::after, .font-sans .lg\\:text-5xl .leading-4.capsize::after,.lg\\:text-5xl .font-sans.leading-4.capsize::after,.lg\\:text-5xl .font-sans .leading-4.capsize::after {
    content: '';
    margin-top: 0.2203em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-5.capsize::before, .font-sans .lg\\:text-5xl.leading-5.capsize::before, .font-sans .lg\\:text-5xl .leading-5.capsize::before,.lg\\:text-5xl .font-sans.leading-5.capsize::before,.lg\\:text-5xl .font-sans .leading-5.capsize::before {
    content: '';
    margin-bottom: 0.1347em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-5.capsize::after, .font-sans .lg\\:text-5xl.leading-5.capsize::after, .font-sans .lg\\:text-5xl .leading-5.capsize::after,.lg\\:text-5xl .font-sans.leading-5.capsize::after,.lg\\:text-5xl .font-sans .leading-5.capsize::after {
    content: '';
    margin-top: 0.1787em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-6.capsize::before, .font-sans .lg\\:text-5xl.leading-6.capsize::before, .font-sans .lg\\:text-5xl .leading-6.capsize::before,.lg\\:text-5xl .font-sans.leading-6.capsize::before,.lg\\:text-5xl .font-sans .leading-6.capsize::before {
    content: '';
    margin-bottom: 0.093em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-6.capsize::after, .font-sans .lg\\:text-5xl.leading-6.capsize::after, .font-sans .lg\\:text-5xl .leading-6.capsize::after,.lg\\:text-5xl .font-sans.leading-6.capsize::after,.lg\\:text-5xl .font-sans .leading-6.capsize::after {
    content: '';
    margin-top: 0.137em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-7.capsize::before, .font-sans .lg\\:text-5xl.leading-7.capsize::before, .font-sans .lg\\:text-5xl .leading-7.capsize::before,.lg\\:text-5xl .font-sans.leading-7.capsize::before,.lg\\:text-5xl .font-sans .leading-7.capsize::before {
    content: '';
    margin-bottom: 0.0513em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-7.capsize::after, .font-sans .lg\\:text-5xl.leading-7.capsize::after, .font-sans .lg\\:text-5xl .leading-7.capsize::after,.lg\\:text-5xl .font-sans.leading-7.capsize::after,.lg\\:text-5xl .font-sans .leading-7.capsize::after {
    content: '';
    margin-top: 0.0953em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-8.capsize::before, .font-sans .lg\\:text-5xl.leading-8.capsize::before, .font-sans .lg\\:text-5xl .leading-8.capsize::before,.lg\\:text-5xl .font-sans.leading-8.capsize::before,.lg\\:text-5xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.0097em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-8.capsize::after, .font-sans .lg\\:text-5xl.leading-8.capsize::after, .font-sans .lg\\:text-5xl .leading-8.capsize::after,.lg\\:text-5xl .font-sans.leading-8.capsize::after,.lg\\:text-5xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: 0.0537em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-9.capsize::before, .font-sans .lg\\:text-5xl.leading-9.capsize::before, .font-sans .lg\\:text-5xl .leading-9.capsize::before,.lg\\:text-5xl .font-sans.leading-9.capsize::before,.lg\\:text-5xl .font-sans .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.032em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-9.capsize::after, .font-sans .lg\\:text-5xl.leading-9.capsize::after, .font-sans .lg\\:text-5xl .leading-9.capsize::after,.lg\\:text-5xl .font-sans.leading-9.capsize::after,.lg\\:text-5xl .font-sans .leading-9.capsize::after {
    content: '';
    margin-top: 0.012em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-10.capsize::before, .font-sans .lg\\:text-5xl.leading-10.capsize::before, .font-sans .lg\\:text-5xl .leading-10.capsize::before,.lg\\:text-5xl .font-sans.leading-10.capsize::before,.lg\\:text-5xl .font-sans .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.0737em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-10.capsize::after, .font-sans .lg\\:text-5xl.leading-10.capsize::after, .font-sans .lg\\:text-5xl .leading-10.capsize::after,.lg\\:text-5xl .font-sans.leading-10.capsize::after,.lg\\:text-5xl .font-sans .leading-10.capsize::after {
    content: '';
    margin-top: -0.0297em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-none.capsize::before, .font-sans .lg\\:text-5xl.leading-none.capsize::before, .font-sans .lg\\:text-5xl .leading-none.capsize::before,.lg\\:text-5xl .font-sans.leading-none.capsize::before,.lg\\:text-5xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-none.capsize::after, .font-sans .lg\\:text-5xl.leading-none.capsize::after, .font-sans .lg\\:text-5xl .leading-none.capsize::after,.lg\\:text-5xl .font-sans.leading-none.capsize::after,.lg\\:text-5xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-tight.capsize::before, .font-sans .lg\\:text-5xl.leading-tight.capsize::before, .font-sans .lg\\:text-5xl .leading-tight.capsize::before,.lg\\:text-5xl .font-sans.leading-tight.capsize::before,.lg\\:text-5xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-tight.capsize::after, .font-sans .lg\\:text-5xl.leading-tight.capsize::after, .font-sans .lg\\:text-5xl .leading-tight.capsize::after,.lg\\:text-5xl .font-sans.leading-tight.capsize::after,.lg\\:text-5xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-snug.capsize::before, .font-sans .lg\\:text-5xl.leading-snug.capsize::before, .font-sans .lg\\:text-5xl .leading-snug.capsize::before,.lg\\:text-5xl .font-sans.leading-snug.capsize::before,.lg\\:text-5xl .font-sans .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3445em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-snug.capsize::after, .font-sans .lg\\:text-5xl.leading-snug.capsize::after, .font-sans .lg\\:text-5xl .leading-snug.capsize::after,.lg\\:text-5xl .font-sans.leading-snug.capsize::after,.lg\\:text-5xl .font-sans .leading-snug.capsize::after {
    content: '';
    margin-top: -0.3005em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-normal.capsize::before, .font-sans .lg\\:text-5xl.leading-normal.capsize::before, .font-sans .lg\\:text-5xl .leading-normal.capsize::before,.lg\\:text-5xl .font-sans.leading-normal.capsize::before,.lg\\:text-5xl .font-sans .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-normal.capsize::after, .font-sans .lg\\:text-5xl.leading-normal.capsize::after, .font-sans .lg\\:text-5xl .leading-normal.capsize::after,.lg\\:text-5xl .font-sans.leading-normal.capsize::after,.lg\\:text-5xl .font-sans .leading-normal.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-relaxed.capsize::before, .font-sans .lg\\:text-5xl.leading-relaxed.capsize::before, .font-sans .lg\\:text-5xl .leading-relaxed.capsize::before,.lg\\:text-5xl .font-sans.leading-relaxed.capsize::before,.lg\\:text-5xl .font-sans .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4695em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-relaxed.capsize::after, .font-sans .lg\\:text-5xl.leading-relaxed.capsize::after, .font-sans .lg\\:text-5xl .leading-relaxed.capsize::after,.lg\\:text-5xl .font-sans.leading-relaxed.capsize::after,.lg\\:text-5xl .font-sans .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4255em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-loose.capsize::before, .font-sans .lg\\:text-5xl.leading-loose.capsize::before, .font-sans .lg\\:text-5xl .leading-loose.capsize::before,.lg\\:text-5xl .font-sans.leading-loose.capsize::before,.lg\\:text-5xl .font-sans .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .lg\\:text-5xl.font-sans.leading-loose.capsize::after, .font-sans .lg\\:text-5xl.leading-loose.capsize::after, .font-sans .lg\\:text-5xl .leading-loose.capsize::after,.lg\\:text-5xl .font-sans.leading-loose.capsize::after,.lg\\:text-5xl .font-sans .leading-loose.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-3.capsize::before, .font-sans .lg\\:text-7xl.leading-3.capsize::before, .font-sans .lg\\:text-7xl .leading-3.capsize::before,.lg\\:text-7xl .font-sans.leading-3.capsize::before,.lg\\:text-7xl .font-sans .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.2597em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-3.capsize::after, .font-sans .lg\\:text-7xl.leading-3.capsize::after, .font-sans .lg\\:text-7xl .leading-3.capsize::after,.lg\\:text-7xl .font-sans.leading-3.capsize::after,.lg\\:text-7xl .font-sans .leading-3.capsize::after {
    content: '';
    margin-top: 0.3037em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-4.capsize::before, .font-sans .lg\\:text-7xl.leading-4.capsize::before, .font-sans .lg\\:text-7xl .leading-4.capsize::before,.lg\\:text-7xl .font-sans.leading-4.capsize::before,.lg\\:text-7xl .font-sans .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.2319em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-4.capsize::after, .font-sans .lg\\:text-7xl.leading-4.capsize::after, .font-sans .lg\\:text-7xl .leading-4.capsize::after,.lg\\:text-7xl .font-sans.leading-4.capsize::after,.lg\\:text-7xl .font-sans .leading-4.capsize::after {
    content: '';
    margin-top: 0.2759em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-5.capsize::before, .font-sans .lg\\:text-7xl.leading-5.capsize::before, .font-sans .lg\\:text-7xl .leading-5.capsize::before,.lg\\:text-7xl .font-sans.leading-5.capsize::before,.lg\\:text-7xl .font-sans .leading-5.capsize::before {
    content: '';
    margin-bottom: 0.2041em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-5.capsize::after, .font-sans .lg\\:text-7xl.leading-5.capsize::after, .font-sans .lg\\:text-7xl .leading-5.capsize::after,.lg\\:text-7xl .font-sans.leading-5.capsize::after,.lg\\:text-7xl .font-sans .leading-5.capsize::after {
    content: '';
    margin-top: 0.2481em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-6.capsize::before, .font-sans .lg\\:text-7xl.leading-6.capsize::before, .font-sans .lg\\:text-7xl .leading-6.capsize::before,.lg\\:text-7xl .font-sans.leading-6.capsize::before,.lg\\:text-7xl .font-sans .leading-6.capsize::before {
    content: '';
    margin-bottom: 0.1763em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-6.capsize::after, .font-sans .lg\\:text-7xl.leading-6.capsize::after, .font-sans .lg\\:text-7xl .leading-6.capsize::after,.lg\\:text-7xl .font-sans.leading-6.capsize::after,.lg\\:text-7xl .font-sans .leading-6.capsize::after {
    content: '';
    margin-top: 0.2203em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-7.capsize::before, .font-sans .lg\\:text-7xl.leading-7.capsize::before, .font-sans .lg\\:text-7xl .leading-7.capsize::before,.lg\\:text-7xl .font-sans.leading-7.capsize::before,.lg\\:text-7xl .font-sans .leading-7.capsize::before {
    content: '';
    margin-bottom: 0.1486em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-7.capsize::after, .font-sans .lg\\:text-7xl.leading-7.capsize::after, .font-sans .lg\\:text-7xl .leading-7.capsize::after,.lg\\:text-7xl .font-sans.leading-7.capsize::after,.lg\\:text-7xl .font-sans .leading-7.capsize::after {
    content: '';
    margin-top: 0.1926em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-8.capsize::before, .font-sans .lg\\:text-7xl.leading-8.capsize::before, .font-sans .lg\\:text-7xl .leading-8.capsize::before,.lg\\:text-7xl .font-sans.leading-8.capsize::before,.lg\\:text-7xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1208em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-8.capsize::after, .font-sans .lg\\:text-7xl.leading-8.capsize::after, .font-sans .lg\\:text-7xl .leading-8.capsize::after,.lg\\:text-7xl .font-sans.leading-8.capsize::after,.lg\\:text-7xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: 0.1648em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-9.capsize::before, .font-sans .lg\\:text-7xl.leading-9.capsize::before, .font-sans .lg\\:text-7xl .leading-9.capsize::before,.lg\\:text-7xl .font-sans.leading-9.capsize::before,.lg\\:text-7xl .font-sans .leading-9.capsize::before {
    content: '';
    margin-bottom: 0.093em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-9.capsize::after, .font-sans .lg\\:text-7xl.leading-9.capsize::after, .font-sans .lg\\:text-7xl .leading-9.capsize::after,.lg\\:text-7xl .font-sans.leading-9.capsize::after,.lg\\:text-7xl .font-sans .leading-9.capsize::after {
    content: '';
    margin-top: 0.137em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-10.capsize::before, .font-sans .lg\\:text-7xl.leading-10.capsize::before, .font-sans .lg\\:text-7xl .leading-10.capsize::before,.lg\\:text-7xl .font-sans.leading-10.capsize::before,.lg\\:text-7xl .font-sans .leading-10.capsize::before {
    content: '';
    margin-bottom: 0.0652em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-10.capsize::after, .font-sans .lg\\:text-7xl.leading-10.capsize::after, .font-sans .lg\\:text-7xl .leading-10.capsize::after,.lg\\:text-7xl .font-sans.leading-10.capsize::after,.lg\\:text-7xl .font-sans .leading-10.capsize::after {
    content: '';
    margin-top: 0.1092em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-none.capsize::before, .font-sans .lg\\:text-7xl.leading-none.capsize::before, .font-sans .lg\\:text-7xl .leading-none.capsize::before,.lg\\:text-7xl .font-sans.leading-none.capsize::before,.lg\\:text-7xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-none.capsize::after, .font-sans .lg\\:text-7xl.leading-none.capsize::after, .font-sans .lg\\:text-7xl .leading-none.capsize::after,.lg\\:text-7xl .font-sans.leading-none.capsize::after,.lg\\:text-7xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-tight.capsize::before, .font-sans .lg\\:text-7xl.leading-tight.capsize::before, .font-sans .lg\\:text-7xl .leading-tight.capsize::before,.lg\\:text-7xl .font-sans.leading-tight.capsize::before,.lg\\:text-7xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-tight.capsize::after, .font-sans .lg\\:text-7xl.leading-tight.capsize::after, .font-sans .lg\\:text-7xl .leading-tight.capsize::after,.lg\\:text-7xl .font-sans.leading-tight.capsize::after,.lg\\:text-7xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-snug.capsize::before, .font-sans .lg\\:text-7xl.leading-snug.capsize::before, .font-sans .lg\\:text-7xl .leading-snug.capsize::before,.lg\\:text-7xl .font-sans.leading-snug.capsize::before,.lg\\:text-7xl .font-sans .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3445em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-snug.capsize::after, .font-sans .lg\\:text-7xl.leading-snug.capsize::after, .font-sans .lg\\:text-7xl .leading-snug.capsize::after,.lg\\:text-7xl .font-sans.leading-snug.capsize::after,.lg\\:text-7xl .font-sans .leading-snug.capsize::after {
    content: '';
    margin-top: -0.3005em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-normal.capsize::before, .font-sans .lg\\:text-7xl.leading-normal.capsize::before, .font-sans .lg\\:text-7xl .leading-normal.capsize::before,.lg\\:text-7xl .font-sans.leading-normal.capsize::before,.lg\\:text-7xl .font-sans .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-normal.capsize::after, .font-sans .lg\\:text-7xl.leading-normal.capsize::after, .font-sans .lg\\:text-7xl .leading-normal.capsize::after,.lg\\:text-7xl .font-sans.leading-normal.capsize::after,.lg\\:text-7xl .font-sans .leading-normal.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-relaxed.capsize::before, .font-sans .lg\\:text-7xl.leading-relaxed.capsize::before, .font-sans .lg\\:text-7xl .leading-relaxed.capsize::before,.lg\\:text-7xl .font-sans.leading-relaxed.capsize::before,.lg\\:text-7xl .font-sans .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4695em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-relaxed.capsize::after, .font-sans .lg\\:text-7xl.leading-relaxed.capsize::after, .font-sans .lg\\:text-7xl .leading-relaxed.capsize::after,.lg\\:text-7xl .font-sans.leading-relaxed.capsize::after,.lg\\:text-7xl .font-sans .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4255em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-loose.capsize::before, .font-sans .lg\\:text-7xl.leading-loose.capsize::before, .font-sans .lg\\:text-7xl .leading-loose.capsize::before,.lg\\:text-7xl .font-sans.leading-loose.capsize::before,.lg\\:text-7xl .font-sans .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .lg\\:text-7xl.font-sans.leading-loose.capsize::after, .font-sans .lg\\:text-7xl.leading-loose.capsize::after, .font-sans .lg\\:text-7xl .leading-loose.capsize::after,.lg\\:text-7xl .font-sans.leading-loose.capsize::after,.lg\\:text-7xl .font-sans .leading-loose.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-3.capsize::before, .font-sans .lg\\:text-3.3xl.leading-3.capsize::before, .font-sans .lg\\:text-3.3xl .leading-3.capsize::before,.lg\\:text-3.3xl .font-sans.leading-3.capsize::before,.lg\\:text-3.3xl .font-sans .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.1555em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-3.capsize::after, .font-sans .lg\\:text-3.3xl.leading-3.capsize::after, .font-sans .lg\\:text-3.3xl .leading-3.capsize::after,.lg\\:text-3.3xl .font-sans.leading-3.capsize::after,.lg\\:text-3.3xl .font-sans .leading-3.capsize::after {
    content: '';
    margin-top: 0.1995em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-4.capsize::before, .font-sans .lg\\:text-3.3xl.leading-4.capsize::before, .font-sans .lg\\:text-3.3xl .leading-4.capsize::before,.lg\\:text-3.3xl .font-sans.leading-4.capsize::before,.lg\\:text-3.3xl .font-sans .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.093em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-4.capsize::after, .font-sans .lg\\:text-3.3xl.leading-4.capsize::after, .font-sans .lg\\:text-3.3xl .leading-4.capsize::after,.lg\\:text-3.3xl .font-sans.leading-4.capsize::after,.lg\\:text-3.3xl .font-sans .leading-4.capsize::after {
    content: '';
    margin-top: 0.137em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-5.capsize::before, .font-sans .lg\\:text-3.3xl.leading-5.capsize::before, .font-sans .lg\\:text-3.3xl .leading-5.capsize::before,.lg\\:text-3.3xl .font-sans.leading-5.capsize::before,.lg\\:text-3.3xl .font-sans .leading-5.capsize::before {
    content: '';
    margin-bottom: 0.0305em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-5.capsize::after, .font-sans .lg\\:text-3.3xl.leading-5.capsize::after, .font-sans .lg\\:text-3.3xl .leading-5.capsize::after,.lg\\:text-3.3xl .font-sans.leading-5.capsize::after,.lg\\:text-3.3xl .font-sans .leading-5.capsize::after {
    content: '';
    margin-top: 0.0745em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-6.capsize::before, .font-sans .lg\\:text-3.3xl.leading-6.capsize::before, .font-sans .lg\\:text-3.3xl .leading-6.capsize::before,.lg\\:text-3.3xl .font-sans.leading-6.capsize::before,.lg\\:text-3.3xl .font-sans .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.032em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-6.capsize::after, .font-sans .lg\\:text-3.3xl.leading-6.capsize::after, .font-sans .lg\\:text-3.3xl .leading-6.capsize::after,.lg\\:text-3.3xl .font-sans.leading-6.capsize::after,.lg\\:text-3.3xl .font-sans .leading-6.capsize::after {
    content: '';
    margin-top: 0.012em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-7.capsize::before, .font-sans .lg\\:text-3.3xl.leading-7.capsize::before, .font-sans .lg\\:text-3.3xl .leading-7.capsize::before,.lg\\:text-3.3xl .font-sans.leading-7.capsize::before,.lg\\:text-3.3xl .font-sans .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.0945em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-7.capsize::after, .font-sans .lg\\:text-3.3xl.leading-7.capsize::after, .font-sans .lg\\:text-3.3xl .leading-7.capsize::after,.lg\\:text-3.3xl .font-sans.leading-7.capsize::after,.lg\\:text-3.3xl .font-sans .leading-7.capsize::after {
    content: '';
    margin-top: -0.0505em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-8.capsize::before, .font-sans .lg\\:text-3.3xl.leading-8.capsize::before, .font-sans .lg\\:text-3.3xl .leading-8.capsize::before,.lg\\:text-3.3xl .font-sans.leading-8.capsize::before,.lg\\:text-3.3xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-8.capsize::after, .font-sans .lg\\:text-3.3xl.leading-8.capsize::after, .font-sans .lg\\:text-3.3xl .leading-8.capsize::after,.lg\\:text-3.3xl .font-sans.leading-8.capsize::after,.lg\\:text-3.3xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-9.capsize::before, .font-sans .lg\\:text-3.3xl.leading-9.capsize::before, .font-sans .lg\\:text-3.3xl .leading-9.capsize::before,.lg\\:text-3.3xl .font-sans.leading-9.capsize::before,.lg\\:text-3.3xl .font-sans .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.2195em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-9.capsize::after, .font-sans .lg\\:text-3.3xl.leading-9.capsize::after, .font-sans .lg\\:text-3.3xl .leading-9.capsize::after,.lg\\:text-3.3xl .font-sans.leading-9.capsize::after,.lg\\:text-3.3xl .font-sans .leading-9.capsize::after {
    content: '';
    margin-top: -0.1755em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-10.capsize::before, .font-sans .lg\\:text-3.3xl.leading-10.capsize::before, .font-sans .lg\\:text-3.3xl .leading-10.capsize::before,.lg\\:text-3.3xl .font-sans.leading-10.capsize::before,.lg\\:text-3.3xl .font-sans .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-10.capsize::after, .font-sans .lg\\:text-3.3xl.leading-10.capsize::after, .font-sans .lg\\:text-3.3xl .leading-10.capsize::after,.lg\\:text-3.3xl .font-sans.leading-10.capsize::after,.lg\\:text-3.3xl .font-sans .leading-10.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-none.capsize::before, .font-sans .lg\\:text-3.3xl.leading-none.capsize::before, .font-sans .lg\\:text-3.3xl .leading-none.capsize::before,.lg\\:text-3.3xl .font-sans.leading-none.capsize::before,.lg\\:text-3.3xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-none.capsize::after, .font-sans .lg\\:text-3.3xl.leading-none.capsize::after, .font-sans .lg\\:text-3.3xl .leading-none.capsize::after,.lg\\:text-3.3xl .font-sans.leading-none.capsize::after,.lg\\:text-3.3xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-tight.capsize::before, .font-sans .lg\\:text-3.3xl.leading-tight.capsize::before, .font-sans .lg\\:text-3.3xl .leading-tight.capsize::before,.lg\\:text-3.3xl .font-sans.leading-tight.capsize::before,.lg\\:text-3.3xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-tight.capsize::after, .font-sans .lg\\:text-3.3xl.leading-tight.capsize::after, .font-sans .lg\\:text-3.3xl .leading-tight.capsize::after,.lg\\:text-3.3xl .font-sans.leading-tight.capsize::after,.lg\\:text-3.3xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-snug.capsize::before, .font-sans .lg\\:text-3.3xl.leading-snug.capsize::before, .font-sans .lg\\:text-3.3xl .leading-snug.capsize::before,.lg\\:text-3.3xl .font-sans.leading-snug.capsize::before,.lg\\:text-3.3xl .font-sans .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3445em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-snug.capsize::after, .font-sans .lg\\:text-3.3xl.leading-snug.capsize::after, .font-sans .lg\\:text-3.3xl .leading-snug.capsize::after,.lg\\:text-3.3xl .font-sans.leading-snug.capsize::after,.lg\\:text-3.3xl .font-sans .leading-snug.capsize::after {
    content: '';
    margin-top: -0.3005em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-normal.capsize::before, .font-sans .lg\\:text-3.3xl.leading-normal.capsize::before, .font-sans .lg\\:text-3.3xl .leading-normal.capsize::before,.lg\\:text-3.3xl .font-sans.leading-normal.capsize::before,.lg\\:text-3.3xl .font-sans .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-normal.capsize::after, .font-sans .lg\\:text-3.3xl.leading-normal.capsize::after, .font-sans .lg\\:text-3.3xl .leading-normal.capsize::after,.lg\\:text-3.3xl .font-sans.leading-normal.capsize::after,.lg\\:text-3.3xl .font-sans .leading-normal.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-relaxed.capsize::before, .font-sans .lg\\:text-3.3xl.leading-relaxed.capsize::before, .font-sans .lg\\:text-3.3xl .leading-relaxed.capsize::before,.lg\\:text-3.3xl .font-sans.leading-relaxed.capsize::before,.lg\\:text-3.3xl .font-sans .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4695em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-relaxed.capsize::after, .font-sans .lg\\:text-3.3xl.leading-relaxed.capsize::after, .font-sans .lg\\:text-3.3xl .leading-relaxed.capsize::after,.lg\\:text-3.3xl .font-sans.leading-relaxed.capsize::after,.lg\\:text-3.3xl .font-sans .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4255em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-loose.capsize::before, .font-sans .lg\\:text-3.3xl.leading-loose.capsize::before, .font-sans .lg\\:text-3.3xl .leading-loose.capsize::before,.lg\\:text-3.3xl .font-sans.leading-loose.capsize::before,.lg\\:text-3.3xl .font-sans .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .lg\\:text-3.font-sans.3xl.leading-loose.capsize::after, .font-sans .lg\\:text-3.3xl.leading-loose.capsize::after, .font-sans .lg\\:text-3.3xl .leading-loose.capsize::after,.lg\\:text-3.3xl .font-sans.leading-loose.capsize::after,.lg\\:text-3.3xl .font-sans .leading-loose.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-3.capsize::before, .font-serif .lg\\:text-sm.leading-3.capsize::before, .font-serif .lg\\:text-sm .leading-3.capsize::before,.lg\\:text-sm .font-serif.leading-3.capsize::before,.lg\\:text-sm .font-serif .leading-3.capsize::before {
    content: '';
    margin-bottom: -0.0486em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-3.capsize::after, .font-serif .lg\\:text-sm.leading-3.capsize::after, .font-serif .lg\\:text-sm .leading-3.capsize::after,.lg\\:text-sm .font-serif.leading-3.capsize::after,.lg\\:text-sm .font-serif .leading-3.capsize::after {
    content: '';
    margin-top: -0.0286em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-4.capsize::before, .font-serif .lg\\:text-sm.leading-4.capsize::before, .font-serif .lg\\:text-sm .leading-4.capsize::before,.lg\\:text-sm .font-serif.leading-4.capsize::before,.lg\\:text-sm .font-serif .leading-4.capsize::before {
    content: '';
    margin-bottom: -0.1914em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-4.capsize::after, .font-serif .lg\\:text-sm.leading-4.capsize::after, .font-serif .lg\\:text-sm .leading-4.capsize::after,.lg\\:text-sm .font-serif.leading-4.capsize::after,.lg\\:text-sm .font-serif .leading-4.capsize::after {
    content: '';
    margin-top: -0.1714em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-5.capsize::before, .font-serif .lg\\:text-sm.leading-5.capsize::before, .font-serif .lg\\:text-sm .leading-5.capsize::before,.lg\\:text-sm .font-serif.leading-5.capsize::before,.lg\\:text-sm .font-serif .leading-5.capsize::before {
    content: '';
    margin-bottom: -0.3343em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-5.capsize::after, .font-serif .lg\\:text-sm.leading-5.capsize::after, .font-serif .lg\\:text-sm .leading-5.capsize::after,.lg\\:text-sm .font-serif.leading-5.capsize::after,.lg\\:text-sm .font-serif .leading-5.capsize::after {
    content: '';
    margin-top: -0.3143em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-6.capsize::before, .font-serif .lg\\:text-sm.leading-6.capsize::before, .font-serif .lg\\:text-sm .leading-6.capsize::before,.lg\\:text-sm .font-serif.leading-6.capsize::before,.lg\\:text-sm .font-serif .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.4771em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-6.capsize::after, .font-serif .lg\\:text-sm.leading-6.capsize::after, .font-serif .lg\\:text-sm .leading-6.capsize::after,.lg\\:text-sm .font-serif.leading-6.capsize::after,.lg\\:text-sm .font-serif .leading-6.capsize::after {
    content: '';
    margin-top: -0.4571em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-7.capsize::before, .font-serif .lg\\:text-sm.leading-7.capsize::before, .font-serif .lg\\:text-sm .leading-7.capsize::before,.lg\\:text-sm .font-serif.leading-7.capsize::before,.lg\\:text-sm .font-serif .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-7.capsize::after, .font-serif .lg\\:text-sm.leading-7.capsize::after, .font-serif .lg\\:text-sm .leading-7.capsize::after,.lg\\:text-sm .font-serif.leading-7.capsize::after,.lg\\:text-sm .font-serif .leading-7.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-8.capsize::before, .font-serif .lg\\:text-sm.leading-8.capsize::before, .font-serif .lg\\:text-sm .leading-8.capsize::before,.lg\\:text-sm .font-serif.leading-8.capsize::before,.lg\\:text-sm .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.7629em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-8.capsize::after, .font-serif .lg\\:text-sm.leading-8.capsize::after, .font-serif .lg\\:text-sm .leading-8.capsize::after,.lg\\:text-sm .font-serif.leading-8.capsize::after,.lg\\:text-sm .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.7429em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-9.capsize::before, .font-serif .lg\\:text-sm.leading-9.capsize::before, .font-serif .lg\\:text-sm .leading-9.capsize::before,.lg\\:text-sm .font-serif.leading-9.capsize::before,.lg\\:text-sm .font-serif .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.9057em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-9.capsize::after, .font-serif .lg\\:text-sm.leading-9.capsize::after, .font-serif .lg\\:text-sm .leading-9.capsize::after,.lg\\:text-sm .font-serif.leading-9.capsize::after,.lg\\:text-sm .font-serif .leading-9.capsize::after {
    content: '';
    margin-top: -0.8857em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-10.capsize::before, .font-serif .lg\\:text-sm.leading-10.capsize::before, .font-serif .lg\\:text-sm .leading-10.capsize::before,.lg\\:text-sm .font-serif.leading-10.capsize::before,.lg\\:text-sm .font-serif .leading-10.capsize::before {
    content: '';
    margin-bottom: -1.0486em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-10.capsize::after, .font-serif .lg\\:text-sm.leading-10.capsize::after, .font-serif .lg\\:text-sm .leading-10.capsize::after,.lg\\:text-sm .font-serif.leading-10.capsize::after,.lg\\:text-sm .font-serif .leading-10.capsize::after {
    content: '';
    margin-top: -1.0286em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-none.capsize::before, .font-serif .lg\\:text-sm.leading-none.capsize::before, .font-serif .lg\\:text-sm .leading-none.capsize::before,.lg\\:text-sm .font-serif.leading-none.capsize::before,.lg\\:text-sm .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-none.capsize::after, .font-serif .lg\\:text-sm.leading-none.capsize::after, .font-serif .lg\\:text-sm .leading-none.capsize::after,.lg\\:text-sm .font-serif.leading-none.capsize::after,.lg\\:text-sm .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-tight.capsize::before, .font-serif .lg\\:text-sm.leading-tight.capsize::before, .font-serif .lg\\:text-sm .leading-tight.capsize::before,.lg\\:text-sm .font-serif.leading-tight.capsize::before,.lg\\:text-sm .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-tight.capsize::after, .font-serif .lg\\:text-sm.leading-tight.capsize::after, .font-serif .lg\\:text-sm .leading-tight.capsize::after,.lg\\:text-sm .font-serif.leading-tight.capsize::after,.lg\\:text-sm .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-snug.capsize::before, .font-serif .lg\\:text-sm.leading-snug.capsize::before, .font-serif .lg\\:text-sm .leading-snug.capsize::before,.lg\\:text-sm .font-serif.leading-snug.capsize::before,.lg\\:text-sm .font-serif .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3075em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-snug.capsize::after, .font-serif .lg\\:text-sm.leading-snug.capsize::after, .font-serif .lg\\:text-sm .leading-snug.capsize::after,.lg\\:text-sm .font-serif.leading-snug.capsize::after,.lg\\:text-sm .font-serif .leading-snug.capsize::after {
    content: '';
    margin-top: -0.2875em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-normal.capsize::before, .font-serif .lg\\:text-sm.leading-normal.capsize::before, .font-serif .lg\\:text-sm .leading-normal.capsize::before,.lg\\:text-sm .font-serif.leading-normal.capsize::before,.lg\\:text-sm .font-serif .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-normal.capsize::after, .font-serif .lg\\:text-sm.leading-normal.capsize::after, .font-serif .lg\\:text-sm .leading-normal.capsize::after,.lg\\:text-sm .font-serif.leading-normal.capsize::after,.lg\\:text-sm .font-serif .leading-normal.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-relaxed.capsize::before, .font-serif .lg\\:text-sm.leading-relaxed.capsize::before, .font-serif .lg\\:text-sm .leading-relaxed.capsize::before,.lg\\:text-sm .font-serif.leading-relaxed.capsize::before,.lg\\:text-sm .font-serif .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4325em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-relaxed.capsize::after, .font-serif .lg\\:text-sm.leading-relaxed.capsize::after, .font-serif .lg\\:text-sm .leading-relaxed.capsize::after,.lg\\:text-sm .font-serif.leading-relaxed.capsize::after,.lg\\:text-sm .font-serif .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4125em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-loose.capsize::before, .font-serif .lg\\:text-sm.leading-loose.capsize::before, .font-serif .lg\\:text-sm .leading-loose.capsize::before,.lg\\:text-sm .font-serif.leading-loose.capsize::before,.lg\\:text-sm .font-serif .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .lg\\:text-sm.font-serif.leading-loose.capsize::after, .font-serif .lg\\:text-sm.leading-loose.capsize::after, .font-serif .lg\\:text-sm .leading-loose.capsize::after,.lg\\:text-sm .font-serif.leading-loose.capsize::after,.lg\\:text-sm .font-serif .leading-loose.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-3.capsize::before, .font-serif .lg\\:text-base.leading-3.capsize::before, .font-serif .lg\\:text-base .leading-3.capsize::before,.lg\\:text-base .font-serif.leading-3.capsize::before,.lg\\:text-base .font-serif .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.005em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-3.capsize::after, .font-serif .lg\\:text-base.leading-3.capsize::after, .font-serif .lg\\:text-base .leading-3.capsize::after,.lg\\:text-base .font-serif.leading-3.capsize::after,.lg\\:text-base .font-serif .leading-3.capsize::after {
    content: '';
    margin-top: 0.025em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-4.capsize::before, .font-serif .lg\\:text-base.leading-4.capsize::before, .font-serif .lg\\:text-base .leading-4.capsize::before,.lg\\:text-base .font-serif.leading-4.capsize::before,.lg\\:text-base .font-serif .leading-4.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-4.capsize::after, .font-serif .lg\\:text-base.leading-4.capsize::after, .font-serif .lg\\:text-base .leading-4.capsize::after,.lg\\:text-base .font-serif.leading-4.capsize::after,.lg\\:text-base .font-serif .leading-4.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-5.capsize::before, .font-serif .lg\\:text-base.leading-5.capsize::before, .font-serif .lg\\:text-base .leading-5.capsize::before,.lg\\:text-base .font-serif.leading-5.capsize::before,.lg\\:text-base .font-serif .leading-5.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-5.capsize::after, .font-serif .lg\\:text-base.leading-5.capsize::after, .font-serif .lg\\:text-base .leading-5.capsize::after,.lg\\:text-base .font-serif.leading-5.capsize::after,.lg\\:text-base .font-serif .leading-5.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-6.capsize::before, .font-serif .lg\\:text-base.leading-6.capsize::before, .font-serif .lg\\:text-base .leading-6.capsize::before,.lg\\:text-base .font-serif.leading-6.capsize::before,.lg\\:text-base .font-serif .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-6.capsize::after, .font-serif .lg\\:text-base.leading-6.capsize::after, .font-serif .lg\\:text-base .leading-6.capsize::after,.lg\\:text-base .font-serif.leading-6.capsize::after,.lg\\:text-base .font-serif .leading-6.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-7.capsize::before, .font-serif .lg\\:text-base.leading-7.capsize::before, .font-serif .lg\\:text-base .leading-7.capsize::before,.lg\\:text-base .font-serif.leading-7.capsize::before,.lg\\:text-base .font-serif .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.495em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-7.capsize::after, .font-serif .lg\\:text-base.leading-7.capsize::after, .font-serif .lg\\:text-base .leading-7.capsize::after,.lg\\:text-base .font-serif.leading-7.capsize::after,.lg\\:text-base .font-serif .leading-7.capsize::after {
    content: '';
    margin-top: -0.475em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-8.capsize::before, .font-serif .lg\\:text-base.leading-8.capsize::before, .font-serif .lg\\:text-base .leading-8.capsize::before,.lg\\:text-base .font-serif.leading-8.capsize::before,.lg\\:text-base .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-8.capsize::after, .font-serif .lg\\:text-base.leading-8.capsize::after, .font-serif .lg\\:text-base .leading-8.capsize::after,.lg\\:text-base .font-serif.leading-8.capsize::after,.lg\\:text-base .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-9.capsize::before, .font-serif .lg\\:text-base.leading-9.capsize::before, .font-serif .lg\\:text-base .leading-9.capsize::before,.lg\\:text-base .font-serif.leading-9.capsize::before,.lg\\:text-base .font-serif .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.745em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-9.capsize::after, .font-serif .lg\\:text-base.leading-9.capsize::after, .font-serif .lg\\:text-base .leading-9.capsize::after,.lg\\:text-base .font-serif.leading-9.capsize::after,.lg\\:text-base .font-serif .leading-9.capsize::after {
    content: '';
    margin-top: -0.725em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-10.capsize::before, .font-serif .lg\\:text-base.leading-10.capsize::before, .font-serif .lg\\:text-base .leading-10.capsize::before,.lg\\:text-base .font-serif.leading-10.capsize::before,.lg\\:text-base .font-serif .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.87em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-10.capsize::after, .font-serif .lg\\:text-base.leading-10.capsize::after, .font-serif .lg\\:text-base .leading-10.capsize::after,.lg\\:text-base .font-serif.leading-10.capsize::after,.lg\\:text-base .font-serif .leading-10.capsize::after {
    content: '';
    margin-top: -0.85em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-none.capsize::before, .font-serif .lg\\:text-base.leading-none.capsize::before, .font-serif .lg\\:text-base .leading-none.capsize::before,.lg\\:text-base .font-serif.leading-none.capsize::before,.lg\\:text-base .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-none.capsize::after, .font-serif .lg\\:text-base.leading-none.capsize::after, .font-serif .lg\\:text-base .leading-none.capsize::after,.lg\\:text-base .font-serif.leading-none.capsize::after,.lg\\:text-base .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-tight.capsize::before, .font-serif .lg\\:text-base.leading-tight.capsize::before, .font-serif .lg\\:text-base .leading-tight.capsize::before,.lg\\:text-base .font-serif.leading-tight.capsize::before,.lg\\:text-base .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-tight.capsize::after, .font-serif .lg\\:text-base.leading-tight.capsize::after, .font-serif .lg\\:text-base .leading-tight.capsize::after,.lg\\:text-base .font-serif.leading-tight.capsize::after,.lg\\:text-base .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-snug.capsize::before, .font-serif .lg\\:text-base.leading-snug.capsize::before, .font-serif .lg\\:text-base .leading-snug.capsize::before,.lg\\:text-base .font-serif.leading-snug.capsize::before,.lg\\:text-base .font-serif .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3075em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-snug.capsize::after, .font-serif .lg\\:text-base.leading-snug.capsize::after, .font-serif .lg\\:text-base .leading-snug.capsize::after,.lg\\:text-base .font-serif.leading-snug.capsize::after,.lg\\:text-base .font-serif .leading-snug.capsize::after {
    content: '';
    margin-top: -0.2875em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-normal.capsize::before, .font-serif .lg\\:text-base.leading-normal.capsize::before, .font-serif .lg\\:text-base .leading-normal.capsize::before,.lg\\:text-base .font-serif.leading-normal.capsize::before,.lg\\:text-base .font-serif .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-normal.capsize::after, .font-serif .lg\\:text-base.leading-normal.capsize::after, .font-serif .lg\\:text-base .leading-normal.capsize::after,.lg\\:text-base .font-serif.leading-normal.capsize::after,.lg\\:text-base .font-serif .leading-normal.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-relaxed.capsize::before, .font-serif .lg\\:text-base.leading-relaxed.capsize::before, .font-serif .lg\\:text-base .leading-relaxed.capsize::before,.lg\\:text-base .font-serif.leading-relaxed.capsize::before,.lg\\:text-base .font-serif .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4325em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-relaxed.capsize::after, .font-serif .lg\\:text-base.leading-relaxed.capsize::after, .font-serif .lg\\:text-base .leading-relaxed.capsize::after,.lg\\:text-base .font-serif.leading-relaxed.capsize::after,.lg\\:text-base .font-serif .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4125em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-loose.capsize::before, .font-serif .lg\\:text-base.leading-loose.capsize::before, .font-serif .lg\\:text-base .leading-loose.capsize::before,.lg\\:text-base .font-serif.leading-loose.capsize::before,.lg\\:text-base .font-serif .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .lg\\:text-base.font-serif.leading-loose.capsize::after, .font-serif .lg\\:text-base.leading-loose.capsize::after, .font-serif .lg\\:text-base .leading-loose.capsize::after,.lg\\:text-base .font-serif.leading-loose.capsize::after,.lg\\:text-base .font-serif .leading-loose.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-3.capsize::before, .font-serif .lg\\:text-2xl.leading-3.capsize::before, .font-serif .lg\\:text-2xl .leading-3.capsize::before,.lg\\:text-2xl .font-serif.leading-3.capsize::before,.lg\\:text-2xl .font-serif .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.13em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-3.capsize::after, .font-serif .lg\\:text-2xl.leading-3.capsize::after, .font-serif .lg\\:text-2xl .leading-3.capsize::after,.lg\\:text-2xl .font-serif.leading-3.capsize::after,.lg\\:text-2xl .font-serif .leading-3.capsize::after {
    content: '';
    margin-top: 0.15em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-4.capsize::before, .font-serif .lg\\:text-2xl.leading-4.capsize::before, .font-serif .lg\\:text-2xl .leading-4.capsize::before,.lg\\:text-2xl .font-serif.leading-4.capsize::before,.lg\\:text-2xl .font-serif .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.0467em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-4.capsize::after, .font-serif .lg\\:text-2xl.leading-4.capsize::after, .font-serif .lg\\:text-2xl .leading-4.capsize::after,.lg\\:text-2xl .font-serif.leading-4.capsize::after,.lg\\:text-2xl .font-serif .leading-4.capsize::after {
    content: '';
    margin-top: 0.0667em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-5.capsize::before, .font-serif .lg\\:text-2xl.leading-5.capsize::before, .font-serif .lg\\:text-2xl .leading-5.capsize::before,.lg\\:text-2xl .font-serif.leading-5.capsize::before,.lg\\:text-2xl .font-serif .leading-5.capsize::before {
    content: '';
    margin-bottom: -0.0367em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-5.capsize::after, .font-serif .lg\\:text-2xl.leading-5.capsize::after, .font-serif .lg\\:text-2xl .leading-5.capsize::after,.lg\\:text-2xl .font-serif.leading-5.capsize::after,.lg\\:text-2xl .font-serif .leading-5.capsize::after {
    content: '';
    margin-top: -0.0167em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-6.capsize::before, .font-serif .lg\\:text-2xl.leading-6.capsize::before, .font-serif .lg\\:text-2xl .leading-6.capsize::before,.lg\\:text-2xl .font-serif.leading-6.capsize::before,.lg\\:text-2xl .font-serif .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-6.capsize::after, .font-serif .lg\\:text-2xl.leading-6.capsize::after, .font-serif .lg\\:text-2xl .leading-6.capsize::after,.lg\\:text-2xl .font-serif.leading-6.capsize::after,.lg\\:text-2xl .font-serif .leading-6.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-7.capsize::before, .font-serif .lg\\:text-2xl.leading-7.capsize::before, .font-serif .lg\\:text-2xl .leading-7.capsize::before,.lg\\:text-2xl .font-serif.leading-7.capsize::before,.lg\\:text-2xl .font-serif .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.2033em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-7.capsize::after, .font-serif .lg\\:text-2xl.leading-7.capsize::after, .font-serif .lg\\:text-2xl .leading-7.capsize::after,.lg\\:text-2xl .font-serif.leading-7.capsize::after,.lg\\:text-2xl .font-serif .leading-7.capsize::after {
    content: '';
    margin-top: -0.1833em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-8.capsize::before, .font-serif .lg\\:text-2xl.leading-8.capsize::before, .font-serif .lg\\:text-2xl .leading-8.capsize::before,.lg\\:text-2xl .font-serif.leading-8.capsize::before,.lg\\:text-2xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.2867em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-8.capsize::after, .font-serif .lg\\:text-2xl.leading-8.capsize::after, .font-serif .lg\\:text-2xl .leading-8.capsize::after,.lg\\:text-2xl .font-serif.leading-8.capsize::after,.lg\\:text-2xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.2667em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-9.capsize::before, .font-serif .lg\\:text-2xl.leading-9.capsize::before, .font-serif .lg\\:text-2xl .leading-9.capsize::before,.lg\\:text-2xl .font-serif.leading-9.capsize::before,.lg\\:text-2xl .font-serif .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-9.capsize::after, .font-serif .lg\\:text-2xl.leading-9.capsize::after, .font-serif .lg\\:text-2xl .leading-9.capsize::after,.lg\\:text-2xl .font-serif.leading-9.capsize::after,.lg\\:text-2xl .font-serif .leading-9.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-10.capsize::before, .font-serif .lg\\:text-2xl.leading-10.capsize::before, .font-serif .lg\\:text-2xl .leading-10.capsize::before,.lg\\:text-2xl .font-serif.leading-10.capsize::before,.lg\\:text-2xl .font-serif .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.4533em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-10.capsize::after, .font-serif .lg\\:text-2xl.leading-10.capsize::after, .font-serif .lg\\:text-2xl .leading-10.capsize::after,.lg\\:text-2xl .font-serif.leading-10.capsize::after,.lg\\:text-2xl .font-serif .leading-10.capsize::after {
    content: '';
    margin-top: -0.4333em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-none.capsize::before, .font-serif .lg\\:text-2xl.leading-none.capsize::before, .font-serif .lg\\:text-2xl .leading-none.capsize::before,.lg\\:text-2xl .font-serif.leading-none.capsize::before,.lg\\:text-2xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-none.capsize::after, .font-serif .lg\\:text-2xl.leading-none.capsize::after, .font-serif .lg\\:text-2xl .leading-none.capsize::after,.lg\\:text-2xl .font-serif.leading-none.capsize::after,.lg\\:text-2xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-tight.capsize::before, .font-serif .lg\\:text-2xl.leading-tight.capsize::before, .font-serif .lg\\:text-2xl .leading-tight.capsize::before,.lg\\:text-2xl .font-serif.leading-tight.capsize::before,.lg\\:text-2xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-tight.capsize::after, .font-serif .lg\\:text-2xl.leading-tight.capsize::after, .font-serif .lg\\:text-2xl .leading-tight.capsize::after,.lg\\:text-2xl .font-serif.leading-tight.capsize::after,.lg\\:text-2xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-snug.capsize::before, .font-serif .lg\\:text-2xl.leading-snug.capsize::before, .font-serif .lg\\:text-2xl .leading-snug.capsize::before,.lg\\:text-2xl .font-serif.leading-snug.capsize::before,.lg\\:text-2xl .font-serif .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3075em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-snug.capsize::after, .font-serif .lg\\:text-2xl.leading-snug.capsize::after, .font-serif .lg\\:text-2xl .leading-snug.capsize::after,.lg\\:text-2xl .font-serif.leading-snug.capsize::after,.lg\\:text-2xl .font-serif .leading-snug.capsize::after {
    content: '';
    margin-top: -0.2875em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-normal.capsize::before, .font-serif .lg\\:text-2xl.leading-normal.capsize::before, .font-serif .lg\\:text-2xl .leading-normal.capsize::before,.lg\\:text-2xl .font-serif.leading-normal.capsize::before,.lg\\:text-2xl .font-serif .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-normal.capsize::after, .font-serif .lg\\:text-2xl.leading-normal.capsize::after, .font-serif .lg\\:text-2xl .leading-normal.capsize::after,.lg\\:text-2xl .font-serif.leading-normal.capsize::after,.lg\\:text-2xl .font-serif .leading-normal.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-relaxed.capsize::before, .font-serif .lg\\:text-2xl.leading-relaxed.capsize::before, .font-serif .lg\\:text-2xl .leading-relaxed.capsize::before,.lg\\:text-2xl .font-serif.leading-relaxed.capsize::before,.lg\\:text-2xl .font-serif .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4325em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-relaxed.capsize::after, .font-serif .lg\\:text-2xl.leading-relaxed.capsize::after, .font-serif .lg\\:text-2xl .leading-relaxed.capsize::after,.lg\\:text-2xl .font-serif.leading-relaxed.capsize::after,.lg\\:text-2xl .font-serif .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4125em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-loose.capsize::before, .font-serif .lg\\:text-2xl.leading-loose.capsize::before, .font-serif .lg\\:text-2xl .leading-loose.capsize::before,.lg\\:text-2xl .font-serif.leading-loose.capsize::before,.lg\\:text-2xl .font-serif .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .lg\\:text-2xl.font-serif.leading-loose.capsize::after, .font-serif .lg\\:text-2xl.leading-loose.capsize::after, .font-serif .lg\\:text-2xl .leading-loose.capsize::after,.lg\\:text-2xl .font-serif.leading-loose.capsize::after,.lg\\:text-2xl .font-serif .leading-loose.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-3.capsize::before, .font-serif .lg\\:text-3xl.leading-3.capsize::before, .font-serif .lg\\:text-3xl .leading-3.capsize::before,.lg\\:text-3xl .font-serif.leading-3.capsize::before,.lg\\:text-3xl .font-serif .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.18em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-3.capsize::after, .font-serif .lg\\:text-3xl.leading-3.capsize::after, .font-serif .lg\\:text-3xl .leading-3.capsize::after,.lg\\:text-3xl .font-serif.leading-3.capsize::after,.lg\\:text-3xl .font-serif .leading-3.capsize::after {
    content: '';
    margin-top: 0.2em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-4.capsize::before, .font-serif .lg\\:text-3xl.leading-4.capsize::before, .font-serif .lg\\:text-3xl .leading-4.capsize::before,.lg\\:text-3xl .font-serif.leading-4.capsize::before,.lg\\:text-3xl .font-serif .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.1133em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-4.capsize::after, .font-serif .lg\\:text-3xl.leading-4.capsize::after, .font-serif .lg\\:text-3xl .leading-4.capsize::after,.lg\\:text-3xl .font-serif.leading-4.capsize::after,.lg\\:text-3xl .font-serif .leading-4.capsize::after {
    content: '';
    margin-top: 0.1333em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-5.capsize::before, .font-serif .lg\\:text-3xl.leading-5.capsize::before, .font-serif .lg\\:text-3xl .leading-5.capsize::before,.lg\\:text-3xl .font-serif.leading-5.capsize::before,.lg\\:text-3xl .font-serif .leading-5.capsize::before {
    content: '';
    margin-bottom: 0.0467em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-5.capsize::after, .font-serif .lg\\:text-3xl.leading-5.capsize::after, .font-serif .lg\\:text-3xl .leading-5.capsize::after,.lg\\:text-3xl .font-serif.leading-5.capsize::after,.lg\\:text-3xl .font-serif .leading-5.capsize::after {
    content: '';
    margin-top: 0.0667em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-6.capsize::before, .font-serif .lg\\:text-3xl.leading-6.capsize::before, .font-serif .lg\\:text-3xl .leading-6.capsize::before,.lg\\:text-3xl .font-serif.leading-6.capsize::before,.lg\\:text-3xl .font-serif .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.02em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-6.capsize::after, .font-serif .lg\\:text-3xl.leading-6.capsize::after, .font-serif .lg\\:text-3xl .leading-6.capsize::after,.lg\\:text-3xl .font-serif.leading-6.capsize::after,.lg\\:text-3xl .font-serif .leading-6.capsize::after {
    content: '';
    margin-top: 0em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-7.capsize::before, .font-serif .lg\\:text-3xl.leading-7.capsize::before, .font-serif .lg\\:text-3xl .leading-7.capsize::before,.lg\\:text-3xl .font-serif.leading-7.capsize::before,.lg\\:text-3xl .font-serif .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.0867em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-7.capsize::after, .font-serif .lg\\:text-3xl.leading-7.capsize::after, .font-serif .lg\\:text-3xl .leading-7.capsize::after,.lg\\:text-3xl .font-serif.leading-7.capsize::after,.lg\\:text-3xl .font-serif .leading-7.capsize::after {
    content: '';
    margin-top: -0.0667em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-8.capsize::before, .font-serif .lg\\:text-3xl.leading-8.capsize::before, .font-serif .lg\\:text-3xl .leading-8.capsize::before,.lg\\:text-3xl .font-serif.leading-8.capsize::before,.lg\\:text-3xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1533em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-8.capsize::after, .font-serif .lg\\:text-3xl.leading-8.capsize::after, .font-serif .lg\\:text-3xl .leading-8.capsize::after,.lg\\:text-3xl .font-serif.leading-8.capsize::after,.lg\\:text-3xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.1333em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-9.capsize::before, .font-serif .lg\\:text-3xl.leading-9.capsize::before, .font-serif .lg\\:text-3xl .leading-9.capsize::before,.lg\\:text-3xl .font-serif.leading-9.capsize::before,.lg\\:text-3xl .font-serif .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.22em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-9.capsize::after, .font-serif .lg\\:text-3xl.leading-9.capsize::after, .font-serif .lg\\:text-3xl .leading-9.capsize::after,.lg\\:text-3xl .font-serif.leading-9.capsize::after,.lg\\:text-3xl .font-serif .leading-9.capsize::after {
    content: '';
    margin-top: -0.2em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-10.capsize::before, .font-serif .lg\\:text-3xl.leading-10.capsize::before, .font-serif .lg\\:text-3xl .leading-10.capsize::before,.lg\\:text-3xl .font-serif.leading-10.capsize::before,.lg\\:text-3xl .font-serif .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.2867em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-10.capsize::after, .font-serif .lg\\:text-3xl.leading-10.capsize::after, .font-serif .lg\\:text-3xl .leading-10.capsize::after,.lg\\:text-3xl .font-serif.leading-10.capsize::after,.lg\\:text-3xl .font-serif .leading-10.capsize::after {
    content: '';
    margin-top: -0.2667em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-none.capsize::before, .font-serif .lg\\:text-3xl.leading-none.capsize::before, .font-serif .lg\\:text-3xl .leading-none.capsize::before,.lg\\:text-3xl .font-serif.leading-none.capsize::before,.lg\\:text-3xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-none.capsize::after, .font-serif .lg\\:text-3xl.leading-none.capsize::after, .font-serif .lg\\:text-3xl .leading-none.capsize::after,.lg\\:text-3xl .font-serif.leading-none.capsize::after,.lg\\:text-3xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-tight.capsize::before, .font-serif .lg\\:text-3xl.leading-tight.capsize::before, .font-serif .lg\\:text-3xl .leading-tight.capsize::before,.lg\\:text-3xl .font-serif.leading-tight.capsize::before,.lg\\:text-3xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-tight.capsize::after, .font-serif .lg\\:text-3xl.leading-tight.capsize::after, .font-serif .lg\\:text-3xl .leading-tight.capsize::after,.lg\\:text-3xl .font-serif.leading-tight.capsize::after,.lg\\:text-3xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-snug.capsize::before, .font-serif .lg\\:text-3xl.leading-snug.capsize::before, .font-serif .lg\\:text-3xl .leading-snug.capsize::before,.lg\\:text-3xl .font-serif.leading-snug.capsize::before,.lg\\:text-3xl .font-serif .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3075em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-snug.capsize::after, .font-serif .lg\\:text-3xl.leading-snug.capsize::after, .font-serif .lg\\:text-3xl .leading-snug.capsize::after,.lg\\:text-3xl .font-serif.leading-snug.capsize::after,.lg\\:text-3xl .font-serif .leading-snug.capsize::after {
    content: '';
    margin-top: -0.2875em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-normal.capsize::before, .font-serif .lg\\:text-3xl.leading-normal.capsize::before, .font-serif .lg\\:text-3xl .leading-normal.capsize::before,.lg\\:text-3xl .font-serif.leading-normal.capsize::before,.lg\\:text-3xl .font-serif .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-normal.capsize::after, .font-serif .lg\\:text-3xl.leading-normal.capsize::after, .font-serif .lg\\:text-3xl .leading-normal.capsize::after,.lg\\:text-3xl .font-serif.leading-normal.capsize::after,.lg\\:text-3xl .font-serif .leading-normal.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-relaxed.capsize::before, .font-serif .lg\\:text-3xl.leading-relaxed.capsize::before, .font-serif .lg\\:text-3xl .leading-relaxed.capsize::before,.lg\\:text-3xl .font-serif.leading-relaxed.capsize::before,.lg\\:text-3xl .font-serif .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4325em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-relaxed.capsize::after, .font-serif .lg\\:text-3xl.leading-relaxed.capsize::after, .font-serif .lg\\:text-3xl .leading-relaxed.capsize::after,.lg\\:text-3xl .font-serif.leading-relaxed.capsize::after,.lg\\:text-3xl .font-serif .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4125em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-loose.capsize::before, .font-serif .lg\\:text-3xl.leading-loose.capsize::before, .font-serif .lg\\:text-3xl .leading-loose.capsize::before,.lg\\:text-3xl .font-serif.leading-loose.capsize::before,.lg\\:text-3xl .font-serif .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .lg\\:text-3xl.font-serif.leading-loose.capsize::after, .font-serif .lg\\:text-3xl.leading-loose.capsize::after, .font-serif .lg\\:text-3xl .leading-loose.capsize::after,.lg\\:text-3xl .font-serif.leading-loose.capsize::after,.lg\\:text-3xl .font-serif .leading-loose.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-3.capsize::before, .font-serif .lg\\:text-5xl.leading-3.capsize::before, .font-serif .lg\\:text-5xl .leading-3.capsize::before,.lg\\:text-5xl .font-serif.leading-3.capsize::before,.lg\\:text-5xl .font-serif .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.255em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-3.capsize::after, .font-serif .lg\\:text-5xl.leading-3.capsize::after, .font-serif .lg\\:text-5xl .leading-3.capsize::after,.lg\\:text-5xl .font-serif.leading-3.capsize::after,.lg\\:text-5xl .font-serif .leading-3.capsize::after {
    content: '';
    margin-top: 0.275em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-4.capsize::before, .font-serif .lg\\:text-5xl.leading-4.capsize::before, .font-serif .lg\\:text-5xl .leading-4.capsize::before,.lg\\:text-5xl .font-serif.leading-4.capsize::before,.lg\\:text-5xl .font-serif .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.2133em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-4.capsize::after, .font-serif .lg\\:text-5xl.leading-4.capsize::after, .font-serif .lg\\:text-5xl .leading-4.capsize::after,.lg\\:text-5xl .font-serif.leading-4.capsize::after,.lg\\:text-5xl .font-serif .leading-4.capsize::after {
    content: '';
    margin-top: 0.2333em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-5.capsize::before, .font-serif .lg\\:text-5xl.leading-5.capsize::before, .font-serif .lg\\:text-5xl .leading-5.capsize::before,.lg\\:text-5xl .font-serif.leading-5.capsize::before,.lg\\:text-5xl .font-serif .leading-5.capsize::before {
    content: '';
    margin-bottom: 0.1717em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-5.capsize::after, .font-serif .lg\\:text-5xl.leading-5.capsize::after, .font-serif .lg\\:text-5xl .leading-5.capsize::after,.lg\\:text-5xl .font-serif.leading-5.capsize::after,.lg\\:text-5xl .font-serif .leading-5.capsize::after {
    content: '';
    margin-top: 0.1917em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-6.capsize::before, .font-serif .lg\\:text-5xl.leading-6.capsize::before, .font-serif .lg\\:text-5xl .leading-6.capsize::before,.lg\\:text-5xl .font-serif.leading-6.capsize::before,.lg\\:text-5xl .font-serif .leading-6.capsize::before {
    content: '';
    margin-bottom: 0.13em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-6.capsize::after, .font-serif .lg\\:text-5xl.leading-6.capsize::after, .font-serif .lg\\:text-5xl .leading-6.capsize::after,.lg\\:text-5xl .font-serif.leading-6.capsize::after,.lg\\:text-5xl .font-serif .leading-6.capsize::after {
    content: '';
    margin-top: 0.15em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-7.capsize::before, .font-serif .lg\\:text-5xl.leading-7.capsize::before, .font-serif .lg\\:text-5xl .leading-7.capsize::before,.lg\\:text-5xl .font-serif.leading-7.capsize::before,.lg\\:text-5xl .font-serif .leading-7.capsize::before {
    content: '';
    margin-bottom: 0.0883em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-7.capsize::after, .font-serif .lg\\:text-5xl.leading-7.capsize::after, .font-serif .lg\\:text-5xl .leading-7.capsize::after,.lg\\:text-5xl .font-serif.leading-7.capsize::after,.lg\\:text-5xl .font-serif .leading-7.capsize::after {
    content: '';
    margin-top: 0.1083em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-8.capsize::before, .font-serif .lg\\:text-5xl.leading-8.capsize::before, .font-serif .lg\\:text-5xl .leading-8.capsize::before,.lg\\:text-5xl .font-serif.leading-8.capsize::before,.lg\\:text-5xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.0467em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-8.capsize::after, .font-serif .lg\\:text-5xl.leading-8.capsize::after, .font-serif .lg\\:text-5xl .leading-8.capsize::after,.lg\\:text-5xl .font-serif.leading-8.capsize::after,.lg\\:text-5xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: 0.0667em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-9.capsize::before, .font-serif .lg\\:text-5xl.leading-9.capsize::before, .font-serif .lg\\:text-5xl .leading-9.capsize::before,.lg\\:text-5xl .font-serif.leading-9.capsize::before,.lg\\:text-5xl .font-serif .leading-9.capsize::before {
    content: '';
    margin-bottom: 0.005em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-9.capsize::after, .font-serif .lg\\:text-5xl.leading-9.capsize::after, .font-serif .lg\\:text-5xl .leading-9.capsize::after,.lg\\:text-5xl .font-serif.leading-9.capsize::after,.lg\\:text-5xl .font-serif .leading-9.capsize::after {
    content: '';
    margin-top: 0.025em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-10.capsize::before, .font-serif .lg\\:text-5xl.leading-10.capsize::before, .font-serif .lg\\:text-5xl .leading-10.capsize::before,.lg\\:text-5xl .font-serif.leading-10.capsize::before,.lg\\:text-5xl .font-serif .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.0367em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-10.capsize::after, .font-serif .lg\\:text-5xl.leading-10.capsize::after, .font-serif .lg\\:text-5xl .leading-10.capsize::after,.lg\\:text-5xl .font-serif.leading-10.capsize::after,.lg\\:text-5xl .font-serif .leading-10.capsize::after {
    content: '';
    margin-top: -0.0167em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-none.capsize::before, .font-serif .lg\\:text-5xl.leading-none.capsize::before, .font-serif .lg\\:text-5xl .leading-none.capsize::before,.lg\\:text-5xl .font-serif.leading-none.capsize::before,.lg\\:text-5xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-none.capsize::after, .font-serif .lg\\:text-5xl.leading-none.capsize::after, .font-serif .lg\\:text-5xl .leading-none.capsize::after,.lg\\:text-5xl .font-serif.leading-none.capsize::after,.lg\\:text-5xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-tight.capsize::before, .font-serif .lg\\:text-5xl.leading-tight.capsize::before, .font-serif .lg\\:text-5xl .leading-tight.capsize::before,.lg\\:text-5xl .font-serif.leading-tight.capsize::before,.lg\\:text-5xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-tight.capsize::after, .font-serif .lg\\:text-5xl.leading-tight.capsize::after, .font-serif .lg\\:text-5xl .leading-tight.capsize::after,.lg\\:text-5xl .font-serif.leading-tight.capsize::after,.lg\\:text-5xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-snug.capsize::before, .font-serif .lg\\:text-5xl.leading-snug.capsize::before, .font-serif .lg\\:text-5xl .leading-snug.capsize::before,.lg\\:text-5xl .font-serif.leading-snug.capsize::before,.lg\\:text-5xl .font-serif .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3075em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-snug.capsize::after, .font-serif .lg\\:text-5xl.leading-snug.capsize::after, .font-serif .lg\\:text-5xl .leading-snug.capsize::after,.lg\\:text-5xl .font-serif.leading-snug.capsize::after,.lg\\:text-5xl .font-serif .leading-snug.capsize::after {
    content: '';
    margin-top: -0.2875em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-normal.capsize::before, .font-serif .lg\\:text-5xl.leading-normal.capsize::before, .font-serif .lg\\:text-5xl .leading-normal.capsize::before,.lg\\:text-5xl .font-serif.leading-normal.capsize::before,.lg\\:text-5xl .font-serif .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-normal.capsize::after, .font-serif .lg\\:text-5xl.leading-normal.capsize::after, .font-serif .lg\\:text-5xl .leading-normal.capsize::after,.lg\\:text-5xl .font-serif.leading-normal.capsize::after,.lg\\:text-5xl .font-serif .leading-normal.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-relaxed.capsize::before, .font-serif .lg\\:text-5xl.leading-relaxed.capsize::before, .font-serif .lg\\:text-5xl .leading-relaxed.capsize::before,.lg\\:text-5xl .font-serif.leading-relaxed.capsize::before,.lg\\:text-5xl .font-serif .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4325em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-relaxed.capsize::after, .font-serif .lg\\:text-5xl.leading-relaxed.capsize::after, .font-serif .lg\\:text-5xl .leading-relaxed.capsize::after,.lg\\:text-5xl .font-serif.leading-relaxed.capsize::after,.lg\\:text-5xl .font-serif .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4125em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-loose.capsize::before, .font-serif .lg\\:text-5xl.leading-loose.capsize::before, .font-serif .lg\\:text-5xl .leading-loose.capsize::before,.lg\\:text-5xl .font-serif.leading-loose.capsize::before,.lg\\:text-5xl .font-serif .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .lg\\:text-5xl.font-serif.leading-loose.capsize::after, .font-serif .lg\\:text-5xl.leading-loose.capsize::after, .font-serif .lg\\:text-5xl .leading-loose.capsize::after,.lg\\:text-5xl .font-serif.leading-loose.capsize::after,.lg\\:text-5xl .font-serif .leading-loose.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-3.capsize::before, .font-serif .lg\\:text-7xl.leading-3.capsize::before, .font-serif .lg\\:text-7xl .leading-3.capsize::before,.lg\\:text-7xl .font-serif.leading-3.capsize::before,.lg\\:text-7xl .font-serif .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.2967em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-3.capsize::after, .font-serif .lg\\:text-7xl.leading-3.capsize::after, .font-serif .lg\\:text-7xl .leading-3.capsize::after,.lg\\:text-7xl .font-serif.leading-3.capsize::after,.lg\\:text-7xl .font-serif .leading-3.capsize::after {
    content: '';
    margin-top: 0.3167em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-4.capsize::before, .font-serif .lg\\:text-7xl.leading-4.capsize::before, .font-serif .lg\\:text-7xl .leading-4.capsize::before,.lg\\:text-7xl .font-serif.leading-4.capsize::before,.lg\\:text-7xl .font-serif .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.2689em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-4.capsize::after, .font-serif .lg\\:text-7xl.leading-4.capsize::after, .font-serif .lg\\:text-7xl .leading-4.capsize::after,.lg\\:text-7xl .font-serif.leading-4.capsize::after,.lg\\:text-7xl .font-serif .leading-4.capsize::after {
    content: '';
    margin-top: 0.2889em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-5.capsize::before, .font-serif .lg\\:text-7xl.leading-5.capsize::before, .font-serif .lg\\:text-7xl .leading-5.capsize::before,.lg\\:text-7xl .font-serif.leading-5.capsize::before,.lg\\:text-7xl .font-serif .leading-5.capsize::before {
    content: '';
    margin-bottom: 0.2411em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-5.capsize::after, .font-serif .lg\\:text-7xl.leading-5.capsize::after, .font-serif .lg\\:text-7xl .leading-5.capsize::after,.lg\\:text-7xl .font-serif.leading-5.capsize::after,.lg\\:text-7xl .font-serif .leading-5.capsize::after {
    content: '';
    margin-top: 0.2611em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-6.capsize::before, .font-serif .lg\\:text-7xl.leading-6.capsize::before, .font-serif .lg\\:text-7xl .leading-6.capsize::before,.lg\\:text-7xl .font-serif.leading-6.capsize::before,.lg\\:text-7xl .font-serif .leading-6.capsize::before {
    content: '';
    margin-bottom: 0.2133em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-6.capsize::after, .font-serif .lg\\:text-7xl.leading-6.capsize::after, .font-serif .lg\\:text-7xl .leading-6.capsize::after,.lg\\:text-7xl .font-serif.leading-6.capsize::after,.lg\\:text-7xl .font-serif .leading-6.capsize::after {
    content: '';
    margin-top: 0.2333em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-7.capsize::before, .font-serif .lg\\:text-7xl.leading-7.capsize::before, .font-serif .lg\\:text-7xl .leading-7.capsize::before,.lg\\:text-7xl .font-serif.leading-7.capsize::before,.lg\\:text-7xl .font-serif .leading-7.capsize::before {
    content: '';
    margin-bottom: 0.1856em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-7.capsize::after, .font-serif .lg\\:text-7xl.leading-7.capsize::after, .font-serif .lg\\:text-7xl .leading-7.capsize::after,.lg\\:text-7xl .font-serif.leading-7.capsize::after,.lg\\:text-7xl .font-serif .leading-7.capsize::after {
    content: '';
    margin-top: 0.2056em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-8.capsize::before, .font-serif .lg\\:text-7xl.leading-8.capsize::before, .font-serif .lg\\:text-7xl .leading-8.capsize::before,.lg\\:text-7xl .font-serif.leading-8.capsize::before,.lg\\:text-7xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1578em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-8.capsize::after, .font-serif .lg\\:text-7xl.leading-8.capsize::after, .font-serif .lg\\:text-7xl .leading-8.capsize::after,.lg\\:text-7xl .font-serif.leading-8.capsize::after,.lg\\:text-7xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: 0.1778em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-9.capsize::before, .font-serif .lg\\:text-7xl.leading-9.capsize::before, .font-serif .lg\\:text-7xl .leading-9.capsize::before,.lg\\:text-7xl .font-serif.leading-9.capsize::before,.lg\\:text-7xl .font-serif .leading-9.capsize::before {
    content: '';
    margin-bottom: 0.13em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-9.capsize::after, .font-serif .lg\\:text-7xl.leading-9.capsize::after, .font-serif .lg\\:text-7xl .leading-9.capsize::after,.lg\\:text-7xl .font-serif.leading-9.capsize::after,.lg\\:text-7xl .font-serif .leading-9.capsize::after {
    content: '';
    margin-top: 0.15em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-10.capsize::before, .font-serif .lg\\:text-7xl.leading-10.capsize::before, .font-serif .lg\\:text-7xl .leading-10.capsize::before,.lg\\:text-7xl .font-serif.leading-10.capsize::before,.lg\\:text-7xl .font-serif .leading-10.capsize::before {
    content: '';
    margin-bottom: 0.1022em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-10.capsize::after, .font-serif .lg\\:text-7xl.leading-10.capsize::after, .font-serif .lg\\:text-7xl .leading-10.capsize::after,.lg\\:text-7xl .font-serif.leading-10.capsize::after,.lg\\:text-7xl .font-serif .leading-10.capsize::after {
    content: '';
    margin-top: 0.1222em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-none.capsize::before, .font-serif .lg\\:text-7xl.leading-none.capsize::before, .font-serif .lg\\:text-7xl .leading-none.capsize::before,.lg\\:text-7xl .font-serif.leading-none.capsize::before,.lg\\:text-7xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-none.capsize::after, .font-serif .lg\\:text-7xl.leading-none.capsize::after, .font-serif .lg\\:text-7xl .leading-none.capsize::after,.lg\\:text-7xl .font-serif.leading-none.capsize::after,.lg\\:text-7xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-tight.capsize::before, .font-serif .lg\\:text-7xl.leading-tight.capsize::before, .font-serif .lg\\:text-7xl .leading-tight.capsize::before,.lg\\:text-7xl .font-serif.leading-tight.capsize::before,.lg\\:text-7xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-tight.capsize::after, .font-serif .lg\\:text-7xl.leading-tight.capsize::after, .font-serif .lg\\:text-7xl .leading-tight.capsize::after,.lg\\:text-7xl .font-serif.leading-tight.capsize::after,.lg\\:text-7xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-snug.capsize::before, .font-serif .lg\\:text-7xl.leading-snug.capsize::before, .font-serif .lg\\:text-7xl .leading-snug.capsize::before,.lg\\:text-7xl .font-serif.leading-snug.capsize::before,.lg\\:text-7xl .font-serif .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3075em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-snug.capsize::after, .font-serif .lg\\:text-7xl.leading-snug.capsize::after, .font-serif .lg\\:text-7xl .leading-snug.capsize::after,.lg\\:text-7xl .font-serif.leading-snug.capsize::after,.lg\\:text-7xl .font-serif .leading-snug.capsize::after {
    content: '';
    margin-top: -0.2875em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-normal.capsize::before, .font-serif .lg\\:text-7xl.leading-normal.capsize::before, .font-serif .lg\\:text-7xl .leading-normal.capsize::before,.lg\\:text-7xl .font-serif.leading-normal.capsize::before,.lg\\:text-7xl .font-serif .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-normal.capsize::after, .font-serif .lg\\:text-7xl.leading-normal.capsize::after, .font-serif .lg\\:text-7xl .leading-normal.capsize::after,.lg\\:text-7xl .font-serif.leading-normal.capsize::after,.lg\\:text-7xl .font-serif .leading-normal.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-relaxed.capsize::before, .font-serif .lg\\:text-7xl.leading-relaxed.capsize::before, .font-serif .lg\\:text-7xl .leading-relaxed.capsize::before,.lg\\:text-7xl .font-serif.leading-relaxed.capsize::before,.lg\\:text-7xl .font-serif .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4325em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-relaxed.capsize::after, .font-serif .lg\\:text-7xl.leading-relaxed.capsize::after, .font-serif .lg\\:text-7xl .leading-relaxed.capsize::after,.lg\\:text-7xl .font-serif.leading-relaxed.capsize::after,.lg\\:text-7xl .font-serif .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4125em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-loose.capsize::before, .font-serif .lg\\:text-7xl.leading-loose.capsize::before, .font-serif .lg\\:text-7xl .leading-loose.capsize::before,.lg\\:text-7xl .font-serif.leading-loose.capsize::before,.lg\\:text-7xl .font-serif .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .lg\\:text-7xl.font-serif.leading-loose.capsize::after, .font-serif .lg\\:text-7xl.leading-loose.capsize::after, .font-serif .lg\\:text-7xl .leading-loose.capsize::after,.lg\\:text-7xl .font-serif.leading-loose.capsize::after,.lg\\:text-7xl .font-serif .leading-loose.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-3.capsize::before, .font-serif .lg\\:text-3.3xl.leading-3.capsize::before, .font-serif .lg\\:text-3.3xl .leading-3.capsize::before,.lg\\:text-3.3xl .font-serif.leading-3.capsize::before,.lg\\:text-3.3xl .font-serif .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.1925em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-3.capsize::after, .font-serif .lg\\:text-3.3xl.leading-3.capsize::after, .font-serif .lg\\:text-3.3xl .leading-3.capsize::after,.lg\\:text-3.3xl .font-serif.leading-3.capsize::after,.lg\\:text-3.3xl .font-serif .leading-3.capsize::after {
    content: '';
    margin-top: 0.2125em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-4.capsize::before, .font-serif .lg\\:text-3.3xl.leading-4.capsize::before, .font-serif .lg\\:text-3.3xl .leading-4.capsize::before,.lg\\:text-3.3xl .font-serif.leading-4.capsize::before,.lg\\:text-3.3xl .font-serif .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.13em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-4.capsize::after, .font-serif .lg\\:text-3.3xl.leading-4.capsize::after, .font-serif .lg\\:text-3.3xl .leading-4.capsize::after,.lg\\:text-3.3xl .font-serif.leading-4.capsize::after,.lg\\:text-3.3xl .font-serif .leading-4.capsize::after {
    content: '';
    margin-top: 0.15em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-5.capsize::before, .font-serif .lg\\:text-3.3xl.leading-5.capsize::before, .font-serif .lg\\:text-3.3xl .leading-5.capsize::before,.lg\\:text-3.3xl .font-serif.leading-5.capsize::before,.lg\\:text-3.3xl .font-serif .leading-5.capsize::before {
    content: '';
    margin-bottom: 0.0675em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-5.capsize::after, .font-serif .lg\\:text-3.3xl.leading-5.capsize::after, .font-serif .lg\\:text-3.3xl .leading-5.capsize::after,.lg\\:text-3.3xl .font-serif.leading-5.capsize::after,.lg\\:text-3.3xl .font-serif .leading-5.capsize::after {
    content: '';
    margin-top: 0.0875em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-6.capsize::before, .font-serif .lg\\:text-3.3xl.leading-6.capsize::before, .font-serif .lg\\:text-3.3xl .leading-6.capsize::before,.lg\\:text-3.3xl .font-serif.leading-6.capsize::before,.lg\\:text-3.3xl .font-serif .leading-6.capsize::before {
    content: '';
    margin-bottom: 0.005em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-6.capsize::after, .font-serif .lg\\:text-3.3xl.leading-6.capsize::after, .font-serif .lg\\:text-3.3xl .leading-6.capsize::after,.lg\\:text-3.3xl .font-serif.leading-6.capsize::after,.lg\\:text-3.3xl .font-serif .leading-6.capsize::after {
    content: '';
    margin-top: 0.025em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-7.capsize::before, .font-serif .lg\\:text-3.3xl.leading-7.capsize::before, .font-serif .lg\\:text-3.3xl .leading-7.capsize::before,.lg\\:text-3.3xl .font-serif.leading-7.capsize::before,.lg\\:text-3.3xl .font-serif .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.0575em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-7.capsize::after, .font-serif .lg\\:text-3.3xl.leading-7.capsize::after, .font-serif .lg\\:text-3.3xl .leading-7.capsize::after,.lg\\:text-3.3xl .font-serif.leading-7.capsize::after,.lg\\:text-3.3xl .font-serif .leading-7.capsize::after {
    content: '';
    margin-top: -0.0375em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-8.capsize::before, .font-serif .lg\\:text-3.3xl.leading-8.capsize::before, .font-serif .lg\\:text-3.3xl .leading-8.capsize::before,.lg\\:text-3.3xl .font-serif.leading-8.capsize::before,.lg\\:text-3.3xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-8.capsize::after, .font-serif .lg\\:text-3.3xl.leading-8.capsize::after, .font-serif .lg\\:text-3.3xl .leading-8.capsize::after,.lg\\:text-3.3xl .font-serif.leading-8.capsize::after,.lg\\:text-3.3xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-9.capsize::before, .font-serif .lg\\:text-3.3xl.leading-9.capsize::before, .font-serif .lg\\:text-3.3xl .leading-9.capsize::before,.lg\\:text-3.3xl .font-serif.leading-9.capsize::before,.lg\\:text-3.3xl .font-serif .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.1825em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-9.capsize::after, .font-serif .lg\\:text-3.3xl.leading-9.capsize::after, .font-serif .lg\\:text-3.3xl .leading-9.capsize::after,.lg\\:text-3.3xl .font-serif.leading-9.capsize::after,.lg\\:text-3.3xl .font-serif .leading-9.capsize::after {
    content: '';
    margin-top: -0.1625em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-10.capsize::before, .font-serif .lg\\:text-3.3xl.leading-10.capsize::before, .font-serif .lg\\:text-3.3xl .leading-10.capsize::before,.lg\\:text-3.3xl .font-serif.leading-10.capsize::before,.lg\\:text-3.3xl .font-serif .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-10.capsize::after, .font-serif .lg\\:text-3.3xl.leading-10.capsize::after, .font-serif .lg\\:text-3.3xl .leading-10.capsize::after,.lg\\:text-3.3xl .font-serif.leading-10.capsize::after,.lg\\:text-3.3xl .font-serif .leading-10.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-none.capsize::before, .font-serif .lg\\:text-3.3xl.leading-none.capsize::before, .font-serif .lg\\:text-3.3xl .leading-none.capsize::before,.lg\\:text-3.3xl .font-serif.leading-none.capsize::before,.lg\\:text-3.3xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-none.capsize::after, .font-serif .lg\\:text-3.3xl.leading-none.capsize::after, .font-serif .lg\\:text-3.3xl .leading-none.capsize::after,.lg\\:text-3.3xl .font-serif.leading-none.capsize::after,.lg\\:text-3.3xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-tight.capsize::before, .font-serif .lg\\:text-3.3xl.leading-tight.capsize::before, .font-serif .lg\\:text-3.3xl .leading-tight.capsize::before,.lg\\:text-3.3xl .font-serif.leading-tight.capsize::before,.lg\\:text-3.3xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-tight.capsize::after, .font-serif .lg\\:text-3.3xl.leading-tight.capsize::after, .font-serif .lg\\:text-3.3xl .leading-tight.capsize::after,.lg\\:text-3.3xl .font-serif.leading-tight.capsize::after,.lg\\:text-3.3xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-snug.capsize::before, .font-serif .lg\\:text-3.3xl.leading-snug.capsize::before, .font-serif .lg\\:text-3.3xl .leading-snug.capsize::before,.lg\\:text-3.3xl .font-serif.leading-snug.capsize::before,.lg\\:text-3.3xl .font-serif .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3075em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-snug.capsize::after, .font-serif .lg\\:text-3.3xl.leading-snug.capsize::after, .font-serif .lg\\:text-3.3xl .leading-snug.capsize::after,.lg\\:text-3.3xl .font-serif.leading-snug.capsize::after,.lg\\:text-3.3xl .font-serif .leading-snug.capsize::after {
    content: '';
    margin-top: -0.2875em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-normal.capsize::before, .font-serif .lg\\:text-3.3xl.leading-normal.capsize::before, .font-serif .lg\\:text-3.3xl .leading-normal.capsize::before,.lg\\:text-3.3xl .font-serif.leading-normal.capsize::before,.lg\\:text-3.3xl .font-serif .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-normal.capsize::after, .font-serif .lg\\:text-3.3xl.leading-normal.capsize::after, .font-serif .lg\\:text-3.3xl .leading-normal.capsize::after,.lg\\:text-3.3xl .font-serif.leading-normal.capsize::after,.lg\\:text-3.3xl .font-serif .leading-normal.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-relaxed.capsize::before, .font-serif .lg\\:text-3.3xl.leading-relaxed.capsize::before, .font-serif .lg\\:text-3.3xl .leading-relaxed.capsize::before,.lg\\:text-3.3xl .font-serif.leading-relaxed.capsize::before,.lg\\:text-3.3xl .font-serif .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4325em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-relaxed.capsize::after, .font-serif .lg\\:text-3.3xl.leading-relaxed.capsize::after, .font-serif .lg\\:text-3.3xl .leading-relaxed.capsize::after,.lg\\:text-3.3xl .font-serif.leading-relaxed.capsize::after,.lg\\:text-3.3xl .font-serif .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4125em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-loose.capsize::before, .font-serif .lg\\:text-3.3xl.leading-loose.capsize::before, .font-serif .lg\\:text-3.3xl .leading-loose.capsize::before,.lg\\:text-3.3xl .font-serif.leading-loose.capsize::before,.lg\\:text-3.3xl .font-serif .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .lg\\:text-3.font-serif.3xl.leading-loose.capsize::after, .font-serif .lg\\:text-3.3xl.leading-loose.capsize::after, .font-serif .lg\\:text-3.3xl .leading-loose.capsize::after,.lg\\:text-3.3xl .font-serif.leading-loose.capsize::after,.lg\\:text-3.3xl .font-serif .leading-loose.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .lg\\:after\\:-right-5::after {
    content: var(--tw-content);
    right: -1.25rem;
  }

  .lg\\:after\\:bottom-auto::after {
    content: var(--tw-content);
    bottom: auto;
  }

  .lg\\:after\\:left-auto::after {
    content: var(--tw-content);
    left: auto;
  }

  .lg\\:after\\:top-1\\/2::after {
    content: var(--tw-content);
    top: 50%;
  }

  .after\\:lg\\:my-8::after {
    content: var(--tw-content);
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .lg\\:after\\:hidden::after {
    content: var(--tw-content);
    display: none;
  }

  .lg\\:after\\:h-14::after {
    content: var(--tw-content);
    height: 3.5rem;
  }

  .after\\:lg\\:w-20::after {
    content: var(--tw-content);
    width: 5rem;
  }

  .lg\\:after\\:w-px::after {
    content: var(--tw-content);
    width: 1px;
  }

  .lg\\:after\\:-translate-y-1\\/2::after {
    content: var(--tw-content);
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\\:after\\:translate-x-0::after {
    content: var(--tw-content);
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .group\\/card:hover .lg\\:group-hover\\/card\\:scale-105 {
    --tw-scale-x: 1.05;
    --tw-scale-y: 1.05;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .group\\/hero:hover .lg\\:group-hover\\/hero\\:scale-105 {
    --tw-scale-x: 1.05;
    --tw-scale-y: 1.05;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .group\\/card:hover .lg\\:group-hover\\/card\\:opacity-100 {
    opacity: 1;
  }
}
@media (min-width: 1280px) {

  .xl\\:bottom-10 {
    bottom: 2.5rem;
  }

  .xl\\:mt-8 {
    margin-top: 2rem;
  }

  .xl\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .xl\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .xl\\:text-8xl {
    font-size: 6rem;
    line-height: 1;
  }

  .xl\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .xl\\:text-base.font-sans.leading-3.capsize::before, .font-sans .xl\\:text-base.leading-3.capsize::before, .font-sans .xl\\:text-base .leading-3.capsize::before,.xl\\:text-base .font-sans.leading-3.capsize::before,.xl\\:text-base .font-sans .leading-3.capsize::before {
    content: '';
    margin-bottom: -0.032em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-3.capsize::after, .font-sans .xl\\:text-base.leading-3.capsize::after, .font-sans .xl\\:text-base .leading-3.capsize::after,.xl\\:text-base .font-sans.leading-3.capsize::after,.xl\\:text-base .font-sans .leading-3.capsize::after {
    content: '';
    margin-top: 0.012em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-4.capsize::before, .font-sans .xl\\:text-base.leading-4.capsize::before, .font-sans .xl\\:text-base .leading-4.capsize::before,.xl\\:text-base .font-sans.leading-4.capsize::before,.xl\\:text-base .font-sans .leading-4.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-4.capsize::after, .font-sans .xl\\:text-base.leading-4.capsize::after, .font-sans .xl\\:text-base .leading-4.capsize::after,.xl\\:text-base .font-sans.leading-4.capsize::after,.xl\\:text-base .font-sans .leading-4.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-5.capsize::before, .font-sans .xl\\:text-base.leading-5.capsize::before, .font-sans .xl\\:text-base .leading-5.capsize::before,.xl\\:text-base .font-sans.leading-5.capsize::before,.xl\\:text-base .font-sans .leading-5.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-5.capsize::after, .font-sans .xl\\:text-base.leading-5.capsize::after, .font-sans .xl\\:text-base .leading-5.capsize::after,.xl\\:text-base .font-sans.leading-5.capsize::after,.xl\\:text-base .font-sans .leading-5.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-6.capsize::before, .font-sans .xl\\:text-base.leading-6.capsize::before, .font-sans .xl\\:text-base .leading-6.capsize::before,.xl\\:text-base .font-sans.leading-6.capsize::before,.xl\\:text-base .font-sans .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-6.capsize::after, .font-sans .xl\\:text-base.leading-6.capsize::after, .font-sans .xl\\:text-base .leading-6.capsize::after,.xl\\:text-base .font-sans.leading-6.capsize::after,.xl\\:text-base .font-sans .leading-6.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-7.capsize::before, .font-sans .xl\\:text-base.leading-7.capsize::before, .font-sans .xl\\:text-base .leading-7.capsize::before,.xl\\:text-base .font-sans.leading-7.capsize::before,.xl\\:text-base .font-sans .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.532em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-7.capsize::after, .font-sans .xl\\:text-base.leading-7.capsize::after, .font-sans .xl\\:text-base .leading-7.capsize::after,.xl\\:text-base .font-sans.leading-7.capsize::after,.xl\\:text-base .font-sans .leading-7.capsize::after {
    content: '';
    margin-top: -0.488em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-8.capsize::before, .font-sans .xl\\:text-base.leading-8.capsize::before, .font-sans .xl\\:text-base .leading-8.capsize::before,.xl\\:text-base .font-sans.leading-8.capsize::before,.xl\\:text-base .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-8.capsize::after, .font-sans .xl\\:text-base.leading-8.capsize::after, .font-sans .xl\\:text-base .leading-8.capsize::after,.xl\\:text-base .font-sans.leading-8.capsize::after,.xl\\:text-base .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-9.capsize::before, .font-sans .xl\\:text-base.leading-9.capsize::before, .font-sans .xl\\:text-base .leading-9.capsize::before,.xl\\:text-base .font-sans.leading-9.capsize::before,.xl\\:text-base .font-sans .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.782em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-9.capsize::after, .font-sans .xl\\:text-base.leading-9.capsize::after, .font-sans .xl\\:text-base .leading-9.capsize::after,.xl\\:text-base .font-sans.leading-9.capsize::after,.xl\\:text-base .font-sans .leading-9.capsize::after {
    content: '';
    margin-top: -0.738em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-10.capsize::before, .font-sans .xl\\:text-base.leading-10.capsize::before, .font-sans .xl\\:text-base .leading-10.capsize::before,.xl\\:text-base .font-sans.leading-10.capsize::before,.xl\\:text-base .font-sans .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.907em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-10.capsize::after, .font-sans .xl\\:text-base.leading-10.capsize::after, .font-sans .xl\\:text-base .leading-10.capsize::after,.xl\\:text-base .font-sans.leading-10.capsize::after,.xl\\:text-base .font-sans .leading-10.capsize::after {
    content: '';
    margin-top: -0.863em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-none.capsize::before, .font-sans .xl\\:text-base.leading-none.capsize::before, .font-sans .xl\\:text-base .leading-none.capsize::before,.xl\\:text-base .font-sans.leading-none.capsize::before,.xl\\:text-base .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-none.capsize::after, .font-sans .xl\\:text-base.leading-none.capsize::after, .font-sans .xl\\:text-base .leading-none.capsize::after,.xl\\:text-base .font-sans.leading-none.capsize::after,.xl\\:text-base .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-tight.capsize::before, .font-sans .xl\\:text-base.leading-tight.capsize::before, .font-sans .xl\\:text-base .leading-tight.capsize::before,.xl\\:text-base .font-sans.leading-tight.capsize::before,.xl\\:text-base .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-tight.capsize::after, .font-sans .xl\\:text-base.leading-tight.capsize::after, .font-sans .xl\\:text-base .leading-tight.capsize::after,.xl\\:text-base .font-sans.leading-tight.capsize::after,.xl\\:text-base .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-snug.capsize::before, .font-sans .xl\\:text-base.leading-snug.capsize::before, .font-sans .xl\\:text-base .leading-snug.capsize::before,.xl\\:text-base .font-sans.leading-snug.capsize::before,.xl\\:text-base .font-sans .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3445em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-snug.capsize::after, .font-sans .xl\\:text-base.leading-snug.capsize::after, .font-sans .xl\\:text-base .leading-snug.capsize::after,.xl\\:text-base .font-sans.leading-snug.capsize::after,.xl\\:text-base .font-sans .leading-snug.capsize::after {
    content: '';
    margin-top: -0.3005em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-normal.capsize::before, .font-sans .xl\\:text-base.leading-normal.capsize::before, .font-sans .xl\\:text-base .leading-normal.capsize::before,.xl\\:text-base .font-sans.leading-normal.capsize::before,.xl\\:text-base .font-sans .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-normal.capsize::after, .font-sans .xl\\:text-base.leading-normal.capsize::after, .font-sans .xl\\:text-base .leading-normal.capsize::after,.xl\\:text-base .font-sans.leading-normal.capsize::after,.xl\\:text-base .font-sans .leading-normal.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-relaxed.capsize::before, .font-sans .xl\\:text-base.leading-relaxed.capsize::before, .font-sans .xl\\:text-base .leading-relaxed.capsize::before,.xl\\:text-base .font-sans.leading-relaxed.capsize::before,.xl\\:text-base .font-sans .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4695em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-relaxed.capsize::after, .font-sans .xl\\:text-base.leading-relaxed.capsize::after, .font-sans .xl\\:text-base .leading-relaxed.capsize::after,.xl\\:text-base .font-sans.leading-relaxed.capsize::after,.xl\\:text-base .font-sans .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4255em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-loose.capsize::before, .font-sans .xl\\:text-base.leading-loose.capsize::before, .font-sans .xl\\:text-base .leading-loose.capsize::before,.xl\\:text-base .font-sans.leading-loose.capsize::before,.xl\\:text-base .font-sans .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .xl\\:text-base.font-sans.leading-loose.capsize::after, .font-sans .xl\\:text-base.leading-loose.capsize::after, .font-sans .xl\\:text-base .leading-loose.capsize::after,.xl\\:text-base .font-sans.leading-loose.capsize::after,.xl\\:text-base .font-sans .leading-loose.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-3.capsize::before, .font-sans .xl\\:text-3xl.leading-3.capsize::before, .font-sans .xl\\:text-3xl .leading-3.capsize::before,.xl\\:text-3xl .font-sans.leading-3.capsize::before,.xl\\:text-3xl .font-sans .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.143em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-3.capsize::after, .font-sans .xl\\:text-3xl.leading-3.capsize::after, .font-sans .xl\\:text-3xl .leading-3.capsize::after,.xl\\:text-3xl .font-sans.leading-3.capsize::after,.xl\\:text-3xl .font-sans .leading-3.capsize::after {
    content: '';
    margin-top: 0.187em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-4.capsize::before, .font-sans .xl\\:text-3xl.leading-4.capsize::before, .font-sans .xl\\:text-3xl .leading-4.capsize::before,.xl\\:text-3xl .font-sans.leading-4.capsize::before,.xl\\:text-3xl .font-sans .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.0763em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-4.capsize::after, .font-sans .xl\\:text-3xl.leading-4.capsize::after, .font-sans .xl\\:text-3xl .leading-4.capsize::after,.xl\\:text-3xl .font-sans.leading-4.capsize::after,.xl\\:text-3xl .font-sans .leading-4.capsize::after {
    content: '';
    margin-top: 0.1203em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-5.capsize::before, .font-sans .xl\\:text-3xl.leading-5.capsize::before, .font-sans .xl\\:text-3xl .leading-5.capsize::before,.xl\\:text-3xl .font-sans.leading-5.capsize::before,.xl\\:text-3xl .font-sans .leading-5.capsize::before {
    content: '';
    margin-bottom: 0.0097em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-5.capsize::after, .font-sans .xl\\:text-3xl.leading-5.capsize::after, .font-sans .xl\\:text-3xl .leading-5.capsize::after,.xl\\:text-3xl .font-sans.leading-5.capsize::after,.xl\\:text-3xl .font-sans .leading-5.capsize::after {
    content: '';
    margin-top: 0.0537em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-6.capsize::before, .font-sans .xl\\:text-3xl.leading-6.capsize::before, .font-sans .xl\\:text-3xl .leading-6.capsize::before,.xl\\:text-3xl .font-sans.leading-6.capsize::before,.xl\\:text-3xl .font-sans .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.057em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-6.capsize::after, .font-sans .xl\\:text-3xl.leading-6.capsize::after, .font-sans .xl\\:text-3xl .leading-6.capsize::after,.xl\\:text-3xl .font-sans.leading-6.capsize::after,.xl\\:text-3xl .font-sans .leading-6.capsize::after {
    content: '';
    margin-top: -0.013em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-7.capsize::before, .font-sans .xl\\:text-3xl.leading-7.capsize::before, .font-sans .xl\\:text-3xl .leading-7.capsize::before,.xl\\:text-3xl .font-sans.leading-7.capsize::before,.xl\\:text-3xl .font-sans .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.1237em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-7.capsize::after, .font-sans .xl\\:text-3xl.leading-7.capsize::after, .font-sans .xl\\:text-3xl .leading-7.capsize::after,.xl\\:text-3xl .font-sans.leading-7.capsize::after,.xl\\:text-3xl .font-sans .leading-7.capsize::after {
    content: '';
    margin-top: -0.0797em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-8.capsize::before, .font-sans .xl\\:text-3xl.leading-8.capsize::before, .font-sans .xl\\:text-3xl .leading-8.capsize::before,.xl\\:text-3xl .font-sans.leading-8.capsize::before,.xl\\:text-3xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1903em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-8.capsize::after, .font-sans .xl\\:text-3xl.leading-8.capsize::after, .font-sans .xl\\:text-3xl .leading-8.capsize::after,.xl\\:text-3xl .font-sans.leading-8.capsize::after,.xl\\:text-3xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: -0.1463em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-9.capsize::before, .font-sans .xl\\:text-3xl.leading-9.capsize::before, .font-sans .xl\\:text-3xl .leading-9.capsize::before,.xl\\:text-3xl .font-sans.leading-9.capsize::before,.xl\\:text-3xl .font-sans .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.257em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-9.capsize::after, .font-sans .xl\\:text-3xl.leading-9.capsize::after, .font-sans .xl\\:text-3xl .leading-9.capsize::after,.xl\\:text-3xl .font-sans.leading-9.capsize::after,.xl\\:text-3xl .font-sans .leading-9.capsize::after {
    content: '';
    margin-top: -0.213em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-10.capsize::before, .font-sans .xl\\:text-3xl.leading-10.capsize::before, .font-sans .xl\\:text-3xl .leading-10.capsize::before,.xl\\:text-3xl .font-sans.leading-10.capsize::before,.xl\\:text-3xl .font-sans .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.3237em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-10.capsize::after, .font-sans .xl\\:text-3xl.leading-10.capsize::after, .font-sans .xl\\:text-3xl .leading-10.capsize::after,.xl\\:text-3xl .font-sans.leading-10.capsize::after,.xl\\:text-3xl .font-sans .leading-10.capsize::after {
    content: '';
    margin-top: -0.2797em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-none.capsize::before, .font-sans .xl\\:text-3xl.leading-none.capsize::before, .font-sans .xl\\:text-3xl .leading-none.capsize::before,.xl\\:text-3xl .font-sans.leading-none.capsize::before,.xl\\:text-3xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-none.capsize::after, .font-sans .xl\\:text-3xl.leading-none.capsize::after, .font-sans .xl\\:text-3xl .leading-none.capsize::after,.xl\\:text-3xl .font-sans.leading-none.capsize::after,.xl\\:text-3xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-tight.capsize::before, .font-sans .xl\\:text-3xl.leading-tight.capsize::before, .font-sans .xl\\:text-3xl .leading-tight.capsize::before,.xl\\:text-3xl .font-sans.leading-tight.capsize::before,.xl\\:text-3xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-tight.capsize::after, .font-sans .xl\\:text-3xl.leading-tight.capsize::after, .font-sans .xl\\:text-3xl .leading-tight.capsize::after,.xl\\:text-3xl .font-sans.leading-tight.capsize::after,.xl\\:text-3xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-snug.capsize::before, .font-sans .xl\\:text-3xl.leading-snug.capsize::before, .font-sans .xl\\:text-3xl .leading-snug.capsize::before,.xl\\:text-3xl .font-sans.leading-snug.capsize::before,.xl\\:text-3xl .font-sans .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3445em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-snug.capsize::after, .font-sans .xl\\:text-3xl.leading-snug.capsize::after, .font-sans .xl\\:text-3xl .leading-snug.capsize::after,.xl\\:text-3xl .font-sans.leading-snug.capsize::after,.xl\\:text-3xl .font-sans .leading-snug.capsize::after {
    content: '';
    margin-top: -0.3005em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-normal.capsize::before, .font-sans .xl\\:text-3xl.leading-normal.capsize::before, .font-sans .xl\\:text-3xl .leading-normal.capsize::before,.xl\\:text-3xl .font-sans.leading-normal.capsize::before,.xl\\:text-3xl .font-sans .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-normal.capsize::after, .font-sans .xl\\:text-3xl.leading-normal.capsize::after, .font-sans .xl\\:text-3xl .leading-normal.capsize::after,.xl\\:text-3xl .font-sans.leading-normal.capsize::after,.xl\\:text-3xl .font-sans .leading-normal.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-relaxed.capsize::before, .font-sans .xl\\:text-3xl.leading-relaxed.capsize::before, .font-sans .xl\\:text-3xl .leading-relaxed.capsize::before,.xl\\:text-3xl .font-sans.leading-relaxed.capsize::before,.xl\\:text-3xl .font-sans .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4695em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-relaxed.capsize::after, .font-sans .xl\\:text-3xl.leading-relaxed.capsize::after, .font-sans .xl\\:text-3xl .leading-relaxed.capsize::after,.xl\\:text-3xl .font-sans.leading-relaxed.capsize::after,.xl\\:text-3xl .font-sans .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4255em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-loose.capsize::before, .font-sans .xl\\:text-3xl.leading-loose.capsize::before, .font-sans .xl\\:text-3xl .leading-loose.capsize::before,.xl\\:text-3xl .font-sans.leading-loose.capsize::before,.xl\\:text-3xl .font-sans .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .xl\\:text-3xl.font-sans.leading-loose.capsize::after, .font-sans .xl\\:text-3xl.leading-loose.capsize::after, .font-sans .xl\\:text-3xl .leading-loose.capsize::after,.xl\\:text-3xl .font-sans.leading-loose.capsize::after,.xl\\:text-3xl .font-sans .leading-loose.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-3.capsize::before, .font-sans .xl\\:text-8xl.leading-3.capsize::before, .font-sans .xl\\:text-8xl .leading-3.capsize::before,.xl\\:text-8xl .font-sans.leading-3.capsize::before,.xl\\:text-8xl .font-sans .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.2805em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-3.capsize::after, .font-sans .xl\\:text-8xl.leading-3.capsize::after, .font-sans .xl\\:text-8xl .leading-3.capsize::after,.xl\\:text-8xl .font-sans.leading-3.capsize::after,.xl\\:text-8xl .font-sans .leading-3.capsize::after {
    content: '';
    margin-top: 0.3245em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-4.capsize::before, .font-sans .xl\\:text-8xl.leading-4.capsize::before, .font-sans .xl\\:text-8xl .leading-4.capsize::before,.xl\\:text-8xl .font-sans.leading-4.capsize::before,.xl\\:text-8xl .font-sans .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.2597em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-4.capsize::after, .font-sans .xl\\:text-8xl.leading-4.capsize::after, .font-sans .xl\\:text-8xl .leading-4.capsize::after,.xl\\:text-8xl .font-sans.leading-4.capsize::after,.xl\\:text-8xl .font-sans .leading-4.capsize::after {
    content: '';
    margin-top: 0.3037em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-5.capsize::before, .font-sans .xl\\:text-8xl.leading-5.capsize::before, .font-sans .xl\\:text-8xl .leading-5.capsize::before,.xl\\:text-8xl .font-sans.leading-5.capsize::before,.xl\\:text-8xl .font-sans .leading-5.capsize::before {
    content: '';
    margin-bottom: 0.2388em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-5.capsize::after, .font-sans .xl\\:text-8xl.leading-5.capsize::after, .font-sans .xl\\:text-8xl .leading-5.capsize::after,.xl\\:text-8xl .font-sans.leading-5.capsize::after,.xl\\:text-8xl .font-sans .leading-5.capsize::after {
    content: '';
    margin-top: 0.2828em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-6.capsize::before, .font-sans .xl\\:text-8xl.leading-6.capsize::before, .font-sans .xl\\:text-8xl .leading-6.capsize::before,.xl\\:text-8xl .font-sans.leading-6.capsize::before,.xl\\:text-8xl .font-sans .leading-6.capsize::before {
    content: '';
    margin-bottom: 0.218em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-6.capsize::after, .font-sans .xl\\:text-8xl.leading-6.capsize::after, .font-sans .xl\\:text-8xl .leading-6.capsize::after,.xl\\:text-8xl .font-sans.leading-6.capsize::after,.xl\\:text-8xl .font-sans .leading-6.capsize::after {
    content: '';
    margin-top: 0.262em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-7.capsize::before, .font-sans .xl\\:text-8xl.leading-7.capsize::before, .font-sans .xl\\:text-8xl .leading-7.capsize::before,.xl\\:text-8xl .font-sans.leading-7.capsize::before,.xl\\:text-8xl .font-sans .leading-7.capsize::before {
    content: '';
    margin-bottom: 0.1972em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-7.capsize::after, .font-sans .xl\\:text-8xl.leading-7.capsize::after, .font-sans .xl\\:text-8xl .leading-7.capsize::after,.xl\\:text-8xl .font-sans.leading-7.capsize::after,.xl\\:text-8xl .font-sans .leading-7.capsize::after {
    content: '';
    margin-top: 0.2412em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-8.capsize::before, .font-sans .xl\\:text-8xl.leading-8.capsize::before, .font-sans .xl\\:text-8xl .leading-8.capsize::before,.xl\\:text-8xl .font-sans.leading-8.capsize::before,.xl\\:text-8xl .font-sans .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.1763em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-8.capsize::after, .font-sans .xl\\:text-8xl.leading-8.capsize::after, .font-sans .xl\\:text-8xl .leading-8.capsize::after,.xl\\:text-8xl .font-sans.leading-8.capsize::after,.xl\\:text-8xl .font-sans .leading-8.capsize::after {
    content: '';
    margin-top: 0.2203em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-9.capsize::before, .font-sans .xl\\:text-8xl.leading-9.capsize::before, .font-sans .xl\\:text-8xl .leading-9.capsize::before,.xl\\:text-8xl .font-sans.leading-9.capsize::before,.xl\\:text-8xl .font-sans .leading-9.capsize::before {
    content: '';
    margin-bottom: 0.1555em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-9.capsize::after, .font-sans .xl\\:text-8xl.leading-9.capsize::after, .font-sans .xl\\:text-8xl .leading-9.capsize::after,.xl\\:text-8xl .font-sans.leading-9.capsize::after,.xl\\:text-8xl .font-sans .leading-9.capsize::after {
    content: '';
    margin-top: 0.1995em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-10.capsize::before, .font-sans .xl\\:text-8xl.leading-10.capsize::before, .font-sans .xl\\:text-8xl .leading-10.capsize::before,.xl\\:text-8xl .font-sans.leading-10.capsize::before,.xl\\:text-8xl .font-sans .leading-10.capsize::before {
    content: '';
    margin-bottom: 0.1347em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-10.capsize::after, .font-sans .xl\\:text-8xl.leading-10.capsize::after, .font-sans .xl\\:text-8xl .leading-10.capsize::after,.xl\\:text-8xl .font-sans.leading-10.capsize::after,.xl\\:text-8xl .font-sans .leading-10.capsize::after {
    content: '';
    margin-top: 0.1787em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-none.capsize::before, .font-sans .xl\\:text-8xl.leading-none.capsize::before, .font-sans .xl\\:text-8xl .leading-none.capsize::before,.xl\\:text-8xl .font-sans.leading-none.capsize::before,.xl\\:text-8xl .font-sans .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.157em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-none.capsize::after, .font-sans .xl\\:text-8xl.leading-none.capsize::after, .font-sans .xl\\:text-8xl .leading-none.capsize::after,.xl\\:text-8xl .font-sans.leading-none.capsize::after,.xl\\:text-8xl .font-sans .leading-none.capsize::after {
    content: '';
    margin-top: -0.113em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-tight.capsize::before, .font-sans .xl\\:text-8xl.leading-tight.capsize::before, .font-sans .xl\\:text-8xl .leading-tight.capsize::before,.xl\\:text-8xl .font-sans.leading-tight.capsize::before,.xl\\:text-8xl .font-sans .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.282em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-tight.capsize::after, .font-sans .xl\\:text-8xl.leading-tight.capsize::after, .font-sans .xl\\:text-8xl .leading-tight.capsize::after,.xl\\:text-8xl .font-sans.leading-tight.capsize::after,.xl\\:text-8xl .font-sans .leading-tight.capsize::after {
    content: '';
    margin-top: -0.238em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-snug.capsize::before, .font-sans .xl\\:text-8xl.leading-snug.capsize::before, .font-sans .xl\\:text-8xl .leading-snug.capsize::before,.xl\\:text-8xl .font-sans.leading-snug.capsize::before,.xl\\:text-8xl .font-sans .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3445em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-snug.capsize::after, .font-sans .xl\\:text-8xl.leading-snug.capsize::after, .font-sans .xl\\:text-8xl .leading-snug.capsize::after,.xl\\:text-8xl .font-sans.leading-snug.capsize::after,.xl\\:text-8xl .font-sans .leading-snug.capsize::after {
    content: '';
    margin-top: -0.3005em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-normal.capsize::before, .font-sans .xl\\:text-8xl.leading-normal.capsize::before, .font-sans .xl\\:text-8xl .leading-normal.capsize::before,.xl\\:text-8xl .font-sans.leading-normal.capsize::before,.xl\\:text-8xl .font-sans .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.407em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-normal.capsize::after, .font-sans .xl\\:text-8xl.leading-normal.capsize::after, .font-sans .xl\\:text-8xl .leading-normal.capsize::after,.xl\\:text-8xl .font-sans.leading-normal.capsize::after,.xl\\:text-8xl .font-sans .leading-normal.capsize::after {
    content: '';
    margin-top: -0.363em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-relaxed.capsize::before, .font-sans .xl\\:text-8xl.leading-relaxed.capsize::before, .font-sans .xl\\:text-8xl .leading-relaxed.capsize::before,.xl\\:text-8xl .font-sans.leading-relaxed.capsize::before,.xl\\:text-8xl .font-sans .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4695em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-relaxed.capsize::after, .font-sans .xl\\:text-8xl.leading-relaxed.capsize::after, .font-sans .xl\\:text-8xl .leading-relaxed.capsize::after,.xl\\:text-8xl .font-sans.leading-relaxed.capsize::after,.xl\\:text-8xl .font-sans .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4255em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-loose.capsize::before, .font-sans .xl\\:text-8xl.leading-loose.capsize::before, .font-sans .xl\\:text-8xl .leading-loose.capsize::before,.xl\\:text-8xl .font-sans.leading-loose.capsize::before,.xl\\:text-8xl .font-sans .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.657em;
    display: table;
  }

  .xl\\:text-8xl.font-sans.leading-loose.capsize::after, .font-sans .xl\\:text-8xl.leading-loose.capsize::after, .font-sans .xl\\:text-8xl .leading-loose.capsize::after,.xl\\:text-8xl .font-sans.leading-loose.capsize::after,.xl\\:text-8xl .font-sans .leading-loose.capsize::after {
    content: '';
    margin-top: -0.613em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-3.capsize::before, .font-serif .xl\\:text-base.leading-3.capsize::before, .font-serif .xl\\:text-base .leading-3.capsize::before,.xl\\:text-base .font-serif.leading-3.capsize::before,.xl\\:text-base .font-serif .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.005em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-3.capsize::after, .font-serif .xl\\:text-base.leading-3.capsize::after, .font-serif .xl\\:text-base .leading-3.capsize::after,.xl\\:text-base .font-serif.leading-3.capsize::after,.xl\\:text-base .font-serif .leading-3.capsize::after {
    content: '';
    margin-top: 0.025em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-4.capsize::before, .font-serif .xl\\:text-base.leading-4.capsize::before, .font-serif .xl\\:text-base .leading-4.capsize::before,.xl\\:text-base .font-serif.leading-4.capsize::before,.xl\\:text-base .font-serif .leading-4.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-4.capsize::after, .font-serif .xl\\:text-base.leading-4.capsize::after, .font-serif .xl\\:text-base .leading-4.capsize::after,.xl\\:text-base .font-serif.leading-4.capsize::after,.xl\\:text-base .font-serif .leading-4.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-5.capsize::before, .font-serif .xl\\:text-base.leading-5.capsize::before, .font-serif .xl\\:text-base .leading-5.capsize::before,.xl\\:text-base .font-serif.leading-5.capsize::before,.xl\\:text-base .font-serif .leading-5.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-5.capsize::after, .font-serif .xl\\:text-base.leading-5.capsize::after, .font-serif .xl\\:text-base .leading-5.capsize::after,.xl\\:text-base .font-serif.leading-5.capsize::after,.xl\\:text-base .font-serif .leading-5.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-6.capsize::before, .font-serif .xl\\:text-base.leading-6.capsize::before, .font-serif .xl\\:text-base .leading-6.capsize::before,.xl\\:text-base .font-serif.leading-6.capsize::before,.xl\\:text-base .font-serif .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-6.capsize::after, .font-serif .xl\\:text-base.leading-6.capsize::after, .font-serif .xl\\:text-base .leading-6.capsize::after,.xl\\:text-base .font-serif.leading-6.capsize::after,.xl\\:text-base .font-serif .leading-6.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-7.capsize::before, .font-serif .xl\\:text-base.leading-7.capsize::before, .font-serif .xl\\:text-base .leading-7.capsize::before,.xl\\:text-base .font-serif.leading-7.capsize::before,.xl\\:text-base .font-serif .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.495em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-7.capsize::after, .font-serif .xl\\:text-base.leading-7.capsize::after, .font-serif .xl\\:text-base .leading-7.capsize::after,.xl\\:text-base .font-serif.leading-7.capsize::after,.xl\\:text-base .font-serif .leading-7.capsize::after {
    content: '';
    margin-top: -0.475em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-8.capsize::before, .font-serif .xl\\:text-base.leading-8.capsize::before, .font-serif .xl\\:text-base .leading-8.capsize::before,.xl\\:text-base .font-serif.leading-8.capsize::before,.xl\\:text-base .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-8.capsize::after, .font-serif .xl\\:text-base.leading-8.capsize::after, .font-serif .xl\\:text-base .leading-8.capsize::after,.xl\\:text-base .font-serif.leading-8.capsize::after,.xl\\:text-base .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-9.capsize::before, .font-serif .xl\\:text-base.leading-9.capsize::before, .font-serif .xl\\:text-base .leading-9.capsize::before,.xl\\:text-base .font-serif.leading-9.capsize::before,.xl\\:text-base .font-serif .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.745em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-9.capsize::after, .font-serif .xl\\:text-base.leading-9.capsize::after, .font-serif .xl\\:text-base .leading-9.capsize::after,.xl\\:text-base .font-serif.leading-9.capsize::after,.xl\\:text-base .font-serif .leading-9.capsize::after {
    content: '';
    margin-top: -0.725em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-10.capsize::before, .font-serif .xl\\:text-base.leading-10.capsize::before, .font-serif .xl\\:text-base .leading-10.capsize::before,.xl\\:text-base .font-serif.leading-10.capsize::before,.xl\\:text-base .font-serif .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.87em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-10.capsize::after, .font-serif .xl\\:text-base.leading-10.capsize::after, .font-serif .xl\\:text-base .leading-10.capsize::after,.xl\\:text-base .font-serif.leading-10.capsize::after,.xl\\:text-base .font-serif .leading-10.capsize::after {
    content: '';
    margin-top: -0.85em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-none.capsize::before, .font-serif .xl\\:text-base.leading-none.capsize::before, .font-serif .xl\\:text-base .leading-none.capsize::before,.xl\\:text-base .font-serif.leading-none.capsize::before,.xl\\:text-base .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-none.capsize::after, .font-serif .xl\\:text-base.leading-none.capsize::after, .font-serif .xl\\:text-base .leading-none.capsize::after,.xl\\:text-base .font-serif.leading-none.capsize::after,.xl\\:text-base .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-tight.capsize::before, .font-serif .xl\\:text-base.leading-tight.capsize::before, .font-serif .xl\\:text-base .leading-tight.capsize::before,.xl\\:text-base .font-serif.leading-tight.capsize::before,.xl\\:text-base .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-tight.capsize::after, .font-serif .xl\\:text-base.leading-tight.capsize::after, .font-serif .xl\\:text-base .leading-tight.capsize::after,.xl\\:text-base .font-serif.leading-tight.capsize::after,.xl\\:text-base .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-snug.capsize::before, .font-serif .xl\\:text-base.leading-snug.capsize::before, .font-serif .xl\\:text-base .leading-snug.capsize::before,.xl\\:text-base .font-serif.leading-snug.capsize::before,.xl\\:text-base .font-serif .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3075em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-snug.capsize::after, .font-serif .xl\\:text-base.leading-snug.capsize::after, .font-serif .xl\\:text-base .leading-snug.capsize::after,.xl\\:text-base .font-serif.leading-snug.capsize::after,.xl\\:text-base .font-serif .leading-snug.capsize::after {
    content: '';
    margin-top: -0.2875em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-normal.capsize::before, .font-serif .xl\\:text-base.leading-normal.capsize::before, .font-serif .xl\\:text-base .leading-normal.capsize::before,.xl\\:text-base .font-serif.leading-normal.capsize::before,.xl\\:text-base .font-serif .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-normal.capsize::after, .font-serif .xl\\:text-base.leading-normal.capsize::after, .font-serif .xl\\:text-base .leading-normal.capsize::after,.xl\\:text-base .font-serif.leading-normal.capsize::after,.xl\\:text-base .font-serif .leading-normal.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-relaxed.capsize::before, .font-serif .xl\\:text-base.leading-relaxed.capsize::before, .font-serif .xl\\:text-base .leading-relaxed.capsize::before,.xl\\:text-base .font-serif.leading-relaxed.capsize::before,.xl\\:text-base .font-serif .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4325em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-relaxed.capsize::after, .font-serif .xl\\:text-base.leading-relaxed.capsize::after, .font-serif .xl\\:text-base .leading-relaxed.capsize::after,.xl\\:text-base .font-serif.leading-relaxed.capsize::after,.xl\\:text-base .font-serif .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4125em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-loose.capsize::before, .font-serif .xl\\:text-base.leading-loose.capsize::before, .font-serif .xl\\:text-base .leading-loose.capsize::before,.xl\\:text-base .font-serif.leading-loose.capsize::before,.xl\\:text-base .font-serif .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .xl\\:text-base.font-serif.leading-loose.capsize::after, .font-serif .xl\\:text-base.leading-loose.capsize::after, .font-serif .xl\\:text-base .leading-loose.capsize::after,.xl\\:text-base .font-serif.leading-loose.capsize::after,.xl\\:text-base .font-serif .leading-loose.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-3.capsize::before, .font-serif .xl\\:text-3xl.leading-3.capsize::before, .font-serif .xl\\:text-3xl .leading-3.capsize::before,.xl\\:text-3xl .font-serif.leading-3.capsize::before,.xl\\:text-3xl .font-serif .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.18em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-3.capsize::after, .font-serif .xl\\:text-3xl.leading-3.capsize::after, .font-serif .xl\\:text-3xl .leading-3.capsize::after,.xl\\:text-3xl .font-serif.leading-3.capsize::after,.xl\\:text-3xl .font-serif .leading-3.capsize::after {
    content: '';
    margin-top: 0.2em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-4.capsize::before, .font-serif .xl\\:text-3xl.leading-4.capsize::before, .font-serif .xl\\:text-3xl .leading-4.capsize::before,.xl\\:text-3xl .font-serif.leading-4.capsize::before,.xl\\:text-3xl .font-serif .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.1133em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-4.capsize::after, .font-serif .xl\\:text-3xl.leading-4.capsize::after, .font-serif .xl\\:text-3xl .leading-4.capsize::after,.xl\\:text-3xl .font-serif.leading-4.capsize::after,.xl\\:text-3xl .font-serif .leading-4.capsize::after {
    content: '';
    margin-top: 0.1333em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-5.capsize::before, .font-serif .xl\\:text-3xl.leading-5.capsize::before, .font-serif .xl\\:text-3xl .leading-5.capsize::before,.xl\\:text-3xl .font-serif.leading-5.capsize::before,.xl\\:text-3xl .font-serif .leading-5.capsize::before {
    content: '';
    margin-bottom: 0.0467em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-5.capsize::after, .font-serif .xl\\:text-3xl.leading-5.capsize::after, .font-serif .xl\\:text-3xl .leading-5.capsize::after,.xl\\:text-3xl .font-serif.leading-5.capsize::after,.xl\\:text-3xl .font-serif .leading-5.capsize::after {
    content: '';
    margin-top: 0.0667em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-6.capsize::before, .font-serif .xl\\:text-3xl.leading-6.capsize::before, .font-serif .xl\\:text-3xl .leading-6.capsize::before,.xl\\:text-3xl .font-serif.leading-6.capsize::before,.xl\\:text-3xl .font-serif .leading-6.capsize::before {
    content: '';
    margin-bottom: -0.02em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-6.capsize::after, .font-serif .xl\\:text-3xl.leading-6.capsize::after, .font-serif .xl\\:text-3xl .leading-6.capsize::after,.xl\\:text-3xl .font-serif.leading-6.capsize::after,.xl\\:text-3xl .font-serif .leading-6.capsize::after {
    content: '';
    margin-top: 0em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-7.capsize::before, .font-serif .xl\\:text-3xl.leading-7.capsize::before, .font-serif .xl\\:text-3xl .leading-7.capsize::before,.xl\\:text-3xl .font-serif.leading-7.capsize::before,.xl\\:text-3xl .font-serif .leading-7.capsize::before {
    content: '';
    margin-bottom: -0.0867em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-7.capsize::after, .font-serif .xl\\:text-3xl.leading-7.capsize::after, .font-serif .xl\\:text-3xl .leading-7.capsize::after,.xl\\:text-3xl .font-serif.leading-7.capsize::after,.xl\\:text-3xl .font-serif .leading-7.capsize::after {
    content: '';
    margin-top: -0.0667em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-8.capsize::before, .font-serif .xl\\:text-3xl.leading-8.capsize::before, .font-serif .xl\\:text-3xl .leading-8.capsize::before,.xl\\:text-3xl .font-serif.leading-8.capsize::before,.xl\\:text-3xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: -0.1533em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-8.capsize::after, .font-serif .xl\\:text-3xl.leading-8.capsize::after, .font-serif .xl\\:text-3xl .leading-8.capsize::after,.xl\\:text-3xl .font-serif.leading-8.capsize::after,.xl\\:text-3xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: -0.1333em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-9.capsize::before, .font-serif .xl\\:text-3xl.leading-9.capsize::before, .font-serif .xl\\:text-3xl .leading-9.capsize::before,.xl\\:text-3xl .font-serif.leading-9.capsize::before,.xl\\:text-3xl .font-serif .leading-9.capsize::before {
    content: '';
    margin-bottom: -0.22em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-9.capsize::after, .font-serif .xl\\:text-3xl.leading-9.capsize::after, .font-serif .xl\\:text-3xl .leading-9.capsize::after,.xl\\:text-3xl .font-serif.leading-9.capsize::after,.xl\\:text-3xl .font-serif .leading-9.capsize::after {
    content: '';
    margin-top: -0.2em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-10.capsize::before, .font-serif .xl\\:text-3xl.leading-10.capsize::before, .font-serif .xl\\:text-3xl .leading-10.capsize::before,.xl\\:text-3xl .font-serif.leading-10.capsize::before,.xl\\:text-3xl .font-serif .leading-10.capsize::before {
    content: '';
    margin-bottom: -0.2867em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-10.capsize::after, .font-serif .xl\\:text-3xl.leading-10.capsize::after, .font-serif .xl\\:text-3xl .leading-10.capsize::after,.xl\\:text-3xl .font-serif.leading-10.capsize::after,.xl\\:text-3xl .font-serif .leading-10.capsize::after {
    content: '';
    margin-top: -0.2667em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-none.capsize::before, .font-serif .xl\\:text-3xl.leading-none.capsize::before, .font-serif .xl\\:text-3xl .leading-none.capsize::before,.xl\\:text-3xl .font-serif.leading-none.capsize::before,.xl\\:text-3xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-none.capsize::after, .font-serif .xl\\:text-3xl.leading-none.capsize::after, .font-serif .xl\\:text-3xl .leading-none.capsize::after,.xl\\:text-3xl .font-serif.leading-none.capsize::after,.xl\\:text-3xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-tight.capsize::before, .font-serif .xl\\:text-3xl.leading-tight.capsize::before, .font-serif .xl\\:text-3xl .leading-tight.capsize::before,.xl\\:text-3xl .font-serif.leading-tight.capsize::before,.xl\\:text-3xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-tight.capsize::after, .font-serif .xl\\:text-3xl.leading-tight.capsize::after, .font-serif .xl\\:text-3xl .leading-tight.capsize::after,.xl\\:text-3xl .font-serif.leading-tight.capsize::after,.xl\\:text-3xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-snug.capsize::before, .font-serif .xl\\:text-3xl.leading-snug.capsize::before, .font-serif .xl\\:text-3xl .leading-snug.capsize::before,.xl\\:text-3xl .font-serif.leading-snug.capsize::before,.xl\\:text-3xl .font-serif .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3075em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-snug.capsize::after, .font-serif .xl\\:text-3xl.leading-snug.capsize::after, .font-serif .xl\\:text-3xl .leading-snug.capsize::after,.xl\\:text-3xl .font-serif.leading-snug.capsize::after,.xl\\:text-3xl .font-serif .leading-snug.capsize::after {
    content: '';
    margin-top: -0.2875em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-normal.capsize::before, .font-serif .xl\\:text-3xl.leading-normal.capsize::before, .font-serif .xl\\:text-3xl .leading-normal.capsize::before,.xl\\:text-3xl .font-serif.leading-normal.capsize::before,.xl\\:text-3xl .font-serif .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-normal.capsize::after, .font-serif .xl\\:text-3xl.leading-normal.capsize::after, .font-serif .xl\\:text-3xl .leading-normal.capsize::after,.xl\\:text-3xl .font-serif.leading-normal.capsize::after,.xl\\:text-3xl .font-serif .leading-normal.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-relaxed.capsize::before, .font-serif .xl\\:text-3xl.leading-relaxed.capsize::before, .font-serif .xl\\:text-3xl .leading-relaxed.capsize::before,.xl\\:text-3xl .font-serif.leading-relaxed.capsize::before,.xl\\:text-3xl .font-serif .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4325em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-relaxed.capsize::after, .font-serif .xl\\:text-3xl.leading-relaxed.capsize::after, .font-serif .xl\\:text-3xl .leading-relaxed.capsize::after,.xl\\:text-3xl .font-serif.leading-relaxed.capsize::after,.xl\\:text-3xl .font-serif .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4125em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-loose.capsize::before, .font-serif .xl\\:text-3xl.leading-loose.capsize::before, .font-serif .xl\\:text-3xl .leading-loose.capsize::before,.xl\\:text-3xl .font-serif.leading-loose.capsize::before,.xl\\:text-3xl .font-serif .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .xl\\:text-3xl.font-serif.leading-loose.capsize::after, .font-serif .xl\\:text-3xl.leading-loose.capsize::after, .font-serif .xl\\:text-3xl .leading-loose.capsize::after,.xl\\:text-3xl .font-serif.leading-loose.capsize::after,.xl\\:text-3xl .font-serif .leading-loose.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-3.capsize::before, .font-serif .xl\\:text-8xl.leading-3.capsize::before, .font-serif .xl\\:text-8xl .leading-3.capsize::before,.xl\\:text-8xl .font-serif.leading-3.capsize::before,.xl\\:text-8xl .font-serif .leading-3.capsize::before {
    content: '';
    margin-bottom: 0.3175em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-3.capsize::after, .font-serif .xl\\:text-8xl.leading-3.capsize::after, .font-serif .xl\\:text-8xl .leading-3.capsize::after,.xl\\:text-8xl .font-serif.leading-3.capsize::after,.xl\\:text-8xl .font-serif .leading-3.capsize::after {
    content: '';
    margin-top: 0.3375em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-4.capsize::before, .font-serif .xl\\:text-8xl.leading-4.capsize::before, .font-serif .xl\\:text-8xl .leading-4.capsize::before,.xl\\:text-8xl .font-serif.leading-4.capsize::before,.xl\\:text-8xl .font-serif .leading-4.capsize::before {
    content: '';
    margin-bottom: 0.2967em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-4.capsize::after, .font-serif .xl\\:text-8xl.leading-4.capsize::after, .font-serif .xl\\:text-8xl .leading-4.capsize::after,.xl\\:text-8xl .font-serif.leading-4.capsize::after,.xl\\:text-8xl .font-serif .leading-4.capsize::after {
    content: '';
    margin-top: 0.3167em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-5.capsize::before, .font-serif .xl\\:text-8xl.leading-5.capsize::before, .font-serif .xl\\:text-8xl .leading-5.capsize::before,.xl\\:text-8xl .font-serif.leading-5.capsize::before,.xl\\:text-8xl .font-serif .leading-5.capsize::before {
    content: '';
    margin-bottom: 0.2758em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-5.capsize::after, .font-serif .xl\\:text-8xl.leading-5.capsize::after, .font-serif .xl\\:text-8xl .leading-5.capsize::after,.xl\\:text-8xl .font-serif.leading-5.capsize::after,.xl\\:text-8xl .font-serif .leading-5.capsize::after {
    content: '';
    margin-top: 0.2958em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-6.capsize::before, .font-serif .xl\\:text-8xl.leading-6.capsize::before, .font-serif .xl\\:text-8xl .leading-6.capsize::before,.xl\\:text-8xl .font-serif.leading-6.capsize::before,.xl\\:text-8xl .font-serif .leading-6.capsize::before {
    content: '';
    margin-bottom: 0.255em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-6.capsize::after, .font-serif .xl\\:text-8xl.leading-6.capsize::after, .font-serif .xl\\:text-8xl .leading-6.capsize::after,.xl\\:text-8xl .font-serif.leading-6.capsize::after,.xl\\:text-8xl .font-serif .leading-6.capsize::after {
    content: '';
    margin-top: 0.275em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-7.capsize::before, .font-serif .xl\\:text-8xl.leading-7.capsize::before, .font-serif .xl\\:text-8xl .leading-7.capsize::before,.xl\\:text-8xl .font-serif.leading-7.capsize::before,.xl\\:text-8xl .font-serif .leading-7.capsize::before {
    content: '';
    margin-bottom: 0.2342em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-7.capsize::after, .font-serif .xl\\:text-8xl.leading-7.capsize::after, .font-serif .xl\\:text-8xl .leading-7.capsize::after,.xl\\:text-8xl .font-serif.leading-7.capsize::after,.xl\\:text-8xl .font-serif .leading-7.capsize::after {
    content: '';
    margin-top: 0.2542em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-8.capsize::before, .font-serif .xl\\:text-8xl.leading-8.capsize::before, .font-serif .xl\\:text-8xl .leading-8.capsize::before,.xl\\:text-8xl .font-serif.leading-8.capsize::before,.xl\\:text-8xl .font-serif .leading-8.capsize::before {
    content: '';
    margin-bottom: 0.2133em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-8.capsize::after, .font-serif .xl\\:text-8xl.leading-8.capsize::after, .font-serif .xl\\:text-8xl .leading-8.capsize::after,.xl\\:text-8xl .font-serif.leading-8.capsize::after,.xl\\:text-8xl .font-serif .leading-8.capsize::after {
    content: '';
    margin-top: 0.2333em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-9.capsize::before, .font-serif .xl\\:text-8xl.leading-9.capsize::before, .font-serif .xl\\:text-8xl .leading-9.capsize::before,.xl\\:text-8xl .font-serif.leading-9.capsize::before,.xl\\:text-8xl .font-serif .leading-9.capsize::before {
    content: '';
    margin-bottom: 0.1925em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-9.capsize::after, .font-serif .xl\\:text-8xl.leading-9.capsize::after, .font-serif .xl\\:text-8xl .leading-9.capsize::after,.xl\\:text-8xl .font-serif.leading-9.capsize::after,.xl\\:text-8xl .font-serif .leading-9.capsize::after {
    content: '';
    margin-top: 0.2125em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-10.capsize::before, .font-serif .xl\\:text-8xl.leading-10.capsize::before, .font-serif .xl\\:text-8xl .leading-10.capsize::before,.xl\\:text-8xl .font-serif.leading-10.capsize::before,.xl\\:text-8xl .font-serif .leading-10.capsize::before {
    content: '';
    margin-bottom: 0.1717em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-10.capsize::after, .font-serif .xl\\:text-8xl.leading-10.capsize::after, .font-serif .xl\\:text-8xl .leading-10.capsize::after,.xl\\:text-8xl .font-serif.leading-10.capsize::after,.xl\\:text-8xl .font-serif .leading-10.capsize::after {
    content: '';
    margin-top: 0.1917em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-none.capsize::before, .font-serif .xl\\:text-8xl.leading-none.capsize::before, .font-serif .xl\\:text-8xl .leading-none.capsize::before,.xl\\:text-8xl .font-serif.leading-none.capsize::before,.xl\\:text-8xl .font-serif .leading-none.capsize::before {
    content: '';
    margin-bottom: -0.12em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-none.capsize::after, .font-serif .xl\\:text-8xl.leading-none.capsize::after, .font-serif .xl\\:text-8xl .leading-none.capsize::after,.xl\\:text-8xl .font-serif.leading-none.capsize::after,.xl\\:text-8xl .font-serif .leading-none.capsize::after {
    content: '';
    margin-top: -0.1em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-tight.capsize::before, .font-serif .xl\\:text-8xl.leading-tight.capsize::before, .font-serif .xl\\:text-8xl .leading-tight.capsize::before,.xl\\:text-8xl .font-serif.leading-tight.capsize::before,.xl\\:text-8xl .font-serif .leading-tight.capsize::before {
    content: '';
    margin-bottom: -0.245em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-tight.capsize::after, .font-serif .xl\\:text-8xl.leading-tight.capsize::after, .font-serif .xl\\:text-8xl .leading-tight.capsize::after,.xl\\:text-8xl .font-serif.leading-tight.capsize::after,.xl\\:text-8xl .font-serif .leading-tight.capsize::after {
    content: '';
    margin-top: -0.225em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-snug.capsize::before, .font-serif .xl\\:text-8xl.leading-snug.capsize::before, .font-serif .xl\\:text-8xl .leading-snug.capsize::before,.xl\\:text-8xl .font-serif.leading-snug.capsize::before,.xl\\:text-8xl .font-serif .leading-snug.capsize::before {
    content: '';
    margin-bottom: -0.3075em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-snug.capsize::after, .font-serif .xl\\:text-8xl.leading-snug.capsize::after, .font-serif .xl\\:text-8xl .leading-snug.capsize::after,.xl\\:text-8xl .font-serif.leading-snug.capsize::after,.xl\\:text-8xl .font-serif .leading-snug.capsize::after {
    content: '';
    margin-top: -0.2875em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-normal.capsize::before, .font-serif .xl\\:text-8xl.leading-normal.capsize::before, .font-serif .xl\\:text-8xl .leading-normal.capsize::before,.xl\\:text-8xl .font-serif.leading-normal.capsize::before,.xl\\:text-8xl .font-serif .leading-normal.capsize::before {
    content: '';
    margin-bottom: -0.37em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-normal.capsize::after, .font-serif .xl\\:text-8xl.leading-normal.capsize::after, .font-serif .xl\\:text-8xl .leading-normal.capsize::after,.xl\\:text-8xl .font-serif.leading-normal.capsize::after,.xl\\:text-8xl .font-serif .leading-normal.capsize::after {
    content: '';
    margin-top: -0.35em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-relaxed.capsize::before, .font-serif .xl\\:text-8xl.leading-relaxed.capsize::before, .font-serif .xl\\:text-8xl .leading-relaxed.capsize::before,.xl\\:text-8xl .font-serif.leading-relaxed.capsize::before,.xl\\:text-8xl .font-serif .leading-relaxed.capsize::before {
    content: '';
    margin-bottom: -0.4325em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-relaxed.capsize::after, .font-serif .xl\\:text-8xl.leading-relaxed.capsize::after, .font-serif .xl\\:text-8xl .leading-relaxed.capsize::after,.xl\\:text-8xl .font-serif.leading-relaxed.capsize::after,.xl\\:text-8xl .font-serif .leading-relaxed.capsize::after {
    content: '';
    margin-top: -0.4125em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-loose.capsize::before, .font-serif .xl\\:text-8xl.leading-loose.capsize::before, .font-serif .xl\\:text-8xl .leading-loose.capsize::before,.xl\\:text-8xl .font-serif.leading-loose.capsize::before,.xl\\:text-8xl .font-serif .leading-loose.capsize::before {
    content: '';
    margin-bottom: -0.62em;
    display: table;
  }

  .xl\\:text-8xl.font-serif.leading-loose.capsize::after, .font-serif .xl\\:text-8xl.leading-loose.capsize::after, .font-serif .xl\\:text-8xl .leading-loose.capsize::after,.xl\\:text-8xl .font-serif.leading-loose.capsize::after,.xl\\:text-8xl .font-serif .leading-loose.capsize::after {
    content: '';
    margin-top: -0.6em;
    display: table;
  }
}
@media (min-width: 1380px) {

  .\\32xl\\:\\!-left-6 {
    left: -1.5rem !important;
  }

  .\\32xl\\:\\!-right-6 {
    right: -1.5rem !important;
  }

  .\\32xl\\:px-24 {
    padding-left: 6rem;
    padding-right: 6rem;
  }
}
.\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar {
  display: none;
}
.\\[\\&\\>\\*\\:last-child\\]\\:\\!mb-0>*:last-child {
  margin-bottom: 0px !important;
}
.\\[\\&\\>\\:last-child\\]\\:\\!mb-0>:last-child {
  margin-bottom: 0px !important;
}
.\\[\\&\\>p\\]\\:max-w-3xl>p {
  max-width: 48rem;
}
@media (min-width: 992px) {

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p {
    font-size: 1.125rem !important;
    line-height: 1.75rem !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-3.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-3.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-3.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-3.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-3.capsize::before {
    content: '' !important;
    margin-bottom: 0.0097em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-3.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-3.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-3.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-3.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-3.capsize::after {
    content: '' !important;
    margin-top: 0.0537em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-4.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-4.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-4.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-4.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-4.capsize::before {
    content: '' !important;
    margin-bottom: -0.1014em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-4.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-4.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-4.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-4.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-4.capsize::after {
    content: '' !important;
    margin-top: -0.0574em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-5.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-5.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-5.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-5.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-5.capsize::before {
    content: '' !important;
    margin-bottom: -0.2126em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-5.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-5.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-5.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-5.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-5.capsize::after {
    content: '' !important;
    margin-top: -0.1686em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-6.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-6.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-6.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-6.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-6.capsize::before {
    content: '' !important;
    margin-bottom: -0.3237em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-6.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-6.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-6.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-6.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-6.capsize::after {
    content: '' !important;
    margin-top: -0.2797em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-7.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-7.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-7.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-7.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-7.capsize::before {
    content: '' !important;
    margin-bottom: -0.4348em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-7.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-7.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-7.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-7.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-7.capsize::after {
    content: '' !important;
    margin-top: -0.3908em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-8.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-8.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-8.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-8.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-8.capsize::before {
    content: '' !important;
    margin-bottom: -0.5459em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-8.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-8.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-8.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-8.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-8.capsize::after {
    content: '' !important;
    margin-top: -0.5019em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-9.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-9.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-9.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-9.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-9.capsize::before {
    content: '' !important;
    margin-bottom: -0.657em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-9.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-9.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-9.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-9.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-9.capsize::after {
    content: '' !important;
    margin-top: -0.613em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-10.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-10.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-10.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-10.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-10.capsize::before {
    content: '' !important;
    margin-bottom: -0.7681em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-10.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-10.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-10.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-10.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-10.capsize::after {
    content: '' !important;
    margin-top: -0.7241em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-none.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-none.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-none.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-none.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-none.capsize::before {
    content: '' !important;
    margin-bottom: -0.157em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-none.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-none.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-none.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-none.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-none.capsize::after {
    content: '' !important;
    margin-top: -0.113em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-tight.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-tight.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-tight.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-tight.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-tight.capsize::before {
    content: '' !important;
    margin-bottom: -0.282em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-tight.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-tight.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-tight.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-tight.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-tight.capsize::after {
    content: '' !important;
    margin-top: -0.238em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-snug.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-snug.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-snug.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-snug.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-snug.capsize::before {
    content: '' !important;
    margin-bottom: -0.3445em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-snug.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-snug.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-snug.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-snug.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-snug.capsize::after {
    content: '' !important;
    margin-top: -0.3005em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-normal.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-normal.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-normal.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-normal.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-normal.capsize::before {
    content: '' !important;
    margin-bottom: -0.407em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-normal.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-normal.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-normal.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-normal.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-normal.capsize::after {
    content: '' !important;
    margin-top: -0.363em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-relaxed.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-relaxed.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-relaxed.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-relaxed.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-relaxed.capsize::before {
    content: '' !important;
    margin-bottom: -0.4695em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-relaxed.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-relaxed.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-relaxed.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-relaxed.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-relaxed.capsize::after {
    content: '' !important;
    margin-top: -0.4255em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-loose.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-loose.capsize::before, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-loose.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-loose.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-loose.capsize::before {
    content: '' !important;
    margin-bottom: -0.657em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-sans.leading-loose.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-loose.capsize::after, .font-sans .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-loose.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans.leading-loose.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-sans .leading-loose.capsize::after {
    content: '' !important;
    margin-top: -0.613em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-3.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-3.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-3.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-3.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-3.capsize::before {
    content: '' !important;
    margin-bottom: 0.0467em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-3.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-3.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-3.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-3.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-3.capsize::after {
    content: '' !important;
    margin-top: 0.0667em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-4.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-4.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-4.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-4.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-4.capsize::before {
    content: '' !important;
    margin-bottom: -0.0644em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-4.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-4.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-4.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-4.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-4.capsize::after {
    content: '' !important;
    margin-top: -0.0444em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-5.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-5.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-5.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-5.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-5.capsize::before {
    content: '' !important;
    margin-bottom: -0.1756em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-5.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-5.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-5.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-5.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-5.capsize::after {
    content: '' !important;
    margin-top: -0.1556em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-6.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-6.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-6.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-6.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-6.capsize::before {
    content: '' !important;
    margin-bottom: -0.2867em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-6.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-6.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-6.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-6.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-6.capsize::after {
    content: '' !important;
    margin-top: -0.2667em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-7.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-7.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-7.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-7.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-7.capsize::before {
    content: '' !important;
    margin-bottom: -0.3978em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-7.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-7.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-7.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-7.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-7.capsize::after {
    content: '' !important;
    margin-top: -0.3778em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-8.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-8.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-8.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-8.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-8.capsize::before {
    content: '' !important;
    margin-bottom: -0.5089em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-8.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-8.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-8.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-8.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-8.capsize::after {
    content: '' !important;
    margin-top: -0.4889em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-9.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-9.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-9.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-9.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-9.capsize::before {
    content: '' !important;
    margin-bottom: -0.62em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-9.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-9.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-9.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-9.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-9.capsize::after {
    content: '' !important;
    margin-top: -0.6em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-10.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-10.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-10.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-10.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-10.capsize::before {
    content: '' !important;
    margin-bottom: -0.7311em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-10.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-10.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-10.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-10.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-10.capsize::after {
    content: '' !important;
    margin-top: -0.7111em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-none.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-none.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-none.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-none.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-none.capsize::before {
    content: '' !important;
    margin-bottom: -0.12em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-none.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-none.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-none.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-none.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-none.capsize::after {
    content: '' !important;
    margin-top: -0.1em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-tight.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-tight.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-tight.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-tight.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-tight.capsize::before {
    content: '' !important;
    margin-bottom: -0.245em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-tight.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-tight.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-tight.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-tight.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-tight.capsize::after {
    content: '' !important;
    margin-top: -0.225em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-snug.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-snug.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-snug.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-snug.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-snug.capsize::before {
    content: '' !important;
    margin-bottom: -0.3075em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-snug.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-snug.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-snug.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-snug.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-snug.capsize::after {
    content: '' !important;
    margin-top: -0.2875em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-normal.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-normal.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-normal.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-normal.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-normal.capsize::before {
    content: '' !important;
    margin-bottom: -0.37em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-normal.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-normal.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-normal.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-normal.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-normal.capsize::after {
    content: '' !important;
    margin-top: -0.35em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-relaxed.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-relaxed.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-relaxed.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-relaxed.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-relaxed.capsize::before {
    content: '' !important;
    margin-bottom: -0.4325em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-relaxed.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-relaxed.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-relaxed.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-relaxed.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-relaxed.capsize::after {
    content: '' !important;
    margin-top: -0.4125em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-loose.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-loose.capsize::before, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-loose.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-loose.capsize::before,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-loose.capsize::before {
    content: '' !important;
    margin-bottom: -0.62em !important;
    display: table !important;
  }

  .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.font-serif.leading-loose.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p.leading-loose.capsize::after, .font-serif .\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .leading-loose.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif.leading-loose.capsize::after,.\\[\\&\\>p\\]\\:lg\\:\\!text-lg>p .font-serif .leading-loose.capsize::after {
    content: '' !important;
    margin-top: -0.6em !important;
    display: table !important;
  }
}
.\\[\\&\\>ul\\>li\\>p\\]\\:\\!mb-0>ul>li>p {
  margin-bottom: 0px !important;
}
.\\[\\&\\>ul\\]\\:\\!mb-6>ul {
  margin-bottom: 1.5rem !important;
}
.\\[\\&_p\\:last-child\\]\\:\\!mb-0 p:last-child {
  margin-bottom: 0px !important;
}
.\\[\\&_p\\]\\:\\!mb-0 p {
  margin-bottom: 0px !important;
}
.\\[\\&_p\\]\\:\\!text-sm p {
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-3.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-3.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-3.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-3.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: -0.0856em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-3.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-3.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-3.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-3.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-3.capsize::after {
  content: '' !important;
  margin-top: -0.0416em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-4.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-4.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-4.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-4.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.2284em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-4.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-4.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-4.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-4.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-4.capsize::after {
  content: '' !important;
  margin-top: -0.1844em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-5.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-5.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-5.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-5.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.3713em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-5.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-5.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-5.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-5.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.3273em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-6.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-6.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-6.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-6.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.5141em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-6.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-6.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-6.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-6.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.4701em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-7.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-7.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-7.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-7.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-7.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-7.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-7.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-7.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-8.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-8.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-8.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-8.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.7999em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-8.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-8.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-8.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-8.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.7559em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-9.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-9.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-9.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-9.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.9427em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-9.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-9.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-9.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-9.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.8987em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-10.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-10.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-10.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-10.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -1.0856em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-10.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-10.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-10.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-10.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-10.capsize::after {
  content: '' !important;
  margin-top: -1.0416em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-none.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-none.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-none.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-none.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-none.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-none.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-none.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-none.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-tight.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-tight.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-tight.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-tight.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-tight.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-tight.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-tight.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-tight.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-snug.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-snug.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-snug.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-snug.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-snug.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-snug.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-snug.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-snug.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-normal.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-normal.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-normal.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-normal.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-normal.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-normal.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-normal.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-normal.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-relaxed.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-relaxed.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-relaxed.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-relaxed.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-relaxed.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-relaxed.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-relaxed.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-relaxed.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-loose.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-loose.capsize::before, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-loose.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-loose.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-sans.leading-loose.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p.leading-loose.capsize::after, .font-sans .\\[\\&_p\\]\\:\\!text-sm p .leading-loose.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans.leading-loose.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-sans .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-3.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-3.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-3.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-3.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: -0.0486em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-3.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-3.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-3.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-3.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-3.capsize::after {
  content: '' !important;
  margin-top: -0.0286em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-4.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-4.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-4.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-4.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.1914em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-4.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-4.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-4.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-4.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-4.capsize::after {
  content: '' !important;
  margin-top: -0.1714em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-5.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-5.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-5.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-5.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.3343em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-5.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-5.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-5.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-5.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.3143em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-6.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-6.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-6.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-6.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.4771em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-6.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-6.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-6.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-6.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.4571em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-7.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-7.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-7.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-7.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.62em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-7.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-7.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-7.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-7.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.6em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-8.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-8.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-8.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-8.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.7629em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-8.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-8.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-8.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-8.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.7429em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-9.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-9.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-9.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-9.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.9057em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-9.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-9.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-9.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-9.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.8857em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-10.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-10.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-10.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-10.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -1.0486em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-10.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-10.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-10.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-10.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-10.capsize::after {
  content: '' !important;
  margin-top: -1.0286em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-none.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-none.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-none.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-none.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.12em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-none.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-none.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-none.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-none.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.1em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-tight.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-tight.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-tight.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-tight.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.245em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-tight.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-tight.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-tight.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-tight.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.225em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-snug.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-snug.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-snug.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-snug.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3075em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-snug.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-snug.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-snug.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-snug.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.2875em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-normal.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-normal.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-normal.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-normal.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.37em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-normal.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-normal.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-normal.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-normal.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.35em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-relaxed.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-relaxed.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-relaxed.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-relaxed.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4325em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-relaxed.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-relaxed.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-relaxed.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-relaxed.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4125em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-loose.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-loose.capsize::before, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-loose.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-loose.capsize::before,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.62em !important;
  display: table !important;
}
.\\[\\&_p\\]\\:\\!text-sm p.font-serif.leading-loose.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p.leading-loose.capsize::after, .font-serif .\\[\\&_p\\]\\:\\!text-sm p .leading-loose.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif.leading-loose.capsize::after,.\\[\\&_p\\]\\:\\!text-sm p .font-serif .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.6em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong {
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-3.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-3.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-3.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-3.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: -0.0856em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-3.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-3.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-3.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-3.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-3.capsize::after {
  content: '' !important;
  margin-top: -0.0416em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-4.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-4.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-4.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-4.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.2284em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-4.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-4.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-4.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-4.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-4.capsize::after {
  content: '' !important;
  margin-top: -0.1844em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-5.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-5.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-5.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-5.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.3713em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-5.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-5.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-5.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-5.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.3273em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-6.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-6.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-6.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-6.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.5141em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-6.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-6.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-6.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-6.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.4701em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-7.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-7.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-7.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-7.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-7.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-7.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-7.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-7.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-8.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-8.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-8.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-8.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.7999em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-8.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-8.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-8.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-8.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.7559em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-9.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-9.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-9.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-9.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.9427em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-9.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-9.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-9.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-9.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.8987em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-10.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-10.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-10.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-10.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -1.0856em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-10.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-10.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-10.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-10.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-10.capsize::after {
  content: '' !important;
  margin-top: -1.0416em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-none.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-none.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-none.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-none.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.157em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-none.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-none.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-none.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-none.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.113em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-tight.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-tight.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-tight.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-tight.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.282em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-tight.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-tight.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-tight.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-tight.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.238em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-snug.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-snug.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-snug.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-snug.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3445em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-snug.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-snug.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-snug.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-snug.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.3005em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-normal.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-normal.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-normal.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-normal.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.407em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-normal.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-normal.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-normal.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-normal.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.363em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-relaxed.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-relaxed.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-relaxed.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-relaxed.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4695em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-relaxed.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-relaxed.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-relaxed.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-relaxed.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4255em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-loose.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-loose.capsize::before, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-loose.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-loose.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.657em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-sans.leading-loose.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong.leading-loose.capsize::after, .font-sans .\\[\\&_strong\\]\\:\\!text-sm strong .leading-loose.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans.leading-loose.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-sans .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.613em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-3.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-3.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-3.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-3.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-3.capsize::before {
  content: '' !important;
  margin-bottom: -0.0486em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-3.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-3.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-3.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-3.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-3.capsize::after {
  content: '' !important;
  margin-top: -0.0286em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-4.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-4.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-4.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-4.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-4.capsize::before {
  content: '' !important;
  margin-bottom: -0.1914em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-4.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-4.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-4.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-4.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-4.capsize::after {
  content: '' !important;
  margin-top: -0.1714em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-5.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-5.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-5.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-5.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-5.capsize::before {
  content: '' !important;
  margin-bottom: -0.3343em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-5.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-5.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-5.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-5.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-5.capsize::after {
  content: '' !important;
  margin-top: -0.3143em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-6.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-6.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-6.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-6.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-6.capsize::before {
  content: '' !important;
  margin-bottom: -0.4771em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-6.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-6.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-6.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-6.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-6.capsize::after {
  content: '' !important;
  margin-top: -0.4571em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-7.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-7.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-7.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-7.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-7.capsize::before {
  content: '' !important;
  margin-bottom: -0.62em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-7.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-7.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-7.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-7.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-7.capsize::after {
  content: '' !important;
  margin-top: -0.6em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-8.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-8.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-8.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-8.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-8.capsize::before {
  content: '' !important;
  margin-bottom: -0.7629em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-8.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-8.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-8.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-8.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-8.capsize::after {
  content: '' !important;
  margin-top: -0.7429em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-9.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-9.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-9.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-9.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-9.capsize::before {
  content: '' !important;
  margin-bottom: -0.9057em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-9.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-9.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-9.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-9.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-9.capsize::after {
  content: '' !important;
  margin-top: -0.8857em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-10.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-10.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-10.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-10.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-10.capsize::before {
  content: '' !important;
  margin-bottom: -1.0486em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-10.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-10.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-10.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-10.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-10.capsize::after {
  content: '' !important;
  margin-top: -1.0286em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-none.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-none.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-none.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-none.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-none.capsize::before {
  content: '' !important;
  margin-bottom: -0.12em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-none.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-none.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-none.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-none.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-none.capsize::after {
  content: '' !important;
  margin-top: -0.1em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-tight.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-tight.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-tight.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-tight.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-tight.capsize::before {
  content: '' !important;
  margin-bottom: -0.245em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-tight.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-tight.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-tight.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-tight.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-tight.capsize::after {
  content: '' !important;
  margin-top: -0.225em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-snug.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-snug.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-snug.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-snug.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-snug.capsize::before {
  content: '' !important;
  margin-bottom: -0.3075em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-snug.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-snug.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-snug.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-snug.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-snug.capsize::after {
  content: '' !important;
  margin-top: -0.2875em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-normal.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-normal.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-normal.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-normal.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-normal.capsize::before {
  content: '' !important;
  margin-bottom: -0.37em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-normal.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-normal.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-normal.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-normal.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-normal.capsize::after {
  content: '' !important;
  margin-top: -0.35em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-relaxed.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-relaxed.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-relaxed.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-relaxed.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-relaxed.capsize::before {
  content: '' !important;
  margin-bottom: -0.4325em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-relaxed.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-relaxed.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-relaxed.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-relaxed.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-relaxed.capsize::after {
  content: '' !important;
  margin-top: -0.4125em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-loose.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-loose.capsize::before, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-loose.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-loose.capsize::before,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-loose.capsize::before {
  content: '' !important;
  margin-bottom: -0.62em !important;
  display: table !important;
}
.\\[\\&_strong\\]\\:\\!text-sm strong.font-serif.leading-loose.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong.leading-loose.capsize::after, .font-serif .\\[\\&_strong\\]\\:\\!text-sm strong .leading-loose.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif.leading-loose.capsize::after,.\\[\\&_strong\\]\\:\\!text-sm strong .font-serif .leading-loose.capsize::after {
  content: '' !important;
  margin-top: -0.6em !important;
  display: table !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/tailwind.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,iCAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;EAAd;EAAA,iBAAc;EAAd,mCAAc;EAAd,kCAAc;IAAd,kCAAc;IAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AA4BlB;IACE,2BAA2B;IAC3B,gCAAgC;IAChC,mCAAmC;IACnC,+BAA+B;EACjC;AAhCF;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,UAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,yHAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAqCjB,gDAAgD;AAChD;IACE,aAAa;EACf;AACA,4CAA4C;AAC5C;IACE,wBAAwB,EAAE,gBAAgB;IAC1C,qBAAqB,EAAE,YAAY;EACrC;AAEA;IACE,4BAA4B;EAC9B;AAjDF;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAEnB;;;;;;;CAOC;AA0BD,wBAAwB;AAiBxB,UAAU;AAGR;EAAA,uBAA8C;EAA9C,4CAA8C;EAA9C,2BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,8BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,iCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,8BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,iCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,8BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,iCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,8BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,iCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,8BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,iCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,8BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,8BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,iCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,8BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,iCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,8BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,iCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,8BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,iCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,8BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,iCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,8BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,iCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,8BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,iCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,8BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,8BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,iCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,6BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,iCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,6BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,kCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,mCAA8C;EAA9C;AAA8C;AAA9C;EAAA,sBAA8C;EAA9C,gCAA8C;EAA9C;AAA8C;AAI9C;EAAA;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,8BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,iCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,8BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,iCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,8BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,iCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,8BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,iCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,8BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,iCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,8BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,8BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,iCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,8BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,iCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,8BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,iCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,8BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,iCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,8BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,iCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,8BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,iCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,8BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,iCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,8BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,8BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAIjB;EAAA,sBAA4B;EAA5B,oBAA4B;EAA5B;AAA4B;AAA5B;;EAAA;IAAA,oBAA4B;IAA5B;EAA4B;AAAA;AAG5B;EAAA,sBAAuC;EAAvC;AAAuC;AAAvC;;EAAA;IAAA;EAAuC;AAAA;AAIvC;EAAA;AAAa;AAIb;EAAA,aAAgC;EAAhC,mBAAgC;EAAhC,oBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,sBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,mBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,uBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,oBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,uBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,oBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,uBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,oBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,wBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,qBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,wBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,qBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,uBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,oBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,wBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,qBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,uBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,oBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,uBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,oBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,wBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,qBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,uBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,oBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,wBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,qBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,uBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,oBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,qBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,iBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,uBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,oBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,uBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,oBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,sBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,eAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,wBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,qBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,wBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,qBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,sBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,kBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,wBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,qBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,sBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,kBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,uBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,oBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,wBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,qBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,sBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,mBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,wBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,qBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,sBAAgC;EAAhC;AAAgC;AAAhC;EAAA,WAAgC;EAAhC,kBAAgC;EAAhC;AAAgC;AAIhC;EAAA;AAAW;AAIX;EAAA,mBAAqC;EAArC,oBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,sBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,mBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,uBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,oBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,uBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,oBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,uBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,oBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,wBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,qBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,wBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,qBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,uBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,oBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,wBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,qBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,uBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,oBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,uBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,oBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,wBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,qBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,uBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,oBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,wBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,qBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,uBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,oBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,qBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,iBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,uBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,oBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,uBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,oBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,sBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,eAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,wBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,qBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,wBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,qBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,sBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,kBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,wBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,qBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,sBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,kBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,uBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,oBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,wBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,qBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,sBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,mBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,wBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,qBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,sBAAqC;EAArC;AAAqC;AAArC;EAAA,WAAqC;EAArC,kBAAqC;EAArC;AAAqC;AAArC;;EAAA;IAAA,eAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,sBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,mBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,uBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,oBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,uBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,oBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,sBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,mBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,uBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,oBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,uBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,oBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,uBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,mBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,wBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,qBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,uBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,oBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,uBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,oBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,wBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,qBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,uBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,oBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,wBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,qBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,uBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,oBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,sBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,mBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,uBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,oBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,uBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,oBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,qBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,kBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,uBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,oBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,uBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,oBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,sBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,mBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,wBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,qBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,sBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,kBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,uBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,oBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,wBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,qBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,sBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,mBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,wBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,qBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,sBAAqC;IAArC;EAAqC;;EAArC;IAAA,WAAqC;IAArC,kBAAqC;IAArC;EAAqC;AAAA;AAIrC;EAAA;AAAW;AAIX;EAAA,aAAqC;EAArC,WAAqC;EAArC;AAAqC;AAIrC;EAAA,YAA+F;EAA/F,kBAA+F;EAA/F,kBAA+F;EAA/F,sDAA+F;EAA/F,kBAA+F;EAA/F,mBAA+F;EAA/F,mBAA+F;EAA/F,sBAA+F;EAA/F,gBAA+F;EAA/F,yBAA+F;EAA/F,sBAA+F;EAA/F,oBAA+F;EAA/F;AAA+F;AAQ/F;;;;;EAAA,6BAA8C;EAA9C,gBAA8C;EAA9C,oBAA8C;EAA9C;AAA8C;AAI9C;EAAA;AAAW;AAIX;EAAA;AAAa;AAIb;EAAA,gBAAuB;EAAvB;AAAuB;AAIvB;EAAA,WAA4F;EAA5F,YAA4F;EAA5F,YAA4F;EAA5F,kBAA4F;EAA5F,aAA4F;EAA5F,gBAA4F;EAA5F,yBAA4F;EAA5F,cAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,uBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,oBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,uBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,oBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,uBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,oBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,uBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,oBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,uBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,oBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,uBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,oBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,uBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,oBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,uBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,oBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,uBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,oBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,uBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,oBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,uBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,oBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,uBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,oBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,uBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,oBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,uBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,oBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,uBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,oBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,sBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,kBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,sBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,kBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,sBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,kBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,sBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,kBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,sBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,kBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,sBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,kBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,sBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,kBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,sBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,kBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,sBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,kBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,sBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,kBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,sBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,kBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,sBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,kBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,sBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,kBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,sBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,kBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,sBAA4F;EAA5F;AAA4F;AAA5F;EAAA,WAA4F;EAA5F,kBAA4F;EAA5F;AAA4F;AAI5F;EAAA;AAAW;AAGb,YAAY;AAOV;;;;;EAAA,kBAA6C;EAA7C,kBAA6C;EAA7C;AAA6C;AAI7C;EAAA,aAA0G;EAA1G,yBAA0G;EAA1G,gDAA0G;EAA1G,6CAA0G;EAA1G;AAA0G;AAA1G;;EAAA;IAAA;EAA0G;AAAA;AAA1G;;EAAA;IAAA,gDAA0G;IAA1G;EAA0G;AAAA;AAM1G;;;EAAA;AAAa;AAIb;EAAA,aAAgD;EAAhD,mBAAgD;EAAhD,uBAAgD;EAAhD,kBAAgD;EAAhD;AAAgD;AAIhD;EAAA,gBAAwD;EAAxD,yBAAwD;EAAxD,sBAAwD;EAAxD,oBAAwD;EAAxD;AAAwD;AAIxD;EAAA;AAAiB;AAIjB;EAAA;AAAiB;AAIjB;EAAA;AAAa;AAIb;EAAA;AAA6C;AAA7C;;EAAA;IAAA;EAA6C;AAAA;AAA7C;;EAAA;IAAA;EAA6C;AAAA;AAI7C;EAAA,mBAAgB;EAAhB;AAAgB;AAKhB;;EAAA,WAAqB;EAArB;AAAqB;AAGvB,2DAA2D;AAQzD;;EAAA;;;;;;;IAAA;EAAqB;AAAA;AAMrB;;;EAAA;AAAqB;AAIrB;EAAA;AAAW;AAIX;EAAA;AAAmB;AAInB;EAAA,YAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,wBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,qBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,wBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,qBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,uBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,oBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,wBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,qBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,uBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,oBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,wBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,qBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,wBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,qBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,wBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,qBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,wBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,qBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,uBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,oBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,uBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,oBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,uBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,oBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,uBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,oBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,wBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,qBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,uBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,oBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,wBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,qBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,wBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,qBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,sBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,mBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,wBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,qBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,sBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,kBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,wBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,qBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,wBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,qBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,wBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,qBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,wBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,qBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,uBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,oBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,uBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,oBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,uBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,oBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,uBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,oBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,wBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,qBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,uBAAwB;EAAxB;AAAwB;AAAxB;EAAA,WAAwB;EAAxB,oBAAwB;EAAxB;AAAwB;AAUxB;;;;;;;EAAA,YAAwC;EAAxC,WAAwC;EAAxC,kBAAwC;EAAxC,kBAAwC;EAAxC;AAAwC;AAKxC;;EAAA,YAA4B;EAA5B,WAA4B;EAA5B,kBAA4B;EAA5B;AAA4B;AAI5B;EAAA,6BAAe;EAAf;AAAe;AAIf;EAAA;AAAY;AAOZ;;;;EAAA,wBAA2C;EAA3C,mBAA2C;EAA3C,sBAA2C;EAA3C;AAA2C;AAY3C;;;;;;;;;EAAA,YAAoF;EAApF,WAAoF;EAApF,eAAoF;EAApF,kBAAoF;EAApF,wBAAoF;EAApF,kBAAoF;EAApF,sBAAoF;EAApF,sDAAoF;EAApF;AAAoF;AAIpF;EAAA;AAAiB;AAKjB;;EAAA,YAAuF;EAAvF,kBAAuF;EAAvF,sBAAuF;EAAvF,uBAAuF;EAAvF,wBAAuF;EAAvF,qBAAuF;EAAvF,sBAAuF;EAAvF,sDAAuF;EAAvF,6BAAuF;EAAvF,oEAAuF;EAAvF;AAAuF;AAIvF;EAAA,8BAA8B;EAA9B,+BAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,mCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,gCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,mCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,gCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,mCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,gCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,mCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,gCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,kCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,+BAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,mCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,gCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,mCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,gCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,mCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,gCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,kCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,+BAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,kCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,+BAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,mCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,gCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,kCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,+BAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,mCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,gCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,kCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,+BAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,mCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,gCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,mCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,gCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,mCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,gCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,mCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,gCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,iCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,6BAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,mCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,gCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,mCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,gCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,mCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,gCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,iCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,6BAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,kCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,+BAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,mCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,gCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,iCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,8BAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,mCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,gCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,iCAA8B;EAA9B;AAA8B;AAA9B;EAAA,sBAA8B;EAA9B,6BAA8B;EAA9B;AAA8B;AAI9B;EAAA,eAAiC;EAAjC,WAAiC;EAAjC,sBAAiC;EAAjC;AAAiC;AAIjC;EAAA;AAAa;AAIb;EAAA;AAAe;AAGjB,YAAY;AAGV;EAAA,QAAyC;EAAzC,WAAyC;EAAzC,kBAAyC;EAAzC,yDAAyC;EAAzC;AAAyC;AAAzC;;EAAA;IAAA;EAAyC;AAAA;AAIzC;EAAA;AAA6B;AAA7B;;EAAA;IAAA;EAA6B;AAAA;AAI7B;EAAA,eAA8B;EAA9B,kBAA8B;EAA9B,WAA8B;EAA9B;AAA8B;AAA9B;;EAAA;IAAA;EAA8B;AAAA;AAI9B;EAAA;AAAa;AAIb;EAAA;AAAa;AAIb;EAAA,kBAAwB;EAAxB,yDAAwB;EAAxB,oBAAwB;EAAxB,qBAAwB;EAAxB;AAAwB;AAIxB;EAAA,6BAAyB;EAAzB,4BAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,kCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,+BAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,mCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,gCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,mCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,gCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,kCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,+BAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,mCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,gCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,mCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,gCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,kCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,+BAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,mCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,gCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,kCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,+BAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,kCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,+BAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,mCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,gCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,kCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,+BAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,mCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,gCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,kCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,+BAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,iCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,6BAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,mCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,gCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,mCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,gCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,iCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,6BAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,mCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,gCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,mCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,gCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,iCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,6BAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,mCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,gCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,iCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,6BAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,kCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,+BAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,mCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,gCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,iCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,8BAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,mCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,gCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,iCAAyB;EAAzB;AAAyB;AAAzB;EAAA,sBAAyB;EAAzB,6BAAyB;EAAzB;AAAyB;AAIzB;EAAA,eAAkB;EAAlB,kBAAkB;EAAlB;AAAkB;AAIlB;EAAA;AAAW;AAIX;EAAA,WAAyB;EAAzB;AAAyB;AASzB;;;;;;EAAA,iBAA2B;EAA3B,6BAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,kCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,+BAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,mCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,gCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,mCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,gCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,kCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,+BAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,mCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,gCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,mCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,gCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,kCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,+BAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,mCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,gCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,kCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,+BAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,kCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,+BAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,mCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,gCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,kCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,+BAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,mCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,gCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,kCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,+BAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,iCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,6BAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,mCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,gCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,mCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,gCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,iCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,6BAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,mCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,gCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,mCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,gCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,iCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,6BAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,mCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,gCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,iCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,6BAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,kCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,+BAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,mCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,gCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,iCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,8BAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,mCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,gCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,iCAA2B;EAA3B;AAA2B;AAA3B;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA,sBAA2B;EAA3B,6BAA2B;EAA3B;AAA2B;AAI3B;EAAA;AAAa;AAIb;EAAA,mBAAgB;EAAhB;AAAgB;AAShB;;;;;;EAAA,eAAW;EAAX;AAAW;AAIX;EAAA,gBAAkD;EAAlD,qBAAkD;EAAlD,mBAAkD;EAAlD,sBAAkD;EAAlD;AAAkD;AAIlD;EAAA,mBAA0B;EAA1B,WAA0B;EAA1B;AAA0B;AAI1B;EAAA;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAInB;EAAA;AAAoB;AAIpB;EAAA,qBAAuB;EAAvB;AAAuB;AAIvB;EAAA,qBAA0B;EAA1B,sBAA0B;EAA1B;AAA0B;AAI1B;EAAA;AAAW;AAIX;EAAA,gBAAiC;EAAjC,kBAAiC;EAAjC,oBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,sBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,mBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,uBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,oBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,uBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,oBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,uBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,oBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,uBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,oBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,uBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,oBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,uBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,oBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,uBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,oBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,uBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,oBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,uBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,oBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,wBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,qBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,uBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,oBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,wBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,qBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,uBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,oBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,qBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,iBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,sBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,eAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,sBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,kBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,sBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,kBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,sBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,kBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,sBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,kBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,sBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,kBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,sBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,kBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,sBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,kBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,uBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,oBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,wBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,qBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,sBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,mBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,wBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,qBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,sBAAiC;EAAjC;AAAiC;AAAjC;EAAA,WAAiC;EAAjC,kBAAiC;EAAjC;AAAiC;AAIjC;EAAA,eAA8B;EAA9B,mBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,uBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,mBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,uBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,oBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,uBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,oBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,uBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,oBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,uBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,oBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,uBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,oBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,uBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,oBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,uBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,oBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,uBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,oBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,uBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,oBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,wBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,qBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,uBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,oBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,wBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,qBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,uBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,oBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,sBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,mBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,sBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,kBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,uBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,oBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,sBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,mBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,uBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,oBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,sBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,kBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,uBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,oBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,sBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,mBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,sBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,kBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,uBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,oBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,wBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,qBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,sBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,mBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,wBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,qBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,sBAA8B;EAA9B;AAA8B;AAA9B;EAAA,WAA8B;EAA9B,kBAA8B;EAA9B;AAA8B;AAI9B;EAAA,0BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,8BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,iCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,8BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,iCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,6BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,iCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,8BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,iCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,6BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,iCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,8BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,iCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,6BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,kCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,+BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,iCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,8BAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,mCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,gCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,iCAAiB;EAAjB;AAAiB;AAAjB;EAAA,sBAAiB;EAAjB,6BAAiB;EAAjB;AAAiB;AAIjB;EAAA,kBAA2B;EAA3B,cAA2B;EAA3B;AAA2B;AAI3B;EAAA,mBAAgB;EAAhB;AAAgB;AAIhB;;EAAA;IAAA;EAA0B;AAAA;AAA1B;;EAAA;IAAA;EAA0B;AAAA;AAI1B;EAAA,kBAA4M;EAA5M,UAA4M;EAA5M,SAA4M;EAA5M,WAA4M;EAA5M,WAA4M;EAA5M,YAA4M;EAA5M,gBAA4M;EAA5M,qBAA4M;EAA5M,kBAA4M;EAA5M,sDAA4M;EAA5M,wFAA4M;EAA5M,qBAA4M;EAA5M,2BAA4M;EAA5M,4BAA4M;EAA5M;AAA4M;AAI5M;EAAA,qBAAyB;EAAzB,iBAAyB;EAAzB;AAAyB;AAIzB;EAAA;AAAY;AAIZ;EAAA,mBAA4E;EAA5E,eAA4E;EAA5E,mBAA4E;EAA5E,2BAA4E;EAA5E,kBAA4E;EAA5E,yDAA4E;EAA5E,kBAA4E;EAA5E,mBAA4E;EAA5E,oBAA4E;EAA5E;AAA4E;AAG9E,kBAAkB;AAGhB;EAAA,kBAAe;EACf;AADe;AAKf;EAAA,UAAwE;EAAxE,YAAwE;EAAxE,sBAAwE;EAAxE,sBAAwE;EAAxE;AAAwE;AAAxE;;EAAA;IAAA;EAAwE;AAAA;AAIxE;EAAA,WAA+E;EAA/E,eAA+E;EAA/E,eAA+E;EAA/E,iBAA+E;EAA/E,mBAA+E;EAA/E,sBAA+E;EAA/E,sDAA+E;EAA/E,sBAA+E;EAA/E,8BAA+E;EAA/E;AAA+E;AAI/E;EAAA,WAA6E;EAA7E,YAA6E;EAA7E,WAA6E;EAA7E,YAA6E;EAA7E,gBAA6E;EAA7E,uBAA6E;EAA7E,mBAA6E;EAA7E,6BAA6E;EAA7E,qBAA6E;EAA7E,sBAA6E;EAA7E,oBAA6E;EAA7E,uBAA6E;EAA7E,eAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,uBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,mBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,uBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,oBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,uBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,oBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,uBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,oBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,uBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,oBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,uBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,oBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,uBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,oBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,uBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,oBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,uBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,oBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,uBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,oBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,wBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,qBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,uBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,oBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,wBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,qBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,uBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,oBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,sBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,mBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,sBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,kBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,uBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,oBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,sBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,mBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,uBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,oBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,sBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,kBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,uBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,oBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,sBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,mBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,sBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,kBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,uBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,oBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,wBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,qBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,sBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,mBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,wBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,qBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,sBAA6E;EAA7E;AAA6E;AAA7E;EAAA,WAA6E;EAA7E,kBAA6E;EAA7E;AAA6E;AAI7E;EAAA,SAAmC;EAAnC,QAAmC;EAAnC,eAAmC;EAAnC;AAAmC;AAInC;EAAA,aAAwB;EAAxB;AAAwB;AAIxB;EAAA;AAAU;AAIV;EAAA,WAAqB;EAArB,6EAAqB;EAArB,iGAAqB;EAArB;AAAqB;AAIrB;EAAA;AAAW;AAIX;EAAA;AAAa;AAIb;EAAA,cAA0C;EAA1C,aAA0C;EAA1C,6BAA0C;EAA1C;AAA0C;AAI1C;EAAA;AAAa;AAIb;EAAA,kBAA+C;EAA/C,mBAA+C;EAA/C;AAA+C;AAI/C;EAAA,aAAgG;EAAhG,uBAAgG;EAAhG,YAAgG;EAAhG,sBAAgG;EAAhG,uBAAgG;EAAhG,kBAAgG;EAAhG,yDAAgG;EAAhG,6EAAgG;EAAhG,iGAAgG;EAAhG;AAAgG;AAAhG;;EAAA;IAAA,kBAAgG;IAAhG,sBAAgG;IAAhG,8BAAgG;IAAhG;EAAgG;AAAA;AAIhG;EAAA,eAAgB;EAAhB,eAAgB;EAAhB;AAAgB;AAIhB;EAAA;AAAc;AA5dhB;;EAAA;IAAA;EA8dA;;EA9dA;;IAAA;MAAA;IA8dA;EAAA;;EA9dA;;IAAA;MAAA;IA8dA;EAAA;;EA9dA;;IAAA;MAAA;IA8dA;EAAA;;EA9dA;;IAAA;MAAA;IA8dA;EAAA;;EA9dA;;IAAA;MAAA;IA8dA;EAAA;;EA9dA;;IAAA;MAAA;IA8dA;EAAA;AAAA;AA9dA;EAAA,0BA8dA;EA9dA,6BA8dA;EA9dA;AA8dA;AA9dA;EAAA,0BA8dA;EA9dA;AA8dA;AA9dA;EAAA,0BA8dA;EA9dA;AA8dA;AA9dA;EAAA,0BA8dA;EA9dA;AA8dA;AA9dA;EAAA,0BA8dA;EA9dA,oBA8dA;EA9dA;AA8dA;AA9dA;EAAA,0BA8dA;EA9dA,kBA8dA;EA9dA;AA8dA;AA9dA;EAAA,0BA8dA;EA9dA;AA8dA;AA9dA;EAAA,0BA8dA;EA9dA;AA8dA;AA9dA;EAAA,0BA8dA;EA9dA;AA8dA;AA9dA;EAAA,0BA8dA;EA9dA;AA8dA;AA9dA;EAAA,0BA8dA;EA9dA;AA8dA;AA9dA;EAAA,0BA8dA;EA9dA;AA8dA;AA9dA;EAAA,0BA8dA;EA9dA,sBA8dA;EA9dA;AA8dA;AA9dA;EAAA,0BA8dA;EA9dA;AA8dA;AA9dA;EAAA,0BA8dA;EA9dA;AA8dA;AA9dA;EAAA,0BA8dA;EA9dA;AA8dA;AA9dA;EAAA,0BA8dA;EA9dA,6BA8dA;EA9dA;AA8dA;AA9dA;EAAA,0BA8dA;EA9dA,kBA8dA;EA9dA;AA8dA;AA9dA;EAAA,0BA8dA;EA9dA;AA8dA;AA9dA;EAAA,0BA8dA;EA9dA,kBA8dA;EA9dA;AA8dA;AA9dA;EAAA,0BA8dA;EA9dA;AA8dA;AA9dA;EAAA,gBA8dA;EA9dA;AA8dA;AA9dA;EAAA,iBA8dA;EA9dA;AA8dA;AA9dA;EAAA,iBA8dA;EA9dA;AA8dA;AA9dA;EAAA,kBA8dA;EA9dA;AA8dA;AA9dA;EAAA;AA8dA;AA9dA;EAAA;AA8dA;AA9dA;EAAA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA;AA8dA;AA9dA;EAAA,6BA8dA;EA9dA;AA8dA;AA9dA;EAAA,kBA8dA;EA9dA;AA8dA;AA9dA;EAAA,kBA8dA;EA9dA;AA8dA;AA9dA;EAAA,kBA8dA;EA9dA;AA8dA;AA9dA;EAAA,kBA8dA;EA9dA;AA8dA;AA9dA;EAAA,oBA8dA;EA9dA;AA8dA;AA9dA;EAAA,oBA8dA;EA9dA;AA8dA;AA9dA;EAAA;AA8dA;AA9dA;EAAA,kBA8dA;EA9dA;AA8dA;AA9dA;EAAA;AA8dA;AA9dA;EAAA,oBA8dA;EA9dA;AA8dA;AA9dA;EAAA;AA8dA;AA9dA;EAAA,yBA8dA;EA9dA;AA8dA;AA9dA;;EAAA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;AAAA;AA9dA;;EAAA;IAAA;EA8dA;;EA9dA;IAAA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;AAAA;AA9dA;;EAAA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA,2BA8dA;IA9dA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA,iBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,eA8dA;IA9dA;EA8dA;;EA9dA;IAAA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,iBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,iBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,iBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;AAAA;AA9dA;;EAAA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA,UA8dA;IA9dA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA,gBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,gBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,iBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,iBA8dA;IA9dA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,iBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,iBA8dA;IA9dA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA,eA8dA;IA9dA;EA8dA;;EA9dA;IAAA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA,6EA8dA;IA9dA,iGA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,iBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,eA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,iBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,iBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,iBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA,kBA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;AAAA;AA9dA;;EAAA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA,iBA8dA;IA9dA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA,iBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,iBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA,iBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,eA8dA;IA9dA;EA8dA;;EA9dA;IAAA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,eA8dA;IA9dA;EA8dA;;EA9dA;IAAA,iBA8dA;IA9dA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA,eA8dA;IA9dA;EA8dA;;EA9dA;IAAA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,iBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,eA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,0BA8dA;IA9dA;EA8dA;;EA9dA;IAAA,0BA8dA;IA9dA;EA8dA;;EA9dA;IAAA,0BA8dA;IA9dA;EA8dA;;EA9dA;IAAA,0BA8dA;IA9dA;EA8dA;;EA9dA;IAAA,0BA8dA;IA9dA,gBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,0BA8dA;IA9dA;EA8dA;;EA9dA;IAAA,0BA8dA;IA9dA;EA8dA;;EA9dA;IAAA,0BA8dA;IA9dA;EA8dA;;EA9dA;IAAA,0BA8dA;IA9dA;EA8dA;;EA9dA;IAAA,0BA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,0BA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,kBA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,kBA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA;EA8dA;AAAA;AA9dA;;EAAA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,eA8dA;IA9dA;EA8dA;;EA9dA;IAAA,eA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,iBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,eA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,uBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,oBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,mBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,wBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,qBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,sBA8dA;IA9dA;EA8dA;;EA9dA;IAAA,WA8dA;IA9dA,kBA8dA;IA9dA;EA8dA;AAAA;AA9dA;;EAAA;IAAA;EA8dA;;EA9dA;IAAA;EA8dA;;EA9dA;IAAA,kBA8dA;IA9dA;EA8dA;AAAA;AA9dA;EAAA;AA8dA;AA9dA;EAAA;AA8dA;AA9dA;EAAA;AA8dA;AA9dA;EAAA;AA8dA;AA9dA;;EAAA;IAAA,8BA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,kCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,+BA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,mCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,gCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,mCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,gCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,mCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,gCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,mCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,gCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,mCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,gCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,kCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,+BA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,mCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,gCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,kCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,+BA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,kCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,+BA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,mCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,gCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,kCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,+BA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,mCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,gCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,kCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,+BA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,kCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,+BA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,mCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,gCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,mCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,gCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,mCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,gCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,mCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,gCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,mCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,gCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,iCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,6BA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,mCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,gCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,iCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,6BA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,kCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,+BA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,mCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,gCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,iCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,8BA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,mCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,gCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,iCA8dA;IA9dA;EA8dA;;EA9dA;IAAA,sBA8dA;IA9dA,6BA8dA;IA9dA;EA8dA;AAAA;AA9dA;EAAA;AA8dA;AA9dA;EAAA;AA8dA;AA9dA;EAAA;AA8dA;AA9dA;EAAA;AA8dA;AA9dA;EAAA,8BA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,kCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,+BA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,kCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,+BA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,kCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,+BA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,kCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,+BA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,kCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,+BA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,iCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,6BA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,iCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,6BA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,kCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,+BA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,iCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,8BA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,iCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,6BA8dA;EA9dA;AA8dA;AA9dA;EAAA,8BA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,kCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,+BA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,kCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,+BA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,kCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,+BA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,kCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,+BA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,kCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,+BA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,iCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,6BA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,iCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,6BA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,kCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,+BA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,iCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,8BA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,mCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,gCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,iCA8dA;EA9dA;AA8dA;AA9dA;EAAA,sBA8dA;EA9dA,6BA8dA;EA9dA;AA8dA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/*\n  The base layer is for things like reset rules or default styles applied to plain HTML elements.\n  The components layer is for class-based styles that you want to be able to override with utilities.\n  The utilities layer is for small, single-purpose classes that should always take precedence over any other styles.\n\n  The @layer directive helps you control declaration order by automatically relocating your styles to the corresponding\n  @tailwind directive, and also enables features like modifiers and tree-shaking for your own custom CSS.  \n*/\n\n@layer base {\n  body {\n    @apply min-h-screen antialiased;\n    min-height: -webkit-fill-available;\n    padding-bottom: env(safe-area-inset-bottom);\n  }\n}\n\n@layer components {\n  .backface-visible {\n    backface-visibility: visible;\n    -moz-backface-visibility: visible;\n    -webkit-backface-visibility: visible;\n    -ms-backface-visibility: visible;\n  }\n\n  .backface-hidden {\n    backface-visibility: hidden;\n    -moz-backface-visibility: hidden;\n    -webkit-backface-visibility: hidden;\n    -ms-backface-visibility: hidden;\n  }\n}\n\n/* add the code bellow */\n@layer utilities {\n  /* Hide scrollbar for Chrome, Safari and Opera */\n  .no-scrollbar::-webkit-scrollbar {\n    display: none;\n  }\n  /* Hide scrollbar for IE, Edge and Firefox */\n  .no-scrollbar {\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n  }\n\n  .ligatures-none {\n    font-variant-ligatures: none;\n  }\n}\n\n/* Yotpo */\n\n.yotpo-sr-bottom-line-text--right-panel {\n  @apply !p-0 !font-sans !font-normal !leading-7;\n}\n\n#yotpo-reviews * {\n  @apply !font-sans;\n}\n\n.pdp-storytelling #yotpo-reviews .yotpo-base-layout {\n  @apply !w-full px-6 md:px-10;\n}\n.Pdp:not(.pdp-storytelling) #yotpo-reviews .yotpo-base-layout {\n  @apply !w-full p-6 xl:!max-w-screen-2xl;\n}\n\n#yotpo-reviews .yotpo-head {\n  @apply hidden;\n}\n\n#yotpo-reviews .yotpo-headline {\n  @apply hidden text-3xl font-bold;\n}\n\n#yotpo-reviews .yotpo-bottom-line-summary {\n  @apply mt-0;\n}\n\n#yotpo-reviews .yotpo-bottom-line-score {\n  @apply text-3xl font-bold md:text-5xl;\n}\n\n#yotpo-reviews .yotpo-bottom-line .yotpo-bottom-line-right-panel {\n  @apply pr-0;\n}\n\n#yotpo-reviews .yotpo-reviews-pagination-item {\n  @apply grid w-full place-items-center;\n}\n\n#yotpo-reviews-main-widget.yotpo-display-s .yotpo-reviews-pagination-item {\n  @apply h-auto rounded-none bg-black px-4 py-2 font-semibold uppercase tracking-wider text-white;\n}\n\n#yotpo-reviews .yotpo-horizontal-pagination .selected,\n#yotpo-reviews\n  .yotpo-horizontal-pagination\n  .yotpo-pagination-number-container\n  .yotpo-pagination-number:hover {\n  @apply bg-transparent font-semibold text-black;\n}\n\n#yotpo-reviews .yotpo-bottom-line {\n  @apply mr-0;\n}\n\n#yotpo-reviews .yotpo-header-container + .yotpo-review-border-smooth {\n  @apply hidden;\n}\n\n#yotpo-reviews .yotpo-reviews-summary-button {\n  @apply mt-4 self-center;\n}\n\n#yotpo-reviews .yotpo-reviews-summary-button button {\n  @apply m-0 h-auto gap-1 rounded-none p-4 font-semibold uppercase leading-none tracking-wider;\n}\n\n#yotpo-reviews .yotpo-display-s .yotpo-main-layout .yotpo-layout-header-wrapper {\n  @apply mb-0;\n}\n\n/* Filters */\n\n#yotpo-reviews label input,\n#yotpo-reviews label div,\n#yotpo-reviews label button,\n#yotpo-reviews .yotpo-media-filter-container button,\n#yotpo-reviews .yotpo-score-filter-container .yotpo-selected-value {\n  @apply rounded-none border-none font-semibold;\n}\n\n#yotpo-reviews-main-widget:not(.yotpo-display-s) .yotpo-filters-top-panel {\n  @apply grid grid-flow-row-dense grid-cols-2 grid-rows-5 gap-4 sm:grid-cols-3 lg:grid-cols-6 lg:grid-rows-2;\n}\n\n#yotpo-reviews .yotpo-custom-questions-filter,\n#yotpo-reviews .yotpo-free-search-filter-container,\n#yotpo-reviews .yotpo-score-filter-container {\n  @apply w-auto;\n}\n\n#yotpo-reviews .yotpo-mobile-filters-btn {\n  @apply flex items-center justify-center bg-black;\n}\n\n#yotpo-reviews .yotpo-mobile-filters-btn-text {\n  @apply font-semibold uppercase tracking-wider text-white;\n}\n\n#yotpo-reviews .yotpo-mobile-filters-btn svg path {\n  @apply fill-white;\n}\n\n#yotpo-reviews .yotpo-media-select svg path {\n  @apply fill-black;\n}\n\n#yotpo-reviews .yotpo-mobile-filters-btn-badge-wrapper {\n  @apply hidden;\n}\n\n#yotpo-reviews-main-widget:not(.yotpo-display-s) .yotpo-search-filter {\n  @apply col-span-2 sm:col-span-3 lg:col-span-2;\n}\n\n#yotpo-reviews .yotpo-review {\n  @apply mb-8 mt-6;\n}\n\n#yotpo-reviews .yotpo-filters-top-panel,\n#yotpo-reviews .yotpo-filters-right-panel {\n  @apply w-full basis-0;\n}\n\n/* #yotpo-reviews .yotpo-filters-top-panel :nth-child(2), */\n#yotpo-reviews .yotpo-filters-top-panel :nth-child(3),\n#yotpo-reviews .yotpo-filters-top-panel :nth-child(4),\n#yotpo-reviews .yotpo-filters-top-panel :nth-child(5),\n#yotpo-reviews .yotpo-filters-top-panel :nth-child(6),\n#yotpo-reviews .yotpo-filters-top-panel :nth-child(7),\n#yotpo-reviews .yotpo-filters-top-panel :nth-child(8),\n#yotpo-reviews .yotpo-filters-top-panel :nth-child(9) {\n  @apply lg:row-start-2;\n}\n\n#yotpo-reviews .yotpo-filters-right-panel label,\n#yotpo-reviews .yotpo-filters-right-panel .yotpo-dropdown-closable,\n#yotpo-reviews .yotpo-filters-right-panel .yotpo-dropdown-placeholder {\n  @apply bg-transparent;\n}\n\n#yotpo-reviews .yotpo-sorting-filter-container {\n  @apply h-10;\n}\n\n#yotpo-reviews .yotpo-sorting-filter-container button {\n  @apply items-center;\n}\n\n#yotpo-reviews .yotpo-sorting-filter-container .yotpo-dropdown-placeholder {\n  @apply h-full leading-10;\n}\n\n#yotpo-reviews .yotpo-filter-select,\n#yotpo-reviews .yotpo-media-select,\n#yotpo-reviews .yotpo-media-filter-container,\n#yotpo-reviews .yotpo-free-search-filter-container input,\n#yotpo-reviews .yotpo-dropdown-placeholder-input,\n#yotpo-reviews button.yotpo-dropdown-closable,\n#yotpo-reviews .yotpo-search-filter .yotpo-search-label {\n  @apply h-full w-full border-none bg-grey;\n}\n\n#yotpo-reviews .yotpo-search-filter label,\n#yotpo-reviews .yotpo-dropdown-base {\n  @apply h-full w-full bg-grey;\n}\n\n#yotpo-reviews .yotpo-dropdown-placeholder-input {\n  @apply !bg-grey;\n}\n\n#yotpo-reviews .yotpo-search-filter .yotpo-search-label .yotpo-search-input {\n  @apply pl-10;\n}\n\n#yotpo-reviews .yotpo-search-filter,\n#yotpo-reviews .yotpo-score-filter,\n#yotpo-reviews .yotpo-media-filter-container,\n#yotpo-reviews .yotpo-custom-questions-filter {\n  @apply border-b-2 border-solid border-black;\n}\n\n[class*='yotpo-display-'][class*='yotpo-device-'][style]\n  .yotpo-filters-container\n  .yotpo-filters-top-panel\n  > [class$='filter-container']\n  input[placeholder],\n[class*='yotpo-display-'][class*='yotpo-device-'].yotpo-device-mobile\n  .yotpo-filters-container\n  .yotpo-filters-top-panel\n  .yotpo-mobile-filters-btn {\n  @apply h-auto w-full min-w-full rounded-none border-b-2 border-none border-black p-4;\n}\n\n#yotpo-reviews .yotpo-dropdown-closable .yotpo-dropdown-content-wrapper {\n  @apply top-[50px];\n}\n\n#yotpo-mobile-filters-popup .yotpo-filter-select,\n#yotpo-mobile-filters-popup .yotpo-dropdown-placeholder-input {\n  @apply h-[50px] rounded-none border-x-0 border-b-2 border-t-0 border-black !bg-grey p-4;\n}\n\n#yotpo-mobile-filters-popup .yotpo-dropdown-base .yotpo-selected-value {\n  @apply !text-sm !font-semibold;\n}\n\n#yotpo-reviews.yotpo-widget-instance .yotpo-review-border-smooth {\n  @apply mt-0 h-px border-black-300;\n}\n\n#yotpo-reviews .yotpo-reviewer-details-verified svg {\n  @apply hidden;\n}\n\n#yotpo-reviews .yotpo-dropdown-base .yotpo-dropdown-arrow-icon {\n  @apply !-mt-0.5;\n}\n\n/* Reviews */\n\n#yotpo-reviews .yotpo-review-left-panel {\n  @apply order-3 w-full bg-grey p-6 lg:w-80;\n}\n\n#yotpo-reviews-main-widget:not(.yotpo-display-s) .yotpo-review-left-panel {\n  @apply self-start max-lg:mt-4;\n}\n\n#yotpo-reviews .yotpo-review-center-panel {\n  @apply my-0 gap-2 p-0 lg:pr-10;\n}\n\n#yotpo-reviews .yotpo-review-right-panel {\n  @apply hidden;\n}\n\n#yotpo-reviews .yotpo-review-customer-questions-container {\n  @apply w-full;\n}\n\n#yotpo-reviews-main-widget .yotpo-review-questions-mobile-panel {\n  @apply bg-grey px-6 pt-6;\n}\n\n#yotpo-reviews .yotpo-custom-questions-see-more-label {\n  @apply !text-xs underline;\n}\n\n#yotpo-reviews-main-widget.yotpo-display-s .yotpo-review-key-value-question {\n  @apply my-0 !gap-1;\n}\n\n#yotpo-reviews-main-widget:not(.yotpo-display-s) .yotpo-review-key-value-question {\n  @apply mb-0;\n}\n\n#yotpo-reviews-main-widget.yotpo-display-s .yotpo-custom-questions-question-wrapper {\n  @apply w-full flex-nowrap;\n}\n\n#yotpo-reviews-main-widget.yotpo-display-s\n  .yotpo-custom-questions-wrapper\n  .yotpo-custom-questions-title,\n#yotpo-reviews-main-widget.yotpo-display-s\n  .yotpo-custom-questions-wrapper\n  .yotpo-custom-questions-value {\n  @apply flex-nowrap !text-xs;\n}\n\n#yotpo-reviews-main-widget.yotpo-display-s .yotpo-custom-questions-wrapper-suffix-padding {\n  @apply hidden;\n}\n\n#yotpo-reviews-main-widget.yotpo-display-s .yotpo-review-content {\n  @apply mb-4 mt-0;\n}\n\n#yotpo-reviews-main-widget.yotpo-display-s .yotpo-review-comment,\n#yotpo-reviews-main-widget.yotpo-display-s .yotpo-review-customer-questions,\n#yotpo-reviews-main-widget.yotpo-display-s .yotpo-review-question,\n#yotpo-reviews-main-widget.yotpo-display-s .yotpo-review-questions-mobile-panel,\n#yotpo-reviews-main-widget.yotpo-display-s .yotpo-review-title,\n#yotpo-reviews-main-widget.yotpo-display-s .yotpo-review-rating-title {\n  @apply my-0;\n}\n\n#yotpo-reviews-main-widget:not(.yotpo-display-s) .yotpo-review-customer-questions-container {\n  @apply mt-4 border-t border-solid border-black-300;\n}\n\n#yotpo-reviews .yotpo-reviewer-details-verified {\n  @apply flex-row gap-2 pt-0;\n}\n\n#yotpo-reviews .yotpo-reviewer-details-verified > * {\n  @apply leading-none;\n}\n\n#yotpo-reviews .yotpo-reviewer-details-verified :first-child {\n  @apply font-semibold;\n}\n\n#yotpo-reviews .yotpo-reviewer-details-verified :last-child {\n  @apply items-end italic;\n}\n\n#yotpo-reviews .yotpo-review-rating-title {\n  @apply mb-2 flex-col gap-2;\n}\n\n#yotpo-reviews-main-widget.yotpo-display-s .yotpo-review-star-rating {\n  @apply mb-2;\n}\n\n#yotpo-reviews .yotpo-review-title {\n  @apply ml-0 text-xl font-semibold;\n}\n\n#yotpo-reviews .yotpo-read-more {\n  @apply text-base font-semibold;\n}\n\n#yotpo-reviews .yotpo-read-more-text {\n  @apply !text-base;\n}\n\n#yotpo-reviews-main-widget .yotpo-review-comment {\n  @apply relative block gap-4;\n}\n\n#yotpo-reviews-main-widget.yotpo-display-s .yotpo-review-comment {\n  @apply mb-4 mt-0;\n}\n\n#yotpo-reviews-main-widget:not(.yotpo-display-s) .yotpo-review-comment {\n  @apply max-lg:mb-4 lg:mt-4;\n}\n\n#yotpo-reviews .yotpo-comment-title {\n  @apply absolute -left-0 -top-0 m-0 size-8 overflow-hidden rounded-full bg-black bg-[url('https://cdn.allbirds.com/image/upload/v1731638362/bird-icon.svg')] bg-[size:24px] bg-center bg-no-repeat -indent-96;\n}\n\n#yotpo-reviews .yotpo-comment-title::before {\n  @apply mr-1 content-['-'];\n}\n\n#yotpo-reviews .yotpo-comment-data {\n  @apply gap-2;\n}\n\n#yotpo-reviews .yotpo-comment-content {\n  @apply ml-10 max-w-prose rounded-2xl rounded-tl-none bg-blue-light px-4 py-3;\n}\n\n/* Store Locator */\n\n#store-locator {\n  @apply relative;\n  height: calc(100svh - env(safe-area-inset-bottom) - 60px);\n}\n\n.mapboxgl-ctrl-top-left {\n  @apply left-[10px] top-3 !z-40 box-border min-w-[250px] md:min-w-[370px];\n}\n\n.mapboxgl-ctrl-top-left .mapboxgl-ctrl {\n  @apply m-0 min-w-full max-w-full border-2 border-solid border-black shadow-none;\n}\n\n.mapboxgl-ctrl-top-left .mapboxgl-ctrl .mapboxgl-ctrl-geocoder--input {\n  @apply m-0 h-8 w-full cursor-text truncate bg-transparent px-7 py-1 text-base;\n}\n\n.mapboxgl-ctrl-top-left .mapboxgl-ctrl-geocoder--icon-search {\n  @apply left-[5px] top-[7px] h-5 w-5;\n}\n\n.mapboxgl-ctrl-top-left .mapboxgl-ctrl-geocoder .mapboxgl-ctrl-geocoder--pin-right > * {\n  @apply right-2 top-[7px];\n}\n\n.mapboxgl-ctrl-top-left .mapboxgl-ctrl-geocoder .mapboxgl-ctrl-geocoder--icon-close {\n  @apply m-0;\n}\n\n.mapboxgl-ctrl-top-left .mapboxgl-ctrl-geocoder .suggestions {\n  @apply z-40 shadow-md;\n}\n\n.mapboxgl-ctrl-top-right {\n  @apply z-20;\n}\n\n.mapboxgl-ctrl-bottom-left .mapboxgl-ctrl a.mapboxgl-ctrl-logo {\n  @apply hidden;\n}\n\n.splide__arrow {\n  @apply h-10 w-10 !border-none !opacity-100;\n}\n\n.splide__arrow:disabled {\n  @apply hidden;\n}\n\n.splide.is-focus-in .splide__arrow:focus {\n  @apply outline-1 outline-offset-1 outline-black;\n}\n\n#store-locator .splide__slide {\n  @apply flex min-h-max grow flex-col rounded-md bg-white shadow-md md:rounded-none md:shadow-none;\n}\n\n#store-locator .splide__slide.is-active {\n  @apply scale-100;\n}\n\nbody.index #gladlyChat_container .minimizedChatButtonSelector {\n  @apply !hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
